webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiDomain; });

var apiDomain = 'https://app.drifttech.io/api';

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	addHaulsFolder: function addHaulsFolder(foldersHauls) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls/folder/', foldersHauls, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	test: function test() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls/test/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll: function getAll(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getUnloadLocation: function getUnloadLocation(driver_id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls/unload/locations/' + driver_id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getLoadLocation: function getLoadLocation(energy_company_id, driver_id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls/load/locations/' + energy_company_id + '/' + driver_id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(saveData) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/create/', saveData, { headers: {
					'Content-Type': 'application/json',
					'mobile': false,
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(haulId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/' + haulId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';

				data = response.data.haul;
				data = {
					'haul': response.data.haul,
					'update_data': response.data.update_data,
					'folders': response.data.folders,
					'folder_haul': response.data.folder_haul,
					'messages': response.data.messages,
					'message': response.data.message,
					'role': response.data.role,
					'status': response.data.status
				};
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(haulUpdate, id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/update/' + id + '/', haulUpdate, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveSelectedColumns: function saveSelectedColumns(selectColumns) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/select_columns/', selectColumns, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/delete/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				console.log('here');
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	remove: function remove(haul_id, folder_id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/remove/hauls/folder/' + haul_id + '/' + folder_id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				console.log('here');
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/restore/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveFilters: function saveFilters(id, filters) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/filters/' + id + '/', filters, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getFilters: function getFilters(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls/filters_start/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.filters_start, response.data.filters_start1, response.data.select_columns];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	savePersonalTime: function savePersonalTime(id, personaltime) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/personal_time/' + id + '/', personaltime, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message, response.data.data];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	sendFTP: function sendFTP(filter_ftp) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/send_ftp/', filter_ftp, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getByv2: function getByv2(haulId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_detail/' + haulId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';

				data = response.data.haul;
				data = {
					'haul': response.data.haul,
					'status': response.data.status
				};
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getByv22: function getByv22(haulId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_attributes/' + haulId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';

				data = response.data.haul;
				data = {
					'haul': response.data.haul,
					'folders': response.data.folders,
					'folder_haul': response.data.folder_haul,
					'messages': response.data.messages,
					'message': response.data.message,
					'role': response.data.role,
					'status': response.data.status,
					'hazards': response.data.hazards,
					'controls': response.data.controls

				};
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_trucking_companies: function get_trucking_companies(TruckingCompanyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_edit_data/' + TruckingCompanyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';

				data = response.data.trucking_companies;
				data = {
					'trucking_companies': response.data.trucking_companies,
					'status': response.data.status
				};
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_folders_by: function get_folders_by(EnergyCompanyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user_folders/' + EnergyCompanyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';

				data = response.data.folders;
				data = {
					'folders': response.data.folders,
					'status': response.data.status
				};
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll1: function getAll1() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls_filter_content/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_trucking_hauls: function get_trucking_hauls() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_create_data/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	export_to_csv: function export_to_csv(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/export_to_csv/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	HaulsApproved: function HaulsApproved(HaulsApprovedIds) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls_approved/', HaulsApprovedIds, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	HaulsIgnored: function HaulsIgnored(HaulsApprovedIds) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls_ignored/', HaulsApprovedIds, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_duplicated_hauls: function get_duplicated_hauls(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/duplicated_hauls/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_discrepancy_report: function get_discrepancy_report(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/discrepancy_report/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_values: function update_values(haulAdjust, id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/update_values/' + id + '/', haulAdjust, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_request_hauls: function get_request_hauls(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_request: function save_request(saveData) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_request/create/', saveData, { headers: {
					'Content-Type': 'application/json',
					'mobile': false,
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_request: function update_request(haulAdjust, id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul/update_request/' + id + '/', haulAdjust, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_number_r: function get_number_r() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_number/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	invoiced_cost_update: function invoiced_cost_update(haulUpdate, id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoiced_cost/update/' + id + '/', haulUpdate, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	bbl: function bbl() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/bbl/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/users/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token'),
					'user_id': localStorage.getItem('user_id')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.users, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll1: function getAll1() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/users_attributtes/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token'),
					'user_id': localStorage.getItem('user_id')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.trucking_companies_filter, response.data.role, response.data.insert_data];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll2: function getAll2() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/users_attributtes1/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token'),
					'user_id': localStorage.getItem('user_id')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.insert_data];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll3: function getAll3() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/users_attributtes2/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token'),
					'user_id': localStorage.getItem('user_id')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.update_data];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(userId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/' + userId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.user, response.data.update_data, response.data.role];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(dataUser) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/create/', dataUser, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idUser, dataUser) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/update/' + idUser + '/', dataUser, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idUser) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/delete/' + idUser + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/restore/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveDocuments: function saveDocuments(documents, idUser) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/upload_documents/' + idUser + '/', documents, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	deleteDocument: function deleteDocument(idDocument) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/document/delete/' + idDocument + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	resend: function resend(idUser) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/resend/' + idUser + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	pre_edit: function pre_edit(idUser, dataU) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/pre_edit/' + idUser + '/', dataU, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoices/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_invoices_hauls: function get_invoices_hauls(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice/hauls/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	addHaulsInvoice: function addHaulsInvoice(invoiceHauls) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls/', invoiceHauls, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	send_invoice: function send_invoice(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/send_haul_notification/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	HaulsUnasigned: function HaulsUnasigned(invoiceHauls) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_unasigned/', invoiceHauls, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll_c: function getAll_c() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_customer/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_IC: function save_IC(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_customer/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_IC1: function save_IC1(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_contract/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_IC2: function save_IC2(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_adjust/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll_cc: function getAll_cc() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_contract/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll_ca: function getAll_ca() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_adjust/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll_cp: function getAll_cp() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_price/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_IC3: function save_IC3(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_price/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy_iprice: function getBy_iprice(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_price/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_iprice: function delete_iprice(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_price/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore_iprice: function restore_iprice(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_price/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy_iadjust: function getBy_iadjust(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_adjust/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_iadjust: function delete_iadjust(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_adjust/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore_iadjust: function restore_iadjust(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_adjust/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy_icustomer: function getBy_icustomer(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_customer/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_icustomer: function delete_icustomer(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_customer/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore_icustomer: function restore_icustomer(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_customer/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy_icontract: function getBy_icontract(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_contract/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_icontract: function delete_icontract(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_contract/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore_icontract: function restore_icontract(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_contract/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_icontract: function update_icontract(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_contract/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_iprice: function update_iprice(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_price/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_icustomer: function update_icustomer(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_customer/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_iadjust: function update_iadjust(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_adjust/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_companies/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.trucking_companies, response.data.insert_data, response.data.role];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(companyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/' + companyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = '';

					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(tcData) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/create/', tcData, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idCompany, tcData) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/update/' + idCompany + '/', tcData, { headers: {
					'Content-Type': 'multipart/form-data',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/delete/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/restore/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_attr: function get_attr(companyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/attrib/' + companyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = '';

					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_att: function get_att(companyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucking_company/attrib/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = '';

					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_companies/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_company/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idCompany, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_company/update/' + idCompany + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_company/delete/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(EnergyCompanyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_company/' + EnergyCompanyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_company/restore/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	petrotranz: function petrotranz(Company) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/petrotranz/' + Company + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreements/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.t_agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id];
					resolve(response.data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreements/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(terminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreement/' + terminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.t_agreement, response.data.update_data || [], response.data.role, response.data.energy_company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(terminalID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreement/delete/' + terminalID + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(terminalID, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreement/update/' + terminalID + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getEnergyCompaniesUnload: function getEnergyCompaniesUnload(locationId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/energy_company_location_unload/' + locationId + '/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.energycompanies];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreement/restore/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update1: function update1(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_agreement/update1/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveTCL: function saveTCL(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_company_location/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_indexes: function get_indexes() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/indexes/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.t_agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id];
					resolve(response.data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_indexes: function save_indexes(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/indexes/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getByIndex: function getByIndex(indexId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/index/' + indexId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_index: function delete_index(indexID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/index/delete/' + indexID + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_index: function update_index(indexID, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/index/update/' + indexID + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_wti: function get_wti() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/wti/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_wti: function save_wti(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/wti/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getByWti: function getByWti(wtiId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/wti/' + wtiId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_wti: function delete_wti(wtiID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/wti/delete/' + wtiID + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_wti: function update_wti(wtiID, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/wti/update/' + wtiID + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restoreWti: function restoreWti(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/wti/restore/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restoreIndex: function restoreIndex(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/index/restore/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_attr_ta: function get_attr_ta() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/ta_attr/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.insert_data];
					resolve(response.data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/roles/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.roles];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(RoleName) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/role/create/', { name: RoleName }, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(RoleId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/role/' + RoleId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = '';
					data = response.data;
					resolve(data);
				} else {
					var data = '';
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(Roleid) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/role/delete/' + Roleid + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(Roleid, RoleName) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/role/update/' + Roleid + '/', { name: RoleName }, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hazards/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hazard/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(HazardId, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hazard/update/' + HazardId + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(HazardId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hazard/delete/' + HazardId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(HazardId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hazard/' + HazardId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(HazardId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hazard/restore/' + HazardId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAllC: function getAllC() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/controls/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveC: function saveC(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/control/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	updateC: function updateC(ControlId, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/control/update/' + ControlId + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	deleteC: function deleteC(ControlId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/control/delete/' + ControlId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getByC: function getByC(ControlId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/control/' + ControlId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restoreC: function restoreC(ControlId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/control/restore/' + ControlId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAll_tdg: function getAll_tdg() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/tdgs/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save_tdg: function save_tdg(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/tdg/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy_tdg: function getBy_tdg(TdgId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/tdg/' + TdgId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update_tdg: function update_tdg(TdgId, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/tdg/update/' + TdgId + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete_tdg: function delete_tdg(TdgId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/tdg/delete/' + TdgId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore_tdg: function restore_tdg(TdgId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/tdg/restore/' + TdgId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/services/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.services, response.data.insert_data || []];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/service/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message, response.data.new];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(ServiceId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/service/' + ServiceId, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.service, response.data.update_data || []];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(serviceID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/service/delete/' + serviceID, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(Serviceid, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/service/update/' + Serviceid, model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	deleteR: function deleteR(relationID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/service_roles/delete/' + relationID, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
  headers: {
    'Content-Type': 'application/json',
    'token': localStorage.getItem('access_token')
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreements/', { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token'),
          'user_id': localStorage.getItem('user_id')
        } }).then(function (response) {
        if (response.data.status === 'success') {
          var data = [response.data.status, response.data.agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id];
          resolve(data);
        } else {
          var data = [response.data.status, response.data.message];
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBy: function getBy(agreementId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreement/' + agreementId + '/', { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        if (response.data.status === 'success') {
          var data = [response.data.status, response.data.agreement, response.data.update_data, response.data.role, response.data.energy_company_id];
          resolve(data);
        } else {
          var data = [response.data.status, response.data.message];
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  save: function save(dataAgreement) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreements/create/', dataAgreement, { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  update: function update(id, dataAgreement) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreement/update/' + id + '/', dataAgreement, { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  delete: function _delete(id, hauls) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreement/delete/' + id + '/', hauls, { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  restore: function restore(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreement/restore/' + id + '/', { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  verify: function verify(dataAgreement) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/agreements/verify/', dataAgreement, { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message, response.data.data];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllPending: function getAllPending() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls_pending/', { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token'),
          'user_id': localStorage.getItem('user_id')
        } }).then(function (response) {
        if (response.data.status === 'success') {
          var data = response.data;

          resolve(data);
        } else {
          var data = response.data;
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  filters_agree: function filters_agree(filters) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/filters_agree/', filters, { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPendingDetail: function getPendingDetail(PendingId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/hauls_pending_detail/' + PendingId + '/', { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token'),
          'user_id': localStorage.getItem('user_id')
        } }).then(function (response) {
        if (response.data.status === 'success') {
          var data = response.data;
          resolve(data);
        } else {
          var data = response.data;
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'Token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/targets/', { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = [response.data.status, response.data.targets, response.data.insert_data, response.data.role, response.data.energy_company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/target/create/', model, { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(targetId, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/target/update/' + targetId + '/', model, { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTargets) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/target/delete/' + idTargets + '/', { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTargets) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/target/restore/' + idTargets + '/', { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(idTarget) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/target/' + idTarget + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.target, response.data.update_data, response.data.role, response.data.energy_company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfig = {
  headers: {
    'Content-Type': 'application/json'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  logout: function logout() {
    this.clearStorage();
  },
  clearStorage: function clearStorage() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('full_name');
    localStorage.removeItem('role');
    localStorage.removeItem('role_id');
    localStorage.removeItem('user_id');
    localStorage.removeItem('menu');
  },
  isLoguedIn: function isLoguedIn() {
    return !!localStorage.getItem('access_token');
  },
  login: function login(user, password) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/auth/login', { email: user, password: password }, axiosConfig).then(function (response) {
        var loggResp = '';
        if (response.data.status === 'success') {
          var checkData = response.data.data;
          localStorage.setItem('access_token', checkData.token);
          localStorage.setItem('user_id', checkData.user_id);
          localStorage.setItem('role', checkData.role);
          localStorage.setItem('role_id', checkData.role_id);
          localStorage.setItem('full_name', checkData.first_name + ' ' + checkData.last_name);
          localStorage.setItem('menu', checkData.menu);
          loggResp = ['success', response.data.message];
          resolve(loggResp);
        } else {
          loggResp = ['failed', response.data.message];
          resolve(loggResp);
        }
      }).catch(function (error) {
        reject(new Error(error));
      });
    });
  },
  getUser: function getUser(user) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/forgot_password/', { email: user }, { headers: {
          'Content-Type': 'application/json' } }).then(function (response) {
        var loggResp = '';
        if (response.data.status === 'success') {
          loggResp = ['success', response.data.message, response.data.message1];
          resolve(loggResp);
        } else {
          loggResp = ['warning', response.data.message, response.data.message1];
          resolve(loggResp);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rowDetails_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501b970d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rowDetails_vue__ = __webpack_require__(1088);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rowDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501b970d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rowDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_types/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = response.data;
				if (data.status === 'success') {
					resolve(data);
				} else {
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(TruckTypesName) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_type/create/', { name: TruckTypesName }, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTruckTypes, TruckTypesName) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_type/update/' + idTruckTypes + '/', { name: TruckTypesName }, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTruckTypes) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_type/delete/' + idTruckTypes + '/', { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TruckTypeId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_type/' + TruckTypeId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.truck_type];
					resolve(response.data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/locations/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.locations, response.data.insert_data, response.data.role, response.data.energy_company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/location/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idCompany, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/location/update/' + idCompany + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/location/delete/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/location/restore/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(companyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/location/' + companyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = [response.data.status, response.data.location, response.data.update_data, response.data.role, response.data.energy_company_id];
					resolve(data);
				} else {
					data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	assigndrivers: function assigndrivers(idCompany, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/location/assign_drivers/' + idCompany + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	petrotranz: function petrotranz(filter) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/petrotranz/location/', filter, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/fluid_types/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(FluidModel) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/fluid_type/create/', FluidModel, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idFluidTypes, FluidModel) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/fluid_type/update/' + idFluidTypes + '/', FluidModel, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idFluidTypes) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/fluid_type/delete/' + idFluidTypes + '/', { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(fluidTypeId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/fluid_type/' + fluidTypeId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.data];
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTerminal, formData) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/update/' + idTerminal + '/', formData, { headers: {
					'Content-Type': 'multipart/form-data',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	find: function find(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/monthly_report/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_company: function get_company() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/pwbi/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	get_receipts_wo_hauls: function get_receipts_wo_hauls(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/receipts_wo_hauls/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_altex_hauls: function get_altex_hauls() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/altex_check/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_petrotranz_hauls: function get_petrotranz_hauls(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/petrotranz_reports/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(694);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(701);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(718);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(740);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),
/* 188 */,
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(745);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(771);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Footer */]
  },
  created: function created() {
    var current_role = localStorage.getItem('role');
    var menu = 0;
    if ('menu' in localStorage) {
      menu = localStorage.getItem('menu');
    }
    if (current_role == 'super_admin') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items;
    } else if (current_role == 'analyst') {
      if (menu == 1) {
        this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_analyst_ser;
      } else {
        this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_analyst;
      }
    } else if (current_role == 'super_analyst') {
      if (menu == 1) {
        this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_super_analyst_ser;
      } else {
        this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_super_analyst;
      }
    } else if (current_role == 'marketing_accountant') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_marketing_accountant;
    } else if (current_role == 'trucking_company_admin') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_trucking_company_admin;
    } else if (current_role == 'driver') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_drivers;
    } else if (current_role == 'trucking_company_admin_light') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_trucking_company_admin_light;
    } else if (current_role == 'operations_manager') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_operations_manager_admin;
    } else if (current_role == 'trucking_operational_manager') {
      this.nav = __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items_trucking_operational_manager;
    }
  },
  data: function data() {
    return {
      nav: [{
        title: true,
        name: 'Area Admin',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }]
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 192 */,
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_hauls_HaulPopup__ = __webpack_require__(775);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_0__Callout__["a" /* default */],
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch__["a" /* default */],
    HaulPopup: __WEBPACK_IMPORTED_MODULE_2__views_hauls_HaulPopup__["a" /* default */]
  },
  data: function data() {
    return {
      componentKey: 0,
      data_in: {
        id: null,
        haul_invoice: false,
        edit: ''
      },
      haul_id: null
    };
  },

  created: function created() {
    var _this = this;

    this.$root.$on('openPopup', function (id) {
      _this.haul_id = id.id;
      _this.data_in = id;
      _this.componentKey += 1;
      document.body.classList.toggle('aside-menu-hidden', false);
    });
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(773);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(774);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(4);









__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
	load: {
		key: 'AIzaSyATdAd4aao2C4a1osTnnfVVK_wiVsS2uzs'
	}
});
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'HaulPopup',
	created: function created() {
		this.getHaulData();
	},
	props: {
		data_in: {
			type: Object,
			default: function _default() {}
		}

	},
	components: {
		vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
	},
	updated: function updated() {
		var h = document.getElementById('pageinfo').offsetHeight + 70;
		document.getElementById('haul-information').style['height'] = 'calc(100vh - ' + h + 'px)';
	},
	data: function data() {
		return {
			haulId: null,
			modalFolders: false,
			files: "",
			subTitle: "",
			wait_times: [],
			water_actual: 0,
			water_estimate: 0,
			oil_actual: 0,
			oil_estimate: 0,
			unload_location_select: [],
			fluid_type_select: [],
			truck_company_select: [],
			load_location_select: [],
			trucks_select: [],
			energy_company_select: [],
			user_id: '',
			selected_driver: [],
			full_name: '',
			driver_select: [],
			driver_select2: [],
			truck_select: [],
			mapTypeId: 'roadmap',
			zoom: 14,
			options: {
				strokeColor: '#e5c163',
				strokeOpacity: 1.0,
				strokeWeight: 6,
				geodesic: true
			},
			center: {
				"lat": 0,
				"lng": 0
			},
			markers: [],
			path: [],
			infoContent: '',
			infoLink: '',
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			companyName: '',
			edit: false,
			editHaulModal: false,
			tabIndex: 1,
			load_location: '',
			loadingData: true,
			unload_location: '',
			haul_start_date: '',
			waitCount: 0,
			trucks: [],
			driver: 0,
			areas: 0,
			areasCount: 50,
			originalData: null,
			originalData1: null,
			avg_speed: 0,
			cost_regular: 0,
			cost_stb: 0,
			total_cost: 0,
			role: '',
			view: true,
			view1: true,
			truck_type: '',
			selected: [],
			energy_companies_id: '',
			model: {
				id: null,
				initial_date: null,
				end_date: null,
				rate: null,
				charge_type: null,
				cost_type: null,
				chain_up_rat: null,
				energy_company: null,
				trucking_company: null,
				truck_type: null
			},
			modalAgreement: false,
			striped: false,
			bordered: true,
			borderless: false,
			outlined: true,
			small: true,
			hover: false,
			dark: false,
			fixed: true,
			personal_time_add: true,
			personal_time_modal: false,
			personal_time_items: {
				total: '',
				comments: ''
			},
			mapStyle: null,
			terminal_treatment_fee: null,
			terminal_other_fees: null,
			terminal_h2s_fees: null,
			terminal_density_fee: null,
			total_terminal_treatment_fees: null,
			gross_revenue: null,
			netback: null,
			rerouted: null,
			agreement_id: null,
			calculate: false,
			chain_up_rate: '',
			chain_up_time: '',
			worktime_rate: '',
			rate: '',
			stb_rate: '',
			volume_actual: '',
			formula: 'Total Cost: (Drive Rate * Volume Estimate) + (Stand by Rate * Volume Estimate) + (Worktime Rate * Volume Estimate) + Total Terminal Cost + Chain Up Rate',
			type_rate: 'Volume Estimate',
			type_stb_rate: 'Volume Estimate',
			type_worktime_rate: 'Volume Estimate',
			work_time: '00:00',
			trucking_companies: [],
			folder_haul: [],
			folderOptions: [],
			folders: [],
			multiload_data: [],
			chain_up_applied: false,
			edit_analyst: false,

			edit_invoiced_cost: false,
			invoiced_cost: '0.00',
			justification: '',
			invoiced_cost_text: '',
			justification_text: '',
			hz_load: { 'hazards': [], 'controls': [] },
			hz_unload: { 'hazards': [], 'controls': [] },
			hazards: [],
			controls: [],
			hazard_id: [],
			control_id: [],
			indeterminateHZ: false,
			hzAllSelected: false,
			indeterminateCTL: false,
			ctlAllSelected: false,
			hazard1_id: [],
			control1_id: [],
			indeterminateHZ1: false,
			hz1AllSelected: false,
			indeterminateCTL1: false,
			ctl1AllSelected: false,
			trucks_unit_id: null,
			truck_unit: '',
			terminal_boss: '',
			truck_unit_select: [],

			tdg_id: null,
			tdg: '',
			residue_last_contained: 'false',
			cnr: false,
			truck2_id: null,
			truck2: '',
			tdg_select: [],
			cnr_details: [],
			driving_time: '',
			cost_worktime: 0
		};
	},

	computed: {
		haulLink: function haulLink() {
			return this.haulId ? location.protocol + '//' + location.host + '/#/haul/' + this.haulId : '';
		}
	},
	methods: {
		closePopupHaul: function closePopupHaul() {
			document.body.classList.toggle('aside-menu-hidden', true);
			this.$root.$emit('closePopup');
		},
		personal_time_option: function personal_time_option() {
			this.personal_time_modal = true;
		},
		hidepersonaltime: function hidepersonaltime() {
			this.personal_time_modal = false;
		},
		getHaulData: function getHaulData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getByv2(this.data_in.id).then(function (data) {
				if (data.status == 'success') {
					_this.loadingData = false;
					_this.originalData = data['haul'];
					_this.restoreOriginalData();
					_this.messages = data['messages'];
					_this.haulId = _this.data_in.id;
					_this.getHaulData1();
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response.2 ' + error, 'error');
				_this.loadingData = false;
			});
		},
		getHaulData1: function getHaulData1() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getByv22(this.data_in.id).then(function (data) {
				if (data.status == 'success') {
					_this2.originalData1 = data['haul'];
					_this2.restoreOriginalData1();
					_this2.folder_haul = data.folder_haul;
					_this2.folderHaulIds = _this2.folder_haul.map(function (item) {
						return item.id;
					});
					_this2.selected = _this2.folderHaulIds;
					_this2.messages = data['messages'];

					_this2.role = data['role'];
					_this2.hazards = data.hazards;
					_this2.controls = data.controls;
					if (_this2.role == 'super_admin') {
						_this2.view = true;
						_this2.get_trucking_companies();
						_this2.getUnloadLocation(_this2.user_id);
						_this2.getLoadLocation(_this2.energy_companies_id, _this2.user_id);
					} else if (_this2.role == 'super_analyst') {
						_this2.view = false;
					} else if (_this2.role == 'trucking_company_admin' || _this2.role == 'trucking_operational_manager') {
						_this2.view1 = false;
						_this2.get_trucking_companies();
						_this2.getUnloadLocation(_this2.user_id);
						_this2.getLoadLocation(_this2.energy_companies_id, _this2.user_id);
					} else if (_this2.role == 'analyst' || _this2.role == 'marketing_accountant') {
						_this2.getUnloadLocation(_this2.user_id);
						_this2.getLoadLocation(_this2.energy_companies_id, _this2.user_id);
						_this2.view = false;
					}
					_this2.subTitle = 'Haul ' + _this2.originalData1.times.haul_start_date + " - " + new Date("1990-02-02 " + _this2.originalData1.times.haul_start_time).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
				} else {
					_this2.$swal(data.status, data.message, data.status);
					_this2.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.loadingData = false;
			});
		},
		restoreOriginalData1: function restoreOriginalData1() {
			var features = this.originalData1;
			this.path = features.map.path;
			this.center = features.map.center;
			this.markers = features.map.markers;
			this.haul_start_date = features.times.haul_start_date;
			this.haul_start_time = features.times.haul_start_time;
			this.haul_end_date = features.times.haul_end_date;
			this.haul_end_time = features.times.haul_end_time;
			this.wait_times = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(features.wait_times));
			if (this.wait_times.length > 0) {
				var add_personal_time = this.wait_times.map(function (o) {
					return o.type_id;
				}).indexOf(6);
				if (add_personal_time > -1) {
					this.personal_time_add = false;
				}
			}

			this.waitCount = features.wait_count;
			this.driving_time = features.times.driving_time;
			this.stb = features.times.stb;
			this.personal_time = features.times.personal_time;
			this.work_time = features.times.work_time;
			this.files = features.files;
		},
		restoreOriginalData: function restoreOriginalData() {
			var features = this.originalData;

			this.user_id = features.user_id;
			this.haulId = features.haul_id;
			this.user = features.user;
			this.full_name = features.full_name;

			this.energy_companies_id = features.energy_companies_id;
			this.energy_company = features.energy_company;
			this.fluid_type_id = features.fluid_type_id;
			this.fluid_type = features.fluid_type;
			this.load_location_id = features.load_location_id;
			this.load_location = features.load_location;
			this.unload_location_id = features.unload_location_id;
			this.unload_location = features.unload_location;
			this.truck_id = features.truck_id;
			this.truck = features.truck;
			this.truck_type = features.truck_type;
			this.truck_company = features.truck_company;
			this.truck_company_id = features.truck_company_id;

			this.volume_actual = features.volume_actual;
			this.volume_estimate = features.volume_estimate;
			this.bsw = features.bsw;
			this.oil_actual = features.oil_actual;
			this.water_actual = features.water_actual;
			this.ticket = features.ticket;
			this.terminal_ticket = features.terminal_ticket;
			this.total_distance = features.total_distance;
			this.comments_start = features.comments_start;
			this.comments_end = features.comments_end;
			this.other_comments = features.other_comments;
			this.updated_date = features.updated_date;
			this.updated_time = features.updated_time;
			this.created_date = features.created_date;
			this.created_time = features.created_time;

			this.haul_start_datetime = features.haul_start_datetime;
			this.haul_end_datetime = features.haul_end_datetime;
			this.water_percentage_estimate = features.water_percentage_estimate;
			this.water_percentage_actual = features.water_percentage_actual;

			this.avg_speed = features.avg_speed;

			this.rate = features.rate;

			if (features.chain_up_rate != 'N/A') {
				this.chain_up_rate = features.chain_up_rate;
				this.chain_up_applied = true;
			} else {
				this.chain_up_rate = "$0.00";
				this.chain_up_applied = false;
			}
			this.chain_up_time = features.chain_up_time;
			this.stb_rate = features.stb_rate;
			this.worktime_rate = features.worktime_rate;

			this.total_cost = features.total_cost;
			this.formula = features.formula;
			this.type_rate = features.type_rate;
			this.type_stb_rate = features.type_stb_rate;
			this.type_worktime_rate = features.type_worktime_rate;

			this.terminal_treatment_fee = features.terminal_treatment_fee;
			this.terminal_other_fees = features.terminal_other_fees;
			this.terminal_h2s_fees = features.terminal_h2s_fees;
			this.terminal_density_fee = features.terminal_density_fee;
			this.total_terminal_treatment_fees = features.total_terminal_treatment_fees;

			this.gross_revenue = features.gross_revenue;
			this.netback = features.netback;
			this.rerouted = features.rerouted;
			this.agreement_id = features.agreement_id;

			this.unit_cost = features.unit_cost;
			this.invoiced_cost = features.invoiced_cost;
			this.justification = features.justification;

			this.path = [];
			this.center = {
				"lat": 0,
				"lng": 0
			};
			this.markers = [];
			this.haul_start_date = "";
			this.haul_start_time = "";
			this.haul_end_date = "";
			this.haul_end_time = "";
			this.wait_times = [];
			this.waitCount = "";
			this.driving_time = "";
			this.stb = "";
			this.personal_time = "";
			this.work_time = "";
			this.files = "";

			this.multiload_data = features.loads ? features.loads : [];
			this.hz_load.hazards = features.hz_load.hazards;
			this.hz_load.controls = features.hz_load.controls;
			this.hz_unload.hazards = features.hz_unload.hazards;
			this.hz_unload.controls = features.hz_unload.controls;

			this.trucks_unit_id = features.trucks_unit_id;
			this.truck_unit = features.truck_unit;
			this.terminal_boss = features.terminal_boss;

			this.truck2_id = features.truck2_id;
			this.truck2 = features.truck2;
			this.tdg_id = features.tdg_id;
			this.tdg = features.tdg;
			this.residue_last_contained = features.residue_last_contained;
			this.cnr = features.cnr;
			this.cnr_details = features.cnr_details;
			this.cost_regular = features.cost_regular;
			this.cost_worktime = features.cost_worktime;
			this.cost_stb = features.cost_stb;
		},
		personal_time_save: function personal_time_save() {
			var _this3 = this;

			this.personal_time_modal = false;
			if (this.personal_time_items.total != '') {
				var new_personal_time = {
					type_id: 6,
					total: this.personal_time_items.total,
					comments: this.personal_time_items.comments
				};
				__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].savePersonalTime(this.haulId, new_personal_time).then(function (data) {
					if (data[0] == 'success') {
						var new_personal_time_view = {
							id: data[2],
							type_id: 6,
							total: _this3.personal_time_items.total,
							type_wait_times: "Personal Time",
							comments: _this3.personal_time_items.comments
						};
						_this3.wait_times.push(new_personal_time_view);
						_this3.personal_time_add = false;
						_this3.personal_time = _this3.personal_time_items.total;
					} else {
						_this3.personal_time_add = false;
						__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					}
				}).catch(function (error) {
					_this3.personal_time_add = false;
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				});
			}
		},
		timeBlur: function timeBlur(variableName) {
			var variableValue = this.personal_time_items[variableName];
			if (variableValue.length == 0) {
				this.personal_time_items[variableName] = "00:00";
			} else {
				var tempValue = variableValue.split(":");
				if (tempValue.length == 1) {
					var min = String(Math.min(tempValue[0], 24));
					this.personal_time_items[variableName] = ("0" + min).slice(-2) + ":00";
				} else if (tempValue.length == 2) {
					var min1 = String(Math.min(tempValue[0], 24));
					var min2 = String(Math.min(tempValue[1], 59));
					this.personal_time_items[variableName] = ("0" + min1).slice(-2) + ":" + ("0" + min2).slice(-2);
				}
			}
		},
		saveImage: function saveImage(file) {
			var item_image = file.replace(/^data:image\/(png|jpg|gif);base64,/, "");
			var blob = this.base64toBlob(item_image, 'image/gif');
			var data = window.URL.createObjectURL(blob);
			var link = document.createElement('a');
			link.href = data;
			link.download = 'photo.gif';
			document.body.appendChild(link);
			link.click();
			setTimeout(function () {
				window.URL.revokeObjectURL(data);
			}, 2000);
		},
		base64toBlob: function base64toBlob(base64Data, contentType) {
			contentType = contentType || '';
			var sliceSize = 1024;
			var byteCharacters = atob(base64Data);

			var bytesLength = byteCharacters.length;
			var slicesCount = Math.ceil(bytesLength / sliceSize);
			var byteArrays = new Array(slicesCount);

			for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
				var begin = sliceIndex * sliceSize;
				var end = Math.min(begin + sliceSize, bytesLength);

				var bytes = new Array(end - begin);
				for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
					bytes[i] = byteCharacters[offset].charCodeAt(0);
				}
				byteArrays[sliceIndex] = new Uint8Array(bytes);
			}
			return new Blob(byteArrays, { type: contentType });
		},
		deleteHaul: function deleteHaul(item) {
			var _this4 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Haul?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].delete(_this4.haulId).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							if (!_this4.data_in.haul_invoice) {
								_this4.$router.replace('/hauls');
								_this4.$root.$emit('haulUpdated');
								_this4.closePopupHaul();
							} else {
								if (_this4.data_in.edit.length === 0) {
									_this4.$router.replace('/invoices_hauls');
									_this4.$root.$emit('haul_Updated');
									_this4.closePopupHaul();
								} else {
									_this4.$router.replace('/invoice/' + _this4.data_in.edit + '/');
									_this4.$root.$emit('haul_edit');
									_this4.closePopupHaul();
								}
							}
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
			this.edit = false;
		},
		editHaul: function editHaul() {
			if (this.edit || this.edit_analyst) {
				this.edit = false;
				this.edit_analyst = false;
			} else {
				if (this.role === 'super_admin' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
					this.edit = true;
				} else if (this.role === 'analyst' || this.role == 'marketing_accountant') {
					this.edit_analyst = true;
				}
				this.setupFields();
			}
		},
		get_trucking_companies: function get_trucking_companies() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].get_trucking_companies(this.truck_company_id).then(function (data) {
				if (data.status == 'success') {
					_this5.trucking_companies = data.trucking_companies;
					var trucking_companies = _this5.trucking_companies;
					_this5.truck_company_select = trucking_companies.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
					_this5.selects_trucking_company();
					_this5.selects_driver();
					_this5.select_truck_unit();
				} else {
					_this5.$swal(data.status, data.message, data.status);
					_this5.trucking_companies = [];
				}
			}).catch(function (error) {
				_this5.$swal('Error', 'Server not response. ' + error, 'error');
				_this5.trucking_companies = [];
			});
		},
		selects_trucking_company: function selects_trucking_company() {
			if (this.role == 'super_admin') {
				var trucking_companies = this.trucking_companies;

				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					var drivers = trucking_companies[current_truck_company_index]['drivers'];
					this.driver_select = drivers.map(function (item) {
						return { 'value': item.id, 'text': item.name };
					});

					var trucks = trucking_companies[current_truck_company_index]['trucks'];
					this.truck_select = trucks.map(function (item) {
						return { 'value': item.id, 'text': item.truck_name };
					});

					if (this.driver_select.length == 1) {
						this.full_name = this.driver_select[0].text;
						this.user_id = this.driver_select[0].value;
					}
					if (this.truck_select.length == 1) {
						this.truck = this.truck_select[0].text;
						this.truck_id = this.truck_select[0].value;
					}
				}
			}
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				var _trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];

				var _current_truck_company_index = _trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);

				var _drivers = this.trucking_companies[0]['drivers'];
				this.driver_select = _drivers.map(function (item) {
					return { 'value': item.id, 'text': item.name };
				});

				var _trucks = this.trucking_companies[0]['trucks'];
				this.truck_select = _trucks.map(function (item) {
					return { 'value': item.id, 'text': item.truck_name };
				});

				if (this.driver_select.length == 1) {
					this.full_name = this.driver_select[0].text;
					this.user_id = this.driver_select[0].value;
				}
				if (this.truck_select.length == 1) {
					this.truck = this.truck_select[0].text;
					this.truck_id = this.truck_select[0].value;
				}
			}
		},
		selects_driver: function selects_driver() {
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				var trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];
				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					var drivers = this.trucking_companies[0]['drivers'];
					var drivers_index = drivers.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (drivers_index > -1) {
						var energycompanies = drivers[drivers_index]['energy_companies'];
						this.energy_company_select = energycompanies.map(function (item) {
							return { 'value': item.id, 'text': item.company_name };
						});
					}
				}
			}
			if (this.role == 'super_admin') {
				var _trucking_companies2 = this.trucking_companies;
				var _current_truck_company_index2 = _trucking_companies2.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (_current_truck_company_index2 > -1) {
					var _drivers2 = _trucking_companies2[_current_truck_company_index2]['drivers'];
					var _drivers_index = _drivers2.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (_drivers_index > -1) {
						var _energycompanies = _drivers2[_drivers_index]['energy_companies'];
						this.energy_company_select = _energycompanies.map(function (item) {
							return { 'value': item.id, 'text': item.company_name };
						});
					}
				}
			}
		},
		getUnloadLocation: function getUnloadLocation(driver_id) {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getUnloadLocation(driver_id).then(function (data) {
				if (data['status'] == 'success') {
					var loads_locations = data['unload_locations'];
					_this6.unload_location_select = loads_locations.map(function (item) {
						return {
							'value': item.id,
							'text': item.legal_location
						};
					});
				} else {
					_this6.$swal('Error', 'Server not response. ' + error, 'error');
				}
				_this6.loadingData = false;
			}).catch(function (error) {
				_this6.$swal('Error', 'Server not response. ' + error, 'error');
				_this6.loadingData = false;
			});
		},
		getLoadLocation: function getLoadLocation(energy_company_id, driver_id) {
			var _this7 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getLoadLocation(energy_company_id, driver_id).then(function (data) {
				if (data['status'] == 'success') {

					_this7.loads_locations = data['load_locations'];
					_this7.load_location_select = _this7.loads_locations.map(function (item) {
						return {
							'value': item.id,
							'text': item.legal_location
						};
					});
					if (_this7.load_location_select.length == 1) {
						_this7.load_location = _this7.load_location_select[0].text;
						_this7.load_location_id = _this7.load_location_select[0].value;
					}
					var loads_locations = _this7.loads_locations;
					var loads_locations_index = loads_locations.map(function (o) {
						return o.id;
					}).indexOf(_this7.load_location_id);
					if (loads_locations_index > -1) {
						var fluid_types = loads_locations[loads_locations_index]['fluids'];
						_this7.fluid_type_select = fluid_types.map(function (item) {
							return {
								'value': item.id,
								'text': item.name
							};
						});
						_this7.tdg_select = [];
						var ft_index = fluid_types.map(function (o) {
							return o.id;
						}).indexOf(_this7.fluid_type_id);
						if (ft_index > -1) {
							if ('tdg' in fluid_types[ft_index]) {
								_this7.tdg_select = fluid_types[ft_index].tdg;
							}
						}
					}
				} else {
					_this7.$swal('Error', 'Server not response. ' + error, 'error');
				}
				_this7.loadingData = false;
			}).catch(function (error) {
				_this7.$swal('Error', 'Server not response. ' + error, 'error');
				_this7.loadingData = false;
			});
		},
		setupFields: function setupFields(clear) {
			if (this.role == 'super_admin') {
				this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '');
				this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '');
				this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '');
				this.total_distance = this.total_distance.replace(/[^\./\d]/g, '');
				this.oil_actual = this.oil_actual.replace(/[^\./\d]/g, '');
				this.bsw = this.bsw.replace(/[^\./\d]/g, '');
			} else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '');
				this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '');
				this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '');
				this.total_distance = this.total_distance.replace(/[^\./\d]/g, '');
				this.oil_actual = this.oil_actual.replace(/[^\./\d]/g, '');
				this.bsw = this.bsw.replace(/[^\./\d]/g, '');
			} else if (this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '');
				this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '');
				this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '');
				this.total_distance = this.total_distance.replace(/[^\./\d]/g, '');
				this.oil_actual = this.oil_actual.replace(/[^\./\d]/g, '');
				this.bsw = this.bsw.replace(/[^\./\d]/g, '');
			}

			var hazard = this.hz_load.hazards;
			if (hazard.length > 0) {
				this.hazard_id = hazard.map(function (item) {
					return item.hazard_id;
				});
			} else {
				this.hazard_id = [];
			}

			var hazard1 = this.hz_unload.hazards;
			if (hazard1.length > 0) {
				this.hazard1_id = hazard1.map(function (item) {
					return item.hazard_id;
				});
			} else {
				this.hazard1_id = [];
			}

			var control = this.hz_load.controls;
			if (control.length > 0) {
				this.control_id = control.map(function (item) {
					return item.control_id;
				});
			} else {
				this.control_id = [];
			}

			var control1 = this.hz_unload.controls;
			if (control1.length > 0) {
				this.control1_id = control1.map(function (item) {
					return item.control_id;
				});
			} else {
				this.control1_id = [];
			}
		},
		updateHaul: function updateHaul() {
			var _this8 = this;

			if (!this.okToUpdate()) {
				return;
			}
			this.haulUpdate = {
				'energy_companies_id': this.energy_companies_id,
				'fluid_type_id': this.fluid_type_id,
				'load_location_id': this.load_location_id,
				'unload_location_id': this.unload_location_id,
				'truck_id': this.truck_id,
				'user_id': this.user_id,
				'haul_start_datetime': this.haul_start_datetime,
				'haul_end_datetime': this.haul_end_datetime,
				'haul_start_date': this.haul_start_date,
				'haul_start_time': this.haul_start_time,
				'haul_end_date': this.haul_end_date,
				'haul_end_time': this.haul_end_time,
				'volume_estimate': this.volume_estimate,
				'volume_actual': this.volume_actual,
				'oil_actual': this.oil_actual,
				'water_percentage_estimate': this.water_percentage_estimate,
				'water_percentage_actual': this.water_percentage_actual,
				'bsw': this.bsw,
				'truck_ticket': this.ticket,
				'terminal_ticket': this.terminal_ticket,
				'total_distance': this.total_distance,
				'comments_start': this.comments_start,
				'other_comments': this.other_comments,
				'comments_end': this.comments_end,
				"wait_times": [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.wait_times)),
				"hazard_id": this.hazard_id,
				"control_id": this.control_id,
				"hazard1_id": this.hazard1_id,
				"control1_id": this.control1_id,
				"terminal_boss": this.terminal_boss,
				"trucks_unit_id": this.trucks_unit_id,
				"truck2_id": this.truck2_id,
				"tdg_id": this.tdg_id,
				"residue_last_contained": this.residue_last_contained,
				"cnr": this.cnr,
				"cnr_details": this.cnr_details

			};
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].update(this.haulUpdate, this.haulId).then(function (data) {
				_this8.$swal(data[0], data[1], data[0]).then(function (result) {
					_this8.getHaulData();
				});
				if (!_this8.data_in.haul_invoice) {
					_this8.$root.$emit('haulUpdated');
				} else {
					_this8.$root.$emit('haul_Updated');
				}
			}).catch(function (error) {
				_this8.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
			this.edit_analyst = false;
		},
		okToUpdate: function okToUpdate() {
			if (this.energy_companies_id === undefined || this.energy_companies_id.length == 0) {
				this.$swal('Alert!', 'Energy Company not selected', 'warning');
				return false;
			} else if (this.fluid_type_id === undefined || this.fluid_type_id.length == 0) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				return false;
			} else if (this.load_location_id === undefined || this.load_location_id.length == 0) {
				this.$swal('Alert!', 'Load Location not selected', 'warning');
				return false;
			} else if (this.truck_company_id === undefined || this.truck_company_id.length == 0) {
				this.$swal('Alert!', 'Truck Company not selected', 'warning');
				return false;
			} else if (this.unload_location_id === undefined || this.unload_location_id.length == 0) {
				this.$swal('Alert!', 'Unload Location not selected', 'warning');
				return false;
			} else if (this.user_id === undefined || this.user_id.length == 0) {
				this.$swal('Alert!', 'Driver not selected', 'warning');
				return false;
			} else if (this.truck_id === undefined || this.truck_id.length == 0) {
				this.$swal('Alert!', 'Truck not selected', 'warning');
				return false;
			} else if (this.volume_actual < 5) {
				this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning');
				return false;
			}
			return true;
		},
		est_detail: function est_detail() {
			this.calculate = true;
		},
		inputBlur: function inputBlur(variableName) {
			var variableValue = this[variableName];
			if (variableValue.length == 0) {
				this[variableName] = "0.00";
			} else {
				var tempValue = variableValue.split(".");
				if (tempValue.length == 1) {
					this[variableName] = String(variableValue) + ".00";
				} else if (tempValue.length == 2) {
					this[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
				}
			}
		},
		waterActualNumber: function waterActualNumber(evt) {
			var dotPosition = this.water_percentage_actual.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.water_percentage_actual.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		volumeActualNumber: function volumeActualNumber(evt) {
			var dotPosition = this.volume_actual.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.volume_actual.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		oilActualNumber: function oilActualNumber(evt) {
			var dotPosition = this.oil_actual.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.oil_actual.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		bswNumber: function bswNumber(evt) {
			var dotPosition = this.bsw.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.bsw.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		volumeEstimateNumber: function volumeEstimateNumber(evt) {
			var dotPosition = this.volume_estimate.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.volume_estimate.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		temperatureLoad: function temperatureLoad(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].temperature_load.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].temperature_load.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		temperatureULoad: function temperatureULoad(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].temperature_unload.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].temperature_unload.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		grossWeight: function grossWeight(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].gross_weight.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].gross_weight.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		tareWeight: function tareWeight(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].tare_weight.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].tare_weight.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		inputBlur1: function inputBlur1(variableName) {
			if (this.cnr && this.cnr_details.length > 0) {
				var variableValue = variableName;
				if (variableValue.length == 0) {
					variableName = "0.00";
				} else {
					var tempValue = variableValue.split(".");
					if (tempValue.length == 1) {
						variableName = String(variableValue) + ".00";
					} else if (tempValue.length == 2) {
						variableName = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
					}
				}
			}
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		selects_energy_company: function selects_energy_company() {
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				var trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];
				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					var drivers = this.trucking_companies[0]['drivers'];
					var drivers_index = drivers.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (drivers_index > -1) {
						var energycompanies = drivers[drivers_index]['energy_companies'];
						var energy_company_index = energycompanies.map(function (o) {
							return o.id;
						}).indexOf(this.energy_companies_id);
						this.getLoadLocation(energycompanies[energy_company_index].id, drivers[drivers_index].id);
					}
				}
			}
			if (this.role == 'super_admin') {
				var _trucking_companies3 = this.trucking_companies;
				var _current_truck_company_index3 = _trucking_companies3.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (_current_truck_company_index3 > -1) {
					var _drivers3 = _trucking_companies3[_current_truck_company_index3]['drivers'];
					var _drivers_index2 = _drivers3.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (_drivers_index2 > -1) {
						var _energycompanies2 = _drivers3[_drivers_index2]['energy_companies'];
						var _energy_company_index = _energycompanies2.map(function (o) {
							return o.id;
						}).indexOf(this.energy_companies_id);
						this.getLoadLocation(_energycompanies2[_energy_company_index].id, _drivers3[_drivers_index2].id);
					}
				}
			}
		},
		selects_load_location: function selects_load_location() {
			var loads_locations = this.loads_locations;
			var loads_locations_index = loads_locations.map(function (o) {
				return o.id;
			}).indexOf(this.load_location_id);
			if (loads_locations_index > -1) {
				var fluid_types = loads_locations[loads_locations_index]['fluids'];
				this.fluid_type_select = fluid_types.map(function (item) {
					return {
						'value': item.id,
						'text': item.name
					};
				});
				this.tdg_select = [];
				var ft_index = fluid_types.map(function (o) {
					return o.id;
				}).indexOf(this.fluid_type_id);
				if (ft_index > -1) {
					if ('tdg' in fluid_types[ft_index]) {
						this.tdg_select = fluid_types[ft_index].tdg;
					}
				}
			}
		},

		toggleInfoWindow: function toggleInfoWindow(marker, idx) {
			this.infoWindowPos = marker.position;
			this.infoContent = marker.title;
			this.infoLink = marker.www;

			if (this.currentMidx === idx) {
				this.infoWinOpen = !this.infoWinOpen;
			} else {
				this.currentMidx = idx;
				this.infoWinOpen = true;
			}
		},
		get_folders_by: function get_folders_by() {
			var _this9 = this;

			this.folderOptions = [];
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].get_folders_by(this.energy_companies_id).then(function (data) {
				if (data.status == 'success') {
					_this9.folders = data.folders;
					_this9.folders.map(function (item) {
						var item_data = {};
						item_data['value'] = item.id;
						item_data['text'] = item.name;
						_this9.folderOptions.push(item_data);
					});
				} else {
					_this9.$swal(data.status, data.message, data.status);
					_this9.folders = [];
				}
			}).catch(function (error) {
				_this9.$swal('Error', 'Server not response. ' + error, 'error');
				_this9.folders = [];
			});
		},
		addHaulsFolder: function addHaulsFolder() {
			if (this.selected.length < this.folderHaulIds.length && this.folderHaulIds.length != 0) {
				this.removeHaul();
			} else {
				if (this.selected.length != 0) {
					this.addHaul();
				} else {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('warning', 'Please select almos 1 folder', 'warning');
					this.modalFolders = false;
					this.getHaulData();
					this.loadingData = true;
				}
			}
		},
		addHaul: function addHaul() {
			var _this10 = this;

			this.foldersHauls = [];
			this.selected.map(function (item) {
				var item_data = {};
				item_data['folder_id'] = item;
				item_data['haul_id'] = _this10.haulId;
				_this10.foldersHauls.push(item_data);
			});
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].addHaulsFolder(this.foldersHauls).then(function (data) {
				if (data.status == 'success') {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data.status, data.message, data.status);
					_this10.haul_ids = [];
					_this10.modalFolders = false;
					_this10.getHaulData();
					_this10.loadingData = true;
				} else {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data.status, data.message, data.status);
					_this10.modalFolders = false;
					_this10.getHaulData();
					_this10.loadingData = true;
				}
			});
		},
		openModal: function openModal() {
			this.haul_ids = [];
			this.get_folders_by();
			this.haul_ids.push(this.haulId);
			this.modalFolders = true;
		},
		removeHaul: function removeHaul() {
			var _this11 = this;

			this.removeFolders = [];
			this.folderHaulIds.map(function (item) {
				if (!_this11.selected.includes(item)) {
					_this11.removeFolders.push(item);
				}
			});
			this.haul_ids = [];
			this.haul_ids.push(this.haulId);
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].remove(this.haul_ids, this.removeFolders).then(function (data) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data[0], data[1], data[0]);
				_this11.filter = '';

				_this11.getHaulData();
				_this11.loadingData = true;
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		hmsToSecondsOnly: function hmsToSecondsOnly(str) {
			var p = str.split(':'),
			    s = 0,
			    m = 1;
			while (p.length > 0) {
				s += m * parseInt(p.pop(), 10);
				m *= 60;
			}
			return s;
		},
		savePersonalTime: function savePersonalTime() {
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].savePersonalTime(0, this.filters_save).then(function (data) {
				if (data[0] == 'success') {
					return data[0];
				} else {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					return 0;
				}
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				return 0;
			});
		},
		invoiced_cost_click: function invoiced_cost_click() {
			console.log('click');
			this.edit_invoiced_cost = true;
			this.invoiced_cost_text = this.invoiced_cost;
			this.justification_text = this.justification;
		},
		invoicedcostNumber: function invoicedcostNumber(evt) {
			var dotPosition = this.invoiced_cost_text.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.invoiced_cost_text.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		invoiced_cost_cancel: function invoiced_cost_cancel() {
			this.edit_invoiced_cost = false;
		},
		invoiced_cost_update: function invoiced_cost_update() {
			var _this12 = this;

			var invoiced_cost = { 'invoiced_cost': this.invoiced_cost_text, 'justification': this.justification_text };
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].invoiced_cost_update(invoiced_cost, this.haulId).then(function (data) {
				_this12.$swal(data[0], data[1], data[0]).then(function (result) {
					_this12.invoiced_cost = _this12.invoiced_cost_text;
					_this12.justification = _this12.justification_text;
					_this12.$root.$emit('haul_Updated');
				});
			}).catch(function (error) {
				_this12.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit_invoiced_cost = false;
		},
		HZChange: function HZChange() {
			if (this.hazard_id.length === 0) {
				this.indeterminateHZ = false;
				this.hzAllSelected = false;
			} else if (this.hazard_id.length === this.hazards.length) {
				this.indeterminateHZ = false;
				this.hzAllSelected = true;
			} else {
				this.indeterminateHZ = true;
				this.hzAllSelected = false;
			}
		},
		HZToggleAll: function HZToggleAll(checked) {
			this.hazard_id = checked ? this.hazards.map(function (item) {
				return item.id;
			}) : [];
		},
		CTLChange: function CTLChange() {
			if (this.control_id.length === 0) {
				this.indeterminateCTL = false;
				this.ctlAllSelected = false;
			} else if (this.control_id.length === this.controls.length) {
				this.indeterminateCTL = false;
				this.ctlAllSelected = true;
			} else {
				this.indeterminateCTL = true;
				this.ctlAllSelected = false;
			}
		},
		CTLToggleAll: function CTLToggleAll(checked) {
			this.control_id = checked ? this.controls.map(function (item) {
				return item.id;
			}) : [];
		},
		HZ1Change: function HZ1Change() {
			if (this.hazard1_id.length === 0) {
				this.indeterminateHZ1 = false;
				this.hz1AllSelected = false;
			} else if (this.hazard1_id.length === this.hazards.length) {
				this.indeterminateHZ1 = false;
				this.hz1AllSelected = true;
			} else {
				this.indeterminateHZ1 = true;
				this.hz1AllSelected = false;
			}
		},
		HZ1ToggleAll: function HZ1ToggleAll(checked) {
			this.hazard1_id = checked ? this.hazards.map(function (item) {
				return item.id;
			}) : [];
		},
		CTL1Change: function CTL1Change() {
			if (this.control1_id.length === 0) {
				this.indeterminateCTL1 = false;
				this.ctl1AllSelected = false;
			} else if (this.control1_id.length === this.controls.length) {
				this.indeterminateCTL1 = false;
				this.ctl1AllSelected = true;
			} else {
				this.indeterminateCTL1 = true;
				this.ctl1AllSelected = false;
			}
		},
		CTL1ToggleAll: function CTL1ToggleAll(checked) {
			this.control1_id = checked ? this.controls.map(function (item) {
				return item.id;
			}) : [];
		},
		select_truck_unit: function select_truck_unit() {
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				var trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];
				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					this.truck_unit_select = this.trucking_companies[0]['truck_units'];
				}
			}
			if (this.role == 'super_admin') {
				var _trucking_companies4 = this.trucking_companies;
				var _current_truck_company_index4 = _trucking_companies4.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (_current_truck_company_index4 > -1) {
					this.truck_unit_select = _trucking_companies4[_current_truck_company_index4]['truck_units'];
				}
			}
		}
	}
});

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer',
  data: function data() {
    return {
      year: null
    };
  },
  created: function created() {
    var d = new Date();
    this.year = d.getFullYear();
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdownAccnt_vue__ = __webpack_require__(949);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appheader',
  created: function created() {
    var current_role = localStorage.getItem('role');
    if (current_role == 'trucking_company_admin' || current_role == 'trucking_operational_manager') {
      this.view = false;
      this.view1 = true;
      this.op = '/dash';
    } else if (current_role == 'trucking_company_admin_light') {
      this.view = false;
      this.view1 = true;
      this.op = '/hauls';
    } else {
      this.view = true;
      this.view1 = true;
      this.op = '/dashboard';
    }
  },
  components: {
    HeaderDropdownAccnt: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdownAccnt_vue__["a" /* default */]
  },
  data: function data() {
    return {
      view: true,
      current_role: localStorage.getItem('role')
    };
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown-accnt',
  created: function created() {
    var current_role = localStorage.getItem('role');
    if (current_role == 'super_analyst') {
      this.role = current_role;
      this.view = true;
    } else if (current_role == 'analyst') {
      this.role = current_role;
      this.view = true;
    } else if (current_role == 'marketing_accountant') {
      this.role = current_role;
      this.view = true;
    } else if (current_role == 'operations_manager') {
      this.role = current_role;
      this.view = true;
    } else if (current_role == 'driver') {
      this.role = current_role;
      this.view = true;
    } else if (current_role == 'trucking_company_admin' || current_role == 'trucking_operational_manager') {
      this.role = current_role;
      this.view = true;
    } else {
      this.view = false;
    }
  },
  data: function data() {
    return {
      itemsCount: 42,
      current_user: localStorage.getItem('full_name'),
      role: '',
      view: true,
      userID: localStorage.getItem('user_id')
    };
  },
  methods: {
    getProfile: function getProfile() {
      this.$router.push('/profile/' + this.userID);
    },
    logout: function logout() {
      this.$router.push('/logout');
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_hauls_haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    this.getAll();
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */]
  },
  data: function data() {
    return {
      badge: { text: '', variant: 'danger' }
    };
  },

  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    getAll: function getAll() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_9__views_hauls_haul_service__["a" /* default */].get_number_r().then(function (data) {
        if (data.status == 'success') {
          var tag = data.notif;
          if (tag !== 0) {
            _this.badge['text'] = tag.toString();
          } else {
            _this.badge['text'] = '';
          }
        } else {
          _this.$swal(data.status, data.message, data.status);
          return;
        }
      }).catch(function (error) {
        Vue.swal('Error', 'Server not response. ' + error, 'error');
      });
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_CardBarChartTarget__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);


var _created$data$name$na;






/* harmony default export */ __webpack_exports__["a"] = (_created$data$name$na = {
  created: function created() {
    if (localStorage.getItem("role") == "super_admin" || localStorage.getItem("role") == "super_analyst" || localStorage.getItem("role") == "analyst" || localStorage.getItem("role") == "marketing_accountant" || localStorage.getItem("role") == "operations_manager") {
      this.getChartConfigs();
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();

      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      this.dash_filter();
    } else if (localStorage.getItem("role") == "trucking_company_admin") {
      this.getAlerts();
    }
  },
  data: function data() {
    return {
      enabled: true,
      list: [],
      dragging: false,

      alerts: {},
      targets: [],
      targets_chart: [],
      targets_chart1: [],
      location_other: [],
      head_text: [],
      updateArgs: "",
      wait_time_chart: {},
      avg_daily_distance_chart: {},
      avg_minute_load_chart: {},
      fluid_by_unload_chart: {},
      fluid_by_load_chart: {},
      loadingData: true,

      h: 85,
      dataCharts: [],
      optionsChart: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false,
            categoryPercentage: 1,
            barPercentage: 0.5
          }],
          yAxes: [{
            display: false
          }]
        }
      },
      optionsChartB: {},
      optionsChartBB: {},
      role: "",
      view: true,
      energy_company_id: 1,
      calculate: false,
      model: {
        wti: "",
        index: "",
        forex: "",
        wadf: "",
        bbl: "",
        avg_haul_cost: "",
        terminal_cost: ""
      },

      estimate_selling_price: [],
      save_selling_price: {
        location_id: 0,
        price: "0.00",
        variables: [],
        initial_date: "",
        end_date: ""
      },
      bbl_array: [{ id: 1, name: "Heavy BBL to m3 6.289800" }, { id: 2, name: "Light BBL to m3 6.7" }],
      show_formula: "Selling Price(estimated) = ({({ WTI Last Price + Index } * Forex * BBL to m3 ) + WADF } - Avg Haul Cost)- Terminal Cost",
      chart: {
        'chart': { 'backgroundColor': '#37393F',
          'height': 600
        }
      },
      loadlocationselect: [],
      unloadlocationselect: [],
      indeterminateLL: false,
      llAllSelected: false,
      indeterminateUL: false,
      indeterminate: false,
      ulAllSelected: false,
      load_locations_id: [],
      unload_locations_id: [],
      users_select: [],
      users_id: [],
      indeterminate_user: false,
      user_AllSelected: false,
      chart_users: {
        'chart': { 'backgroundColor': '#37393F',
          'height': 600
        }
      },
      chart_activated: false,
      energy_companies_filter: [],
      operating_areas_filter: [],
      trucking_companies_filter: [],
      ec_filter: "",
      tc_filter: "All Trucking Companies",
      oa_filter: "All Operating Areas",
      filter_by: {
        energy_company_id: 1,
        trucking_company_id: "",
        initial_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("month").format("YYYY-MM-DD"),
        operating_area_id: ""
      },
      energy_companies_filter1: [],
      operating_areas_filter1: [],
      trucking_companies_filter1: [],
      ec_filter1: "All Energy Companies",
      tc_filter1: "All Trucking Companies",
      oa_filter1: "All Operating Areas",
      filter_by1: {
        energy_company_id: "",
        trucking_company_id: "",
        initial_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("month").format("YYYY-MM-DD"),
        operating_area_id: "",
        users: [],
        load_locations: [],
        unload_locations: []
      },
      company: "Energy Companies"
    };
  },

  name: "charts"
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_created$data$name$na, "name", "dashboard"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_created$data$name$na, "beforeCreate", function beforeCreate() {
  if (!localStorage.getItem("access_token")) {
    this.$router.replace("/login");
  }
  if (localStorage.getItem("role") == "trucking_company_admin") {
    this.$router.replace("/dash/");
  }
  if (localStorage.getItem("role") == "trucking_company_admin_light") {
    this.$router.replace("/users/");
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_created$data$name$na, "components", {
  CardBarChartTarget: __WEBPACK_IMPORTED_MODULE_1__dashboard_CardBarChartTarget__["a" /* default */],
  highcharts: __WEBPACK_IMPORTED_MODULE_3_highcharts_vue__["Chart"],
  draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_created$data$name$na, "computed", {
  draggingInfo: function draggingInfo() {
    return this.dragging ? "under drag" : "";
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_created$data$name$na, "methods", {
  getTargetIter: function getTargetIter(id) {
    var _this = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getTargetIter(this.filter_by, id).then(function (data) {
      if (data.status == "success" && data.targets_chart.length > 0) {
        _this.targets_chart.push(data.targets_chart[0]);
        if (_this.targets_chart.length != 0) {
          _this.targets_chart.forEach(function (target) {
            target.target_chart.chart.width = null;
            target.target_chart.chart.height = 280;
            target.target_chart.chart.margin = [9, 5, 60, 0];
            target.target_chart.yAxis[0]["max"] = null;
            target.target_chart.yAxis[0]["lineWidth"] = 0;
            target.target_chart.xAxis[0]["lineWidth"] = 1;

            target.target_chart.xAxis[0].labels = {
              enabled: true,
              formatter: function formatter() {
                return moment(this.value).format("MMM-DD");
              },
              autoRotation: [-90],
              style: {
                color: "#FFF",
                fontSize: "10px"
              }
            };

            target.target_chart1.series[0].dataLabels.style = {
              color: "white",
              textOutline: false,
              fontSize: "14px"
            };
            target.target_chart1.series[1].dataLabels.style = {
              color: "white",
              textOutline: false,
              fontSize: "14px"
            };
            target.target_chart.plotOptions.series.point.events.click = function () {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash04");
              localStorage.setItem("dashboard_start_date", moment(this.category).format("YYYY-MM-DD"));
              localStorage.setItem("dashboard_end_date", moment(this.category).format("YYYY-MM-DD"));
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem("dashboard_location_id", filters_sep[2]);
              localStorage.setItem("dashboard_location_name", filters_sep[3]);
              localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
              localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
              localStorage.setItem("dashboard_trucking_company_id", filters_sep[6]);
              localStorage.setItem("dashboard_trucking_company_name", filters_sep[7]);
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
          });
        }
      }
    }).catch(function (error) {
      _this.$swal("Error", "Server not response. " + error, "error");
      _this.loadingData = false;
    });
  },
  getTargetList: function getTargetList() {
    var _this2 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getTargetList(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this2.targets = data.targets;
        _this2.targets_chart = [];
        _this2.targets.map(function (item) {
          _this2.getTargetIter(item.id);
        });
      }
    }).catch(function (error) {
      _this2.$swal("Error", "Server not response. " + error, "error");
      _this2.loadingData = false;
    });
  },
  getAlerts: function getAlerts() {
    var _this3 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getAlerts(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this3.alerts = data.alerts;
      }
    }).catch(function (error) {
      _this3.$swal("Error", "Server not response. " + error, "error");
      _this3.loadingData = false;
    });
  },
  getFluidByUnloadChart: function getFluidByUnloadChart() {
    var _this4 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getFluidByUnloadChart(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this4.fluid_by_unload_chart = data.fluid_by_unload_chart;
        localStorage.setItem("dashboard_start_date", _this4.fluid_by_unload_chart.plotOptions.series.point.events.click);
        localStorage.setItem("dashboard_end_date", _this4.fluid_by_unload_chart.plotOptions.series.point.description);
        _this4.fluid_by_unload_chart.plotOptions.series.point.description = undefined;
        _this4.fluid_by_unload_chart.plotOptions.series.point.events.click = function () {
          var filters = this.options.key;
          var filters_sep = filters.split("?");
          localStorage.setItem("dashboard", "dash06");
          localStorage.setItem("dashboard_energy_id", filters_sep[0]);
          localStorage.setItem("dashboard_energy_name", filters_sep[1]);
          localStorage.setItem("dashboard_location_id", filters_sep[2]);
          localStorage.setItem("dashboard_location_name", filters_sep[3]);
          localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
          localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
          localStorage.setItem("dashboard_trucking_company_id", filters_sep[6]);
          localStorage.setItem("dashboard_trucking_company_name", filters_sep[7]);
          var currentUrl = "http://" + window.location.host + "/#/hauls";
          window.location.href = currentUrl;
          return;
        };
        _this4.fluid_by_unload_chart.tooltip.formatter = function () {
          var location = this.series.name;
          var min = this.series.options.stack;
          var percentage = " (" + this.point.percentage.toFixed(1) + "%)";
          return "<b>" + this.x + "</b><br/>" + location + ": " + this.y + min + percentage + "<br/>" + " Total Column: " + this.point.stackTotal + min;
        };
      }
    }).catch(function (error) {
      _this4.$swal("Error", "Server not response. " + error, "error");
      _this4.loadingData = false;
    });
  },
  getFluidByLoadChart: function getFluidByLoadChart() {
    var _this5 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getFluidByLoadChart(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this5.fluid_by_load_chart = data.fluid_by_load_chart;
        localStorage.setItem("dashboard_start_date", _this5.fluid_by_load_chart.plotOptions.series.point.events.click);
        localStorage.setItem("dashboard_end_date", _this5.fluid_by_load_chart.plotOptions.series.point.description);
        _this5.fluid_by_load_chart.plotOptions.series.point.description = undefined;
        _this5.fluid_by_load_chart.plotOptions.series.point.events.click = function () {
          var filters = this.options.key;
          var filters_sep = filters.split("?");
          localStorage.setItem("dashboard", "dash05");
          localStorage.setItem("dashboard_energy_id", filters_sep[0]);
          localStorage.setItem("dashboard_energy_name", filters_sep[1]);
          localStorage.setItem("dashboard_location_id", filters_sep[2]);
          localStorage.setItem("dashboard_location_name", filters_sep[3]);
          localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
          localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
          localStorage.setItem("dashboard_trucking_company_id", filters_sep[6]);
          localStorage.setItem("dashboard_trucking_company_name", filters_sep[7]);
          var currentUrl = "http://" + window.location.host + "/#/hauls";
          window.location.href = currentUrl;
          return;
        };
        _this5.fluid_by_load_chart.tooltip.formatter = function () {
          var location = this.series.name;
          var min = this.series.options.stack;
          var percentage = " (" + this.point.percentage.toFixed(1) + "%)";
          return "<b>" + this.x + "</b><br/>" + location + ": " + this.y + min + percentage + "<br/>" + " Total Column: " + this.point.stackTotal + min;
        };
      }
    }).catch(function (error) {
      _this5.$swal("Error", "Server not response. " + error, "error");
      _this5.loadingData = false;
    });
  },
  getAvgMinuteLoadChart: function getAvgMinuteLoadChart() {
    var _this6 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getAvgMinuteLoadChart(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this6.avg_minute_load_chart = data.avg_minute_load_chart;
        var filters = _this6.avg_minute_load_chart.plotOptions.series.point.events.click;
        _this6.avg_minute_load_chart.plotOptions.series.point.events.click = function () {
          var filters = this.options.key;
          var filters_sep = filters.split("?");
          localStorage.setItem("dashboard", "dash03");
          localStorage.setItem("dashboard_energy_id", filters_sep[0]);
          localStorage.setItem("dashboard_energy_name", filters_sep[1]);
          localStorage.setItem("dashboard_location_id", filters_sep[2]);
          localStorage.setItem("dashboard_location_name", filters_sep[3]);
          localStorage.setItem("dashboard_trucking_company_id", filters_sep[4]);
          localStorage.setItem("dashboard_trucking_company_name", filters_sep[5]);
          localStorage.setItem("dashboard_start_date", moment(this.category).format("YYYY-MM-DD"));
          localStorage.setItem("dashboard_end_date", moment(this.category).format("YYYY-MM-DD"));
          var currentUrl = "http://" + window.location.host + "/#/hauls";
          window.location.href = currentUrl;
          return;
        };
        _this6.avg_minute_load_chart.tooltip.formatter = function () {
          var location = this.series.name;
          var stack = this.series.options.stack;
          var min = " min";
          var percentage = " (" + this.point.percentage.toFixed(1) + "%)";
          if (stack.indexOf("Total") == 0) {
            stack = "Total";
          } else if (stack.indexOf("Oil") == 0) {
            stack = "Oil";
          } else if (stack.indexOf("Water") == 0) {
            stack = "Water";
          } else if (stack.indexOf("Load") == 0) {
            stack = "Load";
          } else if (stack.indexOf("Unload") == 0) {
            stack = "Unload";
          } else if (stack.indexOf(" Load/Unload") == 0) {
            stack = "Load/Unload";
            min = " ";
            percentage = " ";
          }

          if (this.series.name.indexOf("Total") == 0) {
            location = this.series.options.stack.substring(5, this.series.options.stack.length);
            stack = "Total";
          } else if (this.series.name.indexOf("Oil") == 0) {
            location = this.series.options.stack.substring(3, this.series.options.stack.length);
            stack = "Oil";
          } else if (this.series.name.indexOf("Water") == 0) {
            location = this.series.options.stack.substring(5, this.series.options.stack.length);
            stack = "Water";
          } else if (this.series.name.indexOf("Load") == 0) {
            location = this.series.options.stack.substring(4, this.series.options.stack.length);
            stack = "Load";
          } else if (this.series.name.indexOf("Unload") == 0) {
            location = this.series.options.stack.substring(6, this.series.options.stack.length);
            stack = "Unload";
          } else if (this.series.name.indexOf(" Load/Unload") == 0) {
            location = this.series.options.stack.substring(12, this.series.options.stack.length);
            stack = "Load/Unload";
          }

          return "<b>" + this.x + "</b><br/>" + stack + "<br/>" + location + ": " + this.y + min + percentage + "<br/>" + " Total Column: " + this.point.stackTotal + min;
        };
      }
    }).catch(function (error) {
      _this6.$swal("Error", "Server not response. " + error, "error");
      _this6.loadingData = false;
    });
  },
  getTargetChart: function getTargetChart() {
    var _this7 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getTargetChart(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this7.targets_chart = data.targets_chart;
        if (_this7.targets_chart.length != 0) {
          _this7.targets_chart.forEach(function (target) {
            target.target_chart.chart.width = null;
            target.target_chart.chart.height = 280;
            target.target_chart.chart.margin = [9, 5, 60, 0];
            target.target_chart.yAxis[0]["max"] = null;
            target.target_chart.yAxis[0]["lineWidth"] = 0;
            target.target_chart.xAxis[0]["lineWidth"] = 1;

            target.target_chart.xAxis[0].labels = {
              enabled: true,
              formatter: function formatter() {
                return moment(this.value).format("MMM-DD");
              },
              autoRotation: [-90],
              style: {
                color: "#FFF",
                fontSize: "10px"
              }
            };

            target.target_chart1.series[0].dataLabels.style = {
              color: "white",
              textOutline: false,
              fontSize: "14px"
            };
            target.target_chart1.series[1].dataLabels.style = {
              color: "white",
              textOutline: false,
              fontSize: "14px"
            };
            target.target_chart.plotOptions.series.point.events.click = function () {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash04");
              localStorage.setItem("dashboard_start_date", moment(this.category).format("YYYY-MM-DD"));
              localStorage.setItem("dashboard_end_date", moment(this.category).format("YYYY-MM-DD"));
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem("dashboard_location_id", filters_sep[2]);
              localStorage.setItem("dashboard_location_name", filters_sep[3]);
              localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
              localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
              localStorage.setItem("dashboard_trucking_company_id", filters_sep[6]);
              localStorage.setItem("dashboard_trucking_company_name", filters_sep[7]);
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
          });
        }
      }
    }).catch(function (error) {
      _this7.$swal("Error", "Server not response. " + error, "error");
      _this7.loadingData = false;
    });
  },
  getAvgDailyDistance: function getAvgDailyDistance() {
    var _this8 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getAvgDailyDistance(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this8.avg_daily_distance_chart = data.avg_daily_distance_chart;
        _this8.avg_daily_distance_chart.plotOptions.series.point.events.click = function () {
          var filters = this.options.key;
          var filters_sep = filters.split("?");
          localStorage.setItem("dashboard", "dash01");
          localStorage.setItem("dashboard_start_date", moment(this.category).format("YYYY-MM-DD"));
          localStorage.setItem("dashboard_end_date", moment(this.category).format("YYYY-MM-DD"));
          localStorage.setItem("dashboard_energy_id", filters_sep[0]);
          localStorage.setItem("dashboard_energy_name", filters_sep[1]);
          localStorage.setItem("dashboard_trucking_company_id", filters_sep[2]);
          localStorage.setItem("dashboard_trucking_company_name", filters_sep[3]);
          var currentUrl = "http://" + window.location.host + "/#/hauls";
          window.location.href = currentUrl;
          return;
        };
      }
    }).catch(function (error) {
      _this8.$swal("Error", "Server not response. " + error, "error");
      _this8.loadingData = false;
    });
  },
  getWaitTimeChart: function getWaitTimeChart() {
    var _this9 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getWaitTimeChart(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this9.wait_time_chart = data.wait_time_chart;
        _this9.wait_time_chart.plotOptions.series.point.events.click = function () {
          var filters = this.options.key;
          var filters_sep = filters.split("?");
          localStorage.setItem("dashboard", "dash02");
          localStorage.setItem("dashboard_start_date", moment(this.category).format("YYYY-MM-DD"));
          localStorage.setItem("dashboard_end_date", moment(this.category).add(6, "days").format("YYYY-MM-DD"));
          localStorage.setItem("dashboard_energy_id", filters_sep[0]);
          localStorage.setItem("dashboard_energy_name", filters_sep[1]);
          localStorage.setItem("dashboard_trucking_company_id", filters_sep[2]);
          localStorage.setItem("dashboard_trucking_company_name", filters_sep[3]);
          var currentUrl = "http://" + window.location.host + "/#/hauls";
          window.location.href = currentUrl;
          return;
        };
      }
    }).catch(function (error) {
      _this9.$swal("Error", "Server not response. " + error, "error");
      _this9.loadingData = false;
    });
  },
  getDashboard: function getDashboard() {
    var _this10 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getDashboard(this.filter_by).then(function (data) {
      if (data.status == "success") {
        _this10.location_other = data.location_other;

        if (_this10.location_other.length != 0) {
          _this10.location_other.forEach(function (other) {
            other.target_chart.plotOptions.series.point.events.click = function () {
              var filters = this.options.key;
              var filters_sep = filters.split("?");
              localStorage.setItem("dashboard", "dash07");
              localStorage.setItem("dashboard_start_date", moment(this.category).format("YYYY-MM-DD"));
              localStorage.setItem("dashboard_end_date", moment(this.category).format("YYYY-MM-DD"));
              localStorage.setItem("dashboard_energy_id", filters_sep[0]);
              localStorage.setItem("dashboard_energy_name", filters_sep[1]);
              localStorage.setItem("dashboard_location_id", filters_sep[2]);
              localStorage.setItem("dashboard_location_name", filters_sep[3]);
              localStorage.setItem("dashboard_fluid_type_id", filters_sep[4]);
              localStorage.setItem("dashboard_fluid_type_name", filters_sep[5]);
              localStorage.setItem("dashboard_trucking_company_id", filters_sep[6]);
              localStorage.setItem("dashboard_trucking_company_name", filters_sep[7]);
              var currentUrl = "http://" + window.location.host + "/#/hauls";
              window.location.href = currentUrl;
              return;
            };
          });
        }

        var monthNames = [" Jan. ", " Feb. ", " Mar. ", " Apr. ", " May. ", " Jun. ", " Jul. ", " Aug. ", " Sep. ", " Oct. ", " Nov. ", " Dec. "];
        _this10.energy_companies_filter = data.energy_companies_filter;

        _this10.energy_companies_filter.forEach(function (value) {
          if (app.filter_by["energy_company_id"] === value.id) {
            app.ec_filter = value.company_name;
          } else {
            localStorage.setItem("temp_energy_company_id", value.id);
            localStorage.setItem("temp_energy_company_name", value.company_name);
          }
        });
        if (_this10.ec_filter == "") {
          _this10.ec_filter = localStorage.getItem("temp_energy_company_name");
          _this10.filter_by["energy_company_id"] = localStorage.getItem("temp_energy_company_id");
        }
        if ("temp_energy_company_id" in localStorage) {
          localStorage.removeItem("temp_energy_company_id");
        }
        if ("temp_energy_company_name" in localStorage) {
          localStorage.removeItem("temp_energy_company_name");
        }
        _this10.role = data.role;
        if (_this10.role == "super_admin") {
          _this10.view = true;
        } else {
          _this10.view = false;
          _this10.filter_by["energy_company_id"] = _this10.energy_companies_filter[0].id;
        }
        var pos = _this10.energy_companies_filter.map(function (o) {
          return o.id;
        }).indexOf(_this10.filter_by["energy_company_id"]);
        if (pos > -1) {
          _this10.operating_areas_filter = _this10.energy_companies_filter[pos].operating_areas;
          _this10.trucking_companies_filter = _this10.energy_companies_filter[pos].trucking_companies;
        } else {
          _this10.operating_areas_filter = [];
          _this10.trucking_companies_filter = [];
        }
        _this10.loadingData = false;
      } else {
        _this10.$swal(data.status, data.message, data.status);
        _this10.loadingData = false;

        return;
      }
    }).catch(function (error) {
      _this10.$swal("Error", "Server not response. " + error, "error");
      _this10.loadingData = false;
    });
  },
  $eval: function $eval(expr, obj) {
    var item = obj;
    return eval(expr);
  },
  change: function change() {
    var _this11 = this;

    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].putChartConfigs(this.list).then(function (data) {
      _this11.getChartConfigs();
    });
  },
  activate_custom_backdrop: function activate_custom_backdrop() {
    this.$root.$el.classList.add("custom_backdrop_behavior");
  },
  deactivate_custom_backdrop: function deactivate_custom_backdrop() {
    this.$root.$el.classList.remove("custom_backdrop_behavior");
  },
  bbl: function bbl() {
    var app = this;
    __WEBPACK_IMPORTED_MODULE_4__users_users_service__["a" /* default */].bbl().then(function (data) {
      if (data[0] == "success") {
        app.getDashboard();
        app.getAlerts();
      } else {
        Vue.swal(data[0], data[1], data[0]);
      }
    });
  },
  iFilter: function iFilter() {
    if (this.filter_by["end_date"] == "" || !this.filter_by["end_date"]) {
      this.filter_by["end_date"] = "";
    }
    this.getDashboard();
    this.getAlerts();
    this.getAvgDailyDistance();
    this.getWaitTimeChart();

    this.getAvgMinuteLoadChart();
    this.getFluidByLoadChart();
    this.getFluidByUnloadChart();
    this.getTargetList();
    this.loadingData = true;
  },
  eFilter: function eFilter() {
    if (this.filter_by["initial_date"] == "" || !this.filter_by["initial_date"]) {
      this.filter_by["initial_date"] = "";
    }
    this.getDashboard();
    this.getAlerts();
    this.getAvgDailyDistance();
    this.getWaitTimeChart();

    this.getAvgMinuteLoadChart();
    this.getFluidByLoadChart();
    this.getFluidByUnloadChart();
    this.getTargetList();

    this.loadingData = true;
  },
  clearFilters: function clearFilters() {
    this.ec_filter = "";
    this.filter_by = {
      energy_company_id: 1,
      trucking_company_id: "",
      initial_date: moment().startOf("month").format("YYYY-MM-DD"),
      end_date: moment().endOf("month").format("YYYY-MM-DD"),
      operating_area_id: ""
    };
    this.loadingData = true;
    this.getDashboard();
    this.getAlerts();
    this.getAvgDailyDistance();
    this.getWaitTimeChart();

    this.getAvgMinuteLoadChart();
    this.getFluidByLoadChart();
    this.getFluidByUnloadChart();
    this.getTargetList();
  },
  ecFilter: function ecFilter(ec_filter, id) {
    this.ec_filter = ec_filter;
    this.filter_by["energy_company_id"] = id;
    this.oa_filter = "All Operating Areas";
    this.loadingData = true;
    this.getDashboard();
    this.getAlerts();
    this.getAvgDailyDistance();
    this.getWaitTimeChart();

    this.getAvgMinuteLoadChart();
    this.getFluidByLoadChart();
    this.getFluidByUnloadChart();
    this.getTargetList();
  },
  tcFilter: function tcFilter(tc_filter, id) {
    this.tc_filter = tc_filter;
    this.filter_by["trucking_company_id"] = id;
    if (id == 0) {
      this.filter_by["trucking_company_id"] = "";
    }
    this.loadingData = true;
    this.getDashboard();
    this.getAlerts();
    this.getAvgDailyDistance();
    this.getWaitTimeChart();

    this.getAvgMinuteLoadChart();
    this.getFluidByLoadChart();
    this.getFluidByUnloadChart();
    this.getTargetList();
  },
  oaFilter: function oaFilter(oa_filter, id) {
    this.oa_filter = oa_filter;
    this.filter_by["operating_area_id"] = id;
    if (id == 0) {
      this.filter_by["operating_area_id"] = "";
    }
    this.loadingData = true;
    this.getDashboard();
    this.getAlerts();
    this.getAvgDailyDistance();
    this.getWaitTimeChart();

    this.getAvgMinuteLoadChart();
    this.getFluidByLoadChart();
    this.getFluidByUnloadChart();
    this.getTargetList();
  },
  getChartConfigs: function getChartConfigs() {
    var _this12 = this;

    var app = this;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].getChartConfigs().then(function (data) {
      _this12.list = data;
    });
  },
  ecFilter1: function ecFilter1(ec_filter, id) {
    this.ec_filter1 = ec_filter;
    this.filter_by1["energy_company_id"] = id;
    this.oa_filter1 = "All Operating Areas";
    if (id !== 0) {
      var pos = this.energy_companies_filter1.map(function (o) {
        return o.id;
      }).indexOf(this.filter_by1["energy_company_id"]);
      if (pos > -1) {
        this.operating_areas_filter1 = this.energy_companies_filter1[pos].operating_areas;
        this.filter_by1["operating_area_id"] = '';
        this.location_list();
        this.load_locations_id = [];
        this.unload_locations_id = [];
        this.users_id = [];
        this.user_Change();
      } else {
        this.operating_areas_filter1 = [];
        this.loadlocationselect = [];
        this.unloadlocationselect = [];
        this.filter_by1["operating_area_id"] = '';
        this.load_locations_id = [];
        this.unload_locations_id = [];
        this.users_id = [];
        this.user_Change();
      }
    } else {
      this.filter_by1['energy_company_id'] = '';
      this.filter_by1["operating_area_id"] = '';
      this.ec_list();
      this.location_list();
      this.load_locations_id = [];
      this.unload_locations_id = [];
      this.users_id = [];
      this.user_Change();
    }
  },
  tcFilter1: function tcFilter1(tc_filter, id) {
    this.tc_filter1 = tc_filter;
    this.filter_by1["trucking_company_id"] = id;

    if (id !== 0) {
      var pos = this.trucking_companies_filter1.map(function (o) {
        return o.id;
      }).indexOf(this.filter_by1["trucking_company_id"]);
      if (pos > -1) {
        this.energy_companies_filter1 = this.trucking_companies_filter1[pos].energy_companies;
        this.users_select = this.trucking_companies_filter1[pos].drivers;
        this.filter_by1['energy_company_id'] = '';
        this.filter_by1["operating_area_id"] = '';
        this.ec_list();
        this.location_list();
        this.load_locations_id = [];
        this.unload_locations_id = [];
        this.users_id = [];
        this.user_Change();
      } else {
        this.energy_companies_filter1 = [];
        this.users_select = [];
        this.filter_by1['energy_company_id'] = '';
        this.filter_by1["operating_area_id"] = '';
        this.loadlocationselect = [];
        this.unloadlocationselect = [];
        this.load_locations_id = [];
        this.unload_locations_id = [];
        this.users_id = [];
        this.user_Change();
      }
    } else {
      this.filter_by1['energy_company_id'] = '';
      this.filter_by1["operating_area_id"] = '';
      this.ec_list();
      this.location_list();
      this.load_locations_id = [];
      this.unload_locations_id = [];
      this.users_id = [];
      this.user_Change();
    }
  },
  iFilter1: function iFilter1() {
    if (this.filter_by1["end_date"] == "" || !this.filter_by1["end_date"]) {
      this.filter_by1["end_date"] = "";
    }
  },
  eFilter1: function eFilter1() {
    if (this.filter_by1["initial_date"] == "" || !this.filter_by1["initial_date"]) {
      this.filter_by1["initial_date"] = "";
    }
  },
  oaFilter1: function oaFilter1(oa_filter, id) {
    this.oa_filter1 = oa_filter;
    this.filter_by1["operating_area_id"] = id;
    if (id == 0) {
      this.filter_by1["operating_area_id"] = "";
    }
    this.location_list();
    this.load_locations_id = [];
    this.unload_locations_id = [];
  },
  clearFilters1: function clearFilters1() {

    this.ec_filter1 = "All Energy Companies";
    this.tc_filter1 = "All Trucking Companies";
    this.oa_filter1 = "All Operating Areas";
    this.filter_by1 = {
      energy_company_id: "",
      trucking_company_id: "",
      initial_date: moment().startOf("month").format("YYYY-MM-DD"),
      end_date: moment().endOf("month").format("YYYY-MM-DD"),
      operating_area_id: "",
      users: [],
      load_locations: [],
      unload_locations: []
    };
    this.loadlocationselect = [];
    this.unloadlocationselect = [];
    this.load_locations_id = [];
    this.unload_locations_id = [];
    this.users_id = [];
  },
  alert_filter: function alert_filter(flag) {
    localStorage.setItem("dashboard", "dash08");
    localStorage.setItem("dashboard_start_date", this.filter_by.initial_date);
    localStorage.setItem("dashboard_end_date", this.filter_by.end_date);
    localStorage.setItem("dashboard_energy_id", this.filter_by.energy_company_id);
    localStorage.setItem("dashboard_energy_name", this.ec_filter);
    localStorage.setItem("dashboard_trucking_company_id", this.filter_by.trucking_company_id);
    localStorage.setItem("dashboard_trucking_company_name", this.tc_filter);
    localStorage.setItem("dashboard_flag_name", flag);
    var currentUrl = "http://" + window.location.host + "/#/hauls";
    window.location.href = currentUrl;
    return;
  },
  est_detail: function est_detail(est) {
    this.calculate = true;
    this.estimate_selling_price = est.variables;
    this.save_selling_price.location_id = est.location_id;
    this.save_selling_price.price = est.price;
    this.save_selling_price.variables = est.variables;
    this.save_selling_price.initial_date = est.initial_date;
    this.save_selling_price.end_date = est.end_date;
  },
  checkedField: function checkedField() {
    var var_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var index = arguments[1];
    var chk = arguments[2];

    var cad = var_name.slice(0, -1);
    var show_formula = this.show_formula;
    var newcad = show_formula.replace(cad, "excluded");
  },
  save_formula: function save_formula() {
    var _this13 = this;

    this.calculate = false;
    this.save_selling_price.variables = this.estimate_selling_price;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].Config_Formula(this.save_selling_price).then(function (data) {
      _this13.$swal(data.status, data.message, data.status).then(function (result) {
        if (data.status == "success") {
          _this13.getDashboard();
          _this13.getAlerts();
          _this13.getAvgDailyDistance();
          _this13.getWaitTimeChart();

          _this13.getAvgMinuteLoadChart();
          _this13.getFluidByLoadChart();
          _this13.getFluidByUnloadChart();
          _this13.getTargetList();
        }
      });
    }).catch(function (error) {
      _this13.$swal("Error", "Server not response. " + error, "error");
    });
  },
  get_volume_by_date_chart: function get_volume_by_date_chart() {
    var _this14 = this;

    this.filter_by1['load_locations'] = this.load_locations_id;
    this.filter_by1['unload_locations'] = this.unload_locations_id;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].get_volume_by_date(this.filter_by1).then(function (data) {
      if (data.status == "success") {
        _this14.chart = data.volume_by_date_chart;
      }
    }).catch(function (error) {
      _this14.$swal("Error", "Server not response. " + error, "error");
      _this14.loadingData = false;
    });
  },
  get_volume_by_date_user_chart: function get_volume_by_date_user_chart() {
    var _this15 = this;

    this.filter_by1['load_locations'] = this.load_locations_id;
    this.filter_by1['unload_locations'] = this.unload_locations_id;
    this.filter_by1['users'] = this.users_id;
    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].get_volume_user(this.filter_by1).then(function (data) {
      if (data.status == "success") {
        _this15.chart_users = data.volume_by_date_user_chart;
      }
    }).catch(function (error) {
      _this15.$swal("Error", "Server not response. " + error, "error");
      _this15.loadingData = false;
    });
  },
  LLToggleAll: function LLToggleAll(checked) {
    this.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
      return item.id;
    }) : [];
  },
  ULToggleAll: function ULToggleAll(checked) {
    this.unload_locations_id = checked ? this.unloadlocationselect.map(function (item) {
      return item.id;
    }) : [];
  },
  user_ToggleAll: function user_ToggleAll(checked) {
    this.users_id = checked ? this.users_select.map(function (item) {
      return item.id;
    }) : [];
  },
  loadLocationsChange: function loadLocationsChange() {
    if (this.role == 'super_admin') {
      if (this.load_locations_id.length === 0) {
        this.indeterminateLL = false;
        this.llAllSelected = false;
      } else if (this.load_locations_id.length === this.loadlocationselect.length) {
        this.indeterminateLL = false;
        this.llAllSelected = true;
      } else {
        this.indeterminateLL = true;
        this.llAllSelected = false;
      }
    }
  },
  unloadLocationsChange: function unloadLocationsChange() {
    if (this.role == 'super_admin') {
      if (this.unload_locations_id.length === 0) {
        this.indeterminateUL = false;
        this.ulAllSelected = false;
      } else if (this.unload_locations_id.length === this.unloadlocationselect.length) {
        this.indeterminateUL = false;
        this.ulAllSelected = true;
      } else {
        this.indeterminateUL = true;
        this.ulAllSelected = false;
      }
    }
  },
  user_Change: function user_Change() {
    if (this.role == 'super_admin') {
      if (this.users_id.length === 0) {
        this.indeterminate_user = false;
        this.user_AllSelected = false;
      } else if (this.users_id.length === this.users_select.length) {
        this.indeterminate_user = false;
        this.user_AllSelected = true;
      } else {
        this.indeterminate_user = true;
        this.user_AllSelected = false;
      }
    }
  },
  location_list: function location_list() {
    if (this.role == 'super_admin') {
      this.loadlocationselect = [];
      this.unloadlocationselect = [];
      var location = this.operating_areas_filter1;
      if (this.filter_by1["operating_area_id"] === "") {
        var new_unloadlocations = [];
        var new_loadlocations = [];
        location.map(function (item) {
          item.loads.forEach(function (element) {
            var index2 = new_loadlocations.map(function (o) {
              return o.id;
            }).indexOf(element.id);
            if (index2 < 0) {
              new_loadlocations.push(element);
            }
          });
          item.unloads.forEach(function (element) {
            var index1 = new_unloadlocations.map(function (o) {
              return o.id;
            }).indexOf(element.id);
            if (index1 < 0) {
              new_unloadlocations.push(element);
            }
          });
        });
        if (new_unloadlocations.length > 0) {
          var mapped = new_unloadlocations.map(function (el, i) {
            return { index: i, value: el.legal_location.toLowerCase() };
          });
          mapped.sort(function (a, b) {
            if (a.value > b.value) {
              return 1;
            }
            if (a.value < b.value) {
              return -1;
            }
            return 0;
          });
          this.unloadlocationselect = mapped.map(function (el) {
            return new_unloadlocations[el.index];
          });
        }
        if (new_loadlocations.length > 0) {
          var mapped1 = new_loadlocations.map(function (el, i) {
            return { index: i, value: el.legal_location.toLowerCase() };
          });
          mapped1.sort(function (a, b) {
            if (a.value > b.value) {
              return 1;
            }
            if (a.value < b.value) {
              return -1;
            }
            return 0;
          });
          this.loadlocationselect = mapped1.map(function (el) {
            return new_loadlocations[el.index];
          });
        }
      } else {
        var index = location.map(function (o) {
          return o.id;
        }).indexOf(this.filter_by1["operating_area_id"]);
        if (index > -1) {
          this.loadlocationselect = location[index].loads;
          this.unloadlocationselect = location[index].unloads;
        }
      }
    }
  },
  user_list: function user_list() {
    var _this16 = this;

    if (this.role == 'super_admin') {
      this.users_select = [];
      var trucking_companies = this.trucking_companies_filter;
      if (this.filter_by["trucking_company_id"] === "") {
        trucking_companies.map(function (item) {
          item.drivers.forEach(function (element) {
            _this16.users_select.push(element);
          });
        });
      } else {
        var index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.filter_by["trucking_company_id"]);
        if (index > -1) {
          this.users_select = trucking_companies[index].drivers;
        }
      }
    }
  },
  generate_chart_click: function generate_chart_click() {
    this.get_volume_by_date_chart();
    this.get_volume_by_date_user_chart();
  },
  activate_chart_click: function activate_chart_click() {
    if (this.role == 'super_admin') {
      this.chart_activated = !this.chart_activated;
    }
  },
  dash_filter: function dash_filter() {
    var _this17 = this;

    __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_service__["a" /* default */].dashboard_tc().then(function (data) {
      if (data.status == "success") {
        _this17.trucking_companies_filter1 = data.trucking_company_filter;
      } else {
        _this17.$swal(data.status, data.message, data.status);
        return;
      }
    }).catch(function (error) {
      _this17.$swal("Error", "Server not response. " + error, "error");
    });
  },
  ec_list: function ec_list() {
    var _this18 = this;

    this.operating_areas_filter1 = [];
    var energy_companies = this.energy_companies_filter1;
    if (this.filter_by1["energy_company_id"] === "") {
      energy_companies.map(function (item) {
        item.operating_areas.forEach(function (element) {
          _this18.operating_areas_filter1.push(element);
        });
      });
    } else {
      var index = energy_companies.map(function (o) {
        return o.id;
      }).indexOf(this.filter_by1["energy_company_id"]);
      if (index > -1) {
        this.operating_areas_filter1 = energy_companies[index].operating_areas;
      }
    }
  }
}), _created$data$name$na);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(978);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  mixins: [reactiveProp],
  props: ['height', 'options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getDashboard: function getDashboard(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getTargetIter: function getTargetIter(filter_by, id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/target/' + id + '/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getTargetList: function getTargetList(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/target/list/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAlerts: function getAlerts(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/alerts/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAvgDailyDistance: function getAvgDailyDistance(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/avg_daily/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getWaitTimeChart: function getWaitTimeChart(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/wait_time/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getTargetChart: function getTargetChart(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/target/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAvgMinuteLoadChart: function getAvgMinuteLoadChart(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/avg_minute/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getFluidByUnloadChart: function getFluidByUnloadChart(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/fluid_by_location/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getFluidByLoadChart: function getFluidByLoadChart(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/fluid_by_load/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getChartConfigs: function getChartConfigs() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/config/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data.configs.dashboard_charts);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	putChartConfigs: function putChartConfigs(config) {
		console.log('dasdasd', config);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/config/', { "dashboard_charts": config }, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	Config_Formula: function Config_Formula(config) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/config_formula/', { "formula": config }, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getAlerts_tc: function getAlerts_tc() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dash/alerts/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	dashboard_tc: function dashboard_tc() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dash_tc/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_volume_by_date: function get_volume_by_date(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/volume_by_date/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_volume_user: function get_volume_user(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/dashboard/volume_user/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;

					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_roles_roles_service__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(146);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',

  data: function data() {
    return {
      user: '',
      password: '',
      dataRequired: false,
      loginFailed: false,
      loginFailedMessage: '',
      waiting: false,
      waitingMessage: 'Please wait...',
      notResponse: false,
      roles: [],
      selectedRole: null,
      ForgotPassword: false,
      model: {
        first_name: '',
        last_name: '',
        usename: '',
        email: '',
        role_id: null
      },

      show: true
    };
  },
  methods: {
    register: function register() {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Opss!', 'Register is disabled', 'error');
    },
    loginUser: function loginUser() {
      if (this.user.trim() && this.password.trim()) {
        this.waiting = true;
        this.doLogin(this.user, this.password);
      } else {
        this.dataRequired = true;
        this.cleanDataRequired();
      }
    },
    cleanDataRequired: function cleanDataRequired() {
      var _this = this;

      setTimeout(function () {
        _this.dataRequired = !_this.dataRequired;
      }, 2000);
    },
    doLogin: function doLogin(user, password) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].login(user, password).then(function (loogResp) {
        _this2.waiting = false;
        if (loogResp[0] === 'success') {
          if (localStorage.getItem('role') == 'trucking_company_admin') {
            _this2.$router.replace('/hauls/');
          } else if (localStorage.getItem('role') == 'trucking_company_admin_light') {
            _this2.$router.replace('/hauls/');
          } else {
            _this2.$router.replace('/dashboard');
          }
        } else {
          _this2.loginFailed = true;
          _this2.loginFailedMessage = loogResp[1];
          if (_this2.loginFailedMessage == 'Incorrect username or password.') {
            setTimeout(function () {
              _this2.loginFailed = false;
            }, 3000);
          } else {
            setTimeout(function () {
              _this2.loginFailed = false;
            }, 6000);
          }
        }
      }).catch(function (error) {
        _this2.waiting = false;
        _this2.notResponse = true;
        console.log(error);
        setTimeout(function () {
          _this2.notResponse = false;
        }, 3000);
      });
    },
    resetNewModal: function resetNewModal() {
      this.user = '';
    },
    getUser: function getUser() {
      var _this3 = this;

      if (this.user.trim()) {
        __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].getUser(this.user).then(function (data) {
          if (data[0] == 'success') {
            _this3.$swal({ title: data[1],
              text: data[2],
              type: 'success',
              showCancelButton: false });
          } else {
            _this3.$swal({ title: data[1],
              text: data[2],
              type: 'warning',
              showCancelButton: false });
          }
          _this3.$refs.ForgotPassword.hide();
          _this3.show = false;
        }).catch(function (error) {
          _this3.$swal('Error', 'Server not response. ' + error, 'error');
          _this3.$refs.ForgotPassword.hide();
          _this3.show = false;
        });
      } else {
        this.$swal({ title: 'Opss!',
          text: 'Email Required',
          type: 'warning',
          showCancelButton: false });
      }
    },
    Cancel: function Cancel() {
      this.$refs.ForgotPassword.hide();
      this.show = false;
    },
    ForgotP: function ForgotP() {
      this.$refs.ForgotPassword.show();
      this.show = true;
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table_vue__ = __webpack_require__(1045);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tables',
  components: { cTable: __WEBPACK_IMPORTED_MODULE_0__Table_vue__["a" /* default */] }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var shuffleArray = function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      items: shuffleArray([{ username: 'Samppa Nori', registered: '2012/01/01', role: 'Member', status: 'Active' }, { username: 'Estavan Lykos', registered: '2012/02/01', role: 'Staff', status: 'Banned' }, { username: 'Chetan Mohamed', registered: '2012/02/01', role: 'Admin', status: 'Inactive' }, { username: 'Derick Maximinus', registered: '2012/03/01', role: 'Member', status: 'Pending' }, { username: 'Friderik Dávid', registered: '2012/01/21', role: 'Staff', status: 'Active' }, { username: 'Yiorgos Avraamu', registered: '2012/01/01', role: 'Member', status: 'Active' }, { username: 'Avram Tarasios', registered: '2012/02/01', role: 'Staff', status: 'Banned' }, { username: 'Quintin Ed', registered: '2012/02/01', role: 'Admin', status: 'Inactive' }, { username: 'Enéas Kwadwo', registered: '2012/03/01', role: 'Member', status: 'Pending' }, { username: 'Agapetus Tadeáš', registered: '2012/01/21', role: 'Staff', status: 'Active' }, { username: 'Carwyn Fachtna', registered: '2012/01/01', role: 'Member', status: 'Active' }, { username: 'Nehemiah Tatius', registered: '2012/02/01', role: 'Staff', status: 'Banned' }, { username: 'Ebbe Gemariah', registered: '2012/02/01', role: 'Admin', status: 'Inactive' }, { username: 'Eustorgios Amulius', registered: '2012/03/01', role: 'Member', status: 'Pending' }, { username: 'Leopold Gáspár', registered: '2012/01/21', role: 'Staff', status: 'Active' }, { username: 'Pompeius René', registered: '2012/01/01', role: 'Member', status: 'Active' }, { username: 'Paĉjo Jadon', registered: '2012/02/01', role: 'Staff', status: 'Banned' }, { username: 'Micheal Mercurius', registered: '2012/02/01', role: 'Admin', status: 'Inactive' }, { username: 'Ganesha Dubhghall', registered: '2012/03/01', role: 'Member', status: 'Pending' }, { username: 'Hiroto Šimun', registered: '2012/01/21', role: 'Staff', status: 'Active' }, { username: 'Vishnu Serghei', registered: '2012/01/01', role: 'Member', status: 'Active' }, { username: 'Zbyněk Phoibos', registered: '2012/02/01', role: 'Staff', status: 'Banned' }, { username: 'Einar Randall', registered: '2012/02/01', role: 'Admin', status: 'Inactive' }, { username: 'Félix Troels', registered: '2012/03/21', role: 'Staff', status: 'Active' }, { username: 'Aulus Agmundr', registered: '2012/01/01', role: 'Member', status: 'Pending' }]),
      fields: [{ key: 'username' }, { key: 'registered' }, { key: 'role' }, { key: 'status' }],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    };
  },
  methods: {
    getBadge: function getBadge(status) {
      return status === 'Active' ? 'success' : status === 'Inactive' ? 'secondary' : status === 'Pending' ? 'warning' : status === 'Banned' ? 'danger' : 'primary';
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ec_service__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trucking_companies_tc_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a);


var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'energyCompanies',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      truckingcompaniesselect: [],
      model: {
        energy_company_name: '',
        trucking_company_id: [],
        isolera: false,
        address: '',
        phone_number_24: '',
        cnr_inputs: 'false'
      },
      indeterminateTC: false,
      tcAllSelected: false,

      newEC: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Company Name',
        sortable: true
      }, {
        key: 'address',
        label: 'Address',
        sortable: true
      }, {
        key: 'phone_number_24',
        label: '24 Phone Number',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    TCChange: function TCChange() {
      if (this.model.trucking_company_id.length === 0) {
        this.indeterminateTC = false;
        this.tcAllSelected = false;
      } else if (this.model.trucking_company_id.length === this.truckingcompaniesselect.length) {
        this.indeterminateTC = false;
        this.tcAllSelected = true;
      } else {
        this.indeterminateTC = true;
        this.tcAllSelected = false;
      }
    },
    TCToggleAll: function TCToggleAll(checked) {
      this.model.trucking_company_id = checked ? this.truckingcompaniesselect.map(function (item) {
        return item.id;
      }) : [];
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newECModal: function newECModal() {
      this.model = {
        energy_company_name: '',
        trucking_company_id: [],
        address: '',
        phone_number_24: '',
        cnr_inputs: 'false'
      };
      this.savebtn = false;
      this.newEC = true;
    },
    trashEC: function trashEC() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        localStorage.setItem('xyz', row.id);
        this.$router.push('/energy_company/' + row.id + '/');
      } else {
        this.restoreEC(row.id);
      }
    },
    okToSave: function okToSave() {
      if (this.model.energy_company_name === undefined || this.model.energy_company_name.trim().length == 0) {
        this.$swal('Alert!', 'Energy Company Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveEC: function saveEC() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var model = {
        company_name: this.model.energy_company_name,
        trucking_companies: this.model.trucking_company_id.map(function (item) {
          return {
            id: String(item)
          };
        }),
        isolera: this.model.isolera,
        address: this.model.address,
        phone_number_24: this.model.phone_number_24,
        cnr_inputs: this.model.cnr_inputs
      };
      __WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].save(model).then(function (data) {
        _this.$swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this.newEC = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.energy_companies.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });

          _this2.truckingcompaniesselect = data.insert_data.trucking_companies;
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;

          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreEC: function restoreEC(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Energy Company?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.message == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tc_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);










var items = [];
var fields = ['details', 'id', 'name', 'drivers', 'trucks', 'operating_areas', 'actions'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'truckingCompanies',
  created: function created() {
    localStorage.removeItem("ftPage");
    localStorage.removeItem("targetsaPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("userPage");
    if (!localStorage.tcPage) {
      localStorage.tcPage = 0;
    }
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      energycompaniesselect: [],
      model: {
        trucking_company_name: '',
        energy_company_id: [],

        operating_areas_id: [],
        load_locations_id: [],
        unload_locations_id: [],
        multiloads: false,
        address: '',
        dispatch_title: '',
        phone_number1: '',
        phone_number2: '',
        company_logo: '',
        alternate_name: '',
        in_truck_printing: false,
        hazard_id: [],
        control_id: []
      },
      indeterminateEC: false,
      ecAllSelected: false,
      loadingData: true,
      items: items,
      newTC: false,
      configTable: false,
      companyName: '',
      companyId: null,
      fields: fields,
      fieldsTh: [{ key: 'id', label: 'ID', sortable: true }, { key: 'name', label: 'Company Name', sortable: true }],
      currentPage: parseInt(localStorage.tcPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      modalInfo: { title: '', content: '' },
      modalEdit: { title: '' },
      selectedItems: ['id', 'name', 'drivers', 'trucks', 'operating_areas'],
      savebtn: true,

      operatingareasselect: [],
      indeterminateOA: false,
      oaAllSelected: false,
      loadlocationsselect: [],
      indeterminateLL: false,
      llAllSelected: false,
      unloadlocationsselect: [],
      indeterminateUL: false,
      ulAllSelected: false,
      role: '',
      file: '',
      url: '',
      load_logo: 'Saving Logo file.....',
      uploadPercentage: 0,
      progress: false,
      hazards: [],
      controls: [],
      indeterminateHZ: false,
      hzAllSelected: false,
      indeterminateCTL: false,
      ctlAllSelected: false,
      updateData: null,
      file_64: ''
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fieldsTh.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    ECChange: function ECChange() {
      var _this = this;

      if (this.role === 'super_admin') {
        var i;

        var _ret = function () {
          var energy_companies = _this.energycompaniesselect;
          var energy_companies_id = _this.model.energy_company_id;
          _this.loadlocationsselect = [];
          _this.unloadlocationsselect = [];
          _this.operatingareasselect = [];
          var new_loadlocations = [];
          var new_oa = [];
          var new_unloadlocations = [];

          for (i = 0; i < energy_companies_id.length; i += 1) {
            var energy_company_index = energy_companies.map(function (o) {
              return o.id;
            }).indexOf(energy_companies_id[i]);
            if (energy_company_index > -1) {
              var _loadlocations = energy_companies[energy_company_index].loads_locations;
              var operatingarea = energy_companies[energy_company_index].operating_area;
              var _unloadlocations = energy_companies[energy_company_index].unloads_locations;
              _loadlocations.forEach(function (e) {
                if (new_loadlocations.length != 0) {
                  if (new_loadlocations.map(function (o) {
                    return o.id;
                  }).indexOf(e.id) < 0) {
                    new_loadlocations.push(e);
                  }
                } else {
                  new_loadlocations.push(e);
                }
              });
              _unloadlocations.forEach(function (e) {
                if (new_unloadlocations.length != 0) {
                  if (new_unloadlocations.map(function (o) {
                    return o.id;
                  }).indexOf(e.id) < 0) {
                    new_unloadlocations.push(e);
                  }
                } else {
                  new_unloadlocations.push(e);
                }
              });
              operatingarea.forEach(function (e) {
                if (new_oa.length != 0) {
                  if (new_oa.map(function (o) {
                    return o.id;
                  }).indexOf(e.id) < 0) {
                    new_oa.push(e);
                  }
                } else {
                  new_oa.push(e);
                }
              });
            } else {
              new_loadlocations = [];
              new_unloadlocations = [];
              new_oa = [];
            }
          }
          _this.loadlocationsselect = new_loadlocations;

          _this.operatingareasselect = new_oa;
          if (new_unloadlocations.length != 0) {
            _this.unloadlocationsselect = new_unloadlocations.map(function (item) {
              return {
                'value': item.id,
                'text': item.legal_location.charAt(0).toUpperCase() + item.legal_location.slice(1).toLowerCase()
              };
            });
          }

          var operating_area = _this.operatingareasselect;
          var operating_area_id = _this.model.operating_areas_id;
          if (operating_area_id === true) {
            return {
              v: void 0
            };
          }
          var new_oa_id = [];
          operating_area_id.forEach(function (e) {
            if (operating_area.length != 0) {
              if (operating_area.map(function (o) {
                return o.id;
              }).indexOf(e) > -1) {
                new_oa_id.push(e);
              }
            }
          });
          _this.model.operating_areas_id = new_oa_id;

          var loadlocations = _this.loadlocationsselect;
          if (_this.model.load_locations_id == null) {
            _this.model.load_locations_id = [];
          }
          var loadlocations_id = _this.model.load_locations_id;
          var new_ll_id = [];
          loadlocations_id.forEach(function (e) {
            if (loadlocations.length != 0) {
              if (loadlocations.map(function (o) {
                return o.id;
              }).indexOf(e) > -1) {
                new_ll_id.push(e);
              }
            }
          });
          _this.model.load_locations_id = new_ll_id;

          var unloadlocations = _this.unloadlocationsselect;
          if (_this.model.unload_locations_id == null) {
            _this.model.unload_locations_id = [];
          }
          var unloadlocations_id = _this.model.unload_locations_id;
          var new_ul_id = [];
          unloadlocations_id.forEach(function (e) {
            if (unloadlocations.length != 0) {
              if (unloadlocations.map(function (o) {
                return o.id;
              }).indexOf(e) > -1) {
                new_ul_id.push(e);
              }
            }
          });
          _this.model.unload_locations_id = new_ul_id;

          if (_this.model.energy_company_id.length === 0) {
            _this.indeterminateEC = false;
            _this.ecAllSelected = false;
          } else if (_this.model.energy_company_id.length === _this.energycompaniesselect.length) {
            _this.indeterminateEC = false;
            _this.ecAllSelected = true;
          } else {
            _this.indeterminateEC = true;
            _this.ecAllSelected = false;
          }
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    ECToggleAll: function ECToggleAll(checked) {
      this.model.energy_company_id = checked ? this.energycompaniesselect.map(function (item) {
        return item.id;
      }) : [];
    },
    ULChange: function ULChange() {
      if (this.model.unload_locations_id == null) {
        this.model.unload_locations_id = [];
      }
      if (this.model.unload_locations_id.length === 0) {
        this.indeterminateUL = false;
        this.ulAllSelected = false;
      } else if (this.model.unload_locations_id.length === this.unloadlocationsselect.length) {
        this.indeterminateUL = false;
        this.ulAllSelected = true;
      } else {
        this.indeterminateUL = true;
        this.ulAllSelected = false;
      }
    },
    ULToggleAll: function ULToggleAll(checked) {
      this.model.unload_locations_id = checked ? this.unloadlocationsselect.map(function (item) {
        return item.value;
      }) : [];
    },
    LLChange: function LLChange() {
      if (this.model.load_locations_id == null) {
        this.model.load_locations_id = [];
      }
      if (this.model.load_locations_id.length === 0) {
        this.indeterminateLL = false;
        this.llAllSelected = false;
      } else if (this.model.load_locations_id.length === this.loadlocationsselect.length) {
        this.indeterminateLL = false;
        this.llAllSelected = true;
      } else {
        this.indeterminateLL = true;
        this.llAllSelected = false;
      }
    },
    LLToggleAll: function LLToggleAll(checked) {
      this.model.load_locations_id = checked ? this.loadlocationsselect.map(function (item) {
        return item.id;
      }) : [];
    },
    OAChange: function OAChange() {
      var operating_area = this.operatingareasselect;
      var operating_area_id = this.model.operating_areas_id;
      var load_locations = this.loadlocationsselect;
      var load_locations_id = this.model.load_locations_id;
      if (operating_area_id === true) {
        return;
      }
      var ll = operating_area_id.map(function (item) {
        var oa_index = operating_area.map(function (o) {
          return o.id;
        }).indexOf(item);
        if (oa_index > -1) {
          return operating_area[oa_index].load_locations.map(function (o) {
            return o.id;
          });
        }
      });
      var ll1 = [];
      ll.flat().forEach(function (element) {
        var ll_index = load_locations.map(function (o) {
          return o.id;
        }).indexOf(element);
        if (ll_index >= 0) {
          ll1.push(element);
        }
      });

      var ll2 = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(ll1)));
      this.model.load_locations_id = Array.prototype.concat.apply([], ll2);

      var ul = operating_area_id.map(function (item) {
        var oa_index = operating_area.map(function (o) {
          return o.id;
        }).indexOf(item);
        if (oa_index > -1) {
          return operating_area[oa_index].unload_locations.map(function (o) {
            return o.id;
          });
        }
      });
      this.model.unload_locations_id = Array.prototype.concat.apply([], ul);

      if (this.model.operating_areas_id == null) {
        this.model.operating_areas_id = [];
      }
      if (this.model.operating_areas_id.length === 0) {
        this.indeterminateOA = false;
        this.oaAllSelected = false;
      } else if (this.model.operating_areas_id.length === this.operatingareasselect.length) {
        this.indeterminateOA = false;
        this.oaAllSelected = true;
      } else {
        this.indeterminateOA = true;
        this.oaAllSelected = false;
      }
    },
    OAToggleAll: function OAToggleAll(checked) {
      this.model.operating_areas_id = checked ? this.operatingareasselect.map(function (item) {
        return item.id;
      }) : [];
    },
    newTCModal: function newTCModal() {

      this.savebtn = false;
      this.newTC = true;
      if (this.role === 'super_admin') {
        this.model = {
          trucking_company_name: '',
          energy_company_id: [],
          operating_areas_id: [],
          load_locations_id: [],
          unload_locations_id: [],
          multiloads: false,
          address: '',
          dispatch_title: '',
          phone_number1: '',
          phone_number2: '',
          company_logo: '',
          alternate_name: '',
          in_truck_printing: false,
          hazard_id: [],
          control_id: []
        };
        this.file = '';
        this.url = '';
        this.loadlocationsselect = [];
        this.progress = false;
        this.indeterminateHZ = false;
        this.hzAllSelected = false;
        this.indeterminateCTL = false;
        this.ctlAllSelected = false;
      } else if (this.role === 'operations_manager') {
        this.model.trucking_company_name = '';
        this.model.operating_areas_id = [];
        this.model.load_locations_id = [];
        this.model.unload_locations_id = [];
        this.model.multiloads = false;
      }
    },
    trashTC: function trashTC() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      localStorage.tcPage = this.currentPage;
      if (!this.trash) {
        localStorage.setItem('xyz', row.id);
        this.$router.push('/trucking_company/' + row.id + '/');
      } else {
        this.restoreTC(row.id);
      }
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.tcPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].getAll().then(function (data) {
        if (data[0] == 'success') {
          _this2.items = data[1].filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
          _this2.energycompaniesselect = [];
          _this2.hazards = [];
          _this2.controls = [];
          _this2.role = data[3];

          _this2.get_attributtes();
        } else {
          _this2.items = [];
          _this2.$swal(data[0], data[1], data[0]);
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        _this2.$swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    okToSave: function okToSave() {
      if (this.model.trucking_company_name === undefined || this.model.trucking_company_name.trim().length == 0) {
        this.$swal('Alert!', 'Trucking Company Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveTC: function saveTC() {
      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      this.saveLogo();
      this.savebtn = false;
    },
    restoreTC: function restoreTC(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Trucking Company?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data[0], data[1], data[0]);
            if (data[0] == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.model.company_logo = this.file['name'];
      var url = window.URL.createObjectURL(this.file);
      this.url = url;
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);

      var reader = new FileReader();

      reader.readAsDataURL(this.file);

      reader.onload = function () {
        localStorage.setItem('file_64', reader.result);
        return;
      };
    },
    saveLogo: function saveLogo() {
      var file_64 = '';
      if ('file_64' in localStorage) {
        file_64 = localStorage.getItem('file_64');
      }
      var model = {
        name: this.model.trucking_company_name,
        energy_companies: this.model.energy_company_id.map(function (item) {
          return {
            id: String(item)
          };
        }),
        operating_areas: this.model.operating_areas_id.map(function (item) {
          return {
            id: String(item)
          };
        }),
        load_locations: this.model.load_locations_id.map(function (item) {
          return {
            id: String(item)
          };
        }),
        unload_locations: this.model.unload_locations_id.map(function (item) {
          return {
            id: String(item)
          };
        }),
        multiloads: this.model.multiloads,
        address: this.model.address,
        dispatch_title: this.model.dispatch_title,
        phone_number1: this.model.phone_number1,
        phone_number2: this.model.phone_number2,
        alternate_name: this.model.alternate_name,
        company_logo: this.model.company_logo,
        in_truck_printing: this.model.in_truck_printing,
        hazard_id: this.model.hazard_id,
        control_id: this.model.control_id,
        file_64: file_64

      };
      var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model);
      var blob = new Blob([json], {
        type: 'application/json'
      });
      var formData = new FormData();
      formData.append("document", blob);
      formData.append('file', '');
      this.uploadPercentage = 0;
      if (this.file != '') {
        this.progress = true;
      }
      this.load_logo = 'Saving Logo file.....';

      this.save_logo(formData);
    },
    save_logo: function save_logo(formData) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* apiDomain */] + '/trucking_company/create/', formData, { headers: {
          'Content-Type': 'multipart/form-data',
          'token': localStorage.getItem('access_token')
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          _this4.uploadPercentage = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == 'success') {
          _this4.load_logo = 'Logo file saved';
          localStorage.removeItem('file_64');
          _this4.$swal(data.status, data.message, data.status);
          _this4.newTC = false;
          _this4.getAll();
        } else {
          _this4.load_logo = 'Saving Logo file.....', _this4.uploadPercentage = 0, _this4.progress = false;
          _this4.model.company_logo = '';
          _this4.url = '';
          _this4.file = '';
          _this4.$swal(data.status, data.message, data.status);
        }
      }).catch(function (error) {
        _this4.load_logo = 'Saving Logo file.....', _this4.uploadPercentage = 0, _this4.progress = false;
        _this4.$swal('Error', 'Server not response. ' + error, 'error');
      });
    },
    HZChange: function HZChange() {
      if (this.model.hazard_id.length === 0) {
        this.indeterminateHZ = false;
        this.hzAllSelected = false;
      } else if (this.model.hazard_id.length === this.hazards.length) {
        this.indeterminateHZ = false;
        this.hzAllSelected = true;
      } else {
        this.indeterminateHZ = true;
        this.hzAllSelected = false;
      }
    },
    HZToggleAll: function HZToggleAll(checked) {
      this.model.hazard_id = checked ? this.hazards.map(function (item) {
        return item.id;
      }) : [];
    },
    CTLChange: function CTLChange() {
      if (this.model.control_id.length === 0) {
        this.indeterminateCTL = false;
        this.ctlAllSelected = false;
      } else if (this.model.control_id.length === this.controls.length) {
        this.indeterminateCTL = false;
        this.ctlAllSelected = true;
      } else {
        this.indeterminateCTL = true;
        this.ctlAllSelected = false;
      }
    },
    CTLToggleAll: function CTLToggleAll(checked) {
      this.model.control_id = checked ? this.controls.map(function (item) {
        return item.id;
      }) : [];
    },
    get_attributtes: function get_attributtes() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].get_att().then(function (data) {
        if (data.status === 'success') {
          _this5.updateData = data.update_data;
          _this5.hazards = _this5.updateData.hazards;
          _this5.controls = _this5.updateData.controls;
          _this5.energycompaniesselect = _this5.updateData.energy_companies;

          if (_this5.role === 'operations_manager') {
            _this5.operatingareasselect = _this5.energycompaniesselect[0].operating_area;
            var new_unloadlocations = _this5.energycompaniesselect[0].unloads_locations;
            _this5.unloadlocationsselect = [];
            if (new_unloadlocations.length != 0) {
              _this5.unloadlocationsselect = new_unloadlocations.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.legal_location.charAt(0).toUpperCase() + item.legal_location.slice(1).toLowerCase()
                };
              });
            }
            _this5.loadlocationsselect = _this5.energycompaniesselect[0].loads_locations;
            if (_this5.energycompaniesselect != 0) {
              _this5.model.energy_company_id = _this5.energycompaniesselect.map(function (item) {
                return item.id;
              });
            }
          }
        } else {
          _this5.$swal(data.status, data.message, data.status);
          _this5.loadingData = false;
          return;
        }
      }).catch(function (error) {
        _this5.$swal('Error', 'Server not response. ' + error, 'error');
        _this5.loadingData = false;
      });
    }
  }
});

/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tc_service__ = __webpack_require__(40);







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'truckingCompany',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			energycompaniesselect: [],
			model: {
				trucking_company_name: '',
				energy_company_id: [],
				operating_areas_id: [],
				load_locations_id: [],
				unload_locations_id: [],

				energy_companies: [],
				operating_areas: [],
				load_locations: [],
				unload_locations: [],
				multiloads: false,
				address: '',
				dispatch_title: '',
				phone_number1: '',
				phone_number2: '',
				company_logo: '',
				alternate_name: '',
				in_truck_printing: false,
				hazard_id: [],
				control_id: [],
				hazard: [],
				control: []
			},
			indeterminateEC: false,
			ecAllSelected: false,
			updateData: null,
			originalData: null,
			loadingData: true,

			operatingareasselect: [],
			indeterminateOA: false,
			oaAllSelected: false,
			operating_areas: [],

			loadlocationsselect: [],
			unloadlocationsselect: [],
			load_locations: [],
			unload_locations: [],
			indeterminateLL: false,
			llAllSelected: false,
			indeterminateUL: false,
			ulAllSelected: false,
			role: '',
			file: '',
			url: '',
			hazard: [],
			control: [],
			hazards: [],
			controls: [],
			indeterminateHZ: false,
			hzAllSelected: false,
			indeterminateCTL: false,
			ctlAllSelected: false
		};
	},

	methods: {
		allCheckedEC: function allCheckedEC() {},
		editTC: function editTC() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		ECChange: function ECChange() {
			var _this = this;

			if (this.role === 'super_admin') {
				var i;

				(function () {
					var energy_companies = _this.energycompaniesselect;
					var energy_companies_id = _this.model.energy_company_id;
					_this.loadlocationsselect = [];
					_this.operatingareasselect = [];
					var new_loadlocations = [];
					var new_oa = [];

					var new_unloadlocations = [];
					_this.unloadlocationsselect = [];
					for (i = 0; i < energy_companies_id.length; i += 1) {
						var energy_company_index = energy_companies.map(function (o) {
							return o.id;
						}).indexOf(energy_companies_id[i]);
						if (energy_company_index > -1) {
							var loadlocations = energy_companies[energy_company_index].loads_locations;
							var operatingarea = energy_companies[energy_company_index].operating_area;
							loadlocations.forEach(function (e) {
								if (new_loadlocations.length != 0) {
									if (new_loadlocations.map(function (o) {
										return o.id;
									}).indexOf(e.id) < 0) {
										new_loadlocations.push(e);
									}
								} else {
									new_loadlocations.push(e);
								}
							});
							operatingarea.forEach(function (e) {
								if (new_oa.length != 0) {
									if (new_oa.map(function (o) {
										return o.id;
									}).indexOf(e.id) < 0) {
										new_oa.push(e);
										new_unloadlocations = new_unloadlocations.concat(e.unload_locations);
									}
								} else {
									new_oa.push(e);
									new_unloadlocations = new_unloadlocations.concat(e.unload_locations);
								}
							});
						} else {
							new_loadlocations = [];
							new_unloadlocations = [];
							new_oa = [];
						}
					}
					_this.loadlocationsselect = new_loadlocations;
					_this.operatingareasselect = new_oa;
					_this.unloadlocationsselect = _this.arrayUnique(new_unloadlocations);

					if (_this.model.energy_company_id.length === 0) {
						_this.indeterminateEC = false;
						_this.ecAllSelected = false;
					} else if (_this.model.energy_company_id.length === _this.energycompaniesselect.length) {
						_this.indeterminateEC = false;
						_this.ecAllSelected = true;
					} else {
						_this.indeterminateEC = true;
						_this.ecAllSelected = false;
					}
				})();
			}
		},
		ECToggleAll: function ECToggleAll(checked) {
			this.model.energy_company_id = checked ? this.energycompaniesselect.map(function (item) {
				return item.id;
			}) : [];
		},
		OAChange: function OAChange() {
			var operating_area = this.operatingareasselect;
			var operating_area_id = this.model.operating_areas_id;
			if (operating_area_id === true) {
				return;
			}
			var ll = operating_area_id.map(function (item) {
				var oa_index = operating_area.map(function (o) {
					return o.id;
				}).indexOf(item);
				if (oa_index > -1) {
					return operating_area[oa_index].load_locations.map(function (o) {
						return o.id;
					});
				}
			});

			var ul = operating_area_id.map(function (item) {
				var oa_index = operating_area.map(function (o) {
					return o.id;
				}).indexOf(item);
				if (oa_index > -1) {
					return operating_area[oa_index].unload_locations.map(function (o) {
						return o.id;
					});
				}
			});

			var ul_l = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(Array.prototype.concat.apply([], ul))));
			var ll_l = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(Array.prototype.concat.apply([], ll))));

			this.model.load_locations_id = ll_l;
			this.model.unload_locations_id = ul_l;

			if (this.model.operating_areas_id === null) {
				return;
			}
			if (this.model.operating_areas_id.length === 0) {
				this.indeterminateOA = false;
				this.oaAllSelected = false;
			} else if (this.model.operating_areas_id.length === this.operatingareasselect.length) {
				this.indeterminateOA = false;
				this.oaAllSelected = true;
			} else {
				this.indeterminateOA = true;
				this.oaAllSelected = false;
			}
		},
		LLChange: function LLChange() {
			if (this.model.load_locations_id === null) {
				this.model.load_locations_id = [];
				return;
			}
			if (this.model.load_locations_id.length === 0) {
				this.indeterminateLL = false;
				this.llAllSelected = false;
			} else if (this.model.load_locations_id.length === this.loadlocationsselect.length) {
				this.indeterminateLL = false;
				this.llAllSelected = true;
			} else {
				this.indeterminateLL = true;
				this.llAllSelected = false;
			}
		},
		ULChange: function ULChange() {

			if (this.model.unload_locations_id === null) {
				return;
			}
			if (this.model.unload_locations_id.length === 0) {
				this.indeterminateUL = false;
				this.ulAllSelected = false;
			} else if (this.model.unload_locations_id.length === this.unloadlocationsselect.length) {
				this.indeterminateUL = false;
				this.ulAllSelected = true;
			} else {
				this.indeterminateUL = true;
				this.ulAllSelected = false;
			}
		},
		OAToggleAll: function OAToggleAll(checked) {
			this.model.operating_areas_id = checked ? this.operatingareasselect.map(function (item) {
				return item.id;
			}) : [];
		},
		LLToggleAll: function LLToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationsselect.map(function (item) {
				return item.id;
			}) : [];
		},
		ULToggleAll: function ULToggleAll(checked) {
			this.model.unload_locations_id = checked ? this.unloadlocationsselect.map(function (item) {
				return item.id;
			}) : [];
		},
		allCheckedOA: function allCheckedOA() {},
		allCheckedLL: function allCheckedLL() {},
		allCheckedUL: function allCheckedUL() {},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData, {
				trucking_company_name: this.originalData.name,
				energy_company_id: [],

				load_locations_id: []
			});
			this.model = model;
		},
		setupFields: function setupFields() {

			if (this.model.energy_companies.length > 0) {
				this.model.energy_company_id = this.model.energy_companies.map(function (item) {
					return item.id;
				});
			}

			if (this.model.load_locations.length > 0) {
				this.model.load_locations_id = this.model.load_locations.map(function (item) {
					return item.id;
				});
			}
			if (this.model.unload_locations.length > 0) {
				this.model.unload_locations_id = this.model.unload_locations.map(function (item) {
					return item.id;
				});
			}
			if (this.model.operating_areas.length > 0) {
				this.model.operating_areas_id = this.model.operating_areas.map(function (item) {
					return item.id;
				});
			}

			if (this.model.hazard.length > 0) {
				this.model.hazard_id = this.model.hazard.map(function (item) {
					return item.hazard_id;
				});
			}

			if (this.model.control.length > 0) {
				this.model.control_id = this.model.control.map(function (item) {
					return item.control_id;
				});
			}
		},
		getCompanyData: function getCompanyData() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this2.originalData = data.trucking_company;
					_this2.updateData = [];
					_this2.role = data.role;
					_this2.companyId = _this2.id;
					_this2.loadingData = false;
					_this2.found = true;

					_this2.operating_areas = _this2.originalData.operating_areas;
					_this2.load_locations = _this2.originalData.load_locations;
					_this2.unload_locations = _this2.originalData.unload_locations;

					_this2.restoreOriginalData();
					_this2.subTitle = _this2.originalData.name;
					_this2.energycompaniesselect = [];

					_this2.operatingareasselect = [];
					_this2.loadlocationsselect = [];
					_this2.unloadlocationsselect = [];
					_this2.hazards = [];
					_this2.controls = [];
					_this2.get_attributtes();
				} else {
					_this2.$swal(data.status, data.message, data.status);
					_this2.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.trucking_company_name === undefined || this.model.trucking_company_name.trim().length == 0) {
				this.$swal('Alert!', 'Trucking Company Name can not be empty', 'warning');
				return false;
			} else if (this.id != localStorage.getItem('xyz')) {
				this.$swal('Alert!', 'Denegated Access', 'warning');
				this.$router.push('/trucking_companies');
				return false;
			}
			var m_load_locations_id = this.model.load_locations_id;
			var new_ll = [];
			m_load_locations_id.forEach(function (e) {
				if (e !== undefined) {
					new_ll.push(e);
				}
			});
			this.model.load_locations_id = new_ll;

			var m_unload_locations_id = this.model.unload_locations_id;
			var new_ul = [];
			m_unload_locations_id.forEach(function (e) {
				if (e !== undefined) {
					new_ul.push(e);
				}
			});
			this.model.unload_locations_id = new_ul;
			return true;
		},
		updateTC: function updateTC() {
			var _this3 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var file_64 = '';
			if ('file_64' in localStorage) {
				file_64 = localStorage.getItem('file_64');
			}
			var model = {
				name: this.model.trucking_company_name,
				energy_companies: this.model.energy_company_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				operating_areas: this.model.operating_areas_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				load_locations: this.model.load_locations_id.map(function (item) {
					return String(item);
				}),
				unload_locations: this.model.unload_locations_id.map(function (item) {
					return String(item);
				}),
				load_locations_in: this.load_locations.map(function (item) {
					return String(item.id);
				}),
				unload_locations_in: this.unload_locations.map(function (item) {
					return String(item.id);
				}),
				multiloads: this.model.multiloads,
				address: this.model.address,
				dispatch_title: this.model.dispatch_title,
				phone_number1: this.model.phone_number1,
				phone_number2: this.model.phone_number2,
				alternate_name: this.model.alternate_name,
				company_logo: this.model.company_logo,
				in_truck_printing: this.model.in_truck_printing,
				hazard_id: this.model.hazard_id,
				control_id: this.model.control_id,
				file_64: file_64
			};
			var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model);
			var blob = new Blob([json], {
				type: 'application/json'
			});
			var formData = new FormData();
			formData.append("document", blob);
			formData.append('file', '');
			__WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].update(this.companyId, formData).then(function (data) {
				_this3.$swal(data[0], data[1], data[0]).then(function (result) {
					localStorage.removeItem('file_64');
					_this3.getCompanyData();
				});
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
			});

			this.edit = false;
		},
		deleteTC: function deleteTC(item) {
			var _this4 = this;

			this.$swal({
				title: 'Please Confirm!',
				text: "Are you sure to delete this Trucking Company: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].delete(_this4.companyId).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this4.$router.replace('/trucking_companies');
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		arrayUnique: function arrayUnique(array) {
			var a = array.concat();
			for (var i = 0; i < a.length; ++i) {
				for (var j = i + 1; j < a.length; ++j) {
					if (a[i].id === a[j].id) a.splice(j--, 1);
				}
			}
			return a;
		},
		handleFileUpload: function handleFileUpload() {
			this.file = this.$refs.file.files[0];
			this.model.company_logo = this.file['name'];
			var url = window.URL.createObjectURL(this.file);
			this.url = url;
			setTimeout(function () {
				return window.URL.revokeObjectURL(url);
			}, 100);
			var reader = new FileReader();

			reader.readAsDataURL(this.file);

			reader.onload = function () {
				localStorage.setItem('file_64', reader.result);
				return;
			};
		},
		HZChange: function HZChange() {
			if (this.model.hazard_id.length === 0) {
				this.indeterminateHZ = false;
				this.hzAllSelected = false;
			} else if (this.model.hazard_id.length === this.hazards.length) {
				this.indeterminateHZ = false;
				this.hzAllSelected = true;
			} else {
				this.indeterminateHZ = true;
				this.hzAllSelected = false;
			}
		},
		HZToggleAll: function HZToggleAll(checked) {
			this.model.hazard_id = checked ? this.hazards.map(function (item) {
				return item.id;
			}) : [];
		},
		CTLChange: function CTLChange() {
			if (this.model.control_id.length === 0) {
				this.indeterminateCTL = false;
				this.ctlAllSelected = false;
			} else if (this.model.control_id.length === this.controls.length) {
				this.indeterminateCTL = false;
				this.ctlAllSelected = true;
			} else {
				this.indeterminateCTL = true;
				this.ctlAllSelected = false;
			}
		},
		CTLToggleAll: function CTLToggleAll(checked) {
			this.model.control_id = checked ? this.controls.map(function (item) {
				return item.id;
			}) : [];
		},
		get_attributtes: function get_attributtes() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_4__tc_service__["a" /* default */].get_attr(this.id).then(function (data) {
				if (data.status === 'success') {
					_this5.updateData = data.update_data;
					_this5.hazards = _this5.updateData.hazards;
					_this5.controls = _this5.updateData.controls;
					_this5.energycompaniesselect = _this5.updateData.energy_companies;
					_this5.operatingareasselect = _this5.updateData.operating_areas_all;
					_this5.loadlocationsselect = _this5.updateData.load_locations_all;
					_this5.unloadlocationsselect = _this5.updateData.unload_locations_all;
				} else {
					_this5.$swal(data.status, data.message, data.status);
					_this5.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this5.$swal('Error', 'Server not response. ' + error, 'error');
				_this5.loadingData = false;
			});
		}
	}
});

/***/ }),
/* 393 */,
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reports_service__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reports',
  created: function created() {
    this.getFilters();
    localStorage.removeItem("haulsaPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("ftPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("userPage");
    if (!localStorage.reportPage) {
      localStorage.reportPage = 0;
    }
  },
  data: function data() {
    var _this = this;

    return {
      filename: 'report_' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "avg_load_size": "avg_load_size",
        "avg_m3_day": "avg_m3_day",
        "charge_type": "charge_type",
        "charge_type_id": "charge_type_id",
        "company_name": "company_name",
        "cost_type": "cost_type",
        "cost_type_id": "cost_type_id",
        "energy_company_id": "energy_company_id",
        "est_bbl_haul_cost": "est_bbl_haul_cost",
        "fluid_hauled_km": "fluid_hauled_km",
        "loads": "loads",
        "rate": "rate",
        "report_id": "report_id",
        "short_long_target": "short_long_target",
        "speed": "speed",
        "target_end_date": "target_end_date",
        "target_start_date": "target_start_date",
        "target_volume": "target_volume",
        "term_fee_m": "term_fee_m",
        "total_cost": "total_cost",
        "total_driving_time": "total_driving_time",
        "total_regular": "total_regular",
        "total_stb": "total_stb",
        "total_stb_time": "total_stb_time",
        "truck_type": "truck_type",
        "truck_type_id": "truck_type_id",
        "two_ways_est_hrs": "two_ways_est_hrs",
        "unload_latitude": "unload_latitude",
        "unload_location_id": "unload_location_id",
        "unload_locations": "unload_locations",
        "unload_longitude": "unload_longitude",
        "volume_actual": "volume_actual"
      },
      json_data: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      insert_data: null,
      energy_companies_filter: '',
      trucking_companies_filter: '',
      unload_locations_filter: '',
      truck_types_filter: '',
      drivers_filter: '',
      trucks_filter: '',
      row: 0,
      loadingData: true,
      trash: false,
      dpdt: "Active",
      ec_filter: "All Energy Companies",
      tt_filter: "All Truck Types",
      tc_filter: "All Trucking Companies",
      t_filter: "All Trucks",
      v_filter: "All",
      u_filter: "All Unloads",
      filter_by: {
        "energy_company_id": "",
        "unload_location_id": "",
        "truck_type_id": "",
        "truck_id": "",
        "initial_date": "",
        "end_date": ""
      },
      companyName: '',
      companyId: null,
      newEC: false,
      configTable: false,
      items: items,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 10,
      tempFields: [],
      fields: [{
        key: 'target_start_date',
        label: 'Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
        }
      }, {
        key: 'unload_locations',
        label: 'Unload',
        sortable: true
      }, {
        key: 'truck_type',
        label: 'Truck Type',
        sortable: true
      }, {
        key: 'volume_actual',
        label: 'Deliveries',
        sortable: true,
        formatter: function formatter(value) {
          return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + _this.unit;
        }
      }, {
        key: 'target_volume',
        label: 'Target',
        sortable: true,
        formatter: function formatter(value) {
          return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + _this.unit;
        }
      }, {
        key: 'loads',
        label: '# Loads',
        sortable: true
      }, {
        key: 'total_cost',
        label: 'Total Cost',
        sortable: true,
        formatter: function formatter(value) {
          return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      }],
      currentPage: parseInt(localStorage.reportPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['target_start_date', 'unload_locations', 'truck_type', 'volume_actual', 'target_volume', 'loads', 'total_cost'],
      rol: '',
      view: true,
      unit: '',
      filters_save: {
        energy_company_id: 0,
        energy_company_name: 'All Energy Companies',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Comanies',
        truck_type_id: 0,
        truck_type_name: 'All Truck Types',
        unload_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        sortby: null,
        sortdesc: false
      },
      filters_start: {
        energy_company_id: 0,
        trucking_company_id: 0,
        truck_id: 0,
        load_id: 0,
        unload_id: 0,
        initial_date: '',
        end_date: '',
        sortby: '',
        sortdesc: false
      }
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    rowClicked: function rowClicked(row) {
      localStorage.reportPage = this.currentPage;
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      var _this2 = this;

      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      __WEBPACK_IMPORTED_MODULE_3__reports_service__["a" /* default */].saveSelectedColumns(this.fields).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            setTimeout(function () {
              _this2.configTable = false;
            }, 500);
          }
        });
      });
    },
    bbl: function bbl() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__users_users_service__["a" /* default */].bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this3.loadingData = true;
            _this3.getAll();
          }
        });
      });
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this4 = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'target_start_date' || option == 'target_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'total_cost' || option == 'total_stb' || option == 'total_regular' || option == 'term_fee_m' || option == 'rate') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              }
            };
          } else if (option == 'volume_actual' || option == 'avg_load_size' || option == 'target_volume' || option == 'short_long_target' || option == 'avg_m3_day') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + _this4.unit;
              }
            };
          } else if (option == 'fluid_hauled_km') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' km';
              }
            };
          } else if (option == 'speed') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' km/h';
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.reportPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearFilters: function clearFilters() {
      this.ec_filter = "All Energy Companies";
      this.tt_filter = "All Truck Types";
      this.tc_filter = "All Trucking Companies";
      this.t_filter = "All Trucks";
      this.v_filter = "All";
      this.u_filter = "All Unloads";
      this.sortBy = null;
      this.sortDesc = false;
      this.filter_by = {
        "energy_company_id": "",
        "unload_location_id": "",
        "truck_type_id": "",
        "truck_id": "",
        "trucking_company_id": "",
        "initial_date": "",
        "end_date": ""
      }, this.filters_save = {
        energy_company_id: 0,
        energy_company_name: 'All Energy Companies',
        trucking_company_id: 0,
        truncin_company_name: 'All Trucking Companies',
        truck_id: 0,
        truck_name: 'All Trucks',
        truck_type_id: 0,
        truck_type_name: 'All Truck Types',
        unload_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        sortby: null,
        sortdesc: false
      };

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.ec_filter = ec_filter;
      this.filter_by['energy_company_id'] = id == 0 ? '' : id;

      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_company_id = id;

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.tc_filter = tc_filter;
      this.filter_by['trucking_company_id'] = id == 0 ? '' : id;

      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.t_filter = t_filter;
      this.filter_by['truck_id'] = id == 0 ? '' : id;

      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    ttFilter: function ttFilter(tt_filter, id) {
      this.tt_filter = tt_filter;
      this.filter_by['truck_type_id'] = id == 0 ? '' : id;

      this.filters_save.truck_type_name = tt_filter;
      this.filters_save.truck_type_id = id;
      this.saveFilters();

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.u_filter = u_filter;
      this.filter_by['unload_location_id'] = id == 0 ? '' : id;

      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_id = id;

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    iFilter: function iFilter() {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }

      this.filters_save.initial_date = this.filter_by.initial_date;

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    eFilter: function eFilter() {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }

      this.filters_save.end_date = this.filter_by.end_date;

      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    getAll: function getAll() {
      var _this5 = this;

      this.items = [];
      this.v_items = [];
      __WEBPACK_IMPORTED_MODULE_3__reports_service__["a" /* default */].getAll(this.filter_by).then(function (data) {
        if (data.status == 'success') {

          _this5.energy_companies_filter = data.energy_companies_filter;
          _this5.unload_locations_filter = data.unloads_locations_filter;
          _this5.trucking_companies_filter = data.trucking_companies_filter;
          _this5.trucks_filter = data.trucks_filter;
          _this5.truck_types_filter = data.truck_types_filter;
          _this5.rol = data.rol;
          if (_this5.rol == 'super_admin') {
            _this5.view = true;
          } else {
            _this5.view = false;
          }
          _this5.items = data.haul_report;

          for (var i = 0; i < _this5.items.length; i++) {
            var total_cost = _this5.items[i].total_cost;
            var total_stb = _this5.items[i].total_stb;
            var total_regular = _this5.items[i].total_regular;
            var term_fee_m = _this5.items[i].term_fee_m;
            var rate = _this5.items[i].rate;
            var est_bbl_haul_cost = _this5.items[i].est_bbl_haul_cost;

            var volume_actual = _this5.items[i].volume_actual;
            if (_this5.items[i].volume_actual.indexOf('bbl') != -1) {
              _this5.unit = ' bbl';
            } else {
              _this5.unit = ' m³';
            }
            var avg_load_size = _this5.items[i].avg_load_size;
            var target_volume = _this5.items[i].target_volume;
            var short_long_target = _this5.items[i].short_long_target;
            var avg_m3_day = _this5.items[i].avg_m3_day;

            var fluid_hauled_km = _this5.items[i].fluid_hauled_km;
            var speed = _this5.items[i].speed;

            _this5.items[i].total_cost = parseFloat(total_cost.replace("$", ""));
            _this5.items[i].total_stb = parseFloat(total_stb.replace("$", ""));
            _this5.items[i].total_regular = parseFloat(total_regular.replace("$", ""));
            _this5.items[i].term_fee_m = parseFloat(term_fee_m.replace("$", ""));
            _this5.items[i].rate = parseFloat(rate.replace("$", ""));

            _this5.items[i].volume_actual = parseFloat(volume_actual.replace(_this5.unit, ""));
            _this5.items[i].avg_load_size = parseFloat(avg_load_size.replace(_this5.unit, ""));
            _this5.items[i].target_volume = parseFloat(target_volume.replace(_this5.unit, ""));
            _this5.items[i].short_long_target = parseFloat(short_long_target.replace(_this5.unit, ""));
            _this5.items[i].avg_m3_day = parseFloat(avg_m3_day.replace(_this5.unit, ""));

            _this5.items[i].fluid_hauled_km = parseFloat(fluid_hauled_km.replace(' km', ""));
            _this5.items[i].speed = parseFloat(speed.replace(' km/h', ""));
          }
          if (data.select_columns != '') {
            _this5.fields = [];
            _this5.fields = data.select_columns;
          }
          if (_this5.fields.length > 0) {
            _this5.selectedItems = [];
            for (var _i = 0; _i < _this5.fields.length; _i++) {
              var key = _this5.fields[_i].key;
              _this5.selectedItems.push(key);
              if (key == 'target_start_date' || key == 'target_end_date') {
                _this5.fields[_i].formatter = function (value) {
                  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
                };
              }
              if (key == 'total_cost' || key == 'total_stb' || key == 'total_regular' || key == 'term_fee_m' || key == 'rate') {
                _this5.fields[_i].formatter = function (value) {
                  return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                };
              }
              if (key == 'volume_actual' || key == 'avg_load_size' || key == 'target_volume' || key == 'short_long_target' || key == 'avg_m3_day') {
                _this5.fields[_i].formatter = function (value) {
                  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + _this5.unit;
                };
              }
              if (key == 'fluid_hauled_km') {
                _this5.fields[_i].formatter = function (value) {
                  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' km';
                };
              }
              if (key == 'speed') {
                _this5.fields[_i].formatter = function (value) {
                  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' km/h';
                };
              }
            }
          }
          _this5.loadingData = false;
        } else {
          _this5.$swal(data.status, data.message, data.status);
          _this5.loadingData = false;
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this5.loadingData = false;
      });
    },
    saveFilters: function saveFilters() {
      console.log(this.filters_save);
      __WEBPACK_IMPORTED_MODULE_3__reports_service__["a" /* default */].saveFilters(this.filters_save).then(function (data) {
        if (data[0] == 'success') {
          return;
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]);
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        return;
      });
    },
    getFilters: function getFilters() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3__reports_service__["a" /* default */].getFilters().then(function (data) {
        if (data[0] == 'success') {
          _this6.filters_start = data[1];
          if (_this6.filters_start.length != 0) {
            if (_this6.filters_start[0].energy_company_id != 0) {
              _this6.filter_by.energy_company_id = _this6.filters_start[0].energy_company_id;
            } else {
              _this6.filter_by.energy_company_id = '';
            }
            if (_this6.filters_start[0].trucking_company_id != 0) {
              _this6.filter_by.trucking_company_id = _this6.filters_start[0].trucking_company_id;
            } else {
              _this6.filter_by.trucking_company_id = '';
            }
            if (_this6.filters_start[0].truck_id != 0) {
              _this6.filter_by.truck_id = _this6.filters_start[0].truck_id;
            } else {
              _this6.filter_by.truck_id = '';
            }
            if (_this6.filters_start[0].driver_id != 0) {
              _this6.filter_by.users_id = _this6.filters_start[0].driver_id;
            } else {
              _this6.filter_by.users_id = '';
            }
            if (_this6.filters_start[0].load_id != 0) {
              _this6.filter_by.load_location_id = _this6.filters_start[0].load_id;
            } else {
              _this6.filter_by.load_location_id = '';
            }
            if (_this6.filters_start[0].unload_id != 0) {
              _this6.filter_by.unload_location_id = _this6.filters_start[0].unload_id;
            } else {
              _this6.filter_by.unload_location_id = '';
            }
            if (_this6.filters_start[0].initial_date != null) {
              _this6.filter_by.initial_date = _this6.filters_start[0].initial_date;
            } else {
              _this6.filter_by.initial_date = '';
            }
            if (_this6.filters_start[0].end_date != null) {
              _this6.filter_by.end_date = _this6.filters_start[0].end_date;
            } else {
              _this6.filter_by.end_date = '';
            }
            if (_this6.filters_start[0].sortby != null) {
              _this6.filters_save.sortby = _this6.filters_start[0].sortby;
              _this6.sortBy = _this6.filters_start[0].sortby;
            } else {
              _this6.filters_save.sortby = null;
              _this6.sortBy = null;
            }
            if (_this6.filters_start[0].sortdesc != null) {
              _this6.filters_save.sortdesc = _this6.filters_start[0].sortdesc;
              _this6.sortDesc = _this6.filters_start[0].sortdesc;
            } else {
              _this6.filters_save.sortdesc = false;
              _this6.sortDesc = false;
            }

            _this6.filters_save.energy_company_name = _this6.filters_start[0].energycompany_name;
            _this6.filters_save.energy_company_id = _this6.filters_start[0].energy_company_id;

            _this6.filters_save.trucking_company_name = _this6.filters_start[0].trucking_company_name;
            _this6.filters_save.trucking_company_id = _this6.filters_start[0].trucking_company_id;

            _this6.filters_save.truck_id = _this6.filters_start[0].truck_id;
            _this6.filters_save.truck_name = _this6.filters_start[0].truck_name;

            _this6.filters_save.truck_type_id = _this6.filters_start[0].truck_type_id;
            _this6.filters_save.truck_type_name = _this6.filters_start[0].truck_type_name;

            _this6.filters_save.unload_id = _this6.filters_start[0].unload_id;
            _this6.filters_save.unload_name = _this6.filters_start[0].unload_name;

            _this6.filters_save.initial_date = _this6.filters_start[0].initial_date;
            _this6.filters_save.end_date = _this6.filters_start[0].end_date;

            if (_this6.filters_save.energy_company_name != null) {
              _this6.ec_filter = _this6.filters_save.energy_company_name;
            } else {
              _this6.ec_filter = "All Energy Companies";
            }
            if (_this6.filters_save.trucking_company_name != null) {
              _this6.tc_filter = _this6.filters_save.trucking_company_name;
            } else {
              _this6.tc_filter = "All Trucking Companies";
            }
            if (_this6.filters_save.truck_name != null) {
              _this6.t_filter = _this6.filters_save.truck_name;
            } else {
              _this6.t_filter = "All Trucks";
            }
            if (_this6.filters_save.truck_type_name != null) {
              _this6.tt_filter = _this6.filters_save.truck_type_name;
            } else {
              _this6.tt_filter = "All Truck Types";
            }
            if (_this6.filters_save.unload_name != null) {
              _this6.u_filter = _this6.filters_save.unload_name;
            } else {
              _this6.u_filter = "All Unloads";
            }
            if (_this6.filters_save.initial_date != null) {
              _this6.filter_by.initial_date = _this6.filters_save.initial_date;
            } else {
              _this6.filters_save.initial_date = '';
              _this6.filter_by.initial_date = '';
            }
            if (_this6.filters_save.end_date != null) {
              _this6.filter_by.end_date = _this6.filters_save.end_date;
            } else {
              _this6.filter_by.end_date = '';
              _this6.filters_save.end_date = '';
            }
          } else {
            _this6.ec_filter = "All Energy Companies";
            _this6.tc_filter = "All Trucking Companies";
            _this6.t_filter = "All Trucks";
            _this6.tt_filter = "All Truck Types";
            _this6.u_filter = "All Unloads";

            _this6.filters_save.energy_company_id = 0;
            _this6.filters_save.energy_company_name = _this6.ec_filter;
            _this6.filters_save.trucking_company_id = 0;
            _this6.filters_save.truking_company_name = _this6.tc_filter;
            _this6.filters_save.truck_id = 0;
            _this6.filters_save.truck_name = _this6.t_filter;
            _this6.filters_save.truck_type_id = 0;
            _this6.filters_save.truck_type_name = _this6.tt_filter;
            _this6.filters_save.unload_id = 0;
            _this6.filters_save.unload_name = _this6.u_filter;
            _this6.filters_save.initial_date = '';
            _this6.filters_save.end_date = '';
            _this6.filters_save.sortby = null;
            _this6.filters_save.sortdesc = false;
            _this6.filter_by = { "initial_date": "", "end_date": "", "truck_id": "", "users_id": "", "unload_location_id": "", "energy_company_id": "", "trucking_company_id": "", "truck_type_id": "" };
          }
          _this6.getAll();
          _this6.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]);
          _this6.loadingData = false;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this6.loadingData = false;
      });
    },
    sortingChanged: function sortingChanged(ctx) {
      this.filters_save.sortdesc = ctx.sortDesc;
      this.filters_save.sortby = ctx.sortBy;
      this.saveFilters();
    }
  }
});

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rowDetails__ = __webpack_require__(151);















__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hauls',
  components: {
    'row-details': __WEBPACK_IMPORTED_MODULE_11__rowDetails__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.Switch_Filters();

    localStorage.removeItem("haulsaPage");
    localStorage.removeItem("locationsaPage");
    localStorage.removeItem("tagetsaPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("userPage");
    if (!localStorage.haulPage) {
      localStorage.haulPage = 0;
    }
    this.$root.$on('haulUpdated', function () {
      _this.haul_updated = true;
      _this.getAll(parseInt(localStorage.haulPage));
    });
    this.$root.$on('closePopup', function () {
      _this.selected_haul_detail = null;
    });
  },
  data: function data() {
    var _newHaul,
        _this2 = this;

    return {
      haul_updated: false,
      selected_haul_detail: null,
      filename: 'report_' + __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "haul_id": "haul_id",
        "load_location": "load_location",
        "load_location_lsd": "load_location_lsd",
        "unload_location": "unload_location",
        "unload_location_lsd": "unload_location_lsd",
        "trailer": "trailer",
        "truck_unit": "truck_unit",
        "full_name": "full_name",
        "ticket": "ticket",
        "oil_actual": "oil_actual",
        "volume_actual": "volume_actual",
        "volume_estimate": "volume_estimate",
        "water_actual": "water_actual",
        "bsw": "bsw",
        "energy_company": "energy_company",
        "fluid_type": "fluid_type",
        "haul_start_date": "haul_start_date",
        "haul_end_date": "haul_end_date",
        "water_cut_actual": "water_cut_actual",
        "trucking_company": "trucking_company",
        "haul_start_time": "haul_start_time",
        "haul_end_time": "haul_end_time",
        "avg_speed": "avg_speed",
        "cost_regular": "cost_regular",
        "cost_stb": "cost_stb",
        "cost_worktime": "cost_worktime",
        "total_cost": "total_cost",
        "comments_start": "comments_start",
        "comments_end": "comments_end",
        "wait_to_load": "wait_to_load",
        "comment_wait_to_load": "comment_wait_to_load",
        "wait_to_unload": "wait_to_unload",
        "comment_wait_to_unload": "comment_wait_to_unload",
        "other_wait_time": "other_wait_time",
        "comment_other_wait_time": "comment_other_wait_time",
        "personal_time": "personal_time",
        "comment_personal_time": "comment_personal_time",
        "operating_areas": "operating_areas",
        "nomination": "nomination",
        "truck_types": "truck_types"
      },
      exp_csv: ["haul_id", "load_location", "load_location_lsd", "unload_location", "unload_location_lsd", "trailer", 'truck_unit', "full_name", "ticket", "oil_actual", "volume_actual", "volume_estimate", "water_actual", "bsw", "energy_company", "fluid_type", "haul_start_date", "haul_end_date", "water_cut_actual", "trucking_company", "haul_start_time", "haul_end_time", "avg_speed", "cost_regular", "cost_stb", "cost_worktime", "total_cost", "comments_start", "comments_end", "wait_to_load", "comment_wait_to_load", "wait_to_unload", "comment_wait_to_unload", "other_wait_time", "comment_other_wait_time", "personal_time", "comment_personal_time", "operating_areas", "nomination", "truck_types"],
      json_data: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      newHaul: (_newHaul = {
        water_actual: "",
        water_percentage_estimate: "",
        oil_actual: "",
        truck_company_select: [],
        driver_select: [],
        energy_company_select: [],
        unload_location_select: [],
        fluid_type_select: [],
        load_location_select: [],
        loads_locations: [],
        truck_select: [],
        truck_unit_select: [],

        companyName: '',
        load_location: '',
        loadingData: true,
        unload_location: '',
        haul_start_date: '',

        truck_company_id: '',
        load_location_id: '',
        user_id: '',
        full_name: '',
        truck_id: '',
        truck_unit_id: '',
        trucking_company_id: '',
        energy_companies_id: '',
        unload_location_id: '',
        fluid_type_id: '',
        water_percentage_actual: ''
      }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'water_percentage_estimate', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'volume_actual', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'volume_estimate', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_end_datetime', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_start_datetime', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_end_time', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_start_time', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'chain_up', false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'comments_start', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'comments_end', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'wait_times_csv', []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'wait_times', [{
        "type_id": "3",
        "time": "00:00",
        "comments": ""
      }, {
        "type_id": "4",
        "time": "00:00",
        "comments": ""
      }]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'load_location_name', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'unload_location_name', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 'ticket', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 't_ticket', ''), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_newHaul, 't_boss', ''), _newHaul),
      allSelected: false,
      tableValues: [],
      status: 'unchecked',
      insert_data: { 'trucking_companies': [] },
      haul_ids: [],
      haul_iidds: [],
      haul_iiddss: [],
      selected: '',
      folderOptions: [],
      foldersHauls: [],

      energy_companies_filter: '',
      folders: '',
      load_locations_filter: '',
      unload_locations_filter: '',
      drivers_filter: '',
      trucks_filter: '',
      trucking_companies_filter: '',
      fluid_types_filter: '',
      row: 0,
      loadingData: true,
      trash: false,
      dpdt: "Active",
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "", "flags": "",
        "column": ['ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] },
      companyName: '',
      companyId: null,
      newEC: false,
      configTable: false,
      modalFolders: false,

      items: items,
      itemsAll: items,
      items_csv: [],
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'select_haul',
        label: 'Select',
        thClass: 'select_column', tdClass: 'select_column'
      }, {
        key: 'ticket',
        label: 'Ticket #',
        sortable: true
      }, {
        key: 'load_location',
        label: 'Load',
        sortable: true
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: true
      }, {
        key: 'volume_actual',
        label: 'Deliveries',
        sortable: true,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'oil_actual',
        label: 'Oil',
        sortable: true,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'water_actual',
        label: 'Water',
        sortable: true,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }

      }, {
        key: 'bsw',
        label: 'BS&W (%)',
        sortable: true
      }, {
        key: 'haul_start_date',
        label: 'Start Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_9_moment___default()(value).format("MMM DD, YYYY");
        }
      }, {
        key: 'haul_start_time',
        label: 'Start Time',
        sortable: true
      }],
      currentPage: parseInt(localStorage.haulPage),
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'],
      role: '',
      savebtn: true,
      energy_company_id: null,
      unit: '',
      dash: '',
      FromDash: 'NoWaittimes',
      fromHaul: 0,
      filters_save: {
        folder_id: 0,
        folder: 'All Folders',
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        sortby: 'haul_id',
        sortdesc: false
      },
      filters_start: {
        folder_id: 0,
        folder: 'All Folders',
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        sortby: 'haul_id',
        sortdesc: false
      },
      bbll: false,
      h_approved: false,
      myToggle: false,
      activated: false,
      Approved: 'Show Approved',
      progress: false,
      load_csv: 'Loading CSV......',
      iscsv: false,
      csv: '',
      hazards: [],
      controls: [],
      hazard_id: [],
      control_id: [],
      indeterminateHZ: false,
      hzAllSelected: false,
      indeterminateCTL: false,
      ctlAllSelected: false,
      hazard1_id: [],
      control1_id: [],
      indeterminateHZ1: false,
      hz1AllSelected: false,
      indeterminateCTL1: false,
      ctl1AllSelected: false,
      drivers_temp: []
    };
  },

  watch: {
    selected_haul_detail: function selected_haul_detail(a, b) {
      var item = this.tableValues.find(function (obj) {
        return obj.haul_id === b;
      });
      if (item) {
        item._rowVariant = '';
      }
      item = this.tableValues.find(function (obj) {
        return obj.haul_id === a;
      });
      if (item) {
        item._rowVariant = 'selected2';
      }
      var tmp = this.haul_ids;
      this.haul_ids = [];
      this.haul_ids.push({ haul_id: a });
      this.haul_ids = tmp;
    },
    haul_ids: function haul_ids(a, b) {
      var _this3 = this;

      this.allSelected = this.tableValues.length > 0 && this.tableValues.length === a.length ? true : false;
      b.map(function (haul_id) {
        var item = _this3.tableValues.find(function (obj) {
          return obj.haul_id === haul_id;
        });
        if (item && item.haul_id != _this3.selected_haul_detail) {
          item._rowVariant = '';
        }
        return item;
      });
      a.map(function (haul_id) {
        var item = _this3.tableValues.find(function (obj) {
          return obj.haul_id === haul_id;
        });
        if (item && item.haul_id != _this3.selected_haul_detail) {
          item._rowVariant = 'selected';
        }
        return item;
      });
    },
    perPage: function perPage(a, b) {
      if (a !== b) {
        this.currentPage = 1;
      }
    },
    currentPage: function currentPage(a, b) {
      if (a !== b) {
        console.log('currentPage');
      }
    }
  },
  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    haulUpdated: function haulUpdated() {
      if (this.haul_updated === true) this.currentPage = parseInt(localStorage.haulPage);
      this.haul_updated = false;
    },
    selectAllHauls: function selectAllHauls() {
      if (!this.allSelected) {
        this.toggleAllSelected();
      }
    },
    unselectAllHauls: function unselectAllHauls() {
      if (this.haul_ids.length > 0) {
        this.haul_ids = [];

        var tmp1 = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp = this.haul_ids;
        var tmp2 = this.array_diff(tmp, tmp1);
        this.haul_ids = tmp2;
      }
    },
    toggleAllSelected: function toggleAllSelected() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        var tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp1 = this.haul_ids;
        tmp1.push.apply(tmp1, tmp);
        this.haul_ids = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(tmp1)));
      } else {
        var _tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var _tmp2 = this.haul_ids;
        var tmp2 = this.array_diff(_tmp2, _tmp);
        this.haul_ids = tmp2;
      }
    },
    array_diff: function array_diff(tmp, tmp1) {
      return tmp.filter(function (elemento) {
        return tmp1.indexOf(elemento) == -1;
      });
    },
    openCreateFolder: function openCreateFolder() {
      localStorage.setItem('folderTo', '01');
      this.$router.push('/folders');
    },
    addHaulsFolder: function addHaulsFolder() {
      var _this4 = this;

      this.foldersHauls = [];
      this.haul_ids.map(function (item) {
        var item_data = {};
        item_data['folder_id'] = _this4.selected;
        item_data['haul_id'] = item;
        _this4.foldersHauls.push(item_data);
      });
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].addHaulsFolder(this.foldersHauls).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this4.haul_ids = [];
          _this4.selected = '';
          _this4.modalFolders = false;
          _this4.getAll();
          _this4.loadingData = true;
        } else {
          _this4.selected = '';
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this4.modalFolders = false;
        }
      });
    },
    openModal: function openModal() {
      var _this5 = this;

      this.folderOptions = [];
      this.folders.map(function (item) {
        var item_data = {};
        item_data['value'] = item.id;
        item_data['text'] = item.name;
        _this5.folderOptions.push(item_data);
      });
      this.modalFolders = true;
    },
    removeHaul: function removeHaul() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal({
        title: 'Please, confirm',
        text: "Are you sure to remove this Hauls?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].remove(_this6.haul_ids, _this6.filter_by['folder_id']).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]);
            _this6.filter = '';

            _this6.getAll();
            _this6.loadingData = true;
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    deleteHaul: function deleteHaul() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal({
        title: 'Please, confirm',
        text: "Are you sure to delete this Hauls?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].delete(_this7.haul_ids).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]);
            _this7.filter = '';

            _this7.getAll();
            _this7.loadingData = true;
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    restoreHauls: function restoreHauls() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Hauls?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].restore(_this8.haul_ids).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]);
            _this8.filter = '';

            _this8.getAll();
            _this8.loadingData = true;
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    checkedField: function checkedField(row) {
      if (this.haul_ids.includes(row.item.haul_id)) {
        var index = this.haul_ids.indexOf(row.item.haul_id);
        if (index > -1) {
          this.haul_ids.splice(index, 1);
        }
      } else {
        this.haul_ids.push(row.item.haul_id);
      }
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    bbl: function bbl() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_10__users_users_service__["a" /* default */].bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this9.loadingData = true;
            _this9.getAll();
          }
        });
      });
    },
    rowClicked: function rowClicked(row, index, e) {
      e.preventDefault();
      localStorage.haulPage = this.currentPage;
      if (!this.trash) {
        this.selected_haul_detail = row.haul_id;
        var to_popup = { 'id': row.haul_id, 'haul_invoice': false, 'edit': '' };
        this.$root.$emit('openPopup', to_popup);
      } else {
        this.restoreHaul(row.haul_id);
      }
    },
    addWaitTime: function addWaitTime() {
      this.newHaul.wait_times.push({
        "type_id": "5",
        "time": "00:00",
        "comments": ""
      });
    },
    hmsToSecondsOnly: function hmsToSecondsOnly(str) {
      var p = str.split(':'),
          s = 0,
          m = 1;

      while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
      }
      s *= 60;
      return s;
    },
    waitTimeLabel: function waitTimeLabel(wait_time) {
      var wait_times_label = [{
        type_id: "3",
        label: "Wait Time To Load"
      }, {
        type_id: "4",
        label: "Wait Time To Unload"
      }];
      var myIndex = wait_times_label.map(function (o) {
        return o.type_id;
      }).indexOf(wait_time.type_id);
      if (myIndex > -1) {
        return wait_times_label[myIndex].label;
      }
      return "Other Wait Time";
    },
    hideNewHaulModal: function hideNewHaulModal() {
      this.$refs.newHaulModal.hide();
    },
    showNewHaulModal: function showNewHaulModal() {
      this.savebtn = false;
      this.newHaul.truck_company_select = [];
      this.newHaul.driver_select = [];
      this.newHaul.energy_company_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];
      this.newHaul.load_location_select = [];
      this.newHaul.truck_select = [];

      this.newHaul.truck_company_id = '';
      this.newHaul.load_location_id = '';
      this.newHaul.user_id = '';
      this.newHaul.full_name = '';
      this.newHaul.truck_id = '';
      this.newHaul.truck_unit_id = '';
      this.newHaul.energy_companies_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';

      this.newHaul.comments_start = '';
      this.newHaul.comments_end = '';

      this.water_percentage_actual = '';
      this.water_percentage_estimate = '';
      this.volume_actual = '';
      this.volume_estimate = '';
      var tempDate = new Date();
      var tempDateTime = String(tempDate.getFullYear()) + "-" + ("0" + String(tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempDate.getDate())).slice(-2);
      var tempTime = ("0" + String(tempDate.getHours())).slice(-2) + ":" + ("0" + String(tempDate.getMinutes())).slice(-2);

      this.newHaul.haul_end_datetime = '';
      this.newHaul.haul_start_datetime = '';
      this.newHaul.haul_end_time = tempTime;
      this.newHaul.haul_start_time = tempTime;
      this.newHaul.chain_up = false;

      this.newHaul.t_ticket = '';
      this.newHaul.t_boss = '';

      this.newHaul.load_location_name = '';
      this.newHaul.unload_location_name = '';
      this.hazard_id = [];
      this.control_id = [];
      this.indeterminateHZ = false;
      this.hzAllSelected = false;
      this.indeterminateCTL = false;
      this.ctlAllSelected = false;
      this.hazard1_id = [];
      this.control1_id = [];
      this.indeterminateHZ1 = false;
      this.hz1AllSelected = false;
      this.indeterminateCTL1 = false;
      this.ctl1AllSelected = false;

      if (this.role == 'super_admin') {
        if (this.insert_data.trucking_companies.length > 0) {
          var trucking_companies = this.insert_data.trucking_companies;
          this.newHaul.truck_company_select = trucking_companies.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
        } else {
          this.get_trucking_companies();
        }
      } else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        if (this.insert_data.trucking_companies.length > 0) {
          this.selects_trucking_company();
        } else {
          this.get_trucking_companies();
          this.selects_trucking_company();
        }
      }
      this.newEC = true;
    },
    okToSave: function okToSave() {
      if (this.newHaul.energy_companies_id === undefined || this.newHaul.energy_companies_id.length == 0) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.newHaul.fluid_type_id === undefined || this.newHaul.fluid_type_id.length == 0) {
        this.$swal('Alert!', 'Fluid Type not selected', 'warning');
        return false;
      } else if (this.newHaul.load_location_id === undefined || this.newHaul.load_location_id.length == 0) {
        this.$swal('Alert!', 'Load Location not selected', 'warning');
        return false;
      } else if (this.newHaul.truck_company_id === undefined || this.newHaul.truck_company_id.length == 0) {
        this.$swal('Alert!', 'Truck Company not selected', 'warning');
        return false;
      } else if (this.newHaul.unload_location_id === undefined || this.newHaul.unload_location_id.length == 0) {
        this.$swal('Alert!', 'Unload Location not selected', 'warning');
        return false;
      } else if (this.newHaul.user_id === undefined || this.newHaul.user_id.length == 0) {
        this.$swal('Alert!', 'Driver not selected', 'warning');
        return false;
      } else if (this.newHaul.truck_id === undefined || this.newHaul.truck_id.length == 0) {
        this.$swal('Alert!', 'Trailer not selected', 'warning');
        return false;
      } else if (this.newHaul.volume_actual === undefined || this.newHaul.volume_actual.length == 0) {
        this.$swal('Alert!', 'Volume Actual can not be empty', 'warning');
        return false;
      } else if (this.newHaul.volume_actual < 5) {
        this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning');
        return false;
      } else if (this.newHaul.volume_estimate === undefined || this.newHaul.volume_estimate.length == 0) {
        this.$swal('Alert!', 'Volume Estimate can not be empty', 'warning');
        return false;
      } else if (this.newHaul.ticket === undefined || this.newHaul.ticket.length == 0) {
        this.$swal('Alert!', 'Ticket can not be empty', 'warning');
        return false;
      } else if (!this.Check_one_numbers(this.newHaul.ticket)) {
        this.$swal('Alert!', 'Ticket must have at least on number', 'warning');
        return false;
      }

      try {
        var startDateValidation = new Date(this.newHaul.haul_start_datetime).getFullYear();
        if (startDateValidation <= 2000 || startDateValidation >= 2100) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'Start Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      try {
        var endDateValidation = new Date(this.newHaul.haul_end_datetime).getFullYear();
        if (endDateValidation <= 2000 || endDateValidation >= 2100) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      return true;
    },
    waitTimeBlur: function waitTimeBlur(myIndex) {
      try {
        var variableValue = this.newHaul.wait_times[myIndex].time;
        if (variableValue.length == 0) {
          this.newHaul.wait_times[myIndex].time = "00:00";
        } else {
          var tempValue = variableValue.split(":");
          if (tempValue.length == 1) {
            this.newHaul.wait_times[myIndex].time = String(Math.min(variableValue, 24)) + ":00";
          } else if (tempValue.length == 2) {
            var min1 = String(Math.min(tempValue[0], 24));
            var min2 = String(Math.min(tempValue[1], 59));
            this.newHaul.wait_times[myIndex].time = ("0" + min1).slice(-2) + ":" + (min2 + "0").slice(-2);
          }
        }
      } catch (error) {}
    },
    removeTimeBlur: function removeTimeBlur(myIndex) {
      try {
        this.newHaul.wait_times.splice(myIndex, 1);
      } catch (error) {}
    },
    timeBlur: function timeBlur(variableName) {
      var variableValue = this.newHaul[variableName];
      if (variableValue.length == 0) {
        this.newHaul[variableName] = "00:00";
      } else {
        var tempValue = variableValue.split(":");
        if (tempValue.length == 1) {
          var min = String(Math.min(tempValue[0], 24));
          this.newHaul[variableName] = ("0" + min).slice(-2) + ":00";
        } else if (tempValue.length == 2) {
          var min1 = String(Math.min(tempValue[0], 24));
          var min2 = String(Math.min(tempValue[1], 59));
          this.newHaul[variableName] = ("0" + min1).slice(-2) + ":" + ("0" + min2).slice(-2);
        }
      }
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.newHaul[variableName];
      if (variableValue.length == 0) {
        this.newHaul[variableName] = "0.00";
      } else {
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {
          this.newHaul[variableName] = String(variableValue) + ".00";
        } else if (tempValue.length == 2) {
          this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
        }
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.newHaul[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.newHaul[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    selects_trucking_company: function selects_trucking_company() {
      if (this.role == 'super_admin') {
        this.newHaul.user_id = '';
        this.newHaul.full_name = '';
        this.newHaul.truck_id = '';
        this.newHaul.truck = '';
        this.newHaul.truck_unit_id = '';
        this.newHaul.truck_unit = '';
        var trucking_companies = this.insert_data.trucking_companies;

        var current_truck_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.truck_company_id);
        if (current_truck_company_index > -1) {
          var drivers = trucking_companies[current_truck_company_index]['drivers'];
          this.newHaul.driver_select = drivers.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
          var trucks = trucking_companies[current_truck_company_index]['trucks'];
          this.newHaul.truck_select = trucks.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_name
            };
          });
          var truck_units = trucking_companies[current_truck_company_index]['truck_units'];
          this.newHaul.truck_unit_select = truck_units.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_unit
            };
          });

          if (this.newHaul.driver_select.length == 1) {
            this.newHaul.full_name = this.newHaul.driver_select[0].text;
            this.newHaul.user_id = this.newHaul.driver_select[0].value;
          }
          if (this.newHaul.truck_select.length == 1) {
            this.newHaul.truck = this.newHaul.truck_select[0].text;
            this.newHaul.truck_id = this.newHaul.truck_select[0].value;
          }
          if (this.newHaul.truck_unit_select.length == 1) {
            this.newHaul.truck_unit = this.newHaul.truck_select[0].text;
            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value;
          }
        }
      } else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {

        this.newHaul.user_id = '';
        this.newHaul.full_name = '';
        this.newHaul.truck_id = '';
        this.newHaul.truck = '';
        this.newHaul.truck_unit_id = '';
        if (this.insert_data.trucking_companies.length > 0) {
          var _trucking_companies = this.insert_data.trucking_companies;
          this.newHaul.truck_company_id = _trucking_companies[0].id;
          var _drivers = _trucking_companies[0]['drivers'];
          this.newHaul.driver_select = _drivers.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
          var _trucks = _trucking_companies[0]['trucks'];
          this.newHaul.truck_select = _trucks.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_name
            };
          });
          var _truck_units = _trucking_companies[0]['truck_units'];
          this.newHaul.truck_unit_select = _truck_units.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_unit
            };
          });

          if (this.newHaul.driver_select.length == 1) {
            this.newHaul.full_name = this.newHaul.driver_select[0].text;
            this.newHaul.user_id = this.newHaul.driver_select[0].value;
          }
          if (this.newHaul.truck_select.length == 1) {
            this.newHaul.truck = this.newHaul.truck_select[0].text;
            this.newHaul.truck_id = this.newHaul.truck_select[0].value;
          }
          if (this.newHaul.truck_unit_select.length == 1) {
            this.newHaul.truck_unit = this.newHaul.truck_select[0].text;
            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value;
          }
        }
      }
    },
    selects_energy_company: function selects_energy_company() {
      this.newHaul.load_location_select = [];
      this.newHaul.load_location = '';
      this.newHaul.load_location_id = '';
      var trucking_companies = this.insert_data.trucking_companies;

      var current_truck_company_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.truck_company_id);
      if (current_truck_company_index > -1) {
        var drivers = trucking_companies[current_truck_company_index]['drivers'];
        var drivers_index = drivers.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.user_id);
        if (drivers_index > -1) {
          var energycompanies = drivers[drivers_index]['energy_companies'];
          var energy_company_index = energycompanies.map(function (o) {
            return o.id;
          }).indexOf(this.newHaul.energy_companies_id);
          this.getLoadLocation(energycompanies[energy_company_index].id, drivers[drivers_index].id);
        }
      }
    },
    getLoadLocation: function getLoadLocation(energy_company_id, driver_id) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].getLoadLocation(energy_company_id, driver_id).then(function (data) {
        if (data['status'] == 'success') {
          _this10.loads_locations = data['load_locations'];
          _this10.newHaul.load_location_select = _this10.loads_locations.map(function (item) {
            return {
              'value': item.id,
              'text': item.legal_location
            };
          });
          if (_this10.newHaul.load_location_select.length == 1) {
            _this10.newHaul.load_location = _this10.newHaul.load_location_select[0].text;
            _this10.newHaul.load_location_id = _this10.newHaul.load_location_select[0].value;
          }
        } else {
          _this10.$swal(data[0], data[1], data[0]);
        }
        _this10.loadingData = false;
      }).catch(function (error) {
        _this10.$swal('Error', 'Server not response. ' + error, 'error');
        _this10.loadingData = false;
      });
    },
    selects_driver: function selects_driver() {
      this.newHaul.energy_companies_id = '';
      this.newHaul.energy_company = '';
      this.newHaul.unload_location_select = [];
      this.newHaul.unload_location = '';
      this.newHaul.unload_location_id = '';

      var trucking_companies = this.insert_data.trucking_companies;
      var current_truck_company_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.truck_company_id);
      if (current_truck_company_index > -1) {
        var drivers = trucking_companies[current_truck_company_index]['drivers'];
        var drivers_index = drivers.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.user_id);
        var energycompanies = drivers[drivers_index]['energy_companies'];
        this.newHaul.energy_company_select = energycompanies.map(function (item) {
          return {
            'value': item.id,
            'text': item.company_name
          };
        });
        this.getUnloadLocation(drivers[drivers_index].id);
      }
    },
    getUnloadLocation: function getUnloadLocation(driver_id) {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].getUnloadLocation(driver_id).then(function (data) {
        if (data['status'] == 'success') {
          var loads_locations = data['unload_locations'];
          _this11.newHaul.unload_location_select = loads_locations.map(function (item) {
            return {
              'value': item.id,
              'text': item.legal_location
            };
          });
        } else {
          _this11.$swal(data[0], data[1], data[0]);
        }
        _this11.loadingData = false;
      }).catch(function (error) {
        _this11.$swal('Error', 'Server not response. ' + error, 'error');
        _this11.loadingData = false;
      });
    },
    selects_load_location: function selects_load_location() {

      this.newHaul.fluid_type_select = [];
      this.newHaul.fluid_type = '';
      this.newHaul.fluid_type_id = '';
      var loads_locations = this.loads_locations;
      var loads_locations_index = loads_locations.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.load_location_id);
      if (loads_locations_index > -1) {
        var fluid_types = loads_locations[loads_locations_index]['fluids'];
        this.newHaul.load_location_name = loads_locations[loads_locations_index].legal_location;
        this.newHaul.fluid_type_select = fluid_types.map(function (item) {
          return {
            'value': item.id,
            'text': item.name
          };
        });
      }
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      var _this12 = this;

      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.filter_by.column = this.fields.map(function (item) {
        return item.key;
      });
      this.configTable = false;
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].saveSelectedColumns(this.fields).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this12.getAll();
            setTimeout(function () {
              _this12.$refs.mEdit.hide();
            }, 500);
          }
        });
      });
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this13 = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'haul_start_date' || option == 'haul_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_9_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'oil_actual' || option == 'volume_actual' || option == 'volume_estimate' || option == 'water_actual') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                if (_this13.bbll == true) {
                  value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                } else {
                  value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                };return value;
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row: ' + (index + 1);
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    resetEditModal: function resetEditModal() {
      this.modalEdit.title = '';
      this.companyName = '';
    },
    onFiltered: function onFiltered(filteredItems) {

      this.currentPage = parseInt(localStorage.haulPage);

      this.totalRows = filteredItems.length;
      if (this.haul_updated !== true) this.currentPage = 1;
    },
    saveHaul: function saveHaul() {
      var _this14 = this;

      this.inputBlur('water_percentage_actual');
      this.inputBlur('water_percentage_estimate');
      this.inputBlur('volume_actual');
      this.inputBlur('volume_estimate');
      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var tempStartDateTime = new Date((this.newHaul.haul_start_datetime + " " + this.newHaul.haul_start_time).replace(/-/g, "/"));
      var tempEndDateTime = new Date((this.newHaul.haul_end_datetime + " " + this.newHaul.haul_end_time).replace(/-/g, "/"));

      var haul_start_datetime = String(tempStartDateTime.getFullYear()) + "-" + ("0" + String(tempStartDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempStartDateTime.getDate())).slice(-2) + " " + tempStartDateTime.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });
      var haul_end_datetime = String(tempEndDateTime.getFullYear()) + "-" + ("0" + String(tempEndDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempEndDateTime.getDate())).slice(-2) + " " + tempEndDateTime.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });

      var saveData = {
        "energy_companies_id": String(this.newHaul.energy_companies_id),
        "users_id": String(this.newHaul.user_id),
        "fluid_type_id": String(this.newHaul.fluid_type_id),
        "load_location_id": String(this.newHaul.load_location_id),
        "unload_location_id": String(this.newHaul.unload_location_id),
        "truck_id": String(this.newHaul.truck_id),
        "trucks_unit_id": String(this.newHaul.truck_unit_id),
        "haul_start_datetime": haul_start_datetime,
        "haul_end_datetime": haul_end_datetime,
        "volume_estimate": String(this.newHaul.volume_estimate),
        "volume_actual": String(this.newHaul.volume_actual),
        "water_percentage_estimate": String(this.newHaul.water_percentage_estimate),
        "water_percentage_actual": String(this.newHaul.water_percentage_actual),
        "terminal_ticket": String(this.newHaul.t_ticket),
        "truck_ticket": String(this.newHaul.ticket),
        "terminal_boss_ticket_id": String(this.newHaul.t_boss),
        "chain_up_required": this.newHaul.chain_up,
        "total_distance": "0",
        "comments_start": String(this.newHaul.comments_start),
        "comments_end": String(this.newHaul.comments_end),
        "waypoints": "",
        "trip_pictures": "",
        "wait_times": this.newHaul.wait_times.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
            time: _this14.hmsToSecondsOnly(item.time)
          });
        }),
        "hazard_id": this.hazard_id,
        "control_id": this.control_id,
        "hazard1_id": this.hazard1_id,
        "control1_id": this.control1_id
      };
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].save(saveData).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this14.companyName = '';
            _this14.newEC = false;
            _this14.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    trashHaul: function trashHaul() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "truck_id": "",
        "trucking_company_id": "",
        "users_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "folder_id": "",
        "fluid_type_id": "",
        "flags": "",
        "column": ['ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] };
      this.filters_save = {
        folder_id: 0,
        folder: 'All Folders',
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        truck_id: 0,
        truck_name: 'All Trucks',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        sortby: 'haul_id',
        sortdesc: false
      };
      this.FromDash = 'NoWaittimes';
      this.Approved = 'Show Approved';
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    Folders: function Folders(folder, id) {
      this.filter_by['folder_id'] = id;

      if (id == 0 && folder == 'All Folders') {
        this.filter_by['folder_id'] = '';
      }
      if (id == 0 && folder == 'Unassigned Hauls') {
        this.filter_by['folder_id'] = id;
      }
      this.filters_save.folder = folder;
      this.filters_save.folder_id = id;
      this.saveFilters();
      this.getAll();
      this.loadingData = true;
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    ftFilter: function ftFilter(ft_filter, id) {
      this.filter_by['fluid_type_id'] = id;

      if (id == 0) {
        this.filter_by['fluid_type_id'] = '';
      }
      this.filters_save.fluid_type_name = ft_filter;
      this.filters_save.fluid_type_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    dFilter: function dFilter(d_filter, id) {
      this.filter_by['users_id'] = id;
      if (id == 0) {
        this.filter_by['users_id'] = '';
      }
      this.filters_save.driver_name = d_filter;
      this.filters_save.users_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.filter_by['truck_id'] = id;
      if (id == 0) {
        this.filter_by['truck_id'] = '';
      }
      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    ttFilter: function ttFilter(tt_filter, id) {
      this.filter_by['truck_type_id'] = id;
      if (id == 0) {
        this.filter_by['truck_type_id'] = '';
      }
      this.getAll();
      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    vFilter: function vFilter(v_filter, id) {
      this.filter_by['flags'] = id;
      this.filters_save.flag_name = v_filter;
      this.Approved = 'Show Approved';
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    getAll: function getAll() {
      var _this15 = this;

      this.items = [];
      this.v_items = [];
      this.activated = false;
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].getAll(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this15.items = data.hauls.filter(function (o) {
            return o.status_id == (_this15.trash ? 2 : 1);
          });
          _this15.itemsAll = _this15.items;
          _this15.haul_iidds = data.haul_approved_ids;
          _this15.haul_iiddss = data.haul_unapproved_ids;
          _this15.drivers_temp = data.drivers;
          if (_this15.Approved == 'Approved' || _this15.Approved == 'Unapproved') {
            _this15.approvedFilter(_this15.Approved);
          }
          _this15.getAll1();
          _this15.activated = true;
          _this15.export_to_csv();
          _this15.$refs.excel;
        } else {
          _this15.$swal(data.status, data.message, data.status);
          _this15.loadingData = false;
          return;
        }
        _this15.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this15.loadingData = false;
      });
    },
    reformat: function reformat(value) {
      if (value.indexOf('%') != -1) {
        return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
      } else if (value.indexOf('km') != -1) {
        return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km";
      } else {
        return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    editEC: function editEC(item, button) {
      this.modalEdit.title = 'Editing ID: ' + item.id;
      this.companyName = item.name;
      this.companyId = item.id;
      this.$root.$emit('bv::show::modal', 'modalEdit', button);
    },
    updateEC: function updateEC() {
      var _this16 = this;

      if (this.companyName.trim() && this.companyId) {
        __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].update(this.companyId, this.companyName).then(function (data) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
            if (data[0] == 'success') {
              _this16.companyName = '';
              _this16.getAll();
              setTimeout(function () {
                _this16.$refs.mEdit.hide();
              }, 500);
            }
          });
        });
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Alert!', 'Company name have not empty', 'warning').catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        });
      } else {}
    },
    restoreHaul: function restoreHaul(id) {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Haul?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].restore(id).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]);
            _this17.filter = '';
            _this17.trash = 1;
            _this17.getAll();
            _this17.loadingData = true;
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    saveFilters: function saveFilters() {
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].saveFilters(0, this.filters_save).then(function (data) {
        if (data[0] == 'success') {
          return;
        } else {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]);
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        return;
      });
    },
    getFilters: function getFilters() {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].getFilters(0).then(function (data) {
        if (data[0] == 'success') {
          _this18.filters_start = data[1];
          _this18.filters_start1 = data[2];
          if (_this18.filters_start.length != 0) {
            for (var property in _this18.filters_start[0]) {
              _this18.filters_save[property] = _this18.filters_start[0][property];
              if (_this18.filters_start[0][property] == 0) {
                _this18.filter_by[property] = "";
              } else if (_this18.filters_start[0][property] == null) {
                _this18.filter_by[property] = "";
              } else {
                _this18.filter_by[property] = _this18.filters_start[0][property];
              }
            }
            if (_this18.filters_start[0]['initial_date'] == null) {
              _this18.filter_by['initial_date'] = __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD');
              _this18.filters_save['initial_date'] = __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD');
            }
            if (_this18.filters_start[0]['end_date'] == null) {
              _this18.filter_by['end_date'] = __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD');
              _this18.filters_save['end_date'] = __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD');
            }

            for (var property in _this18.filters_start1[0]) {
              _this18.filters_save[property] = _this18.filters_start1[0][property];
            }

            if (_this18.filters_start[0].folder_id == 0 && _this18.filters_start1[0].folder == 'Unassigned Hauls') {
              _this18.filter_by.folder_id = _this18.filters_start[0].folder_id;
            }
            _this18.filters_save.folder_id = _this18.filters_start[0].folder_id;
            _this18.filters_save.folder = _this18.filters_start1[0].folder;

            if (data[3] != '') {
              _this18.fields = [];
              _this18.fields = data[3];
            }
            if (_this18.fields.length > 0) {
              _this18.selectedItems = [];
              for (var i = 0; i < _this18.fields.length; i++) {
                var key = _this18.fields[i].key;
                _this18.selectedItems.push(key);
                if (key == 'haul_start_date' || key == 'haul_end_date') {
                  _this18.fields[i].formatter = function (value) {
                    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(value).format("MMM DD, YYYY");
                  };
                }

                if (key == 'oil_actual' || key == 'volume_actual' || key == 'volume_estimate' || key == 'water_actual') {
                  _this18.fields[i].formatter = function (value) {
                    if (_this18.bbll == true) {
                      value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                    } else {
                      value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                    };return value;
                  };
                }
              }
            }
            _this18.filter_by.column = _this18.selectedItems;
          } else {
            _this18.filters_save.folder_id = 0;
            _this18.filters_save.folder = "All Folders";
            _this18.filters_save.energy_companies_id = 0;
            _this18.filters_save.energy_company_name = "All Energy Companies";
            _this18.filters_save.fluid_type_id = 0;
            _this18.filters_save.fluid_type_name = "All Fluid Types";
            _this18.filters_save.users_id = 0;
            _this18.filters_save.driver_name = "All Drivers";
            _this18.filters_save.truck_id = 0;
            _this18.filters_save.truck_name = "All Trucks";
            _this18.filters_save.trucking_company_id = 0;
            _this18.filters_save.trucking_company_name = "All Trucking Companies";
            _this18.filters_save.unload_location_id = 0;
            _this18.filters_save.load_name = "All Loads";
            _this18.filters_save.unload_location_id = 0;
            _this18.filters_save.unload_name = "All Unloads";
            _this18.filters_save.flag_name = "All Flags";
            _this18.filters_save.initial_date = __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD');
            _this18.filters_save.end_date = __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD');
            _this18.filters_save.sortby = 'haul_id';
            _this18.filters_save.sortdesc = false;
            _this18.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD'),
              "end_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD'),
              "truck_id": "",
              "trucking_company_id": "",
              "users_id": "",
              "unload_location_id": "",
              "energy_companies_id": "",
              "load_location_id": "",
              "folder_id": "",
              "fluid_type_id": "",
              "flags": "",
              "column": ['ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] };
          }
          _this18.getAll();
          _this18.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data[0], data[1], data[0]);
          _this18.loadingData = false;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this18.loadingData = false;
      });
    },
    sortingChanged: function sortingChanged(ctx) {
      this.filters_save.sortdesc = ctx.sortDesc;
      this.filters_save.sortby = ctx.sortBy;
      this.saveFilters();
    },
    Switch_Filters: function Switch_Filters() {

      if ("dashboard" in localStorage) {
        this.dash = localStorage.getItem('dashboard');
      } else {
        this.dash = "dash00";
      }
      this.FromDash = 'NoWaittimes';
      if (this.dash == "dash00") {
        localStorage.setItem('dashboard', 'dash00');
        this.getFilters();
      } else if (this.dash == "dash09") {
        this.filters_save.folder_id = 0;
        this.filters_save.folder = "All Folders";
        this.filters_save.energy_companies_id = 0;
        this.filters_save.fluid_type_id = 0;
        this.filters_save.fluid_type_name = "All Fluid Types";
        this.filters_save.users_id = 0;
        this.filters_save.driver_name = "All Drivers";
        this.filters_save.truck_id = 0;
        this.filters_save.truck_name = "All Trucks";
        this.filters_save.trucking_company_id = 0;
        this.filters_save.trucking_company_name = "All Trucking Companies";
        this.filters_save.load_location_id = 0;
        this.filters_save.load_name = "All Loads";
        this.filters_save.unload_location_id = 0;
        this.filters_save.unload_name = "All Unloads";
        this.filters_save.flag_name = "All Flags";
        this.filters_save.sortby = 'haul_id';
        this.filters_save.sortdesc = false;
        this.filter_by = { "initial_date": '', "end_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "", "flags": "",
          "column": ['ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] };
        this.filters_save.flag_name = localStorage.getItem('dashboard_flag_name');
        this.filter_by.flags = parseInt(localStorage.getItem('dashboard_flag_id'));
        localStorage.removeItem('dashboard_flag_name');
        localStorage.removeItem('dashboard_flag_id');
        localStorage.setItem('dashboard', 'dash00');
        this.getAll();
        this.loadingData = true;
      } else {
        this.filters_save.folder_id = 0;
        this.filters_save.folder = "All Folders";
        this.filters_save.energy_companies_id = 0;
        this.filters_save.fluid_type_id = 0;
        this.filters_save.fluid_type_name = "All Fluid Types";
        this.filters_save.users_id = 0;
        this.filters_save.driver_name = "All Drivers";
        this.filters_save.truck_id = 0;
        this.filters_save.truck_name = "All Trucks";
        this.filters_save.trucking_company_id = 0;
        this.filters_save.trucking_company_name = "All Trucking Companies";
        this.filters_save.load_location_id = 0;
        this.filters_save.load_name = "All Loads";
        this.filters_save.unload_location_id = 0;
        this.filters_save.unload_name = "All Unloads";
        this.filters_save.flag_name = "All Flags";
        this.filters_save.sortby = 'haul_id';
        this.filters_save.sortdesc = false;
        this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "", "flags": "",
          "column": ['ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] };

        this.filter_by.initial_date = localStorage.getItem('dashboard_start_date');
        this.filter_by.end_date = localStorage.getItem('dashboard_end_date');
        this.filter_by.energy_companies_id = localStorage.getItem('dashboard_energy_id');
        this.filters_save.energy_company_name = localStorage.getItem('dashboard_energy_name');

        if ("dashboard_trucking_company_id" in localStorage) {
          if (localStorage.getItem('dashboard_trucking_company_id') != '') {
            this.filters_save.trucking_company_id = localStorage.getItem('dashboard_trucking_company_id');
            this.filter_by.trucking_company_id = this.filters_save.trucking_company_id;
          } else {
            this.filters_save.trucking_company_id = 0;
            this.filter_by.trucking_company_id = '';
          }
        } else {
          this.filters_save.trucking_company_id = 0;
          this.filter_by.trucking_company_id = '';
        }

        if ("dashboard_trucking_company_name" in localStorage) {
          if (localStorage.getItem('dashboard_trucking_company_name') != '') {
            this.filters_save.trucking_company_name = localStorage.getItem('dashboard_trucking_company_name');
          } else {
            this.filters_save.trucking_company_name = "All Trucking Companies";
          }
        } else {
          this.filters_save.trucking_company_name = "All Trucking Companies";
        }

        if (this.dash == 'dash03') {
          this.filters_save.unload_location_id = localStorage.getItem('dashboard_location_id');
          this.filter_by.unload_location_id = this.filters_save.unload_location_id;
          this.filters_save.unload_name = localStorage.getItem('dashboard_location_name');
          this.FromDash = 'Waittimes';
          localStorage.removeItem('dashboard_location_id');
          localStorage.removeItem('dashboard_location_name');
        }

        if (this.dash == 'dash04' || this.dash == 'dash06' || this.dash == 'dash07') {
          this.filters_save.unload_location_id = localStorage.getItem('dashboard_location_id');
          this.filter_by.unload_location_id = this.filters_save.unload_location_id;
          this.filters_save.unload_name = localStorage.getItem('dashboard_location_name');
          this.filters_save.fluid_type_id = localStorage.getItem('dashboard_fluid_type_id');
          this.filter_by.fluid_type_id = this.filters_save.fluid_type_id;
          this.filters_save.fluid_type_name = localStorage.getItem('dashboard_fluid_type_name');

          localStorage.removeItem('dashboard_location_id');
          localStorage.removeItem('dashboard_location_name');
          localStorage.removeItem('dashboard_fluid_type_id');
          localStorage.removeItem('dashboard_fluid_type_name');
        }

        if (this.dash == 'dash05') {
          this.filters_save.load_location_id = localStorage.getItem('dashboard_location_id');
          this.filter_by.load_location_id = this.filters_save.load_location_id;
          this.filters_save.load_name = localStorage.getItem('dashboard_location_name');
          this.filters_save.fluid_type_id = localStorage.getItem('dashboard_fluid_type_id');
          this.filter_by.fluid_type_id = this.filters_save.fluid_type_id;
          this.filters_save.fluid_type_name = localStorage.getItem('dashboard_fluid_type_name');

          localStorage.removeItem('dashboard_location_id');
          localStorage.removeItem('dashboard_location_name');
          localStorage.removeItem('dashboard_fluid_type_id');
          localStorage.removeItem('dashboard_fluid_type_name');
        }

        if (this.dash == 'dash08') {
          this.filters_save.flag_name = localStorage.getItem('dashboard_flag_name');
          this.filter_by.flags = 11;
          localStorage.removeItem('dashboard_flag_name');
        }
        if (this.dash == 'dash09') {
          this.filters_save.flag_name = localStorage.getItem('dashboard_flag_name');
          this.filter_by.flags = 11;
          localStorage.removeItem('dashboard_flag_name');
        }

        localStorage.setItem('dashboard', 'dash00');
        localStorage.removeItem("dashboard_start_date");
        localStorage.removeItem("dashboard_end_date");
        localStorage.removeItem('dashboard_energy_id');
        localStorage.removeItem('dashboard_energy_name');
        localStorage.removeItem('dashboard_trucking_company_id');
        localStorage.removeItem('dashboard_trucking_company_name');
        this.getAll();
        this.loadingData = true;
      }
    },
    getAll1: function getAll1() {
      var _this19 = this;

      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {

          _this19.energy_companies_filter = data.energy_companies_filter;
          _this19.folders = data.folders;
          _this19.drivers_filter = data.drivers_filter;
          _this19.load_locations_filter = data.load_locations_filter;
          _this19.unload_locations_filter = data.unload_locations_filter;
          _this19.trucks_filter = data.trucks_filter;
          _this19.truck_types_filter = data.truck_types_filter;
          _this19.trucking_companies_filter = data.trucking_companies_filter;
          _this19.fluid_types_filter = data.fluid_types_filter;

          _this19.bbll = data.bbl;
          _this19.role = data.role;
          if (_this19.role == 'trucking_company_admin') {
            _this19.drivers_filter = _this19.drivers_temp;
          }
          _this19.hazards = data.hazards;
          _this19.controls = data.controls;
        } else {

          _this19.$swal(data.status, data.message, data.status);
          _this19.loadingData = false;
          return;
        }
        _this19.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this19.loadingData = false;
      });
    },
    get_trucking_companies: function get_trucking_companies() {
      var _this20 = this;

      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].get_trucking_hauls().then(function (data) {
        if (data.status == 'success') {
          _this20.insert_data = data.insert_data;
          var trucking_companies = _this20.insert_data.trucking_companies;
          if (_this20.role == 'super_admin') {

            _this20.newHaul.truck_company_select = trucking_companies.map(function (item) {
              return {
                'value': item.id,
                'text': item.name
              };
            });
          } else if (_this20.role == 'trucking_company_admin' || _this20.role == 'trucking_operational_manager') {
            if (trucking_companies.length > 0) {
              _this20.newHaul.truck_company_id = trucking_companies[0].id;

              var drivers = trucking_companies[0]['drivers'];

              _this20.newHaul.driver_select = drivers.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.name
                };
              });
              var trucks = trucking_companies[0]['trucks'];
              _this20.newHaul.truck_select = trucks.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.truck_name
                };
              });
              var truck_units = trucking_companies[0]['truck_units'];
              _this20.newHaul.truck_unit_select = truck_units.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.truck_unit
                };
              });
              if (_this20.newHaul.truck_unit_select.length == 1) {
                _this20.newHaul.truck_unit = _this20.newHaul.truck_select[0].text;
                _this20.newHaul.truck_unit_id = _this20.newHaul.truck_select[0].value;
              }

              if (_this20.newHaul.driver_select.length == 1) {
                _this20.newHaul.full_name = _this20.newHaul.driver_select[0].text;
                _this20.newHaul.user_id = _this20.newHaul.driver_select[0].value;
              }
              if (_this20.newHaul.truck_select.length == 1) {
                _this20.newHaul.truck = _this20.newHaul.truck_select[0].text;
                _this20.newHaul.truck_id = _this20.newHaul.truck_select[0].value;
              }
            }
          }
        } else {
          _this20.$swal(data.status, data.message, data.status);
        }
      }).catch(function (error) {
        _this20.$swal('Error', 'Server not response. ' + error, 'error');
      });
    },
    export_to_csv: function export_to_csv() {
      var _this21 = this;

      this.items_csv = [];
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].export_to_csv(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this21.items_csv = data.hauls;
          console.log(_this21.items_csv);
          if (_this21.items_csv.length !== 0) {
            _this21.csv = _this21.combine_to_csv();
            if (_this21.iscvs) {
              _this21.progress = false;
              _this21.iscvs = false;
              _this21.exportCSVFile(_this21.csv, _this21.filename);
            }
          } else {
            if (_this21.iscvs) {
              _this21.progress = false;
              _this21.iscvs = false;
            }
          }
        } else {
          _this21.items_csv = [];
          _this21.progress = false;
        }
      }).catch(function (error) {
        _this21.items_csv = [];
        _this21.progress = false;
      });
    },
    HaulsApproved: function HaulsApproved() {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].HaulsApproved(this.haul_ids).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);

          _this22.getAll();
          _this22.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    h_approved_change: function h_approved_change() {
      if (!this.h_approved) {
        this.h_approved = true;
        this.haul_ids = this.haul_iidds;
      } else {
        this.h_approved = false;
        this.haul_ids = [];
      }
    },
    h_approved_click: function h_approved_click() {
      var _this23 = this;

      var model = {
        command: 'approved',
        approved: this.haul_ids
      };

      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].HaulsApproved(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this23.getAll();
          _this23.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    h_deapproved_click: function h_deapproved_click() {
      var _this24 = this;

      var model = {
        command: 'unapproved',
        unapproved: this.haul_ids
      };

      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].HaulsApproved(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this24.getAll();
          _this24.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    mergeByProperty: function mergeByProperty(target, source, prop) {
      var _this25 = this;

      var str = "";
      var line = "";
      this.exp_csv.forEach(function (element1) {
        line += element1;
        line += ",";
      });
      str += line + "\r\n";
      source.forEach(function (sourceElement) {
        var targetElement = target.find(function (targetElement) {
          return sourceElement[prop] === targetElement[prop];
        });
        targetElement ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(targetElement, sourceElement) : target.push(sourceElement);
        var line = "";
        _this25.exp_csv.forEach(function (element1) {
          if (element1 in targetElement) {
            line += '\"' + targetElement[element1] + '\",';
          }
        });
        str += line + "\r\n";
      });
      return str;
    },
    combine_to_csv: function combine_to_csv() {
      var hauls_data = this.items;
      var hauls_csv = this.items_csv;
      var columns = this.filter_by.column;
      return this.mergeByProperty(hauls_csv, hauls_data, 'haul_id');
    },
    approvedFilter: function approvedFilter(apr_filter) {
      if (this.role == 'super_admin' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        var itemsO = this.itemsAll;
        this.Approved = apr_filter;
        if (apr_filter === 'Approved') {
          var result = itemsO.filter(function (item) {
            return item.trucking_company_approved == true;
          });
          this.items = result;

          this.filters_save.flag_name = 'Approved';
        } else if (apr_filter === 'Unapproved') {
          var _result = itemsO.filter(function (item) {
            return item.trucking_company_unapproved == true;
          });
          this.items = _result;

          this.filters_save.flag_name = 'Unapproved';
        } else {
          this.items = this.itemsAll;
          this.haul_ids = [];
          this.Approved = 'Show Approved';
        }
      }
    },
    ignore_click: function ignore_click(flag) {
      var _this26 = this;

      if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        var model = {
          flag: flag,
          ignored: this.haul_ids
        };
        this.haul_ids = [];
        __WEBPACK_IMPORTED_MODULE_8__haul_service__["a" /* default */].HaulsIgnored(model).then(function (data) {
          if (data.status == 'success') {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
            _this26.getAll();
            _this26.loadingData = true;
          } else {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].swal(data.status, data.message, data.status);
          }
        });
      }
    },
    csv_export: function csv_export() {
      if (this.items_csv.length === 0) {
        if (this.items.length !== 0) {
          this.progress = true;
          this.iscvs = true;
        }
      } else {
        this.progress = false;
        this.iscvs = false;

        this.exportCSVFile(this.csv, this.filename);
      }
    },
    exportCSVFile: function exportCSVFile(csv, fileName) {

      var exportName = fileName;
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    keyMonitor: function keyMonitor(evt) {
      if (evt.key.match(/[a-zA-Z0-9]/i) === null) {
        evt.preventDefault();
        return;
      } else {
        evt = evt ? evt : window.event;
        var key = evt.key;
        if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
          return;
        } else if (key == "Backspace") {
          var filter_txt = this.newHaul.ticket;
          var nn = filter_txt.length - 1;
          if (nn > 0) {
            this.newHaul.ticket = filter_txt.substring(0, nn);
            return;
          } else {
            this.newHaul.ticket = '';
            return;
          }
        } else if (key == "Delete") {
          return;
        } else {

          var _filter_txt = this.newHaul.ticket;
          var _nn = _filter_txt.length;
          if (_nn < 10) {
            _filter_txt = _filter_txt + key;
            this.newHaul.ticket = _filter_txt;
          } else {
            evt.preventDefault();
          }
          return;
        }
      }
    },
    keyMonitor1: function keyMonitor1(evt) {
      if (evt.key.match(/[a-zA-Z0-9]/i) === null) {
        evt.preventDefault();
        return;
      } else {
        evt = evt ? evt : window.event;
        var key = evt.key;
        if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
          return;
        } else if (key == "Backspace") {
          var filter_txt = this.newHaul.t_ticket;
          var nn = filter_txt.length - 1;
          if (nn > 0) {
            this.newHaul.t_ticket = filter_txt.substring(0, nn);
            return;
          } else {
            this.newHaul.t_ticket = '';
            return;
          }
        } else if (key == "Delete") {
          return;
        } else {

          var _filter_txt2 = this.newHaul.t_ticket;
          var _nn2 = _filter_txt2.length;
          if (_nn2 < 10) {
            _filter_txt2 = _filter_txt2 + key;
            this.newHaul.t_ticket = _filter_txt2;
          } else {
            evt.preventDefault();
          }
          return;
        }
      }
    },
    Check_one_numbers: function Check_one_numbers(str_in) {
      var regex = /\d/;
      return regex.test(str_in);
    },
    HZChange: function HZChange() {
      if (this.hazard_id.length === 0) {
        this.indeterminateHZ = false;
        this.hzAllSelected = false;
      } else if (this.hazard_id.length === this.hazards.length) {
        this.indeterminateHZ = false;
        this.hzAllSelected = true;
      } else {
        this.indeterminateHZ = true;
        this.hzAllSelected = false;
      }
    },
    HZToggleAll: function HZToggleAll(checked) {
      this.hazard_id = checked ? this.hazards.map(function (item) {
        return item.id;
      }) : [];
    },
    CTLChange: function CTLChange() {
      if (this.control_id.length === 0) {
        this.indeterminateCTL = false;
        this.ctlAllSelected = false;
      } else if (this.control_id.length === this.controls.length) {
        this.indeterminateCTL = false;
        this.ctlAllSelected = true;
      } else {
        this.indeterminateCTL = true;
        this.ctlAllSelected = false;
      }
    },
    CTLToggleAll: function CTLToggleAll(checked) {
      this.control_id = checked ? this.controls.map(function (item) {
        return item.id;
      }) : [];
    },
    HZ1Change: function HZ1Change() {
      if (this.hazard1_id.length === 0) {
        this.indeterminateHZ1 = false;
        this.hz1AllSelected = false;
      } else if (this.hazard1_id.length === this.hazards.length) {
        this.indeterminateHZ1 = false;
        this.hz1AllSelected = true;
      } else {
        this.indeterminateHZ1 = true;
        this.hz1AllSelected = false;
      }
    },
    HZ1ToggleAll: function HZ1ToggleAll(checked) {
      this.hazard1_id = checked ? this.hazards.map(function (item) {
        return item.id;
      }) : [];
    },
    CTL1Change: function CTL1Change() {
      if (this.control1_id.length === 0) {
        this.indeterminateCTL1 = false;
        this.ctl1AllSelected = false;
      } else if (this.control1_id.length === this.controls.length) {
        this.indeterminateCTL1 = false;
        this.ctl1AllSelected = true;
      } else {
        this.indeterminateCTL1 = true;
        this.ctl1AllSelected = false;
      }
    },
    CTL1ToggleAll: function CTL1ToggleAll(checked) {
      this.control1_id = checked ? this.controls.map(function (item) {
        return item.id;
      }) : [];
    },
    selects_unload_location: function selects_unload_location() {

      var unloads_locations = this.newHaul.unload_location_select;
      var unloads_locations_index = unloads_locations.map(function (o) {
        return o.value;
      }).indexOf(this.newHaul.unload_location_id);
      if (unloads_locations_index > -1) {
        this.newHaul.unload_location_name = unloads_locations[unloads_locations_index].text;
      }
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    loads: {
      type: Array,
      default: []
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__haul_service__ = __webpack_require__(18);




var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hauls',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {

      items: items
    };
  },

  methods: {
    getAll: function getAll() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__haul_service__["a" /* default */].test().then(function (data) {
        _this.items = data.hauls;
      });
    }
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(4);









__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
	load: {
		key: 'AIzaSyATdAd4aao2C4a1osTnnfVVK_wiVsS2uzs'
	}
});
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'haul',
	created: function created() {
		this.getHaulData();
	},
	updated: function updated() {
		if (this.isPopup === true) {
			var h = document.getElementById('pageinfo').offsetHeight + 138;
			document.getElementById('haul-information').getElementsByClassName('tab-content')[0].style['height'] = 'calc(100vh - ' + h + 'px)';
		}
	},
	props: {
		id: {
			type: Number,
			default: 0
		},
		isPopup: {
			type: Boolean,
			default: false
		}
	},
	components: {
		vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
	},
	data: function data() {
		return {
			modalFolders: false,
			files: "",
			subTitle: "",
			wait_times: [],
			water_actual: 0,
			water_estimate: 0,
			oil_actual: 0,
			oil_estimate: 0,
			unload_location_select: [],
			fluid_type_select: [],
			truck_company_select: [],
			load_location_select: [],
			trucks_select: [],
			energy_company_select: [],
			user_id: '',
			selected_driver: [],
			full_name: '',
			driver_select: [],
			driver_select2: [],
			truck_select: [],
			mapTypeId: 'roadmap',
			zoom: 14,
			options: {
				strokeColor: '#e5c163',
				strokeOpacity: 1.0,
				strokeWeight: 6,
				geodesic: true
			},
			center: {
				"lat": 0,
				"lng": 0
			},
			markers: [],
			path: [],
			infoContent: '',
			infoLink: '',
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			companyName: '',
			edit: false,
			editHaulModal: false,
			tabIndex: 1,
			load_location: '',
			loadingData: true,
			unload_location: '',
			haul_start_date: '',
			waitCount: 0,
			trucks: [],
			driver: 0,
			areas: 0,
			areasCount: 50,
			originalData: null,
			originalData1: null,
			avg_speed: 0,
			cost_regular: 0,
			cost_stb: 0,
			total_cost: 0,
			role: '',
			view: true,
			view1: true,
			truck_type: '',

			selected: [],
			energy_companies_id: '',

			model: {
				id: null,
				initial_date: null,
				end_date: null,
				rate: null,
				charge_type: null,
				cost_type: null,
				chain_up_rate: null,
				energy_company: null,
				trucking_company: null,
				truck_type: null
			},
			modalAgreement: false,
			striped: false,
			bordered: true,
			borderless: false,
			outlined: true,
			small: true,
			hover: false,
			dark: false,
			fixed: true,
			personal_time_add: true,
			personal_time_modal: false,
			personal_time_items: {
				total: '',
				comments: ''
			},
			mapStyle: null,
			terminal_treatment_fee: null,
			terminal_other_fees: null,
			terminal_h2s_fees: null,
			terminal_density_fee: null,
			total_terminal_treatment_fees: null,
			gross_revenue: null,
			netback: null,
			rerouted: null,
			agreement_id: null,
			calculate: false,
			chain_up_rate: '',
			chain_up_time: '',
			chain_up_applied: false,
			worktime_rate: '',
			rate: '',
			stb_rate: '',
			volume_actual: '',
			formula: 'Total Cost: (Drive Rate * Volume Estimate) + (Stand by Rate * Volume Estimate) + (Worktime Rate * Volume Estimate) + Total Terminal Cost + Chain Up Rate',
			type_rate: 'Volume Estimate',
			type_stb_rate: 'Volume Estimate',
			type_worktime_rate: 'Volume Estimate',

			work_time: '00:00',
			trucking_companies: [],
			folder_haul: [],
			folderOptions: [],
			folders: [],
			edit_analyst: false,
			hz_load: { 'hazards': [], 'controls': [] },
			hz_unload: { 'hazards': [], 'controls': [] },
			hazards: [],
			controls: [],
			hazard_id: [],
			control_id: [],
			hazard1_id: [],
			control1_id: [],
			trucks_unit_id: null,
			truck_unit: '',
			terminal_boss: '',
			truck_unit_select: [],

			tdg_id: null,
			tdg: '',
			residue_last_contained: 'false',
			cnr: false,
			truck2_id: null,
			truck2: '',
			tdg_select: [],
			cnr_details: [],
			driving_time: '',
			cost_worktime: 0
		};
	},

	methods: {
		closePopupHaul: function closePopupHaul() {
			document.body.classList.toggle('aside-menu-hidden', true);
		},
		personal_time_option: function personal_time_option() {
			this.personal_time_modal = true;
		},
		personal_time_save: function personal_time_save() {
			var _this = this;

			this.personal_time_modal = false;
			if (this.personal_time_items.total != '') {

				var new_personal_time = {
					type_id: 6,
					total: this.personal_time_items.total,
					comments: this.personal_time_items.comments
				};
				__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].savePersonalTime(this.haulId, new_personal_time).then(function (data) {
					if (data[0] == 'success') {
						var new_personal_time_view = {
							id: data[2],
							type_id: 6,
							total: _this.personal_time_items.total,
							type_wait_times: "Personal Time",
							comments: _this.personal_time_items.comments
						};
						_this.wait_times.push(new_personal_time_view);
						_this.personal_time_add = false;
						_this.personal_time = _this.personal_time_items.total;
					} else {
						_this.personal_time_add = false;
						__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					}
				}).catch(function (error) {
					_this.personal_time_add = false;
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				});
			}
		},
		hidepersonaltime: function hidepersonaltime() {
			this.personal_time_modal = false;
		},
		addHaulsFolder: function addHaulsFolder() {
			if (this.selected.length < this.folderHaulIds.length && this.folderHaulIds.length != 0) {
				this.removeHaul();
			} else {
				if (this.selected.length != 0) {
					this.addHaul();
				} else {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('warning', 'Please select almos 1 folder', 'warning');
					this.modalFolders = false;
					this.getHaulData();
					this.loadingData = true;
				}
			}
		},
		addHaul: function addHaul() {
			var _this2 = this;

			this.foldersHauls = [];
			this.selected.map(function (item) {
				var item_data = {};
				item_data['folder_id'] = item;
				item_data['haul_id'] = _this2.haulId;
				_this2.foldersHauls.push(item_data);
			});
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].addHaulsFolder(this.foldersHauls).then(function (data) {
				if (data.status == 'success') {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data.status, data.message, data.status);
					_this2.haul_ids = [];

					_this2.modalFolders = false;
					_this2.getHaulData();
					_this2.loadingData = true;
				} else {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data.status, data.message, data.status);
					_this2.modalFolders = false;
					_this2.getHaulData();
					_this2.loadingData = true;
				}
			});
		},
		openModal: function openModal() {
			this.haul_ids = [];
			this.get_folders_by();
			this.haul_ids.push(this.haulId);
			this.modalFolders = true;
		},
		removeHaul: function removeHaul() {
			var _this3 = this;

			this.removeFolders = [];
			this.folderHaulIds.map(function (item) {
				if (!_this3.selected.includes(item)) {
					_this3.removeFolders.push(item);
				}
			});
			this.haul_ids = [];
			this.haul_ids.push(this.haulId);
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].remove(this.haul_ids, this.removeFolders).then(function (data) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data[0], data[1], data[0]);
				_this3.filter = '';

				_this3.getHaulData();
				_this3.loadingData = true;
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		hmsToSecondsOnly: function hmsToSecondsOnly(str) {
			var p = str.split(':'),
			    s = 0,
			    m = 1;

			while (p.length > 0) {
				s += m * parseInt(p.pop(), 10);
				m *= 60;
			}
			return s;
		},
		waitTimeBlur: function waitTimeBlur(myIndex) {
			try {
				var variableValue = this.wait_times[myIndex].total;
				if (variableValue.length == 0) {
					this.wait_times[myIndex].total = "00:00";
				} else {
					var tempValue = variableValue.split(":");
					if (tempValue.length == 1) {
						var min = String(Math.min(tempValue[0], 24));
						this.wait_times[myIndex].total = ("0" + min).slice(-2) + ":00";
					} else if (tempValue.length == 2) {
						var min1 = String(Math.min(tempValue[0], 24));
						var min2 = String(Math.min(tempValue[1], 59));
						this.wait_times[myIndex].total = ("0" + min1).slice(-2) + ":" + (min2 + "0").slice(-2);
					}
				}
			} catch (error) {
				console.log("Wrong index", error);
			}
		},
		inputBlur: function inputBlur(variableName) {
			var variableValue = this[variableName];
			if (variableValue.length == 0) {
				this[variableName] = "0.00";
			} else {
				var tempValue = variableValue.split(".");
				if (tempValue.length == 1) {
					this[variableName] = String(variableValue) + ".00";
				} else if (tempValue.length == 2) {
					this[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
				}
			}
		},
		inputBlur1: function inputBlur1(variableName) {
			if (this.cnr && this.cnr_details.length > 0) {
				var variableValue = variableName;
				if (variableValue.length == 0) {
					variableName = "0.00";
				} else {
					var tempValue = variableValue.split(".");
					if (tempValue.length == 1) {
						variableName = String(variableValue) + ".00";
					} else if (tempValue.length == 2) {
						variableName = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
					}
				}
			}
		},
		waterActualNumber: function waterActualNumber(evt) {
			var dotPosition = this.water_percentage_actual.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.water_percentage_actual.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		waterEstimateNumber: function waterEstimateNumber(evt) {
			var dotPosition = this.water_percentage_estimate.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.water_percentage_estimate.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		volumeActualNumber: function volumeActualNumber(evt) {
			var dotPosition = this.volume_actual.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.volume_actual.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		oilActualNumber: function oilActualNumber(evt) {
			var dotPosition = this.oil_actual.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.oil_actual.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		bswNumber: function bswNumber(evt) {
			var dotPosition = this.bsw.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.bsw.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		volumeEstimateNumber: function volumeEstimateNumber(evt) {
			var dotPosition = this.volume_estimate.indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.volume_estimate.length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},
		temperatureLoad: function temperatureLoad(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].temperature_load.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].temperature_load.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		temperatureULoad: function temperatureULoad(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].temperature_unload.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].temperature_unload.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		grossWeight: function grossWeight(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].gross_weight.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].gross_weight.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},
		tareWeight: function tareWeight(evt) {
			if (this.cnr && this.cnr_details.length > 0) {
				var dotPosition = this.cnr_details[0].tare_weight.indexOf(".");
				var hasDot = dotPosition > -1;
				var length = this.cnr_details[0].tare_weight.length;
				this.isNumber(evt, hasDot, dotPosition, length);
			}
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		selects_trucking_company: function selects_trucking_company() {
			if (this.role == 'super_admin') {
				var trucking_companies = this.trucking_companies;

				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					var drivers = trucking_companies[current_truck_company_index]['drivers'];
					this.driver_select = drivers.map(function (item) {
						return { 'value': item.id, 'text': item.name };
					});

					var trucks = trucking_companies[current_truck_company_index]['trucks'];
					this.truck_select = trucks.map(function (item) {
						return { 'value': item.id, 'text': item.truck_name };
					});

					if (this.driver_select.length == 1) {
						this.full_name = this.driver_select[0].text;
						this.user_id = this.driver_select[0].value;
					}
					if (this.truck_select.length == 1) {
						this.truck = this.truck_select[0].text;
						this.truck_id = this.truck_select[0].value;
					}
				}
			}
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational__manager') {
				var _trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];

				var _current_truck_company_index = _trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);

				var _drivers = this.trucking_companies[0]['drivers'];
				this.driver_select = _drivers.map(function (item) {
					return { 'value': item.id, 'text': item.name };
				});

				var _trucks = this.trucking_companies[0]['trucks'];
				this.truck_select = _trucks.map(function (item) {
					return { 'value': item.id, 'text': item.truck_name };
				});

				if (this.driver_select.length == 1) {
					this.full_name = this.driver_select[0].text;
					this.user_id = this.driver_select[0].value;
				}
				if (this.truck_select.length == 1) {
					this.truck = this.truck_select[0].text;
					this.truck_id = this.truck_select[0].value;
				}
			}
		},
		selects_energy_company: function selects_energy_company() {
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational__manager') {
				var trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];

				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					var drivers = this.trucking_companies[0]['drivers'];
					var drivers_index = drivers.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (drivers_index > -1) {
						var energycompanies = drivers[drivers_index]['energy_companies'];
						var energy_company_index = energycompanies.map(function (o) {
							return o.id;
						}).indexOf(this.energy_companies_id);

						this.getLoadLocation(energycompanies[energy_company_index].id, drivers[drivers_index].id);
					}
				}
			}
			if (this.role == 'super_admin') {
				var _trucking_companies2 = this.trucking_companies;

				var _current_truck_company_index2 = _trucking_companies2.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (_current_truck_company_index2 > -1) {
					var _drivers2 = _trucking_companies2[_current_truck_company_index2]['drivers'];
					var _drivers_index = _drivers2.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (_drivers_index > -1) {
						var _energycompanies = _drivers2[_drivers_index]['energy_companies'];
						var _energy_company_index = _energycompanies.map(function (o) {
							return o.id;
						}).indexOf(this.energy_companies_id);

						this.getLoadLocation(_energycompanies[_energy_company_index].id, _drivers2[_drivers_index].id);
					}
				}
			}
		},
		getLoadLocation: function getLoadLocation(energy_company_id, driver_id) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getLoadLocation(energy_company_id, driver_id).then(function (data) {
				if (data['status'] == 'success') {
					_this4.loads_locations = data['load_locations'];
					_this4.load_location_select = _this4.loads_locations.map(function (item) {
						return {
							'value': item.id,
							'text': item.legal_location
						};
					});
					if (_this4.load_location_select.length == 1) {
						_this4.load_location = _this4.load_location_select[0].text;
						_this4.load_location_id = _this4.load_location_select[0].value;
					}
					var loads_locations = _this4.loads_locations;
					var loads_locations_index = loads_locations.map(function (o) {
						return o.id;
					}).indexOf(_this4.load_location_id);
					if (loads_locations_index > -1) {
						var fluid_types = loads_locations[loads_locations_index]['fluids'];
						_this4.fluid_type_select = fluid_types.map(function (item) {
							return {
								'value': item.id,
								'text': item.name
							};
						});
						_this4.tdg_select = [];
						var ft_index = fluid_types.map(function (o) {
							return o.id;
						}).indexOf(_this4.fluid_type_id);
						if (ft_index > -1) {
							if ('tdg' in fluid_types[ft_index]) {
								_this4.tdg_select = fluid_types[ft_index].tdg;
							}
						}
					}
				} else {
					_this4.$swal('Error', 'Server not response. ' + error, 'error');
				}
				_this4.loadingData = false;
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
				_this4.loadingData = false;
			});
		},
		selects_driver: function selects_driver() {
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational__manager') {

				var trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];
				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					var drivers = this.trucking_companies[0]['drivers'];
					var drivers_index = drivers.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (drivers_index > -1) {
						var energycompanies = drivers[drivers_index]['energy_companies'];
						this.energy_company_select = energycompanies.map(function (item) {
							return { 'value': item.id, 'text': item.company_name };
						});
					}
				}
			}
			if (this.role == 'super_admin') {
				var _trucking_companies3 = this.trucking_companies;
				var _current_truck_company_index3 = _trucking_companies3.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (_current_truck_company_index3 > -1) {
					var _drivers3 = _trucking_companies3[_current_truck_company_index3]['drivers'];
					var _drivers_index2 = _drivers3.map(function (o) {
						return o.id;
					}).indexOf(this.user_id);
					if (_drivers_index2 > -1) {
						var _energycompanies2 = _drivers3[_drivers_index2]['energy_companies'];
						this.energy_company_select = _energycompanies2.map(function (item) {
							return { 'value': item.id, 'text': item.company_name };
						});
					}
				}
			}
		},
		getUnloadLocation: function getUnloadLocation(driver_id) {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getUnloadLocation(driver_id).then(function (data) {
				if (data['status'] == 'success') {
					var loads_locations = data['unload_locations'];
					_this5.unload_location_select = loads_locations.map(function (item) {
						return {
							'value': item.id,
							'text': item.legal_location
						};
					});
				} else {
					_this5.$swal(data[0], data[1], data[0]);
				}
				_this5.loadingData = false;
			}).catch(function (error) {
				_this5.$swal('Error', 'Server not response. ' + error, 'error');
				_this5.loadingData = false;
			});
		},
		selects_load_location: function selects_load_location() {
			var loads_locations = this.loads_locations;
			var loads_locations_index = loads_locations.map(function (o) {
				return o.id;
			}).indexOf(this.load_location_id);
			if (loads_locations_index > -1) {
				var fluid_types = loads_locations[loads_locations_index]['fluids'];
				this.fluid_type_select = fluid_types.map(function (item) {
					return {
						'value': item.id,
						'text': item.name
					};
				});
				this.tdg_select = [];
				var ft_index = fluid_types.map(function (o) {
					return o.id;
				}).indexOf(this.fluid_type_id);
				if (ft_index > -1) {
					if ('tdg' in fluid_types[ft_index]) {
						this.tdg_select = fluid_types[ft_index].tdg;
					}
				}
			}
		},
		okToUpdate: function okToUpdate() {
			if (this.energy_companies_id === undefined || this.energy_companies_id.length == 0) {
				this.$swal('Alert!', 'Energy Company not selected', 'warning');
				return false;
			} else if (this.fluid_type_id === undefined || this.fluid_type_id.length == 0) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				return false;
			} else if (this.load_location_id === undefined || this.load_location_id.length == 0) {
				this.$swal('Alert!', 'Load Location not selected', 'warning');
				return false;
			} else if (this.truck_company_id === undefined || this.truck_company_id.length == 0) {
				this.$swal('Alert!', 'Truck Company not selected', 'warning');
				return false;
			} else if (this.unload_location_id === undefined || this.unload_location_id.length == 0) {
				this.$swal('Alert!', 'Unload Location not selected', 'warning');
				return false;
			} else if (this.user_id === undefined || this.user_id.length == 0) {
				this.$swal('Alert!', 'Driver not selected', 'warning');
				return false;
			} else if (this.truck_id === undefined || this.truck_id.length == 0) {
				this.$swal('Alert!', 'Truck not selected', 'warning');
				return false;
			} else if (this.volume_actual < 5) {
				this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning');
				return false;
			}
			return true;
		},

		toggleInfoWindow: function toggleInfoWindow(marker, idx) {
			this.infoWindowPos = marker.position;
			this.infoContent = marker.title;
			this.infoLink = marker.www;

			if (this.currentMidx === idx) {
				this.infoWinOpen = !this.infoWinOpen;
			} else {
				this.currentMidx = idx;
				this.infoWinOpen = true;
			}
		},
		getHaulData: function getHaulData() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getByv2(this.id).then(function (data) {
				if (data.status == 'success') {
					_this6.loadingData = false;
					_this6.originalData = data['haul'];
					_this6.restoreOriginalData();
					_this6.messages = data['messages'];
					_this6.haulId = _this6.id;
					_this6.getHaulData1();
				} else {
					_this6.$swal(data.status, data.message, data.status);
					_this6.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this6.$swal('Error', 'Server not response.2 ' + error, 'error');
				_this6.loadingData = false;
			});
		},
		editHaul: function editHaul() {
			if (this.edit || this.edit_analyst) {
				this.edit = false;
				this.edit_analyst = false;
			} else {
				if (this.role === 'super_admin' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational__manager') {
					this.edit = true;
				} else if (this.role === 'analyst' || this.role == 'marketing_accountant') {
					this.edit_analyst = true;
				}
				this.setupFields();
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var features = this.originalData;

			this.user_id = features.user_id;
			this.haulId = features.haul_id;
			this.user = features.user;
			this.full_name = features.full_name;

			this.energy_companies_id = features.energy_companies_id;
			this.energy_company = features.energy_company;
			this.fluid_type_id = features.fluid_type_id;
			this.fluid_type = features.fluid_type;
			this.load_location_id = features.load_location_id;
			this.load_location = features.load_location;
			this.unload_location_id = features.unload_location_id;
			this.unload_location = features.unload_location;
			this.truck_id = features.truck_id;
			this.truck = features.truck;
			this.truck_type = features.truck_type;
			this.truck_company = features.truck_company;
			this.truck_company_id = features.truck_company_id;

			this.volume_actual = features.volume_actual;
			this.volume_estimate = features.volume_estimate;
			this.bsw = features.bsw;
			this.oil_actual = features.oil_actual;
			this.water_actual = features.water_actual;
			this.ticket = features.ticket;
			this.terminal_ticket = features.terminal_ticket;
			this.total_distance = features.total_distance;
			this.comments_start = features.comments_start;
			this.comments_end = features.comments_end;
			this.other_comments = features.other_comments;
			this.updated_date = features.updated_date;
			this.updated_time = features.updated_time;
			this.created_date = features.created_date;
			this.created_time = features.created_time;

			this.haul_start_datetime = features.haul_start_datetime;
			this.haul_end_datetime = features.haul_end_datetime;
			this.water_percentage_estimate = features.water_percentage_estimate;
			this.water_percentage_actual = features.water_percentage_actual;

			this.avg_speed = features.avg_speed;

			this.rate = features.rate;

			if (features.chain_up_rate != 'N/A') {
				this.chain_up_rate = features.chain_up_rate;
				this.chain_up_applied = true;
			} else {
				this.chain_up_rate = "$0.00";
				this.chain_up_applied = false;
			}
			this.chain_up_time = features.chain_up_time;
			this.stb_rate = features.stb_rate;
			this.worktime_rate = features.worktime_rate;

			this.total_cost = features.total_cost;
			this.formula = features.formula;
			this.type_rate = features.type_rate;
			this.type_stb_rate = features.type_stb_rate;
			this.type_worktime_rate = features.type_worktime_rate;

			this.terminal_treatment_fee = features.terminal_treatment_fee;
			this.terminal_other_fees = features.terminal_other_fees;
			this.terminal_h2s_fees = features.terminal_h2s_fees;
			this.terminal_density_fee = features.terminal_density_fee;
			this.total_terminal_treatment_fees = features.total_terminal_treatment_fees;

			this.gross_revenue = features.gross_revenue;
			this.netback = features.netback;
			this.rerouted = features.rerouted;
			this.agreement_id = features.agreement_id;

			this.unit_cost = features.unit_cost;

			this.path = [];
			this.center = {
				"lat": 0,
				"lng": 0
			};
			this.markers = [];
			this.haul_start_date = "";
			this.haul_start_time = "";
			this.haul_end_date = "";
			this.haul_end_time = "";
			this.wait_times = [];
			this.waitCount = "";
			this.driving_time = "";
			this.stb = "";
			this.personal_time = "";
			this.work_time = "";
			this.files = "";
			this.hz_load.hazards = features.hz_load.hazards;
			this.hz_load.controls = features.hz_load.controls;
			this.hz_unload.hazards = features.hz_unload.hazards;
			this.hz_unload.controls = features.hz_unload.controls;

			this.trucks_unit_id = features.trucks_unit_id;
			this.truck_unit = features.truck_unit;
			this.terminal_boss = features.terminal_boss;

			this.truck2_id = features.truck2_id;
			this.truck2 = features.truck2;
			this.tdg_id = features.tdg_id;
			this.tdg = features.tdg;
			this.residue_last_contained = features.residue_last_contained;
			this.cnr = features.cnr;
			this.cnr_details = features.cnr_details;
			this.cost_regular = features.cost_regular;
			this.cost_worktime = features.cost_worktime;
			this.cost_stb = features.cost_stb;
		},
		setupFields: function setupFields(clear) {
			if (this.role == 'super_admin') {
				this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '');
				this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '');
				this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '');
				this.total_distance = this.total_distance.replace(/[^\./\d]/g, '');
				this.oil_actual = this.oil_actual.replace(/[^\./\d]/g, '');
				this.bsw = this.bsw.replace(/[^\./\d]/g, '');
			} else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational__manager') {
				this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '');
				this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '');
				this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '');
				this.total_distance = this.total_distance.replace(/[^\./\d]/g, '');
				this.oil_actual = this.oil_actual.replace(/[^\./\d]/g, '');
				this.bsw = this.bsw.replace(/[^\./\d]/g, '');
			} else if (this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.volume_actual = this.volume_actual.replace(/[^\./\d]/g, '');
				this.water_percentage_actual = this.water_percentage_actual.replace(/[^\./\d]/g, '');
				this.volume_estimate = this.volume_estimate.replace(/[^\./\d]/g, '');
				this.total_distance = this.total_distance.replace(/[^\./\d]/g, '');
				this.oil_actual = this.oil_actual.replace(/[^\./\d]/g, '');
				this.bsw = this.bsw.replace(/[^\./\d]/g, '');
			}
			var hazard = this.hz_load.hazards;
			if (hazard.length > 0) {
				this.hazard_id = hazard.map(function (item) {
					return item.hazard_id;
				});
			} else {
				this.hazard_id = [];
			}

			var hazard1 = this.hz_unload.hazards;
			if (hazard1.length > 0) {
				this.hazard1_id = hazard1.map(function (item) {
					return item.hazard_id;
				});
			} else {
				this.hazard1_id = [];
			}

			var control = this.hz_load.controls;
			if (control.length > 0) {
				this.control_id = control.map(function (item) {
					return item.control_id;
				});
			} else {
				this.control_id = [];
			}

			var control1 = this.hz_unload.controls;
			if (control1.length > 0) {
				this.control1_id = control1.map(function (item) {
					return item.control_id;
				});
			} else {
				this.control1_id = [];
			}
		},
		updateHaul: function updateHaul() {
			var _this7 = this;

			if (!this.okToUpdate()) {
				return;
			}
			this.haulUpdate = {
				'energy_companies_id': this.energy_companies_id,
				'fluid_type_id': this.fluid_type_id,
				'load_location_id': this.load_location_id,
				'unload_location_id': this.unload_location_id,
				'truck_id': this.truck_id,
				'user_id': this.user_id,
				'haul_start_datetime': this.haul_start_datetime,
				'haul_end_datetime': this.haul_end_datetime,
				'haul_start_date': this.haul_start_date,
				'haul_start_time': this.haul_start_time,
				'haul_end_date': this.haul_end_date,
				'haul_end_time': this.haul_end_time,
				'volume_estimate': this.volume_estimate,
				'volume_actual': this.volume_actual,
				'oil_actual': this.oil_actual,
				'water_percentage_estimate': this.water_percentage_estimate,
				'water_percentage_actual': this.water_percentage_actual,
				'bsw': this.bsw,
				'truck_ticket': this.ticket,
				'terminal_ticket': this.terminal_ticket,
				'total_distance': this.total_distance,
				'comments_start': this.comments_start,
				'other_comments': this.other_comments,
				'comments_end': this.comments_end,
				"wait_times": [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.wait_times)),
				"hazard_id": this.hazard_id,
				"control_id": this.control_id,
				"hazard1_id": this.hazard1_id,
				"control1_id": this.control1_id,
				"terminal_boss": this.terminal_boss,
				"trucks_unit_id": this.trucks_unit_id,
				"truck2_id": this.truck2_id,
				"tdg_id": this.tdg_id,
				"residue_last_contained": this.residue_last_contained,
				"cnr": this.cnr,
				"cnr_details": this.cnr_details
			};
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].update(this.haulUpdate, this.haulId).then(function (data) {
				_this7.$root.$emit('haulUpdated');
				_this7.$swal(data[0], data[1], data[0]).then(function (result) {
					_this7.getHaulData();
				});
			}).catch(function (error) {
				_this7.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
			this.edit_analyst = false;
		},
		deleteHaul: function deleteHaul(item) {
			var _this8 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Haul?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].delete(_this8.haulId).then(function (data) {
						_this8.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this8.$router.replace('/hauls');
							_this8.$root.$emit('haulUpdated');
							_this8.closePopupHaul();
						}
					}).catch(function (error) {
						_this8.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
			this.edit = false;
			this.edit_analyst = false;
		},
		base64toBlob: function base64toBlob(base64Data, contentType) {
			contentType = contentType || '';
			var sliceSize = 1024;
			var byteCharacters = atob(base64Data);

			var bytesLength = byteCharacters.length;
			var slicesCount = Math.ceil(bytesLength / sliceSize);
			var byteArrays = new Array(slicesCount);

			for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
				var begin = sliceIndex * sliceSize;
				var end = Math.min(begin + sliceSize, bytesLength);

				var bytes = new Array(end - begin);
				for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
					bytes[i] = byteCharacters[offset].charCodeAt(0);
				}
				byteArrays[sliceIndex] = new Uint8Array(bytes);
			}
			return new Blob(byteArrays, { type: contentType });
		},
		saveImage: function saveImage(file) {

			var item_image = file.replace(/^data:image\/(png|jpg|gif);base64,/, "");
			var blob = this.base64toBlob(item_image, 'image/gif');
			var data = window.URL.createObjectURL(blob);
			var link = document.createElement('a');
			link.href = data;
			link.download = 'photo.gif';
			document.body.appendChild(link);
			link.click();
			setTimeout(function () {
				window.URL.revokeObjectURL(data);
			}, 2000);
		},
		timeBlur: function timeBlur(variableName) {
			var variableValue = this.personal_time_items[variableName];
			if (variableValue.length == 0) {
				this.personal_time_items[variableName] = "00:00";
			} else {
				var tempValue = variableValue.split(":");
				if (tempValue.length == 1) {
					var min = String(Math.min(tempValue[0], 24));
					this.personal_time_items[variableName] = ("0" + min).slice(-2) + ":00";
				} else if (tempValue.length == 2) {
					var min1 = String(Math.min(tempValue[0], 24));
					var min2 = String(Math.min(tempValue[1], 59));
					this.personal_time_items[variableName] = ("0" + min1).slice(-2) + ":" + ("0" + min2).slice(-2);
				}
			}
		},
		savePersonalTime: function savePersonalTime() {
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].savePersonalTime(0, this.filters_save).then(function (data) {
				if (data[0] == 'success') {
					return data[0];
				} else {
					__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					return 0;
				}
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				return 0;
			});
		},
		est_detail: function est_detail() {
			this.calculate = true;
		},
		getHaulData1: function getHaulData1() {
			var _this9 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getByv22(this.id).then(function (data) {
				if (data.status == 'success') {
					_this9.originalData1 = data['haul'];
					_this9.restoreOriginalData1();

					_this9.folder_haul = data.folder_haul;
					_this9.folderHaulIds = _this9.folder_haul.map(function (item) {
						return item.id;
					});
					_this9.selected = _this9.folderHaulIds;
					_this9.messages = data['messages'];

					_this9.role = data['role'];
					if (_this9.role == 'super_admin') {
						_this9.view = true;
						_this9.get_trucking_companies();
						_this9.getUnloadLocation(_this9.user_id);
						_this9.getLoadLocation(_this9.energy_companies_id, _this9.user_id);
					} else if (_this9.role == 'super_analyst' || _this9.role == 'operations_manager') {
						_this9.view = false;
					} else if (_this9.role == 'trucking_company_admin' || _this9.role == 'trucking_operational__manager') {
						_this9.view1 = false;
						_this9.get_trucking_companies();
						_this9.getUnloadLocation(_this9.user_id);
						_this9.getLoadLocation(_this9.energy_companies_id, _this9.user_id);
					} else if (_this9.role == 'analyst' || _this9.role == 'marketing_accountant') {
						_this9.view = false;
						_this9.getUnloadLocation(_this9.user_id);
						_this9.getLoadLocation(_this9.energy_companies_id, _this9.user_id);
					}
					_this9.subTitle = _this9.originalData1.times.haul_start_date + " - " + new Date("1990-02-02 " + _this9.originalData1.times.haul_start_time).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
				} else {
					_this9.$swal(data.status, data.message, data.status);
					_this9.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this9.$swal('Error', 'Server not response. ' + error, 'error');
				_this9.loadingData = false;
			});
		},
		restoreOriginalData1: function restoreOriginalData1() {
			var features = this.originalData1;
			this.path = features.map.path;
			this.center = features.map.center;
			this.markers = features.map.markers;
			this.haul_start_date = features.times.haul_start_date;
			this.haul_start_time = features.times.haul_start_time;
			this.haul_end_date = features.times.haul_end_date;
			this.haul_end_time = features.times.haul_end_time;
			this.wait_times = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(features.wait_times));
			if (this.wait_times.length > 0) {
				var add_personal_time = this.wait_times.map(function (o) {
					return o.type_id;
				}).indexOf(6);
				if (add_personal_time > -1) {
					this.personal_time_add = false;
				}
			}

			this.waitCount = features.wait_count;
			this.driving_time = features.times.driving_time;
			this.stb = features.times.stb;
			this.personal_time = features.times.personal_time;
			this.work_time = features.times.work_time;
			this.files = features.files;
		},
		get_trucking_companies: function get_trucking_companies() {
			var _this10 = this;

			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].get_trucking_companies(this.truck_company_id).then(function (data) {
				if (data.status == 'success') {
					_this10.trucking_companies = data.trucking_companies;
					var trucking_companies = _this10.trucking_companies;
					_this10.truck_company_select = trucking_companies.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
					_this10.selects_trucking_company();
					_this10.selects_driver();
					_this10.select_truck_unit();
				} else {
					_this10.$swal(data.status, data.message, data.status);
					_this10.trucking_companies = [];
				}
			}).catch(function (error) {
				_this10.$swal('Error', 'Server not response. ' + error, 'error');
				_this10.trucking_companies = [];
			});
		},
		get_folders_by: function get_folders_by() {
			var _this11 = this;

			this.folderOptions = [];
			__WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].get_folders_by(this.energy_companies_id).then(function (data) {
				if (data.status == 'success') {
					_this11.folders = data.folders;
					_this11.folders.map(function (item) {
						var item_data = {};
						item_data['value'] = item.id;
						item_data['text'] = item.name;
						_this11.folderOptions.push(item_data);
					});
				} else {
					_this11.$swal(data.status, data.message, data.status);
					_this11.folders = [];
				}
			}).catch(function (error) {
				_this11.$swal('Error', 'Server not response. ' + error, 'error');
				_this11.folders = [];
			});
		},
		select_truck_unit: function select_truck_unit() {
			if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				var trucking_companies = this.trucking_companies;
				this.truck_company_select = this.trucking_companies[0]['id'];
				this.truck_company_id = this.trucking_companies[0]['id'];
				var current_truck_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (current_truck_company_index > -1) {
					this.truck_unit_select = this.trucking_companies[0]['truck_units'];
				}
			}
			if (this.role == 'super_admin') {
				var _trucking_companies4 = this.trucking_companies;
				var _current_truck_company_index4 = _trucking_companies4.map(function (o) {
					return o.id;
				}).indexOf(this.truck_company_id);
				if (_current_truck_company_index4 > -1) {
					this.truck_unit_select = _trucking_companies4[_current_truck_company_index4]['truck_units'];
				}
			}
		}
	}
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trucks_service__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trucking_companies_tc_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);





var items = [];
var truckingCompanies = [];
var typeTrucks = [{
	value: '1',
	label: 'Pequeño'
}, {
	value: '2',
	label: 'Mediano'
}, {
	value: '3',
	label: 'Grande'
}];
var fields = ['truck_name', 'trucking_company', 'type'];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'truck',
	created: function created() {
		this.getAll();
		localStorage.removeItem("haulsaPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("servicePage");
		localStorage.removeItem("truckuserPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("taPage");
		localStorage.removeItem("tasaPage");
		if (!localStorage.truckPage) {
			localStorage.truckPage = 0;
		}
	},
	components: {
		vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a
	},
	data: function data() {
		return {
			insert_data: null,
			trash: false,
			dpdt: 'Active',
			model: {
				truck_name: '',
				trucking_company_id: '',
				truck_type_id: ''
			},
			truckingcompaniesselect: [],
			trucktypesselect: [],

			truckName: '',
			truckId: null,
			plateTruck: '',
			selectedTC: null,
			truckingCompanies: [],
			selectedType: null,
			typeTrucks: typeTrucks,
			newTruck: false,
			items: items,

			loadingData: true,
			currentPage: parseInt(localStorage.truckPage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: 'truck_name',
			sortDesc: false,
			fields: fields,
			modalEdit: {
				title: ''
			},
			fieldsTh: [{
				key: 'id',
				label: 'ID',
				sortable: true
			}, {
				key: 'truck_name',
				label: 'Truck Name',
				sortable: true
			}, {
				key: 'type',
				label: 'Type'
			}, {
				key: 'trucking_company',
				label: 'Trucking Company'
			}],
			filter: null,
			modalInfo: {
				title: '',
				content: ''
			},
			configTable: false,
			selectedItems: ['truck_name', 'type', 'trucking_company'],
			savebtn: true,
			role: '',
			view: true,
			trucking_company_id: ''
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return {
					text: f.label,
					value: f.key
				};
			});
		}
	},
	methods: {
		newTruckModal: function newTruckModal() {
			this.model = {
				truck_name: '',
				trucking_company_id: '',
				truck_type_id: ''
			};
			this.savebtn = false;
			this.newTruck = true;
		},
		rowClicked: function rowClicked(row) {
			localStorage.truckPage = this.currentPage;
			if (!this.trash) {
				this.$router.push('/truck/' + row.id + '/');
			} else {
				this.restoreTruck(row.id);
			}
		},
		actionField: function actionField(option) {
			var fieldsThLength = this.fieldsTh.length;
			var fieldIsActive = false;
			for (var i = 0; i <= fieldsThLength; i++) {
				fieldIsActive = true;
				try {
					if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
						this.fieldsTh.splice(i, 1);
						fieldIsActive = false;
						break;
					}
				} catch (err) {
					var position = this.fields.indexOf(option);
					this.fieldsTh.splice(position, 0, option);
				}
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.truckPage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		trashTrucks: function trashTrucks() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		getAll: function getAll() {
			var _this = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					_this.items = data[1].filter(function (o) {
						return o.status_id == (_this.trash ? 2 : 1);
					});
					_this.insert_data = data[2];
					_this.trucktypesselect = _this.insert_data.truck_types;
					_this.truckingcompaniesselect = _this.insert_data.trucking_companies;
					_this.role = data[3];
					if (_this.role == 'super_admin') {
						_this.view = true;
					} else if (_this.role == 'super_analyst' || _this.role == 'analyst' || _this.role == 'marketing_accountant') {
						_this.view = false;
					} else if (_this.role == 'trucking_company_admin' || _this.role === 'trucking_operational_manager') {
						_this.view = false;
						_this.trucking_company_id = data[4];
					}
				} else {
					_this.items = [];
					_this.$swal(data[0], data[1], data[0]);
				}
				_this.loadingData = false;
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		saveNewTruck: function saveNewTruck() {
			var _this2 = this;

			if (!this.okToSave()) {
				return;
			}
			this.savebtn = true;
			if (this.role == 'trucking_company_admin' || this.role === 'trucking_operational_manager') {
				this.model.trucking_company_id = this.trucking_company_id;
			}
			var dataTruck = {
				truck_name: this.model.truck_name,
				trucking_company_id: this.model.trucking_company_id,
				truck_type_id: this.model.truck_type_id
			};

			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].save(dataTruck).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					if (data[0] == 'success') {
						_this2.newTruck = false;
						_this2.getAll();
					}
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = false;
		},
		okToSave: function okToSave() {
			if (this.role == 'super_admin') {
				if (this.model.trucking_company_id === undefined || this.model.trucking_company_id.length == 0) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.truck_name === undefined || this.model.truck_name.trim().length == 0) {
				this.$swal('Alert!', 'Truck Name can not be empty', 'warning');
				return false;
			} else if (this.model.truck_type_id === undefined || this.model.truck_type_id.length == 0) {
				this.$swal('Alert!', 'Truck Type not selected', 'warning');
				return false;
			}

			return true;
		},
		restoreTruck: function restoreTruck(id) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Truck?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].restore(id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.filter = '';
							_this3.trash = false;
							_this3.getAll();
							_this3.loadingData = true;
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucks/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.trucks, response.data.insert_data, response.data.role, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(idTruck) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck/' + idTruck + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.truck, response.data.update_data, response.data.role, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(dataTruck) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck/create/', dataTruck, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTruck, dataTruck) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck/update/' + idTruck + '/', dataTruck, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTruck) {
		console.log('Mi id: ' + idTruck);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck/delete/' + idTruck + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTruck) {
		console.log('Mi id: ' + idTruck);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck/restore/' + idTruck + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trucks_service__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trucking_companies_tc_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__m_truck_types_trucktypes__ = __webpack_require__(152);





var truckingCompanies = [];
var typeTrucks = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'truck',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getTruckData();
	},
	data: function data() {
		return {
			originalData: null,
			updateData: null,
			edit: false,
			model: {
				truck_name: '',
				trucking_company_id: '',
				truck_type_id: ''
			},
			truckingcompaniesselect: [],
			trucktypesselect: [],
			subTitle: '',

			selectedTC: null,
			selectedType: null,
			loadingData: true,
			truckingCompanies: [],
			typeTrucks: typeTrucks,
			truckName: '',
			truckPlate: '',
			created: '',
			updated: '',
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			role: '',
			view: true,
			trucking_company_id: ''
		};
	},

	methods: {
		restoreOriginalData: function restoreOriginalData() {
			this.model = {
				trucking_company: this.originalData.trucking_company,
				trucking_company_id: this.originalData.trucking_company_id,
				truck_type: this.originalData.type,
				truck_type_id: this.originalData.type_id,
				truck_name: this.originalData.truck_name
			};
		},
		setupFields: function setupFields() {},
		editTruck: function editTruck() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		getTruckData: function getTruckData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] === 'success') {
					_this.originalData = data[1];
					_this.updateData = data[2];
					_this.subTitle = _this.originalData.truck_name;
					_this.trucktypesselect = _this.updateData.truck_types;
					_this.truckingcompaniesselect = _this.updateData.trucking_companies;
					_this.restoreOriginalData();

					_this.found = true;
					_this.loadingData = false;

					_this.role = data[3];
					if (_this.role == 'super_admin') {
						_this.view = true;
					} else if (_this.role == 'trucking_company_admin' || _this.role === 'trucking_operational_manager') {
						_this.view = false;
						_this.trucking_company_id = data[4];
					}
				} else {
					_this.$swal(data[0], data[1], data[0]);
					_this.found = true;
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.role == 'super_admin') {
				if (this.model.trucking_company_id === undefined || this.model.trucking_company_id.length == 0) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.truck_name === undefined || this.model.truck_name.trim().length == 0) {
				this.$swal('Alert!', 'Truck Name can not be empty', 'warning');
				return false;
			} else if (this.model.truck_type_id === undefined || this.model.truck_type_id.length == 0) {
				this.$swal('Alert!', 'Truck Type not selected', 'warning');
				return false;
			}

			return true;
		},
		updateTruck: function updateTruck() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			if (this.role == 'trucking_company_admin' || this.role === 'trucking_operational_manager') {
				this.model.trucking_company_id = this.trucking_company_id;
			}
			var dataTruck = {
				truck_name: this.model.truck_name,
				trucking_company_id: this.model.trucking_company_id,
				truck_type_id: this.model.truck_type_id
			};

			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].update(this.id, dataTruck).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					if (data[0] == 'success') {
						_this2.getTruckData();
					}
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTruck: function deleteTruck() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Truck: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/trucks');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		getTruckingCompanies: function getTruckingCompanies() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1__trucking_companies_tc_service__["a" /* default */].getAll().then(function (data) {
				_this4.truckingCompanies = [];
				var tc_items = data.length;
				for (var i = 0; i < tc_items; i++) {
					_this4.truckingCompanies.push({
						'value': data[1][i].id,
						'label': data[1][i].name
					});
				}
			});
		},
		getTypesTrucks: function getTypesTrucks() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_2__m_truck_types_trucktypes__["a" /* default */].getAll().then(function (data) {
				_this5.typeTrucks = [];
				var tt_items = data.length;
				for (var i = 0; i < tt_items; i++) {
					_this5.typeTrucks.push({
						'value': data[i].id,
						'label': data[i].name
					});
				}
			});
		}
	}
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__agreements_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trucking_companies_tc_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__energy_companies_ec_service__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select__);







var items = [];
var fields = [{ key: 'id', label: 'ID', sortable: true }, { key: 'energy_company', label: 'Energy Company', sortable: true }, { key: 'trucking_company', label: 'Trucking Company', sortable: true }, { key: 'initial_date', label: 'Initial Date', sortable: true }, { key: 'end_date', label: 'End Date', sortable: true }, { key: 'cost_type', label: 'Cost Type', sortable: true }, { key: 'rate', label: 'Rate', sortable: true }, { key: 'charge_type', label: 'Charge Type' }, { key: 'truck_type', label: 'Truck Type', sortable: true }, { key: 'status', label: 'Status' }];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agreements',
	components: {
		vSelect: __WEBPACK_IMPORTED_MODULE_4_vue_select___default.a
	},
	created: function created() {
		this.getAll();
	},
	data: function data() {
		return {
			trash: false,
			dpdt: 'Active',
			insert_data: null,
			newAgreements: false,
			items: [],
			itemsO: [],

			chargeTypes: [],


			loadingData: true,
			currentPage: 1,
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: 'initial_date',
			sortDesc: false,
			fields: fields,
			fieldsTh: [{ key: 'id', label: 'ID', sortable: true }, { key: 'energy_company', label: 'Energy Company', sortable: true }, { key: 'trucking_company', label: 'Trucking Company', sortable: true }, { key: 'load_locations_l', label: 'Load Locations', sortable: false }, { key: 'unload_locations_l', label: 'Unload Locations', sortable: false }, { key: 'fluidtypes', label: 'Fluid Types', sortable: false }, { key: 'truck_types_l', label: 'Truck Types', sortable: false }, { key: 'initial_date', label: 'Initial Date', sortable: true, formatter: function formatter(value) {
					return moment(value).format("LL");
				} }, { key: 'end_date', label: 'End Date', sortable: true, formatter: function formatter(value) {
					return moment(value).format("LL");
				} }, { key: 'regular_charge', label: 'Regular Charge Type' }, { key: 'regular_rate', label: 'Regular Rate', sortable: true }, { key: 'stb_charge', label: 'Standby Time Charge Type' }, { key: 'stb_rate', label: 'Standby Time Rate', sortable: true }, { key: 'worktime_rate', label: 'Worktime Rate', sortable: true }, { key: 'located_based', label: 'Located Based Contract', sortable: true }, { key: 'fluidtypes_based', label: 'Fluid Types Based Contract', sortable: true }, { key: 'chain_up_rate', label: 'Chain Up Rate', sortable: true }],
			filter: null,
			modalInfo: { title: '', content: '' },
			configTable: false,
			selectedItems: ['id', 'initial_date', 'end_date', 'rate', 'energy_company', 'trucking_company', 'charge_type'],

			role: '',
			savebtn: true,
			energy_company_iidd: null,
			model: {
				id: null,
				energy_company_id: null,
				trucking_company_id: null,
				initial_date: null,
				end_date: null,
				regular_charge_id: null,
				regular_rate: null,
				stb_charge_id: null,
				stb_rate: null,
				worktime_charge_id: null,
				worktime_rate: null,
				chain_up_rate: null,
				truck_type_id: [],
				unload_locations_id: [],
				load_locations_id: [],
				located_based: 'false',
				rounding: 'false',
				wait_time_discount: 'false',
				fluid_based: 'false',
				fluid_types_id: [],
				fluid_types: []
			},
			energyCompanies: [],
			truckingCompanies: [],
			modalTabIndex: 0,
			unloadlocationselect: [],
			indeterminateUL: false,
			ulAllSelected: false,
			loadlocationselect: [],
			indeterminateLL: false,
			llAllSelected: false,
			truckTypes: [],
			indeterminateTT: false,
			ttAllSelected: false,
			options: [{ text: 'Yes', value: 'true' }, { text: 'No', value: 'false' }],
			options1: [{ text: 'Yes', value: 'true' }, { text: 'No', value: 'false' }],
			regular_rate: '',
			chain_up_rate: '',
			stb_rate: '',
			worktime_rate: '',
			trucking_companies_filter: [],
			energy_companies_filter: [],
			unload_locations_filter: [],
			load_locations_filter: [],
			truck_types_filter: [],
			filter_agree: { trucking_company: 'All Trucking Companies',
				energy_company: 'All Energy Companies',
				load_locations: 'All Load Locations',
				load_locations_id: 0,
				unload_locations: 'All Unload Locations',
				unload_locations_id: 0,
				truck_types: 'All Truck Types',
				truck_types_id: 0
			},
			fluidtypeselect: [],
			indeterminateFT: false,
			ftAllSelected: false
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return { text: f.label, value: f.key };
			});
		}
	},
	methods: {
		activate_custom_backdrop: function activate_custom_backdrop() {
			this.$root.$el.classList.add("custom_backdrop_behavior");
		},
		deactivate_custom_backdrop: function deactivate_custom_backdrop() {
			this.$root.$el.classList.remove("custom_backdrop_behavior");
		},
		tcFilter: function tcFilter(tc_filter, id) {
			var _this = this;

			this.filter_agree.trucking_company = tc_filter;
			var result = [];
			if (this.filter_agree.trucking_company === 'All Trucking Companies') {
				result = this.itemsO;
			} else {
				result = this.itemsO.filter(function (item) {
					return item.trucking_company == _this.filter_agree.trucking_company;
				});
			}
			var result1 = [];
			if (this.filter_agree.energy_company == 'All Energy Companies') {
				result1 = result;
			} else {
				result1 = result.filter(function (item) {
					return item.energy_company == _this.filter_agree.energy_company;
				});
			}
			var result2 = [];
			if (this.filter_agree.load_locations == 'All Load Locations') {
				result2 = result1;
			} else {
				result2 = result1.filter(function (item) {
					return item.load_locations == _this.filter_agree.load_locations;
				});
			}
			var result3 = [];
			if (this.filter_agree.unload_locations == 'All Unload Locations') {
				result3 = result2;
			} else {
				result3 = result2.filter(function (item) {
					var ok = false;
					if (item.unload_locations.indexOf(_this.filter_agree.unload_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result4 = [];
			if (this.filter_agree.truck_types == 'All Truck Types') {
				result4 = result3;
			} else {
				result4 = result3.filter(function (item) {
					var ok = false;
					if (item.truck_types.indexOf(_this.filter_agree.truck_types_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			this.items = result4;
			this.filters_agree_update();
		},
		ecFilter: function ecFilter(ec_filter, id) {
			var _this2 = this;

			this.filter_agree.energy_company = ec_filter;
			var result = [];
			if (this.filter_agree.energy_company == 'All Energy Companies') {
				result = this.itemsO;
			} else {
				result = this.itemsO.filter(function (item) {
					return item.energy_company == _this2.filter_agree.energy_company;
				});
			}
			var result1 = [];
			if (this.filter_agree.trucking_company === 'All Trucking Companies') {
				result1 = result;
			} else {
				result1 = result.filter(function (item) {
					return item.trucking_company == _this2.filter_agree.trucking_company;
				});
			}
			var result2 = [];
			if (this.filter_agree.load_locations == 'All Load Locations') {
				result2 = result1;
			} else {
				result2 = result1.filter(function (item) {
					var ok = false;
					if (item.load_locations.indexOf(_this2.filter_agree.load_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result3 = [];
			if (this.filter_agree.unload_locations == 'All Unload Locations') {
				result3 = result2;
			} else {
				result3 = result2.filter(function (item) {
					var ok = false;
					if (item.unload_locations.indexOf(_this2.filter_agree.unload_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result4 = [];
			if (this.filter_agree.truck_types == 'All Truck Types') {
				result4 = result3;
			} else {
				result4 = result3.filter(function (item) {
					var ok = false;
					if (item.truck_types.indexOf(_this2.filter_agree.truck_types_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			this.items = result4;
			this.filters_agree_update();
		},
		lFilter: function lFilter(ul_filter, id) {
			var _this3 = this;

			this.filter_agree.load_locations = ul_filter;
			this.filter_agree.load_locations_id = id;
			var result = [];
			if (this.filter_agree.load_locations == 'All Load Locations') {
				result = this.itemsO;
			} else {
				result = this.itemsO.filter(function (item) {
					var ok = false;
					if (item.load_locations.indexOf(_this3.filter_agree.load_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result1 = [];
			if (this.filter_agree.trucking_company === 'All Trucking Companies') {
				result1 = result;
			} else {
				result1 = result.filter(function (item) {
					return item.trucking_company == _this3.filter_agree.trucking_company;
				});
			}
			var result2 = [];
			if (this.filter_agree.energy_company == 'All Energy Companies') {
				result2 = result1;
			} else {
				result2 = result1.filter(function (item) {
					return item.energy_company == _this3.filter_agree.energy_company;
				});
			}
			var result3 = [];
			if (this.filter_agree.unload_locations == 'All Unload Locations') {
				result3 = result2;
			} else {
				result3 = result2.filter(function (item) {
					var ok = false;
					if (item.unload_locations.indexOf(_this3.filter_agree.unload_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result4 = [];
			if (this.filter_agree.truck_types == 'All Truck Types') {
				result4 = result3;
			} else {
				result4 = result3.filter(function (item) {
					var ok = false;
					if (item.truck_types.indexOf(_this3.filter_agree.truck_types_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			this.items = result4;
			this.filters_agree_update();
		},
		uFilter: function uFilter(ul_filter, id) {
			var _this4 = this;

			this.filter_agree.unload_locations = ul_filter;
			this.filter_agree.unload_locations_id = id;
			var result = [];
			if (this.filter_agree.unload_locations == 'All Unload Locations') {
				result = this.itemsO;
			} else {
				result = this.itemsO.filter(function (item) {
					var ok = false;
					if (item.unload_locations.indexOf(_this4.filter_agree.unload_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result1 = [];
			if (this.filter_agree.trucking_company === 'All Trucking Companies') {
				result1 = result;
			} else {
				result1 = result.filter(function (item) {
					return item.trucking_company == _this4.filter_agree.trucking_company;
				});
			}
			var result2 = [];
			if (this.filter_agree.energy_company == 'All Energy Companies') {
				result2 = result1;
			} else {
				result2 = result1.filter(function (item) {
					return item.energy_company == _this4.filter_agree.energy_company;
				});
			}
			var result3 = [];
			if (this.filter_agree.load_locations == 'All Load Locations') {
				result3 = result2;
			} else {
				result3 = result2.filter(function (item) {
					var ok = false;
					if (item.load_locations.indexOf(_this4.filter_agree.load_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result4 = [];
			if (this.filter_agree.truck_types == 'All Truck Types') {
				result4 = result3;
			} else {
				result4 = result3.filter(function (item) {
					var ok = false;
					if (item.truck_types.indexOf(_this4.filter_agree.truck_types_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			this.items = result4;
			this.filters_agree_update();
		},
		filters_init: function filters_init() {
			var _this5 = this;

			var result = [];
			if (this.filter_agree.truck_types == 'All Truck Types') {
				result = this.itemsO;
			} else {
				result = this.itemsO.filter(function (item) {
					var ok = false;
					if (item.truck_types.indexOf(_this5.filter_agree.truck_types_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result1 = [];
			if (this.filter_agree.trucking_company === 'All Trucking Companies') {
				result1 = result;
			} else {
				result1 = result.filter(function (item) {
					return item.trucking_company == _this5.filter_agree.trucking_company;
				});
			}

			var result2 = [];
			if (this.filter_agree.energy_company == 'All Energy Companies') {
				result2 = result1;
			} else {
				result2 = result1.filter(function (item) {
					return item.energy_company == _this5.filter_agree.energy_company;
				});
			}
			var result3 = [];
			if (this.filter_agree.load_locations == 'All Load Locations') {
				result3 = result2;
			} else {
				result3 = result2.filter(function (item) {
					var ok = false;
					if (item.load_locations.indexOf(_this5.filter_agree.load_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result4 = [];
			if (this.filter_agree.unload_locations == 'All Unload Locations') {
				result4 = result3;
			} else {
				result4 = result3.filter(function (item) {
					var ok = false;
					if (item.unload_locations.indexOf(_this5.filter_agree.unload_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			this.items = result4;
		},
		ttFilter: function ttFilter(ul_filter, id) {
			var _this6 = this;

			this.filter_agree.truck_types = ul_filter;
			this.filter_agree.truck_types_id = id;
			var result = [];
			if (this.filter_agree.truck_types == 'All Truck Types') {
				result = this.itemsO;
			} else {
				result = this.itemsO.filter(function (item) {
					var ok = false;
					if (item.truck_types.indexOf(_this6.filter_agree.truck_types_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result1 = [];
			if (this.filter_agree.trucking_company === 'All Trucking Companies') {
				result1 = result;
			} else {
				result1 = result.filter(function (item) {
					return item.trucking_company == _this6.filter_agree.trucking_company;
				});
			}
			var result2 = [];
			if (this.filter_agree.energy_company == 'All Energy Companies') {
				result2 = result1;
			} else {
				result2 = result1.filter(function (item) {
					return item.energy_company == _this6.filter_agree.energy_company;
				});
			}
			var result3 = [];
			if (this.filter_agree.load_locations == 'All Load Locations') {
				result3 = result2;
			} else {
				result3 = result2.filter(function (item) {
					var ok = false;
					if (item.load_locations.indexOf(_this6.filter_agree.load_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			var result4 = [];
			if (this.filter_agree.unload_locations == 'All Unload Locations') {
				result4 = result3;
			} else {
				result4 = result3.filter(function (item) {
					var ok = false;
					if (item.unload_locations.indexOf(_this6.filter_agree.unload_locations_id) > -1) {
						ok = true;
					};return ok;
				});
			}
			this.items = result4;
			this.filters_agree_update();
		},
		trucktypesChange: function trucktypesChange() {
			if (this.role == 'super_admin') {
				if (this.model.truck_type_id.length === 0) {
					this.indeterminateTT = false;
					this.ttAllSelected = false;
				} else if (this.model.truck_type_id.length === this.truckTypes.length) {
					this.indeterminateTT = false;
					this.ttAllSelected = true;
				} else {
					this.indeterminateTT = true;
					this.ttAllSelected = false;
				}
			}
		},
		ttToggleAll: function ttToggleAll(checked) {
			this.model.truck_type_id = checked ? this.truckTypes.map(function (item) {
				return item.id;
			}) : [];
		},
		loadLocationsChange: function loadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		LLToggleAll: function LLToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		unloadLocationsChange: function unloadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false;
					this.ulAllSelected = false;
				} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
					this.indeterminateUL = false;
					this.ulAllSelected = true;
				} else {
					this.indeterminateUL = true;
					this.ulAllSelected = false;
				}
			}
		},
		ULToggleAll: function ULToggleAll(checked) {
			this.model.unload_locations_id = checked ? this.unloadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		select_energy_companies: function select_energy_companies() {

			this.truckTypes = [];
			this.indeterminateUL = false;
			this.ulAllSelected = false;
			this.indeterminateLL = false;
			this.llAllSelected = false;
			this.model.unload_locations_id = [];
			this.model.load_locations_id = [];

			var energycompanies = this.insert_data.energy_companies;
			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				this.loadlocationselect = energycompanies[energy_company_index]['load_locations'];
				this.unloadlocationselect = energycompanies[energy_company_index]['unload_locations'];
				var trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
				this.truckingCompanies = trucking_companies.map(function (item) {
					return { 'value': item.id, 'text': item.name };
				});

				if (this.truckingCompanies.length == 1) {
					this.model.trucking_company_id = this.truckingCompanies[0].value;

					var _trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
					var trucking_company_index = _trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.model.trucking_company_id);
					if (trucking_company_index > -1) {
						var truck_types = _trucking_companies[trucking_company_index]['truck_types'];
						this.truckTypes = truck_types;
					}
				} else {
					this.model.trucking_company_id = null;
				}
			}
		},
		select_trucking_companies: function select_trucking_companies() {

			this.indeterminateTT = false;
			this.ttAllSelected = false;
			this.model.truck_type_id = [];
			if (this.role == 'super_admin') {
				var energycompanies = this.insert_data.energy_companies;
				var energy_company_index = energycompanies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
					var trucking_company_index = trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.model.trucking_company_id);
					if (trucking_company_index > -1) {
						var truck_types = trucking_companies[trucking_company_index]['truck_types'];
						this.truckTypes = truck_types;
					}
				}
			} else if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				var _trucking_companies2 = this.insert_data.energy_companies[0].trucking_companies;
				var _trucking_company_index = _trucking_companies2.map(function (o) {
					return o.id;
				}).indexOf(this.model.trucking_company_id);
				if (_trucking_company_index > -1) {
					var _truck_types = _trucking_companies2[_trucking_company_index]['truck_types'];
					this.truckTypes = _truck_types;
				}
			}
		},
		rowClicked: function rowClicked(row) {
			if (!this.trash) {
				this.$router.push('/agreement/' + row.id + '/');
			} else {
				this.restoreAgreement(row.id);
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		reload: function reload() {
			this.getAll();
		},
		info: function info(item, index, button) {
			this.modalInfo.title = 'Row: ' + (index + 1);
			this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
			this.$root.$emit('bv::show::modal', 'modalInfo', button);
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		resetNewModal: function resetNewModal() {
			this.initialDate = '';
			this.endDate = '';
			this.rate = '';
			this.chain_up_rate = '';
			this.selectedChargeType = '';
			this.selectedTruckingC = '';
			this.selectedEnergyC = '';
			this.selectedtruckTypesC = '';
		},
		showNewModal: function showNewModal() {
			this.model = {
				id: null,
				energy_company_id: null,
				trucking_company_id: null,
				initial_date: null,
				end_date: null,
				regular_charge_id: null,
				regular_rate: null,
				stb_charge_id: null,
				stb_rate: null,
				worktime_charge_id: null,
				worktime_rate: null,
				chain_up_rate: null,
				truck_type_id: [],
				unload_locations_id: [],
				load_locations_id: [],
				located_based: 'false',
				rounding: 'false',
				wait_time_discount: 'false',
				fluid_based: 'false',
				fluid_types_id: [],
				fluid_types: []
			};
			if (this.role == 'super_admin') {
				this.truckingCompanies = [];
			}
			this.truckTypes = [];
			this.indeterminateUL = false;
			this.ulAllSelected = false;
			this.indeterminateLL = false;
			this.llAllSelected = false;
			this.indeterminateTT = false;
			this.ttAllSelected = false;
			this.savebtn = false;
			this.newAgreements = true;
			this.indeterminateFT = false;
			this.ftAllSelected = false;
		},
		cancelNew: function cancelNew() {
			this.$refs.newAgreements.hide();
		},
		goTo: function goTo(item) {
			this.$router.push('/users/' + item.id);
		},
		trashAgreement: function trashAgreement() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		getAll: function getAll() {
			var _this7 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					if (data[2]) {
						_this7.insert_data = data[2];
						_this7.energy_companies_filter = _this7.insert_data.energy_companies;
						_this7.trucking_companies_filter = _this7.insert_data.trucking_companies_filter;
						_this7.unload_locations_filter = _this7.insert_data.locations_unload;
						_this7.load_locations_filter = _this7.insert_data.locations_load;
						_this7.truck_types_filter = _this7.insert_data.truck_types_filter;
						_this7.filter_agree = _this7.insert_data.filters;

						_this7.fluidtypeselect = _this7.insert_data.fluid_types;
						if (_this7.insert_data.charge_types.length > 0) {
							_this7.chargeTypes = _this7.insert_data.charge_types.map(function (item) {
								return { text: item.name, value: item.id };
							});
						} else {
							_this7.chargeTypes = [];
						}

						_this7.role = data[3];
						if (_this7.role == 'super_admin') {
							_this7.energyCompanies = _this7.insert_data.energy_companies.map(function (item) {
								return { text: item.company_name, value: item.id };
							});
						} else if (_this7.role == 'super_analyst' || _this7.role == 'analyst' || _this7.role == 'marketing_accountant') {
							_this7.energy_company_iidd = data[4];
							var trucking_companies = _this7.insert_data.energy_companies[0].trucking_companies;
							_this7.truckingCompanies = trucking_companies.map(function (item) {
								return { 'value': item.id, 'text': item.name };
							});
							_this7.loadlocationselect = _this7.insert_data.energy_companies[0].load_locations;
							_this7.unloadlocationselect = _this7.insert_data.energy_companies[0].unload_locations;
						}
					}
					_this7.items = data[1].filter(function (o) {
						return o.status_id == (_this7.trash ? 2 : 1);
					});
					_this7.itemsO = _this7.items;
					_this7.filters_init();
				} else {
					_this7.items = [];
					_this7.itemsO = _this7.items;
					_this7.$swal(data[0], data[1], data[0]);
				}
				_this7.loadingData = false;
			}).catch(function (error) {
				_this7.$swal('Error', 'Server not response. ' + error, 'error');
				_this7.loadingData = false;
			});
		},
		saveAgreements: function saveAgreements() {
			var _this8 = this;

			if (this.selectedCostType == 2) {
				this.chain_up_rate = 0;
			}
			if (!this.okToSave()) {
				return;
			}
			this.savebtn = true;
			if (this.role == 'super_admin') {
				this.energy_company_iidd = this.model.energy_company_id;
			} else if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_iidd;
			}
			if (this.model.fluid_based == 'true') {
				var fluid_types_id = this.model.fluid_types_id;
				var new_fluid_types = [];
				var index = -1;
				fluid_types_id.forEach(function (e) {
					if (_this8.fluidtypeselect.length != 0) {
						index = _this8.fluidtypeselect.map(function (o) {
							return o.id;
						}).indexOf(e);
						if (index > -1) {
							new_fluid_types.push(_this8.fluidtypeselect[index]);
						}
					}
				});
				this.model.fluid_types = new_fluid_types;
			}

			__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].verify(this.model).then(function (data) {
				if (data[0] == 'success') {
					__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].save(_this8.model).then(function (data) {
						_this8.$swal(data[0], data[1], data[0]).then(function (result) {
							if (data[0] == 'success') {
								_this8.newAgreements = false;
								_this8.getAll();
							}
						});
					}).catch(function (error) {
						_this8.$swal('Error', 'Server not response. ' + error, 'error');
					});
				} else {
					if (data[2].length > 0) {
						_this8.$swal({
							title: 'Please, confirm',
							text: "Hauls with contracts. Would you like assign them to this agreement?",
							type: 'question',
							showCancelButton: true,
							confirmButtonColor: '#3085d6',
							cancelButtonColor: '#d33',
							confirmButtonText: 'Yes',
							reverseButtons: true
						}).then(function (result) {
							if (result.value) {
								__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].save(_this8.model).then(function (data) {
									_this8.$swal(data[0], data[1], data[0]);
									if (data[0] == 'success') {
										_this8.newAgreements = false;
										_this8.getAll();
									}
								}).catch(function (error) {
									_this8.$swal('Error', 'Server not response. ' + error, 'error');
								});
							}
						});
						console.log('Hauls with contracts');
					} else {
						_this8.$swal(data[0], data[1], data[0]);
					}
				}
			}).catch(function (error) {
				_this8.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = false;
		},
		restoreAgreement: function restoreAgreement(id) {
			var _this9 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Agreement?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].restore(id).then(function (data) {
						_this9.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this9.filter = '';
							_this9.trash = false;
							_this9.getAll();
							_this9.loadingData = true;
						}
					}).catch(function (error) {
						_this9.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		okToSave: function okToSave() {

			if (this.role == 'super_admin') {
				if (this.model.energy_company_id == null) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}

			if (this.model.initial_date === undefined || this.model.initial_date == null) {
				this.$swal('Alert!', 'Initial Date not selected', 'warning');
				return false;
			} else if (this.model.end_date === undefined || this.model.end_date == null) {
				this.$swal('Alert!', 'End Date not selected', 'warning');
				return false;
			} else if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
				this.$swal('Alert!', 'Trucking Company not selected', 'warning');
				return false;
			} else if (this.model.regular_charge_id === undefined || this.model.regular_charge_id == null) {
				this.$swal('Alert!', 'Regular Charge Type not selected', 'warning');
				return false;
			} else if (this.model.regular_rate === undefined || this.model.regular_rate == null || this.model.regular_rate == '') {
				this.$swal('Alert!', 'Regular Rate can not be empty', 'warning');
				return false;
			} else if (this.model.truck_type_id.length == 0) {
				this.$swal('Alert!', 'Truck Types not selected', 'warning');
				return false;
			} else if (this.model.stb_charge_id === undefined || this.model.stb_charge_id == null) {
				this.$swal('Alert!', 'Standby Time Charge Type not selected', 'warning');
				return false;
			} else if (this.model.stb_rate === undefined || this.model.stb_rate == null || this.model.stb_rate == '') {
				this.$swal('Alert!', 'Standby Time Rate can not be empty', 'warning');
				return false;
			} else if (this.model.worktime_charge_id === undefined || this.model.worktime_charge_id == null) {
				this.$swal('Alert!', 'Worktime Charge Type not selected', 'warning');
				return false;
			} else if (this.model.worktime_rate === undefined || this.model.worktime_rate == null || this.model.worktime_rate == '') {
				this.$swal('Alert!', 'Worktime Rate can not be empty', 'warning');
				return false;
			} else if (this.model.located_based == 'true' && this.model.load_locations_id.length == 0) {
				this.$swal('Alert!', 'Load Location not selected', 'warning');
				return false;
			} else if (this.model.located_based == 'true' && this.model.unload_locations_id.length == 0) {
				this.$swal('Alert!', 'Unload Location not selected', 'warning');
				return false;
			} else if (this.model.fluid_based == 'true' && this.model.fluid_types_id.length == 0) {
				this.$swal('Alert!', 'Fluid Types not selected', 'warning');
				return false;
			}

			return true;
		},
		editItemMdoule: function editItemMdoule(item) {
			alert(item.id);
		},
		deleteItemMdoule: function deleteItemMdoule(item) {
			alert(item.id);
		},
		filters_agree_update: function filters_agree_update() {
			var _this10 = this;

			__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].filters_agree(this.filter_agree).then(function (data) {
				if (data[0] == 'success') {
					console.log('filters updated');
				} else {
					_this10.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this10.$swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		FTToggleAll: function FTToggleAll(checked) {
			this.model.fluid_types_id = checked ? this.fluidtypeselect.map(function (item) {
				return item.id;
			}) : [];
		},
		fluidtypesChange: function fluidtypesChange() {
			if (this.model.fluid_types_id.length === 0) {
				this.indeterminateFT = false;
				this.ftAllSelected = false;
			} else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
				this.indeterminateFT = false;
				this.ftAllSelected = true;
			} else {
				this.indeterminateFT = true;
				this.ftAllSelected = false;
			}
		}
	}
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__agreements_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
				name: 'agreements_pending',
				created: function created() {
								this.getAll();
				},
				data: function data() {
								return {
												items: items,
												loadingData: true,
												currentPage: 1,
												perPage: 25,
												totalRows: items.length,
												pageOptions: [25, 50, 100],
												configTable: false,
												sortBy: 'haul_last_date',
												sortDesc: true,
												filter: null,

												fields: [{ key: 'id', label: 'ID', sortable: true }, { key: 'trucking_company', label: 'Trucking Company', sortable: true }, { key: 'energy_company', label: 'Energy Company', sortable: true }, { key: 'truck_type', label: 'Truck Type', sortable: true }, { key: 'load_location', label: 'Load Location', sortable: true }, { key: 'unload_location', label: 'Unload Location', sortable: true }, { key: 'total', label: 'Hauls', sortable: true }, { key: 'haul_last_date', label: 'Haul Last Date', sortable: true }],
												role: '',
												energy_company_id: null

								};
				},

				computed: {
								sortOptions: function sortOptions() {
												return this.fieldsTh.filter(function (f) {
																return f.sortable;
												}).map(function (f) {
																return { text: f.label, value: f.key };
												});
								}
				},
				methods: {
								onFiltered: function onFiltered(filteredItems) {
												this.totalRows = filteredItems.length;
												this.currentPage = 1;
								},
								create_a: function create_a(item, index) {
												this.re_item = item;
								},
								rowClicked: function rowClicked(row) {
												console.log('go');
												this.$router.push('/agreement_pending_detail/' + row.id);
								},
								getAll: function getAll() {
												var _this = this;

												this.loadingData = true;
												__WEBPACK_IMPORTED_MODULE_1__agreements_service__["a" /* default */].getAllPending().then(function (data) {
																if (data.status == 'success') {
																				_this.items = data.hauls_pending;
																				_this.role = data.role;
																				console.log(_this.items);
																} else {
																				_this.items = [];
																				_this.$swal(data.status, data.message, data.status);
																}
																_this.loadingData = false;
												}).catch(function (error) {
																_this.$swal('Error', 'Server not response. ' + error, 'error');
																_this.loadingData = false;
												});
								}
				}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__agreements_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__m_targets_targets__ = __webpack_require__(93);










__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_location',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getAgreementData();
	},
	data: function data() {
		return {
			rate: '',
			chain_up_rate: '',
			chargeTypes: [],
			energyCompanies: [],
			truckingCompanies: [],
			originalData: null,
			updateDate: null,
			edit: false,
			subTitle: "",
			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			role: '',
			view: true,
			energy_company_iidd: null,
			model: {
				id: null,
				energy_company: '',
				energy_company_id: null,
				trucking_company: '',
				trucking_company_id: null,
				initial_date: null,
				end_date: null,
				regular_charge: '',
				regular_charge_id: null,
				regular_rate: null,
				stb_charge_id: null,
				stb_rate: null,
				worktime_charge_id: null,
				worktime_rate: null,
				chain_up_rate: null,
				truck_types: [],
				truck_type_id: [],
				unload_locations_id: [],
				load_locations_id: [],
				load_locations: [],
				unload_locations: [],
				hauls: [],
				located_based: 'false',
				rounding: 'false',
				wait_time_discount: 'false',
				fluid_based: 'false',
				fluid_types_id: [],
				fluid_types: []
			},
			options: [{ text: 'Yes', value: 'true' }, { text: 'No', value: 'false' }],
			truckTypes: [],
			indeterminateTT: false,
			ttAllSelected: false,
			loadlocationselect: [],
			indeterminateLL: false,
			llAllSelected: false,
			unloadlocationselect: [],
			indeterminateUL: false,
			ulAllSelected: false,
			fluidtypeselect: [],
			indeterminateFT: false,
			ftAllSelected: false
		};
	},

	methods: {
		unloadLocationsChange: function unloadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false;
					this.ulAllSelected = false;
				} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
					this.indeterminateUL = false;
					this.ulAllSelected = true;
				} else {
					this.indeterminateUL = true;
					this.ulAllSelected = false;
				}
			}
		},
		ulToggleAll: function ulToggleAll(checked) {
			this.model.unload_locations_id = checked ? this.unloadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		loadLocationsChange: function loadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		llToggleAll: function llToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		trucktypesChange: function trucktypesChange() {
			if (this.role == 'super_admin') {
				if (this.model.truck_type_id.length === 0) {
					this.indeterminateTT = false;
					this.ttAllSelected = false;
				} else if (this.model.truck_type_id.length === this.truckTypes.length) {
					this.indeterminateTT = false;
					this.ttAllSelected = true;
				} else {
					this.indeterminateTT = true;
					this.ttAllSelected = false;
				}
			}
		},
		ttToggleAll: function ttToggleAll(checked) {
			this.model.truck_type_id = checked ? this.truckTypes.map(function (item) {
				return item.id;
			}) : [];
		},
		select_energy_companies: function select_energy_companies() {
			this.truckTypes = [];
			this.indeterminateLL = false;
			this.llAllSelected = false;
			this.model.load_locations_id = [];
			var energycompanies = this.updateDate.energy_companies;
			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				this.loadlocationselect = energycompanies[energy_company_index]['load_locations'];
				this.unloadlocationselect = energycompanies[energy_company_index]['unload_locations'];
				var trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
				this.truckingCompanies = trucking_companies;

				if (this.truckingCompanies.length == 1) {
					this.model.trucking_company_id = this.truckingCompanies[0].id;
					var _trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
					var trucking_company_index = _trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.model.trucking_company_id);
					if (trucking_company_index > -1) {
						var truck_types = _trucking_companies[trucking_company_index]['truck_types'];
						this.truckTypes = truck_types;
					}
				} else {
					this.model.trucking_company_id = null;
				}
			}
		},
		select_trucking_companies: function select_trucking_companies() {
			this.indeterminateTT = false;
			this.ttAllSelected = false;
			this.model.truck_type_id = [];
			var energycompanies = this.updateDate.energy_companies;
			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				var trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
				var trucking_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.trucking_company_id);
				if (trucking_company_index > -1) {
					var truck_types = trucking_companies[trucking_company_index]['truck_types'];
					this.truckTypes = truck_types;
				}
			}
		},
		setupFields: function setupFields() {
			var chargetypes = this.updateDate.charge_types;
			this.chargeTypes = chargetypes;

			var energycompanies = this.updateDate.energy_companies;
			this.energyCompanies = energycompanies;

			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				this.loadlocationselect = energycompanies[energy_company_index]['load_locations'];
				this.unloadlocationselect = energycompanies[energy_company_index]['unload_locations'];
				var trucking_companies = energycompanies[energy_company_index]['trucking_companies'];
				this.truckingCompanies = trucking_companies;

				var trucking_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.trucking_company_id);
				if (trucking_company_index > -1) {
					var truck_types = trucking_companies[trucking_company_index]['truck_types'];
					this.truckTypes = truck_types;
				}
			}
			this.model.truck_type_id = this.model.truck_types.map(function (item) {
				return item.id;
			});
			this.trucktypesChange();
			this.model.load_locations_id = this.model.load_locations.map(function (item) {
				return item.id;
			});
			this.loadLocationsChange();
			this.model.unload_locations_id = this.model.unload_locations.map(function (item) {
				return item.id;
			});
			this.unloadLocationsChange();
			this.fluidtypesChange();
		},
		editAgreement: function editAgreement() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {

			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
		},
		okToUpdate: function okToUpdate() {
			if (this.role == 'super_admin') {
				if (this.model.energy_company_id == null) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.initial_date === undefined || this.model.initial_date == null) {
				this.$swal('Alert!', 'Initial Date not selected', 'warning');
				return false;
			} else if (this.model.end_date === undefined || this.model.end_date == null) {
				this.$swal('Alert!', 'End Date not selected', 'warning');
				return false;
			} else if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
				this.$swal('Alert!', 'Trucking Company not selected', 'warning');
				return false;
			} else if (this.model.regular_charge_id === undefined || this.model.regular_charge_id == null) {
				this.$swal('Alert!', 'Regular Charge Type not selected', 'warning');
				return false;
			} else if (this.model.regular_rate === undefined || this.model.regular_rate == null || this.model.regular_rate == '') {
				this.$swal('Alert!', 'Regular Rate can not be empty', 'warning');
				return false;
			} else if (this.model.truck_type_id.length == 0) {
				this.$swal('Alert!', 'Truck Types not selected', 'warning');
				return false;
			} else if (this.model.stb_charge_id === undefined || this.model.stb_charge_id == null) {
				this.$swal('Alert!', 'Standby Time Charge Type not selected', 'warning');
				return false;
			} else if (this.model.stb_rate === undefined || this.model.stb_rate == null || this.model.stb_rate == '') {
				this.$swal('Alert!', 'Standby Time Rate can not be empty', 'warning');
				return false;
			} else if (this.model.worktime_charge_id === undefined || this.model.worktime_charge_id == null) {
				this.$swal('Alert!', 'Worktime Charge Type not selected', 'warning');
				return false;
			} else if (this.model.worktime_rate === undefined || this.model.worktime_rate == null || this.model.worktime_rate == '') {
				this.$swal('Alert!', 'Worktime Rate can not be empty', 'warning');
				return false;
			} else if (this.model.located_based == 'true' && this.model.load_locations_id.length == 0) {
				this.$swal('Alert!', 'Load Location not selected', 'warning');
				return false;
			} else if (this.model.located_based == 'true' && this.model.unload_locations_id.length == 0) {
				this.$swal('Alert!', 'Unload Location not selected', 'warning');
				return false;
			} else if (this.model.fluid_based == 'true' && this.model.fluid_types_id.length == 0) {
				this.$swal('Alert!', 'Fluid Types not selected', 'warning');
				return false;
			}
			return true;
		},
		updateAgreement: function updateAgreement() {
			var _this = this;

			if (!this.okToUpdate()) {
				return;
			}
			if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_iidd;
			}
			if (this.model.fluid_based == 'true') {
				var fluid_types_id = this.model.fluid_types_id;
				var new_fluid_types = [];
				var index = -1;
				fluid_types_id.forEach(function (e) {
					if (_this.fluidtypeselect.length != 0) {
						index = _this.fluidtypeselect.map(function (o) {
							return o.id;
						}).indexOf(e);
						if (index > -1) {
							new_fluid_types.push(_this.fluidtypeselect[index]);
						}
					}
				});
				this.model.fluid_types = new_fluid_types;
			}
			__WEBPACK_IMPORTED_MODULE_6__agreements_service__["a" /* default */].update(this.model.id, this.model).then(function (data) {
				_this.$swal(data[0], data[1], data[0]).then(function (result) {
					if (data[0] == 'success') {
						_this.getAgreementData();
						_this.edit = false;
					}
				});
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		deleteAgreement: function deleteAgreement() {
			var _this2 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Agreement: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_6__agreements_service__["a" /* default */].delete(_this2.id, _this2.model.hauls).then(function (data) {
						_this2.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this2.$router.replace('/agreements');
						}
					}).catch(function (error) {
						_this2.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
			this.edit = false;
		},
		getAgreementData: function getAgreementData() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_6__agreements_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] == 'success') {
					_this3.originalData = data[1];
					_this3.updateDate = data[2];

					_this3.fluidtypeselect = _this3.updateDate.fluid_types;
					_this3.restoreOriginalData();
					_this3.subTitle = _this3.originalData.energy_company;
					_this3.found = true;
					_this3.loadingData = false;
					_this3.role = data[3];
					if (_this3.role == 'super_admin') {
						_this3.view = true;
					} else if (_this3.role == 'super_analyst' || _this3.role == 'analyst' || _this3.role == 'marketing_accountant') {
						_this3.view = false;
						_this3.energy_company_iidd = data[4];
					}
				} else {
					_this3.$swal(data[0], data[1], data[0]);
					_this3.loadingData = false;
				}
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
				_this3.loadingData = false;
			});
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this.model[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.model[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		ftToggleAll: function ftToggleAll(checked) {
			this.model.fluid_types_id = checked ? this.fluidtypeselect.map(function (item) {
				return item.id;
			}) : [];
		},
		fluidtypesChange: function fluidtypesChange() {
			if (this.model.fluid_types_id.length === 0) {
				this.indeterminateFT = false;
				this.ftAllSelected = false;
			} else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
				this.indeterminateFT = false;
				this.ftAllSelected = true;
			} else {
				this.indeterminateFT = true;
				this.ftAllSelected = false;
			}
		}
	}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locations_service__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__energy_companies_ec_service__ = __webpack_require__(53);







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_locations',
	created: function created() {
		this.getAll();
		localStorage.removeItem("haulsaPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("servicePage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("taPage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("userPage");
		if (!localStorage.locationPage) {
			localStorage.locationPage = 0;
		}
	},
	data: function data() {
		return {
			isSuperAnalyst: false,
			trash: false,
			dpdt: "Active",
			indeterminateOA: false,
			indeterminate: false,
			oaAllSelected: false,
			fluidAllSelected: false,
			insert_data: null,
			newLocations: false,
			items: [],
			loadingData: true,
			currentPage: parseInt(localStorage.locationPage),
			perPage: 25,
			totalRows: 0,
			pageOptions: [25, 50, 100],
			sortBy: 'legal_location',
			sortDesc: false,
			fields: [{
				key: 'id',
				label: 'ID',
				sortable: true
			}, {
				key: 'legal_location',
				label: 'Location Name',
				sortable: true
			}, {
				key: 'lsd',
				label: 'LSD',
				sortable: true
			}, {
				key: 'latitude',
				label: 'Latitude'
			}, {
				key: 'longitude',
				label: 'Longitude'
			}, {
				key: 'location_type',
				label: 'Location Type',
				sortable: true
			}],
			filter: null,
			configTable: false,
			selectedItems: ['id', 'name', 'status'],
			locationselect: [],
			energycompanyselect: [],
			fluidtypeselect: [],
			operationareaselect: [],
			location_type_name: '',
			model: {
				id: null,
				legal_location: '',
				longitude: '',
				latitude: '',
				location_types_id: '',
				fluid_type_id: [],
				energy_company_id: '',
				energy_company_name: '',
				operation_area_id: [],
				lsd: '',
				alldrivers: 'not_accepted',

				company_type: false,
				trucking_company_id: [],
				invoice_code: '',
				uwi: [],
				contact_name: '',

				isolera_location_name: '',
				battery_code: '',
				terminal_code: '',
				terminal_id: null,
				agreement_id: []
			},

			zoom: 10,
			mapTypeId: 'roadmap',
			center: {
				"lat": 50.995457775379,
				"lng": -113.97837946982
			},
			start: null,
			role: '',
			view: true,
			view1: true,
			savebtn: true,
			energy_company_id: null,

			truckingcompanyselect: [],
			truckingcompanyAllSelected: false,
			terminalselect: [],
			percentage: '',
			resp_al: [],
			resp_aall: [],

			agreements: [],
			indeterminateAgree: false,
			agreeAllSelected: false
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return {
					text: f.label,
					value: f.key
				};
			});
		}
	},
	mounted: function mounted() {
		this.geolocate();
	},

	methods: {
		coordsBlur: function coordsBlur(variableName) {
			if (this.model[variableName] !== undefined) {
				var x = String(this.model[variableName]).split(".");
				if (x.length == 1 && x[0].length == 0) {
					this.model[variableName] = '0.00';
				} else if (x.length == 1) {
					this.model[variableName] = this.model[variableName] + '.00';
				} else {
					this.model[variableName] = x[0] + "." + x[1];
					this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])));
				}
			}
		},
		clear: function clear() {
			if (this.model.company_type == true) {
				this.operationareaselect = [];
				this.agreements = [];
			} else {
				this.operationareaselect = this.resp_al;
				this.agreements = this.resp_aall;
			}

			this.model.operation_area_id = [];
			this.model.agreement_id = [];
			this.model.location_types_id = '';
			this.model.fluid_type_id = [];
			this.location_type_name = '';
			this.indeterminateAgree = false;
			this.agreeAllSelected = false;
		},
		trashLocation: function trashLocation() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? 'Trash' : 'Active';
			this.getAll();
			this.loadingData = true;
		},
		fluidToggleAll: function fluidToggleAll(checked) {
			this.model.fluid_type_id = checked ? this.fluidtypeselect.map(function (item) {
				return item.value;
			}) : [];
		},
		OAToggleAll: function OAToggleAll(checked) {
			this.model.operation_area_id = checked ? this.operationareaselect.map(function (item) {
				return item.value;
			}) : [];
		},
		fluidTypeChange: function fluidTypeChange() {
			if (this.model.fluid_type_id.length === 0) {
				this.indeterminate = false;
				this.fluidAllSelected = false;
			} else if (this.model.fluid_type_id.length === this.fluidtypeselect.length) {
				this.indeterminate = false;
				this.fluidAllSelected = true;
			} else {
				this.indeterminate = true;
				this.fluidAllSelected = false;
			}
		},
		truckingcompanyTypeChange: function truckingcompanyTypeChange() {
			if (this.model.trucking_company_id.length === 0) {
				this.indeterminate = false;
				this.truckingcompanyAllSelected = false;
			} else if (this.model.trucking_company_id.length === this.truckingcompanyselect.length) {
				this.indeterminate = false;
				this.truckingcompanyAllSelected = true;
			} else {
				this.indeterminate = true;
				this.truckingcompanyAllSelected = false;
			}
		},
		truckingcompanyToggleAll: function truckingcompanyToggleAll(checked) {
			this.model.trucking_company_id = checked ? this.truckingcompanyselect.map(function (item) {
				return item.value;
			}) : [];
		},
		operationAreaChange: function operationAreaChange() {
			if (this.model.operation_area_id.length === 0) {
				this.indeterminateOA = false;
				this.oaAllSelected = false;
			} else if (this.model.operation_area_id.length === this.operationareaselect.length) {
				this.indeterminateOA = false;
				this.oaAllSelected = true;
			} else {
				this.indeterminateOA = true;
				this.oaAllSelected = false;
			}
		},
		select_energy_company: function select_energy_company() {
			var energycompanies = this.insert_data.energy_companies;
			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				this.model.energy_company_name = energycompanies[energy_company_index].company_name;
				var operatingareas = energycompanies[energy_company_index].operating_areas;
				var agreements = energycompanies[energy_company_index].agreements;
				if (Array.isArray(operatingareas)) {
					this.operationareaselect = operatingareas.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
					this.model.operation_area_id = [];
					this.resp_al = this.operationareaselect;
					this.agreements = agreements;
					this.resp_aall = this.agreements;
				} else {
					this.operationareaselect = [];
					this.model.operation_area_id = [];
					this.resp_al = this.operationareaselect;
					this.agreements = [];
					this.resp_aall = this.agreements;
				}
			}
		},
		select_location_type: function select_location_type() {
			var location_types = this.insert_data.location_types;

			var current_location_type_index = location_types.map(function (o) {
				return o.id;
			}).indexOf(this.model.location_types_id);
			if (current_location_type_index > -1) {
				this.location_type_name = location_types[current_location_type_index].name;

				if (location_types[current_location_type_index].fluid_types) {
					var fluidtypes = location_types[current_location_type_index].fluid_types;
					this.fluidtypeselect = fluidtypes.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
				} else {
					this.fluidtypeselect = [];
					this.model.fluid_type_id = [];
				}
			}
		},
		rowClicked: function rowClicked(row) {
			localStorage.locationPage = this.currentPage;
			if (!this.trash) {
				localStorage.setItem('xyz', row.id);
				this.$router.push('/location/' + row.id + '/');
			} else {
				this.restoreLocation(row.id);
			}
		},
		clicked: function clicked(e) {
			this.start = {
				latLng: e.latLng
			};
			this.model.longitude = e.latLng.lng();
			this.model.latitude = e.latLng.lat();
		},
		geolocate: function geolocate() {
			var _this = this;

			navigator.geolocation.getCurrentPosition(function (position) {
				_this.center = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};
			});
		},
		actionField: function actionField(option) {
			var fieldsThLength = this.fieldsTh.length;
			var fieldIsActive = false;
			for (var i = 0; i <= fieldsThLength; i++) {
				fieldIsActive = true;
				try {
					if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
						this.fieldsTh.splice(i, 1);
						fieldIsActive = false;
						break;
					}
				} catch (err) {
					var position = this.fields.indexOf(option);
					this.fieldsTh.splice(position, 0, option);
				}
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			if (localStorage.getItem("locationPage") === null) {
				this.currentPage = 0;
				localStorage.setItem('locationPage', 0);
			} else {
				this.currentPage = parseInt(localStorage.locationPage);
			}
		},
		hideNewLocationModal: function hideNewLocationModal() {
			this.$refs.newLocationModal.hide();
		},
		showNewLocationModal: function showNewLocationModal() {
			var _model;

			this.savebtn = true;
			this.model = (_model = {
				legal_location: '',
				longitude: '',
				latitude: '',
				location_types_id: '',
				fluid_type_id: [],
				energy_company_id: '',
				energy_company_name: '',
				operation_area_id: [],
				lsd: '',
				terminal_code: '',
				alldrivers: 'not_accepted',

				company_type: false,
				trucking_company_id: [],
				invoice_code: '',
				uwi: [],
				contact_name: '',

				isolera_location_name: '',
				battery_code: ''
			}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_model, 'terminal_code', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_model, 'terminal_id', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_model, 'agreement_id', []), _model);

			this.fluidtypeselect = [];
			this.operationareaselect = [];
			this.newLocations = true;
			this.location_type_name = '';
			this.agreements = [];
			this.indeterminateAgree = false;
			this.agreeAllSelected = false;
			this.resp_aall = [];
			this.resp_al = [];

			if (this.role == 'operations_manager') {
				this.model.energy_company_id = this.energy_company_id;
				this.select_energy_company();
				this.operationareaselect = [];
			}
		},
		okToSave: function okToSave() {
			if (this.model.location_types_id === undefined || this.model.location_types_id.length == 0) {
				this.$swal('Alert!', 'Location Type not selected', 'warning');
				return false;
			} else if (this.model.legal_location === undefined || this.model.legal_location.length == 0) {
				this.$swal('Alert!', 'Location Name can not be empty', 'warning');
				return false;
			} else if (this.model.longitude === null || String(this.model.longitude).length == 0) {
				this.$swal('Alert!', 'Longitude can not be empty', 'warning');
				return false;
			} else if (this.model.latitude === null || String(this.model.latitude).length == 0) {
				this.$swal('Alert!', 'Latitude can not be empty', 'warning');
				return false;
			}

			if (this.model.uwi.length > 0) {
				var length = this.model.uwi.length;
				for (var i = 0; i < length; i++) {
					if (this.model.uwi[i].name == null || this.model.uwi[i].name == '') {
						this.$swal('Alert!', 'Uwi name cannot be empty', 'warning');
						return false;
					} else if (this.model.uwi[i].cost_code == null || this.model.uwi[i].cost_code == '') {
						this.$swal('Alert!', 'Uwi Cost Code cannot be empty', 'warning');
						return false;
					} else if (this.model.uwi[i].percentage == null || this.model.uwi[i].percentage == '') {
						this.$swal('Alert!', 'Uwi Percentage cannot be empty', 'warning');
						return false;
					}
				}
			}

			return true;
		},
		saveLocations: function saveLocations(model) {
			var _this2 = this;

			this.savebtn = false;
			if (!this.okToSave()) {
				this.savebtn = true;
				return;
			}
			model = {
				legal_location: model.legal_location,
				isolera_location_name: model.isolera_location_name,
				energy_company_id: model.energy_company_id,
				energy_company_name: model.energy_company_name,
				longitude: parseFloat(parseFloat(String(model.longitude))),
				latitude: parseFloat(parseFloat(String(model.latitude))),
				location_types_id: model.location_types_id,
				fluid_types: model.fluid_type_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				operating_areas: model.operation_area_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				lsd: model.lsd,
				terminal_id: model.terminal_id,
				terminal_code: model.terminal_code,
				battery_code: model.battery_code,
				alldrivers: model.alldrivers,

				company_type: model.company_type,
				trucking_companies: model.trucking_company_id,
				invoice_code: model.invoice_code,
				uwi: model.uwi,
				contact_name: model.contact_name,
				agreements: model.agreement_id.map(function (item) {
					return {
						id: String(item)
					};
				})
			};

			__WEBPACK_IMPORTED_MODULE_3__locations_service__["a" /* default */].save(model).then(function (data) {
				__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]);

				if (data[0] == 'success') {
					_this2.newLocations = false;
					_this2.start = null;
					_this2.getAll();
					_this2.savebtn = true;
				} else {
					_this2.savebtn = true;
				}
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				_this2.savebtn = true;
			});
		},
		getAll: function getAll() {
			var _this3 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_3__locations_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					_this3.items = data[1].filter(function (item) {
						return item.status_id == (!_this3.trash ? 1 : 2);
					});
					_this3.insert_data = data[2];
					var location = _this3.insert_data.location_types;
					_this3.locationselect = location.map(function (item) {
						return {
							'value': item.id,
							'text': item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
						};
					});

					var energycompanies = _this3.insert_data.energy_companies;
					console.log(energycompanies);
					_this3.energycompanyselect = energycompanies.map(function (item) {
						return {
							'value': item.id,
							'text': item.company_name
						};
					});

					var trucking_companies_map = _this3.insert_data.trucking_companies;
					if (trucking_companies_map.length != 0) {
						_this3.truckingcompanyselect = trucking_companies_map.map(function (item) {
							return {
								'value': item.id,
								'text': item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
							};
						});
					}
					_this3.terminalselect = _this3.insert_data.terminals;

					_this3.role = data[3];
					if (_this3.role == 'super_admin') {
						_this3.view = true;
						_this3.view1 = true;
					} else if (_this3.role == 'super_analyst') {
						_this3.energy_company_id = data[4];
						_this3.view = true;
						_this3.view1 = false;
					} else if (_this3.role == 'analyst' || _this3.role == 'marketing_accountant') {
						_this3.view = false;
						_this3.view1 = false;
					} else if (_this3.role == 'trucking_company_admin' || _this3.role == 'trucking_operational_manager') {
						_this3.view = false;
						_this3.view1 = false;
					} else if (_this3.role == 'operations_manager') {
						_this3.energy_company_id = data[4];
						_this3.view = false;
						_this3.view1 = false;
					}
				} else {
					_this3.locationselect = [];
					_this3.items = [];
					_this3.$swal(data[0], data[1], data[0]);
				}
				_this3.loadingData = false;
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
				_this3.loadingData = false;
			});
		},
		restoreLocation: function restoreLocation(id) {
			var _this4 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Location",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_3__locations_service__["a" /* default */].restore(id).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this4.filter = '';
							_this4.trash = false;
							_this4.dpdt = _this4.trash ? 'Trash' : 'Active';
							_this4.getAll();
							_this4.loadingData = true;
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		adduwi: function adduwi() {
			var uwi = {
				name: null,
				cost_code: null,
				percentage: null
			};
			this.model.uwi.push(uwi);
		},
		removeuwi: function removeuwi(uwi) {
			this.model.uwi.splice(uwi, 1);
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		agreeToggleAll: function agreeToggleAll(checked) {
			this.model.agreement_id = checked ? this.agreements.map(function (item) {
				return item.value;
			}) : [];
		},
		agreeChange: function agreeChange() {
			if (this.model.agreement_id.length === 0) {
				this.indeterminateAgree = false;
				this.agreeAllSelected = false;
			} else if (this.model.agreement_id.length === this.agreements.length) {
				this.indeterminateAgree = false;
				this.agreeAllSelected = true;
			} else {
				this.indeterminateAgree = true;
				this.agreeAllSelected = false;
			}
		}
	}
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locations_service__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__m_targets_targets__ = __webpack_require__(93);










__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_location',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		if (localStorage.getItem('role') == "super_analyst") {
			this.isSuperAnalyst = true;
		}
		this.getLocationData();
	},
	data: function data() {
		return {
			isSuperAnalyst: false,
			indeterminateOA: false,
			indeterminate: false,
			oaAllSelected: false,
			fluidAllSelected: false,
			location_type_name: '',

			locationselect: [],
			energycompanyselect: [],
			fluidtypeselect: [],
			operationareaselect: [],
			terminalselect: [],

			operatingAreasfields: {
				operating_area: {
					label: 'Operating Area Name'
				}
			},
			fluidTypesfields: {
				fluid_type: {
					label: 'Fluid Type Name'
				}
			},
			originalData: null,
			edit: false,
			subTitle: "",
			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			item: [],

			model: {
				id: null,
				legal_location: '',
				isolera_location_name: '',
				longitude: null,
				latitude: null,
				location_types_id: '',
				fluid_type_id: [],
				energy_company_id: '',
				energy_company: '',
				operation_area_id: [],
				lsd: '',
				energy_company_owned: false,
				battery_code: '',
				terminal_id: null,
				terminal: '',
				terminal_code: '',
				invoice_code: '',
				uwi: [],
				contact_name: '',
				agreement_id: [],
				petrotranz: null,
				filter: '' },
			filtered: '',
			items: items,
			options: [],
			fluids: [],
			operatingAreasItems: [],
			fluidTypesItems: [],
			role: '',
			view: true,
			view1: true,
			percentage: '',
			agreements: [],
			indeterminateAgree: false,
			agreeAllSelected: false,

			petrotranz: [],
			petrotranz_origin: [],
			model1: {
				petrotranz_company_id: { id: null, name: '' }
			},
			size: 6,
			offset: '',
			ready: false,
			suggest: true
		};
	},

	watch: {
		filtered: function filtered(val, oldVal) {
			this.petrotranz = [];
			this.model.filter = val;
			this.filter_p(this.model.filter);
		}
	},
	methods: {
		coordsBlur: function coordsBlur(variableName) {
			if (this.model[variableName] !== undefined) {
				var x = String(this.model[variableName]).split(".");
				if (x.length == 1 && x[0].length == 0) {
					this.model[variableName] = '0.00';
				} else if (x.length == 1) {
					this.model[variableName] = this.model[variableName] + '.00';
				} else {
					this.model[variableName] = x[0] + "." + x[1];
					this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])));
				}
			}
		},
		allChecked: function allChecked() {
			return Array(this.model.fluid_types.length).fill(true);
		},
		allCheckedOA: function allCheckedOA() {
			return Array(this.model.operating_areas.length).fill(true);
		},
		fluidToggleAll: function fluidToggleAll(checked) {
			this.model.fluid_type_id = checked ? this.fluidtypeselect.map(function (item) {
				return item.value;
			}) : [];
		},
		OAToggleAll: function OAToggleAll(checked) {
			this.model.operation_area_id = checked ? this.operationareaselect.map(function (item) {
				return item.value;
			}) : [];
		},
		fluidTypeChange: function fluidTypeChange() {
			if (this.model.fluid_type_id.length === 0) {
				this.indeterminate = false;
				this.fluidAllSelected = false;
			} else if (this.model.fluid_type_id.length === this.fluidtypeselect.length) {
				this.indeterminate = false;
				this.fluidAllSelected = true;
			} else {
				this.indeterminate = true;
				this.fluidAllSelected = false;
			}
		},
		operationAreaChange: function operationAreaChange() {
			if (this.model.operation_area_id.length === 0) {
				this.indeterminateOA = false;
				this.oaAllSelected = false;
			} else if (this.model.operation_area_id.length === this.operationareaselect.length) {
				this.indeterminateOA = false;
				this.oaAllSelected = true;
			} else {
				this.indeterminateOA = true;
				this.oaAllSelected = false;
			}
		},
		select_energy_company: function select_energy_company() {

			var energycompanies = this.updateData['energy_companies'];
			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				this.model.energy_company = energycompanies[energy_company_index].company_name;
				var operatingareas = energycompanies[energy_company_index].operating_areas;
				var agreements = energycompanies[energy_company_index].agreements;
				if (Array.isArray(operatingareas)) {
					this.operationareaselect = operatingareas.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
					this.model.operation_area_id = [];
					this.agreements = agreements;
					this.model.agreement_id = [];
				} else {
					this.operationareaselect = [];
					this.model.operation_area_id = [];
					this.indeterminateOA = false;
					this.indeterminate = false;
					this.oaAllSelected = false;
					this.fluidAllSelected = false;
					this.agreements = [];
					this.model.agreement_id = [];
					this.indeterminateAgree = false;
					this.indeterminate = false;
					this.agreeAllSelected = false;
				}
			}
		},
		select_location_type: function select_location_type() {
			this.indeterminate = false;

			this.fluidAllSelected = false;

			var location_types = this.updateData.location_types;

			var current_location_type_index = location_types.map(function (o) {
				return o.id;
			}).indexOf(this.model.location_types_id);
			if (current_location_type_index > -1) {
				this.location_type_name = location_types[current_location_type_index].name;
				if (location_types[current_location_type_index].fluid_types) {
					var fluidtypes = location_types[current_location_type_index].fluid_types;
					this.fluidtypeselect = fluidtypes.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});

					if (this.model.fluid_types.length > 0) {
						this.model.fluid_type_id = this.model.fluid_types.map(function (item) {
							return item.id;
						});
					}
				} else {
					this.fluidtypeselect = [];
					this.model.fluid_type_id = [];
				}
			}
		},
		editLocation: function editLocation() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData, {
				fluid_type_id: [],
				operation_area_id: [],
				agreement_id: [],
				agreements: Array.isArray(this.originalData.agreements) ? this.originalData.agreements : [],
				fluid_types: Array.isArray(this.originalData.fluid_types) ? this.originalData.fluid_types : [],
				operating_areas: Array.isArray(this.originalData.operating_areas) ? this.originalData.operating_areas : []
			});
			this.location_type_name = model.location_type;
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
			this.indeterminateAgree = false, this.agreeAllSelected = false;
			this.filtered = this.model.filter;
		},
		setupFields: function setupFields() {
			var location_types = this.updateData['location_types'];
			this.locationselect = location_types.map(function (item) {
				return {
					'value': item.id,
					'text': item.name
				};
			});

			var energy_company = this.updateData['energy_companies'];
			this.energycompanyselect = energy_company.map(function (item) {
				return {
					'value': item.id,
					'text': item.company_name
				};
			});
			if (this.model.energy_company_owned) {
				var energy_company_index = energy_company.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var operating_areas = energy_company[energy_company_index]['operating_areas'];
					if (Array.isArray(operating_areas)) {
						this.operationareaselect = operating_areas.map(function (item) {
							return {
								'value': item.id,
								'text': item.name
							};
						});

						if (this.model.operating_areas.length > 0) {
							this.model.operation_area_id = this.model.operating_areas.map(function (item) {
								return item.id;
							});
						}
					} else {
						this.operationareaselect = [];
						this.model.operating_areas_id = [];
					}
					var agreements = energy_company[energy_company_index].agreements;
					if (Array.isArray(agreements)) {
						this.agreements = agreements;
						if (this.model.agreements.length > 0) {
							this.model.agreement_id = this.model.agreements.map(function (item) {
								return item.id;
							});
						}
					} else {
						this.agreements = [];
						this.model.agreement_id = [];
					}
				}
			} else {
				var operatingareas = this.updateData['operating_areas'];
				if (Array.isArray(operatingareas)) {
					this.operationareaselect = operatingareas.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
					this.model.operation_area_id = this.model.operating_areas.map(function (o) {
						return o.id;
					});
				} else {
					this.operationareaselect = [];
					this.model.operation_area_id = [];
					this.indeterminateOA = false;
					this.indeterminate = false;
					this.oaAllSelected = false;
					this.fluidAllSelected = false;
				}
				this.agreements = [];
				this.model.agreement_id = [];
			}

			var location_types_index = location_types.map(function (o) {
				return o.id;
			}).indexOf(this.model.location_types_id);
			if (location_types_index > -1) {
				var fluid_types = location_types[location_types_index]['fluid_types'];
				if (Array.isArray(fluid_types)) {
					this.fluidtypeselect = fluid_types.map(function (item) {
						return {
							'value': item.id,
							'text': item.name
						};
					});
				} else {
					this.fluidtypeselect = [];
				}

				if (this.model.fluid_types.length > 0) {
					this.model.fluid_type_id = this.model.fluid_types.map(function (item) {
						return item.id;
					});
				}
			}
			this.petrotranz = this.petrotranz_origin;
			this.size = 6;
			this.ready = false;
			this.suggest = true;
		},
		getLocationData: function getLocationData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_6__locations_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] == 'success') {
					_this.originalData = data[1];
					_this.updateData = data[2];
					_this.restoreOriginalData();
					_this.terminalselect = _this.updateData.terminals;
					_this.subTitle = _this.originalData.legal_location;
					_this.found = true;
					_this.loadingData = false;
					_this.petrotranz = _this.updateData.petrotranz;
					_this.petrotranz_origin = _this.updateData.petrotranz;
					_this.role = data[3];
					if (_this.role == 'super_admin') {
						_this.view = true;
						_this.view1 = true;
					} else if (_this.role == 'super_analyst') {
						_this.view = false;
						_this.view1 = true;
						_this.energy_company_id = data[4];
					} else if (_this.role == 'analyst' || _this.role == 'marketing_accountant') {
						_this.view = false;
						_this.view1 = false;
					} else if (_this.role == 'trucking_company_admin' || _this.role == 'trucking_operational_manager') {
						_this.view1 = false;
					} else if (_this.role == 'operations_manager') {
						_this.view1 = false;
					}
				} else {
					_this.loadingData = false;
					_this.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.location_types_id === undefined || this.model.location_types_id.length == 0) {
				this.$swal('Alert!', 'Location Type not selected', 'warning');
				return false;
			} else if (this.model.legal_location === undefined || this.model.legal_location.length == 0) {
				this.$swal('Alert!', 'Location Name can not be empty', 'warning');
				return false;
			} else if (this.model.longitude === null || String(this.model.longitude).length == 0) {
				this.$swal('Alert!', 'Longitude can not be empty', 'warning');
				return false;
			} else if (this.model.latitude === null || String(this.model.latitude).length == 0) {
				this.$swal('Alert!', 'Latitude can not be empty', 'warning');
				return false;
			}
			if (this.model.location_types_id === 1) {
				if (this.model.invoice_code === undefined || this.model.invoice_code === null) {
					this.$swal('Alert!', 'Invoice Code  Required', 'warning');
					return false;
				} else if (this.model.contact_name === undefined || this.model.contact_name === null) {
					this.$swal('Alert!', 'Contact Name  Required', 'warning');
					return false;
				}

				if (this.model.uwi.length > 0) {
					var length = this.model.uwi.length;
					for (var i = 0; i < length; i++) {
						if (this.model.uwi[i].name == null || this.model.uwi[i].name == '') {
							this.$swal('Alert!', 'Uwi name cannot be empty', 'warning');
							return false;
						} else if (this.model.uwi[i].cost_code == null || this.model.uwi[i].cost_code == '') {
							this.$swal('Alert!', 'Uwi Cost Code cannot be empty', 'warning');
							return false;
						} else if (this.model.uwi[i].percentage == null || this.model.uwi[i].percentage == '') {
							this.$swal('Alert!', 'Uwi Percentage cannot be empty', 'warning');
							return false;
						}
					}
				}
			}

			if (this.model.energy_company_owned) {
				if ((this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) && (this.location_type_name.toLowerCase() == 'loads' || this.location_type_name.toLowerCase() == 'load')) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}

			return true;
		},
		updateLocation: function updateLocation(model) {
			var _this2 = this;

			if (this.role == 'super_analyst') {
				this.model.energy_company_id = this.energy_company_id;
			}
			if (!this.okToUpdate()) {
				return;
			}

			model = {
				legal_location: model.legal_location,
				isolera_location_name: model.isolera_location_name,
				energy_company_owned: model.energy_company_owned,
				energy_company_id: model.energy_company_id,
				energy_company: model.energy_company,
				longitude: parseFloat(parseFloat(String(model.longitude))),
				latitude: parseFloat(parseFloat(String(model.latitude))),
				location_types_id: model.location_types_id,
				fluid_types: model.fluid_type_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				operating_areas: model.operation_area_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				lsd: model.lsd,
				battery_code: model.battery_code,
				terminal_id: model.terminal_id,
				terminal_code: model.terminal_code,
				invoice_code: model.invoice_code,
				uwi: model.uwi,
				contact_name: model.contact_name,
				agreements: model.agreement_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				petrotranz: this.model1.petrotranz_company_id
			};
			this.model.id = this.id;
			__WEBPACK_IMPORTED_MODULE_6__locations_service__["a" /* default */].update(this.id, model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getLocationData();
					_this2.edit = false;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.edit = false;
			});
		},
		deleteLocations: function deleteLocations() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Location: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_6__locations_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.filter = '';
							_this3.$router.push('/locations');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		assigndrivers: function assigndrivers() {
			var _this4 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to assign all drivers to this Location?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_6__locations_service__["a" /* default */].assigndrivers(_this4.id, _this4.model.operating_areas).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this4.getLocationData();
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		adduwi: function adduwi() {
			var uwi = {
				name: null,
				cost_code: null,
				percentage: null
			};
			this.model.uwi.push(uwi);
		},
		removeuwi: function removeuwi(uwi) {
			this.model.uwi.splice(uwi, 1);
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		allCheckedAgree: function allCheckedAgree() {
			return Array(this.model.agreements.length).fill(true);
		},
		agreeToggleAll: function agreeToggleAll(checked) {
			this.model.agreement_id = checked ? this.agreements.map(function (item) {
				return item.value;
			}) : [];
		},
		agreeChange: function agreeChange() {
			if (this.model.agreement_id.length === 0) {
				this.indeterminateAgree = false;
				this.agreeAllSelected = false;
			} else if (this.model.agreement_id.length === this.agreements.length) {
				this.indeterminateAgree = false;
				this.agreeAllSelected = true;
			} else {
				this.indeterminateAgree = true;
				this.agreeAllSelected = false;
			}
		},
		keyMonitor: function keyMonitor(evt) {
			if (evt.key.match(/[a-zA-Z0-9,/,-]/i) === null) {
				evt.preventDefault();
				return;
			} else {
				evt = evt ? evt : window.event;
				var key = evt.key;
				this.offset = key;
				this.suggest = true;
				if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
					return;
				} else if (key == "Backspace") {
					var splitter = this.filtered.split("(");
					this.filtered = splitter[0];
					this.model.filter = this.filtered;
					this.petrotranz = [];
					this.filter_p(this.model.filter);
					this.model1.petrotranz_company_id.id = null;
					return;
				} else if (key == "Delete") {
					return;
				} else {
					return;
				}
			}
		},
		select_petrotranz: function select_petrotranz() {
			this.size = 1;

			this.model.filter = this.model1.petrotranz_company_id.name;
			this.filtered = this.model.filter;

			this.suggest = false;
		},
		filter_p: function filter_p(check_filter) {
			var _this5 = this;

			this.size = 6;
			if (this.model.filter !== '' && this.model.filter.length > 0) {
				var filter = { filter: this.model.filter };
				this.ready = true;
				__WEBPACK_IMPORTED_MODULE_6__locations_service__["a" /* default */].petrotranz(filter).then(function (data) {
					if (data.status == 'success') {
						if (_this5.model.filter == check_filter) {
							_this5.petrotranz = data.petrotranz;
						}
						_this5.ready = false;
					} else {
						_this5.$swal(data.status, data.message, data.status);
						_this5.ready = false;
						return;
					}
				}).catch(function (error) {
					_this5.$swal('Error', 'Server not response. ' + error, 'error');
					_this5.ready = false;
				});
			}
		},
		veo: function veo() {
			if (this.offset === "Delete") {
				var splitter = this.filtered.split("(");
				this.filtered = splitter[0];
				this.model.filter = this.filtered;
				this.petrotranz = [];
				this.filter_p(this.model.filter);
			}
		}
	}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__roles_roles_service__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__ = __webpack_require__(18);









var items = [];
var fields = [{
	key: 'username',
	label: 'User Name',
	sortable: true
}, {
	key: 'email',
	label: 'Email',
	sortable: true
}, {
	key: 'first_name',
	label: 'First Name'
}, {
	key: 'last_name',
	label: 'Last Name'
}, {
	key: 'role',
	label: 'Role'
}, {
	key: 'status',
	label: 'Status',
	sortable: true
}];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'users',
	created: function created() {
		this.getAll();
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("servicePage");
		localStorage.removeItem("taPage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("tcPage");
		if (!localStorage.userPage) {
			localStorage.userPage = 0;
		}
	},
	data: function data() {
		return {
			trash: false,
			dpdt: 'Active',
			roleSuperAnalyst: '',
			EnergyCompanySA: '',
			isSuperAnalyst: false,
			indeterminateOA: false,
			oaAllSelected: false,
			roleBySuperAnalyst: '',
			indeterminateLL: false,
			llAllSelected: false,
			indeterminateUL: false,
			ulAllSelected: false,

			current_user_role_name: '',
			insert_data: null,
			userrolesselect: [],
			energycompanyselect: [],
			truckingcompanyselect: [],
			loadlocationsselect: [],
			unloadlocationsselect: [],
			operatingareasselect: [],

			user_role_id: '',
			phone: '',
			energy_company_id: '',
			operating_areas_id: [],
			trucking_company_id: '',
			load_locations_id: [],
			unload_locations_id: [],
			first_name: '',
			last_name: '',
			email: '',
			terminal_boss_user_id: '',

			showTC: false,
			showPhone: false,
			showEC: false,
			showExtras: false,

			items: items,
			itemsO: items,
			loadingData: true,
			currentPage: parseInt(localStorage.userPage),
			newUser: false,
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: 'id',
			sortDesc: true,
			fields: fields,
			fieldsTh: [{
				key: 'id',
				label: 'ID',
				sortable: true
			}, {
				key: 'first_name',
				label: 'First Name'
			}, {
				key: 'last_name',
				label: 'Last Name'
			}, {
				key: 'username',
				label: 'Username',
				sortable: true
			}, {
				key: 'email',
				label: 'Email',
				sortable: true
			}, {
				key: 'phone',
				label: 'Phone'
			}, {
				key: 'role',
				label: 'Role'
			}],
			filter: null,
			modalInfo: {
				title: '',
				content: ''
			},
			configTable: false,
			selectedItems: ['id', 'username', 'email', 'first_name', 'last_name', 'role'],
			role: '',
			view: true,
			savebtn: true,
			trucking_company_iidd: null,
			text: 'Trucking Company',
			trucking_companies_filter: [],
			filters_save: {
				energy_companies_id: 0,
				energy_company_name: 'All Energy Companies',
				users_id: 0,
				driver_name: 'All Drivers',
				truck_id: 0,
				truck_name: 'All Trucks',
				trucking_company_id: 0,
				trucking_company_name: 'All Trucking Companies',
				load_location_id: 0,
				load_name: 'All Loads',
				fluid_type_id: 0,
				fluid_type_name: 'All Fluid Types',
				unload_location_id: 0,
				unload_name: 'All UnLoads',
				initial_date: '',
				end_date: '',
				flag_name: 'All Flags',
				sortby: 'haul_id',
				sortdesc: false
			},
			filters_start: {
				energy_companies_id: 0,
				energy_company_name: 'All Energy Companies',
				users_id: 0,
				driver_name: 'All Drivers',
				truck_id: 0,
				truck_name: 'All Trucks',
				trucking_company_id: 0,
				trucking_company_name: 'All Trucking Companies',
				load_location_id: 0,
				load_name: 'All Loads',
				fluid_type_id: 0,
				fluid_type_name: 'All Fluid Types',
				unload_location_id: 0,
				unload_name: 'All UnLoads',
				initial_date: '',
				end_date: '',
				flag_name: 'All Flags',
				sortby: 'haul_id',
				sortdesc: false
			},
			filter_by: { "initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "", "flags": "",
				"column": ['haul_id', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] },
			operating_areas_access: true,
			favorites_load_id: [],
			favorites_unload_id: [],
			favorites_load: [],
			favorites_unload: []
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return {
					text: f.label,
					value: f.key
				};
			});
		}
	},
	methods: {
		activate_custom_backdrop: function activate_custom_backdrop() {
			this.$root.$el.classList.add("custom_backdrop_behavior");
		},
		deactivate_custom_backdrop: function deactivate_custom_backdrop() {
			this.$root.$el.classList.remove("custom_backdrop_behavior");
		},
		tcFilter: function tcFilter(tc_filter, id) {
			this.filters_save.trucking_company_name = tc_filter;
			this.filters_save.trucking_company_id = id;
			if (tc_filter === 'All Trucking Companies') {
				this.items = this.itemsO;
			} else {
				var result = this.itemsO.filter(function (item) {
					return item.trucking_company == tc_filter;
				});
				this.items = result;
			}
		},
		rowClicked: function rowClicked(row) {
			localStorage.userPage = this.currentPage;
			if (!this.trash) {
				this.$router.push('/user/' + row.id + '/');
			} else {
				this.restoreUser(row.id);
			}
		},
		llChange: function llChange(value) {
			if (this.favorites_load_id.length === 0) {
				this.indeterminateLL = false;
				this.llAllSelected = false;
			} else if (this.favorites_load_id.length === this.favorites_load.length) {
				this.indeterminateLL = false;
				this.llAllSelected = true;
			} else {
				this.indeterminateLL = true;
				this.llAllSelected = false;
			}
		},
		ulChange: function ulChange(value) {
			if (this.favorites_unload_id.length === 0) {
				this.indeterminateUL = false;
				this.ulAllSelected = false;
			} else if (this.favorites_unload_id.length === this.favorites_unload.length) {
				this.indeterminateUL = false;
				this.ulAllSelected = true;
			} else {
				this.indeterminateUL = true;
				this.ulAllSelected = false;
			}
		},
		operatingAreaChange: function operatingAreaChange() {
			var operating_area = this.operatingareasselect;
			var operating_area_id = this.operating_areas_id;
			if (operating_area_id === true) {
				return;
			}
			var ll = operating_area_id.map(function (item) {
				var oa_index = operating_area.map(function (o) {
					return o.id;
				}).indexOf(item);
				if (oa_index > -1) {
					return operating_area[oa_index].load_locations.map(function (o) {
						return o.id;
					});
				}
			});

			var ul = operating_area_id.map(function (item) {
				var oa_index = operating_area.map(function (o) {
					return o.id;
				}).indexOf(item);
				if (oa_index > -1) {
					return operating_area[oa_index].unload_locations.map(function (o) {
						return o.id;
					});
				}
			});
			this.load_locations_id = Array.prototype.concat.apply([], ll);
			this.unload_locations_id = Array.prototype.concat.apply([], ul);

			var l_locations = this.loadlocationsselect;
			var l_locations_id = this.load_locations_id;
			var oa_ll = l_locations_id.map(function (item) {
				var oa_index = l_locations.map(function (o) {
					return o.id;
				}).indexOf(item);
				if (oa_index > -1) {
					return l_locations[oa_index];
				}
			});
			this.favorites_load = this.arrayUnique(oa_ll);
			this.favorites_load_id = [];

			var ul_locations = this.unloadlocationsselect;
			var ul_locations_id = this.unload_locations_id;
			var oa_ul = ul_locations_id.map(function (item) {
				var oa_index = ul_locations.map(function (o) {
					return o.id;
				}).indexOf(item);
				if (oa_index > -1) {
					return ul_locations[oa_index];
				}
			});
			this.favorites_unload = this.arrayUnique(oa_ul);
			this.favorites_unload_id = [];

			if (this.current_user_role_name === 'driver') {
				if (this.operating_areas_id.length === 0) {
					this.indeterminateOA = false;
					this.oaAllSelected = false;
				} else if (this.operating_areas_id.length === this.operatingareasselect.length) {
					this.indeterminateOA = false;
					this.oaAllSelected = true;
				} else {
					this.indeterminateOA = true;
					this.oaAllSelected = false;
				}
			}
		},
		oaToggleAll: function oaToggleAll(checked) {
			this.operating_areas_id = checked ? this.operatingareasselect.map(function (item) {
				return item.id;
			}) : [];
		},
		llToggleAll: function llToggleAll(checked) {
			this.favorites_load_id = checked ? this.favorites_load.map(function (item) {
				return item.id;
			}) : [];
		},
		ulToggleAll: function ulToggleAll(checked) {
			this.favorites_unload_id = checked ? this.favorites_unload.map(function (item) {
				return item.id;
			}) : [];
		},
		select_trucking_company: function select_trucking_company() {

			var current_user_role_index = this.insert_data.roles.map(function (o) {
				return o.id;
			}).indexOf(this.user_role_id);
			if (current_user_role_index > -1) {
				var current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase();
				if (current_user_role_name === 'driver') {
					var current_trucking_company_index = this.insert_data.roles[current_user_role_index].trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.trucking_company_id);
					if (current_trucking_company_index > -1) {
						var truckingcompany = this.insert_data.roles[current_user_role_index].trucking_companies[current_trucking_company_index];
						this.energycompanyselect = [];
						this.operatingareasselect = truckingcompany.operating_areas;
						this.loadlocationsselect = truckingcompany.load_locations;
						this.unloadlocationsselect = truckingcompany.unload_locations;
						this.operating_areas_id = [];
						this.unload_locations_id = [];
						this.load_locations_id = [];

						this.favorites_load_id = [];
						this.favorites_unload_id = [];
						this.favorites_load = [];
						this.favorites_unload = [];

						this.indeterminateOA = false;
						this.oaAllSelected = false;
						this.indeterminateLL = false;
						this.llAllSelected = false;
						this.indeterminateUL = false;
						this.ulAllSelected = false;
					}
				}
			}
		},
		select_energy_company: function select_energy_company() {
			if (this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
				this.operating_areas_id = [];
				this.checkbox_oa = true;
				var current_user_role_index = this.insert_data.roles.map(function (o) {
					return o.id;
				}).indexOf(this.user_role_id);
				if (current_user_role_index > -1) {
					var energycompanies = this.insert_data.roles[current_user_role_index].energy_companies;
					var ec_index = energycompanies.map(function (o) {
						return o.id;
					}).indexOf(this.energy_company_id);
					if (ec_index > -1) {
						this.operatingareasselect = energycompanies[ec_index].operating_areas;
					}
				}
			}
		},
		select_user_role: function select_user_role() {
			if (this.role == 'super_admin') {
				var current_user_role_index = this.insert_data.roles.map(function (o) {
					return o.id;
				}).indexOf(this.user_role_id);
				if (current_user_role_index > -1) {
					this.current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase();
					if (this.current_user_role_name === 'operations_manager') {
						var energycompanies = this.insert_data.roles[current_user_role_index].energy_companies;
						this.energycompanyselect = Array.isArray(energycompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(energycompanies)) : [];
						this.showEC = true;
						this.showTC = false;
						this.showExtras = false;
						this.energy_company_id = '';
						this.indeterminateEC = false;
						this.ecAllSelected = false;
						this.showPhone = false;
						this.operatingareasselect = [];
						this.operating_areas_access = true;
					} else if (this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
						var _energycompanies = this.insert_data.roles[current_user_role_index].energy_companies;
						this.energycompanyselect = Array.isArray(_energycompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_energycompanies)) : [];
						this.showEC = true;
						this.showTC = false;
						this.showExtras = false;
						this.energy_company_id = '';
						this.indeterminateEC = false;
						this.ecAllSelected = false;
						this.showPhone = false;
						this.operatingareasselect = [];
						this.operating_areas_access = true;
					} else if (this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
						var truckingcompanies = this.insert_data.roles[current_user_role_index].trucking_companies;
						this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(truckingcompanies)) : [];
						this.showTC = true;
						this.showEC = false;
						this.showPhone = false;
						this.trucking_company_id = '';

						this.operatingareasselect = [];
						this.loadlocationsselect = [];
						this.unloadlocationsselect = [];

						if (this.current_user_role_name === 'driver') {
							this.showExtras = true;
							this.showPhone = true;
							this.loadlocationsselect = [];
							this.unloadlocationsselect = [];
							this.load_locations_id = [];
							this.unload_locations_id = [];

							this.favorites_load_id = [];
							this.favorites_unload_id = [];
							this.favorites_load = [];
							this.favorites_unload = [];

							this.indeterminateOA = false;
							this.oaAllSelected = false;
							this.indeterminateLL = false;
							this.llAllSelected = false;
							this.indeterminateUL = false;
							this.ulAllSelected = false;
						} else {
							this.showPhone = false;
							this.showExtras = false;
						}
					} else {
						this.showEC = false;
						this.showPhone = false;
						this.showTC = false;
						this.showExtras = false;
					}
				}
			} else if (this.role == 'trucking_company_admin' || this.role === 'trucking_operational_manager') {
				this.showExtras = false;
				this.showPhone = false;
				this.select_trucking_company_admin();
			} else if (this.role == 'operations_manager') {
				var _current_user_role_index = this.insert_data.roles.map(function (o) {
					return o.id;
				}).indexOf(this.user_role_id);
				if (_current_user_role_index > -1) {
					this.current_user_role_name = this.insert_data.roles[_current_user_role_index].name.toLowerCase();
					if (this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
						var _energycompanies2 = this.insert_data.roles[_current_user_role_index].energy_companies;
						this.energycompanyselect = Array.isArray(_energycompanies2) ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_energycompanies2)) : [];
						this.showEC = false;
						this.showTC = false;
						this.showExtras = false;

						this.indeterminateEC = false;
						this.ecAllSelected = false;
						this.showPhone = false;
						this.operatingareasselect = [];
						this.operating_areas_access = true;
					} else if (this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || role === 'trucking_operational_manager') {
						var _truckingcompanies = this.insert_data.roles[_current_user_role_index].trucking_companies;
						this.truckingcompanyselect = Array.isArray(_truckingcompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_truckingcompanies)) : [];
						this.showTC = true;
						this.showEC = false;
						this.showPhone = false;
						this.trucking_company_id = '';

						this.operatingareasselect = [];
						this.loadlocationsselect = [];
						this.unloadlocationsselect = [];
					} else {
						this.showEC = false;
						this.showPhone = false;
						this.showTC = false;
						this.showExtras = false;
					}
				}
			}
		},
		showNewUserModal: function showNewUserModal() {
			this.user_role_id = '';
			this.current_user_role_name = '';
			this.phone = '';
			this.savebtn = false;
			if (this.role !== 'operations_manager') {
				this.energy_company_id = '';
			}
			this.operating_areas_id = [];
			this.trucking_company_id = '';
			this.load_locations_id = [];
			this.unload_locations_id = [];

			this.favorites_load_id = [];
			this.favorites_unload_id = [];
			this.favorites_load = [];
			this.favorites_unload = [];

			this.first_name = '';
			this.last_name = '';
			this.email = '';
			this.terminal_boss_user_id = '';
			this.showTC = false;
			this.showEC = false;
			if (this.role == 'trucking_company_admin' || this.role === 'trucking_operational_manager') {
				this.showExtras = false;
			}
			if (this.role == 'trucking_company_admin_light') {
				this.showExtras = true;
			} else {
				this.showExtras = false;
			}
			this.newUser = true;
		},
		actionField: function actionField(option) {
			var fieldsThLength = this.fieldsTh.length;
			var fieldIsActive = false;
			for (var i = 0; i <= fieldsThLength; i++) {
				fieldIsActive = true;
				try {
					if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
						this.fieldsTh.splice(i, 1);
						fieldIsActive = false;
						break;
					}
				} catch (err) {
					var length_fields = fields.length;
					var position = -1;
					for (var i = 0; i < length_fields; i++) {
						position = i;
						if (fields[i].key == option) {
							this.fieldsTh.splice(position, 0, fields[position]);
							break;
						}
					}
				}
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = parseInt(localStorage.userPage);
		},
		trashUser: function trashUser() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		restoreUser: function restoreUser(id) {
			var _this = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this User?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_4__users_service__["a" /* default */].restore(id).then(function (data) {
						_this.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this.filter = '';
							_this.trash = false;
							_this.getAll();
							_this.loadingData = true;
						}
					}).catch(function (error) {
						_this.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		getAll: function getAll() {
			var _this2 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_4__users_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					_this2.items = data[1].filter(function (o) {
						return o.status_id == (_this2.trash ? 2 : 1);
					}).map(function (o) {
						o.role = o.role.trim().replace(/_/g, " ").split(" ").map(function (item) {
							return item.charAt(0).toUpperCase() + item.slice(1);
						}).join(" ");
						return o;
					});

					_this2.itemsO = _this2.items;
					_this2.trucking_company_iidd = data[2];
					_this2.getAll1();
				} else {
					_this2.items = [];
					_this2.itemsO = _this2.items;
					_this2.$swal(data[0], data[1], data[0]);
				}
				_this2.loadingData = false;
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.loadingData = false;
			});
		},
		getAll1: function getAll1() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_4__users_service__["a" /* default */].getAll1().then(function (data) {
				if (data[0] == 'success') {

					_this3.trucking_companies_filter = data[1];
					_this3.role = data[2];
					_this3.current_user_role_name == _this3.role;

					_this3.insert_data = data[3];
					_this3.userrolesselect = _this3.insert_data.roles.map(function (item) {
						return {
							id: item.id,
							name: item.name.trim().replace(/_/g, " ").split(" ").map(function (item) {
								return item.charAt(0).toUpperCase() + item.slice(1);
							}).join(" ")
						};
					});

					if (_this3.role == 'super_analyst') {
						_this3.roleBySuperAnalyst = _this3.userrolesselect[0].name;
						_this3.user_role_id = _this3.userrolesselect[0].id;
						_this3.energy_company_id = _this3.insert_data.roles[0].energy_companies[0].id;
						_this3.EnergyCompanySA = _this3.insert_data.roles[0].energy_companies[0].name;
					} else if (_this3.role == 'trucking_company_admin' || _this3.role == 'trucking_company_admin_light' || _this3.role === 'trucking_operational_manager') {
						_this3.trucking_company_id = _this3.trucking_company_iidd;
						_this3.user_role_id = _this3.userrolesselect[0].id;
						_this3.showPhone = true;
						_this3.select_trucking_company();
					} else if (_this3.role == 'operations_manager') {
						_this3.energy_company_id = _this3.trucking_company_iidd;
					}
				} else {
					_this3.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		okToSave: function okToSave() {
			if (this.role == 'super_admin') {
				if (this.user_role_id === undefined || this.user_role_id.length == 0) {
					this.$swal('Alert!', 'User Role not selected', 'warning');
					return false;
				}
			}
			if (this.first_name === null || String(this.first_name).trim().length == 0) {
				this.$swal('Alert!', 'First Name can not be empty', 'warning');
				return false;
			} else if (this.last_name === null || String(this.last_name).trim().length == 0) {
				this.$swal('Alert!', 'Last Name can not be empty', 'warning');
				return false;
			}
			if (this.current_user_role_name === 'operations_manager' || this.current_user_role_name === 'marketing_accountant' || this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst') {
				if (this.energy_company_id === undefined || this.energy_company_id.length == 0) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			} else if (this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.role === 'trucking_operational_manager') {
				if (this.trucking_company_id === undefined || this.trucking_company_id.length == 0) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}

			return true;
		},
		saveUser: function saveUser() {
			var _this4 = this;

			if (!this.okToSave()) {
				return;
			}
			this.savebtn = true;
			var dataUser = {
				email: this.email,
				last_name: this.last_name,
				first_name: this.first_name,
				role_id: this.user_role_id,
				phone: ''
			};
			if (this.current_user_role_name === 'super_admin') {
				dataUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataUser, {
					trucking_company_id: this.trucking_company_id,
					phone: ''
				});
			} else if (this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'analyst' || this.current_user_role_name === 'marketing_accountant') {
				dataUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataUser, {
					energy_company_id: this.energy_company_id,
					phone: '',
					load_locations: this.load_locations_id,
					unload_locations: this.unload_locations_id,
					operating_areas_all: this.operating_areas_access,
					operating_areas: this.operating_areas_id
				});
			} else if (this.current_user_role_name === 'operations_manager') {
				dataUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataUser, {
					energy_company_id: this.energy_company_id,
					phone: '',

					operating_areas_all: this.operating_areas_access
				});
			} else if (this.current_user_role_name === 'driver') {

				dataUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataUser, {
					trucking_company_id: this.trucking_company_id,
					phone: this.phone,
					operating_areas: this.operating_areas_id.map(function (item) {
						return {
							id: String(item)
						};
					}),
					load_locations: this.favorites_load_id.map(function (item) {
						return {
							id: String(item)
						};
					}),
					unload_locations: this.favorites_unload_id.map(function (item) {
						return {
							id: String(item)
						};
					}),
					terminal_boss_user_id: this.terminal_boss_user_id
				});
			} else if (this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
				dataUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataUser, {
					trucking_company_id: this.trucking_company_id,
					phone: ''
				});
			} else if (this.role === 'trucking_company_admin_light') {
				dataUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataUser, {
					trucking_company_id: this.trucking_company_iidd,
					phone: this.phone,
					operating_areas: this.operating_areas_id.map(function (item) {
						return {
							id: String(item)
						};
					})
				});
				dataUser.role_id = 2;
			}
			__WEBPACK_IMPORTED_MODULE_4__users_service__["a" /* default */].save(dataUser).then(function (data) {
				if (data[0] == 'success') {
					_this4.newUser = false;
					_this4.getAll();
				} else if (data[0] == 'foundit') {

					_this4.$swal({
						title: 'Please, confirm',
						text: _this4.first_name + " " + _this4.last_name + " is assigned for a different trucking company, would you want to reassign the driver to your company?",
						type: 'question',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes',
						reverseButtons: true
					}).then(function (result) {
						if (result.value) {
							var dataU = { trucking_company_id: _this4.trucking_company_iidd,
								operating_areas: _this4.operating_areas_id.map(function (item) {
									return {
										id: String(item)
									};
								})
							};
							var new_user_tc = data[1];
							__WEBPACK_IMPORTED_MODULE_4__users_service__["a" /* default */].pre_edit(data[1], dataU).then(function (data) {
								if (data[0] == 'success') {
									_this4.newUser = false;
									_this4.$router.push('/user/' + new_user_tc + '/');
								} else {
									__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]);
									_this4.newUser = false;
								}
							});
						}
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = false;
		},

		isLetter: function isLetter(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			var tecla = String.fromCharCode(charCode).toString();
			var letras = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ";
			if (letras.indexOf(tecla) == -1) {
				if (charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			} else {
				return true;
			}
		},
		isLowerCaseEmail: function isLowerCaseEmail(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 122) {
				return true;
			} else {
				if (charCode == 45 || charCode == 46 || charCode == 64 || charCode == 95 || charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			}
		},
		saveFilters: function saveFilters() {
			__WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].saveFilters(2, this.filters_save).then(function (data) {
				if (data[0] == 'success') {
					return;
				} else {
					__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					return;
				}
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				return;
			});
		},
		getFilters: function getFilters() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getFilters(2).then(function (data) {
				if (data[0] == 'success') {
					_this5.filters_start = data[1];
					_this5.filters_start1 = data[2];
					if (_this5.filters_start.length != 0) {
						for (var property in _this5.filters_start[0]) {
							_this5.filters_save[property] = _this5.filters_start[0][property];
							if (_this5.filters_start[0][property] == 0) {
								_this5.filter_by[property] = "";
							} else if (_this5.filters_start[0][property] == null) {
								_this5.filter_by[property] = "";
							} else {
								_this5.filter_by[property] = _this5.filters_start[0][property];
							}
						}
						if (_this5.filters_start[0]['initial_date'] == null) {
							_this5.filter_by['initial_date'] = moment().startOf('month').format('YYYY-MM-DD');
							_this5.filters_save['initial_date'] = moment().startOf('month').format('YYYY-MM-DD');
						}
						if (_this5.filters_start[0]['end_date'] == null) {
							_this5.filter_by['end_date'] = moment().endOf('month').format('YYYY-MM-DD');
							_this5.filters_save['end_date'] = moment().endOf('month').format('YYYY-MM-DD');
						}

						for (var property in _this5.filters_start1[0]) {
							_this5.filters_save[property] = _this5.filters_start1[0][property];
						}

						if (_this5.filters_start[0].folder_id == 0 && _this5.filters_start1[0].folder == 'Unassigned Hauls') {
							_this5.filter_by.folder_id = _this5.filters_start[0].folder_id;
						}
						_this5.filters_save.folder_id = _this5.filters_start[0].folder_id;
						_this5.filters_save.folder = _this5.filters_start1[0].folder;
					} else {
						_this5.filters_save.folder_id = 0;
						_this5.filters_save.folder = "All Folders";
						_this5.filters_save.energy_companies_id = 0;
						_this5.filters_save.energy_company_name = "All Energy Companies";
						_this5.filters_save.fluid_type_id = 0;
						_this5.filters_save.fluid_type_name = "All Fluid Types";
						_this5.filters_save.users_id = 0;
						_this5.filters_save.driver_name = "All Drivers";
						_this5.filters_save.truck_id = 0;
						_this5.filters_save.truck_name = "All Trucks";
						_this5.filters_save.trucking_company_id = 0;
						_this5.filters_save.trucking_company_name = "All Trucking Companies";
						_this5.filters_save.unload_location_id = 0;
						_this5.filters_save.load_name = "All Loads";
						_this5.filters_save.unload_location_id = 0;
						_this5.filters_save.unload_name = "All Unloads";
						_this5.filters_save.flag_name = "All Flags";
						_this5.filters_save.initial_date = moment().startOf('month').format('YYYY-MM-DD');
						_this5.filters_save.end_date = moment().endOf('month').format('YYYY-MM-DD');
						_this5.filters_save.sortby = 'haul_id';
						_this5.filters_save.sortdesc = false;
						_this5.filter_by = { "initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "", "flags": "",
							"column": ['haul_id', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date', 'haul_start_time'] };
					}
					localStorage.setItem('filter', _this5.filters_save.trucking_company_name);
					_this5.loadingData = true;
					return;
				} else {
					__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					_this5.loadingData = false;
					return;
				}
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
				_this5.loadingData = false;
				return;
			});
		},
		select_trucking_company_admin: function select_trucking_company_admin() {

			var current_user_role_index = this.insert_data.roles.map(function (o) {
				return o.id;
			}).indexOf(this.user_role_id);
			if (current_user_role_index > -1) {
				var current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase();
				this.current_user_role_name = current_user_role_name;
				if (current_user_role_name === 'driver') {
					var current_trucking_company_index = this.insert_data.roles[current_user_role_index].trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.trucking_company_iidd);
					if (current_trucking_company_index > -1) {
						var truckingcompany = this.insert_data.roles[current_user_role_index].trucking_companies[current_trucking_company_index];
						this.energycompanyselect = [];
						this.operatingareasselect = truckingcompany.operating_areas;
						this.loadlocationsselect = truckingcompany.load_locations;
						this.unloadlocationsselect = truckingcompany.unload_locations;
						this.operating_areas_id = [];
						this.unload_locations_id = [];
						this.load_locations_id = [];

						this.favorites_load_id = [];
						this.favorites_unload_id = [];
						this.favorites_load = [];
						this.favorites_unload = [];

						this.indeterminateOA = false;
						this.oaAllSelected = false;
						this.indeterminateLL = false;
						this.llAllSelected = false;
						this.indeterminateUL = false;
						this.ulAllSelected = false;

						this.showExtras = true;
						this.showPhone = true;

						this.trucking_company_id = this.trucking_company_iidd;
					}
				} else {
					this.trucking_company_id = this.trucking_company_iidd;
				}
			}
		},
		arrayUnique: function arrayUnique(array) {
			var a = array.concat();
			for (var i = 0; i < a.length; ++i) {
				for (var j = i + 1; j < a.length; ++j) {
					if (a[i].id === a[j].id) a.splice(j--, 1);
				}
			}
			return a;
		}
	}
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__roles_roles_service__ = __webpack_require__(60);






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'user',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getUserData();
	},
	data: function data() {
		return {
			isSuperAnalyst: false,
			filetitle: '',
			documents: [],
			file: '',
			emptyFiles: true,
			itemsFiles: [],
			fieldsFile: [{
				key: 'comment',
				label: 'Title',
				sortable: true
			}, {
				key: 'file_name',
				label: 'Document',
				sortable: true
			}, { key: 'actions', label: 'Actions' }],
			newDocuments: false,
			loggued_user_rol: localStorage.getItem('role_id'),
			edit: false,
			originalData: null,
			updateData: null,
			subTitle: '',
			tabIndex: 0,
			trucking_company_name: '',
			energy_company_name: '',
			operating_areas: [],
			load_locations: [],
			unload_locations: [],

			indeterminateOA: false,
			oaAllSelected: false,

			indeterminateLL: false,
			llAllSelected: false,
			indeterminateUL: false,
			ulAllSelected: false,

			user_role: '',
			current_user_role_name: '',
			insert_data: null,
			userrolesselect: [],
			energycompanyselect: [],
			truckingcompanyselect: [],
			loadlocationsselect: [],
			unloadlocationsselect: [],
			operatingareasselect: [],

			user_role_id: '',
			energy_company_id: 0,
			operating_areas_id: [],
			operating_areas_id_original: [],
			trucking_company_id: '',
			load_locations_id: [],
			unload_locations_id: [],
			username: '',
			first_name: '',
			last_name: '',
			email: '',
			phone: '',
			password: '',
			new_password: '',

			confirm_new_password: '',

			showTC: false,
			showEC: false,
			showExtras: false,

			loadingData: true,
			found: false,
			notFoundMessage: 'Not found',
			role: '',
			view: true,
			view1: true,
			user_id: '',
			start: true,
			start1: true,
			new_load: [],
			terminal_boss_user_id: '',
			operating_areas_access: true,
			checkbox_oa: false,
			favorites_load_id: [],
			favorites_unload_id: [],
			favorites_load: [],
			favorites_unload: [],
			favorites_load_select: [],
			favorites_unload_select: [],
			Data_attr: [],
			manage_intraday: false,
			updated_at: ''
		};
	},

	methods: {
		linkClass: function linkClass(idx) {
			if (this.tabIndex === idx) {
				return ['bg-primary', 'text-light'];
			} else {
				return ['bg-primary', 'text-light'];
			}
		},
		llChange: function llChange(value) {
			if (this.favorites_load_id.length !== 0) {
				if (this.favorites_load_id[0] == true) {
					this.favorites_load_id = [];
					return;
				}
			}

			if (this.favorites_load_id.length === 0) {
				this.indeterminateLL = false;
				this.llAllSelected = false;
			} else if (this.favorites_load_id.length === this.favorites_load_select.length) {
				this.indeterminateLL = false;
				this.llAllSelected = true;
			} else {
				this.indeterminateLL = true;
				this.llAllSelected = false;
			}
		},
		ulChange: function ulChange(value) {
			if (this.favorites_unload_id.length !== 0) {
				if (this.favorites_unload_id[0] == true) {
					this.favorites_unload_id = [];
					return;
				}
			}
			if (this.favorites_unload_id.length === 0) {
				this.indeterminateUL = false;
				this.ulAllSelected = false;
			} else if (this.favorites_unload_id.length === this.favorites_unload_select.length) {
				this.indeterminateUL = false;
				this.ulAllSelected = true;
			} else {
				this.indeterminateUL = true;
				this.ulAllSelected = false;
			}
		},
		operatingAreaChange: function operatingAreaChange() {

			if (!this.start) {
				var operating_area = this.operatingareasselect;
				var operating_area_id = this.operating_areas_id;
				if (operating_area_id === true) {
					return;
				}

				if (operating_area_id.length != 0) {
					if (operating_area_id[0] === true) {
						operating_area_id = [];
						return;
					}

					var ll = operating_area_id.map(function (item) {
						var oa_index = operating_area.map(function (o) {
							return o.id;
						}).indexOf(item);
						if (oa_index > -1) {
							return operating_area[oa_index].load_locations.map(function (o) {
								return o.id;
							});
						}
					});

					var ul = operating_area_id.map(function (item) {
						var oa_index = operating_area.map(function (o) {
							return o.id;
						}).indexOf(item);
						if (oa_index > -1) {
							return operating_area[oa_index].unload_locations.map(function (o) {
								return o.id;
							});
						}
					});
					this.load_locations_id = Array.prototype.concat.apply([], ll);
					this.unload_locations_id = Array.prototype.concat.apply([], ul);
				} else {
					operating_area = [];
					this.load_locations_id = [];
					this.unload_locations_id = [];
				}

				var l_locations = this.loadlocationsselect;
				var l_locations_id = this.load_locations_id;
				var oa_ll = l_locations_id.map(function (item) {
					var oa_ll_index = l_locations.map(function (o) {
						return o.id;
					}).indexOf(item);
					if (oa_ll_index > -1) {
						return l_locations[oa_ll_index];
					}
				});
				this.favorites_load_select = this.arrayUnique(oa_ll);
				this.favorites_load_id = [];

				var ul_locations = this.unloadlocationsselect;
				var ul_locations_id = this.unload_locations_id;
				var oa_ul = ul_locations_id.map(function (item) {
					var oa_ul_index = ul_locations.map(function (o) {
						return o.id;
					}).indexOf(item);
					if (oa_ul_index > -1) {
						return ul_locations[oa_ul_index];
					}
				});
				this.favorites_unload_select = this.arrayUnique(oa_ul);
				this.favorites_unload_id = [];

				if (this.operating_areas_id.length === 0) {
					this.indeterminateOA = false;
					this.oaAllSelected = false;
				} else if (this.operating_areas_id.length === this.operatingareasselect.length) {
					this.indeterminateOA = false;
					this.oaAllSelected = true;
				} else {
					this.indeterminateOA = true;
					this.oaAllSelected = false;
				}
			} else {
				this.start = false;
			}
		},
		oaToggleAll: function oaToggleAll(checked) {
			this.operating_areas_id = checked ? this.operatingareasselect.map(function (item) {
				return item.id;
			}) : [];
		},
		llToggleAll: function llToggleAll(checked) {
			this.favorites_load_id = checked ? this.favorites_load_select.map(function (item) {
				return item.id;
			}) : [];
		},
		ulToggleAll: function ulToggleAll(checked) {
			this.favorites_unload_id = checked ? this.favorites_unload_select.map(function (item) {
				return item.id;
			}) : [];
		},
		select_trucking_company: function select_trucking_company() {
			var current_user_role_index = this.updateData.roles.map(function (o) {
				return o.id;
			}).indexOf(this.user_role_id);
			if (current_user_role_index > -1) {
				var current_user_role_name = this.updateData.roles[current_user_role_index].name.toLowerCase();
				if (current_user_role_name === 'driver') {
					var current_trucking_company_index = this.updateData.roles[current_user_role_index].trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.trucking_company_id);
					if (current_trucking_company_index > -1) {
						var truckingcompany = this.updateData.roles[current_user_role_index].trucking_companies[current_trucking_company_index];
						this.unloadlocationsselect = truckingcompany.unload_locations;
						this.unload_locations_id = [];
						this.energycompanyselect = truckingcompany.energy_companies;
						this.loadlocationsselect = truckingcompany.load_locations;

						this.load_locations_id = [];
						this.operatingareasselect = truckingcompany.operating_areas;

						this.operating_areas_id = [];

						this.indeterminateOA = false;
						this.oaAllSelected = false;
						this.indeterminateLL = false;
						this.llAllSelected = false;
						this.indeterminateUL = false;
						this.ulAllSelected = false;
					}
				}
			}
		},
		select_user_role: function select_user_role() {
			var current_user_role_index = this.updateData.roles.map(function (o) {
				return o.id;
			}).indexOf(this.user_role_id);
			if (current_user_role_index > -1) {
				this.current_user_role_name = this.updateData.roles[current_user_role_index].name.toLowerCase();
				if (this.current_user_role_name === 'operations_manager' || this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
					var energycompanies = this.updateData.roles[current_user_role_index].energy_companies;
					this.energycompanyselect = Array.isArray(energycompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(energycompanies)) : [];
					this.showEC = true;
					this.showTC = false;
					this.showExtras = false;
					this.energy_company_id = '';
					this.indeterminateEC = false;
					this.ecAllSelected = false;
				} else if (this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
					var truckingcompanies = this.updateData.roles[current_user_role_index].trucking_companies;
					this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(truckingcompanies)) : [];
					this.showTC = true;
					this.showEC = false;
					this.trucking_company_id = '';
					if (this.current_user_role_name === 'driver') {
						this.showExtras = true;
						this.loadlocationsselect = [];
						this.unloadlocationsselect = [];
						this.load_locations_id = [];
						this.unload_locations_id = [];
						this.indeterminateOA = false;
						this.oaAllSelected = false;
						this.indeterminateLL = false;
						this.llAllSelected = false;
						this.indeterminateUL = false;
						this.ulAllSelected = false;
					} else {
						this.showExtras = false;
					}
				} else {
					this.showEC = false;
					this.showTC = false;
					this.showExtras = false;
				}
			}
		},
		allChecked: function allChecked(variable_name) {
			if (this[variable_name].length === 0) {
				return;
			} else {
				return Array(this[variable_name].length).fill(true);
			}
		},
		setupFields: function setupFields() {
			var _this = this;

			var user_roles = this.updateData.roles;
			this.userrolesselect = user_roles.map(function (item) {
				return {
					id: item.id,
					name: item.name.trim().replace(/_/g, " ").split(" ").map(function (item) {
						return item.charAt(0).toUpperCase() + item.slice(1);
					}).join(" ")
				};
			});

			var current_user_role_index = user_roles.map(function (o) {
				return o.id;
			}).indexOf(this.user_role_id);
			if (current_user_role_index > -1) {
				var current_user_role_name = user_roles[current_user_role_index].name.toLowerCase();
				if (current_user_role_name === 'driver' || current_user_role_name === 'trucking_company_admin' || current_user_role_name === 'trucking_company_admin_light' || current_user_role_name === 'trucking_operational_manager') {
					var current_trucking_company_index = user_roles[current_user_role_index].trucking_companies.map(function (o) {
						return o.id;
					}).indexOf(this.trucking_company_id);
					if (current_trucking_company_index > -1) {
						var truckingcompanies = user_roles[current_user_role_index].trucking_companies;
						this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(truckingcompanies)) : [];
						this.showTC = true;

						if (current_user_role_name === 'driver') {

							var truckingcompany = user_roles[current_user_role_index].trucking_companies[current_trucking_company_index];

							this.operatingareasselect = truckingcompany.operating_areas;
							this.unloadlocationsselect = truckingcompany.unload_locations;
							this.energycompanyselect = truckingcompany.energy_companies;
							this.loadlocationsselect = truckingcompany.load_locations;

							this.unload_locations_id = [];
							this.load_locations_id = [];
							this.operating_areas_id = [];

							this.favorites_load_id = [];

							this.showExtras = true;
							this.indeterminateOA = false;
							this.oaAllSelected = false;
							this.indeterminateLL = false;
							this.llAllSelected = false;
							this.indeterminateUL = false;
							this.ulAllSelected = false;

							if (this.originalData.operating_areas.length > 0) {
								this.operating_areas_id = this.originalData.operating_areas.map(function (item) {
									return item.id;
								});
							}
							if (this.originalData.load_locations.length > 0) {
								this.load_locations_id = this.originalData.load_locations.map(function (item) {
									return item.id;
								});
							}

							if (this.originalData.unload_locations.length > 0) {
								this.unload_locations_id = this.originalData.unload_locations.map(function (item) {
									return item.id;
								});
							}

							if (this.originalData.favorites_load.length > 0) {
								this.favorites_load_id = this.originalData.favorites_load.map(function (item) {
									return item.id;
								});
							}

							if (this.originalData.favorites_unload.length > 0) {
								this.favorites_unload_id = this.originalData.favorites_unload.map(function (item) {
									return item.id;
								});
							}

							var l_locations = this.loadlocationsselect;
							var l_locations_id = this.load_locations_id;
							var oa_ll = [];
							oa_ll = l_locations_id.map(function (item) {
								var oa_index = l_locations.map(function (o) {
									return o.id;
								}).indexOf(item);
								if (oa_index > -1) {
									return l_locations[oa_index];
								}
							});
							this.favorites_load_select = oa_ll;

							var ul_locations = this.unloadlocationsselect;
							var ul_locations_id = this.unload_locations_id;
							var oa_ul = ul_locations_id.map(function (item) {
								var oa_index = ul_locations.map(function (o) {
									return o.id;
								}).indexOf(item);
								if (oa_index > -1) {
									return ul_locations[oa_index];
								}
							});

							this.favorites_unload_select = this.arrayUnique(oa_ul);

							this.start = true;
						}
					} else {
						var _truckingcompanies = this.updateData.roles[current_user_role_index].trucking_companies;
						this.truckingcompanyselect = Array.isArray(_truckingcompanies) ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_truckingcompanies)) : [];
						this.showTC = true;
						this.showEC = false;
						this.trucking_company_id = '';
						if (this.current_user_role_name === 'driver') {
							this.showExtras = true;
							this.loadlocationsselect = [];
							this.unloadlocationsselect = [];
							this.load_locations_id = [];
							this.unload_locations_id = [];
							this.indeterminateOA = false;
							this.oaAllSelected = false;
							this.indeterminateLL = false;
							this.llAllSelected = false;
							this.indeterminateUL = false;
							this.ulAllSelected = false;
						} else {
							this.showExtras = false;
						}
					}
				} else if (current_user_role_name === 'operations_manager' || current_user_role_name === 'marketing_accountant' || current_user_role_name === 'analyst' || current_user_role_name === 'super_analyst') {
					this.operating_areas_id = [];
					var energy_companies = user_roles[current_user_role_index].energy_companies;
					this.energycompanyselect = energy_companies;
					setTimeout(function () {
						_this.energy_company_id = _this.originalData.energy_company_id;
						_this.$forceUpdate();
					}, 200);

					var ec_index = energy_companies.map(function (o) {
						return o.id;
					}).indexOf(this.energy_company_id);
					if (ec_index > -1) {
						this.operatingareasselect = energy_companies[ec_index].operating_areas;
					}

					var operating_areas_id = this.operating_areas_id;
					var operating_areas = this.operating_areas;
					if (operating_areas.length > 0) {
						operating_areas_id = operating_areas.map(function (item) {
							return item.id;
						});
					}
					this.operating_areas_id = operating_areas_id;
					this.start1 = true;
				}
			}
		},
		editUser: function editUser() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			this.user_id = this.originalData.id;
			this.username = this.originalData.username;
			this.first_name = this.originalData.first_name;
			this.last_name = this.originalData.last_name;
			this.email = this.originalData.email;
			this.phone = this.originalData.phone;
			this.terminal_boss_user_id = this.originalData.terminal_boss_user_id;
			this.new_password = '';

			this.confirm_new_password = '';


			this.user_role_id = this.originalData.role_id;
			this.current_user_role_name = this.originalData.role.toLowerCase();
			this.updated_at = this.originalData.updated_at;

			this.user_role = this.originalData.role.trim().replace(/_/g, " ").split(" ").map(function (item) {
				return item.charAt(0).toUpperCase() + item.slice(1);
			}).join(" ");

			if (this.originalData.trucking_company_name) {
				this.showTC = true;
				this.trucking_company_name = this.originalData.trucking_company_name;
				this.trucking_company_id = this.originalData.trucking_company_id;
			}

			if (this.originalData.energy_company_name) {
				this.showEC = true;
				this.energy_company_name = this.originalData.energy_company_name.trim().split(" ").map(function (item) {
					return item.charAt(0).toUpperCase() + item.slice(1);
				}).join(" ");
			}

			if (this.originalData.role == 'driver') {
				this.showExtras = true;
				this.operating_areas = this.originalData.operating_areas;
				this.load_locations = this.originalData.load_locations;
				this.unload_locations = this.originalData.unload_locations;
				this.favorites_load = this.originalData.favorites_load;
				this.favorites_unload = this.originalData.favorites_unload;
				var filesCount = this.originalData.files.length;
				if (filesCount > 0) {
					this.emptyFiles = false;
					this.itemsFiles = [];
					for (var i = 0; i < filesCount; i++) {
						this.itemsFiles.push(this.originalData.files[i]);
					}
				}
			}

			if (this.originalData.role == 'operations_manager' || this.originalData.role == 'analyst' || this.originalData.role == 'super_analyst' || this.originalData.role == 'marketing_accountant') {
				this.energy_company_id = 0;
				if (this.originalData.operating_areas == null) {
					this.operating_areas_access = true;
				} else {
					this.operating_areas_access = false;
					this.operating_areas_id = [];
					this.operating_areas = [];
					var operating_areas_id = [];
					var operating_areas = this.originalData.operating_areas_sel;
					this.operating_areas = operating_areas;
					if (operating_areas.length > 0) {
						operating_areas_id = operating_areas.map(function (item) {
							return item.id;
						});
					}
					this.operating_areas_id = operating_areas_id;

					if (operating_areas_id.length != 0) {
						var ll = operating_areas_id.map(function (item) {
							var oa_index = operating_areas.map(function (o) {
								return o.id;
							}).indexOf(item);
							if (oa_index > -1) {
								return operating_areas[oa_index].load_locations.map(function (o) {
									return o.id;
								});
							}
						});

						var ul = operating_areas_id.map(function (item) {
							var oa_index = operating_areas.map(function (o) {
								return o.id;
							}).indexOf(item);
							if (oa_index > -1) {
								return operating_areas[oa_index].unload_locations.map(function (o) {
									return o.id;
								});
							}
						});
						this.load_locations_id = Array.prototype.concat.apply([], ll);
						this.unload_locations_id = Array.prototype.concat.apply([], ul);
					} else {
						this.load_locations_id = [];
						this.unload_locations_id = [];
					}
				}
				this.manage_intraday = this.originalData.manage_intraday;
			}
		},
		getUserData: function getUserData() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] === 'success') {
					_this2.originalData = data[1];
					_this2.updateData = data[2];
					_this2.restoreOriginalData();
					_this2.subTitle = _this2.originalData.username.trim().replace(/_/g, " ").split(" ").map(function (item) {
						return item.charAt(0).toUpperCase() + item.slice(1);
					}).join(" ");

					_this2.found = true;
					_this2.loadingData = false;

					_this2.role = data[3];
					if (_this2.role == 'super_admin') {
						_this2.view = true;
						_this2.view1 = true;
					} else if (_this2.role == 'operations_manager' || _this2.role == 'marketing_accountant' || _this2.role == 'super_analyst' || _this2.role == 'analyst') {
						_this2.view = false;
						_this2.view1 = false;
					} else if (_this2.role == 'trucking_company_admin' || _this2.role == 'trucking_company_admin_light' || _this2.role === 'trucking_operational_manager') {
						_this2.view = false;
						_this2.view1 = true;
					}
					_this2.getUpdateData();
				} else {
					_this2.items = [];
					_this2.found = false;
					_this2.loadingData = false;
					_this2.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.user_role_id === undefined || this.user_role_id.length == 0) {
				this.$swal('Alert!', 'User Role not selected', 'warning');
				return false;
			} else if (this.username === null || String(this.username).trim().length == 0) {
				this.$swal('Alert!', 'Username can not be empty', 'warning');
				return false;
			} else if (this.first_name === null || String(this.first_name).trim().length == 0) {
				this.$swal('Alert!', 'First Name can not be empty', 'warning');
				return false;
			} else if (this.last_name === null || String(this.last_name).trim().length == 0) {
				this.$swal('Alert!', 'Last Name can not be empty', 'warning');
				return false;
			}

			if (String(this.new_password).trim().length > 0 || String(this.confirm_new_password).trim().length > 0) {
				if (String(this.new_password).trim().length == 0) {
					this.$swal('Alert!', 'New Password can not be empty', 'warning');
					return false;
				} else if (String(this.confirm_new_password).trim().length == 0) {
					this.$swal('Alert!', 'Confirm new Password can not be empty', 'warning');
					return false;
				} else if (String(this.confirm_new_password).trim() !== String(this.new_password).trim()) {
					this.$swal('Alert!', 'New Password does not match the confirm password', 'warning');
					return false;
				}
			}

			if (this.current_user_role_name === 'operations_manager' || this.current_user_role_name === 'marketing_accountant' || this.current_user_role_name === 'super_analyst') {
				if (this.energy_company_id === undefined || this.energy_company_id.length == 0) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			} else if (this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
				if (this.trucking_company_id === undefined || this.trucking_company_id.length == 0) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}

			return true;
		},
		updateUser: function updateUser() {
			var _this3 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var dataUser = {
				username: this.username,
				email: this.email,
				last_name: this.last_name,
				first_name: this.first_name,
				role_id: this.user_role_id,

				new_password: this.new_password,
				new_new_password: this.confirm_new_password

			};
			if (this.current_user_role_name === 'operations_manager') {
				dataUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataUser, {
					energy_company_id: this.energy_company_id,
					operating_areas_all: true
				});
			} else if (this.current_user_role_name === 'marketing_accountant' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'analyst') {
				dataUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataUser, {
					energy_company_id: this.energy_company_id,
					operating_areas_all: this.operating_areas_access,
					load_locations: this.load_locations_id,
					unload_locations: this.unload_locations_id,
					operating_areas: this.operating_areas_id,
					manage_intraday: this.manage_intraday

				});
			} else if (this.current_user_role_name === 'driver') {
				Array.prototype.unique = function (a) {
					return function () {
						return this.filter(a);
					};
				}(function (a, b, c) {
					return c.indexOf(a, b + 1) < 0;
				});
				var load_locations_id = [];
				if (this.favorites_load_id.length != 0) {
					load_locations_id = this.favorites_load_id.map(function (item) {
						return {
							id: String(item)
						};
					});
				}
				var unload_locations_id = [];
				if (this.favorites_unload_id.length != 0) {
					unload_locations_id = this.favorites_unload_id.map(function (item) {
						return {
							id: String(item)
						};
					});
				}
				dataUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataUser, {
					phone: this.phone,
					trucking_company_id: this.trucking_company_id,
					operating_areas: this.operating_areas_id.map(function (item) {
						return {
							id: String(item)
						};
					}),
					load_locations: load_locations_id,
					unload_locations: unload_locations_id,
					terminal_boss_user_id: this.terminal_boss_user_id
				});
			} else if (this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
				dataUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataUser, {
					trucking_company_id: this.trucking_company_id
				});
			}
			__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].update(this.id, dataUser).then(function (data) {
				_this3.$swal(data[0], data[1], data[0]).then(function (result) {
					if (data[0] == 'success') {
						_this3.loadingData = true;
						_this3.found = false;
						_this3.getUserData();
						_this3.edit = false;
					}
				});
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		deleteUser: function deleteUser() {
			var _this4 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this User: " + this.username + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].delete(_this4.id).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this4.$router.replace('/users');
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		saveDocuments: function saveDocuments() {
			var _this5 = this;

			var userDocuments = [];
			if (this.documents == '') {
				this.$swal('Atention!', 'Please, select a file. ', 'warning');
			} else {
				var extensionfile = this.documents.type.split('/');

				if (this.filetitle == '') {
					this.$swal('Atention!', 'Tittle must be not empty. ', 'warning');
				} else if (this.documents.size > 2097152) {
					this.$swal('Atention!', 'Only files up to 2MB are allowed to upload. ', 'warning');
				} else {
					if (extensionfile[1] == 'pdf' || extensionfile[1] == 'jpg' || extensionfile[1] == 'png' || extensionfile[1] == 'jpeg') {

						this.getFileReader(this.documents).then(function (textFile) {
							var currentFile = {
								name: _this5.documents.name,
								comment: _this5.filetitle,
								file: textFile
							};
							userDocuments.push(currentFile);

							var senDocuments = {
								documents: userDocuments
							};
							__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].saveDocuments(senDocuments, _this5.id).then(function (data) {
								_this5.$swal(data[0], data[1], data[0]).then(function (result) {
									if (data[0] == 'success') {
										_this5.getUserData();
										_this5.newDocuments = false;
									}
								});
							}).catch(function (error) {
								_this5.$swal('Error', 'Server not response. ' + error, 'error');
							});
						});
					} else {
						this.$swal('Atention!', 'Only the following extensions are allowed .png .jpg .jpge .pdf. ', 'warning');
					}
				}
			}
		},
		getFileReader: function getFileReader(document) {
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var reader = new FileReader();
				reader.readAsDataURL(document);
				reader.onload = function (e) {
					var textFile = "";
					textFile = e.target.result;
					resolve(textFile);
				};
			});
		},
		resetModal: function resetModal() {
			this.documents = '';
			this.filetitle = '';
		},
		deleteDocument: function deleteDocument(item) {
			var _this6 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Document: " + item.file_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].deleteDocument(item.id).then(function (data) {
						_this6.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this6.getUserData();
						}
					}).catch(function (error) {
						_this6.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		rowClicked: function rowClicked(row) {
			this.$router.push('/user/' + this.id + '/documents/' + row.id);
		},

		isLetter: function isLetter(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			var tecla = String.fromCharCode(charCode).toString();
			var letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
			if (letras.indexOf(tecla) == -1) {
				if (charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			} else {
				return true;
			}
		},
		isLowerCaseEmail: function isLowerCaseEmail(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 122) {
				return true;
			} else {
				if (charCode == 45 || charCode == 46 || charCode == 64 || charCode == 95 || charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			}
		},
		isLowerCaseUsername: function isLowerCaseUsername(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode >= 97 && charCode <= 122) {
				return true;
			} else {
				if (charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			}
		},
		resend: function resend() {
			var _this7 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to send the Credentials ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].resend(_this7.id).then(function (data) {
						_this7.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							var good = 'good';
						}
					}).catch(function (error) {
						_this7.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		arrayUnique: function arrayUnique(array) {
			var a = array.concat();
			var b = a;
			for (var i = 0; i < a.length; ++i) {
				for (var j = i + 1; j < a.length; ++j) {
					if (a[i].id === a[j].id) b.splice(j--, 1);
				}
			}
			return b;
		},
		select_energy_company: function select_energy_company() {
			if ((this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') && this.energy_company_id != 0) {
				if (!this.start1) {
					this.operating_areas_id = [];
					this.load_locations_id = [];
					this.unload_locations_id = [];
				} else {
					this.start1 = false;
				}
				var energycompanies = this.energycompanyselect;
				var energy_company_id = this.energy_company_id;
				var ec_index = energycompanies.map(function (o) {
					return o.id;
				}).indexOf(energy_company_id);
				if (ec_index > -1) {
					this.operatingareasselect = energycompanies[ec_index].operating_areas;
					this.energy_company_name = energycompanies[ec_index].name;
					if (this.energy_company_name === 'Serafina Energy') {
						this.manage_intraday = this.originalData.manage_intraday;
					} else {
						this.manage_intraday = false;
					}
				}
			}
		},
		operatingAreaChange1: function operatingAreaChange1() {
			var operating_area = this.operatingareasselect;
			var operating_area_id = this.operating_areas_id;
			if (operating_area_id === true) {
				return;
			}

			if (operating_area_id.length != 0) {
				var ll = operating_area_id.map(function (item) {
					var oa_index = operating_area.map(function (o) {
						return o.id;
					}).indexOf(item);
					if (oa_index > -1) {
						return operating_area[oa_index].load_locations.map(function (o) {
							return o.id;
						});
					}
				});

				var ul = operating_area_id.map(function (item) {
					var oa_index = operating_area.map(function (o) {
						return o.id;
					}).indexOf(item);
					if (oa_index > -1) {
						return operating_area[oa_index].unload_locations.map(function (o) {
							return o.id;
						});
					}
				});
				this.load_locations_id = Array.prototype.concat.apply([], ll);
				this.unload_locations_id = Array.prototype.concat.apply([], ul);
			} else {
				operating_area = [];
				this.load_locations_id = [];
				this.unload_locations_id = [];
			}
		},
		getUpdateData: function getUpdateData() {
			var _this8 = this;

			__WEBPACK_IMPORTED_MODULE_3__users_service__["a" /* default */].getAll3().then(function (data) {
				if (data[0] === 'success') {
					_this8.updateData = data[1];
					if (_this8.edit) {
						_this8.setupFields();
					}
				} else {
					_this8.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this8.$swal('Error', 'Server not response. ' + error, 'error');
			});
		}
	}
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_service__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'userDocument',
	props: {
		id: {
			type: String,
			default: 0
		},
		idDocument: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getUserData();
	},
	data: function data() {
		return {
			user: '',
			file: '',
			fileName: '',
			fileTitle: '',
			pdf: '',
			isImage: false,
			isApplication: false,
			loadingData: true,
			found: false,
			notFoundMessage: 'Not found',
			tabIndex: 0
		};
	},

	methods: {
		getTypeDocument: function getTypeDocument(nameDocument) {
			var extensionfile = nameDocument.split('.');
			var countExtension = extensionfile.length;
			if (extensionfile[countExtension - 1] == "pdf") return "application";else return "image";
		},
		getUserData: function getUserData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__users_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] === 'success') {
					var userData = data[1];
					_this.user = userData.username;
					var filesCount = userData.files.length;
					if (filesCount > 0) {
						for (var i = 0; i < filesCount; i++) {
							if (userData.files[i].id == _this.idDocument) {
								_this.file = userData.files[i].file;
								_this.fileName = userData.files[i].file_name;
								_this.fileTitle = userData.files[i].comment;
								if (_this.getTypeDocument(_this.fileName) == "image") _this.isImage = true;else {
									_this.pdf = _this.file;
									console.log(_this.file);
									_this.isApplication = true;

									var childWindow = window.open(_this.file, "Drift File", 'width=600,height=300');
								}
								break;
							}
						}
					}
					_this.found = true;
					_this.loadingData = false;
				} else {
					_this.loadingData = false;
					_this.notFoundMessage = data[1];
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		}
	}
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__targets__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__energy_companies_ec_service__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locations_locations_service__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'targets',
  created: function created() {
    this.getAll();
    localStorage.removeItem("haulsaPage");
    localStorage.removeItem("targetsaPage");
    localStorage.removeItem("ftPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("userPage");
    if (!localStorage.targetPage) {
      localStorage.targetPage = 0;
    }
  },
  data: function data() {
    return {
      trash: false,
      dpdt: "Active",
      newTargets: false,
      loadingData: true,
      configTable: false,
      selectedItems: ['energy_company_name', 'location_name', 'fluid_type_name', 'initial_date', 'end_date', 'volume'],
      items: items,
      fields: [{ key: 'id', label: 'ID', sortable: true }, { key: 'energy_company_name', label: 'Energy Company', sortable: true }, { key: 'location_name', label: 'Unload Location', sortable: true }, { key: 'initial_date', label: 'Initial Date', sortable: true, formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
        } }, { key: 'end_date', label: 'End Date', sortable: true, formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
        } }, { key: 'volume', label: 'Volume', sortable: true }, { key: 'actions', label: 'Actions', sortable: false }],
      currentPage: parseInt(localStorage.targetPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'initial_date',
      sortDesc: false,
      filter: null,
      modalInfo: { title: '', content: '' },
      modalEdit: { title: '' },

      fluids: [],
      locations: [],
      energycompanies: [],

      model: {
        id: null,
        energy_company_id: '',
        location_id: '',
        fluid_type_ids: [],
        initial_date: '',
        end_date: '',
        volume: ''
      },
      role: '',
      view: true,
      savebtn: true,
      energy_company_id: null,
      indeterminateFT: false,
      ftAllSelected: false

    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    FTChange: function FTChange() {
      console.log(this.model.fluid_type_ids);
      if (this.model.fluid_type_ids.length === 0) {
        this.indeterminateFT = false;
        this.ftAllSelected = false;
      } else if (this.model.fluid_type_ids.length === this.fluids.length) {
        this.indeterminateFT = false;
        this.ftAllSelected = true;
      } else {
        this.indeterminateFT = true;
        this.ftAllSelected = false;
      }
    },
    FTToggleAll: function FTToggleAll(checked) {
      this.model.fluid_type_ids = checked ? this.fluids.map(function (item) {
        return item.value;
      }) : [];
    },
    trashTarget: function trashTarget() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.model[variableName];
      if (variableValue.length == 0) {
        this.model[variableName] = "0.00";
      } else {
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {
          this.model[variableName] = String(variableValue) + ".00";
        } else if (tempValue.length == 2) {
          this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
        }
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.model[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.model[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    select_energy_companies: function select_energy_companies() {
      if (this.role == 'super_admin') {
        this.fluids = [];
        this.model.fluid_type_ids = [];

        var energycompanies = this.insertData.energy_companies;
        var energy_company_index = energycompanies.map(function (o) {
          return o.id;
        }).indexOf(this.model.energy_company_id);
        if (energy_company_index > -1) {
          var fluid_types = energycompanies[energy_company_index].fluid_types;
          this.fluids = fluid_types.map(function (item) {
            return { 'value': item.id, 'text': item.name };
          });

          console.log(this.fluids);
        }
      }
    },
    rowClicked: function rowClicked(row) {
      localStorage.targetPage = this.currentPage;
      if (!this.trash) {
        this.$router.push('/target/' + row.id + '/');
      } else {
        this.restoreTarget(row.id);
      }
    },
    newTargetModal: function newTargetModal(row) {
      if (row) {
          var datei = new Date(row.item.initial_date + 'T00:00:00');
          var firstDay = new Date(datei.getFullYear(), datei.getMonth() + 1, 1);
          var lastDay = new Date(datei.getFullYear(), datei.getMonth() + 2, 0);
          this.model = {
            energy_company_id: row.item.energy_company_id,
            location_id: row.item.location_id,
            fluid_type_ids: [],

            initial_date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(firstDay).format("YYYY-MM-DD"),
            end_date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(lastDay).format("YYYY-MM-DD"),
            volume: row.item.volume.replace(',', '').replace('m³', '')
          };
        } else {
        this.model = {
          energy_company_id: '',
          location_id: '',
          fluid_type_ids: [],
          initial_date: '',
          end_date: '',
          volume: ''
        };
      }
      this.indeterminateFT = false;
      this.ftAllSelected = false;
      this.newTargets = true;
      this.savebtn = false;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.targetPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    okToSave: function okToSave() {
      if (this.role == 'super_admin') {
        if (this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) {
          this.$swal('Alert!', 'Energy Company not selected', 'warning');
          return false;
        }
      }
      if (this.model.fluid_type_ids === undefined || this.model.fluid_type_ids.length == 0) {
        this.$swal('Alert!', 'Fluid Types not selected', 'warning');
        return false;
      } else if (this.model.location_id === undefined || this.model.location_id.length == 0) {
        this.$swal('Alert!', 'Unload Location not selected', 'warning');
        return false;
      } else if (this.model.volume === undefined || this.model.volume.length == 0) {
        this.$swal('Alert!', 'Water Actual can not be empty', 'warning');
        return false;
      }

      try {
        var startDateValidation = new Date(this.model.initial_date).getFullYear();
        if (startDateValidation <= 2000 || startDateValidation >= 2100 || isNaN(startDateValidation)) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'Initial Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      try {
        var endDateValidation = new Date(this.model.end_date).getFullYear();
        if (endDateValidation <= 2000 || endDateValidation >= 2100 || isNaN(endDateValidation)) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      return true;
    },
    saveTargets: function saveTargets() {
      var _this = this;

      this.inputBlur('volume');

      if (!this.okToSave()) {
        return;
      }

      this.savebtn = true;
      if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
        this.model.energy_company_id = this.energy_company_id;
      }
      var model = {
        location_id: this.model.location_id,
        fluid_type_id: this.model.fluid_type_ids,
        energy_company_id: this.model.energy_company_id,
        initial_date: this.model.initial_date,
        end_date: this.model.end_date,
        volume: parseFloat(parseFloat(this.model.volume).toFixed(2))
      };

      __WEBPACK_IMPORTED_MODULE_2__targets__["a" /* default */].save(model).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]);
        if (data[0] == 'success') {
          _this.newTargets = false;
          _this.getAll();
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_2__targets__["a" /* default */].getAll().then(function (data) {
        if (data[0] == 'success') {
          _this2.items = data[1].filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
          _this2.insertData = data[2];
          _this2.locations = _this2.insertData.unloads_locations.map(function (item) {
            return { 'value': item.id, 'text': item.name };
          });
          if (_this2.locations.length == 1) {
            _this2.model.location_id = _this2.locations[0].value;
          } else {
            _this2.model.location_id = '';
          }

          _this2.role = data[3];
          if (_this2.role == 'super_admin') {
            _this2.view = true;
            _this2.energycompanies = _this2.insertData.energy_companies.map(function (item) {
              return { 'value': item.id, 'text': item.company_name };
            });
          } else if (_this2.role == 'super_analyst' || _this2.role == 'analyst' || _this2.role == 'marketing_accountant') {
            _this2.view = false;
            _this2.energy_company_id = data[4];
            var fluid_types = _this2.insertData.energy_companies[0].fluid_types;
            _this2.fluids = fluid_types.map(function (item) {
              return { 'value': item.id, 'text': item.name };
            });
            _this2.model.fluid_type_ids = [];
          }
        } else {
          _this2.items = [];
          _this2.$swal(data[0], data[1], data[0]);
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        _this2.$swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreTarget: function restoreTarget(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Target?",
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#a1a5a7',
        confirmButtonColor: '#ffce00',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__targets__["a" /* default */].restore(id).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]);
            if (data[0] == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__targets__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__m_fluid_types_fluidtypes__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'target',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getTargetData();
	},
	data: function data() {
		return {
			fluids: [],
			locations: [],
			energycompanies: [],
			subTitle: '',

			model: {
				id: null,
				energy_company_id: '',
				location_id: '',

				fluid_type_ids: [],
				fluid_types: [],
				initial_date: '',
				end_date: '',
				volume: '',
				formatVolume: '',
				initial_date_date: '',
				end_date_date: '',
				hauls: []
			},

			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			item: [],

			edit: false,
			originalData: null,
			dataUpdate: null,
			role: '',
			view: true,
			energy_company_id: null,
			initial_date: '',
			end_date: '',
			indeterminateFT: false,
			ftAllSelected: false
		};
	},

	methods: {
		FTChange: function FTChange() {
			var fluid_type_ids = this.model.fluid_type_ids;
			if (fluid_type_ids === true) {
				return;
			}
			if (fluid_type_ids.length === 0) {
				this.indeterminateFT = false;
				this.ftAllSelected = false;
			} else if (fluid_type_ids.length === this.fluids.length) {
				this.indeterminateFT = false;
				this.ftAllSelected = true;
			} else {
				this.indeterminateFT = true;
				this.ftAllSelected = false;
			}
		},
		FTToggleAll: function FTToggleAll(checked) {
			this.model.fluid_type_ids = checked ? this.fluids.map(function (item) {
				return item.value;
			}) : [];
		},
		inputBlur: function inputBlur(variableName) {
			var variableValue = this.model[variableName];
			if (variableValue.length == 0) {
				this.model[variableName] = "0.00";
			} else {
				var tempValue = variableValue.split(".");
				if (tempValue.length == 1) {
					this.model[variableName] = String(variableValue) + ".00";
				} else if (tempValue.length == 2) {
					this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
				}
			}
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this.model[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.model[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;

			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		select_energy_companies: function select_energy_companies() {
			this.fluids = [];
			var energycompanies = this.dataUpdate.energy_companies;
			var energy_company_index = energycompanies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			if (energy_company_index > -1) {
				var fluid_types = energycompanies[energy_company_index].fluid_types;
				this.fluids = fluid_types.map(function (item) {
					return { 'value': item.id, 'text': item.name };
				});
			}
		},
		edittarget: function edittarget() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				if (this.role == 'super_admin') {
					var energycompanies = this.dataUpdate.energy_companies;
					this.model.energy_company_id = this.originalData.energy_company_id;
					var energy_company_index = energycompanies.map(function (o) {
						return o.id;
					}).indexOf(this.model.energy_company_id);
					if (energy_company_index > -1) {
						var fluid_types = energycompanies[energy_company_index].fluid_types;
						this.fluids = fluid_types.map(function (item) {
							return { 'value': item.id, 'text': item.name };
						});
					}
				}
				this.model.fluid_type_ids = this.model.fluid_types.map(function (item) {
					return item.id;
				});
				this.model.volume = this.replaceAll(this.model.volume, ',', '');
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
			this.model.fluid_type_ids = this.model.fluid_types.map(function (item) {
				return item.id;
			});
			this.initial_date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.model.initial_date).format('MMM DD, YYYY');
			this.end_date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.model.end_date).format('MMM DD, YYYY');
		},
		getTargetData: function getTargetData() {
			var _this = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_3__targets__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] === 'success') {
					_this.originalData = data[1];
					_this.dataUpdate = data[2];

					_this.loadingData = false;
					_this.subTitle = _this.originalData.energy_company_name;
					_this.found = true;
					_this.edit = false;

					_this.locations = _this.dataUpdate.unloads_locations.map(function (item) {
						return { 'value': item.id, 'text': item.name };
					});
					if (_this.locations.length == 1) {
						_this.model.location_id = _this.locations[0].value;
					} else {
						_this.model.location_id = '';
					}

					_this.role = data[3];
					if (_this.role == 'super_admin') {
						_this.view = true;
						_this.energycompanies = _this.dataUpdate.energy_companies.map(function (item) {
							return { 'value': item.id, 'text': item.company_name };
						});
					} else if (_this.role == 'super_analyst' || _this.role == 'analyst' || _this.role == 'marketing_accountant') {
						_this.view = false;
						_this.energy_company_id = data[4];
						var fluid_types = _this.dataUpdate.energy_companies[0].fluid_types;
						_this.fluids = fluid_types.map(function (item) {
							return { 'value': item.id, 'text': item.name };
						});
					}
					_this.restoreOriginalData();
				} else {
					__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]);
					_this.loadingData = false;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.role == 'super_admin') {
				if (this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.fluid_type_ids === undefined || this.model.fluid_type_ids.length == 0) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				return false;
			} else if (this.model.location_id === undefined || this.model.location_id.length == 0) {
				this.$swal('Alert!', 'Unload Location not selected', 'warning');
				return false;
			} else if (this.model.volume === undefined || this.model.volume.length == 0) {
				this.$swal('Alert!', 'Water Actual can not be empty', 'warning');
				return false;
			}

			try {
				var startDateValidation = new Date(this.model.initial_date).getFullYear();
				if (startDateValidation <= 2000 || startDateValidation >= 2100 || isNaN(startDateValidation)) {
					throw '';
				}
			} catch (error) {
				this.$swal('Alert!', 'Initial Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
				return false;
			}

			try {
				var endDateValidation = new Date(this.model.end_date).getFullYear();
				if (endDateValidation <= 2000 || endDateValidation >= 2100 || isNaN(endDateValidation)) {
					throw '';
				}
			} catch (error) {
				this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
				return false;
			}

			return true;
		},
		updateTarget: function updateTarget() {
			var _this2 = this;

			this.inputBlur('volume');
			if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_id;
			}
			if (!this.okToUpdate()) {
				return;
			}
			var model = {
				location_id: this.model.location_id,
				fluid_type_id: this.model.fluid_type_ids,
				energy_company_id: this.model.energy_company_id,
				initial_date: this.model.initial_date,
				end_date: this.model.end_date,
				volume: parseFloat(parseFloat(this.model.volume.replace(',', '')).toFixed(2)),
				hauls: this.model.hauls
			};
			__WEBPACK_IMPORTED_MODULE_3__targets__["a" /* default */].update(this.id, model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getTargetData();
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTargets: function deleteTargets() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Target?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_3__targets__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.filter = '';
							_this3.$router.push('/targets');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		replaceAll: function replaceAll(text, busca, reemplaza) {
			while (text.toString().indexOf(busca) != -1) {
				text = text.toString().replace(busca, reemplaza);
			}return text;
		}
	}
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trucktypes__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_services_service__ = __webpack_require__(76);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mFluidTypes',
  created: function created() {
    this.getAll();
    localStorage.removeItem("haulsaPage");
    localStorage.removeItem("targetsaPage");
    localStorage.removeItem("ftPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("userPage");
    if (!localStorage.tpPage) {
      localStorage.tpPage = 0;
    }
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',

      TruckTypesName: '',
      loadingData: true,
      TruckTypesId: null,
      newTruckTypes: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Truck Type',
        sortable: true
      }],
      currentPage: parseInt(localStorage.tpPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      selectedItems: ['id', 'name'],
      configTable: false,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    newTruckTypeModal: function newTruckTypeModal() {
      this.TruckTypesName = "";
      this.savebtn = false;
      this.newTruckTypes = true;
    },
    rowClicked: function rowClicked(row) {
      localStorage.tpPage = this.currentPage;
      localStorage.setItem('xyz', row.id);
      this.$router.push('/truck_type/' + row.id + '/');
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.tpPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    okToSave: function okToSave() {
      if (this.TruckTypesName === undefined || this.TruckTypesName.trim().length == 0) {
        this.$swal('Alert!', 'Truck Type can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveTruckTypes: function saveTruckTypes() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      __WEBPACK_IMPORTED_MODULE_2__trucktypes__["a" /* default */].save(this.TruckTypesName).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]);
        if (data[0] == 'success') {
          _this.newTruckTypes = false;
          _this.TruckTypesName = '';
          _this.getAll();
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_2__trucktypes__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.truck_types;
          _this2.loadingData = false;
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;

          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trucktypes__ = __webpack_require__(152);






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'mTruckType',
	created: function created() {
		this.getTruckType();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			truckTypeName: '',

			updateData: null,
			originalData: null,

			loadingData: true
		};
	},

	methods: {
		editTT: function editTT() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			this.truckTypeName = this.originalData.name;
		},
		setupFields: function setupFields() {
			this.truckTypeName = this.originalData.name;
		},
		getTruckType: function getTruckType() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__trucktypes__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.truck_type;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.name;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;

					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.truckTypeName === undefined || this.truckTypeName.trim().length == 0) {
				this.$swal('Alert!', 'Truck Type can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateTT: function updateTT() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_2__trucktypes__["a" /* default */].update(this.id, this.truckTypeName).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getTruckType();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTT: function deleteTT(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Truck Type: " + this.truckTypeName + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__trucktypes__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/truck_types');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fluidtypes__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_services_service__ = __webpack_require__(76);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'm_fluid_types',
  created: function created() {
    this.getAll();
    localStorage.removeItem("tagetsaPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("userPage");
    if (!localStorage.ftPage) {
      localStorage.ftPage = 0;
    }
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      FluidTypesName: '',
      isolera_fluid_type_name: '',
      FluidTypesColor: '#ffff00',
      loadingData: true,
      FluidTypesId: null,
      newFluidTypes: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Fluid Type Name',
        sortable: true
      }],
      currentPage: parseInt(localStorage.ftPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      selectedItems: ['id', 'name'],
      configTable: false,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    newFluidTypeModal: function newFluidTypeModal() {
      this.FluidTypesName = "";
      this.isolera_fluid_type_name = "";
      this.savebtn = false;
      this.newFluidTypes = true;
    },
    trashFT: function trashFT() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      currentPage: parseInt(localStorage.ftPage), localStorage.setItem('xyz', row.id);
      this.$router.push('/fluid_type/' + row.id + '/');
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.ftPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    okToSave: function okToSave() {
      if (this.FluidTypesName === undefined || this.FluidTypesName.trim().length == 0) {
        this.$swal('Alert!', 'Fluid Type Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveFluidTypes: function saveFluidTypes() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var model = {
        name: this.FluidTypesName,
        isolera_fluid_type_name: this.isolera_fluid_type_name,
        color: this.FluidTypesColor
      };
      __WEBPACK_IMPORTED_MODULE_2__fluidtypes__["a" /* default */].save(model).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]);
        if (data[0] == 'success') {
          _this.newFluidTypes = false;
          _this.FluidTypesName = '';
          _this.isolera_fluid_type_name = '';
          _this.getAll();
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_2__fluidtypes__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.fluids;
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;

          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreFT: function restoreFT(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please Confirm!',
        text: "Are you sure to restore this Fluid Type?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, restore it!'
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__fluidtypes__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data[0], data[1], data[0]);
            if (data[0] == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fluidtypes__ = __webpack_require__(154);






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'mFluidType',
	created: function created() {
		this.getFluidType();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			fluidTypeColor: '#ffff00',
			fluidTypeName: '',
			isolera_fluid_type_name: '',
			updateData: null,
			originalData: null,
			loadingData: true
		};
	},

	methods: {
		editFT: function editFT() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			this.fluidTypeName = this.originalData.name;
			this.isolera_fluid_type_name = this.originalData.isolera_fluid_type_name;
			this.fluidTypeColor = this.originalData.color;
		},
		setupFields: function setupFields() {
			this.fluidTypeName = this.originalData.name;
			this.isolera_fluid_type_name = this.originalData.isolera_fluid_type_name;
			this.fluidTypeColor = this.originalData.color;
		},
		getFluidType: function getFluidType() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__fluidtypes__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.data;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.name;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;

					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.fluidTypeName === undefined || this.fluidTypeName.trim().length == 0) {
				this.$swal('Alert!', 'Fluid Type Name can not be empty', 'warning');
				return false;
			}
			if (this.fluidTypeColor === undefined || this.fluidTypeColor.trim().length == 0) {
				this.$swal('Alert!', 'Fluid Type Color invalid', 'warning');
				return false;
			}
			return true;
		},
		updateFT: function updateFT() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var model = {
				name: this.fluidTypeName,
				isolera_fluid_type_name: this.isolera_fluid_type_name,
				color: this.fluidTypeColor
			};
			console.log(model);
			__WEBPACK_IMPORTED_MODULE_2__fluidtypes__["a" /* default */].update(this.id, model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getFluidType();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteFT: function deleteFT(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Fluid Type: " + this.fluidTypeName + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__fluidtypes__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/fluid_types');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notification_services__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_services_service__ = __webpack_require__(76);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "m_fluid_types",
  created: function created() {
    this.getAll();
    localStorage.removeItem("tagetsaPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("userPage");
    if (!localStorage.ftPage) {
      localStorage.ftPage = 0;
    }
  },
  data: function data() {
    return {
      check: false,
      trash: false,
      notifications: null,
      dpdt: "Active",
      FluidTypesName: "",
      isolera_fluid_type_name: "",
      FluidTypesColor: "#ffff00",
      loadingData: true,
      FluidTypesId: null,
      newFluidTypes: false,
      items: items,
      fields: [{
        key: "select",
        label: "",
        thClass: 'select_column', tdClass: 'select_column'
      }, {
        key: "id",
        label: "ID",
        sortable: true,
        thClass: 'id_column', tdClass: 'id_column'
      }, {
        key: "fluid",
        label: "Fluid Type Name",
        sortable: true
      }],
      currentPage: parseInt(localStorage.ftPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      selectedItems: ["id", "name"],
      configTable: false,
      modalInfo: {
        title: "",
        content: ""
      },
      modalEdit: {
        title: ""
      },
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    checkedField: function checkedField() {
      var _this = this;

      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (row) {
        this.check = true;
        var new_items = this.items.map(function (value) {
          return {
            id: value.id,
            fluid: value.fluid,
            active: value.id === row.item.id ? !row.item.active : value.active
          };
        });
        var notifications = {
          notification: this.notifications,
          fluid_types: new_items
        };
        console.log("notifications", notifications);
        __WEBPACK_IMPORTED_MODULE_2__notification_services__["a" /* default */].putConfig(notifications).then(function (data) {
          if (data.status == "success") {
            _this.getAll();
            _this.$swal(data.status, data.message, data.status);
          } else {
            _this.$swal(data.status, data.message, data.status);
            _this.loadingData = false;

            return;
          }
          _this.check = false;
          _this.loadingData = false;
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal("Error", "Server not response. " + error, "error");
          _this.loadingData = false;
        });
      } else {
        var _notifications = {
          notification: !this.notifications,
          fluid_types: this.items
        };
        __WEBPACK_IMPORTED_MODULE_2__notification_services__["a" /* default */].putConfig(_notifications).then(function (data) {
          if (data.status == "success") {
            _this.getAll();
            _this.$swal(data.status, data.message, data.status);
          } else {
            _this.$swal(data.status, data.message, data.status);
            _this.loadingData = false;

            return;
          }
          _this.check = false;
          _this.loadingData = false;
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal("Error", "Server not response. " + error, "error");
          _this.loadingData = false;
        });
      }
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.ftPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.items = null;
      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_2__notification_services__["a" /* default */].getAll().then(function (data) {
        if (data.status == "success") {
          _this2.items = data.configs.notifications.fluid_types;
          _this2.notifications = data.configs.notifications.notification;
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;

          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal("Error", "Server not response. " + error, "error");
        _this2.loadingData = false;
      });
    },
    restoreFT: function restoreFT(id) {
      var _this3 = this;

      this.$swal({
        title: "Please Confirm!",
        text: "Are you sure to restore this Fluid Type?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, restore it!"
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__notification_services__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data[0], data[1], data[0]);
            if (data[0] == "success") {
              _this3.filter = "";
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal("Error", "Server not response. " + error, "error");
          });
        }
      });
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locationtypes_service__ = __webpack_require__(541);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'm_location_types',
		created: function created() {
				this.getAll();
		},
		data: function data() {
				return {
						newLocations: false,
						items: items,
						loadingData: true,
						currentPage: 1,
						perPage: 25,
						totalRows: items.length,
						pageOptions: [25, 50, 100],
						sortBy: null,
						sortDesc: false,
						fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'name', label: 'Location Type Name', sortable: true }],
						filter: null,
						modalInfo: { title: '', content: '' },
						configTable: false,
						model: {
								id: null,
								name: ''
						},
						savebtn: true
				};
		},

		computed: {
				sortOptions: function sortOptions() {
						return this.fieldsTh.filter(function (f) {
								return f.sortable;
						}).map(function (f) {
								return { text: f.label, value: f.key };
						});
				}
		},
		methods: {
				rowClicked: function rowClicked(row) {
						localStorage.setItem('xyz', row.id);
						this.$router.push('/location_type/' + row.id + '/');
				},
				onFiltered: function onFiltered(filteredItems) {
						this.totalRows = filteredItems.length;
						this.currentPage = 1;
				},
				resetModal: function resetModal() {
						this.modalInfo.title = '';
						this.modalInfo.content = '';
				},
				hideNewLocationModal: function hideNewLocationModal() {
						this.$refs.newLocationModal.hide();
				},
				showNewLocationModal: function showNewLocationModal() {
						this.model = { id: null, name: '' };
						this.savebtn = false;
						this.newLocations = true;
				},
				saveLocations: function saveLocations() {
						var _this = this;

						this.savebtn = true;
						if (this.model.name != null) {
								__WEBPACK_IMPORTED_MODULE_1__locationtypes_service__["a" /* default */].save(this.model.name).then(function (data) {
										_this.$swal(data[0], data[1], data[0]);
										if (data[0] == 'success') {
												_this.newLocations = false;
												_this.model = {};
												_this.getAll();
										}
								}).catch(function (error) {
										_this.$swal('Error', 'Server not response. ' + error, 'error');
								});
						} else {
								this.$swal('Alert!', 'Data Required', 'warning');
						}
						this.savebtn = false;
				},
				getAll: function getAll() {
						var _this2 = this;

						this.loadingData = true;
						__WEBPACK_IMPORTED_MODULE_1__locationtypes_service__["a" /* default */].getAll().then(function (data) {
								if (data[0] == 'success') {
										_this2.items = data[1];
								} else {
										_this2.items = [];
										_this2.$swal(data[0], data[1], data[0]);
								}
								_this2.loadingData = false;
						}).catch(function (error) {
								_this2.$swal('Error', 'Server not response. ' + error, 'error');
								_this2.loadingData = false;
						});
				}
		}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/locationtypes', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.locationtypes];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(TruckTypesName) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/locationtypes/create', { name: TruckTypesName }, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(locationtypeID, LocationTypeName) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/locationtype/update/' + locationtypeID + '/', { name: LocationTypeName }, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(locationtypeID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/locationtype/delete/' + locationtypeID + '/', { headers: {
					'Content-Type': 'application/json',
					'Token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(LocationTypeId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/locationtype/' + LocationTypeId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.locationtype];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locationtypes_service__ = __webpack_require__(541);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_location_type',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getLocationTypeData();
	},
	data: function data() {
		return {
			originalData: null,
			edit: false,
			loadingData: true,
			model: {
				id: null,
				name: ''
			},
			subTitle: ''
		};
	},

	methods: {
		editservice: function editservice() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = this.originalData;
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
		},
		getLocationTypeData: function getLocationTypeData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__locationtypes_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] == 'success') {
					_this.originalData = data[1];
					_this.restoreOriginalData();
					_this.subTitle = data[1].name;
					_this.loadingData = false;
				} else {
					_this.$swal(data[0], data[1], data[0]);
					_this.loadingData = false;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Location Type can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateservice: function updateservice() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_2__locationtypes_service__["a" /* default */].update(this.id, this.model.name).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getLocationTypeData;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteLocationType: function deleteLocationType() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Location Type: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__locationtypes_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.push('/location_types');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operating_areas_service__ = __webpack_require__(544);






var items = [];
var fields = ['details', 'id', 'name', 'actions'];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_operating_areas',
	created: function created() {
		this.getAll();
		localStorage.removeItem("haulsaPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("servicePage");
		localStorage.removeItem("taPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("userPage");
		if (!localStorage.oaPage) {
			localStorage.oaPage = 0;
		}
	},
	data: function data() {
		return {
			trash: false,
			isSuperAnalyst: false,
			dpdt: 'Active',
			indeterminateLL: false,
			llAllSelected: false,
			indeterminateUL: false,
			indeterminate: false,
			ulAllSelected: false,
			insert_data: null,

			newOperatingArea: false,
			items: items,
			loadingData: true,
			currentPage: parseInt(localStorage.oaPage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: null,
			sortDesc: false,
			fields: [{
				key: 'id',
				label: 'ID'
			}, {
				key: 'name',
				label: 'Operating Area Name'
			}, {
				key: 'energy_company_name',
				label: 'Energy Company Name'
			}, {
				key: 'company_cosigner',
				label: 'Company Cosigner',
				sortable: true
			}, {
				key: 'phone_number',
				label: 'Phone Number',
				sortable: true
			}],
			filter: null,
			configTable: false,
			selectedItems: ['id', 'name', 'status'],
			selected: null,
			options: [],
			operatingareaselect: [],
			energycompanyselect: [],
			loadlocationselect: [],
			unloadlocationselect: [],

			model: {
				name: '',
				energy_company_id: '',
				load_locations_id: [],
				unload_locations_id: [],
				company_cosigner: '',
				phone_number: ''
			},
			role: '',
			view: true,
			view1: true,
			savebtn: true,
			energy_company_id: null
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return {
					text: f.label,
					value: f.key
				};
			});
		}
	},
	methods: {
		rowClicked: function rowClicked(row) {
			localStorage.oaPage = this.currentPage;
			if (!this.trash) {
				localStorage.setItem('xyz', row.id);
				this.$router.push('/operating_area/' + row.id + '/');
			} else {
				this.restoreOA(row.id);
			}
		},
		trashOA: function trashOA() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		operatingAreaModal: function operatingAreaModal() {

			this.model.energy_company_id = '';
			this.model.name = '';
			this.model.company_cosigner = '';
			this.model.phone_number = '';
			this.model.load_locations_id = [];
			this.model.unload_locations_id = [];
			this.savebtn = false;
			this.newOperatingArea = true;
			if (this.role == 'super_admin') {
				this.loadlocationselect = [], this.unloadlocationselect = [];
			}
		},
		select_energy_company: function select_energy_company() {
			if (this.role == 'super_admin') {
				var energy_companies = this.insert_data.energy_companies;


				var energy_company_index = energy_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var loadlocations = energy_companies[energy_company_index].load_locations;
					var unloadlocations = energy_companies[energy_company_index].unload_locations;
					this.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
					this.unloadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(unloadlocations));
				} else {
					this.loadlocationselect = [];
					this.unloadlocationselect = [];
				}
				this.model.load_locations_id = [];
				this.model.unload_locations_id = [];
			}
		},
		LLToggleAll: function LLToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		ULToggleAll: function ULToggleAll(checked) {
			this.model.unload_locations_id = checked ? this.unloadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		loadLocationsChange: function loadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		unloadLocationsChange: function unloadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false;
					this.ulAllSelected = false;
				} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
					this.indeterminateUL = false;
					this.ulAllSelected = true;
				} else {
					this.indeterminateUL = true;
					this.ulAllSelected = false;
				}
			}
		},
		actionField: function actionField(option) {
			var fieldsThLength = this.fieldsTh.length;
			var fieldIsActive = false;
			for (var i = 0; i <= fieldsThLength; i++) {
				fieldIsActive = true;
				try {
					if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
						this.fieldsTh.splice(i, 1);
						fieldIsActive = false;
						break;
					}
				} catch (err) {
					var position = this.fields.indexOf(option);
					this.fieldsTh.splice(position, 0, option);
				}
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.oaPage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		okToSave: function okToSave() {
			if (this.role == 'super_admin' || this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'operations_manager' || this.role == 'marketing_accountant') {
				console.log('ok');
			}

			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Operating Area Name can not be empty', 'warning');
				return false;
			}

			return true;
		},
		saveOperatingAreas: function saveOperatingAreas(model) {
			var _this = this;

			this.savebtn = true;
			if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'operations_manager' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_id;
			}
			if (!this.okToSave()) {
				this.savebtn = false;
				return;
			}
			model = {
				name: model.name,
				energy_company_id: this.model.energy_company_id,
				company_cosigner: this.model.company_cosigner,
				phone_number: this.model.phone_number,
				load_locations: model.load_locations_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				unload_locations: model.unload_locations_id.map(function (item) {
					return {
						id: String(item)
					};
				})
			};
			this.savebtn = true;
			__WEBPACK_IMPORTED_MODULE_2__operating_areas_service__["a" /* default */].save(model).then(function (data) {
				_this.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this.newOperatingArea = false;
					_this.getAll();
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = true;
		},
		restoreOA: function restoreOA(id) {
			var _this2 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Operating Area?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__operating_areas_service__["a" /* default */].restore(id).then(function (data) {
						_this2.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this2.filter = '';
							_this2.trash = false;
							_this2.getAll();
							_this2.loadingData = true;
						}
					}).catch(function (error) {
						_this2.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		getAll: function getAll() {
			var _this3 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_2__operating_areas_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					_this3.items = data[1].filter(function (o) {
						return o.status_id == (_this3.trash ? 2 : 1);
					});
					_this3.insert_data = data[2];

					_this3.energycompanyselect = _this3.insert_data.energy_companies;

					_this3.truckingcompanyselect = _this3.insert_data.trucking_companies;

					_this3.role = data[3];
					if (_this3.role == 'super_admin') {
						_this3.view = true;
						_this3.view1 = true;
					} else if (_this3.role == 'super_analyst' || _this3.role == 'analyst' || _this3.role == 'marketing_accountant') {
						_this3.view = false;
						_this3.view1 = true;
						_this3.energy_company_id = data[4];
					} else if (_this3.role == 'operations_manager') {
						_this3.view = false;
						_this3.view1 = true;
						_this3.energy_company_id = data[4];
					} else if (_this3.role == 'trucking_company_admin' || _this3.role == 'trucking_operational_manager') {
						_this3.view1 = false;
					}
					_this3.get_attributtes();
				} else {
					_this3.items = [];
					_this3.$swal(data[0], data[1], data[0]);
				}
				_this3.loadingData = false;
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
				_this3.loadingData = false;
			});
		},
		get_attributtes: function get_attributtes() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_2__operating_areas_service__["a" /* default */].get_attr().then(function (data) {
				if (data[0] === 'success') {
					_this4.insert_data = data[1];
					_this4.energycompanyselect = _this4.insert_data.energy_companies;
					if (_this4.role == 'super_analyst' || _this4.role == 'analyst' || _this4.role == 'operations_manager' || _this4.role == 'marketing_accountant') {
						var loadlocations = _this4.energycompanyselect[0].load_locations;
						_this4.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
						var unloadlocations = _this4.energycompanyselect[0].unload_locations;
						_this4.unloadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(unloadlocations));
						_this4.model.load_locations_id = [];
						_this4.model.unload_locations_id = [];
					}
				} else {
					_this4.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
			});
		}
	}
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_areas/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.operating_areas, response.data.insert_data, response.data.role, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_area/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idCompany, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_area/update/' + idCompany + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_area/delete/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(companyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_area/' + companyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.operating_area, response.data.update_data, response.data.role, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_area/restore/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	assigndrivers: function assigndrivers(idCompany, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/operating_areas/assign_drivers/' + idCompany + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_attr: function get_attr() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/oa_attributtes/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.insert_data];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_attr_update: function get_attr_update() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/oa_attributtes1/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.update_data.energy_companies];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operating_areas_service__ = __webpack_require__(544);








var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_operating_area',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getOperatingAreasData();
	},
	data: function data() {
		return {
			indeterminateLL: false,
			isSuperAnalyst: false,
			llAllSelected: false,
			indeterminateUL: false,
			ulAllSelected: false,

			updateData: null,
			originalData: null,

			operatingareaselect: [],
			energycompanyselect: [],
			loadlocationselect: [],
			unloadlocationselect: [],

			model: {
				id: null,
				name: '',
				energy_company_id: '',
				company_cosigner: '',
				phone_number: '',
				load_locations_id: [],
				unload_locations_id: [],
				unload_locations: [],
				load_locations: [],
				trucking_companies: [],
				trucking_companies_id: []
			},

			subTitle: "",
			edit: false,

			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',

			items: items,
			role: '',
			view: true,
			view1: true,
			energy_company_id: null,

			truckingcompanyselect: [],
			AllSelectedtc: false,
			indeterminatetc: false,
			assign: true,
			addUsers: false
		};
	},

	methods: {
		editAssign: function editAssign() {
			if (this.addUsers) {
				this.addUsers = false;
			} else {
				if (this.role != 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
					this.addUsers = true;
					this.model.trucking_companies_id = [];
				} else {
					this.assigndrivers();
				}
			}
		},
		allCheckedLL: function allCheckedLL() {},
		allCheckedUL: function allCheckedUL() {},
		allCheckedLL1: function allCheckedLL1() {},
		allCheckedUL1: function allCheckedUL1() {},
		allCheckedTC: function allCheckedTC() {},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData, {
				unload_locations_id: [],
				load_locations_id: [],
				trucking_companies_id: []
			});
			this.model = model;
			this.unloadlocationselect = this.updateData.unload_locations;
		},
		getOperatingAreasData: function getOperatingAreasData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_5__operating_areas_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] == 'success') {
					_this.originalData = data[1];
					_this.updateData = data[2];
					_this.restoreOriginalData();
					_this.energycompanyselect = _this.updateData.energy_companies;
					_this.truckingcompanyselect = _this.updateData.trucking_companies;
					_this.subTitle = _this.originalData.name;
					_this.found = true;
					_this.loadingData = false;

					_this.role = data[3];
					if (_this.role == 'super_admin') {
						_this.view = true;
						_this.view1 = true;
					} else if (_this.role == 'super_analyst' || _this.role == 'analyst' || _this.role == 'marketing_accountant') {
						_this.view = false;
						_this.view1 = true;
						_this.energy_company_id = data[4];
					} else if (_this.role == 'trucking_company_admin' || _this.role == 'trucking_operational_manager') {
						_this.view = true;
						_this.view1 = false;
						_this.model.trucking_companies_id = _this.truckingcompanyselect[0].id;
					} else if (_this.role == 'operations_manager') {
						_this.view = false;
						_this.view1 = true;
						_this.energy_company_id = data[4];
						_this.model.energy_company_id = _this.energy_company_id;
					}
					_this.get_attributtes();
				} else {
					_this.loadingData = false;
					_this.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.role == 'super_admin') {
				if (this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Operating Area Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateOperatingArea: function updateOperatingArea(model) {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			var t1 = this.model.load_locations_id;
			var t2 = this.model.unload_locations_id;

			var t3 = [];
			if (this.model.trucking_companies_id.length != 0) {
				t3 = this.model.trucking_companies_id.map(function (item) {
					return {
						id: String(item)
					};
				});
			}
			model = {
				name: model.name,
				energy_company_id: model.energy_company_id,
				company_cosigner: this.model.company_cosigner,
				phone_number: this.model.phone_number,
				load_locations: t1.map(function (item) {
					return {
						id: String(item)
					};
				}),
				unload_locations: t2.map(function (item) {
					return {
						id: String(item)
					};
				}),
				trucking_company: t3
			};

			this.model.id = this.id;
			__WEBPACK_IMPORTED_MODULE_5__operating_areas_service__["a" /* default */].update(this.id, model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getOperatingAreasData();
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteOperatingArea: function deleteOperatingArea() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Operating Area: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_5__operating_areas_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.filter = '';
							_this3.$router.push('/operating_areas');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		editOA: function editOA() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		select_energy_company: function select_energy_company() {
			if (this.role == 'super_admin' || this.role == 'operations_manager' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
				var energy_companies = this.updateData.energy_companies;
				var loadlocations = [];
				var energy_company_index = energy_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					loadlocations = energy_companies[energy_company_index].load_locations;
				}

				this.loadlocationselect = loadlocations;
			}
		},
		LLToggleAll: function LLToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		ULToggleAll: function ULToggleAll(checked) {
			this.model.unload_locations_id = checked ? this.unloadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		TCToggleAll: function TCToggleAll(checked) {
			this.model.trucking_companies_id = checked ? this.truckingcompanyselect.map(function (item) {
				return item.id;
			}) : [];
		},
		loadLocationsChange: function loadLocationsChange() {
			if (this.role == 'super_admin' || this.role == 'operations_manager') {
				if (this.model.load_locations_id === null) {
					return;
				}
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		unloadLocationsChange: function unloadLocationsChange() {
			if (this.role == 'super_admin' || this.role == 'operations_manager') {
				if (this.model.unload_locations_id === null) {
					return;
				}
				if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false;
					this.ulAllSelected = false;
				} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
					this.indeterminateUL = false;
					this.ulAllSelected = true;
				} else {
					this.indeterminateUL = true;
					this.ulAllSelected = false;
				}
			}
		},
		truckingcompanyChange: function truckingcompanyChange() {
			if (this.role == 'super_admin') {
				if (this.model.trucking_companies_id === null) {
					return;
				}

				if (this.model.trucking_companies_id.length === 0) {
					this.indeterminatetc = false;
					this.AllSelectedtc = false;
				} else if (this.model.trucking_companies_id.length === this.truckingcompanyselect.length) {
					this.indeterminatetc = false;
					this.AllSelectedtc = true;
				} else {
					this.indeterminatetc = true;
					this.AllSelectedtc = false;
				}
			}
		},
		setupFields: function setupFields() {
			this.model.trucking_companies_id = [];
			var energy_companies = this.updateData.energy_companies;

			var energy_company_index = energy_companies.map(function (o) {
				return o.id;
			}).indexOf(this.model.energy_company_id);
			var loadlocations = [];
			if (energy_company_index > -1) {
				loadlocations = energy_companies[energy_company_index].load_locations;
			}

			if (loadlocations.length > 0) {
				this.loadlocationselect = this.arrayUnique(loadlocations);
			} else {
				this.loadlocationselect = [];
			}
			if (this.model.load_locations.length > 0) {
				this.model.load_locations_id = this.model.load_locations.map(function (item) {
					return item.id;
				});
			}

			if (this.model.unload_locations.length > 0) {
				this.model.unload_locations_id = this.model.unload_locations.map(function (item) {
					return item.id;
				});
			}

			this.model.trucking_companies_id = [];
		},
		arrayUnique: function arrayUnique(array) {
			var a = array.concat();
			for (var i = 0; i < a.length; ++i) {
				for (var j = i + 1; j < a.length; ++j) {
					if (a[i].id === a[j].id) a.splice(j--, 1);
				}
			}
			return a;
		},
		assigndrivers: function assigndrivers() {
			var _this4 = this;

			this.assign = false;
			var model = {
				operating_area_id: this.id,
				energy_company_id: this.model.energy_company_id,
				load_locations: this.model.load_locations,
				unload_locations: this.model.unload_locations,
				trucking_companies: this.model.trucking_companies_id
			};
			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to assign all drivers to trucking companies selected?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_5__operating_areas_service__["a" /* default */].assigndrivers(_this4.id, model).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							console.log('good');
							_this4.assign = true;
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
			this.addUsers = false;
		},
		get_attributtes: function get_attributtes() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_5__operating_areas_service__["a" /* default */].get_attr_update().then(function (data) {
				if (data[0] === 'success') {
					_this5.updateData.energy_companies = data[1];
					_this5.energycompanyselect = _this5.updateData.energy_companies;
					if (_this5.role == 'operations_manager') {
						_this5.select_energy_company();
					}
				} else {
					_this5.$swal(data[0], data[1], data[0]);
				}
			}).catch(function (error) {
				_this5.$swal('Error1', 'Server not response. ' + error, 'error');
			});
		}
	}
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ec_service__ = __webpack_require__(53);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'energyCompany',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			truckingcompaniesselect: [],
			model: {
				energy_company_name: '',
				trucking_company_id: [],
				trucking_companies: [],
				isolera: false,
				petrotranz: null,
				filter: '',
				address: '',
				phone_number_24: '',
				cnr_inputs: 'false'
			},

			indeterminateTC: false,
			tcAllSelected: false,

			updateData: null,
			originalData: null,

			loadingData: true,

			petrotranz: [],
			petrotranz_origin: [],
			codes: [],
			model1: {
				petrotranz_company_id: { id: null, name: '', codes: [] }
			},
			indeterminatePT: false,
			ptAllSelected: false,
			size: 6,
			offset: '',
			ready: false,
			suggest: true,
			filtered: ''
		};
	},

	watch: {
		filtered: function filtered(val, oldVal) {
			this.petrotranz = [];
			this.model.filter = val;
			this.filter_p(this.model.filter);
		}
	},
	methods: {
		allCheckedTC: function allCheckedTC() {
			return Array(this.model.trucking_companies.length).fill(true);
		},
		editEC: function editEC() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		TCChange: function TCChange() {
			if (this.model.trucking_company_id.length === 0) {
				this.indeterminateTC = false;
				this.tcAllSelected = false;
			} else if (this.model.trucking_company_id.length === this.truckingcompaniesselect.length) {
				this.indeterminateTC = false;
				this.tcAllSelected = true;
			} else {
				this.indeterminateTC = true;
				this.tcAllSelected = false;
			}
		},
		TCToggleAll: function TCToggleAll(checked) {
			this.model.trucking_company_id = checked ? this.truckingcompaniesselect.map(function (item) {
				return item.id;
			}) : [];
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
				trucking_companies: []
			}, this.originalData, {
				energy_company_name: this.originalData.company_name,
				trucking_company_id: []
			});
			if (model.isolera == 'True') {
				model.isolera = true;
			} else {
				model.isolera = false;
			}
			this.model = model;
			this.filtered = this.model.filter;
		},
		setupFields: function setupFields() {

			if (this.model.trucking_companies.length > 0) {
				this.model.trucking_company_id = this.model.trucking_companies.map(function (item) {
					return item.id;
				});
			}
			if (this.model.petrotranz != null) {
				this.model1.petrotranz_company_id.id = this.model.petrotranz.id;
				this.model1.petrotranz_company_id.name = this.model.petrotranz.name;
				this.model1.petrotranz_company_id.codes = this.model.petrotranz.codes;
				var energy_companies = this.updateData.petrotranz;
				var codes = [];
				var energy_company_index = energy_companies.map(function (o) {
					return o.id.id;
				}).indexOf(this.model1.petrotranz_company_id.id);
				if (energy_company_index > -1) {
					codes = energy_companies[energy_company_index].codes;
				}
				this.codes = codes;
			}
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.energy_company;
					_this.updateData = data.update_data;
					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.company_name;
					_this.truckingcompaniesselect = _this.updateData.trucking_companies;
					_this.petrotranz = _this.updateData.petrotranz;
					_this.petrotranz_origin = _this.updateData.petrotranz;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.energy_company_name === undefined || this.model.energy_company_name.trim().length == 0) {
				this.$swal('Alert!', 'Energy Company Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateEC: function updateEC() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var model = {
				company_name: this.model.energy_company_name,
				trucking_companies: this.model.trucking_company_id.map(function (item) {
					return {
						id: String(item)
					};
				}),
				isolera: this.model.isolera,
				petrotranz: this.model1.petrotranz_company_id,
				address: this.model.address,
				phone_number_24: this.model.phone_number_24,
				cnr_inputs: this.model.cnr_inputs
			};
			__WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].update(this.companyId, model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteEC: function deleteEC(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Energy Company: " + this.model.company_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].delete(_this3.companyId).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/energy_companies');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		select_petrotranz: function select_petrotranz() {
			this.size = 1;
			var energy_companies = this.updateData.petrotranz;
			var codes = [];
			var energy_company_index = energy_companies.map(function (o) {
				return o.id.id;
			}).indexOf(this.model1.petrotranz_company_id.id);
			if (energy_company_index > -1) {
				codes = energy_companies[energy_company_index].codes;
			}
			this.codes = codes;
			this.model1.petrotranz_company_id.codes = [];
			this.suggest = false;
			this.model.filter = this.model1.petrotranz_company_id.name;
			this.filtered = this.model.filter;
		},
		PTToggleAll: function PTToggleAll(checked) {
			this.model1.petrotranz_company_id.codes = checked ? this.codes.map(function (item) {
				return item.id;
			}) : [];
		},
		codesChange: function codesChange() {
			if (this.model1.petrotranz_company_id.codes === true) {
				this.model1.petrotranz_company_id.codes = [];
				return;
			}
			if (this.model1.petrotranz_company_id === null) {
				return;
			}
			if (this.model1.petrotranz_company_id.codes.length === 0) {
				this.indeterminatePT = false;
				this.ptAllSelected = false;
			} else if (this.model1.petrotranz_company_id.codes.length === this.codes.length) {
				this.indeterminatePT = false;
				this.ptAllSelected = true;
			} else {
				this.indeterminatePT = true;
				this.ptAllSelected = false;
			}
		},
		keyMonitor: function keyMonitor(evt) {
			if (evt.key.match(/[a-zA-Z]/i) === null) {
				evt.preventDefault();
				return;
			} else {
				evt = evt ? evt : window.event;
				var key = evt.key;
				this.offset = key;
				this.suggest = true;
				if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
					return;
				} else if (key == "Backspace") {
					var splitter = this.filtered.split("(");
					this.filtered = splitter[0];
					this.model.filter = this.filtered;
					this.petrotranz = [];
					this.filter_p(this.model.filter);
					this.model1.petrotranz_company_id.id = null;
					return;
				} else if (key == "Delete") {
					return;
				} else {
					return;
				}
			}
		},
		veo: function veo() {
			if (this.offset === "Delete") {
				this.petrotranz = [];
				this.filter_p(this.model.filter);
			}
		},
		filter_p: function filter_p(check_filter) {
			var _this4 = this;

			this.size = 6;
			if (this.model.filter !== '' && this.model.filter.length > 2) {
				this.ready = true;
				__WEBPACK_IMPORTED_MODULE_1__ec_service__["a" /* default */].petrotranz(this.model.filter).then(function (data) {
					if (data.status == 'success') {
						if (_this4.model.filter == check_filter) {
							_this4.petrotranz = data.petrotranz;
							_this4.updateData.petrotranz = _this4.petrotranz;
						}
						_this4.ready = false;
					} else {
						_this4.$swal(data.status, data.message, data.status);
						_this4.ready = false;
						return;
					}
				}).catch(function (error) {
					_this4.$swal('Error', 'Server not response. ' + error, 'error');
					_this4.ready = false;
				});
			}
		}
	}
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__roles_service__ = __webpack_require__(60);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'm_roles',
		created: function created() {
				this.getAll();
				localStorage.removeItem("targetsaPage");
				localStorage.removeItem("ftPage");
				localStorage.removeItem("targetPage");
				localStorage.removeItem("tpPage");
				localStorage.removeItem("oasaPage");
				localStorage.removeItem("oaPage");
				localStorage.removeItem("reportPage");
				localStorage.removeItem("tasaPage");
				localStorage.removeItem("servicePage");
				localStorage.removeItem("taPage");
				localStorage.removeItem("tcPage");
				localStorage.removeItem("locationPage");
				localStorage.removeItem("truckPage");
				localStorage.removeItem("userPage");
				if (!localStorage.rolesPage) {
						localStorage.rolesPage = 0;
				}
		},
		data: function data() {
				return {
						newLocations: false,
						items: items,
						loadingData: true,
						currentPage: parseInt(localStorage.rolesPage),
						perPage: 25,
						totalRows: items.length,
						pageOptions: [25, 50, 100],
						sortBy: null,
						sortDesc: false,
						fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'name', label: 'Role Name', sortable: true }],
						filter: null,
						modalInfo: { title: '', content: '' },
						configTable: false,
						model: {
								id: null,
								name: ''
						},
						savebtn: true
				};
		},

		computed: {
				sortOptions: function sortOptions() {
						return this.fieldsTh.filter(function (f) {
								return f.sortable;
						}).map(function (f) {
								return { text: f.label, value: f.key };
						});
				}
		},
		methods: {
				rowClicked: function rowClicked(row) {
						localStorage.rolesPage = this.currentPage;
						localStorage.setItem('xyz', row.id);
						this.$router.push('/role/' + row.id + '/');
				},
				onFiltered: function onFiltered(filteredItems) {
						this.currentPage = parseInt(localStorage.rolesPage);
						this.totalRows = filteredItems.length;
						this.currentPage = 1;
				},
				resetModal: function resetModal() {
						this.modalInfo.title = '';
						this.modalInfo.content = '';
				},
				hideNewLocationModal: function hideNewLocationModal() {
						this.$refs.newLocationModal.hide();
				},
				showNewLocationModal: function showNewLocationModal() {
						this.model = { id: null, name: '' };
						this.savebtn = false;
						this.newLocations = true;
				},
				saveLocations: function saveLocations() {
						var _this = this;

						this.savebtn = true;
						if (this.model.name != null) {
								__WEBPACK_IMPORTED_MODULE_1__roles_service__["a" /* default */].save(this.model.name).then(function (data) {
										_this.$swal(data[0], data[1], data[0]);
										if (data[0] == 'success') {
												_this.newLocations = false;
												_this.model = {};
												_this.getAll();
										}
								}).catch(function (error) {
										_this.$swal('Error', 'Server not response. ' + error, 'error');
								});
						} else {
								this.$swal('Alert!', 'Data Required', 'warning');
						}
						this.savebtn = false;
				},
				getAll: function getAll() {
						var _this2 = this;

						this.loadingData = true;
						__WEBPACK_IMPORTED_MODULE_1__roles_service__["a" /* default */].getAll().then(function (data) {
								if (data[0] == 'success') {
										_this2.items = data[1];
								} else {
										_this2.items = [];
										_this2.$swal(data[0], data[1], data[0]);
								}
								_this2.loadingData = false;
						}).catch(function (error) {
								_this2.$swal('Error', 'Server not response. ' + error, 'error');
								_this2.loadingData = false;
						});
				}
		}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roles_service__ = __webpack_require__(60);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_role',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getRoleData();
	},
	data: function data() {
		return {
			originalData: null,
			edit: false,
			loadingData: true,
			model: {
				id: null,
				name: ''
			},
			subTitle: ""
		};
	},

	methods: {
		editservice: function editservice() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = this.originalData;
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
		},
		getRoleData: function getRoleData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__roles_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.role;
					_this.restoreOriginalData();
					_this.subTitle = data.name;
					_this.loadingData = false;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;

					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Role Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateservice: function updateservice() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			this.model.id = this.id;
			__WEBPACK_IMPORTED_MODULE_2__roles_service__["a" /* default */].update(this.id, this.model.name).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getRoleData();
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteservice: function deleteservice() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Role: " + this.subTitle + "?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__roles_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.push('/roles');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_service__ = __webpack_require__(1150);





var items = [];
var energy_companies = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'keys',
	created: function created() {
		this.getAll();
	},
	data: function data() {
		return {
			newLocations: false,
			items: items,
			energy_companies: energy_companies,
			loadingData: true,
			currentPage: parseInt(localStorage.rolesPage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: null,
			sortDesc: false,
			fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'key', label: 'Key', sortable: true }, { key: 'company_type', label: 'Company Type', sortable: true }, { key: 'company_name', label: 'Company Name', sortable: true }, { key: 'created_by_user', label: 'Created By', sortable: true }, { key: 'created_at', label: 'Created At', sortable: true }, { key: 'updated_at', label: 'Updated At', sortable: true }, { key: 'actions', label: 'Actions', sortable: false }],
			filter: null,
			modalInfo: { title: '', content: '' },
			configTable: false,
			model: {
				company_id: 0,
				company_name: '',
				company_type_id: 0
			},
			savebtn: true,
			energy_company_id: null,
			company_type: [],
			company_name: [],
			role: ''
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return { text: f.label, value: f.key };
			});
		}
	},
	methods: {
		copyKey: function copyKey(row) {
			this.$swal('Copied!', 'You just copied: ' + row.item.key, 'success');
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.rolesPage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		hideNewLocationModal: function hideNewLocationModal() {
			this.$refs.newLocationModal.hide();
		},
		showNewLocationModal: function showNewLocationModal() {
			this.model = {
				company_id: 0,
				company_name: '',
				company_type_id: 0
			};
			this.savebtn = false;
			this.newLocations = true;
		},
		renewKey: function renewKey(row) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__keys_service__["a" /* default */].renewKey(row.item.id).then(function (data) {
				_this.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this.newLocations = false;
					_this.model = {};
					_this.getAll();
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = false;
		},
		deleteKey: function deleteKey(row) {
			var _this2 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Key?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__keys_service__["a" /* default */].deleteKey(row.item.id).then(function (data) {
						_this2.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this2.newLocations = false;
							_this2.model = {};
							_this2.getAll();
						}
					}).catch(function (error) {
						_this2.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
			this.edit = false;
		},
		assignKey: function assignKey() {
			var _this3 = this;

			this.savebtn = true;
			console.log(this.model);
			if (this.model != null) {
				__WEBPACK_IMPORTED_MODULE_1__keys_service__["a" /* default */].save(this.model).then(function (data) {
					_this3.$swal(data[0], data[1], data[0]);
					if (data[0] == 'success') {
						_this3.newLocations = false;

						_this3.getAll();
					}
				}).catch(function (error) {
					_this3.$swal('Error', 'Server not response. ' + error, 'error');
				});
			} else {
				this.$swal('Alert!', 'Data Required', 'warning');
			}
			this.savebtn = false;
		},
		getAll: function getAll() {
			var _this4 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_1__keys_service__["a" /* default */].getAll().then(function (data) {
				if (data.status == 'success') {
					_this4.items = data.keys;

					_this4.company_type = data.insert_data.companies;

					_this4.company_name = _this4.company_type[0].energy_companies;
					_this4.role = data.role;
				} else {
					_this4.items = [];
					_this4.$swal(data[0], data[1], data[0]);
				}
				_this4.loadingData = false;
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
				_this4.loadingData = false;
			});
		},
		select_company_type: function select_company_type() {
			if (this.role == 'super_admin') {
				if (this.model.company_type_id === 0) {
					this.company_name = this.company_type[0].energy_companies;
					this.model.company_id = null;
				} else {
					this.company_name = this.company_type[1].trucking_companies;
					this.model.company_id = null;
				}
			}
		},
		select_company: function select_company() {
			if (this.role == 'super_admin') {
				var companies = this.company_name;
				var company_index = companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.company_id);
				if (company_index > -1) {
					this.model.company_name = companies[company_index].name;
				} else {
					this.model.company_name = '';
				}
			}
		}
	}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(76);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_services',
	created: function created() {
		this.getAll();
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("taPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("userPage");
		if (!localStorage.servicePage) {
			localStorage.servicePage = 0;
		}
	},
	data: function data() {
		return {
			newLocations: false,
			items: items,
			loadingData: true,
			currentPage: parseInt(localStorage.servicePage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: null,
			sortDesc: false,
			fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'name', label: 'Service Name', sortable: true }],
			filter: null,
			modalInfo: { title: '', content: '' },
			configTable: false,
			model: {
				name: '',
				roles_id: []
			},
			roles1: [],
			ServiceID: null,
			indeterminate: false,
			rolesAllSelected: false,
			savebtn: true
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return { text: f.label, value: f.key };
			});
		}
	},
	methods: {
		rowClicked: function rowClicked(row) {
			localStorage.servicePage = this.currentPage;
			localStorage.setItem('xyz', row.id);
			this.$router.push('/service/' + row.id + '/');
		},
		rolesToggleAll: function rolesToggleAll(checked) {
			this.model.roles_id = checked ? this.roles1.map(function (item) {
				return item.value;
			}) : [];
		},
		rolesChange: function rolesChange() {
			if (this.model.roles_id.length === 0) {
				this.indeterminate = false;
				this.rolesAllSelected = false;
			} else if (this.model.roles_id.length === this.roles1.length) {
				this.indeterminate = false;
				this.rolesAllSelected = true;
			} else {
				this.indeterminate = true;
				this.rolesAllSelected = false;
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.servicePage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		hideNewServiceModal: function hideNewServiceModal() {
			this.$refs.newLocationModal.hide();
		},
		showNewLocationModal: function showNewLocationModal() {
			this.model = { name: '', roles_id: [] };
			this.savebtn = false;
			this.newLocations = true;
		},
		saveServices: function saveServices() {
			var _this = this;

			this.savebtn = true;
			if (this.model.name != '') {
				var model1 = {
					name: this.model.name,
					roles: this.model.roles_id.map(function (item) {
						return {
							id: String(item)
						};
					})
				};
				__WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].save(model1).then(function (data) {
					_this.$swal(data[0], data[1], data[0]);
					if (data[0] == 'success') {
						_this.newLocations = false;
						_this.getAll();
					}
				}).catch(function (error) {
					_this.$swal('Error', 'Server not response. ' + error, 'error');
				});
			} else {
				this.$swal('Alert!', 'Data Required', 'warning');
			}
			this.savebtn = false;
		},
		getAll: function getAll() {
			var _this2 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					if (data[2]) {
						_this2.roles1 = data[2].roles.map(function (item) {
							return { text: item.name, value: item.id };
						});
					}
					_this2.items = data[1];
				} else {
					_this2.items = [];
					_this2.$swal(data[0], data[1], data[0]);
				}
				_this2.loadingData = false;
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.loadingData = false;
			});
		}
	}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(76);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_service',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getServiceData();
	},
	data: function data() {
		return {
			originalData: null,
			edit: false,
			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			subTitle: "",
			model: {
				name: '',
				roles_selected: [],
				roles_newselected: []
			},
			roles: [],
			roles1: [],
			ServiceID: null,
			indeterminate: false,
			rolesAllSelected: false
		};
	},

	methods: {
		rolesToggleAll: function rolesToggleAll(checked) {
			this.model.roles_newselected = checked ? this.roles1.map(function (item) {
				return item.value;
			}) : [];
		},
		rolesChange: function rolesChange() {
			if (this.model.roles_newselected.length === 0) {
				this.indeterminate = false;
				this.rolesAllSelected = false;
			} else if (this.model.roles_newselected.length === this.roles1.length) {
				this.indeterminate = false;
				this.rolesAllSelected = true;
			} else {
				this.indeterminate = true;
				this.rolesAllSelected = false;
			}
		},
		editservice: function editservice() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = this.originalData;
			console.log(this.model);
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
			this.roles1 = this.update_data.roles.map(function (item) {
				return { text: item.name, value: item.id };
			});
			this.roles = this.update_data.roles_selected.map(function (item) {
				return { text: item.name, value: item.id, service_id: item.service_id };
			});
			this.model.roles_selected = this.roles.map(function (item) {
				return item.value;
			});
			this.model.roles_newselected = this.model.roles_selected;
		},
		getServiceData: function getServiceData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] == 'success') {
					_this.originalData = data[1];
					_this.update_data = data[2];
					_this.restoreOriginalData();
					_this.subTitle = data[1].name;
					_this.found = true;
					_this.loadingData = false;
				} else {
					_this.$swal(data[0], data[1], data[0]);
					_this.loadingData = false;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Service Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateservice: function updateservice() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].update(this.id, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getServiceData();
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteservice: function deleteservice() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Service: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					_this3.deleteAllR();
					__WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.push('/services');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		deleteAllR: function deleteAllR() {
			var _this4 = this;

			var nelem = this.roles.length;
			console.log(this.roles);
			if (nelem > 0) {
				for (var i = 0; i < nelem; i++) {
					__WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].deleteR(this.roles[i].service_id).then(function (data) {
						if (data[0] != 'success') {
							_this4.$swal(data[0], data[1], data[0]);
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			}
		}
	}
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__folders_service__ = __webpack_require__(553);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'folders',
	created: function created() {
		this.getAll();
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("taPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("userPage");
		if (!localStorage.servicePage) {
			localStorage.servicePage = 0;
		}

		if ("folderTo" in localStorage) {
			if (localStorage.getItem('folderTo') == '01') {}
		}
	},
	data: function data() {
		return {
			newLocations: false,

			items: items,
			loadingData: true,
			currentPage: parseInt(localStorage.servicePage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: null,
			sortDesc: false,

			fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'name', label: 'Folder Name', sortable: true }, { key: 'energy_company', label: 'Energy Company', sortable: true }],
			filter: null,
			modalInfo: { title: '', content: '' },
			configTable: false,
			model: {
				name: '',
				energy_company_id: ''
			},
			energy_companies: [],
			ServiceID: null,
			indeterminate: false,
			rolesAllSelected: false,
			savebtn: true,
			trash: false,
			view: true,
			dpdt: "Active"
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return { text: f.label, value: f.key };
			});
		}
	},
	methods: {
		trashFolder: function trashFolder() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		rowClicked: function rowClicked(row) {
			localStorage.servicePage = this.currentPage;
			if (!this.trash) {
				localStorage.setItem('xyz', row.id);
				this.$router.push('/folder/' + row.id + '/');
			} else {
				this.restoreFolder(row.id);
			}
		},
		restoreFolder: function restoreFolder(id) {
			var _this = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Folder",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__folders_service__["a" /* default */].restore(id).then(function (data) {
						_this.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this.filter = '';
							_this.trash = false;
							_this.dpdt = _this.trash ? 'Trash' : 'Active';
							_this.getAll();
							_this.loadingData = true;
						}
					}).catch(function (error) {
						_this.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		rolesToggleAll: function rolesToggleAll(checked) {
			this.model.roles_id = checked ? this.energy_companies.map(function (item) {
				return item.value;
			}) : [];
		},
		rolesChange: function rolesChange() {
			if (this.model.roles_id.length === 0) {
				this.indeterminate = false;
				this.rolesAllSelected = false;
			} else if (this.model.roles_id.length === this.energy_companies.length) {
				this.indeterminate = false;
				this.rolesAllSelected = true;
			} else {
				this.indeterminate = true;
				this.rolesAllSelected = false;
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.servicePage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		hideNewServiceModal: function hideNewServiceModal() {
			if ("folderTo" in localStorage) {
				if (localStorage.getItem('folderTo') == '01') {
					localStorage.removeItem("folderTo");
					this.$router.push('/hauls');
				}
			}
			this.$refs.newLocationModal.hide();
		},
		showNewLocationModal: function showNewLocationModal() {
			this.model = { name: '', roles_id: [] };
			this.savebtn = false;
			this.newLocations = true;
		},
		saveFolder: function saveFolder() {
			var _this2 = this;

			this.savebtn = true;
			if (this.model.name != '') {
				if (this.energy_companies.length > 1) {
					var model1 = {
						name: this.model.name,
						energy_company_id: this.model.energy_company_id
					};
				} else {
					var model1 = {
						name: this.model.name,
						energy_company_id: this.energy_companies[0].value
					};
				}
				__WEBPACK_IMPORTED_MODULE_1__folders_service__["a" /* default */].save(model1).then(function (data) {
					_this2.$swal(data[0], data[1], data[0]);
					if (data[0] == 'success') {
						if ("folderTo" in localStorage) {
							if (localStorage.getItem('folderTo') == '01') {
								localStorage.removeItem("folderTo");
								_this2.$router.push('/hauls');
							}
						} else {
							_this2.newLocations = false;
							_this2.getAll();
						}
					}
				}).catch(function (error) {
					_this2.$swal('Error', 'Server not response. ' + error, 'error');
					if ("folderTo" in localStorage) {
						if (localStorage.getItem('folderTo') == '01') {
							localStorage.removeItem("folderTo");
							_this2.$router.push('/hauls');
						}
					}
				});
			} else {
				this.$swal('Alert!', 'Data Required', 'warning');
			}
			this.savebtn = false;
		},
		getAll: function getAll() {
			var _this3 = this;

			this.items = [];
			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_1__folders_service__["a" /* default */].getAll().then(function (data) {
				if (data.status == 'success') {
					if ("folderTo" in localStorage) {
						if (localStorage.getItem('folderTo') == '01') {
							if (data.insert_data) {
								var energy_companies = data.insert_data.energy_companies;
								if (energy_companies !== null) {
									_this3.energy_companies = energy_companies.map(function (item) {
										return { text: item.name, value: item.id };
									});
								} else {
									_this3.energy_companies = [];
								}
								_this3.showNewLocationModal();
							}
						}
					} else {
						if (data.insert_data) {
							var features = data.folders;
							for (var i = 0; i < features.length; i++) {
								if (features[i].status_id == (_this3.trash ? 2 : 1)) {
									var id = features[i].id;
									var name = features[i].name;
									var energy_company = features[i].energy_company;
									var energy_company_id = features[i].energy_company_id;
									var _data = {
										"id": id,
										"name": name,
										"energy_company": energy_company,
										"energy_company_id": energy_company_id

									};
									_this3.items.push(_data);
								}
							}
							var _energy_companies = data.insert_data.energy_companies;
							if (_energy_companies !== null) {
								_this3.energy_companies = _energy_companies.map(function (item) {
									return { text: item.name, value: item.id };
								});
							} else {
								_this3.energy_companies = [];
							}
						}
					}
				} else {
					_this3.items = [];
					_this3.$swal(data[0], data[1], data[0]);
				}
				_this3.loadingData = false;
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
				_this3.loadingData = false;
			});
		}
	}
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/folders/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/folder/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message, response.data.new];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(FolderId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/folder/' + FolderId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(FolderId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/folder/delete/' + FolderId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(FolderId, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/folder/update/' + FolderId + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(FolderId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/folder/restore/' + FolderId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__folders_service__ = __webpack_require__(553);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'folder',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getFolderData();
	},
	data: function data() {
		return {
			originalData: null,
			edit: false,
			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			subTitle: "",
			model: {
				name: '',
				energy_company: ''
			},
			roles: [],
			roles1: [],
			ServiceID: null,
			indeterminate: false,
			rolesAllSelected: false
		};
	},

	methods: {
		rolesToggleAll: function rolesToggleAll(checked) {
			this.model.roles_newselected = checked ? this.roles1.map(function (item) {
				return item.value;
			}) : [];
		},
		rolesChange: function rolesChange() {
			if (this.model.roles_newselected.length === 0) {
				this.indeterminate = false;
				this.rolesAllSelected = false;
			} else if (this.model.roles_newselected.length === this.roles1.length) {
				this.indeterminate = false;
				this.rolesAllSelected = true;
			} else {
				this.indeterminate = true;
				this.rolesAllSelected = false;
			}
		},
		editservice: function editservice() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = this.originalData;
			console.log(this.model);
			console.log(model);
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
		},
		getFolderData: function getFolderData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__folders_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					console.log(data);
					_this.originalData = data.folder;
					_this.update_data = data.update_data;
					_this.restoreOriginalData();
					_this.subTitle = data.folder.name;
					_this.found = true;
					_this.loadingData = false;
				} else {
					_this.$swal(data[0], data[1], data[0]);
					_this.loadingData = false;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Service Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateservice: function updateservice() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_2__folders_service__["a" /* default */].update(this.id, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getFolderData();
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteservice: function deleteservice() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Folder: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					_this3.deleteAllR();
					__WEBPACK_IMPORTED_MODULE_2__folders_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.push('/folders');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		deleteAllR: function deleteAllR() {
			var _this4 = this;

			var nelem = this.roles.length;
			console.log(this.roles);
			if (nelem > 0) {
				for (var i = 0; i < nelem; i++) {
					__WEBPACK_IMPORTED_MODULE_2__folders_service__["a" /* default */].deleteR(this.roles[i].service_id).then(function (data) {
						if (data[0] != 'success') {
							_this4.$swal(data[0], data[1], data[0]);
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			}
		}
	}
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__energy_companies_ec_service__ = __webpack_require__(53);







var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'terminal_agreements',
	created: function created() {
		this.getAll();
		localStorage.removeItem("haulsaPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("servicePage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("userPage");
		if (!localStorage.taPage) {
			localStorage.taPage = 0;
		}
	},
	data: function data() {
		return {
			newLocations: false,
			items: items,
			loadingData: true,
			dpdt: 'Active',
			trash: false,
			currentPage: parseInt(localStorage.taPage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: 'id',
			sortDesc: true,
			filter: null,
			modalInfo: { title: '', content: '' },
			configTable: false,

			fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'energy_company', label: 'Energy Company', sortable: true }, { key: 'initial_date', label: 'Initial Date', sortable: true, formatter: function formatter(value) {
					return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format("MMM DD, YYYY");
				} }, { key: 'end_date', label: 'End Date', sortable: true, formatter: function formatter(value) {
					return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format("MMM DD, YYYY");
				} }, { key: 'rate', label: 'Rate', sortable: true }, { key: 'fluid_type', label: 'Fluid Type', sortable: true }, { key: 'completed', label: 'Completed', sortable: true }],
			locations: [],
			energycompanies: [],
			rate: '',
			insert_data: null,
			role: '',
			view: true,
			savebtn: true,
			energy_company_id: null,

			list: true,
			fluidtypes: [],
			terminalcompanies: [],
			treatment_fee_type: [],
			condition: [],
			treatfees: {
				treatment_fee_type_id: null,
				treatment_fee: null,
				condition_id: null,
				percentage: null
			},
			otherfees: {
				terminal_rate: null,
				rate: null
			},
			unload_location: {
				id: null,
				name: null,
				shipping_cost: null,
				monthly_commitment: null,
				contact_person: null,
				contact_email: null,
				terminal_costs: []
			},
			terminal_cost: { terminal_cost_name: null, percentage: null },
			fluid_type: { id: null, name: null },
			other_term: { blending_dry_fee: null, stream_type_id: null },
			model: {
				id: null,
				energy_company_id: null,
				terminal_company_id: null,
				terminal_id: null,
				terminalcost: null,
				initial_date: null,
				end_date: null,
				rate: null,
				fluid_type_id: null,
				other_terms: [],
				treatfees: [{
					treatment_fee_type_id: null,
					treatment_fee: null,
					condition_id: null,
					percentage: null
				}],
				otherfees: [{
					terminal_rate: null,
					rate: null
				}],
				unload_locations: [],
				load_locations_id: []
			},
			treatmentfee: '',
			percentage: '',
			monthly_commitment: '',
			newUnloadLocation: false,
			newLoadLocation: false,
			u_location_id: '',
			loadlocationselect: [],
			indeterminateLL: false,
			llAllSelected: false,
			load_locations: [],
			newModal: false,
			modalTabIndex: 0,
			terminals: []
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return { text: f.label, value: f.key };
			});
		}
	},
	methods: {
		addloadlocation: function addloadlocation() {
			var _this = this;

			var ll = [];
			if (this.model.load_locations_id.length != 0) {
				ll = this.model.load_locations_id.map(function (item) {
					var ll_index = _this.loadlocationselect.map(function (o) {
						return o.id;
					}).indexOf(item);
					if (ll_index > -1) {
						return _this.loadlocationselect[ll_index];
					}
				});
			}
			this.load_locations = ll;
			this.newLoadLocation = false;
		},
		hideloadlocation: function hideloadlocation() {
			this.newLoadLocation = false;
		},
		loadLocationsChange: function loadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		LLToggleAll: function LLToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		showloadlocation: function showloadlocation() {
			this.newLoadLocation = true;
		},
		showunloadlocation: function showunloadlocation() {
			this.newUnloadLocation = true;
		},
		addunloadlocation_2: function addunloadlocation_2() {
			var unload_location = {
				id: null,
				name: null,
				shipping_cost: null,
				monthly_commitment: null,
				contact_person: null,
				contact_email: null,
				terminal_costs: []
			};
			this.model.unload_locations.push(unload_location);
		},
		addtreatmentfee: function addtreatmentfee() {
			this.model.treatfees.push(this.treatfees);
			this.treatfees = {
				treatment_fee_type_id: null,
				treatment_fee: null,
				condition_id: null,
				percentage: null
			};
		},
		otherfee: function otherfee() {
			this.model.otherfees.push(this.otherfees);
			this.otherfees = {
				terminal_rate: null,
				rate: null
			};
		},
		addterminalcost: function addterminalcost(row) {
			var index = row.index;
			var terminal_cost = {
				terminal_cost_name: null,
				percentage: null
			};
			this.model.unload_locations[index].terminal_costs.push(terminal_cost);
			this.terminal_cost = {
				terminal_cost_name: null,
				percentage: null
			};
			if (!row.detailsShowing) {
				row.toggleDetails();
			}
		},
		removetreatmentfee: function removetreatmentfee(treatfee) {
			this.model.treatfees.splice(treatfee, 1);
		},
		removeotherfee: function removeotherfee(otherfee) {
			this.model.otherfees.splice(otherfee, 1);
		},
		removelocation: function removelocation(location) {
			var unload_l = {
				value: this.model.unload_locations[location].id,
				text: this.model.unload_locations[location].name
			};
			this.locations.push(unload_l);
			this.locations.sort(function (a, b) {
				if (a.text > b.text) {
					return 1;
				}
				if (a.text < b.text) {
					return -1;
				}

				return 0;
			});
			this.model.unload_locations.splice(location, 1);
		},
		removeterminalcost: function removeterminalcost(row, terminalcost) {
			this.model.unload_locations[row.index].terminal_costs.splice(terminalcost, 1);

			if (this.model.unload_locations[row.index].terminal_costs.length == 0) {
				row.toggleDetails();
			}
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.taPage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		hideNewServiceModal: function hideNewServiceModal() {
			this.list = true;
		},
		showNewLocationModal: function showNewLocationModal() {
			this.savebtn = false;
			this.model = {
				id: null,
				energy_company_id: null,
				terminal_company_id: null,
				terminal_id: null,
				initial_date: null,
				end_date: null,
				rate: null,
				fluid_type_id: null,
				other_terms: [],
				treatfees: [{
					treatment_fee_type_id: null,
					treatment_fee: null,
					condition_id: null,
					percentage: null
				}],
				otherfees: [{
					terminal_rate: null,
					rate: null
				}],
				unload_locations: [],
				load_locations_id: []
			};
			this.fluid_type = { id: null, name: null };
			this.newLocations = true;
			this.modalTabIndex = 0;
			this.newModal = true;
		},
		trashAgreement: function trashAgreement() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		rowClicked: function rowClicked(row) {
			localStorage.taPage = this.currentPage;
			if (!this.trash) {
				this.$router.push('/terminal_agreement/' + row.id);
			} else {
				this.restoreTerminalAgreement(row.id);
			}
		},
		restoreTerminalAgreement: function restoreTerminalAgreement(id) {
			var _this2 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Terminal Agreement?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].restore(id).then(function (data) {
						_this2.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this2.filter = '';
							_this2.trash = false;
							_this2.dpdt = 'Active';
							_this2.getAll();
							_this2.loadingData = true;
						}
					}).catch(function (error) {
						_this2.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		okToSave: function okToSave() {
			if (this.role == 'super_admin') {
				if (this.model.energy_company_id == null) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					this.modalTabIndex = 0;
					return false;
				}
			}
			if (this.model.fluid_type_id == null) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				this.modalTabIndex = 0;
				return false;
			} else if (this.model.initial_date == null || this.model.initial_date == '') {
				this.$swal('Alert!', 'Initial Date not selected', 'warning');
				this.modalTabIndex = 0;
				return false;
			} else if (this.model.end_date == null || this.model.end_date == '') {
				this.$swal('Alert!', 'End Date not selected', 'warning');
				this.modalTabIndex = 0;
				return false;
			} else if (this.model.rate == null || this.model.rate == '') {
				this.$swal('Alert!', 'Rate cannot be empty', 'warning');
				this.modalTabIndex = 0;
				return false;
			} else if (this.model.terminal_company_id == null) {
				this.$swal('Alert!', 'Terminal Company not selected', 'warning');
				this.modalTabIndex = 0;
				return false;
			} else if (this.model.terminal_id == null) {
				this.$swal('Alert!', 'Terminal not selected', 'warning');
				this.modalTabIndex = 0;
				return false;
			} else if (this.model.other_terms.length > 0) {
				if (this.model.other_terms[0].stream_type_id == null) {
					this.$swal('Alert!', 'Stream Type not selected', 'warning');
					this.modalTabIndex = 0;
					return false;
				} else if (this.model.other_terms[0].blending_dry_fee == null || this.model.other_terms[0].blending_dry_fee == '') {
					this.$swal('Alert!', 'Blending Dry Fee cannot be empty', 'warning');
					this.modalTabIndex = 0;
					return false;
				}
			} else if (this.model.treatfees.length > 0) {
				var length = this.model.treatfees.length;
				for (var i = 0; i < length; i++) {
					if (this.model.treatfees[i].treatment_fee_type_id == null) {
						this.$swal('Alert!', 'Treatment fee type not selected', 'warning');
						this.modalTabIndex = 1;
						return false;
					} else if (this.model.treatfees[i].treatment_fee == null || this.model.treatfees[i].treatment_fee == '') {
						this.modalTabIndex = 1;
						this.$swal('Alert!', 'Treatment fee cannot be empty', 'warning');
						return false;
					} else if (this.model.treatfees[i].condition_id == null) {
						this.modalTabIndex = 1;
						this.$swal('Alert!', 'Condition of treatment fee not selected', 'warning');
						return false;
					} else if (this.model.treatfees[i].percentage == null || this.model.treatfees[i].percentage == '') {
						this.modalTabIndex = 1;
						this.$swal('Alert!', 'Percentage of treatment fee cannot be empty', 'warning');
						return false;
					}
				}
			}

			if (this.model.otherfees.length > 0) {
				var _length = this.model.otherfees.length;
				for (var i = 0; i < _length; i++) {
					if (this.model.otherfees[i].terminal_rate == null || this.model.otherfees[i].terminal_rate == '') {
						this.$swal('Alert!', 'Other fee terminal rate cannot be empty', 'warning');
						this.modalTabIndex = 2;
						return false;
					} else if (this.model.otherfees[i].rate == null || this.model.otherfees[i].rate == '') {
						this.$swal('Alert!', 'Other fee rate cannot be empty', 'warning');
						this.modalTabIndex = 2;
						return false;
					}
				}
			}

			if (this.model.unload_locations.length > 0) {
				var _length2 = this.model.unload_locations.length;
				for (var i = 0; i < _length2; i++) {
					if (this.model.unload_locations[i].id == null) {
						this.$swal('Alert!', 'Unload location not selected', 'warning');
						this.modalTabIndex = 3;
						return false;
					} else if (this.model.unload_locations[i].shipping_cost == null || this.model.unload_locations[i].shipping_cost == '') {
						this.$swal('Alert!', 'Shipping cost	 cannot be empty', 'warning');
						this.modalTabIndex = 3;
						return false;
					} else if (this.model.unload_locations[i].monthly_commitment == null || this.model.unload_locations[i].monthly_commitment == '') {
						this.$swal('Alert!', 'Monthly commitment cannot be empty', 'warning');
						this.modalTabIndex = 3;
						return false;
					} else if (this.model.unload_locations[i].contact_person == null || this.model.unload_locations[i].contact_person == '') {
						this.$swal('Alert!', 'Contact person cannot be empty', 'warning');
						this.modalTabIndex = 3;
						return false;
					} else if (this.model.unload_locations[i].contact_email == null || this.model.unload_locations[i].contact_email == '') {
						this.$swal('Alert!', 'Contact email cannot be empty', 'warning');
						this.modalTabIndex = 3;
						return false;
					}
					if (this.model.unload_locations[i].terminal_costs.length > 0) {
						var length1 = this.model.unload_locations[i].terminal_costs.length;
						for (var j = 0; j < length1; j++) {
							if (this.model.unload_locations[i].terminal_costs[j].terminal_cost_name == null || this.model.unload_locations[i].terminal_costs[j].terminal_cost_name == '') {
								this.$swal('Alert!', 'Terminal cost	 cannot be empty', 'warning');
								this.modalTabIndex = 3;
								return false;
							} else if (this.model.unload_locations[i].terminal_costs[j].percentage == null || this.model.unload_locations[i].terminal_costs[j].percentage == '') {
								this.$swal('Alert!', 'Percentage of terminal cost cannot be empty', 'warning');
								this.modalTabIndex = 3;
								return false;
							}
						}
					}
				}
			} else {
				this.$swal('Alert!', 'No Unload Locations have been added', 'warning');
				this.modalTabIndex = 3;
				return false;
			}
			if (this.model.load_locations_id.length == 0) {
				this.$swal('Alert!', 'Load Location not selected', 'warning');
				this.modalTabIndex = 4;
				return false;
			}
			return true;
		},
		saveTerminalAgreement: function saveTerminalAgreement() {
			var _this3 = this;

			if (!this.okToSave()) {
				return;
			}
			this.savebtn = true;
			if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_id;
			}
			__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].save(this.model).then(function (data) {
				_this3.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this3.newLocations = false;
					_this3.getAll();
					_this3.list = true;
					_this3.newModal = false;
				}
				_this3.savebtn = false;
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
				_this3.savebtn = false;
			});
		},
		getAll: function getAll() {
			var _this4 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].getAll().then(function (data) {
				if (data.status == 'success') {
					_this4.items = data.t_agreements.filter(function (o) {
						return o.status_id == (_this4.trash ? 2 : 1);
					});
					_this4.role = data.role;
					if (_this4.role == 'super_admin') {
						_this4.view = true;
					} else if (_this4.role == 'super_analyst' || _this4.role == 'analyst' || _this4.role == 'marketing_accountant') {
						_this4.view = false;
						_this4.energy_company_id = data.energy_company_id;

						_this4.model.load_locations_id = [];
						_this4.model.energy_company_id = _this4.energy_company_id;
					}
					_this4.get_attributtes();
				} else {
					_this4.items = [];
					_this4.$swal(data.status, data.message, data.status);
				}
				_this4.loadingData = false;
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
				_this4.loadingData = false;
			});
		},
		select_energy_companies1: function select_energy_companies1() {
			var _this5 = this;

			if (this.model.location_id != null) {
				__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].getEnergyCompaniesUnload(this.model.location_id).then(function (data) {
					if (data[0] == 'success') {
						_this5.energycompanies = data[1].map(function (item) {
							return { text: item.name, value: item.id };
						});
					} else {
						_this5.$swal(data[0], data[1], data[0]);
						_this5.energycompanies = [];
					}
				}).catch(function (error) {
					_this5.$swal('Error', 'Server not response. ' + error, 'error');
					_this5.loadingData = false;
				});
				this.model.energy_company_id = null;
			}
		},
		select_energy_company: function select_energy_company() {
			if (this.role == 'super_admin') {
				var energy_companies = this.insert_data.energy_companies;
				var energy_company_index = energy_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var loadlocations = energy_companies[energy_company_index].load_locations;
					this.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
				} else {
					this.loadlocationselect = [];
				}
				this.model.load_locations_id = [];
			}
		},
		select_terminal: function select_terminal() {
			if (this.role == 'super_admin') {
				var terminals = this.insert_data.terminals;
				var terminal_index = terminals.map(function (o) {
					return o.id;
				}).indexOf(this.model.terminal_id);
				if (terminal_index > -1) {
					if (terminals[terminal_index].unload_location.length > 0) {
						this.model.unload_locations = [];
						var unload_locations = {
							id: terminals[terminal_index].unload_location[0].id,
							name: terminals[terminal_index].unload_location[0].name,
							shipping_cost: null,
							monthly_commitment: null,
							contact_person: null,
							contact_email: null,
							terminal_costs: []
						};
						this.model.unload_locations.push(unload_locations);
					} else {
						this.model.unload_locations = [];
					}
				} else {
					this.model.unload_locations = [];
				}
			}
		},
		select_fluid_type: function select_fluid_type() {
			this.model.fluid_type_id = this.fluid_type.id;
			if (this.fluid_type.name == 'Oil') {
				this.model.other_terms.push(this.other_term);
			} else {
				this.model.other_terms = [];
			}
		},
		get_attributtes: function get_attributtes() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].get_attr_ta().then(function (data) {
				if (data.status == 'success') {
					if (data.insert_data) {
						_this6.insert_data = data.insert_data;
						if (data.insert_data.locations_unload.length != 0) {
							_this6.locations = data.insert_data.locations_unload.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}

						if (data.insert_data.fluidtypes.length != 0) {
							_this6.fluidtypes = data.insert_data.fluidtypes;
						}

						_this6.terminals = data.insert_data.terminals;
						_this6.energycompanies = data.insert_data.energy_companies;
						_this6.terminalcompanies = data.insert_data.terminal_companies;
						if (data.insert_data.treatment_fee_type.length != 0) {
							_this6.treatment_fee_type = data.insert_data.treatment_fee_type.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}

						if (data.insert_data.conditions.length != 0) {
							_this6.condition = data.insert_data.conditions.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}
						if (_this6.role == 'super_analyst' || _this6.role == 'analyst' || _this6.role == 'marketing_accountant') {
							if (_this6.energycompanies.length != 0) {
								var loadlocations = _this6.energycompanies[0].load_locations;
								_this6.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
							} else {
								_this6.loadlocationselect = [];
							}
						}
					}
				} else {
					_this6.$swal(data.status, data.message, data.status);
				}
			}).catch(function (error) {
				_this6.$swal('Error', 'Server not response. ' + error, 'error');
			});
		}
	}
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__energy_companies_ec_service__ = __webpack_require__(53);







var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'terminal_agreements',
	created: function created() {
		this.getAll();
		localStorage.removeItem("haulsaPage");
		localStorage.removeItem("targetsaPage");
		localStorage.removeItem("ftPage");
		localStorage.removeItem("targetPage");
		localStorage.removeItem("tpPage");
		localStorage.removeItem("oasaPage");
		localStorage.removeItem("oaPage");
		localStorage.removeItem("reportPage");
		localStorage.removeItem("rolesPage");
		localStorage.removeItem("servicePage");
		localStorage.removeItem("tasaPage");
		localStorage.removeItem("tcPage");
		localStorage.removeItem("locationPage");
		localStorage.removeItem("truckPage");
		localStorage.removeItem("userPage");
		if (!localStorage.taPage) {
			localStorage.taPage = 0;
		}
	},
	data: function data() {
		return {
			newLocations: false,
			items: items,
			loadingData: true,
			dpdt: 'Active',
			trash: false,
			currentPage: parseInt(localStorage.taPage),
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: 'initial_date',
			sortDesc: false,
			filter: null,
			modalInfo: { title: '', content: '' },
			configTable: false,

			fields: [{ key: 'id', label: 'Id', sortable: true }, { key: 'energy_company', label: 'Energy Company', sortable: true }, { key: 'hauls', label: 'Hauls' }, { key: 'action', label: 'Action' }],
			locations: [],
			energycompanies: [],
			rate: '',
			insert_data: null,
			role: '',
			view: true,
			savebtn: true,
			energy_company_id: null,

			list: true,
			fluidtypes: [],
			terminalcompanies: [],
			treatment_fee_type: [],
			condition: [],
			treatfees: {
				treatment_fee_type_id: null,
				treatment_fee: null,
				condition_id: null,
				percentage: null
			},
			otherfees: {
				terminal_rate: null,
				rate: null
			},
			unload_location: {
				shipping_cost: null,
				monthly_commitment: null,
				contact_person: null,
				contact_email: null
			},
			terminal_cost: { terminal_cost_name: null, percentage: null },
			fluid_type: { id: null, name: null },
			other_term: { blending_dry_fee: null, stream_type_id: null },
			model: {
				id: null,
				energy_company_id: null,
				terminal_company_id: null,
				initial_date: null,
				end_date: null,
				rate: null,
				fluid_type_id: null,
				other_terms: [],
				treatfees: [{
					treatment_fee_type_id: null,
					treatment_fee: null,
					condition_id: null,
					percentage: null
				}],
				otherfees: [{
					terminal_rate: null,
					rate: null
				}],
				unload_locations: [],
				load_locations_id: []
			},
			pendig: false,

			re_item: { legal_location: '' },
			treatmentfee: '',
			percentage: '',
			monthly_commitment: '',
			newUnloadLocation: false,
			newLoadLocation: false,
			u_location_id: '',
			loadlocationselect: [],
			indeterminateLL: false,
			llAllSelected: false,
			load_locations: []
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fieldsTh.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return { text: f.label, value: f.key };
			});
		}
	},
	methods: {
		loadLocationsChange: function loadLocationsChange() {
			if (this.role == 'super_admin') {
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		LLToggleAll: function LLToggleAll(checked) {
			this.model.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
				return item.id;
			}) : [];
		},
		addloadlocation: function addloadlocation() {
			var _this = this;

			var ll = [];
			if (this.model.load_locations_id.length != 0) {
				ll = this.model.load_locations_id.map(function (item) {
					var ll_index = _this.loadlocationselect.map(function (o) {
						return o.id;
					}).indexOf(item);
					if (ll_index > -1) {
						return _this.loadlocationselect[ll_index];
					}
				});
			}
			this.load_locations = ll;
			this.newLoadLocation = false;
		},
		showloadlocation: function showloadlocation() {
			this.newLoadLocation = true;
		},
		showunloadlocation: function showunloadlocation() {
			this.newUnloadLocation = true;
		},
		hideloadlocation: function hideloadlocation() {
			this.newLoadLocation = false;
		},
		addunloadlocation: function addunloadlocation() {
			var ul_index = this.locations.map(function (o) {
				return o.value;
			}).indexOf(this.u_location_id);
			if (ul_index > -1) {
				var unload_location = {
					id: this.locations[ul_index].value,
					name: this.locations[ul_index].text,
					shipping_cost: null,
					monthly_commitment: null,
					contact_person: null,
					contact_email: null,
					terminal_costs: [{ terminal_cost_name: null, percentage: null }]
				};
				this.model.unload_locations.push(unload_location);
				this.locations.splice(ul_index--, 1);
			}
			this.newUnloadLocation = false;
		},
		create_a: function create_a(item, index) {
			this.re_item = item;

			this.showNewLocationModal(this.re_item);
		},
		addtreatmentfee: function addtreatmentfee() {
			this.model.treatfees.push(this.treatfees);
			this.treatfees = {
				treatment_fee_type_id: null,
				treatment_fee: null,
				condition_id: null,
				percentage: null
			};
		},
		otherfee: function otherfee() {
			this.model.otherfees.push(this.otherfees);
			this.otherfees = {
				terminal_rate: null,
				rate: null
			};
		},
		addterminalcost: function addterminalcost(index) {
			this.model.unload_locations[index].terminal_costs.push(this.terminal_cost);
			this.terminal_cost = {
				terminal_cost_name: null,
				percentage: null
			};
		},
		removetreatmentfee: function removetreatmentfee(treatfee) {
			this.model.treatfees.splice(treatfee, 1);
		},
		removeotherfee: function removeotherfee(otherfee) {
			this.model.otherfees.splice(otherfee, 1);
		},
		removelocation: function removelocation(location) {
			this.model.unload_locations.splice(location, 1);
		},
		removeterminalcost: function removeterminalcost(index, terminalcost) {
			this.model.unload_locations[index].terminal_costs.splice(terminalcost, 1);
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.taPage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		hideNewServiceModal: function hideNewServiceModal() {
			this.list = true;
		},
		showNewLocationModal: function showNewLocationModal(item) {
			this.savebtn = false;
			this.model = {
				id: item.id,
				energy_company_id: item.energy_company_id,
				terminal_company_id: item.terminal_company_id,
				initial_date: item.initial_date,
				end_date: item.end_date,
				rate: item.rate,
				fluid_type_id: null,
				other_terms: [],
				treatfees: [{
					treatment_fee_type_id: null,
					treatment_fee: null,
					condition_id: null,
					percentage: null
				}],
				otherfees: [{
					terminal_rate: null,
					rate: null
				}],
				unload_locations: [],
				location_id: item.location_id
			};

			this.newLocations = true;
			this.list = false;
		},
		trashAgreement: function trashAgreement() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		rowClicked: function rowClicked(row) {
			localStorage.taPage = this.currentPage;
			if (!this.trash) {
				this.$router.push('/terminal_agreement/' + row.id);
			} else {
				this.restoreTerminalAgreement(row.id);
			}
		},
		restoreTerminalAgreement: function restoreTerminalAgreement(id) {
			var _this2 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Terminal Agreement?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].restore(id).then(function (data) {
						_this2.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this2.filter = '';
							_this2.trash = false;
							_this2.dpdt = 'Active';
							_this2.getAll();
							_this2.loadingData = true;
						}
					}).catch(function (error) {
						_this2.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		okToSave: function okToSave() {
			if (this.role == 'super_admin') {
				if (this.model.energy_company_id == null) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.fluid_type_id == null) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				return false;
			} else if (this.model.initial_date == null) {
				this.$swal('Alert!', 'Initial Date not selected', 'warning');
				return false;
			} else if (this.model.end_date == null) {
				this.$swal('Alert!', 'End Date not selected', 'warning');
				return false;
			} else if (this.model.rate == null) {
				this.$swal('Alert!', 'Rate cannot be empty', 'warning');
				return false;
			} else if (this.model.terminal_company_id == null) {
				this.$swal('Alert!', 'Terminal Company not selected', 'warning');
				return false;
			} else if (this.model.other_terms.length > 0) {
				if (this.model.other_terms[0].stream_type_id == null) {
					this.$swal('Alert!', 'Stream Type not selected', 'warning');
					return false;
				} else if (this.model.other_terms[0].blending_dry_fee == null) {
					this.$swal('Alert!', 'Blending Dry Fee cannot be empty', 'warning');
					return false;
				}
			} else if (this.model.treatfees.length > 0) {
				var length = this.model.treatfees.length;
				for (var i = 0; i < length; i++) {
					if (this.model.treatfees[i].treatment_fee_type_id == null) {
						this.$swal('Alert!', 'Treatment fee type not selected', 'warning');
						return false;
					} else if (this.model.treatfees[i].treatment_fee == null) {
						this.$swal('Alert!', 'Treatment fee cannot be empty', 'warning');
						return false;
					} else if (this.model.treatfees[i].condition_id == null) {
						this.$swal('Alert!', 'Condition of treatment fee not selected', 'warning');
						return false;
					} else if (this.model.treatfees[i].percentage == null || this.model.treatfees[i].percentage == '') {
						this.$swal('Alert!', 'Percentage of treatment fee cannot be empty', 'warning');
						return false;
					}
				}
			}

			if (this.model.otherfees.length > 0) {
				var _length = this.model.otherfees.length;
				for (var i = 0; i < _length; i++) {
					if (this.model.otherfees[i].terminal_rate == null) {
						this.$swal('Alert!', 'Other fee terminal rate cannot be empty', 'warning');
						return false;
					} else if (this.model.otherfees[i].rate == null) {
						this.$swal('Alert!', 'Other fee rate cannot be empty', 'warning');
						return false;
					}
				}
			}

			if (this.model.unload_locations.length > 0) {
				var _length2 = this.model.treatfees.length;
				for (var i = 0; i < _length2; i++) {
					if (this.model.unload_locations[i].shipping_cost == null || this.model.unload_locations[i].shipping_cost == '') {
						this.$swal('Alert!', 'Shipping cost	 cannot be empty', 'warning');
						return false;
					} else if (this.model.unload_locations[i].monthly_commitment == null || this.model.unload_locations[i].monthly_commitment == '') {
						this.$swal('Alert!', 'Monthly commitment cannot be empty', 'warning');
						return false;
					} else if (this.model.unload_locations[i].contact_person == null || this.model.unload_locations[i].contact_person == '') {
						this.$swal('Alert!', 'Contact person cannot be empty', 'warning');
						return false;
					} else if (this.model.unload_locations[i].contact_email == null || this.model.unload_locations[i].contact_email == '') {
						this.$swal('Alert!', 'Contact email cannot be empty', 'warning');
						return false;
					}
					if (this.model.unload_locations[i].terminal_costs.length > 0) {
						var length1 = this.model.unload_locations[i].terminal_costs.length;
						for (var j = 0; j < length1; j++) {
							if (this.model.unload_locations[i].terminal_costs[j].terminal_cost_name == null || this.model.unload_locations[i].terminal_costs[j].terminal_cost_name == '') {
								this.$swal('Alert!', 'Terminal cost	 cannot be empty', 'warning');
								return false;
							} else if (this.model.unload_locations[i].terminal_costs[j].percentage == null || this.model.unload_locations[i].terminal_costs[j].percentage == '') {
								this.$swal('Alert!', 'Percentage of terminal cost cannot be empty', 'warning');
								return false;
							}
						}
					}
				}
			}
			return true;
		},
		saveTerminalAgreement: function saveTerminalAgreement() {
			var _this3 = this;

			if (!this.okToSave()) {
				return;
			}
			this.savebtn = true;
			if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_id;
			}
			this.model.rate = parseFloat(this.model.rate);
			console.log(this.model);
			__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].update(this.model.id, this.model).then(function (data) {
				_this3.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this3.newLocations = false;
					_this3.getAll();
					_this3.list = true;
				}
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = false;
		},
		getAll: function getAll() {
			var _this4 = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].getAll().then(function (data) {
				if (data.status == 'success') {
					var data_items = data.t_agreements.filter(function (o) {
						return o.status_id == (_this4.trash ? 2 : 1);
					});
					_this4.items = data_items.filter(function (o) {
						return o.pending == 'yes';
					});

					_this4.role = data.role;
					if (_this4.role == 'super_admin') {
						_this4.view = true;
					} else if (_this4.role == 'super_analyst' || _this4.role == 'analyst' || _this4.role == 'marketing_accountant') {
						_this4.view = false;
						_this4.energy_company_id = data.energy_company_id;
					}
					_this4.get_attributtes();
				} else {
					_this4.items = [];
					_this4.$swal(data.status, data.message, data.status);
				}
				_this4.loadingData = false;
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
				_this4.loadingData = false;
			});
		},
		select_energy_companies: function select_energy_companies() {
			var _this5 = this;

			if (this.model.location_id != null) {
				__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].getEnergyCompaniesUnload(this.model.location_id).then(function (data) {
					if (data[0] == 'success') {
						_this5.energycompanies = data[1].map(function (item) {
							return { text: item.name, value: item.id };
						});
					} else {
						_this5.$swal(data[0], data[1], data[0]);
						_this5.energycompanies = [];
					}
				}).catch(function (error) {
					_this5.$swal('Error', 'Server not response. ' + error, 'error');
					_this5.loadingData = false;
				});
				this.model.energy_company_id = null;
			}
		},
		select_fluid_type: function select_fluid_type() {
			this.model.fluid_type_id = this.fluid_type.id;
			if (this.fluid_type.name == 'Oil') {
				this.model.other_terms.push(this.other_term);
			} else {
				this.model.other_terms = [];
			}
		},
		select_energy_company: function select_energy_company() {
			if (this.role == 'super_admin') {
				var energy_companies = this.insert_data.energy_companies;
				var energy_company_index = energy_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var loadlocations = energy_companies[energy_company_index].load_locations;
					this.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
				} else {
					this.loadlocationselect = [];
				}
				this.model.load_locations_id = [];
			}
		},
		get_attributtes: function get_attributtes() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_2__t_agreement__["a" /* default */].get_attr_ta().then(function (data) {
				if (data.status == 'success') {
					if (data.insert_data) {
						_this6.insert_data = data.insert_data;
						if (data.insert_data.locations_unload.length != 0) {
							_this6.locations = data.insert_data.locations_unload.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}
						if (data.insert_data.fluidtypes.length != 0) {
							_this6.fluidtypes = data.insert_data.fluidtypes;
						}

						_this6.terminals = data.insert_data.terminals;
						_this6.energycompanies = data.insert_data.energy_companies;
						_this6.terminalcompanies = data.insert_data.terminal_companies;
						if (data.insert_data.treatment_fee_type.length != 0) {
							_this6.treatment_fee_type = data.insert_data.treatment_fee_type.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}

						if (data.insert_data.conditions.length != 0) {
							_this6.condition = data.insert_data.conditions.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}
					}
				} else {
					_this6.$swal(data.status, data.message, data.status);
				}
			}).catch(function (error) {
				_this6.$swal('Error', 'Server not response. ' + error, 'error');
			});
		}
	}
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'm_tagreement',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getAgreementData();
	},
	data: function data() {
		var _ref;

		return _ref = {
			originalData: null,
			edit: false,
			loadingData: true,
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				id: null,
				energy_company_id: null,
				energy_company: '',
				terminal_company_id: null,
				terminal_company: '',
				terminal_id: null,
				terminal: '',
				initial_date: null,
				end_date: null,
				rate: null,
				fluid_type_id: null,
				fluid_type: '',
				other_terms: [],
				treatfees: [{
					treatment_fee_type_id: null,
					treatment_fee_type_name: '',
					treatment_fee: null,
					condition_id: null,
					condition_name: null,
					percentage: null
				}],
				otherfees: [{
					terminal_rate: null,
					rate: null
				}],
				unload_locations: [{
					id: null,
					name: null,
					shipping_cost: null,
					monthly_commitment: null,
					contact_person: null,
					contact_email: null,
					terminal_costs: []
				}],
				load_locations_id: [],
				load_locations: []
			},

			rate: '',
			subTitle: "",

			role: '',
			view: true,
			savebtn: true,
			energy_company_id: null,
			initial_date: '',
			end_date: '',
			load_locations: [],

			update_data: null,
			fluidtypes: [],
			terminalcompanies: [],
			treatment_fee_type: [],
			condition: [],
			locations: [],
			energycompanies: [],
			fluid_type: { 'id': null, 'name': '', stream_type: [] },
			other_term: { blending_dry_fee: null, stream_type_id: null },
			loadlocationselect: [],
			indeterminateLL: false,
			llAllSelected: false,
			treatfees: {
				treatment_fee_type_id: null,
				treatment_fee: null,
				condition_id: null,
				percentage: null
			},
			otherfees: {
				terminal_rate: null,
				rate: null
			},
			unload_location: {
				id: null,
				name: null,
				shipping_cost: null,
				monthly_commitment: null,
				contact_person: null,
				contact_email: null,
				terminal_costs: [{ terminal_cost_name: null, percentage: null }]
			},
			terminal_cost: { terminal_cost_name: null, percentage: null }
		}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'other_term', { blending_dry_fee: null, stream_type_id: null }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'newUnloadLocation', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'u_location_id', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'terminals', []), _ref;
	},

	methods: {
		loadLocationsChange: function loadLocationsChange() {
			if (this.load_locations_id === true) {
				return;
			}
			this.model.load_locations_id = this.load_locations_id;
			if (this.role == 'super_admin') {
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false;
					this.llAllSelected = false;
				} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
					this.indeterminateLL = false;
					this.llAllSelected = true;
				} else {
					this.indeterminateLL = true;
					this.llAllSelected = false;
				}
			}
		},
		LLToggleAll: function LLToggleAll(checked) {
			if (checked === true) {
				this.load_locations_id = this.loadlocationselect.map(function (item) {
					return item.id;
				});
			} else {
				this.load_locations_id = [];
			}
			this.model.load_locations_id = this.load_locations_id;
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = [variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = [variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		setupFields: function setupFields() {
			if (this.role == 'super_admin') {
				var energy_companies = this.update_data.energy_companies;
				var energy_company_index = energy_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var loadlocations = energy_companies[energy_company_index].load_locations;
					this.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
				} else {
					this.loadlocationselect = [];
				}
			}
			this.load_locations_id = [];
			if (this.model.load_locations.length > 0) {
				this.load_locations_id = this.model.load_locations.map(function (item) {
					return item.id;
				});
			}

			for (var i = 0; i < this.fluidtypes.length; i++) {
				if (this.fluidtypes[i].name === this.model.fluid_type) {
					this.fluid_type.name = this.fluidtypes[i].other.name;
					this.fluid_type.id = this.fluidtypes[i].other.id;
					this.fluid_type.stream_type = this.fluidtypes[i].other.stream_type;
					break;
				}
			}
		},
		edit_terminal_agreement: function edit_terminal_agreement() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
			this.initial_date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.model.initial_date).format('MMM DD, YYYY');
			this.end_date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.model.end_date).format('MMM DD, YYYY');
		},
		getAgreementData: function getAgreementData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_5__t_agreement__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] == 'success') {
					_this.originalData = data[1];
					_this.update_data = data[2];
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.energy_company;
					_this.found = true;
					_this.loadingData = false;
					_this.edit = false;
					_this.role = data[3];
					if (_this.role == 'super_admin') {
						_this.view = true;
					} else if (_this.role == 'super_analyst' || _this.role == 'analyst' || _this.role == 'marketing_accountant') {
						_this.view = false;
						_this.energy_company_id = data[4];
						_this.model.load_locations_id = [];
						_this.model.energy_company_id = _this.energy_company_id;
					}
					_this.get_attributtes();
				} else {
					_this.$swal(data[0], data[1], data[0]);
					_this.loadingData = false;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
				_this.$router.push('/terminal_agreements');
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.role == 'super_admin') {
				if (this.model.energy_company_id == null) {
					this.$swal('Alert!', 'Energy Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.fluid_type_id == null) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				return false;
			} else if (this.model.initial_date == null || this.model.initial_date == '') {
				this.$swal('Alert!', 'Initial Date not selected', 'warning');
				return false;
			} else if (this.model.end_date == null || this.model.end_date == '') {
				this.$swal('Alert!', 'End Date not selected', 'warning');
				return false;
			} else if (this.model.rate == null || this.model.rate == '') {
				this.$swal('Alert!', 'Rate cannot be empty', 'warning');
				return false;
			} else if (this.model.terminal_company_id == null) {
				this.$swal('Alert!', 'Terminal Company not selected', 'warning');
				return false;
			} else if (this.model.terminal_id == null) {
				this.$swal('Alert!', 'Terminal not selected', 'warning');
				return false;
			} else if (this.model.other_terms.length > 0) {
				if (this.model.other_terms[0].stream_type_id == null) {
					this.$swal('Alert!', 'Stream Type not selected', 'warning');
					return false;
				} else if (this.model.other_terms[0].blending_dry_fee == null || this.model.other_terms[0].blending_dry_fee == '') {
					this.$swal('Alert!', 'Blending Dry Fee cannot be empty', 'warning');
					return false;
				}
			} else if (this.model.treatfees.length > 0) {
				var length = this.model.treatfees.length;
				for (var i = 0; i < length; i++) {
					if (this.model.treatfees[i].treatment_fee_type_id == null) {
						this.$swal('Alert!', 'Treatment fee type not selected', 'warning');
						return false;
					} else if (this.model.treatfees[i].treatment_fee == null || this.model.treatfees[i].treatment_fee == '') {
						this.$swal('Alert!', 'Treatment fee cannot be empty', 'warning');
						return false;
					} else if (this.model.treatfees[i].condition_id == null) {
						this.$swal('Alert!', 'Condition of treatment fee not selected', 'warning');
						return false;
					} else if (this.model.treatfees[i].percentage == null || this.model.treatfees[i].percentage == '') {
						this.$swal('Alert!', 'Percentage of treatment fee cannot be empty', 'warning');
						return false;
					}
				}
			}

			if (this.model.otherfees.length > 0) {
				var _length = this.model.otherfees.length;
				for (var i = 0; i < _length; i++) {
					if (this.model.otherfees[i].terminal_rate == null || this.model.otherfees[i].terminal_rate == '') {
						this.$swal('Alert!', 'Other fee terminal rate cannot be empty', 'warning');
						return false;
					} else if (this.model.otherfees[i].rate == null || this.model.otherfees[i].rate == '') {
						this.$swal('Alert!', 'Other fee rate cannot be empty', 'warning');
						return false;
					}
				}
			}

			if (this.model.unload_locations.length > 0) {
				var _length2 = this.model.unload_locations.length;
				for (var i = 0; i < _length2; i++) {
					if (this.model.unload_locations[i].id == null) {
						this.$swal('Alert!', 'Unload location not selected', 'warning');
						return false;
					} else if (this.model.unload_locations[i].shipping_cost == null || this.model.unload_locations[i].shipping_cost == '') {
						this.$swal('Alert!', 'Shipping cost	 cannot be empty', 'warning');
						return false;
					} else if (this.model.unload_locations[i].monthly_commitment == null || this.model.unload_locations[i].monthly_commitment == '') {
						this.$swal('Alert!', 'Monthly commitment cannot be empty', 'warning');
						return false;
					} else if (this.model.unload_locations[i].contact_person == null || this.model.unload_locations[i].contact_person == '') {
						this.$swal('Alert!', 'Contact person cannot be empty', 'warning');
						return false;
					} else if (this.model.unload_locations[i].contact_email == null || this.model.unload_locations[i].contact_email == '') {
						this.$swal('Alert!', 'Contact email cannot be empty', 'warning');
						return false;
					}
					if (this.model.unload_locations[i].terminal_costs.length > 0) {
						var length1 = this.model.unload_locations[i].terminal_costs.length;
						for (var j = 0; j < length1; j++) {
							if (this.model.unload_locations[i].terminal_costs[j].terminal_cost_name == null || this.model.unload_locations[i].terminal_costs[j].terminal_cost_name == '') {
								this.$swal('Alert!', 'Terminal cost	 cannot be empty', 'warning');
								return false;
							} else if (this.model.unload_locations[i].terminal_costs[j].percentage == null || this.model.unload_locations[i].terminal_costs[j].percentage == '') {
								this.$swal('Alert!', 'Percentage of terminal cost cannot be empty', 'warning');
								return false;
							}
						}
					}
				}
			}

			if (this.model.load_locations_id.length == 0) {
				this.$swal('Alert!', 'Load location not selected', 'warning');
				return false;
			}
			return true;
		},
		update_terminal_agreement: function update_terminal_agreement() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			if (this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'marketing_accountant') {
				this.model.energy_company_id = this.energy_company_id;
			}
			__WEBPACK_IMPORTED_MODULE_5__t_agreement__["a" /* default */].update(this.model.id, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] == 'success') {
					_this2.getAgreementData();
					_this2.edit = false;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		delete_terminal_agreement: function delete_terminal_agreement() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Terminal Agreement: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_5__t_agreement__["a" /* default */].delete(_this3.model.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.push('/terminal_agreements');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		select_energy_companies1: function select_energy_companies1() {
			if (this.role == 'super_admin') {
				this.model.energy_company_id = '';

				var locations = this.update_data.locations_unload;
				var location_index = locations.map(function (o) {
					return o.id;
				}).indexOf(this.model.location_id);

				if (location_index > -1) {

					var energycompanies = locations[location_index]['energy_companies'];
					this.energycompanies = energycompanies.map(function (item) {
						return { 'value': item.id, 'text': item.name };
					});

					if (this.energycompanies.length == 1) {
						this.model.energy_company_id = this.energycompanies[0].value;

						var _energycompanies = locations[location_index]['energy_companies'];
						var energycompanies_index = _energycompanies.map(function (o) {
							return o.id;
						}).indexOf(this.selectedTruckingC);
					}
				}
			}
		},
		select_fluid_type: function select_fluid_type() {
			this.model.fluid_type_id = this.fluid_type.id;
			if (this.fluid_type.name == 'Oil') {
				this.model.other_terms.push(this.other_term);
			} else {
				this.model.other_terms = [];
			}
		},
		select_energy_company: function select_energy_company() {
			if (this.role == 'super_admin') {
				var energy_companies = this.update_data.energy_companies;
				var energy_company_index = energy_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.energy_company_id);
				if (energy_company_index > -1) {
					var loadlocations = energy_companies[energy_company_index].load_locations;
					this.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
				} else {
					this.loadlocationselect = [];
				}
				this.model.load_locations_id = [];
				this.load_locations_id = [];
			}
		},
		removetreatmentfee: function removetreatmentfee(treatfee) {
			this.model.treatfees.splice(treatfee, 1);
		},
		removeotherfee: function removeotherfee(otherfee) {
			this.model.otherfees.splice(otherfee, 1);
		},
		removelocation: function removelocation(location) {
			var unload_l = {
				value: this.model.unload_locations[location].id,
				text: this.model.unload_locations[location].name
			};
			this.locations.push(unload_l);
			this.locations.sort(function (a, b) {
				if (a.text > b.text) {
					return 1;
				}
				if (a.text < b.text) {
					return -1;
				}

				return 0;
			});
			this.model.unload_locations.splice(location, 1);
		},
		removeterminalcost: function removeterminalcost(row, terminalcost) {
			this.model.unload_locations[row.index].terminal_costs.splice(terminalcost, 1);

			if (this.model.unload_locations[row.index].terminal_costs.length == 0) {
				row.toggleDetails();
			}
		},
		addunloadlocation_2: function addunloadlocation_2() {
			var unload_location = {
				id: null,
				name: null,
				shipping_cost: null,
				monthly_commitment: null,
				contact_person: null,
				contact_email: null,
				terminal_costs: []
			};
			this.model.unload_locations.push(unload_location);
		},
		addtreatmentfee: function addtreatmentfee() {
			this.model.treatfees.push(this.treatfees);
			this.treatfees = {
				treatment_fee_type_id: null,
				treatment_fee: null,
				condition_id: null,
				percentage: null
			};
		},
		otherfee: function otherfee() {
			this.model.otherfees.push(this.otherfees);
			this.otherfees = {
				terminal_rate: null,
				rate: null
			};
		},
		addterminalcost: function addterminalcost(row) {
			var index = row.index;
			var terminal_cost = {
				terminal_cost_name: null,
				percentage: null
			};
			this.model.unload_locations[index].terminal_costs.push(terminal_cost);
			this.terminal_cost = {
				terminal_cost_name: null,
				percentage: null
			};
			if (!row.detailsShowing) {
				row.toggleDetails();
			}
		},
		showunloadlocation: function showunloadlocation() {
			this.newUnloadLocation = true;
		},
		select_terminal: function select_terminal() {
			if (this.role == 'super_admin') {
				var terminals = this.update_data.terminals;
				var terminal_index = terminals.map(function (o) {
					return o.id;
				}).indexOf(this.model.terminal_id);
				if (terminal_index > -1) {
					if (terminals[terminal_index].unload_location.length > 0) {
						this.model.unload_locations = [];
						var unload_locations = {
							id: terminals[terminal_index].unload_location[0].id,
							name: terminals[terminal_index].unload_location[0].name,
							shipping_cost: null,
							monthly_commitment: null,
							contact_person: null,
							contact_email: null,
							terminal_costs: []
						};
						this.model.unload_locations.push(unload_locations);
					} else {
						this.model.unload_locations = [];
					}
				} else {
					this.model.unload_locations = [];
				}
			}
		},
		get_attributtes: function get_attributtes() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_5__t_agreement__["a" /* default */].get_attr_ta().then(function (data) {
				if (data.status == 'success') {
					if (data.insert_data) {
						_this4.update_data = data.insert_data;
						if (_this4.update_data.locations_unload.length != 0) {
							_this4.locations = _this4.update_data.locations_unload.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}

						if (_this4.update_data.fluidtypes.length != 0) {
							_this4.fluidtypes = _this4.update_data.fluidtypes;
						}
						_this4.energycompanies = _this4.update_data.energy_companies;

						_this4.terminalcompanies = _this4.update_data.terminal_companies;
						_this4.terminals = _this4.update_data.terminals;

						if (_this4.update_data.treatment_fee_type.length != 0) {
							_this4.treatment_fee_type = _this4.update_data.treatment_fee_type.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}

						if (_this4.update_data.conditions.length != 0) {
							_this4.condition = _this4.update_data.conditions.map(function (item) {
								return { text: item.name, value: item.id };
							});
						}
						if (_this4.role == 'super_analyst' || _this4.role == 'analyst' || _this4.role == 'marketing_accountant') {
							if (_this4.energycompanies.length != 0) {
								var loadlocations = _this4.energycompanies[0].load_locations;
								_this4.loadlocationselect = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(loadlocations));
							} else {
								_this4.loadlocationselect = [];
							}
						}
					}
				} else {
					_this4.$swal(data.status, data.message, data.status);
				}
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
			});
		}
	}
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Index',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      fluid_types: [],
      model: {
        fluid_type_id: null,
        settle_date: null,
        index: null,
        wadf: null
      },

      newIndex: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'settle_date',
        label: 'Settle Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format("MMM DD, YYYY");
        }
      }, {
        key: 'fluid_type',
        label: 'Fluid Type',
        sortable: true
      }, {
        key: 'index',
        label: 'Index',
        sortable: true,
        formatter: function formatter(value) {
          if (value != '<b-col class ="value_none" ><b>None</b></b-col>') {
            return '$' + value;
          } else {
            return value;
          }
        }
      }, {
        key: 'wadf',
        label: 'WADF',
        sortable: true,
        formatter: function formatter(value) {
          if (value != '<b-col class ="value_none" ><b>None</b></b-col>') {
            return '$' + value;
          } else {
            return value;
          }
        }
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'id',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true,
      rate: ''
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newIndexModal: function newIndexModal() {
      this.model = {
        fluid_type_id: null,
        settle_date: null,
        index: null,
        wadf: null
      };
      this.savebtn = false;
      this.newIndex = true;
    },
    trashIndex: function trashIndex() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/index/' + row.id + '/');
      } else {
        this.restoreIndex(row.id);
      }
    },
    okToSave: function okToSave() {

      if (this.model.settle_date == null) {
        this.$swal('Alert!', 'Settle Date not selected', 'warning');
        return false;
      } else if (this.model.fluid_type_id == null) {
        this.$swal('Alert!', 'Fluid Type not selected', 'warning');
        return false;
      } else if (this.model.index == null) {
        this.$swal('Alert!', 'Index cannot be empty', 'warning');
        return false;
      } else if (this.model.wadf == null) {
        this.$swal('Alert!', 'WADF cannot be empty', 'warning');
        return false;
      }
      return true;
    },
    saveIndex: function saveIndex() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      __WEBPACK_IMPORTED_MODULE_1__t_agreement__["a" /* default */].save_indexes(this.model).then(function (data) {
        _this.$swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this.newIndex = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__t_agreement__["a" /* default */].get_indexes().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.indexes.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
          _this2.fluid_types = data.insert_data.fluid_types;
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreIndex: function restoreIndex(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Index?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__t_agreement__["a" /* default */].restoreIndex(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
              _this3.dpdt = 'Active';
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    coordsBlur: function coordsBlur(variableName) {
      if (this.model[variableName] !== undefined) {
        var x = String(this.model[variableName]).split(".");
        if (x.length == 1 && x[0].length == 0) {
          this.model[variableName] = '0.00';
        } else if (x.length == 1) {
          this.model[variableName] = this.model[variableName] + '.00';
        } else {
          this.model[variableName] = x[0] + "." + x[1];
          this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])));
        }
      }
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'IndexDetail',
	created: function created() {
		this.getIndex();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: true,
			notFoundMessage: 'Not found',
			fluid_types: [],
			model: {
				fluid_type_id: null,
				settle_date: null,
				index: null,
				wadf: null
			},
			updateData: null,
			originalData: null,
			loadingData: false,
			rate: '',
			indexId: '',
			show: {
				settle_date: '',
				fluid_type: '',
				index: '',
				wadf: ''
			}
		};
	},

	methods: {
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		editIndex: function editIndex() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = {
				fluid_type_id: this.originalData.fluid_type_id,
				settle_date: this.originalData.settle_date,
				index: this.originalData.index,
				wadf: this.originalData.wadf
			};
			this.model = model;

			var show = {
				settle_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.originalData.settle_date).format("MMM DD, YYYY"),
				fluid_type: this.originalData.fluid_type,
				index: this.format(this.originalData.index),
				wadf: this.format(this.originalData.wadf)
			};
			this.show = show;
		},
		format: function format(value) {
			if (value == null) {
				return 'None';
			} else {
				return '$' + value;
			}
		},
		getIndex: function getIndex() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__t_agreement__["a" /* default */].getByIndex(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.index;

					_this.indexId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();

					_this.subTitle = _this.originalData.fluid_type + "+" + __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.originalData.settle_date).format("MMM DD, YYYY");
					_this.fluid_types = data.update_data.fluid_types;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.settle_date == null) {
				this.$swal('Alert!', 'Settle Date not selected', 'warning');
				return false;
			} else if (this.model.fluid_type_id == null) {
				this.$swal('Alert!', 'Fluid Type not selected', 'warning');
				return false;
			} else if (this.model.index == null) {
				this.$swal('Alert!', 'Index cannot be empty', 'warning');
				return false;
			} else if (this.model.wadf == null) {
				this.$swal('Alert!', 'WADF cannot be empty', 'warning');
				return false;
			}
			return true;
		},
		updateIndex: function updateIndex() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_0__t_agreement__["a" /* default */].update_index(this.indexId, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getIndex();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteIndex: function deleteIndex(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Index: " + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_0__t_agreement__["a" /* default */].delete_index(_this3.indexId).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/indexes');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		coordsBlur: function coordsBlur(variableName) {
			if (this.model[variableName] !== undefined) {
				var x = String(this.model[variableName]).split(".");
				if (x.length == 1 && x[0].length == 0) {
					this.model[variableName] = '0.00';
				} else if (x.length == 1) {
					this.model[variableName] = this.model[variableName] + '.00';
				} else {
					this.model[variableName] = x[0] + "." + x[1];
					this.model[variableName] = parseFloat(parseFloat(String(this.model[variableName])));
				}
			}
		}
	}
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Wtis',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      model: {
        future: null,
        settle_date: null,
        wti: null,
        forex: null
      },
      newWti: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'settle_date',
        label: 'Settle Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format("MMM DD, YYYY");
        }
      }, {
        key: 'future',
        label: 'Future',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format("MMM-YYYY");
        }
      }, {
        key: 'wti',
        label: 'WTI',
        sortable: true,
        formatter: function formatter(value) {
          if (value != '<b-col class ="value_none" ><b>None</b></b-col>') {
            return '$' + value;
          } else {
            return value;
          }
        }
      }, {
        key: 'forex',
        label: 'Forex',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'id',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true,
      rate: ''
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newWtiModal: function newWtiModal() {
      this.model = {
        future: null,
        settle_date: null,
        wti: null,
        forex: null
      };
      this.savebtn = false;
      this.newWti = true;
    },
    trashWti: function trashWti() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/wti/' + row.id + '/');
      } else {
        this.restoreWti(row.id);
      }
    },
    okToSave: function okToSave() {

      if (this.model.settle_date == null) {
        this.$swal('Alert!', 'Settle Date not selected', 'warning');
        return false;
      } else if (this.model.future == null) {
        this.$swal('Alert!', 'Future not selected', 'warning');
        return false;
      } else if (this.model.wti == null) {
        this.$swal('Alert!', 'Wti cannot be empty', 'warning');
        return false;
      } else if (this.model.forex == null) {
        this.$swal('Alert!', 'Forex cannot be empty', 'warning');
        return false;
      }
      return true;
    },
    saveWti: function saveWti() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      __WEBPACK_IMPORTED_MODULE_1__t_agreement__["a" /* default */].save_wti(this.model).then(function (data) {
        _this.$swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this.newWti = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__t_agreement__["a" /* default */].get_wti().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.wti.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreWti: function restoreWti(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this WTI?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__t_agreement__["a" /* default */].restoreWti(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
              _this3.dpdt = 'Active';
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__t_agreement__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'WtiDetail',
	created: function created() {
		this.getWti();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: true,
			notFoundMessage: 'Not found',
			model: {
				future: null,
				settle_date: null,
				wti: null,
				forex: null
			},
			updateData: null,
			originalData: null,
			loadingData: false,
			rate: '',
			wtiId: '',
			show: {
				settle_date: '',
				future: '',
				wti: '',
				forex: ''
			}
		};
	},

	methods: {
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		editWti: function editWti() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = {
				settle_date: this.originalData.settle_date,
				future: this.originalData.future,
				wti: this.originalData.wti,
				forex: this.originalData.forex
			};
			this.model = model;
			var show = {
				settle_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.originalData.settle_date).format("MMM DD, YYYY"),
				future: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.originalData.future).format("MMM-YYYY"),
				wti: this.format(this.originalData.wti),
				forex: this.originalData.forex
			};
			this.show = show;
		},
		format: function format(value) {
			if (value == null) {
				return 'None';
			} else {
				return '$' + value;
			}
		},
		getWti: function getWti() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__t_agreement__["a" /* default */].getByWti(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.wti;

					_this.wtiId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();

					_this.subTitle = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.originalData.settle_date).format("MMM DD, YYYY");
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.settle_date == null) {
				this.$swal('Alert!', 'Settle Date not selected', 'warning');
				return false;
			} else if (this.model.future == null) {
				this.$swal('Alert!', 'Future not selected', 'warning');
				return false;
			} else if (this.model.wti == null) {
				this.$swal('Alert!', 'WTI cannot be empty', 'warning');
				return false;
			} else if (this.model.forex == null) {
				this.$swal('Alert!', 'Forex cannot be empty', 'warning');
				return false;
			}
			return true;
		},
		updateWti: function updateWti() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_0__t_agreement__["a" /* default */].update_wti(this.wtiId, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getWti();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteWti: function deleteWti(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this WTI " + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_0__t_agreement__["a" /* default */].delete_wti(_this3.wtiId).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/wti');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_users_service__ = __webpack_require__(23);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hauls',
  created: function created() {
    this.Switch_Filters();
  },
  data: function data() {
    var _this = this;

    return {
      filename: 'report_' + __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "TYPE": "type",
        "Ticket_Number": "ticket",
        "To_location": "unload_location_lsd",
        "production_date": "haul_start_date",
        "trucking_company": "trucking_company",
        "From_location": "load_location_lsd",
        "BSW": "bsw",
        "Total Fluid Volume": "volume_actual"
      },
      json_data: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      status: 'unchecked',
      insert_data: null,
      selected: '',
      energy_companies_filter: '',
      load_locations_filter: '',
      unload_locations_filter: '',
      trucking_companies_filter: '',
      row: 0,
      loadingData: true,
      trash: false,
      dpdt: "Active",
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "" },
      companyName: '',
      companyId: null,
      configTable: false,
      items: items,
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'type',
        label: 'Type',
        sortable: true
      }, {
        key: 'ticket',
        label: 'Ticket_Number',
        sortable: true
      }, {
        key: 'unload_location_lsd',
        label: 'To location',
        sortable: true
      }, {
        key: 'haul_start_date',
        label: 'Production date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format("DD-MMM-YYYY");
        }
      }, {
        key: 'trucking_company',
        label: 'Trucking Company',
        sortable: true
      }, {
        key: 'load_location_lsd',
        label: 'From location',
        sortable: true
      }, {
        key: 'bsw',
        label: 'BS&W (%)',
        sortable: true,
        formatter: function formatter(value) {
          return Number(value.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
        }
      }, {
        key: 'volume_actual',
        label: 'Total Fluid Volume',
        sortable: true,
        formatter: function formatter(value) {
          return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + _this.unit;
        }
      }],
      currentPage: parseInt(localStorage.haulPage),
      perPage: 25,
      pageOptions: [25, 50, 100],
      filter: null,
      selectedItems: ["type", "ticket", "unload_location_lsd", "haul_start_date", "trucking_company", "load_location_lsd", "bsw", "volume_actual"],
      role: '',
      energy_company_id: null,
      unit: '',
      dash: '',
      send_ftp: true,
      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        unload_location_id: 0,
        unload_name: 'All UnLoads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        sortby: 'haul_id',
        sortdesc: false
      },
      filters_start: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        unload_location_id: 0,
        unload_name: 'All UnLoads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        sortby: 'haul_id',
        sortdesc: false
      }
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    saveSelectedColumns: function saveSelectedColumns() {
      var _this2 = this;

      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.configTable = false;
      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].saveSelectedColumns(this.fields).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            setTimeout(function () {
              _this2.$refs.mEdit.hide();
            }, 500);
          }
        });
      });
    },
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.haulPage);

      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearFilters: function clearFilters() {

      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "" };
      this.filters_save = {
        folder_id: 0,
        folder: 'All Folders',
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        truck_id: 0,
        truck_name: 'All Trucks',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All UnLoads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        sortby: 'haul_id',
        sortdesc: false
      };
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();
      this.saveFilters();
      this.loadingData = true;
    },
    getAll: function getAll() {
      var _this3 = this;

      this.selected = '';
      this.haul_ids = [];
      this.items = [];
      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].getAll(this.filter_by).then(function (data) {
        if (data.status == 'success') {

          _this3.insert_data = data.insert_data;
          _this3.energy_companies_filter = data.energy_companies_filter;

          _this3.trucking_companies_filter = data.trucking_companies_filter;

          var features = data.hauls;
          _this3.items = [];
          for (var i = 0; i < features.length; i++) {
            if (features[i].status_id == (_this3.trash ? 2 : 1)) {

              var type = "TICKET";
              var haul_id = features[i].haul_id;


              var load_location_lsd = features[i].load_location_lsd;
              switch (load_location_lsd) {
                case '0':
                  load_location_lsd = 'OTHER';
                  break;
                case '01-26-075-10W6':
                  load_location_lsd = '100/04-24-075-10W6/0 (01-26) SWB';
                  break;
                case '04-24-075-10W6':
                  load_location_lsd = '100/04-24-075-10W6/0 (01-26) SWB';
                  break;
                case '5-24-76-11W6':
                  load_location_lsd = '102/5-24-76-11W6';
                  break;
                case '06-14-075-09W6':
                  load_location_lsd = 'Valhalla 06-14-075-09W6 BT';
                  break;
                case '06-06-075-10W6':
                  load_location_lsd = '100/06-06-075-10W6/02';
                  break;
                case '06-18-074-08W6':
                  load_location_lsd = 'Valhalla 06-18-074-08W6 BT';
                  break;
                case '07-32-073-08W6':
                  load_location_lsd = 'Valhalla 7-32 connoco';
                  break;
                case '8-6-75-9W6':
                  load_location_lsd = '100/08-06-075-09W6/00';
                  break;
                case '8-7-75-9W6':
                  load_location_lsd = '100/08-07-075-09W6/00 SWOB';
                  break;
                case '10-17-075-09W6':
                  load_location_lsd = '100/10-17-075-09W6/02';
                  break;
                case '12-24-072-06W6':
                  load_location_lsd = 'Ocean Fluids & Filtration 12-24-072-06W6';
                  break;
                case '14-18-075-08W6':
                  load_location_lsd = 'Valhalla 102/14-18-075-08W6/02 SWB';
                  break;
                case '14-27-076-11W6':
                  load_location_lsd = '14-27-076-11W6 Compressor';
                  break;
                case '14-27-76-11W6':
                  load_location_lsd = '14-27-076-11W6 Compressor';
                  break;
                case '15-06-75-08-W6':
                  load_location_lsd = '100/06-06-075-10W6/02';
                  break;
                case '15-06-075-08W6':
                  load_location_lsd = '102/15-06-075-08W6/00';
                  break;
                case '16-14-75-10W6':
                  load_location_lsd = '100/16-14-075-10W6/00';
                  break;
                case '16-14-75-10W6':
                  load_location_lsd = '100/16-14-075-10W6/00';
                  break;
                case '102/5-24-76-11W6':
                  load_location_lsd = '102/05-24-076-11W6/02 Oil';
                  break;
                case '102/11-29-073-08-W6':
                  load_location_lsd = '(14-32)102/11-29-073-08-W6';
                  break;
                case '103/15-18-075-08W6':
                  load_location_lsd = '102/10-18-075-08W6';
                  break;
                case 'D Ray Pit D Ray Pit':
                  load_location_lsd = 'D Ray Pit D Ray Pit SE-30-071-10-W6';
                  break;
                case "Ocean'S Fluid":
                  load_location_lsd = "Ocean Fluids & Filtration 12-24-072-06W6";
                  break;
                case 'Se-30-071-10-W6':
                  load_location_lsd = 'D Ray Pit D Ray Pit SE-30-071-10-W6';
                  break;

              }

              var unload_location_lsd = features[i].unload_location_lsd;
              switch (unload_location_lsd) {
                case '0':
                  unload_location_lsd = 'OTHER';
                  break;
                case '06-14-75-09W6':
                  unload_location_lsd = 'Valhalla 06-14-075-09W6 BT';
                  break;
                case '06-14-075-09W6':
                  unload_location_lsd = 'Valhalla 06-14-075-09W6 BT';
                  break;
                case '09-16-069-22W5':
                  unload_location_lsd = 'Tervita Valleyview 09-16-69-22W5';
                  break;
                case '10-19-74-8W6':
                  unload_location_lsd = '100/10-19-074-08W6/00';
                  break;
                case '102/11-29-073-08W6':
                  unload_location_lsd = 'Valhalla 102/11-29-073-08W6/00';
                  break;
                case '102/15-06-075-08W6':
                  unload_location_lsd = '102/15-06-075-08W6/00';
                  break;
                case '12-08-073-08W6':
                  unload_location_lsd = 'Tervita LaGlace 12-08-073-08W6';
                  break;
                case '12-31-077-05W6':
                  unload_location_lsd = 'Tervita Spirit River 12-31-077-05W6';
                  break;
                case '12-36-062-020W5':
                  unload_location_lsd = 'Secure Fox 12-36-62-20W5';
                  break;
                case '12-36-062-20W5':
                  unload_location_lsd = 'Secure Fox 12-36-62-20W5';
                  break;
                case '13-08-076-10W6':
                  unload_location_lsd = '100/13-08-076-10W6/00';
                  break;
                case '15-6-76-10W6':
                  unload_location_lsd = 'Surge Battery 15-6-76-10W6';
                  break;
                case '16-07-073-08W6':
                  unload_location_lsd = 'Secure LaGlace 16-07-073-08W6';
                  break;
                case '16-14-075-09W6':
                  unload_location_lsd = 'Valhalla 06-14-075-09W6 BT';
                  break;
                case 'Secure Laglace':
                  unload_location_lsd = 'Secure LaGlace 16-07-073-08W6';
                  break;
                case 'Surge Battery':
                  unload_location_lsd = 'Surge Battery 15-6-76-10W6';
                  break;
                case 'SW-4-21-075-09W6':
                  unload_location_lsd = '100/04-24-075-10W6 (01-26)';
                  break;
                case 'Sw-4-21-075-09W6':
                  unload_location_lsd = '100/04-24-075-10W6 (01-26)';
                  break;
                case 'Tervita Judy Creek':
                  unload_location_lsd = 'Tervita Judy Creek 04-05-063-11W5';
                  break;
                case 'Tervita Laglace':
                  unload_location_lsd = 'Tervita LaGlace 12-08-073-08W6';
                  break;
                case 'Tervita Spirit River':
                  unload_location_lsd = 'Tervita Spirit River 12-31-077-05W6';
                  break;
                case 'Tervita Valleyview':
                  unload_location_lsd = 'Tervita Valleyview 09-16-69-22W5';
                  break;
              }
              var ticket = features[i].ticket;

              if (features[i].oil_actual.indexOf('bbl') != -1) {
                _this3.unit = ' bbl';
              } else {
                _this3.unit = ' m³';
              }
              var volume_actual = features[i].volume_actual;
              var bsw = features[i].bsw;
              var energy_company = features[i].energy_company;
              var haul_start_date = features[i].haul_start_date;
              var volume = features[i].volume;
              var f_bsw = features[i].f_bsw;
              var truck_company = features[i].truck_company;

              var _data = {
                "type": type,
                "haul_id": haul_id,

                "load_location_lsd": load_location_lsd,

                "unload_location_lsd": unload_location_lsd,
                "ticket": ticket,
                "volume_actual": parseFloat(volume_actual.replace(_this3.unit, "")),
                "bsw": parseFloat(bsw.replace("%", "")),
                "energy_company": energy_company,
                "haul_start_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()(haul_start_date).format('DD-MMM-YYYY'),
                "trucking_company": truck_company
              };
              _this3.items.push(_data);
            }
          }
          _this3.role = data.role;
        } else {
          _this3.$swal(data.status, data.message, data.status);
          _this3.loadingData = false;
          return;
        }
        _this3.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this3.loadingData = false;
      });
    },
    saveFilters: function saveFilters() {
      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].saveFilters(1, this.filters_save).then(function (data) {
        if (data[0] == 'success') {
          return;
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]);
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        return;
      });
    },
    getFilters: function getFilters() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].getFilters(1).then(function (data) {
        if (data[0] == 'success') {
          _this4.filters_start = data[1];
          _this4.filters_start1 = data[2];
          if (_this4.filters_start.length != 0) {
            for (var property in _this4.filters_start[0]) {
              _this4.filters_save[property] = _this4.filters_start[0][property];
              if (_this4.filters_start[0][property] == 0) {
                _this4.filter_by[property] = "";
              } else if (_this4.filters_start[0][property] == null) {
                _this4.filter_by[property] = "";
              } else {
                _this4.filter_by[property] = _this4.filters_start[0][property];
              }
            }
            if (_this4.filters_start[0]['initial_date'] == null) {
              _this4.filter_by['initial_date'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD');
              _this4.filters_save['initial_date'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD');
            }
            if (_this4.filters_start[0]['end_date'] == null) {
              _this4.filter_by['end_date'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD');
              _this4.filters_save['end_date'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD');
            }

            for (var property in _this4.filters_start1[0]) {
              _this4.filters_save[property] = _this4.filters_start1[0][property];
            }

            if (_this4.filters_start[0].folder_id == 0 && _this4.filters_start1[0].folder == 'Unassigned Hauls') {
              _this4.filter_by.folder_id = _this4.filters_start[0].folder_id;
            }
            _this4.filters_save.folder_id = _this4.filters_start[0].folder_id;
            _this4.filters_save.folder = _this4.filters_start1[0].folder;
          } else {
            _this4.filters_save.folder_id = 0;
            _this4.filters_save.folder = "All Folders";
            _this4.filters_save.energy_companies_id = 0;
            _this4.filters_save.energy_company_name = "All Energy Companies";
            _this4.filters_save.fluid_type_id = 0;
            _this4.filters_save.fluid_type_name = "All Fluid Types";
            _this4.filters_save.users_id = 0;
            _this4.filters_save.driver_name = "All Drivers";
            _this4.filters_save.truck_id = 0;
            _this4.filters_save.truck_name = "All Trucks";
            _this4.filters_save.trucking_company_id = 0;
            _this4.filters_save.trucking_company_name = "All Trucking Companies";
            _this4.filters_save.unload_location_id = 0;
            _this4.filters_save.load_name = "All Loads";
            _this4.filters_save.unload_location_id = 0;
            _this4.filters_save.unload_name = "All Unloads";
            _this4.filters_save.flag_name = "All Flags";
            _this4.filters_save.initial_date = __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD');
            _this4.filters_save.end_date = __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD');
            _this4.filters_save.sortby = 'haul_id';
            _this4.filters_save.sortdesc = false;
            _this4.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "" };
          }
          _this4.getAll();
          _this4.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]);
          _this4.loadingData = false;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this4.loadingData = false;
      });
    },
    sortingChanged: function sortingChanged(ctx) {
      this.filters_save.sortdesc = ctx.sortDesc;
      this.filters_save.sortby = ctx.sortBy;
      this.saveFilters();
    },
    Switch_Filters: function Switch_Filters() {

      if ("dashboard" in localStorage) {
        this.dash = localStorage.getItem('dashboard');
      } else {
        this.dash = "dash00";
      }
      if (this.dash == "dash00") {
        localStorage.setItem('dashboard', 'dash00');
        this.getFilters();
      } else {
        this.filters_save.folder_id = 0;
        this.filters_save.folder = "All Folders";
        this.filters_save.energy_companies_id = 0;
        this.filters_save.fluid_type_id = 0;
        this.filters_save.fluid_type_name = "All Fluid Types";
        this.filters_save.users_id = 0;
        this.filters_save.driver_name = "All Drivers";
        this.filters_save.truck_id = 0;
        this.filters_save.truck_name = "All Trucks";
        this.filters_save.trucking_company_id = 0;
        this.filters_save.trucking_company_name = "All Trucking Companies";
        this.filters_save.load_location_id = 0;
        this.filters_save.load_name = "All Loads";
        this.filters_save.unload_location_id = 0;
        this.filters_save.unload_name = "All Unloads";
        this.filters_save.flag_name = "All Flags";
        this.filters_save.sortby = 'haul_id';
        this.filters_save.sortdesc = false;
        this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('month').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id": "", "fluid_type_id": "" };

        this.filter_by.initial_date = localStorage.getItem('dashboard_start_date');
        this.filter_by.end_date = localStorage.getItem('dashboard_end_date');
        this.filter_by.energy_companies_id = localStorage.getItem('dashboard_energy_id');
        this.filters_save.energy_company_name = localStorage.getItem('dashboard_energy_name');

        if ("dashboard_trucking_company_id" in localStorage) {
          if (localStorage.getItem('dashboard_trucking_company_id') != '') {
            this.filters_save.trucking_company_id = localStorage.getItem('dashboard_trucking_company_id');
            this.filter_by.trucking_company_id = this.filters_save.trucking_company_id;
          } else {
            this.filters_save.trucking_company_id = 0;
            this.filter_by.trucking_company_id = '';
          }
        } else {
          this.filters_save.trucking_company_id = 0;
          this.filter_by.trucking_company_id = '';
        }

        if ("dashboard_trucking_company_name" in localStorage) {
          if (localStorage.getItem('dashboard_trucking_company_name') != '') {
            this.filters_save.trucking_company_name = localStorage.getItem('dashboard_trucking_company_name');
          } else {
            this.filters_save.trucking_company_name = "All Trucking Companies";
          }
        } else {
          this.filters_save.trucking_company_name = "All Trucking Companies";
        }

        if (this.dash == 'dash03') {
          this.filters_save.unload_location_id = localStorage.getItem('dashboard_location_id');
          this.filter_by.unload_location_id = this.filters_save.unload_location_id;
          this.filters_save.unload_name = localStorage.getItem('dashboard_location_name');
          localStorage.removeItem('dashboard_location_id');
          localStorage.removeItem('dashboard_location_name');
        }

        if (this.dash == 'dash04' || this.dash == 'dash06' || this.dash == 'dash07') {
          this.filters_save.unload_location_id = localStorage.getItem('dashboard_location_id');
          this.filter_by.unload_location_id = this.filters_save.unload_location_id;
          this.filters_save.unload_name = localStorage.getItem('dashboard_location_name');
          this.filters_save.fluid_type_id = localStorage.getItem('dashboard_fluid_type_id');
          this.filter_by.fluid_type_id = this.filters_save.fluid_type_id;
          this.filters_save.fluid_type_name = localStorage.getItem('dashboard_fluid_type_name');

          localStorage.removeItem('dashboard_location_id');
          localStorage.removeItem('dashboard_location_name');
          localStorage.removeItem('dashboard_fluid_type_id');
          localStorage.removeItem('dashboard_fluid_type_name');
        }

        if (this.dash == 'dash05') {
          this.filters_save.load_location_id = localStorage.getItem('dashboard_location_id');
          this.filter_by.load_location_id = this.filters_save.load_location_id;
          this.filters_save.load_name = localStorage.getItem('dashboard_location_name');
          this.filters_save.fluid_type_id = localStorage.getItem('dashboard_fluid_type_id');
          this.filter_by.fluid_type_id = this.filters_save.fluid_type_id;
          this.filters_save.fluid_type_name = localStorage.getItem('dashboard_fluid_type_name');

          localStorage.removeItem('dashboard_location_id');
          localStorage.removeItem('dashboard_location_name');
          localStorage.removeItem('dashboard_fluid_type_id');
          localStorage.removeItem('dashboard_fluid_type_name');
        }

        if (this.dash == 'dash08') {
          this.filters_save.flag_name = localStorage.getItem('dashboard_flag_name');
          localStorage.removeItem('dashboard_flag_name');
        }

        localStorage.setItem('dashboard', 'dash00');
        localStorage.removeItem("dashboard_start_date");
        localStorage.removeItem("dashboard_end_date");
        localStorage.removeItem('dashboard_energy_id');
        localStorage.removeItem('dashboard_energy_name');
        localStorage.removeItem('dashboard_trucking_company_id');
        localStorage.removeItem('dashboard_trucking_company_name');
        this.getAll();
        this.loadingData = true;
      }
    },
    SendFTP: function SendFTP() {
      var _this5 = this;

      if (this.filters_save.energy_company_name === 'Surge Energy') {
        var filter_ftp = {
          initial_date: this.filter_by.initial_date,
          end_date: this.filter_by.end_date,
          trucking_company_id: this.filter_by.trucking_company_id
        };
        this.send_ftp = false;
        __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].sendFTP(filter_ftp).then(function (data) {
          if (data.status == 'success') {
            _this5.$swal(data.status, data.message, data.status);
            _this5.send_ftp = true;
            return;
          } else {
            _this5.$swal(data.status, data.message, data.status);
            _this5.send_ftp = true;
            return;
          }
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
          _this5.send_ftp = true;
        });
      }
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__profile_service__ = __webpack_require__(1180);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'profile',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getProfileData();
	},
	data: function data() {
		return {
			edit: false,
			loadingData: true,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				first_name: '',
				last_name: '',
				usename: '',
				email: '',
				role: ''
			},
			nopassword: true,
			new_password: '',
			confirm_new_password: ''
		};
	},

	methods: {
		getProfileData: function getProfileData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__profile_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] === 'success') {
					_this.model = data[1];
					_this.found = true;
					_this.loadingData = false;
				} else {
					_this.loadingData = false;
					_this.$swal(data[0], data[1], data[0]);

					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		resetpass: function resetpass() {
			this.nopassword = false;
		},
		cancelpass: function cancelpass() {
			this.nopassword = true;
			this.new_password = '';
			this.confirm_new_password = '';
		},
		updatepass: function updatepass() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			var dataUser = {
				new_password: this.new_password,
				new_new_password: this.confirm_new_password
			};
			__WEBPACK_IMPORTED_MODULE_0__profile_service__["a" /* default */].reset_password(dataUser).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]);
				if (data[0] === 'success') {
					_this2.nopassword = true;
				} else {
					_this2.nopassword = true;
					return;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		okToUpdate: function okToUpdate() {

			if (String(this.new_password).trim().length > 0 && String(this.confirm_new_password).trim().length > 0) {
				if (String(this.confirm_new_password).trim() !== String(this.new_password).trim()) {
					this.$swal('Alert!', 'New Password does not match the confirm password', 'warning');
					return false;
				}
			} else {
				if (String(this.new_password).trim().length == 0) {
					this.$swal('Alert!', 'New Password can not be empty', 'warning');
					return false;
				} else if (String(this.confirm_new_password).trim().length == 0) {
					this.$swal('Alert!', 'Confirm new Password can not be empty', 'warning');
					return false;
				}
			}
			return true;
		}
	}
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_roles_roles_service__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(146);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',

  data: function data() {
    return {
      user: '',
      password: '',
      dataRequired: false,
      loginFailed: false,
      loginFailedMessage: '',
      waiting: false,
      waitingMessage: 'Please wait...',
      notResponse: false,
      roles: [],
      selectedRole: null,
      ForgotPassword: false,
      model: {
        first_name: '',
        last_name: '',
        usename: '',
        email: '',
        role_id: null
      },

      show: true
    };
  },
  methods: {
    getUser: function getUser() {
      var _this = this;

      if (this.user.trim()) {
        __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].getUser(this.user).then(function (data) {
          if (data[0] == 'success') {
            _this.$swal({ title: data[1],
              text: data[2],
              type: 'success',
              showCancelButton: false });
          } else {
            _this.$swal({ title: data[1],
              text: data[2],
              type: 'warning',
              showCancelButton: false });
          }
        }).catch(function (error) {
          _this.$swal('Error', 'Server not response. ' + error, 'error');
        });
      } else {
        this.$swal({ title: 'Opss!',
          text: 'Email Required',
          type: 'warning',
          showCancelButton: false });
      }
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logs_service__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_users_service__ = __webpack_require__(23);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logs',
  created: function created() {
    localStorage.removeItem("logsaPage");
    localStorage.removeItem("locationsaPage");
    localStorage.removeItem("tagetsaPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("userPage");
    if (!localStorage.logPage) {
      localStorage.logPage = 0;
    }
    this.getAll();
  },
  data: function data() {
    var _ref;

    return _ref = {
      filename: 'logs_report_' + __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "log_id": "id",
        "log_error": "error",
        "log_service": "service",
        "log_user": "user",
        "log_client": "client",
        "log_generated_at": "generated_at"
      },
      json_data: [],
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],

      status: 'unchecked',
      insert_data: null,
      log_ids: [],
      selected: '',
      row: 0,
      loadingData: true,
      trash: false,
      items: items
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'items', items), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'totalRows', items.length), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'v_items', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'fieldsSelected', 8), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'maxFieldsSelected', 10), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tempFields', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'fields', [{
      key: 'id',
      label: 'Id',
      sortable: true
    }, {
      key: 'error',
      label: 'Error',
      sortable: true
    }, {
      key: 'service',
      label: 'Service',
      sortable: true
    }, {
      key: 'user',
      label: 'User',
      sortable: true
    }, {
      key: 'client',
      label: 'Client',
      sortable: true
    }, {
      key: 'generated_at',
      label: 'Generated At',
      sortable: true
    }, {
      key: 'is_resolved',
      label: 'Status',
      sortable: true,
      formatter: function formatter(value) {
        return value ? 'Solved' : 'Not Solved';
      }
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'currentPage', parseInt(localStorage.logPage)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'perPage', 25), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'pageOptions', [25, 50, 100]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sortBy', 'id'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sortDesc', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modalInfo', {
      title: '',
      content: ''
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modalEdit', {
      title: ''
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedItems', ['log_id', 'log_error', 'log_service', 'log_user', 'log_client', 'log_generated_at']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'role', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'view', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'view1', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'savebtn', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'energy_company_id', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'unit', ''), _ref;
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.currentPage = parseInt(localStorage.logPage);

      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    rowClicked: function rowClicked(row) {
      localStorage.rolesPage = this.currentPage;
      localStorage.setItem('xyz', row.id);
      this.$router.push('/log/' + row.id + '/');
    },
    getAll: function getAll() {
      var _this = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_3__logs_service__["a" /* default */].getAll().then(function (data) {
        if (data[0] == 'success') {
          _this.items = data[1];
        } else {
          _this.items = [];
          _this.$swal(data[0], data[1], data[0]);
        }
        _this.loadingData = false;
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/logs/', { headers: {
          'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        if (response.data.status === 'success') {
          var data = [response.data.status, response.data.logs];
          resolve(data);
        } else {
          var data = [response.data.status, response.data.message];
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBy: function getBy(LogId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/log/' + LogId + '/', { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        if (response.data.status === 'success') {
          var data = '';
          data = response.data;
          resolve(data);
        } else {
          var data = '';
          data = response.data;
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  change_status: function change_status(log_id, status) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/log/changestatus/' + log_id + '/', { solved: status }, { headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  post_json_data: function post_json_data(log_id, log_data, service, method) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + service, method: method, data: log_data, headers: {
          'Content-Type': 'application/json',
          'mobile': false,
          'log_id': log_id,
          'token': localStorage.getItem('access_token')
        } }).then(function (response) {
        var data = [response.data.status, response.data.message];
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logs_service__ = __webpack_require__(566);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'log',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getLogData();
	},
	data: function data() {
		return {
			originalData: null,
			edit: false,
			loadingData: true,
			model: {
				id: null,
				error: '',
				service: '',
				user: '',
				client: '',
				generated_at: '',
				data: '',
				is_resolved: '',
				last_repost_at: '',
				last_repost_response: '',
				traceback: '',
				method: ''
			},
			json: ''
		};
	},
	mounted: function mounted() {
		var jsonprettyScript = document.createElement('script');
		jsonprettyScript.setAttribute('src', 'static/dist/json_pretty.js');
		jsonprettyScript.setAttribute('async', 'false');
		jsonprettyScript.setAttribute('defer', 'false');
		document.head.insertBefore(jsonprettyScript, document.head.firstChild);
	},

	methods: {
		getLogData: function getLogData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__logs_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.log));

					_this.loadingData = false;
					try {
						_this.json = prettyPrint.default(data.log.data);
					} catch (e) {
						_this.json = '<pre style="color: #FFFFFF">' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.log.data, undefined, 4) + '</pre>';
					}
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		changeLogStatus: function changeLogStatus() {
			var _this2 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to change this Log status to: " + (this.model.is_resolved ? 'Not Solved' : 'Solved') + "?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__logs_service__["a" /* default */].change_status(_this2.id, _this2.model.is_resolved ? false : true).then(function (data) {

						if (data[0] == 'success') {
							_this2.$swal({ type: data[0], title: data[0], text: data[1], onBeforeOpen: _this2.getLogData });
						} else {
							_this2.$swal(data[0], data[1], data[0]);
						}
					}).catch(function (error) {
						_this2.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		repostJsonData: function repostJsonData() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure you want to send the Data to service " + this.model.service + " with method " + this.model.method + "?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__logs_service__["a" /* default */].post_json_data(_this3.id, _this3.model.data, _this3.model.service, _this3.model.method).then(function (data) {

						if (data[0] == 'success') {
							_this3.$swal({ type: data[0], title: data[0], text: data[1], onBeforeOpen: _this3.getLogData });
						} else {
							_this3.$swal({ type: data[0], title: data[0], text: data[1], onBeforeOpen: _this3.getLogData });
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__terc_service__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trucking_companies_tc_service__ = __webpack_require__(40);






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TerminalCompanies',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',

      model: {
        terminal_company_name: ''
      },


      newEC: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Company Name',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newECModal: function newECModal() {
      this.model = {
        terminal_company_name: ''
      };
      this.savebtn = false;
      this.newEC = true;
    },
    trashEC: function trashEC() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/terminal_company/' + row.id + '/');
      } else {
        this.restoreEC(row.id);
      }
    },
    okToSave: function okToSave() {
      if (this.model.terminal_company_name === undefined || this.model.terminal_company_name.trim().length == 0) {
        this.$swal('Alert!', 'Terminal Company Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveEC: function saveEC() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var model = {
        company_name: this.model.terminal_company_name
      };

      __WEBPACK_IMPORTED_MODULE_1__terc_service__["a" /* default */].save(model).then(function (data) {
        _this.$swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this.newEC = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__terc_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.terminal_companies.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;

          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreEC: function restoreEC(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Terminal Company?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__terc_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.message == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_companies/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_company/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idCompany, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_company/update/' + idCompany + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_company/delete/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(EnergyCompanyId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_company/' + EnergyCompanyId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idCompany) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal_company/restore/' + idCompany + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__terc_service__ = __webpack_require__(571);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TerminalCompany',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',

			model: {
				terminal_company_name: '',

				trucking_companies: []
			},


			updateData: null,
			originalData: null,

			loadingData: true
		};
	},

	methods: {
		editEC: function editEC() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
				trucking_companies: []
			}, this.originalData, {
				terminal_company_name: this.originalData.company_name
			});
			this.model = model;
		},
		setupFields: function setupFields() {

			if (this.model.unload_locations.length > 0) {
				this.model.unload_locations_id = this.model.unload_locations.map(function (item) {
					return item.id;
				});
			}
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__terc_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.terminal_company;

					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();

					_this.subTitle = _this.originalData.company_name;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;

					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.terminal_company_name === undefined || this.model.terminal_company_name.trim().length == 0) {
				this.$swal('Alert!', 'Terminal Company Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateEC: function updateEC() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var model = {
				company_name: this.model.terminal_company_name
			};

			__WEBPACK_IMPORTED_MODULE_1__terc_service__["a" /* default */].update(this.companyId, model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteEC: function deleteEC(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Terminal Company: " + this.model.company_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__terc_service__["a" /* default */].delete(_this3.companyId).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/terminal_companies');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__term_service__ = __webpack_require__(574);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Terminal',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      model: {
        terminal_name: ''
      },
      newTerminal: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Terminal Name',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newTerminalModal: function newTerminalModal() {
      this.model = {
        terminal_name: ''
      };
      this.savebtn = false;
      this.newTerminal = true;
    },
    trashTerminal: function trashTerminal() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/terminal/' + row.id + '/');
      } else {
        this.restoreTerminal(row.id);
      }
    },
    okToSave: function okToSave() {
      if (this.model.terminal_name === undefined || this.model.terminal_name.trim().length == 0) {
        this.$swal('Alert!', 'Terminal Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveTerminal: function saveTerminal() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].save(this.model).then(function (data) {
        _this.$swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this.newTerminal = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.terminals.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreTerminal: function restoreTerminal(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Terminal ?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.message == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminals/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/terminal/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	petrotranz: function petrotranz(filter) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/petrotranz/business/', filter, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__term_service__ = __webpack_require__(574);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TerminalDetails',
	created: function created() {
		this.getTerminalData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				terminal_name: '',
				petrotranz: null,
				filter: '' },
			updateData: null,
			originalData: null,
			loadingData: true,
			terminalId: null,

			petrotranz: [],
			petrotranz_origin: [],
			ready: false,
			suggest: true,
			model1: {
				petrotranz_company_id: { id: null, name: '' }
			},
			size: 6,
			offset: ''
		};
	},

	methods: {
		editTerminal: function editTerminal() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		setupFields: function setupFields() {
			if (this.model.petrotranz !== null) {
				this.model1 = {
					petrotranz_company_id: this.model.petrotranz
				};
			} else {
				this.model1 = {
					petrotranz_company_id: { id: null, name: '' }
				};
			}
		},
		getTerminalData: function getTerminalData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.terminal;
					_this.terminalId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.petrotranz = data.petrotranz;
					_this.petrotranz_origin = data.petrotranz;
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.terminal_name;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.terminal_name === undefined || this.model.terminal_name.trim().length == 0) {
				this.$swal('Alert!', 'Terminal Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateTerminal: function updateTerminal() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			this.model.petrotranz = this.model1.petrotranz_company_id;
			console.log(this.model);
			__WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].update(this.terminalId, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.getTerminalData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTerminal: function deleteTerminal(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Terminal: " + this.model.terminal_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].delete(_this3.terminalId).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/terminals');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		select_petrotranz: function select_petrotranz() {
			this.size = 1;

			this.model.filter = this.model1.petrotranz_company_id.name;

			this.suggest = false;
		},
		filter_p: function filter_p(check_filter) {
			var _this4 = this;

			this.size = 6;
			if (this.model.filter !== '' && this.model.filter.length > 2) {
				var filter = { filter: this.model.filter };
				this.ready = true;
				__WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */];
				__WEBPACK_IMPORTED_MODULE_1__term_service__["a" /* default */].petrotranz(filter).then(function (data) {
					if (data.status == 'success') {
						if (_this4.model.filter == check_filter) {
							_this4.petrotranz = data.petrotranz;
						}
						_this4.ready = false;
					} else {
						_this4.$swal(data.status, data.message, data.status);
						_this4.ready = false;
						return;
					}
				}).catch(function (error) {
					_this4.$swal('Error', 'Server not response. ' + error, 'error');
					_this4.ready = false;
				});
				console.log('--api---');
			}
		},
		veo: function veo() {
			if (this.offset === "Delete") {
				this.petrotranz = [];
				this.filter_p(this.model.filter);
			}
		},
		keyMonitor: function keyMonitor(evt) {
			if (evt.key.match(/[a-zA-Z0-9,/,-]/i) === null) {
				evt.preventDefault();
				return;
			} else {
				evt = evt ? evt : window.event;
				var key = evt.key;
				this.offset = key;
				this.suggest = true;
				if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
					return;
				} else if (key == "Backspace") {
					this.petrotranz = [];
					var filter_txt = this.model.filter;
					var nn = filter_txt.length - 1;
					if (nn > 0) {
						this.model.filter = filter_txt.substring(0, nn);
						this.filter_p(this.model.filter);
						return;
					} else {
						this.model.filter = '';
						return;
					}
				} else if (key == "Delete") {
					return;
				} else {
					this.petrotranz = [];
					var _filter_txt = this.model.filter;
					_filter_txt = _filter_txt + key;
					this.model.filter = _filter_txt;
					this.filter_p(this.model.filter);
					return;
				}
			}
		}
	}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_service__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hauls_haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_highcharts_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    if (localStorage.getItem("role") == "trucking_company_admin" || localStorage.getItem("role") == "trucking_operational_manager") {
      this.getAlerts();
      this.dashboard();
    }
  },
  data: function data() {
    return {
      alerts: {},
      role: '',
      notification: [],
      newEC: false,
      fields: [{
        key: 'energy_company',
        label: 'Energy Company'
      }, {
        key: 'operating_area',
        label: 'Operating Area'
      }, {
        key: 'load_location',
        label: 'Load'
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'volume',
        label: 'Volume',
        sortable: false,
        formatter: function formatter(value) {
          return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        }
      }, {
        key: 'dispatch_date',
        label: 'Dispatch Date',
        sortable: false,
        formatter: function formatter(value) {
          return moment(value).format("MMM DD, YYYY");
        }
      }, { key: 'action',
        label: '    '
      }, { key: 'action1',
        label: '     '
      }],

      oa_filter: "All Operating Areas",
      ec_filter: "All Energy Companies",
      filter_by: {
        energy_company_id: "",
        trucking_company_id: "",
        initial_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("month").format("YYYY-MM-DD"),
        operating_area_id: "",
        users: [],
        load_locations: [],
        unload_locations: []
      },
      energy_companies_filter: [],
      operating_areas_filter: [],
      loadlocationselect: [],
      unloadlocationselect: [],
      indeterminateLL: false,
      llAllSelected: false,
      indeterminateUL: false,
      indeterminate: false,
      ulAllSelected: false,
      load_locations_id: [],
      unload_locations_id: [],
      users_select: [],
      users_id: [],
      indeterminate_user: false,
      user_AllSelected: false,
      chart_users: {
        'chart': { 'backgroundColor': '#37393F',
          'height': 600
        }
      },
      chart: {
        'chart': { 'backgroundColor': '#37393F',
          'height': 600
        }
      },
      chart_activated: false
    };
  },

  beforeCreate: function beforeCreate() {
    if (!localStorage.getItem("access_token")) {
      this.$router.replace("/login");
    }
    if (localStorage.getItem("role") == "trucking_company_admin" || localStorage.getItem("role") == "trucking_operational_manager") {
      this.$router.replace("/dash/");
    }
    if (localStorage.getItem("role") == "trucking_company_admin_light") {
      this.$router.replace("/users/");
    }
  },
  methods: {
    getAlerts: function getAlerts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__dashboard_service__["a" /* default */].getAlerts_tc().then(function (data) {
        if (data.status == "success") {
          _this.alerts = data.alerts;
          _this.role = data.role;
          _this.notification = data.notification;
          if (_this.notification.length != 0) {
            _this.newEC = true;
          }
        }
      }).catch(function (error) {
        _this.$swal("Error", "Server not response. " + error, "error");
      });
    },
    alert_filter: function alert_filter(flag, flag_id) {
      localStorage.setItem("dashboard", "dash09");
      localStorage.setItem("dashboard_flag_name", flag);
      localStorage.setItem("dashboard_flag_id", flag_id);
      var currentUrl = "http://" + window.location.host + "/#/hauls";
      window.location.href = currentUrl;
      return;
    },
    adjust: function adjust(item, index) {
      var _this2 = this;

      var accepted = { 'status_id': 5 };
      __WEBPACK_IMPORTED_MODULE_1__hauls_haul_service__["a" /* default */].update_request(accepted, item['haul_id']).then(function (data) {
        if (data.status == 'success') {
          _this2.notification.splice(index, 1);
        } else {
          console.log('bad');
        }
      });
    },
    ignore: function ignore(item, index) {
      this.notification.splice(index, 1);
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    iFilter: function iFilter() {
      if (this.filter_by["end_date"] == "" || !this.filter_by["end_date"]) {
        this.filter_by["end_date"] = "";
      }
      this.getDashboard();
      this.getAlerts();
      this.getAvgDailyDistance();
      this.getWaitTimeChart();

      this.getAvgMinuteLoadChart();
      this.getFluidByLoadChart();
      this.getFluidByUnloadChart();
      this.getTargetList();
      this.loadingData = true;
    },
    eFilter: function eFilter() {
      if (this.filter_by["initial_date"] == "" || !this.filter_by["initial_date"]) {
        this.filter_by["initial_date"] = "";
      }
    },
    clearFilters: function clearFilters() {
      this.ec_filter = "All Energy Companies";
      this.filter_by = {
        energy_company_id: "",
        trucking_company_id: "",
        initial_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("month").format("YYYY-MM-DD"),
        operating_area_id: ""
      };
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.ec_filter = ec_filter;
      this.filter_by["energy_company_id"] = id;
      this.oa_filter = "All Operating Areas";
      if (id !== 0) {
        var pos = this.energy_companies_filter.map(function (o) {
          return o.id;
        }).indexOf(this.filter_by["energy_company_id"]);
        if (pos > -1) {
          this.operating_areas_filter = this.energy_companies_filter[pos].operating_areas;
          this.filter_by["operating_area_id"] = '';
          this.location_list();
          this.load_locations_id = [];
          this.unload_locations_id = [];
          this.users_id = [];
          this.user_Change();
        } else {
          this.operating_areas_filter = [];
          this.loadlocationselect = [];
          this.unloadlocationselect = [];
          this.filter_by["operating_area_id"] = '';
          this.load_locations_id = [];
          this.unload_locations_id = [];
          this.users_id = [];
          this.user_Change();
        }
      } else {
        this.filter_by['energy_company_id'] = '';
        this.filter_by["operating_area_id"] = '';
        this.ec_list();
        this.location_list();
        this.load_locations_id = [];
        this.unload_locations_id = [];
        this.users_id = [];
        this.user_Change();
      }
    },
    oaFilter: function oaFilter(oa_filter, id) {
      this.oa_filter = oa_filter;
      this.filter_by["operating_area_id"] = id;
      if (id == 0) {
        this.filter_by["operating_area_id"] = "";
      }
      this.location_list();
    },
    dashboard: function dashboard() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__dashboard_service__["a" /* default */].dashboard_tc().then(function (data) {
        if (data.status == "success") {
          _this3.users_select = data.trucking_company_filter[0].drivers;
          _this3.energy_companies_filter = data.trucking_company_filter[0].energy_companies;
          _this3.filter_by['trucking_company_id'] = data.trucking_company_filter[0].id;
          _this3.ec_list();
          _this3.location_list();
        } else {
          _this3.$swal(data.status, data.message, data.status);
          return;
        }
      }).catch(function (error) {
        _this3.$swal("Error", "Server not response. " + error, "error");
      });
    },
    location_list: function location_list() {
      this.loadlocationselect = [];
      this.unloadlocationselect = [];
      var location = this.operating_areas_filter;
      if (this.filter_by["operating_area_id"] === "") {
        var new_unloadlocations = [];
        var new_loadlocations = [];
        location.map(function (item) {
          item.loads.forEach(function (element) {
            var index2 = new_loadlocations.map(function (o) {
              return o.id;
            }).indexOf(element.id);
            if (index2 < 0) {
              new_loadlocations.push(element);
            }
          });
          item.unloads.forEach(function (element) {
            var index1 = new_unloadlocations.map(function (o) {
              return o.id;
            }).indexOf(element.id);
            if (index1 < 0) {
              new_unloadlocations.push(element);
            }
          });
        });
        if (new_unloadlocations.length > 0) {
          var mapped = new_unloadlocations.map(function (el, i) {
            return { index: i, value: el.legal_location.toLowerCase() };
          });
          mapped.sort(function (a, b) {
            if (a.value > b.value) {
              return 1;
            }
            if (a.value < b.value) {
              return -1;
            }
            return 0;
          });
          this.unloadlocationselect = mapped.map(function (el) {
            return new_unloadlocations[el.index];
          });
        }
        if (new_loadlocations.length > 0) {
          var mapped1 = new_loadlocations.map(function (el, i) {
            return { index: i, value: el.legal_location.toLowerCase() };
          });
          mapped1.sort(function (a, b) {
            if (a.value > b.value) {
              return 1;
            }
            if (a.value < b.value) {
              return -1;
            }
            return 0;
          });
          this.loadlocationselect = mapped1.map(function (el) {
            return new_loadlocations[el.index];
          });
        }
      } else {
        var index = location.map(function (o) {
          return o.id;
        }).indexOf(this.filter_by["operating_area_id"]);
        if (index > -1) {
          this.loadlocationselect = location[index].loads;
          this.unloadlocationselect = location[index].unloads;
        }
      }
    },
    LLToggleAll: function LLToggleAll(checked) {
      this.load_locations_id = checked ? this.loadlocationselect.map(function (item) {
        return item.id;
      }) : [];
    },
    ULToggleAll: function ULToggleAll(checked) {
      this.unload_locations_id = checked ? this.unloadlocationselect.map(function (item) {
        return item.id;
      }) : [];
    },
    user_ToggleAll: function user_ToggleAll(checked) {
      this.users_id = checked ? this.users_select.map(function (item) {
        return item.id;
      }) : [];
    },
    loadLocationsChange: function loadLocationsChange() {
      if (this.load_locations_id.length === 0) {
        this.indeterminateLL = false;
        this.llAllSelected = false;
      } else if (this.load_locations_id.length === this.loadlocationselect.length) {
        this.indeterminateLL = false;
        this.llAllSelected = true;
      } else {
        this.indeterminateLL = true;
        this.llAllSelected = false;
      }
    },
    unloadLocationsChange: function unloadLocationsChange() {
      if (this.unload_locations_id.length === 0) {
        this.indeterminateUL = false;
        this.ulAllSelected = false;
      } else if (this.unload_locations_id.length === this.unloadlocationselect.length) {
        this.indeterminateUL = false;
        this.ulAllSelected = true;
      } else {
        this.indeterminateUL = true;
        this.ulAllSelected = false;
      }
    },
    user_Change: function user_Change() {
      if (this.users_id.length === 0) {
        this.indeterminate_user = false;
        this.user_AllSelected = false;
      } else if (this.users_id.length === this.users_select.length) {
        this.indeterminate_user = false;
        this.user_AllSelected = true;
      } else {
        this.indeterminate_user = true;
        this.user_AllSelected = false;
      }
    },
    generate_chart_click: function generate_chart_click() {
      this.get_volume_by_date_chart();
      this.get_volume_by_date_user_chart();
    },
    get_volume_by_date_chart: function get_volume_by_date_chart() {
      var _this4 = this;

      this.filter_by['load_locations'] = this.load_locations_id;
      this.filter_by['unload_locations'] = this.unload_locations_id;
      __WEBPACK_IMPORTED_MODULE_0__dashboard_service__["a" /* default */].get_volume_by_date(this.filter_by).then(function (data) {
        if (data.status == "success") {
          _this4.chart = data.volume_by_date_chart;
        } else {
          _this4.$swal(data.status, data.message, data.status);
          return;
        }
      }).catch(function (error) {
        _this4.$swal("Error", "Server not response. " + error, "error");
      });
    },
    get_volume_by_date_user_chart: function get_volume_by_date_user_chart() {
      var _this5 = this;

      this.filter_by['load_locations'] = this.load_locations_id;
      this.filter_by['unload_locations'] = this.unload_locations_id;
      this.filter_by['users'] = this.users_id;
      __WEBPACK_IMPORTED_MODULE_0__dashboard_service__["a" /* default */].get_volume_user(this.filter_by).then(function (data) {
        if (data.status == "success") {
          _this5.chart_users = data.volume_by_date_user_chart;
        }
      }).catch(function (error) {
        _this5.$swal("Error", "Server not response. " + error, "error");
        _this5.loadingData = false;
      });
    },
    ec_list: function ec_list() {
      var _this6 = this;

      this.operating_areas_filter = [];
      var energy_companies = this.energy_companies_filter;
      if (this.filter_by["energy_company_id"] === "") {
        energy_companies.map(function (item) {
          item.operating_areas.forEach(function (element) {
            _this6.operating_areas_filter.push(element);
          });
        });
      } else {
        var index = energy_companies.map(function (o) {
          return o.id;
        }).indexOf(this.filter_by["energy_company_id"]);
        if (index > -1) {
          this.operating_areas_filter = energy_companies[index].operating_areas;
        }
      }
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pwbi_service__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);








var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PowerBis',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      model: {
        company_type_id: 0,
        company_id: null,
        company_name: '',
        report_name: '',
        activate_pb: true,
        url: '',
        pdf: ''
      },
      newTerminal: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'company_type',
        label: 'Company Type',
        sortable: true
      }, {
        key: 'company_name',
        label: 'Company Name',
        sortable: true
      }, {
        key: 'report_name',
        label: 'Report Name',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true,
      company_type: [],
      company_name: [],
      energies_companies: [],
      role: '',
      file: '',
      next: '',
      url: '',
      load_pdf: 'Saving PDF file.....',
      uploadPercentage: 0,
      progress: false
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.model.pdf = this.file['name'];
      var url = window.URL.createObjectURL(this.file);
      this.url = url;
      setTimeout(function () {
        return window.URL.revokeObjectURL(url);
      }, 100);
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newTerminalModal: function newTerminalModal() {
      this.model.company_type_id = 0;
      this.model.company_id = null;
      this.model.company_name = '';
      this.model.activate_pb = true;
      this.model.url = '';
      this.model.pdf = '';
      this.model.report_name = '';
      this.url = '';
      this.company_name = this.energies_companies;
      this.savebtn = false;
      this.newTerminal = true;
      this.progress = false;
    },
    trashTerminal: function trashTerminal() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/powerbi/' + row.id + '/');
      } else {
        this.restoreTerminal(row.id);
      }
    },
    okToSave: function okToSave() {
      if (this.model.company_id === undefined || this.model.company_id == null) {
        this.$swal('Alert!', 'Select Company', 'warning');
        return false;
      } else if (this.model.company_name === undefined || this.model.company_name === '') {
        this.$swal('Alert!', 'Select Company', 'warning');
        return false;
      } else if (this.model.report_name === '' || this.model.report_name === null) {
        this.$swal('Alert!', 'Please, Enter Report Name', 'warning');
        return false;
      }

      if (this.model.activate_pb) {
        if (this.model.url === '') {
          this.$swal('Alert!', 'Please, Enter Url', 'warning');
          return false;
        }
      } else {
        if (this.model.pdf === '') {
          this.$swal('Alert!', 'Please, Enter Pdf file', 'warning');
          return false;
        }
      }
      return true;
    },
    saveReport: function saveReport() {
      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model);
      var blob = new Blob([json], {
        type: 'application/json'
      });
      var formData = new FormData();
      formData.append("document", blob);
      formData.append('file', this.file);
      this.uploadPercentage = 0;
      if (!this.model.activate_pb) {
        this.progress = true;
      }
      this.load_pdf = 'Saving PDF file.....';
      this.save_pdf(formData);

      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_2__pwbi_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          if (data.powerbi.length > 0) {
            _this.items = data.powerbi.filter(function (o) {
              return o.status_id == (_this.trash ? 2 : 1);
            });
          }
          _this.company_type = data.insert_data.pwbi;
          _this.energies_companies = data.insert_data.pwbi[0].energy_companies;
          _this.role = data.role;
          _this.loadingData = false;
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    select_company_type: function select_company_type() {
      if (this.role == 'super_admin') {
        if (this.model.company_type_id === 0) {
          this.company_name = this.company_type[0].energy_companies;
          this.model.company_id = null;
        } else {
          this.company_name = this.company_type[1].trucking_companies;
          this.model.company_id = null;
        }
      }
    },
    select_company: function select_company() {
      if (this.role == 'super_admin') {
        var companies = this.company_name;
        var company_index = companies.map(function (o) {
          return o.id;
        }).indexOf(this.model.company_id);
        if (company_index > -1) {
          this.model.company_name = companies[company_index].name;
        } else {
          this.model.company_name = '';
        }
      }
    },
    restoreTerminal: function restoreTerminal(id) {
      var _this2 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Power bi ?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__pwbi_service__["a" /* default */].restore(id).then(function (data) {
            _this2.$swal(data.status, data.message, data.status);
            if (data.message == 'success') {
              _this2.filter = '';
              _this2.trash = false;
              _this2.getAll();
              _this2.loadingData = true;
            }
          }).catch(function (error) {
            _this2.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    save_pdf: function save_pdf(formData) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* apiDomain */] + '/report/create/', formData, { headers: {
          'Content-Type': 'multipart/form-data',
          'token': localStorage.getItem('access_token')
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          _this3.uploadPercentage = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == 'success') {
          _this3.load_pdf = 'PDF file saved';
          _this3.$swal(data.status, data.message, data.status);
          _this3.newTerminal = false;
          _this3.getAll();
        } else {
          _this3.load_pdf = 'Saving PDF file.....', _this3.uploadPercentage = 0, _this3.progress = false;
          _this3.model.pdf = '';
          _this3.url = '';
          _this3.file = '';
          _this3.$swal(data.status, data.message, data.status);
        }
      }).catch(function (error) {
        _this3.load_pdf = 'Saving PDF file.....', _this3.uploadPercentage = 0, _this3.progress = false;
        _this3.$swal('Error', 'Server not response. ' + error, 'error');
      });
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pwbi_detail_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9569212e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pwbi_detail_vue__ = __webpack_require__(1206);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pwbi_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9569212e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pwbi_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pwbi_service__ = __webpack_require__(155);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PowerBi',
	created: function created() {
		this.getTerminalData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				id: null,
				company_type_id: null,
				company_type: '',
				company_id: null,
				company_name: '',
				report_name: '',
				activate_pb: true,
				url: '',
				pdf: ''
			},
			updateData: null,
			originalData: null,
			loadingData: true,
			terminalId: null,
			company_type: [],
			company_name: [],
			role: '',
			file: '',
			change: false,
			url: '',
			pdf_file: '',
			url_save: ''

		};
	},

	methods: {
		toggle: function toggle(checked) {
			if (!checked) {
				this.url_save = this.model.url;
				this.model.url = '';
			} else {
				this.model.url = this.url_save;
			}
		},
		handleFileUpload: function handleFileUpload() {
			var _this = this;

			if (!this.model.activate_pb) {
				this.file = this.$refs.file.files[0];
				this.model.pdf = this.file['name'];
				this.url = window.URL.createObjectURL(this.file);
				setTimeout(function () {
					return window.URL.revokeObjectURL(_this.url);
				}, 100);
				this.model.url = this.url;
			}
		},
		editTerminal: function editTerminal() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
			this.change = false;
			if (!this.model.activate_pb) {
				this.model.url = '';
			}
		},
		setupFields: function setupFields() {
			if (this.role == 'super_admin') {
				if (this.model.company_type_id === 0) {
					this.company_name = this.company_type[0].energy_companies;
				} else {
					this.company_name = this.company_type[1].trucking_companies;
				}
				this.change = false;
			}
		},
		getTerminalData: function getTerminalData() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__pwbi_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this2.originalData = data.powerbi;
					_this2.terminalId = _this2.id;
					_this2.loadingData = false;
					_this2.found = true;
					var pdf_file = data.pdf_file;
					console.log();
					if (pdf_file !== '') {
						var url = window.URL.createObjectURL(_this2.base64ToBlob(pdf_file));
						_this2.url = url;
						setTimeout(function () {
							return window.URL.revokeObjectURL(url);
						}, 100);
					}
					_this2.restoreOriginalData();
					_this2.subTitle = _this2.originalData.report_name;
					_this2.company_type = data.update_data.pwbi;
					_this2.role = data.role;
				} else {
					_this2.$swal(data.status, data.message, data.status);
					_this2.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
				_this2.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.company_id === undefined || this.model.company_id == null) {
				this.$swal('Alert!', 'Select Company', 'warning');
				return false;
			} else if (this.model.company_name === undefined || this.model.company_name === '') {
				this.$swal('Alert!', 'Select Company', 'warning');
				return false;
			} else if (this.model.report_name === '' || this.model.report_name === null) {
				this.$swal('Alert!', 'Please, Enter Report Name', 'warning');
				return false;
			}

			if (this.model.activate_pb) {
				if (this.model.url === '') {
					this.$swal('Alert!', 'Please, Enter Url', 'warning');
					return false;
				}
			} else {
				if (this.model.pdf === '') {
					this.$swal('Alert!', 'Please, Enter Pdf file', 'warning');
					return false;
				}
			}
			return true;
		},
		updateTerminal: function updateTerminal() {
			var _this3 = this;

			if (!this.okToUpdate()) {
				return;
			}
			var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model);
			var blob = new Blob([json], {
				type: 'application/json'
			});
			var formData = new FormData();
			formData.append("document", blob);
			formData.append('file', this.file);
			__WEBPACK_IMPORTED_MODULE_2__pwbi_service__["a" /* default */].update(this.terminalId, formData).then(function (data) {
				_this3.$swal(data[0], data[1], data[0]).then(function (result) {
					_this3.getTerminalData();
				});
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTerminal: function deleteTerminal(item) {
			var _this4 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Power Bi for " + this.model.company_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__pwbi_service__["a" /* default */].delete(_this4.terminalId).then(function (data) {
						_this4.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this4.$router.replace('/powerbi');
						}
					}).catch(function (error) {
						_this4.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		select_company_type: function select_company_type() {
			if (this.role == 'super_admin') {
				if (this.model.company_type_id === 0) {
					this.company_name = this.company_type[0].energy_companies;
					this.model.company_id = null;
				} else {
					this.company_name = this.company_type[1].trucking_companies;
					this.model.company_id = null;
				}
			}
		},
		select_company: function select_company() {
			if (this.role == 'super_admin') {
				var companies = this.company_name;
				var company_index = companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.company_id);
				if (company_index > -1) {
					this.model.company_name = companies[company_index].name;
				} else {
					this.model.company_name = '';
				}
			}
		},
		base64ToBlob: function base64ToBlob(base64) {
			var binaryString = window.atob(base64);
			var len = binaryString.length;
			var bytes = new Uint8Array(len);
			for (var i = 0; i < len; ++i) {
				bytes[i] = binaryString.charCodeAt(i);
			}

			return new Blob([bytes], { type: 'application/pdf' });
		},
		change_file: function change_file() {
			if (!this.model.activate_pb) {
				this.change = true;
				this.model.url = '';
			}
		},
		blobToFile: function blobToFile(theBlob, fileName) {
			return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type });
		}
	}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pwbi_service__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pwbi_detail__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'OtherReport',
    created: function created() {
        this.getAll();
    },
    data: function data() {
        return {
            found: false,
            notFoundMessage: 'Not found',
            model: {
                id: null,
                company_type_id: null,
                company_type: '',
                company_id: null,
                company_name: '',
                report: []
            },
            loadingData: true,
            company_type: [],
            company_name: [],
            role: '',
            url_index: 0,
            view: false,
            report_id: null,
            url: '',
            no_report: 'No report',
            load_pdf: 'Loading PDF file.....',
            uploadPercentage: 0,
            progress: false
        };
    },

    methods: {
        getAll: function getAll() {
            var _this = this;

            this.loadingData = true;
            __WEBPACK_IMPORTED_MODULE_0__pwbi_service__["a" /* default */].get_company().then(function (data) {
                if (data.status == 'success') {
                    _this.role = data.role;
                    _this.company_type = data.insert_data.pwbi;
                    _this.loadingData = false;
                    _this.found = true;
                    if (_this.role === 'super_admin') {
                        _this.company_name = data.insert_data.pwbi[0].energy_companies;
                        _this.model.company_type_id = 0;
                    } else if (_this.role === 'trucking_company_admin' || _this.role === 'trucking_operational_manager') {
                        _this.company_name = data.insert_data.pwbi[0].trucking_companies;
                        _this.model.company_type_id = 1;
                        _this.company_type = 'Trucking Company';
                        _this.model.company_id = data.insert_data.pwbi[0].trucking_companies[0].id;
                        _this.model.company_name = data.insert_data.pwbi[0].trucking_companies[0].name;
                        _this.powerbi();
                    } else if (_this.role === 'super_analyst' || _this.role === 'analyst' || _this.role === 'operations_manager' || _this.role == 'marketing_accountant') {
                        _this.company_name = data.insert_data.pwbi[0].energy_companies;
                        _this.model.company_type_id = 0;
                        _this.company_type = 'Energy Company';
                        _this.model.company_id = data.insert_data.pwbi[0].energy_companies[0].id;
                        _this.model.company_name = data.insert_data.pwbi[0].energy_companies[0].name;
                        _this.powerbi();
                    }
                } else {
                    _this.$swal(data.status, data.message, data.status);
                    _this.loadingData = false;
                    return;
                }
            }).catch(function (error) {
                Vue.swal('Error', 'Server not response. ' + error, 'error');
                _this.loadingData = false;
            });
        },
        select_company_type: function select_company_type() {
            if (this.role == 'super_admin') {
                this.progress = false;
                if (this.model.company_type_id === 0) {
                    this.company_name = this.company_type[0].energy_companies;
                    this.model.company_id = null;
                    this.view = false;
                    this.model.report = [];
                    this.url = '';
                } else {
                    this.company_name = this.company_type[1].trucking_companies;
                    this.model.company_id = null;
                    this.view = false;
                    this.model.report = [];
                    this.url = '';
                }
            }
        },
        select_company: function select_company() {
            if (this.role == 'super_admin') {
                this.progress = false;
                var companies = this.company_name;
                var company_index = companies.map(function (o) {
                    return o.id;
                }).indexOf(this.model.company_id);
                if (company_index > -1) {
                    this.model.company_name = companies[company_index].name;
                    this.view = false;
                    this.model.report = [];
                    this.url = '';
                    this.powerbi();
                    this.report_id = null;
                } else {
                    this.model.company_name = '';
                }
            }
        },
        select_report: function select_report() {
            if (this.role == 'super_admin' || this.role == 'super_analyst' || this.role == 'analyst' || this.role == 'operations_manager' || this.role == 'marketing_accountant' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
                var reports = this.model.report;
                var report_index = reports.map(function (o) {
                    return o.id;
                }).indexOf(this.report_id);
                if (report_index > -1) {
                    if (reports[report_index].activate_pb) {
                        this.url = reports[report_index].url;
                        this.progress = false;
                    } else {
                        this.uploadPercentage = 0;
                        this.progress = true;
                        this.load_pdf = 'Loading PDF file.....';
                        this.url = '';
                        this.get_pdf1(reports[report_index].report_name, reports[report_index].url);
                    }
                } else {
                    this.url = '';
                }
            }
        },
        powerbi: function powerbi() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__pwbi_service__["a" /* default */].find(this.model).then(function (data) {
                if (data.status == 'success') {
                    _this2.model.report = data.report;
                    if (_this2.model.report.length === 0) {
                        _this2.view = true;
                        _this2.no_report = 'No report in ' + _this2.model.company_name + ' Company';
                    }
                } else {
                    _this2.$swal(data.status, data.message, data.status);
                    return;
                }
            }).catch(function (error) {
                Vue.swal('Error', 'Server not response. ' + error, 'error');
            });
        },
        base64ToBlob: function base64ToBlob(base64) {
            var binaryString = window.atob(base64);
            var len = binaryString.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; ++i) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return new Blob([bytes], { type: 'application/pdf' });
        },
        get_pdf1: function get_pdf1(report_name, pdf) {
            var _this3 = this;

            var model = {
                'company_type_id': this.model.company_type_id,
                'company_id': this.model.company_id,
                'report_name': report_name,
                'pdf': pdf
            };

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiDomain */] + '/report/pdf/', model, { headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('access_token')
                },
                onUploadProgress: function onUploadProgress(progressEvent) {
                    _this3.uploadPercentage = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
                }
            }).then(function (response) {
                var data = response.data;
                if (data.status == 'success') {
                    var pdf_file = data.pdf;
                    if (pdf_file !== '') {
                        var url = window.URL.createObjectURL(_this3.base64ToBlob(pdf_file));
                        _this3.url = url;
                        setTimeout(function () {
                            return window.URL.revokeObjectURL(url);
                        }, 100);
                    } else {
                        _this3.url = '';
                    }
                    if (_this3.uploadPercentage > 99) {
                        _this3.load_pdf = 'PDF file loaded';
                    }
                } else {
                    _this3.progress = false;
                    _this3.$swal(data.status, data.message, data.status);
                    return;
                }
            }).catch(function (error) {
                _this3.progress = false;
                Vue.swal('Error', 'Server not response. ' + error, 'error');
            });
        }
    }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rowDetails__ = __webpack_require__(151);











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DuplicatedHauls',
  components: {
    'row-details': __WEBPACK_IMPORTED_MODULE_7__rowDetails__["a" /* default */]
  },
  created: function created() {
    this.getAll();
  },
  data: function data() {
    var _this = this;

    return {
      allSelected: false,
      tableValues: [],
      status: 'unchecked',
      haul_ids: [],
      haul_iidds: [],
      haul_iiddss: [],
      selected: '',
      row: 0,
      loadingData: true,
      companyName: '',
      companyId: null,
      configTable: false,

      items: items,
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'haul_id',
        label: 'ID',
        sortable: false
      }, {
        key: 'ticket',
        label: 'Ticket #',
        sortable: false
      }, {
        key: 'load_location',
        label: 'Load'
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'volume_actual',
        label: 'Deliveries',
        sortable: false,
        formatter: function formatter(value) {
          if (_this.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'oil_actual',
        label: 'Oil',
        sortable: false,
        formatter: function formatter(value) {
          if (_this.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'water_actual',
        label: 'Water',
        sortable: false,
        formatter: function formatter(value) {
          if (_this.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }

      }, {
        key: 'bsw',
        label: 'BS&W (%)',
        sortable: false
      }, {
        key: 'haul_start_date',
        label: 'Start Date',
        sortable: false,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
        }
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['haul_id', 'ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date'],
      role: '',
      savebtn: true,
      energy_company_id: null,
      unit: '',
      fromHaul: 0,
      bbll: false,
      myToggle: false,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column": ['haul_id', 'truck_ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date'] },
      energy_companies_filter: '',

      load_locations_filter: '',
      unload_locations_filter: '',
      drivers_filter: '',
      trucks_filter: '',
      trucking_companies_filter: '',

      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',

        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: ''
      }
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    selectAllHauls: function selectAllHauls() {
      if (!this.allSelected) {
        this.toggleAllSelected();
      }
    },
    unselectAllHauls: function unselectAllHauls() {
      if (this.haul_ids.length > 0) {
        this.haul_ids = [];

        var tmp1 = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp = this.haul_ids;
        var tmp2 = this.array_diff(tmp, tmp1);
        this.haul_ids = tmp2;
      }
    },
    toggleAllSelected: function toggleAllSelected() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        var tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp1 = this.haul_ids;
        tmp1.push.apply(tmp1, tmp);
        this.haul_ids = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(tmp1)));
      } else {
        var _tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var _tmp2 = this.haul_ids;
        var tmp2 = this.array_diff(_tmp2, _tmp);
        this.haul_ids = tmp2;
      }
    },
    array_diff: function array_diff(tmp, tmp1) {
      return tmp.filter(function (elemento) {
        return tmp1.indexOf(elemento) == -1;
      });
    },
    checkedField: function checkedField(row) {
      if (this.haul_ids.includes(row.item.haul_id)) {
        var index = this.haul_ids.indexOf(row.item.haul_id);
        if (index > -1) {
          this.haul_ids.splice(index, 1);
        }
      } else {
        this.haul_ids.push(row.item.haul_id);
      }
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.configTable = false;
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this2 = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'haul_start_date' || option == 'haul_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'oil_actual' || option == 'volume_actual' || option == 'water_actual') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                if (_this2.bbll == true) {
                  value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                } else {
                  value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                };return value;
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this3 = this;

      this.items = [];

      __WEBPACK_IMPORTED_MODULE_4__haul_service__["a" /* default */].get_duplicated_hauls(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this3.items = data.hauls.filter(function (o) {
            return o.status_id == (_this3.trash ? 2 : 1);
          });
          _this3.itemsAll = _this3.items;

          _this3.getAll1();
        } else {
          _this3.$swal(data.status, data.message, data.status);
          _this3.loadingData = false;
          return;
        }
        _this3.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this3.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {

          _this4.energy_companies_filter = data.energy_companies_filter;

          _this4.drivers_filter = data.drivers_filter;
          _this4.load_locations_filter = data.load_locations_filter;
          _this4.unload_locations_filter = data.unload_locations_filter;
          _this4.trucks_filter = data.trucks_filter;

          _this4.trucking_companies_filter = data.trucking_companies_filter;


          _this4.bbll = data.bbl;
          _this4.role = data.role;
        } else {

          _this4.$swal(data.status, data.message, data.status);
          _this4.loadingData = false;
          return;
        }
        _this4.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this4.loadingData = false;
      });
    },
    reformat: function reformat(value) {
      if (value.indexOf('%') != -1) {
        return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
      } else if (value.indexOf('km') != -1) {
        return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km";
      } else {
        return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    dFilter: function dFilter(d_filter, id) {
      this.filter_by['users_id'] = id;
      if (id == 0) {
        this.filter_by['users_id'] = '';
      }
      this.filters_save.driver_name = d_filter;
      this.filters_save.users_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();

      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.filter_by['truck_id'] = id;
      if (id == 0) {
        this.filter_by['truck_id'] = '';
      }
      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "truck_id": "",
        "trucking_company_id": "",
        "users_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "column": ['haul_id', 'truck_ticket', 'load_location', 'unload_location', 'volume_actual', 'oil_actual', 'water_actual', 'bsw', 'haul_start_date'] };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        trucking_company_id: 0,
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags'
      };

      this.getAll();

      this.loadingData = true;
    },
    rowClicked: function rowClicked(row, index, e) {
      e.preventDefault();
      localStorage.haulPage = this.currentPage;
      if (!this.trash) {
        this.selected_haul_detail = row.haul_id;
        this.$root.$emit('openPopup', row.haul_id);
      } else {
        this.restoreHaul(row.haul_id);
      }
    }
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_users_service__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rowDetails__ = __webpack_require__(151);











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DiscrepancyReport',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      allSelected: false,
      tableValues: [],
      status: 'unchecked',
      haul_ids: [],
      haul_iidds: [],
      haul_iiddss: [],
      selected: '',
      row: 0,
      loadingData: true,
      companyName: '',
      companyId: null,
      configTable: false,

      items: items,
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'haul_id',
        label: 'ID',
        sortable: false
      }, {
        key: 'energy_company',
        label: 'Energy Company'
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'ticket',
        label: 'Ticket #',
        sortable: false
      }, {
        key: 'load_location',
        label: 'Load',
        sortable: false
      }, {
        key: 'volume_actual',
        label: 'Total Volume',
        sortable: true
      }, {
        key: 'bsw',
        label: 'BS&W (%)',
        sortable: false
      }, {
        key: 'oil_actual',
        label: 'Oil',
        sortable: false
      }, {
        key: 'drivers_filter',
        label: '            '
      }, {
        key: 'energy_company_unload',
        label: 'Energy Company'
      }, {
        key: 'unload_location_unload',
        label: 'Unload',
        sortable: false
      }, {
        key: 'volume_actual_unload',
        label: 'Total Volume at Unload',
        sortable: true
      }, {
        key: 'bsw_unload',
        label: 'BS&W at Unload',
        sortable: false
      }, {
        key: 'oil_unload',
        label: 'Oil at Unload',
        sortable: false
      }, { key: 'action', label: 'Action' }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['haul_id', 'energy_company', 'unload_location', 'ticket', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'energy_company_ul', 'unload_location_ul', 'volume_actual_ul', 'bsw_ul', 'oil_ul', 'water_ul'],
      role: '',
      savebtn: true,
      energy_company_id: null,
      unit: '',
      fromHaul: 0,
      bbll: false,
      myToggle: false,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column": [] },
      energy_companies_filter: '',

      load_locations_filter: '',
      unload_locations_filter: '',
      drivers_filter: '            ',
      trucks_filter: '',
      trucking_companies_filter: '',

      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',

        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: ''
      },

      filename: 'hauls_discrenpacy_' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "haul_id": "haul_id",
        "energy_company": "energy_company",
        "trucking_company": "trucking_company",
        "ticket": "ticket",
        "unload_location": "unload_location",
        "load_location": "load_location",
        "volume_actual": "volume_actual",
        "bsw": "bsw",
        "oil_actual": "oil_actual",
        "energy_company_unload": "energy_company_unload",
        "unload_location_unload": "unload_location_unload",
        "volume_actual_unload": "volume_actual_unload",
        "bsw_unload": "bsw_unload",
        "oil_unload": "oil_unload"
      },
      items_csv: []
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    selectAllHauls: function selectAllHauls() {
      if (!this.allSelected) {
        this.toggleAllSelected();
      }
    },
    unselectAllHauls: function unselectAllHauls() {
      if (this.haul_ids.length > 0) {
        this.haul_ids = [];

        var tmp1 = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp = this.haul_ids;
        var tmp2 = this.array_diff(tmp, tmp1);
        this.haul_ids = tmp2;
      }
    },
    toggleAllSelected: function toggleAllSelected() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        var tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp1 = this.haul_ids;
        tmp1.push.apply(tmp1, tmp);
        this.haul_ids = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(tmp1)));
      } else {
        var _tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var _tmp2 = this.haul_ids;
        var tmp2 = this.array_diff(_tmp2, _tmp);
        this.haul_ids = tmp2;
      }
    },
    array_diff: function array_diff(tmp, tmp1) {
      return tmp.filter(function (elemento) {
        return tmp1.indexOf(elemento) == -1;
      });
    },
    checkedField: function checkedField(row) {
      if (this.haul_ids.includes(row.item.haul_id)) {
        var index = this.haul_ids.indexOf(row.item.haul_id);
        if (index > -1) {
          this.haul_ids.splice(index, 1);
        }
      } else {
        this.haul_ids.push(row.item.haul_id);
      }
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.configTable = false;
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'haul_start_date' || option == 'haul_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'oil_actual' || option == 'volume_actual' || option == 'water_actual') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                if (_this.bbll == true) {
                  value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                } else {
                  value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                };return value;
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.items = [];

      __WEBPACK_IMPORTED_MODULE_4__haul_service__["a" /* default */].get_discrepancy_report(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.hauls;
          _this2.items_csv = _this2.items;

          _this2.getAll1();
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {

          _this3.energy_companies_filter = data.energy_companies_filter;

          _this3.drivers_filter = data.drivers_filter;
          _this3.load_locations_filter = data.load_locations_filter;
          _this3.unload_locations_filter = data.unload_locations_filter;
          _this3.trucks_filter = data.trucks_filter;

          _this3.trucking_companies_filter = data.trucking_companies_filter;


          _this3.bbll = data.bbl;
          _this3.role = data.role;
          if (_this3.role == 'operations_manager') {
            _this3.fields = [{
              key: 'haul_id',
              label: 'Id',
              sortable: false
            }, {
              key: 'unload_location',
              label: 'Unload',
              sortable: false
            }, {
              key: 'ticket',
              label: 'Ticket #',
              sortable: false
            }, {
              key: 'load_location',
              label: 'Load',
              sortable: false
            }, {
              key: 'volume_actual',
              label: 'Total Volume',
              sortable: true
            }, {
              key: 'bsw',
              label: 'BS&W (%)',
              sortable: false
            }, {
              key: 'oil_actual',
              label: 'Oil',
              sortable: false
            }, {
              key: 'drivers_filter',
              label: '            '
            }, { key: 'unload_location_unload', label: 'Unload', sortable: false
            }, { key: 'volume_actual_unload', label: 'Total Volume at Unload', sortable: true
            }, { key: 'bsw_unload', label: 'BS&W at Unload', sortable: false
            }, { key: 'oil_unload', label: 'Oil at Unload', sortable: false
            }, { key: 'action', label: 'Action' }];
          }
        } else {

          _this3.$swal(data.status, data.message, data.status);
          _this3.loadingData = false;
          return;
        }
        _this3.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this3.loadingData = false;
      });
    },
    reformat: function reformat(value) {
      if (value.indexOf('%') != -1) {
        return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
      } else if (value.indexOf('km') != -1) {
        return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km";
      } else {
        return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    dFilter: function dFilter(d_filter, id) {
      this.filter_by['users_id'] = id;
      if (id == 0) {
        this.filter_by['users_id'] = '';
      }
      this.filters_save.driver_name = d_filter;
      this.filters_save.users_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();

      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.filter_by['truck_id'] = id;
      if (id == 0) {
        this.filter_by['truck_id'] = '';
      }
      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "truck_id": "",
        "trucking_company_id": "",
        "users_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "column": ['haul_id', 'energy_company', 'trucking_company', 'unload_location', 'ticket', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'energy_company_ul', 'unload_location_ul', 'volume_actual_ul', 'bsw_ul', 'oil_ul', 'water_ul'] };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        trucking_company_id: 0,
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags'
      };

      this.getAll();

      this.loadingData = true;
    },
    adjust: function adjust(item, index) {
      if (item['volume_actual'] != item['volume_actual_unload'] || item['oil_actual'] != item['oil_unload'] || item['bsw'] != item['bsw_unload']) {
        item['volume_actual'] = item['volume_actual_unload'];
        item['oil_actual'] = item['oil_unload'];
        item['bsw'] = item['bsw_unload'];
        var haulAdjust = {
          'volume_actual': item['volume_actual_unload'],
          'oil_actual': item['oil_unload'],
          'bsw': item['bsw_unload']
        };
        __WEBPACK_IMPORTED_MODULE_4__haul_service__["a" /* default */].update_values(haulAdjust, item['haul_id']).then(function (data) {
          if (data.status == 'success') {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data.status, data.message, data.status);
            console.log('good');
          } else {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data.status, data.message, data.status);
          }
        });
      }
    },
    rowClicked: function rowClicked(row, index, e) {
      console.log('click');
    },
    bbl: function bbl() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6__users_users_service__["a" /* default */].bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this4.loadingData = true;
            _this4.getAll();
          }
        });
      });
    },
    form: function form(value) {
      if (value !== '--') {
        if (this.bbll == true) {
          value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
        } else {
          value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        };return value;
      } else {
        return value;
      }
    },
    form1: function form1(value) {
      if (value !== '--') {
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';
      } else {
        return value;
      }
    }
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__receipt_service__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hauls_haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_users_service__ = __webpack_require__(23);











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Receipt',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      allSelected: false,
      tableValues: [],
      status: 'unchecked',
      haul_ids: [],
      haul_iidds: [],
      haul_iiddss: [],
      selected: '',
      row: 0,
      loadingData: true,
      companyName: '',
      companyId: null,
      configTable: false,

      items: items,
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'energy_company_unload',
        label: 'Energy Company'
      }, {
        key: 'way_bill',
        label: 'Way Bill',
        sortable: true
      }, {
        key: 'receipt_date',
        label: 'Receipt Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format("MMM DD, YYYY");
        }
      }, {
        key: 'unload_location_unload',
        label: 'Unload',
        sortable: true
      }, {
        key: 'load_location_unload',
        label: 'Load',
        sortable: true
      }, {
        key: 'volume_actual_unload',
        label: 'Total Volume at Unload',
        sortable: true
      }, {
        key: 'bsw_unload',
        label: 'BS&W at Unload',
        sortable: true
      }, {
        key: 'oil_unload',
        label: 'Oil at Unload',
        sortable: false
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['haul_id', 'energy_company', 'unload_location', 'ticket', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'energy_company_ul', 'unload_location_ul', 'volume_actual_ul', 'bsw_ul', 'oil_ul', 'water_ul'],
      role: '',
      savebtn: true,
      energy_company_id: null,
      unit: '',
      fromHaul: 0,
      bbll: false,
      myToggle: false,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_6_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column": [] },
      energy_companies_filter: '',

      load_locations_filter: '',
      unload_locations_filter: '',
      drivers_filter: '            ',
      trucks_filter: '',
      trucking_companies_filter: '',

      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',

        unload_location_id: 0,
        unload_name: 'All UnLoads',
        initial_date: '',
        end_date: ''
      },

      filename: 'receipts_without_hauls' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "receipt_id": "receipt_id",
        "energy_company-unload": "energy_company_unload",
        "way_bill": "way_bill",
        'receipt_date': 'receipt_date',
        "unload_location_unload": "unload_location_unload",
        "load_location_unload": "load_location_unload",
        "volume_actual_unload": "volume_actual_unload",
        "bsw_unload": "bsw_unload",
        "oil_unload": "oil_unload"
      },
      items_csv: []
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    selectAllHauls: function selectAllHauls() {
      if (!this.allSelected) {
        this.toggleAllSelected();
      }
    },
    unselectAllHauls: function unselectAllHauls() {
      if (this.haul_ids.length > 0) {
        this.haul_ids = [];

        var tmp1 = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp = this.haul_ids;
        var tmp2 = this.array_diff(tmp, tmp1);
        this.haul_ids = tmp2;
      }
    },
    toggleAllSelected: function toggleAllSelected() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        var tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp1 = this.haul_ids;
        tmp1.push.apply(tmp1, tmp);
        this.haul_ids = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(tmp1)));
      } else {
        var _tmp = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var _tmp2 = this.haul_ids;
        var tmp2 = this.array_diff(_tmp2, _tmp);
        this.haul_ids = tmp2;
      }
    },
    array_diff: function array_diff(tmp, tmp1) {
      return tmp.filter(function (elemento) {
        return tmp1.indexOf(elemento) == -1;
      });
    },
    checkedField: function checkedField(row) {
      if (this.haul_ids.includes(row.item.haul_id)) {
        var index = this.haul_ids.indexOf(row.item.haul_id);
        if (index > -1) {
          this.haul_ids.splice(index, 1);
        }
      } else {
        this.haul_ids.push(row.item.haul_id);
      }
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.configTable = false;
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'haul_start_date' || option == 'haul_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'oil_actual' || option == 'volume_actual' || option == 'water_actual') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                if (_this.bbll == true) {
                  value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                } else {
                  value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                };return value;
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.items = [];

      __WEBPACK_IMPORTED_MODULE_4__receipt_service__["a" /* default */].get_receipts_wo_hauls(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.hauls;
          _this2.items_csv = _this2.items;
          _this2.getAll1();
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__hauls_haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {

          _this3.energy_companies_filter = data.energy_companies_filter;

          _this3.drivers_filter = data.drivers_filter;
          _this3.load_locations_filter = data.load_locations_filter;
          _this3.unload_locations_filter = data.unload_locations_filter;
          _this3.trucks_filter = data.trucks_filter;

          _this3.trucking_companies_filter = data.trucking_companies_filter;


          _this3.bbll = data.bbl;
          _this3.role = data.role;
          if (_this3.role == 'operations_manager') {
            _this3.fields = [{
              key: 'way_bill',
              label: 'Way Bill',
              sortable: true
            }, {
              key: 'receipt_date',
              label: 'Receipt Date',
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format("MMM DD, YYYY");
              }
            }, {
              key: 'unload_location_unload',
              label: 'Unload',
              sortable: true
            }, {
              key: 'load_location_unload',
              label: 'Load',
              sortable: true
            }, {
              key: 'volume_actual_unload',
              label: 'Total Volume at Unload',
              sortable: true
            }, {
              key: 'bsw_unload',
              label: 'BS&W at Unload',
              sortable: true
            }, {
              key: 'oil_unload',
              label: 'Oil at Unload',
              sortable: false
            }];
          }
        } else {

          _this3.$swal(data.status, data.message, data.status);
          _this3.loadingData = false;
          return;
        }
        _this3.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this3.loadingData = false;
      });
    },
    reformat: function reformat(value) {
      if (value.indexOf('%') != -1) {
        return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
      } else if (value.indexOf('km') != -1) {
        return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km";
      } else {
        return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    dFilter: function dFilter(d_filter, id) {
      this.filter_by['users_id'] = id;
      if (id == 0) {
        this.filter_by['users_id'] = '';
      }
      this.filters_save.driver_name = d_filter;
      this.filters_save.users_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();

      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.filter_by['truck_id'] = id;
      if (id == 0) {
        this.filter_by['truck_id'] = '';
      }
      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_6_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "truck_id": "",
        "trucking_company_id": "",
        "users_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "column": ['haul_id', 'energy_company', 'trucking_company', 'unload_location', 'ticket', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'energy_company_ul', 'unload_location_ul', 'volume_actual_ul', 'bsw_ul', 'oil_ul', 'water_ul'] };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        trucking_company_id: 0,
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All UnLoads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags'
      };

      this.getAll();

      this.loadingData = true;
    },
    rowClicked: function rowClicked(row, index, e) {
      console.log('click');
    },
    bbl: function bbl() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_7__users_users_service__["a" /* default */].bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this4.loadingData = true;
            _this4.getAll();
          }
        });
      });
    },
    form: function form(value) {
      if (value !== '--') {
        if (this.bbll == true) {
          value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
        } else {
          value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        };return value;
      } else {
        return value;
      }
    },
    form1: function form1(value) {
      if (value !== '--') {
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';
      } else {
        return value;
      }
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestHauls',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    var _ref;

    return _ref = {
      loadingData: true,
      newEC: false,
      energy_company_id: null,
      items: items,
      totalRows: items.length,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'haul_id',
        label: 'ID',
        sortable: true
      }, {
        key: 'energy_company',
        label: 'Energy Company'
      }, {
        key: 'trucking_company',
        label: 'Trucking Company'
      }, {
        key: 'operating_area',
        label: 'Operating Area'
      }, {
        key: 'load_location',
        label: 'Load'
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'volume',
        label: 'Volume',
        sortable: false,
        formatter: function formatter(value) {
          return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        }
      }, {
        key: 'dispatch_date',
        label: 'Dispatch Date',
        sortable: false,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format("MMM DD, YYYY");
        }
      }, {
        key: 'status',
        label: 'Status'
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      role: '',
      savebtn: true
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'energy_company_id', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter_by', { "initial_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('week').format('YYYY-MM-DD'),
      "end_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('week').format('YYYY-MM-DD'),
      "trucking_company_id": "",
      "unload_location_id": "",
      "energy_companies_id": "",
      "load_location_id": "",
      "fluid_type_id": ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filters_save', {
      energy_companies_id: 0,
      energy_company_name: 'All Energy Companies',
      trucking_company_id: 0,
      trucking_company_name: 'All Trucking Companies',
      load_location_id: 0,
      load_name: 'All Loads',
      fluid_type_id: 0,
      fluid_type_name: 'All Fluid Types',
      unload_location_id: 0,
      unload_name: 'All Unloads',
      initial_date: '',
      end_date: '',
      sortby: 'haul_id',
      sortdesc: false
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'newHaul', {
      energy_company_select: [],
      trucking_company_select: [],
      operating_area_select: [],
      load_location_select: [],
      unload_location_select: [],
      fluid_type_select: [],
      energy_companies_id: '',
      trucking_company_id: '',
      operating_area_id: '',
      load_location_id: '',
      unload_location_id: '',
      fluid_type_id: '',
      dispatch_date: '',
      volume: ''
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'energy_companies_filter', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'load_locations_filter', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'unload_locations_filter', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'trucking_companies_filter', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'fluid_types_filter', ''), _ref;
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];
      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].get_request_hauls(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this.items = data.hauls;
          _this.newHaul.energy_company_select = data.company;
          _this.energy_company_id = data.energy_company_id;
          _this.getAll1();
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {
          _this2.energy_companies_filter = data.energy_companies_filter;
          _this2.load_locations_filter = data.load_locations_filter;
          _this2.unload_locations_filter = data.unload_locations_filter;
          _this2.trucking_companies_filter = data.trucking_companies_filter;
          _this2.fluid_types_filter = data.fluid_types_filter;
          _this2.role = data.role;
          if (_this2.role == "super_analyst" || _this2.role == "analyst" || _this2.role == 'marketing_accountant') {
            _this2.newHaul.energy_companies_id = _this2.energy_company_id;
            _this2.selects_energy_company();
            _this2.fields = [{ key: 'haul_id', label: 'Id', sortable: true }, {
              key: 'trucking_company',
              label: 'Trucking Company'
            }, {
              key: 'operating_area',
              label: 'Operating Area'
            }, {
              key: 'load_location',
              label: 'Load'
            }, {
              key: 'unload_location',
              label: 'Unload',
              sortable: false
            }, {
              key: 'volume',
              label: 'Volume',
              sortable: false,
              formatter: function formatter(value) {
                return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
              }
            }, {
              key: 'dispatch_date',
              label: 'Dispatch Date',
              sortable: false,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format("MMM DD, YYYY");
              }
            }, {
              key: 'status',
              label: 'Status'
            }];
          }
        } else {

          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
      }
      this.filter_by.end_date = a;

      this.getAll();

      this.loadingData = true;
    },
    ftFilter: function ftFilter(ft_filter, id) {
      this.filter_by['fluid_type_id'] = id;

      if (id == 0) {
        this.filter_by['fluid_type_id'] = '';
      }
      this.filters_save.fluid_type_name = ft_filter;
      this.filters_save.fluid_type_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('week').format('YYYY-MM-DD'),
        'energy_companies_id': '',
        "trucking_company_id": "",
        "load_location_id": "",
        "unload_location_id": "",
        'fluid_type_id': ''
      };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        initial_date: '',
        end_date: '' };
      this.getAll();
      this.loadingData = true;
    },
    hideNewHaulModal: function hideNewHaulModal() {
      this.$refs.newHaulModal.hide();
    },
    showNewHaulModal: function showNewHaulModal() {
      this.savebtn = false;
      this.newHaul.operating_area_select = [];
      this.newHaul.load_location_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];
      if (this.role == "super_admin") {
        this.newHaul.energy_companies_id = '';
        this.newHaul.trucking_company_select = [];
      }

      this.newHaul.trucking_company_id = '';
      this.newHaul.operating_area_id = '';
      this.newHaul.load_location_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';
      this.newHaul.volume = '';
      var tempDate = new Date();
      var tempDateTime = String(tempDate.getFullYear()) + "-" + ("0" + String(tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempDate.getDate())).slice(-2);
      var tempTime = ("0" + String(tempDate.getHours())).slice(-2) + ":" + ("0" + String(tempDate.getMinutes())).slice(-2);
      this.newHaul.dispatch_date = '';
      this.newHaul.dispatch_date = tempTime;
      this.newEC = true;
    },
    okToSave: function okToSave() {
      if (this.newHaul.energy_companies_id === undefined || this.newHaul.energy_companies_id.length == 0) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.newHaul.trucking_company_id === undefined || this.newHaul.trucking_company_id.length == 0) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.newHaul.operating_area_id === undefined || this.newHaul.operating_area_id.length == 0) {
        this.$swal('Alert!', 'Operating Area not selected', 'warning');
        return false;
      } else if (this.newHaul.load_location_id === undefined || this.newHaul.load_location_id.length == 0) {
        this.$swal('Alert!', 'Load Location not selected', 'warning');
        return false;
      } else if (this.newHaul.unload_location_id === undefined || this.newHaul.unload_location_id.length == 0) {
        this.$swal('Alert!', 'Unload Location not selected', 'warning');
        return false;
      } else if (this.newHaul.fluid_type_id === undefined || this.newHaul.fluid_type_id.length == 0) {
        this.$swal('Alert!', 'Fluid Type not selected', 'warning');
        return false;
      } else if (this.newHaul.volume === undefined || this.newHaul.volume.length == 0) {
        this.$swal('Alert!', 'Volume can not be empty', 'warning');
        return false;
      } else if (this.newHaul.volume < 5) {
        this.$swal('Alert!', 'Volume value must have at least five(5) ', 'warning');
        return false;
      } else if (this.newHaul.dispatch_date === undefined || this.newHaul.dispatch_date.length == 0) {
        this.$swal('Alert!', 'Dispatch not selected', 'warning');
        return false;
      }

      return true;
    },
    save_click: function save_click() {
      var _this3 = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var saveData = {
        "energy_companies_id": String(this.newHaul.energy_companies_id),
        "trucking_company_id": String(this.newHaul.trucking_company_id),
        "operating_area_id": String(this.newHaul.operating_area_id),
        "load_location_id": String(this.newHaul.load_location_id),
        "unload_location_id": String(this.newHaul.unload_location_id),
        "fluid_type_id": String(this.newHaul.fluid_type_id),
        "volume": String(this.newHaul.volume),
        "dispatch_date": this.newHaul.dispatch_date
      };
      __WEBPACK_IMPORTED_MODULE_3__haul_service__["a" /* default */].save_request(saveData).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this3.newEC = false;
            _this3.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    selects_energy_company: function selects_energy_company() {
      var energy_companies = this.newHaul.energy_company_select;
      this.newHaul.trucking_company_select = [];
      this.newHaul.operating_area_select = [];
      this.newHaul.load_location_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];
      this.newHaul.trucking_company_id = '';
      this.newHaul.operating_area_id = '';
      this.newHaul.load_location_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';
      var energy_company_index = energy_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.energy_companies_id);

      if (energy_company_index > -1) {
        this.newHaul.trucking_company_select = energy_companies[energy_company_index].trucking_companies;
      }
    },
    selects_trucking_company: function selects_trucking_company() {
      var trucking_companies = this.newHaul.trucking_company_select;
      this.newHaul.operating_area_select = [];
      this.newHaul.load_location_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];

      this.newHaul.operating_area_id = '';
      this.newHaul.load_location_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';
      var operating_area_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.trucking_company_id);
      if (operating_area_index > -1) {
        this.newHaul.operating_area_select = trucking_companies[operating_area_index].operating_area;
      }
    },
    selects_operating_area: function selects_operating_area() {
      var operating_areas = this.newHaul.operating_area_select;
      this.newHaul.load_location_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];

      this.newHaul.load_location_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';
      var operating_area_index = operating_areas.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.operating_area_id);
      if (operating_area_index > -1) {
        this.newHaul.unload_location_select = operating_areas[operating_area_index].unload_locations;
        this.newHaul.load_location_select = operating_areas[operating_area_index].load_locations;
      }
    },
    selects_load_location: function selects_load_location() {
      var load_location = this.newHaul.load_location_select;
      this.newHaul.fluid_type_select = [];
      this.newHaul.fluid_type_id = '';
      var load_location_index = load_location.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.load_location_id);
      if (load_location_index > -1) {
        this.newHaul.fluid_type_select = load_location[load_location_index].fluids[0];
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.newHaul[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.newHaul[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.newHaul[variableName];
      if (variableValue.length == 0) {
        this.newHaul[variableName] = "0.00";
      } else {
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {
          this.newHaul[variableName] = String(variableValue) + ".00";
        } else if (tempValue.length == 2) {
          this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
        }
      }
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestHauls_tc',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      loadingData: true,
      items: items,
      totalRows: items.length,
      fields: [{
        key: 'haul_id',
        label: 'Id',
        sortable: true
      }, {
        key: 'energy_company',
        label: 'Energy Company'
      }, {
        key: 'operating_area',
        label: 'Operating Area'
      }, {
        key: 'load_location',
        label: 'Load'
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'volume',
        label: 'Volume',
        sortable: false,
        formatter: function formatter(value) {
          return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        }
      }, {
        key: 'dispatch_date',
        label: 'Dispatch Date',
        sortable: false,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format("MMM DD, YYYY");
        }
      }, { key: 'action',
        label: 'Action'
      }],
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      filter: null,
      role: '',
      savebtn: true,
      energy_company_id: null,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "trucking_company_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "fluid_type_id": ""
      },
      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        unload_location_id: 0,
        unload_name: 'All UnLoads',
        initial_date: '',
        end_date: '',
        sortby: 'haul_id',
        sortdesc: false
      },
      newHaul: {
        energy_company_select: [],
        trucking_company_select: [],
        operating_area_select: [],
        load_location_select: [],
        unload_location_select: [],
        fluid_type_select: [],
        energy_companies_id: '',
        trucking_company_id: '',
        operating_area_id: '',
        load_location_id: '',
        unload_location_id: '',
        fluid_type_id: '',
        dispatch_date: '',
        volume: ''
      },
      energy_companies_filter: '',
      load_locations_filter: '',
      unload_locations_filter: '',
      trucking_companies_filter: '',
      fluid_types_filter: ''
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];
      __WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].get_request_hauls(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this.items = data.hauls;
          _this.newHaul.energy_company_select = data.company;
          _this.getAll1();
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {
          _this2.energy_companies_filter = data.energy_companies_filter;
          _this2.load_locations_filter = data.load_locations_filter;
          _this2.unload_locations_filter = data.unload_locations_filter;
          _this2.trucking_companies_filter = data.trucking_companies_filter;
          _this2.fluid_types_filter = data.fluid_types_filter;
          _this2.role = data.role;
        } else {

          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
      }
      this.filter_by.end_date = a;

      this.getAll();

      this.loadingData = true;
    },
    ftFilter: function ftFilter(ft_filter, id) {
      this.filter_by['fluid_type_id'] = id;

      if (id == 0) {
        this.filter_by['fluid_type_id'] = '';
      }
      this.filters_save.fluid_type_name = ft_filter;
      this.filters_save.fluid_type_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD'),
        'energy_companies_id': '',
        "trucking_company_id": "",
        "load_location_id": "",
        "unload_location_id": "",
        'fluid_type_id': ''
      };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All UnLoads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        initial_date: '',
        end_date: '' };
      this.getAll();
      this.loadingData = true;
    },
    adjust: function adjust(item, index) {
      var accepted = {
        'status_id': 5
      };
      if (item['status_id'] == 4) {
        item.status_id = 5;
      } else {
        accepted['status_id'] = 4;
        item.status_id = 4;
      }
      __WEBPACK_IMPORTED_MODULE_2__haul_service__["a" /* default */].update_request(accepted, item['haul_id']).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data.status, data.message, data.status);
          console.log('good');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    }
  }
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invoices_service__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invoices',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      loadingData: true,
      newEC: false,
      energy_company_id: null,
      items: items,
      totalRows: items.length,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      sortBy: 'id',
      sortDesc: true,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'energy_company',
        label: 'Energy Company',
        sortable: true
      }, {
        key: 'trucking_company',
        label: 'Trucking Company',
        sortable: true
      }, {
        key: 'volume',
        label: 'Invoice Ref',
        sortable: false
      }, {
        key: 'cost_code',
        label: 'Cost Code',
        sortable: false
      }, {
        key: 'date',
        label: 'Date',
        sortable: false
      }, {
        key: 'surcharge',
        label: 'Surcharge %',
        sortable: false
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      role: '',
      savebtn: true,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "trucking_company_id": "",
        "energy_companies_id": ""
      },
      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        sortby: 'haul_id',
        sortdesc: false
      },
      newHaul: {
        energy_company_select: [],
        trucking_company_select: [],
        energy_company_id: '',
        trucking_company_id: '',
        volume: '',
        cost_code: '',
        date: null,
        surcharge: ''
      },
      energy_companies_filter: '',
      trucking_companies_filter: '',
      trash: false,
      dpdt: 'Active',
      newModal: false,
      model: {
        id: null,
        energy_company_id: null,
        trucking_company_id: null,
        invoice_id: null,
        date: null,
        surcharge: null
      },
      company_name: [],
      energy_companies: [],
      invoices_filter: [],
      sendbtn: true,
      surcharge: ''
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];
      __WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this.items = data.invoices.filter(function (o) {
            return o.status_id == (_this.trash ? 2 : 1);
          });
          _this.newHaul.trucking_company_select = data.insert_data.company;
          _this.invoices_filter = data.insert_data.invoice_filter;
          _this.role = data.role;
          _this.company_name = data.insert_data.company;
          if (_this.role === 'trucking_company_admin' || _this.role === 'trucking_operational_manager') {
            _this.model.energy_company_id = null;
            var trucking_companies = _this.company_name;
            if (trucking_companies.length > 0) {
              _this.model.trucking_company_id = trucking_companies[0].id;
              _this.energy_companies = trucking_companies[0].energy_companies;
            } else {
              _this.model.trucking_company_id = null;
              _this.energy_companies = [];
            }
          }
          if (_this.role === 'trucking_company_admin' || _this.role === 'trucking_operational_manager') {
            _this.newHaul.energy_company_id = '';
            var _trucking_companies = _this.newHaul.trucking_company_select;
            if (_trucking_companies.length > 0) {
              _this.newHaul.trucking_company_id = _trucking_companies[0].id;
              _this.newHaul.energy_company_select = _trucking_companies[0].energy_companies;
            } else {
              _this.newHaul.trucking_company_id = '';
              _this.newHaul.energy_company_select = [];
            }
          }
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
      }
      this.filter_by.end_date = a;

      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD'),
        'energy_companies_id': '',
        "trucking_company_id": "",
        "load_location_id": "",
        "unload_location_id": "",
        'fluid_type_id': ''
      };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        fluid_type_id: 0,
        fluid_type_name: 'All Fluid Types',
        initial_date: '',
        end_date: '' };
      this.getAll();
      this.loadingData = true;
    },
    hideNewInvoiceModal: function hideNewInvoiceModal() {
      this.$refs.newInvoiceModal.hide();
    },
    showNewInvoiceModal: function showNewInvoiceModal() {
      this.savebtn = false;
      if (this.role == "super_admin") {
        this.newHaul.trucking_company_id = '';
        this.newHaul.energy_company_select = [];
      }
      this.newHaul.volume = '';
      this.newHaul.cost_code = '';
      this.newHaul.date = null;
      this.newHaul.surcharge = '';
      this.newEC = true;
    },
    okToSave: function okToSave() {

      if (this.role == "super_admin") {
        if (this.newHaul.trucking_company_id === undefined || this.newHaul.trucking_company_id.length == 0) {
          this.$swal('Alert!', 'Trucking Company not selected', 'warning');
          return false;
        }
      }

      if (this.newHaul.energy_company_id === undefined || this.newHaul.energy_company_id.length == 0) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.newHaul.volume === undefined || this.newHaul.volume.length == 0) {
        this.$swal('Alert!', 'Invoice Ref can not be empty', 'warning');
        return false;
      } else if (this.newHaul.cost_code === undefined || this.newHaul.cost_code.length == 0) {
        this.$swal('Alert!', 'Cost Code can not be empty', 'warning');
        return false;
      } else if (this.newHaul.date === undefined || this.newHaul.date == null) {
        this.$swal('Alert!', 'Date not selected', 'warning');
        return false;
      } else if (this.newHaul.surcharge === undefined || this.newHaul.surcharge.length == 0) {
        this.$swal('Alert!', 'Surcharge value can not be empty', 'warning');
        return false;
      }
      return true;
    },
    save_click: function save_click() {
      var _this2 = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      var saveData = {
        "energy_company_id": String(this.newHaul.energy_company_id),
        "trucking_company_id": String(this.newHaul.trucking_company_id),
        "volume": String(this.newHaul.volume),
        "cost_code": String(this.newHaul.cost_code),
        "date": this.newHaul.date,
        "surcharge": String(this.newHaul.surcharge)
      };
      __WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].save(saveData).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this2.newEC = false;
            _this2.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    selects_energy_company: function selects_energy_company() {},
    selects_trucking_company: function selects_trucking_company() {
      var trucking_companies = this.newHaul.trucking_company_select;
      this.newHaul.energy_company_select = [];
      this.newHaul.energy_company_id = '';
      if (trucking_companies.length > 0) {
        var trucking_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.trucking_company_id);
        if (trucking_company_index > -1) {
          this.newHaul.energy_company_select = trucking_companies[trucking_company_index].energy_companies;
        }
      }
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/invoice/' + row.id + "/");
      } else {
        this.restoreTerminal(row.id);
      }
    },
    trashTerminal: function trashTerminal() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    restoreTerminal: function restoreTerminal(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this invoice ?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.message == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    send_notification_click: function send_notification_click() {
      this.sendbtn = false;
      this.model.energy_company_id = null;
      this.model.invoice_id = null;
      this.newModal = true;
      if (this.role === 'super_admin') {
        this.model.trucking_company_id = null;
      }
    },
    send_click: function send_click() {
      var _this4 = this;

      if (!this.okToSend()) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].send_invoice(this.model).then(function (data) {
        if (data.status == 'success') {
          _this4.$swal(data.status, data.message, data.status);
        } else {
          _this4.$swal(data.status, data.message, data.status);
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.sendbtn = true;
      this.newModal = false;
    },
    selects_trucking_company_1: function selects_trucking_company_1() {
      var trucking_companies = this.company_name;
      this.energy_companies = [];
      this.model.energy_company_id = null;
      if (trucking_companies.length > 0) {
        var trucking_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.model.trucking_company_id);
        if (trucking_company_index > -1) {
          this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
        }
      }
    },
    hideNewModal: function hideNewModal() {
      this.$refs.newModal.hide();
    },
    okToSend: function okToSend() {
      if (this.model.trucking_company_id === undefined || this.model.trucking_company_id === null) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.model.invoice_id === undefined || this.model.invoice_id == null) {
        this.$swal('Alert!', 'Invoice Ref not selected', 'warning');
        return false;
      }
      return true;
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.newHaul[variableName];
      if (variableValue.length == 0) {
        this.newHaul[variableName] = "0.00";
      } else {
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {
          this.newHaul[variableName] = String(variableValue) + ".00";
        } else if (tempValue.length == 2) {
          this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
        }
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.newHaul[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.newHaul[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invoices_service__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hauls_haul_service__ = __webpack_require__(18);






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Invoice',
	created: function created() {
		var _this = this;

		this.$root.$on('haul_edit', function () {
			_this.getTerminalData();
		});
		this.getTerminalData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		var _this2 = this;

		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				id: null,
				energy_company_id: null,
				trucking_company_id: null,
				energy_company_name: '',
				trucking_company_name: '',
				invoice_ref: '',
				cost_code: '',
				date: null,
				hauls: [],
				summary: [],
				volume_avg: 0,
				rate_avg: 0,
				s_total_avg: 0,
				surcharge: ''
			},
			updateData: null,
			originalData: null,
			loadingData: true,
			terminalId: null,
			role: '',
			trucking_companies: [],
			energy_companies: [],
			fields: [{
				key: 'ticket',
				label: 'Ticket #',
				sortable: true
			}, {
				key: 'haul_start_date',
				label: 'Start Date',
				sortable: true,
				formatter: function formatter(value) {
					return moment(value).format("MMM DD, YYYY");
				}
			}, {
				key: 'unload_location',
				label: 'Unload',
				sortable: true
			}, {
				key: 'load_location',
				label: 'Load',
				sortable: false
			}, {
				key: 'volume',
				label: 'Volume',
				sortable: true,
				formatter: function formatter(value) {
					if (_this2.bbll == true) {
						value = Number(parseFloat(value).toFixed(2) * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
					} else {
						value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
					};return value;
				}
			}, {
				key: 'bsw',
				label: 'BS&W (%)',
				sortable: false,
				formatter: function formatter(value) {
					return parseFloat(value).toFixed(2);
				}
			}],
			fields1: [{
				key: 'load_location',
				label: 'Well Description',
				sortable: false
			}, {
				key: 'unload_location',
				label: 'Delivery Point',
				sortable: false
			}, {
				key: 'fluid_type',
				label: 'Fluid',
				sortable: false
			}, {
				key: 'truck_type',
				label: 'Truck Type',
				sortable: false
			}, {
				key: 'cost_code',
				label: 'Cost Center',
				sortable: false
			}, {
				key: 'rate',
				label: 'Rate($/m³)',
				sortable: false
			}, {
				key: 'volume',
				label: 'Volume',
				sortable: false,
				formatter: function formatter(value) {
					if (_this2.bbll == true) {
						value = Number(parseFloat(value).toFixed(2) * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					} else {
						value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					};return value;
				}
			}, {
				key: 's_total',
				label: 'Sub-Total',
				sortable: false
			}],

			tempFields: [],
			fieldsSelected: 7,
			maxFieldsSelected: 20,
			configTable: false,
			bbll: false,
			selectedItems: ['haul_id', 'haul_start_date', 'load_location', 'unload_location', 'ticket', 'volume', 'bsw'],
			surcharge: ''
		};
	},

	methods: {
		editTerminal: function editTerminal() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		setupFields: function setupFields() {
			if (this.role == 'super_admin') {
				var temp = this.model.energy_company_id;
				this.selects_trucking_company();
				this.model.energy_company_id = temp;
			}
		},
		getTerminalData: function getTerminalData() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this3.originalData = data.invoice;
					_this3.terminalId = _this3.id;
					_this3.loadingData = false;
					_this3.found = true;
					_this3.restoreOriginalData();
					_this3.subTitle = _this3.originalData.trucking_company_name;
					_this3.trucking_companies = data.update_data.company;
					_this3.role = data.role;
					if (_this3.role === 'trucking_company_admin' || _this3.role === 'trucking_operational_manager') {
						var trucking_companies = _this3.trucking_companies;
						_this3.energy_companies = trucking_companies[0].energy_companies;

						_this3.model.trucking_company_id = trucking_companies[0].id;
					}
				} else {
					_this3.$swal(data.status, data.message, data.status);
					_this3.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this3.$swal('Error', 'Server not response. ' + error, 'error');
				_this3.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {

			if (this.role == "super_admin") {
				if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}

			if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
				this.$swal('Alert!', 'Select Energy Company ID', 'warning');
				return false;
			} else if (this.model.invoice_ref === '' || this.model.invoice_ref === undefined) {
				this.$swal('Alert!', 'Please, Enter Invoice Ref', 'warning');
				return false;
			} else if (this.model.cost_code === '' || this.model.cost_code === undefined) {
				this.$swal('Alert!', 'Please, Enter Cost Code', 'warning');
				return false;
			} else if (this.model.date === undefined || this.model.date == null) {
				this.$swal('Alert!', 'Please, Enter Date', 'warning');
				return false;
			} else if (this.model.surcharge === undefined || this.model.surcharge.length == 0) {
				this.$swal('Alert!', 'Surcharge value can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateTerminal: function updateTerminal() {
			var _this4 = this;

			if (!this.okToUpdate()) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].update(this.terminalId, this.model).then(function (data) {
				_this4.$swal(data[0], data[1], data[0]).then(function (result) {
					_this4.getTerminalData();
				});
			}).catch(function (error) {
				_this4.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTerminal: function deleteTerminal(item) {
			var _this5 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Invoice for " + this.model.invoice_ref + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].delete(_this5.terminalId).then(function (data) {
						_this5.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this5.$router.replace('/invoices');
						}
					}).catch(function (error) {
						_this5.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		selects_trucking_company: function selects_trucking_company() {
			var trucking_companies = this.trucking_companies;
			this.energy_company = [];
			var trucking_company_index = trucking_companies.map(function (o) {
				return o.id;
			}).indexOf(this.model.trucking_company_id);
			if (trucking_company_index > -1) {
				this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
				this.model.energy_company_id = null;
			}
		},
		openSelectColumns: function openSelectColumns() {
			this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.fields));
			this.configTable = true;
		},
		rowClicked: function rowClicked(row, index, e) {
			e.preventDefault();
			var to_popup = { 'id': row.haul_id, 'haul_invoice': true, 'edit': this.id };
			this.$root.$emit('openPopup', to_popup);
		},
		send_click: function send_click() {
			var _this6 = this;

			this.okToSend();
			var column = this.fields.map(function (item) {
				return item.key;
			});
			var send_invoice = {
				"energy_company_id": this.model.energy_company_id,
				"trucking_company_id": this.model.trucking_company_id,
				"invoice_id": this.terminalId,
				"column": column
			};
			__WEBPACK_IMPORTED_MODULE_2__invoices_service__["a" /* default */].send_invoice(send_invoice).then(function (data) {
				if (data.status == 'success') {
					_this6.$swal(data.status, data.message, data.status);
				} else {
					_this6.$swal(data.status, data.message, data.status);
					return;
				}
			}).catch(function (error) {
				Vue.swal('Error', 'Server not response. ' + error, 'error');
			});
		},
		okToSend: function okToSend() {

			if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
				this.$swal('Alert!', 'Trucking Company not selected', 'warning');
				return false;
			} else if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
				this.$swal('Alert!', 'Select Energy Company ID', 'warning');
				return false;
			} else if (this.model.invoice_ref === '' || this.model.invoice_ref === undefined) {
				this.$swal('Alert!', 'Please, Enter Invoice Ref', 'warning');
				return false;
			}
			return true;
		},
		shouldBeDisabled: function shouldBeDisabled(option) {
			return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
				return o.key;
			}).indexOf(option) == -1;
		},
		actionField: function actionField(option, label, position) {

			var fieldsLength = this.tempFields.length;
			var fieldIsActive = false;
			for (var i = 0; i <= fieldsLength; i++) {
				fieldIsActive = true;
				try {
					if (this.tempFields[i].key === option || this.tempFields[i] === option) {
						this.tempFields.splice(i, 1);
						fieldIsActive = false;
						break;
					}
				} catch (err) {

					if (option == 'haul_start_date') {
						option = {
							key: option,
							label: label,
							sortable: true,
							formatter: function formatter(value) {
								return moment(value).format("MMM DD, YYYY");
							}
						};
					} else {
						option = {
							key: option,
							label: label,
							sortable: true
						};
					}
					this.tempFields.splice(position, 0, option);
				}
			}
			this.fieldsSelected = this.tempFields.length;
		},
		saveSelectedColumns: function saveSelectedColumns() {
			this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
			this.configTable = false;
		},
		inputBlur: function inputBlur(variableName) {
			var variableValue = this.model[variableName];
			if (variableValue.length == 0) {
				this.model[variableName] = "0.00";
			} else {
				var tempValue = variableValue.split(".");
				if (tempValue.length == 1) {
					this.model[variableName] = String(variableValue) + ".00";
				} else if (tempValue.length == 2) {
					this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
				}
			}
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this.model[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.model[variableName].length;
			this.isNumber(evt, hasDot, dotPosition, length);
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length) {

			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		}
	}
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__invoices_service__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_users_service__ = __webpack_require__(23);












__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HaulsInvoices',
  created: function created() {
    var _this = this;

    this.$root.$on('haul_Updated', function () {
      _this.getAll();
    });
    this.getAll();
  },
  data: function data() {
    var _this2 = this,
        _newHaul,
        _ref;

    return _ref = {
      allSelected: false,
      tableValues: [],
      status: 'unchecked',
      haul_ids: [],
      haul_iidds: [],
      haul_iiddss: [],
      selected: '',
      row: 0,
      loadingData: true,
      companyName: '',
      companyId: null,
      configTable: false,

      items: items,
      itemsAll: items,
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'select_haul',
        label: 'Select',
        thClass: 'select_column', tdClass: 'select_column'
      }, {
        key: 'ticket',
        label: 'Ticket #',
        sortable: true
      }, {
        key: 'invoice_id',
        label: 'Invoice ID',
        sortable: true
      }, {
        key: 'invoice_ref',
        label: 'Invoice Ref',
        sortable: true
      }, {
        key: 'energy_company',
        label: 'Energy Company',
        sortable: true
      }, {
        key: 'trucking_company',
        label: 'Trucking Company',
        sortable: true
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'load_location',
        label: 'Load',
        sortable: false
      }, {
        key: 'volume_actual',
        label: 'Deliveries',
        sortable: true,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(parseFloat(value).toFixed(2) * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'bsw',
        label: 'BS&W (%)',
        sortable: false,
        formatter: function formatter(value) {
          return parseFloat(value).toFixed(2);
        }
      }, {
        key: 'oil_actual',
        label: 'Oil',
        sortable: false,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(parseFloat(value).toFixed(2) * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          }return value;
        }
      }, {
        key: 'water_actual',
        label: 'Water',
        sortable: false,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'haul_start_date',
        label: 'Start Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(value).format("MMM DD, YYYY");
        }
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['energy_company', 'trucking_company', 'unload_location', 'ticket', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'haul_start_date', 'invoice_id', 'invoice_ref'],
      role: '',
      savebtn: true,
      energy_company_id: null,
      unit: '',
      fromHaul: 0,
      bbll: false,
      myToggle: false,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column": ['ticket', 'energy_company', 'trucking_company', 'unload_location', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'haul_start_date'], "invoice_id": "",
        "invoic_id": ""
      },
      energy_companies_filter: '',

      load_locations_filter: '',
      unload_locations_filter: '',
      drivers_filter: '            ',
      trucks_filter: '',
      trucking_companies_filter: '',
      invoices_filter: [],

      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',

        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        invoice_id: 0,
        invoice_name: 'Hauls Without Invoice',
        invoic_id: 0,
        invoic_name: 'All Invoices'
      },

      filename: 'hauls_discrenpacy_' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "haul_id": "haul_id",
        "energy_company": "energy_company",
        "trucking_company": "trucking_company",
        "ticket": "ticket",
        "unload_location": "unload_location",
        "load_location": "load_location",
        "volume_actual": "volume_actual",
        "bsw": "bsw",
        "oil_actual": "oil_actual",
        "energy_company_unload": "energy_company_unload",
        "unload_location_unload": "unload_location_unload",
        "volume_actual_unload": "volume_actual_unload",
        "bsw_unload": "bsw_unload",
        "oil_unload": "oil_unload"
      },
      items_csv: [],
      modalInvoice: false,
      invoiceOptions: [],
      invoiceHauls: [],
      newModal: false,
      model: {
        id: null,
        energy_company_id: null,
        trucking_company_id: null,
        invoice_id: null
      },
      company_name: [],
      energy_companies: [],
      sendbtn: true,
      newHaul: (_newHaul = {
        water_actual: "",
        water_percentage_estimate: "",
        oil_actual: "",
        volume_estimate: "",
        truck_company_select: [],
        driver_select: [],
        energy_company_select: [],
        unload_location_select: [],
        fluid_type_select: [],
        load_location_select: [],
        loads_locations: [],
        truck_select: [],
        truck_unit_select: [],

        companyName: '',
        load_location: '',
        loadingData: true,
        unload_location: '',
        haul_start_date: '',

        truck_company_id: '',
        load_location_id: '',
        user_id: '',
        full_name: '',
        truck_id: '',
        truck_unit_id: '',
        trucking_company_id: '',
        energy_companies_id: '',
        unload_location_id: '',
        fluid_type_id: '',
        water_percentage_actual: ''
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'water_percentage_estimate', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'volume_actual', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'volume_estimate', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_end_datetime', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_start_datetime', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_end_time', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_start_time', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'chain_up', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'comments_start', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'comments_end', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'wait_times_csv', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'wait_times', [{
        "type_id": "3",
        "time": "00:00",
        "comments": ""
      }, {
        "type_id": "4",
        "time": "00:00",
        "comments": ""
      }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'ticket', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 't_ticket', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 't_boss', ''), _newHaul),
      newEC: false,
      insert_data: { 'trucking_companies': [] },
      haul_updated: false
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'allSelected', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'Approved', 'Show Approved'), _ref;
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    selectAllHauls: function selectAllHauls() {
      if (!this.allSelected) {
        this.toggleAllSelected();
      }
    },
    unselectAllHauls: function unselectAllHauls() {
      if (this.haul_ids.length > 0) {
        this.haul_ids = [];

        var tmp1 = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp = this.haul_ids;
        var tmp2 = this.array_diff(tmp, tmp1);
        this.haul_ids = tmp2;
      }
    },
    toggleAllSelected: function toggleAllSelected() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        this.haul_ids = [];
        this.haul_ids = this.items.map(function (item) {
          return item.haul_id;
        });
      } else {
        this.haul_ids = [];
      }
    },
    array_diff: function array_diff(tmp, tmp1) {
      return tmp.filter(function (elemento) {
        return tmp1.indexOf(elemento) == -1;
      });
    },
    checkedField: function checkedField(row) {
      if (this.haul_ids.includes(row.item.haul_id)) {
        var index = this.haul_ids.indexOf(row.item.haul_id);
        if (index > -1) {
          this.haul_ids.splice(index, 1);
        }
      } else {
        this.haul_ids.push(row.item.haul_id);
      }
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      var _this3 = this;

      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.configTable = false;
      this.filter_by.column = this.fields.map(function (item) {
        return item.key;
      });
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].saveSelectedColumns(this.fields).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this3.getAll();
          }
        });
      });
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this4 = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'haul_start_date' || option == 'haul_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'oil_actual' || option == 'volume_actual' || option == 'water_actual' || option == 'volume_estimate') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                if (_this4.bbll == true) {
                  value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                } else {
                  value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                };return value;
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this5 = this;

      this.items = [];

      __WEBPACK_IMPORTED_MODULE_5__invoices_service__["a" /* default */].get_invoices_hauls(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this5.items = data.hauls;
          _this5.invoices_filter = data.invoice_filter;
          _this5.items_csv = _this5.items;
          _this5.itemsAll = _this5.items;
          if (_this5.Approved === 'Approved' || _this5.Approved === 'Unapproved') {
            _this5.approvedFilter(_this5.Approved);
          }

          _this5.role = data.role;
          _this5.company_name = data.trucking_companies;
          if (_this5.role === 'trucking_company_admin' || _this5.role === 'trucking_operational_manager') {
            _this5.model.energy_company_id = null;
            var trucking_companies = _this5.company_name;
            if (trucking_companies.length > 0) {
              _this5.model.trucking_company_id = trucking_companies[0].id;
              _this5.energy_companies = trucking_companies[0].energy_companies;
            } else {
              _this5.model.trucking_company_id = null;
              _this5.energy_companies = [];
            }
          }
          _this5.haul_ids = [];
          _this5.allSelected = false;
          _this5.getAll1();
        } else {
          _this5.$swal(data.status, data.message, data.status);
          _this5.loadingData = false;
          return;
        }
        _this5.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this5.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {

          _this6.energy_companies_filter = data.energy_companies_filter;

          _this6.load_locations_filter = data.load_locations_filter;
          _this6.unload_locations_filter = data.unload_locations_filter;

          _this6.trucking_companies_filter = data.trucking_companies_filter;

          _this6.bbll = data.bbl;

          if (_this6.role == 'operations_manager') {
            _this6.fields = [{
              key: 'haul_id',
              label: 'ID',
              sortable: false
            }, {
              key: 'unload_location',
              label: 'Unload',
              sortable: false
            }, {
              key: 'ticket',
              label: 'Ticket #',
              sortable: false
            }, {
              key: 'load_location',
              label: 'Load',
              sortable: false
            }, {
              key: 'volume_actual',
              label: 'Deliveries',
              sortable: true
            }, {
              key: 'bsw',
              label: 'BS&W (%)',
              sortable: false
            }, {
              key: 'oil_actual',
              label: 'Oil',
              sortable: false
            }, {
              key: 'drivers_filter',
              label: '            '
            }, { key: 'unload_location_unload', label: 'Unload', sortable: false
            }, { key: 'volume_actual_unload', label: 'Total Volume at Unload', sortable: true
            }, { key: 'bsw_unload', label: 'BS&W at Unload', sortable: false
            }, { key: 'oil_unload', label: 'Oil at Unload', sortable: false
            }, { key: 'action', label: 'Action' }];
          }
        } else {

          _this6.$swal(data.status, data.message, data.status);
          _this6.loadingData = false;
          return;
        }
        _this6.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this6.loadingData = false;
      });
    },
    reformat: function reformat(value) {
      if (value.indexOf('%') != -1) {
        return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
      } else if (value.indexOf('km') != -1) {
        return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km";
      } else {
        return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    dFilter: function dFilter(d_filter, id) {
      this.filter_by['users_id'] = id;
      if (id == 0) {
        this.filter_by['users_id'] = '';
      }
      this.filters_save.driver_name = d_filter;
      this.filters_save.users_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();

      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.filter_by['truck_id'] = id;
      if (id == 0) {
        this.filter_by['truck_id'] = '';
      }
      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;
      this.getAll();

      this.loadingData = true;
    },
    inFilter: function inFilter(t_filter, id) {
      this.filter_by['invoice_id'] = id;
      if (id == 0) {
        this.filter_by['invoice_id'] = '';
      }
      this.filters_save.invoice_name = t_filter;
      this.filters_save.invoice_id = id;
      this.getAll();

      this.loadingData = true;
    },
    ivFilter: function ivFilter(t_filter, id) {
      this.filter_by['invoic_id'] = id;
      if (id == 0) {
        this.filter_by['invoic_id'] = '';
      }
      this.filters_save.invoic_name = t_filter;
      this.filters_save.invoic_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "truck_id": "",
        "trucking_company_id": "",
        "users_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "column": ['ticket', 'energy_company', 'trucking_company', 'unload_location', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual'],
        "invoice_id": "",
        "invoic_id": ""
      };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        trucking_company_id: 0,
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        invoice_id: 0,
        invoice_name: 'Hauls Without Invoice',
        invoic_id: 0,
        invoic_name: 'All Invoices'
      };

      this.Approved = 'Show Approved';
      this.getAll();

      this.loadingData = true;
    },
    rowClicked: function rowClicked(row, index, e) {
      e.preventDefault();
      var to_popup = { 'id': row.haul_id, 'haul_invoice': true, 'edit': '' };
      this.$root.$emit('openPopup', to_popup);
    },
    bbl: function bbl() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_8__users_users_service__["a" /* default */].bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this7.loadingData = true;
            _this7.getAll();
          }
        });
      });
    },
    form: function form(value) {
      if (value !== '--') {
        if (this.bbll == true) {
          value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
        } else {
          value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        };return value;
      } else {
        return value;
      }
    },
    form1: function form1(value) {
      if (value !== '--') {
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';
      } else {
        return value;
      }
    },
    openModal: function openModal() {
      var _this8 = this;

      this.invoiceOptions = [];
      var invoices_to_save = this.invoices_filter;
      invoices_to_save.map(function (item) {
        var item_data = {};
        item_data['value'] = item.id;
        item_data['text'] = item.invoice_ref;
        _this8.invoiceOptions.push(item_data);
      });
      this.modalInvoice = true;
    },
    addHaulsInvoice: function addHaulsInvoice() {
      var _this9 = this;

      if (!this.okToSave()) {
        return;
      }
      this.invoiceHauls = [];
      this.haul_ids.map(function (item) {
        var item_data = {};
        item_data['invoice_id'] = _this9.selected;
        item_data['haul_id'] = item;
        _this9.invoiceHauls.push(item_data);
      });
      __WEBPACK_IMPORTED_MODULE_5__invoices_service__["a" /* default */].addHaulsInvoice(this.invoiceHauls).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this9.haul_ids = [];
          _this9.selected = '';
          _this9.modalInvoice = false;
          _this9.getAll();
          _this9.loadingData = true;
        } else {
          _this9.selected = '';
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this9.modalInvoice = false;
        }
      });
    },
    okToSave: function okToSave() {
      if (this.selected === undefined || this.selected === '') {
        this.$swal('Alert!', 'Invoice not selected', 'warning');
        return false;
      }
      return true;
    },
    send_notification_click: function send_notification_click() {
      this.sendbtn = false;
      this.model.energy_company_id = null;
      this.model.invoice_id = null;
      this.newModal = true;
      if (this.role === 'super_admin') {
        this.model.trucking_company_id = null;
      }
    },
    send_click: function send_click() {
      var _this10 = this;

      if (!this.okToSend()) {
        return;
      }
      var column = this.fields.map(function (item) {
        return item.key;
      });
      var send_invoice = {
        "energy_company_id": this.model.energy_company_id,
        "trucking_company_id": this.model.trucking_company_id,
        "invoice_id": this.model.invoice_id,
        "column": column
      };
      __WEBPACK_IMPORTED_MODULE_5__invoices_service__["a" /* default */].send_invoice(send_invoice).then(function (data) {
        if (data.status == 'success') {
          _this10.$swal(data.status, data.message, data.status);
        } else {
          _this10.$swal(data.status, data.message, data.status);
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.sendbtn = true;
      this.newModal = false;
    },
    selects_trucking_company_1: function selects_trucking_company_1() {
      var trucking_companies = this.company_name;
      this.energy_companies = [];
      this.model.energy_company_id = null;
      if (trucking_companies.length > 0) {
        var trucking_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.model.trucking_company_id);
        if (trucking_company_index > -1) {
          this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
        }
      }
    },
    hideNewModal: function hideNewModal() {
      this.$refs.newModal.hide();
    },
    okToSend: function okToSend() {
      if (this.model.trucking_company_id === undefined || this.model.trucking_company_id === null) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.model.invoice_id === undefined || this.model.invoice_id == null) {
        this.$swal('Alert!', 'Invoice Ref not selected', 'warning');
        return false;
      }
      return true;
    },
    showNewHaulModal: function showNewHaulModal() {
      this.savebtn = false;
      this.newHaul.truck_company_select = [];
      this.newHaul.driver_select = [];
      this.newHaul.energy_company_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];
      this.newHaul.load_location_select = [];
      this.newHaul.truck_select = [];

      this.newHaul.truck_company_id = '';
      this.newHaul.load_location_id = '';
      this.newHaul.user_id = '';
      this.newHaul.full_name = '';
      this.newHaul.truck_id = '';
      this.newHaul.energy_companies_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';

      this.newHaul.comments_start = '';
      this.newHaul.comments_end = '';

      this.water_percentage_actual = '';
      this.water_percentage_estimate = '';
      this.volume_actual = '';
      this.volume_estimate = '';
      var tempDate = new Date();
      var tempDateTime = String(tempDate.getFullYear()) + "-" + ("0" + String(tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempDate.getDate())).slice(-2);
      var tempTime = ("0" + String(tempDate.getHours())).slice(-2) + ":" + ("0" + String(tempDate.getMinutes())).slice(-2);

      this.newHaul.haul_end_datetime = '';
      this.newHaul.haul_start_datetime = '';
      this.newHaul.haul_end_time = tempTime;
      this.newHaul.haul_start_time = tempTime;
      this.newHaul.chain_up = false;
      this.newHaul.t_ticket = '';
      this.newHaul.t_boss = '';
      if (this.role == 'super_admin') {
        if (this.insert_data.trucking_companies.length > 0) {
          var trucking_companies = this.insert_data.trucking_companies;
          this.newHaul.truck_company_select = trucking_companies.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
        } else {
          this.get_trucking_companies();
        }
      } else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        if (this.insert_data.trucking_companies.length > 0) {
          this.selects_trucking_company();
        } else {
          this.get_trucking_companies();
          this.selects_trucking_company();
        }
      }
      this.newEC = true;
    },
    addWaitTime: function addWaitTime() {
      this.newHaul.wait_times.push({
        "type_id": "5",
        "time": "00:00",
        "comments": ""
      });
    },
    hmsToSecondsOnly: function hmsToSecondsOnly(str) {
      var p = str.split(':'),
          s = 0,
          m = 1;

      while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
      }
      s *= 60;
      return s;
    },
    waitTimeLabel: function waitTimeLabel(wait_time) {
      var wait_times_label = [{
        type_id: "3",
        label: "Wait Time To Load"
      }, {
        type_id: "4",
        label: "Wait Time To Unload"
      }];
      var myIndex = wait_times_label.map(function (o) {
        return o.type_id;
      }).indexOf(wait_time.type_id);
      if (myIndex > -1) {
        return wait_times_label[myIndex].label;
      }
      return "Other Wait Time";
    },
    hideNewHaulModal: function hideNewHaulModal() {
      this.$refs.newHaulModal.hide();
    },
    okToSave_h: function okToSave_h() {
      if (this.newHaul.energy_companies_id === undefined || this.newHaul.energy_companies_id.length == 0) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.newHaul.fluid_type_id === undefined || this.newHaul.fluid_type_id.length == 0) {
        this.$swal('Alert!', 'Fluid Type not selected', 'warning');
        return false;
      } else if (this.newHaul.load_location_id === undefined || this.newHaul.load_location_id.length == 0) {
        this.$swal('Alert!', 'Load Location not selected', 'warning');
        return false;
      } else if (this.newHaul.truck_company_id === undefined || this.newHaul.truck_company_id.length == 0) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.newHaul.unload_location_id === undefined || this.newHaul.unload_location_id.length == 0) {
        this.$swal('Alert!', 'Unload Location not selected', 'warning');
        return false;
      } else if (this.newHaul.user_id === undefined || this.newHaul.user_id.length == 0) {
        this.$swal('Alert!', 'Driver not selected', 'warning');
        return false;
      } else if (this.newHaul.truck_id === undefined || this.newHaul.truck_id.length == 0) {
        this.$swal('Alert!', 'Truck not selected', 'warning');
        return false;
      } else if (this.newHaul.volume_actual === undefined || this.newHaul.volume_actual.length == 0) {
        this.$swal('Alert!', 'Volume Actual can not be empty', 'warning');
        return false;
      } else if (this.newHaul.volume_actual < 5) {
        this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning');
        return false;
      } else if (this.newHaul.ticket === undefined || this.newHaul.ticket.length == 0) {
        this.$swal('Alert!', 'Ticket can not be empty', 'warning');
        return false;
      }

      try {
        var startDateValidation = new Date(this.newHaul.haul_start_datetime).getFullYear();
        if (startDateValidation <= 2000 || startDateValidation >= 2100) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'Start Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      try {
        var endDateValidation = new Date(this.newHaul.haul_end_datetime).getFullYear();
        if (endDateValidation <= 2000 || endDateValidation >= 2100) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      return true;
    },
    saveHaul: function saveHaul() {
      var _this11 = this;

      this.inputBlur('water_percentage_actual');
      this.inputBlur('water_percentage_estimate');
      this.inputBlur('volume_actual');
      this.inputBlur('volume_estimate');
      if (!this.okToSave_h()) {
        return;
      }
      this.savebtn = true;
      var tempStartDateTime = new Date((this.newHaul.haul_start_datetime + " " + this.newHaul.haul_start_time).replace(/-/g, "/"));
      var tempEndDateTime = new Date((this.newHaul.haul_end_datetime + " " + this.newHaul.haul_end_time).replace(/-/g, "/"));

      var haul_start_datetime = String(tempStartDateTime.getFullYear()) + "-" + ("0" + String(tempStartDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempStartDateTime.getDate())).slice(-2) + " " + tempStartDateTime.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });
      var haul_end_datetime = String(tempEndDateTime.getFullYear()) + "-" + ("0" + String(tempEndDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempEndDateTime.getDate())).slice(-2) + " " + tempEndDateTime.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });

      var saveData = {
        "energy_companies_id": String(this.newHaul.energy_companies_id),
        "users_id": String(this.newHaul.user_id),
        "fluid_type_id": String(this.newHaul.fluid_type_id),
        "load_location_id": String(this.newHaul.load_location_id),
        "unload_location_id": String(this.newHaul.unload_location_id),
        "truck_id": String(this.newHaul.truck_id),
        "trucks_unit_id": String(this.newHaul.truck_unit_id),
        "haul_start_datetime": haul_start_datetime,
        "haul_end_datetime": haul_end_datetime,
        "volume_estimate": String(this.newHaul.volume_estimate),
        "volume_actual": String(this.newHaul.volume_actual),
        "water_percentage_estimate": String(this.newHaul.water_percentage_estimate),
        "water_percentage_actual": String(this.newHaul.water_percentage_actual),
        "terminal_ticket": String(this.newHaul.t_ticket),
        "truck_ticket": String(this.newHaul.ticket),
        "terminal_boss_ticket_id": String(this.newHaul.t_boss),
        "chain_up_required": this.newHaul.chain_up,
        "total_distance": "0",
        "comments_start": String(this.newHaul.comments_start),
        "comments_end": String(this.newHaul.comments_end),
        "waypoints": "",
        "trip_pictures": "",
        "wait_times": this.newHaul.wait_times.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            time: _this11.hmsToSecondsOnly(item.time)
          });
        })
      };
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].save(saveData).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this11.newEC = false;
            _this11.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.newHaul[variableName];
      if (variableValue.length == 0) {
        this.newHaul[variableName] = "0.00";
      } else {
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {
          this.newHaul[variableName] = String(variableValue) + ".00";
        } else if (tempValue.length == 2) {
          this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
        }
      }
    },
    get_trucking_companies: function get_trucking_companies() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].get_trucking_hauls().then(function (data) {
        if (data.status == 'success') {
          _this12.insert_data = data.insert_data;
          var trucking_companies = _this12.insert_data.trucking_companies;
          if (_this12.role == 'super_admin') {

            _this12.newHaul.truck_company_select = trucking_companies.map(function (item) {
              return {
                'value': item.id,
                'text': item.name
              };
            });
          } else if (_this12.role == 'trucking_company_admin' || _this12.role == 'trucking_operational_manager') {
            if (trucking_companies.length > 0) {
              _this12.newHaul.truck_company_id = trucking_companies[0].id;

              var drivers = trucking_companies[0]['drivers'];

              _this12.newHaul.driver_select = drivers.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.name
                };
              });
              var trucks = trucking_companies[0]['trucks'];
              _this12.newHaul.truck_select = trucks.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.truck_name
                };
              });
              var truck_units = trucking_companies[0]['truck_units'];
              _this12.newHaul.truck_unit_select = truck_units.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.truck_unit
                };
              });
              if (_this12.newHaul.truck_unit_select.length == 1) {
                _this12.newHaul.truck_unit = _this12.newHaul.truck_select[0].text;
                _this12.newHaul.truck_unit_id = _this12.newHaul.truck_select[0].value;
              }

              if (_this12.newHaul.driver_select.length == 1) {
                _this12.newHaul.full_name = _this12.newHaul.driver_select[0].text;
                _this12.newHaul.user_id = _this12.newHaul.driver_select[0].value;
              }
              if (_this12.newHaul.truck_select.length == 1) {
                _this12.newHaul.truck = _this12.newHaul.truck_select[0].text;
                _this12.newHaul.truck_id = _this12.newHaul.truck_select[0].value;
              }
            }
          }
        } else {
          _this12.$swal(data.status, data.message, data.status);
        }
      }).catch(function (error) {
        _this12.$swal('Error', 'Server not response. ' + error, 'error');
      });
    },
    selects_trucking_company: function selects_trucking_company() {

      if (this.role == 'super_admin') {
        this.newHaul.user_id = '';
        this.newHaul.full_name = '';
        this.newHaul.truck_id = '';
        this.newHaul.truck = '';
        this.newHaul.truck_unit_id = '';
        this.newHaul.truck_unit = '';
        var trucking_companies = this.insert_data.trucking_companies;

        var current_truck_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.truck_company_id);
        if (current_truck_company_index > -1) {
          var drivers = trucking_companies[current_truck_company_index]['drivers'];
          this.newHaul.driver_select = drivers.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
          var trucks = trucking_companies[current_truck_company_index]['trucks'];
          this.newHaul.truck_select = trucks.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_name
            };
          });
          var truck_units = trucking_companies[current_truck_company_index]['truck_units'];
          this.newHaul.truck_unit_select = truck_units.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_unit
            };
          });
          if (this.newHaul.truck_unit_select.length == 1) {
            this.newHaul.truck_unit = this.newHaul.truck_select[0].text;
            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value;
          }

          if (this.newHaul.driver_select.length == 1) {
            this.newHaul.full_name = this.newHaul.driver_select[0].text;
            this.newHaul.user_id = this.newHaul.driver_select[0].value;
          }
          if (this.newHaul.truck_select.length == 1) {
            this.newHaul.truck = this.newHaul.truck_select[0].text;
            this.newHaul.truck_id = this.newHaul.truck_select[0].value;
          }
        }
      } else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {

        this.newHaul.user_id = '';
        this.newHaul.full_name = '';
        this.newHaul.truck_id = '';
        this.newHaul.truck = '';
        this.newHaul.truck_unit_id = '';
        this.newHaul.truck_unit = '';
        if (this.insert_data.trucking_companies.length > 0) {
          var _trucking_companies = this.insert_data.trucking_companies;
          this.newHaul.truck_company_id = _trucking_companies[0].id;
          var _drivers = _trucking_companies[0]['drivers'];
          this.newHaul.driver_select = _drivers.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
          var _trucks = _trucking_companies[0]['trucks'];
          this.newHaul.truck_select = _trucks.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_name
            };
          });
          var _truck_units = _trucking_companies[0]['truck_units'];
          this.newHaul.truck_unit_select = _truck_units.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_unit
            };
          });
          if (this.newHaul.truck_unit_select.length == 1) {
            this.newHaul.truck_unit = this.newHaul.truck_select[0].text;
            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value;
          }

          if (this.newHaul.driver_select.length == 1) {
            this.newHaul.full_name = this.newHaul.driver_select[0].text;
            this.newHaul.user_id = this.newHaul.driver_select[0].value;
          }
          if (this.newHaul.truck_select.length == 1) {
            this.newHaul.truck = this.newHaul.truck_select[0].text;
            this.newHaul.truck_id = this.newHaul.truck_select[0].value;
          }
        }
      }
    },
    selects_energy_company: function selects_energy_company() {
      this.newHaul.load_location_select = [];
      this.newHaul.load_location = '';
      this.newHaul.load_location_id = '';
      var trucking_companies = this.insert_data.trucking_companies;

      var current_truck_company_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.truck_company_id);
      if (current_truck_company_index > -1) {
        var drivers = trucking_companies[current_truck_company_index]['drivers'];
        var drivers_index = drivers.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.user_id);
        if (drivers_index > -1) {
          var energycompanies = drivers[drivers_index]['energy_companies'];
          var energy_company_index = energycompanies.map(function (o) {
            return o.id;
          }).indexOf(this.newHaul.energy_companies_id);
          this.getLoadLocation(energycompanies[energy_company_index].id, drivers[drivers_index].id);
        }
      }
    },
    getLoadLocation: function getLoadLocation(energy_company_id, driver_id) {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getLoadLocation(energy_company_id, driver_id).then(function (data) {
        if (data['status'] == 'success') {
          _this13.loads_locations = data['load_locations'];
          _this13.newHaul.load_location_select = _this13.loads_locations.map(function (item) {
            return {
              'value': item.id,
              'text': item.legal_location
            };
          });
          if (_this13.newHaul.load_location_select.length == 1) {
            _this13.newHaul.load_location = _this13.newHaul.load_location_select[0].text;
            _this13.newHaul.load_location_id = _this13.newHaul.load_location_select[0].value;
          }
        } else {
          _this13.$swal(data[0], data[1], data[0]);
        }
        _this13.loadingData = false;
      }).catch(function (error) {
        _this13.$swal('Error', 'Server not response. ' + error, 'error');
        _this13.loadingData = false;
      });
    },
    selects_driver: function selects_driver() {
      this.newHaul.energy_companies_id = '';
      this.newHaul.energy_company = '';
      this.newHaul.unload_location_select = [];
      this.newHaul.unload_location = '';
      this.newHaul.unload_location_id = '';

      var trucking_companies = this.insert_data.trucking_companies;
      var current_truck_company_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.truck_company_id);
      if (current_truck_company_index > -1) {
        var drivers = trucking_companies[current_truck_company_index]['drivers'];
        var drivers_index = drivers.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.user_id);
        var energycompanies = drivers[drivers_index]['energy_companies'];
        this.newHaul.energy_company_select = energycompanies.map(function (item) {
          return {
            'value': item.id,
            'text': item.company_name
          };
        });
        this.getUnloadLocation(drivers[drivers_index].id);
      }
    },
    getUnloadLocation: function getUnloadLocation(driver_id) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getUnloadLocation(driver_id).then(function (data) {
        if (data['status'] == 'success') {
          var loads_locations = data['unload_locations'];
          _this14.newHaul.unload_location_select = loads_locations.map(function (item) {
            return {
              'value': item.id,
              'text': item.legal_location
            };
          });
        } else {
          _this14.$swal(data[0], data[1], data[0]);
        }
        _this14.loadingData = false;
      }).catch(function (error) {
        _this14.$swal('Error', 'Server not response. ' + error, 'error');
        _this14.loadingData = false;
      });
    },
    selects_load_location: function selects_load_location() {

      this.newHaul.fluid_type_select = [];
      this.newHaul.fluid_type = '';
      this.newHaul.fluid_type_id = '';
      var loads_locations = this.loads_locations;
      var loads_locations_index = loads_locations.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.load_location_id);
      if (loads_locations_index > -1) {
        var fluid_types = loads_locations[loads_locations_index]['fluids'];
        this.newHaul.fluid_type_select = fluid_types.map(function (item) {
          return {
            'value': item.id,
            'text': item.name
          };
        });
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.newHaul[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.newHaul[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    approvedFilter: function approvedFilter(apr_filter) {
      if (this.role == 'super_admin' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        var itemsO = this.itemsAll;
        this.Approved = apr_filter;
        if (apr_filter === 'Approved') {
          var result = itemsO.filter(function (item) {
            return item.trucking_company_approved == true;
          });
          this.items = result;
        } else if (apr_filter === 'Unapproved') {
          var _result = itemsO.filter(function (item) {
            return item.trucking_company_unapproved == true;
          });
          this.items = _result;
        } else {
          this.items = this.itemsAll;
          this.haul_ids = [];
          this.Approved = 'Show Approved';
        }
      }
    },
    h_approved_click: function h_approved_click() {
      var _this15 = this;

      var model = {
        command: 'approved',
        approved: this.haul_ids
      };
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].HaulsApproved(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this15.getAll();
          _this15.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    h_deapproved_click: function h_deapproved_click() {
      var _this16 = this;

      var model = {
        command: 'unapproved',
        unapproved: this.haul_ids
      };
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].HaulsApproved(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this16.getAll();
          _this16.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    h_unasigned_click: function h_unasigned_click() {
      var _this17 = this;

      var model = {
        command: 'unasigned',
        unasigned: this.haul_ids
      };
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_5__invoices_service__["a" /* default */].HaulsUnasigned(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this17.getAll();
          _this17.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    keyMonitor1: function keyMonitor1(evt) {
      if (evt.key.match(/[a-zA-Z0-9]/i) === null) {
        evt.preventDefault();
        return;
      } else {
        evt = evt ? evt : window.event;
        var key = evt.key;
        if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
          return;
        } else if (key == "Backspace") {
          var filter_txt = this.newHaul.t_ticket;
          var nn = filter_txt.length - 1;
          if (nn > 0) {
            this.newHaul.t_ticket = filter_txt.substring(0, nn);
            return;
          } else {
            this.newHaul.t_ticket = '';
            return;
          }
        } else if (key == "Delete") {
          return;
        } else {

          var _filter_txt = this.newHaul.t_ticket;
          var _nn = _filter_txt.length;
          if (_nn < 10) {
            _filter_txt = _filter_txt + key;
            this.newHaul.t_ticket = _filter_txt;
          } else {
            evt.preventDefault();
          }
          return;
        }
      }
    },
    keyMonitor: function keyMonitor(evt) {
      if (evt.key.match(/[a-zA-Z0-9]/i) === null) {
        evt.preventDefault();
        return;
      } else {
        evt = evt ? evt : window.event;
        var key = evt.key;
        if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
          return;
        } else if (key == "Backspace") {
          var filter_txt = this.newHaul.ticket;
          var nn = filter_txt.length - 1;
          if (nn > 0) {
            this.newHaul.ticket = filter_txt.substring(0, nn);
            return;
          } else {
            this.newHaul.ticket = '';
            return;
          }
        } else if (key == "Delete") {
          return;
        } else {

          var _filter_txt2 = this.newHaul.ticket;
          var _nn2 = _filter_txt2.length;
          if (_nn2 < 10) {
            _filter_txt2 = _filter_txt2 + key;
            this.newHaul.ticket = _filter_txt2;
          } else {
            evt.preventDefault();
          }
          return;
        }
      }
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notification_service__ = __webpack_require__(590);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestNotifications',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      loadingData: true,
      newModal: false,
      items: items,
      totalRows: items.length,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      trash: false,
      dpdt: 'Active',
      role: '',
      savebtn: true,
      filter: null,

      fields: [{
        key: 'id',
        label: 'Id',
        sortable: true
      }, {
        key: 'energy_company_name',
        label: 'Energy Company Name',
        sortable: true
      }, {
        key: 'email',
        label: 'Email',
        sortable: true
      }, {
        key: 'activate',
        label: 'Activated'
      }],

      model: {
        id: null,
        energy_company_id: null,
        email: '',
        activate: true
      },
      company_name: []

    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];
      __WEBPACK_IMPORTED_MODULE_2__notification_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this.items = data.notif.filter(function (o) {
            return o.status_id == (_this.trash ? 2 : 1);
          });
          _this.company_name = data.energy_companies;
          _this.role = data.role;
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    hideNewModal: function hideNewModal() {
      this.$refs.newModal.hide();
    },
    showNewModal: function showNewModal() {
      this.savebtn = false;
      this.model.energy_company_id = '';
      this.model.email = '';
      this.model.activate = true;
      this.newModal = true;
    },
    okToSave: function okToSave() {

      if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.model.email === undefined || this.model.email == '') {
        this.$swal('Alert!', 'Email can not be empty', 'warning');
        return false;
      }
      return true;
    },
    save_click: function save_click() {
      var _this2 = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      __WEBPACK_IMPORTED_MODULE_2__notification_service__["a" /* default */].save(this.model).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this2.newModal = false;
            _this2.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },

    isLowerCaseEmail: function isLowerCaseEmail(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 122) {
        return true;
      } else {
        if (charCode == 45 || charCode == 46 || charCode == 64 || charCode == 95 || charCode == 8 || charCode == 9) {
          return true;
        } else {
          evt.preventDefault();
        }
      }
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/request_haul_notification/' + row.id + "/");
      } else {
        this.restore(row.id);
      }
    },
    trash_click: function trash_click() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    restore: function restore(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Request Notification?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__notification_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
              _this3.dpdt = 'Active';
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls_notification/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls_notification/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls_notification/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls_notification/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls_notification/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/request_hauls_notification/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_service__ = __webpack_require__(590);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Request-Notification',
	created: function created() {
		this.get_Data();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			updateData: null,
			originalData: null,
			loadingData: true,
			IIdd: null,
			role: '',
			model: {
				id: null,
				energy_company_name: '',
				energy_company_id: null,
				email: '',
				activate: true
			},
			company_name: []
		};
	},

	methods: {
		edit_e: function edit_e() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
			console.log(this.model);
		},
		setupFields: function setupFields() {
			console.log('setup');
		},
		get_Data: function get_Data() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__notification_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.notif;
					_this.company_name = data.energy_companies;
					_this.IIdd = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.energy_company_name;
					_this.role = data.role;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
				this.$swal('Alert!', 'Energy Company not selected', 'warning');
				return false;
			} else if (this.model.email === undefined || this.model.email == '') {
				this.$swal('Alert!', 'Email can not be empty', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_1__notification_service__["a" /* default */].update(this.IIdd, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.get_Data();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		delete_d: function delete_d(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this " + this.$options.name + "?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__notification_service__["a" /* default */].delete(_this3.IIdd).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/request_haul_notifications');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},

		isLowerCaseEmail: function isLowerCaseEmail(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 122) {
				return true;
			} else {
				if (charCode == 45 || charCode == 46 || charCode == 64 || charCode == 95 || charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			}
		}
	}
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notification_service__ = __webpack_require__(593);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvoiceNotifications',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      loadingData: true,
      newModal: false,
      items: items,
      totalRows: items.length,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      trash: false,
      dpdt: 'Active',
      role: '',
      savebtn: true,
      filter: null,

      fields: [{
        key: 'id',
        label: 'Id',
        sortable: true
      }, {
        key: 'energy_company_name',
        label: 'Energy Company Name',
        sortable: true
      }, {
        key: 'trucking_company_name',
        label: 'Trucking Company Name',
        sortable: true
      }, {
        key: 'email',
        label: 'Email',
        sortable: true
      }],

      model: {
        id: null,
        energy_company_id: null,
        trucking_company_id: null,
        email: ''
      },
      company_name: [],
      energy_companies: []
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];
      __WEBPACK_IMPORTED_MODULE_2__notification_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this.items = data.notif.filter(function (o) {
            return o.status_id == (_this.trash ? 2 : 1);
          });
          _this.company_name = data.trucking_companies;
          _this.role = data.role;
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    hideNewModal: function hideNewModal() {
      this.$refs.newModal.hide();
    },
    showNewModal: function showNewModal() {
      this.savebtn = false;
      this.model.energy_company_id = null;
      this.model.trucking_company_id = null;
      this.model.email = '';
      this.newModal = true;
    },
    okToSave: function okToSave() {

      if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.model.trucking_company_id === undefined || this.model.trucking_company_id === null) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.model.email === undefined || this.model.email == '') {
        this.$swal('Alert!', 'Email can not be empty', 'warning');
        return false;
      }
      return true;
    },
    save_click: function save_click() {
      var _this2 = this;

      if (!this.okToSave()) {
        return;
      }
      this.savebtn = true;
      __WEBPACK_IMPORTED_MODULE_2__notification_service__["a" /* default */].save(this.model).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this2.newModal = false;
            _this2.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },

    isLowerCaseEmail: function isLowerCaseEmail(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 122) {
        return true;
      } else {
        if (charCode == 45 || charCode == 46 || charCode == 64 || charCode == 95 || charCode == 8 || charCode == 9) {
          return true;
        } else {
          evt.preventDefault();
        }
      }
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/invoice_haul_notification/' + row.id + "/");
      } else {
        this.restore(row.id);
      }
    },
    trash_click: function trash_click() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    restore: function restore(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Invoice Notification?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2__notification_service__["a" /* default */].restore(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
              _this3.dpdt = 'Active';
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    selects_trucking_company: function selects_trucking_company() {
      var trucking_companies = this.company_name;
      this.energy_companies = [];
      this.model.energy_company_id = null;
      if (trucking_companies.length > 0) {
        var trucking_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.model.trucking_company_id);
        if (trucking_company_index > -1) {
          this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
        }
      }
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_notification/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_notification/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_notification/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_notification/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_notification/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTerminal, model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/invoice_hauls_notification/update/' + idTerminal + '/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_service__ = __webpack_require__(593);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Invoice Notification',
	created: function created() {
		this.get_Data();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			updateData: null,
			originalData: null,
			loadingData: true,
			IIdd: null,
			role: '',
			model: {
				id: null,
				energy_company_name: '',
				energy_company_id: null,
				trucking_company_name: '',
				trucking_company_id: null,
				email: ''
			},
			company_name: [],
			energy_companies: []
		};
	},

	methods: {
		edit_e: function edit_e() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		setupFields: function setupFields() {
			var trucking_companies = this.company_name;
			this.energy_companies = [];
			if (trucking_companies.length > 0) {
				var trucking_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.trucking_company_id);
				if (trucking_company_index > -1) {
					this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
				}
			}
		},
		get_Data: function get_Data() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__notification_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.notif;
					_this.company_name = data.trucking_companies;
					_this.IIdd = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.originalData.energy_company_name;
					_this.role = data.role;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
				this.$swal('Alert!', 'Energy Company not selected', 'warning');
				return false;
			} else if (this.model.trucking_company_id === undefined || this.model.trucking_company_id === null) {
				this.$swal('Alert!', 'Trucking Company not selected', 'warning');
				return false;
			} else if (this.model.email === undefined || this.model.email == '') {
				this.$swal('Alert!', 'Email can not be empty', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_1__notification_service__["a" /* default */].update(this.IIdd, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					_this2.get_Data();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		delete_d: function delete_d(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this " + this.$options.name + "?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__notification_service__["a" /* default */].delete(_this3.IIdd).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/invoice_haul_notifications');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},

		isLowerCaseEmail: function isLowerCaseEmail(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 122) {
				return true;
			} else {
				if (charCode == 45 || charCode == 46 || charCode == 64 || charCode == 95 || charCode == 8 || charCode == 9) {
					return true;
				} else {
					evt.preventDefault();
				}
			}
		},
		selects_trucking_company: function selects_trucking_company() {
			var trucking_companies = this.company_name;
			this.energy_companies = [];
			this.model.energy_company_id = null;
			if (trucking_companies.length > 0) {
				var trucking_company_index = trucking_companies.map(function (o) {
					return o.id;
				}).indexOf(this.model.trucking_company_id);
				if (trucking_company_index > -1) {
					this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
				}
			}
		}
	}
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trucks_service__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trucking_companies_tc_service__ = __webpack_require__(40);




var items = [];
var truckingCompanies = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TrucksUnits',
	created: function created() {
		this.getAll();
	},
	data: function data() {
		return {
			insert_data: null,
			trash: false,
			dpdt: 'Active',
			model: {
				truck_unit: '',
				trucking_company_id: null
			},
			truckingcompaniesselect: [],
			newTruck: false,
			items: items,

			loadingData: true,
			currentPage: 0,
			perPage: 25,
			totalRows: items.length,
			pageOptions: [25, 50, 100],
			sortBy: 'truck_unit',
			sortDesc: false,

			fields: [{
				key: 'id',
				label: 'ID',
				sortable: true
			}, {
				key: 'truck_unit',
				label: 'Truck Unit',
				sortable: true
			}, {
				key: 'trucking_company',
				label: 'Trucking Company'
			}],
			filter: null,
			modalInfo: {
				title: '',
				content: ''
			},
			savebtn: true,
			role: '',
			trucking_company_id: null
		};
	},

	computed: {
		sortOptions: function sortOptions() {
			return this.fields.filter(function (f) {
				return f.sortable;
			}).map(function (f) {
				return {
					text: f.label,
					value: f.key
				};
			});
		}
	},
	methods: {
		newTruckModal: function newTruckModal() {
			this.model = {
				truck_unit: '',
				trucking_company_id: null
			};
			this.savebtn = false;
			this.newTruck = true;
		},
		rowClicked: function rowClicked(row) {
			localStorage.truckPage = this.currentPage;
			if (!this.trash) {
				this.$router.push('/trucks_unit/' + row.id + '/');
			} else {
				this.restoreTruck(row.id);
			}
		},
		onFiltered: function onFiltered(filteredItems) {
			this.currentPage = parseInt(localStorage.truckPage);
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		trashTrucks: function trashTrucks() {
			this.trash = !this.trash;
			this.dpdt = this.trash ? "Trash" : "Active";
			this.getAll();
			this.loadingData = true;
		},
		resetModal: function resetModal() {
			this.modalInfo.title = '';
			this.modalInfo.content = '';
		},
		getAll: function getAll() {
			var _this = this;

			this.loadingData = true;
			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].getAll().then(function (data) {
				if (data[0] == 'success') {
					_this.items = data[1].filter(function (o) {
						return o.status_id == (_this.trash ? 2 : 1);
					});
					_this.insert_data = data[2];
					_this.truckingcompaniesselect = _this.insert_data.trucking_companies;
					_this.role = data[3];
					_this.trucking_company_id = data[4];
				} else {
					_this.items = [];
					_this.$swal(data[0], data[1], data[0]);
				}
				_this.loadingData = false;
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		saveNewTruck: function saveNewTruck() {
			var _this2 = this;

			if (!this.okToSave()) {
				return;
			}
			this.savebtn = true;
			if (this.role == 'trucking_company_admin' || this.role === 'trucking_operational_manager') {
				this.model.trucking_company_id = this.trucking_company_id;
			}
			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].save(this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					if (data[0] == 'success') {
						_this2.newTruck = false;
						_this2.getAll();
					}
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.savebtn = false;
		},
		okToSave: function okToSave() {
			if (this.role == 'super_admin') {
				if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.truck_unit === undefined || this.model.truck_unit.trim().length == 0) {
				this.$swal('Alert!', 'Truck unit can not be empty', 'warning');
				return false;
			}

			return true;
		},
		restoreTruck: function restoreTruck(id) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to restore this Truck unit?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].restore(id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.filter = '';
							_this3.trash = false;
							_this3.getAll();
							_this3.loadingData = true;
							_this3.dpdt = 'Active';
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/trucks_unit/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.trucks, response.data.insert_data, response.data.role, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(idTruck) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_unit/' + idTruck + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.truck, response.data.update_data, response.data.role, response.data.company_id];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(dataTruck) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_unit/create/', dataTruck, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTruck, dataTruck) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_unit/update/' + idTruck + '/', dataTruck, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTruck) {
		console.log('Mi id: ' + idTruck);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_unit/delete/' + idTruck + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTruck) {
		console.log('Mi id: ' + idTruck);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/truck_unit/restore/' + idTruck + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trucks_service__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trucking_companies_tc_service__ = __webpack_require__(40);




var truckingCompanies = [];
var typeTrucks = [];
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TrucksUnit',
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	created: function created() {
		this.getTruckData();
	},
	data: function data() {
		return {
			originalData: null,
			updateData: null,
			edit: false,
			model: {
				truck_unit: '',
				trucking_company_id: null
			},
			truckingcompaniesselect: [],
			subTitle: '',

			selectedTC: null,
			selectedType: null,
			loadingData: true,
			truckingCompanies: [],
			tabIndex: 0,
			found: false,
			notFoundMessage: 'Not found',
			role: '',
			view: true,
			trucking_company_id: ''
		};
	},

	methods: {
		restoreOriginalData: function restoreOriginalData() {
			this.model = {
				trucking_company: this.originalData.trucking_company,
				trucking_company_id: this.originalData.trucking_company_id,
				truck_unit: this.originalData.truck_unit
			};
		},
		setupFields: function setupFields() {},
		editTruck: function editTruck() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.setupFields();
				this.edit = true;
			}
		},
		getTruckData: function getTruckData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data[0] === 'success') {
					_this.originalData = data[1];
					_this.updateData = data[2];
					_this.subTitle = _this.originalData.truck_unit;
					_this.truckingcompaniesselect = _this.updateData.trucking_companies;
					_this.restoreOriginalData();

					_this.found = true;
					_this.loadingData = false;

					_this.role = data[3];
					console.log(_this.role);
					_this.trucking_company_id = data[4];
				} else {
					_this.$swal(data[0], data[1], data[0]);
					_this.found = true;
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.role == 'super_admin') {
				if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning');
					return false;
				}
			}
			if (this.model.truck_unit === undefined || this.model.truck_unit.trim().length == 0) {
				this.$swal('Alert!', 'Truck Unit can not be empty', 'warning');
				return false;
			}

			return true;
		},
		updateTruck: function updateTruck() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			if (this.role == 'trucking_company_admin' || this.role === 'trucking_operational_manager') {
				this.model.trucking_company_id = this.trucking_company_id;
			}

			__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].update(this.id, this.model).then(function (data) {
				_this2.$swal(data[0], data[1], data[0]).then(function (result) {
					if (data[0] == 'success') {
						_this2.getTruckData();
					}
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTruck: function deleteTruck() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Truck unit: " + this.subTitle + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_0__trucks_service__["a" /* default */].delete(_this3.id).then(function (data) {
						_this3.$swal(data[0], data[1], data[0]);
						if (data[0] == 'success') {
							_this3.$router.replace('/trucks_units');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		getTruckingCompanies: function getTruckingCompanies() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1__trucking_companies_tc_service__["a" /* default */].getAll().then(function (data) {
				_this4.truckingCompanies = [];
				var tc_items = data.length;
				for (var i = 0; i < tc_items; i++) {
					_this4.truckingCompanies.push({
						'value': data[1][i].id,
						'label': data[1][i].name
					});
				}
			});
		}
	}
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__receipt_service__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Altex',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      row: 0,
      loadingData: true,
      configTable: false,

      items: items,
      totalRows: items.length,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'haul_id',
        label: 'Haul ID',
        sortable: true
      }, {
        key: 'truck_ticket',
        label: 'Truck Ticket',
        sortable: true
      }, {
        key: 'result',
        label: 'Reason'
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      role: '',
      bbll: false,
      myToggle: false,

      filename: 'altex' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "id": "id",
        "haul_id": "haul_id",
        "truck_ticket": "truck_ticket",
        'result': 'result'
      },
      items_csv: []
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];

      __WEBPACK_IMPORTED_MODULE_2__receipt_service__["a" /* default */].get_altex_hauls().then(function (data) {
        if (data.status == 'success') {
          _this.items = data.hauls;
          _this.items_csv = _this.items;
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    rowClicked: function rowClicked(row, index, e) {
      console.log('click');
      e.preventDefault();
      var to_popup = { 'id': row.haul_id, 'haul_invoice': false, 'edit': '' };
      this.$root.$emit('openPopup', to_popup);
    },
    bbl: function bbl() {
      var _this2 = this;

      users_service.bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this2.loadingData = true;
            _this2.getAll();
          }
        });
      });
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export applyDrag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intraday_service__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_smooth_dnd__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highcharts__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_highcharts__);









__WEBPACK_IMPORTED_MODULE_5_highcharts___default.a.SVGRenderer.prototype.symbols.target = function (x, y, w, h, options) {
  w = w;
  return ["M", x + w / 2 + (options.width + 4), y + h / 2 + (options.overlap ? 2 : 0), "L", x + w / 2 - (options.width + 4), y + h / 2 + (options.overlap ? 2 : 0), "z"];
};
if (__WEBPACK_IMPORTED_MODULE_5_highcharts___default.a.VMLRenderer) {
  __WEBPACK_IMPORTED_MODULE_5_highcharts___default.a.VMLRenderer.prototype.symbols.target = __WEBPACK_IMPORTED_MODULE_5_highcharts___default.a.SVGRenderer.prototype.symbols.target;
}

var applyDrag = function applyDrag(arr, dragResult) {
  var removedIndex = dragResult.removedIndex,
      addedIndex = dragResult.addedIndex,
      payload = dragResult.payload;

  if (removedIndex === null && addedIndex === null) return arr;

  var result = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(arr));
  var itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};
var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "intraday_report",
  components: {
    Container: __WEBPACK_IMPORTED_MODULE_3_vue_smooth_dnd__["Container"],
    Draggable: __WEBPACK_IMPORTED_MODULE_3_vue_smooth_dnd__["Draggable"],
    highcharts: __WEBPACK_IMPORTED_MODULE_4_highcharts_vue__["Chart"]
  },
  props: {},
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      loadingData: true,
      subTitle: "",
      locacations_data: {},
      newTC: false,
      to_send: 0,
      to_send_data: {
        "site": { "id": 0 },
        "site_name": '',
        "amount": 0,
        "trucking_company": null,
        "terminal": null,
        "index": 0
      },
      trucking_companies: [],
      terminals: [],
      sign: 'm3/+',
      no_detail: true,
      loc: {
        "name": '',
        "volumeChanges": [],
        "current": 0,
        "low": 0,
        "high": 0,
        "pro": 0,
        "ht": 0,
        "haulsRequested": 0,
        "haulsDelivered": 0,
        "rem": 0,
        "percentage": 0

      },
      maps_truckco: [{ "name": 'S.O.R.E. Oilfield Services Inc.', "map": 'SORE' }, { "name": 'CRUDE MASTER TRANSPORT INC.', "map": 'CMT' }, { "name": 'Torq Trucking', "map": 'TORQ' }],
      volume_change: [],
      view: false,
      site_levels: {},
      index_1: null

    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_2__intraday_service__["a" /* default */].getLocationsIndicatorsData().then(function (data) {
        if (data.status == "success") {
          _this.locacations_data = data.locations_indicator;
          _this.site_levels = data.site_levels;
          _this.loadingData = false;
          _this.view = data.view;
        } else {
          _this.loadingData = false;
          _this.view = false;
        }
      }).catch(function (error) {
        _this.$swal("Error", "Server not response. " + error, "error");
        _this.loadingData = false;
        _this.view = false;
      });
    },
    getCardPayload: function getCardPayload(columnId) {
      var _this2 = this;

      return function (index) {
        return _this2.locacations_data.locations[index];
      };
    },
    onCardDrop: function onCardDrop(columnId, dropResult) {
      var tmp = applyDrag(this.locacations_data.locations, dropResult);

      this.locacations_data.locations = tmp;
    },
    shouldAcceptDropDesktop: function shouldAcceptDropDesktop(sourceContainerOptions, payload) {
      return true;
    },
    shouldAnimateDropDesktop: function shouldAnimateDropDesktop(sourceContainerOptions, payload) {
      return false;
    },
    log: function log(e) {},
    getStateVariant: function getStateVariant(state) {
      var s = String(state).toLowerCase();
      if (s === "good") return "success";else if (s === "low") return "warning";else return "danger";
    },
    chartOptions: function chartOptions(index) {
      var _this4 = this;

      var opts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__intraday_service__["a" /* default */].getChartConfig()));
      var bands_colors = ["#D9602F", "#FFD966", "#76716F", "#FFD966", "#D9602F"];
      opts.yAxis = {
        labels: {
          format: "{value}"
        },
        title: null
      };

      opts.tooltip.formatter = function () {
        var _this3 = this;

        var tooltips = "";
        this.series.chart.series.forEach(function (serie) {
          if (Math.abs(_this3.point.y - serie.processedYData[_this3.point.index]) < 7) {
            tooltips += (tooltips.length ? "<br>" : "") + '<span style="color:' + serie.color + "\">\u25CF</span> " + serie.name + ": " + "<b>" + serie.processedYData[_this3.point.index] + "m<sup>3</sup></b>";
          }
        });
        return tooltips;
      };
      if (this.locacations_data.locations[index].ranges.length) {
        opts.yAxis.plotBands = [];
        this.locacations_data.locations[index].ranges.forEach(function (range, i) {
          opts.yAxis.plotBands.push({
            from: range.lowerLimit,
            to: i == _this4.locacations_data.locations[index].ranges.length - 1 ? 9e9 : range.upperLimit,
            color: bands_colors[i]
          });
          if (i === 0) {
            opts.yAxis.min = range.lowerLimit;
          }
          if (i !== 0 && i == _this4.locacations_data.locations[index].ranges.length - 1) {
            opts.yAxis.max = range.upperLimit;
          }
        });
      }
      opts.series = [{
        name: "Low",
        data: [this.locacations_data.locations[index].low],
        color: "#364A8A",
        marker: {
          lineColor: "#364A8A"
        }
      }, {
        name: "High",
        data: [this.locacations_data.locations[index].high],
        color: "#364A8A",
        marker: {
          lineColor: "#364A8A"
        }
      }, {
        name: "EOD",
        data: [this.locacations_data.locations[index].eod],
        color: "#6FA64B",
        marker: {
          lineColor: "#6FA64B"
        }
      }, {
        name: "Current",
        data: [this.locacations_data.locations[index].current],
        color: "#FFD966",
        marker: {
          lineColor: "#FFD966"
        }
      }];

      opts.series.forEach(function (serie, i, series) {
        if (i > 0) {
          var j = series.findIndex(function (e) {
            return Math.abs(serie.data[0] - e.data[0]) < 6;
          });
          if (j != i && j < i) {
            opts.series[i].marker.overlap = true;
          }
        }
      });

      return opts;
    },
    date_format: function date_format(in_datetime) {
      var today = new Date(in_datetime);
      var todayLess = new Date(today - 360 * 60000);
      return moment(today).format("YYYY/MM/DD HH:mm:ss");
    },
    date_format1: function date_format1(in_datetime) {
      var today = new Date(in_datetime);
      var todayLess = new Date(today - 360 * 60000);
      return moment(today).format("MMM DD hh:mma");
    },
    add: function add(index) {
      this.locacations_data.locations[index].preview = true;
      this.locacations_data.locations[index].inc_1++;
      this.locacations_data.locations[index].inc = 35 * this.locacations_data.locations[index].inc_1;
      if (this.locacations_data.locations[index].inc_1 == 0) {
        this.locacations_data.locations[index].preview = false;
      } else if (this.locacations_data.locations[index].inc_1 > 0) {
        this.sign = 'm3/+';
      } else {
        this.sign = 'm3/';
      }
    },
    minus: function minus(index) {
      this.locacations_data.locations[index].preview = true;
      this.locacations_data.locations[index].inc_1--;
      this.locacations_data.locations[index].inc = 35 * this.locacations_data.locations[index].inc_1;
      if (this.locacations_data.locations[index].inc_1 == 0) {
        this.locacations_data.locations[index].preview = false;
      } else if (this.locacations_data.locations[index].inc_1 > 0) {
        this.sign = 'm3/+';
      } else {
        this.sign = 'm3/';
      }
    },
    confirm: function confirm(index) {
      if (this.locacations_data.locations[index].inc != 0) {
        this.newTC = true;
        this.to_send = this.locacations_data.locations[index].inc;
        this.to_send_data.amount = this.locacations_data.locations[index].inc_1;
        this.to_send_data.site["id"] = this.locacations_data.locations[index].id;
        this.to_send_data.site_name = this.locacations_data.locations[index].name;
        this.to_send_data.index = index;
        if (this.locacations_data.locations[index].truckCos.length > 0) {
          this.trucking_companies = this.locacations_data.locations[index].truckCos.map(function (item) {
            return { text: item, value: item };
          });
        } else {
          this.trucking_companies = [];
        }
        if (this.locacations_data.locations[index].terminals.length > 0) {
          this.terminals = this.locacations_data.locations[index].terminals.map(function (item) {
            return { text: item, value: item };
          });
        } else {
          this.terminals = [];
        }
      }
    },
    okTo: function okTo() {
      if (this.to_send_data.trucking_company == null) {
        this.$swal('Alert!', 'Trucking company not selected', 'warning');
        return false;
      }
      if (this.to_send_data.terminal == null) {
        this.$swal('Alert!', 'Terminal not selected', 'warning');
        return false;
      }
      return true;
    },
    confirm_to: function confirm_to() {
      var _this5 = this;

      if (!this.okTo()) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__intraday_service__["a" /* default */].send_volumeChange(this.to_send_data).then(function (data) {
        _this5.$swal(data.status, data.message, data.status);
      }).catch(function (error) {
        _this5.$swal("Error", "Server not response. " + error, "error");
      });
      this.locacations_data.locations[this.to_send_data.index].inc_1 = 0;
      this.locacations_data.locations[this.to_send_data.index].inc = 0;
      this.locacations_data.locations[this.to_send_data.index].preview = false;
      this.cancel();
    },
    cancel: function cancel() {
      this.newTC = false;
      this.to_send_data = {
        "site": { "id": 0 },
        "site_name": '',
        "amount": 0,
        "trucking_company": null,
        "terminal": null,
        "index": 0
      };
    },
    detail: function detail(index) {
      this.loc.name = this.locacations_data.locations[index].name;
      this.loc.volumeChanges = this.locacations_data.locations[index].volumeChanges;

      this.loc.current = this.locacations_data.locations[index].current;
      this.loc.low = this.locacations_data.locations[index].low;
      this.loc.high = this.locacations_data.locations[index].high;
      this.loc.pro = this.locacations_data.locations[index].pro;
      this.loc.ht = this.locacations_data.locations[index].ht;
      this.loc.haulsRequested = this.locacations_data.locations[index].haulsRequested;
      this.loc.haulsDelivered = this.locacations_data.locations[index].haulsDelivered;
      this.loc.rem = this.locacations_data.locations[index].rem;
      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.locacations_data.locations[index].ranges.map(function (o) {
        return o.upperLimit;
      })).concat([0]));
      this.loc.percentage = Math.round(this.loc.current / max * 100, 2);
      this.no_detail = false;
      this.volume_change = [];
      var item = { "item": "Volume",
        "add": this.locacations_data.locations[index].requested.addVolume,
        "cut": this.locacations_data.locations[index].requested.cutVolume,
        "total": this.locacations_data.locations[index].requested.addVolume - this.locacations_data.locations[index].requested.cutVolume,
        "pending": this.locacations_data.locations[index].pending.volume };
      this.volume_change.push(item);
      var item1 = { "item": "Trucks",
        "add": this.locacations_data.locations[index].requested.addCount,
        "cut": this.locacations_data.locations[index].requested.cutCount,
        "total": this.locacations_data.locations[index].requested.addCount - this.locacations_data.locations[index].requested.cutCount,
        "pending": this.locacations_data.locations[index].pending.count };
      this.volume_change.push(item1);
      this.index_1 = index;
    },
    map_tc: function map_tc(tc, items) {
      var index = items.map(function (o) {
        return o.name;
      }).indexOf(tc);
      var map_f = tc;
      if (index > -1) {
        map_f = items[index].map;
      }
      return map_f;
    },
    map_terminal: function map_terminal(tc) {
      var index = tc.split(" ");
      var map_f = '';
      if (index.length > 1) {
        map_f = index[1];
      } else if (index.lenght == 1) {
        map_f = index[0];
      }
      return map_f;
    },
    chartOptions1: function chartOptions1(percentage) {
      var opts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__intraday_service__["a" /* default */].getChartConfig()));
      var bands_colors = ["#D9602F", "#00D966"];
      opts.yAxis = {
        labels: {
          format: "{value}"
        },
        title: null
      };
      opts.yAxis.min = 0;
      opts.yAxis.max = 100;

      opts.yAxis.plotBands = [{
        from: 0,
        to: percentage,
        color: "#0076b9"
      }, {
        from: percentage,
        to: 100,
        color: "#b5b5b5"
      }];

      opts.series = [{
        name: "1",
        data: [percentage],
        marker: { enabled: false }
      }];
      return opts;
    },
    back_click: function back_click() {
      this.no_detail = true;
    },
    chart_options: function chart_options() {
      var opts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__intraday_service__["a" /* default */].getChartConfig_1()));
      opts.chart = {
        type: "spline",
        height: 380,
        borderWidth: 0,
        marginBottom: 48,
        marginLeft: 45,
        plotBackgroundColor: '#EEEEEE'

      }, opts.xAxis = {
        tickmarkPlacement: 'on',
        startOnTick: true,

        minPadding: 0.01,
        minorTicks: true,

        gridLineWidth: 0.6,
        gridLineColor: '#B9B9B9',

        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 4,
        minorTickPosition: 'inside',
        minorTickColor: '#B9B9B9',
        minorGridLineColor: '#B9B9B9',
        minorGridLineWidth: 0.4,
        crosshair: false,
        min: this.site_levels.ticks[0],
        tickInterval: this.site_levels.ticks[1] - this.site_levels.ticks[0],
        tickPositions: this.site_levels.ticks,
        labels: {
          formatter: function formatter() {
            var a = new Date(this.value * 1000);
            var hour = a.getHours();
            var time = hour + ':00';
            return time;
          },
          rotation: -90
        }

      }, opts.yAxis = [{
        title: {
          text: ''
        },
        min: 0,
        max: 2000,
        tickInterval: 200,
        tickPositions: [0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],
        gridLineWidth: 0,
        lineWidth: 0,
        opposite: true
      }, {
        title: {
          text: ''
        },
        min: 1000,
        max: 6000,
        tickInterval: 1000,
        tickPositions: [1000, 2000, 3000, 4000, 5000, 6000],
        gridLineWidth: 0.6,
        gridLineColor: '#B9B9B9',
        labels: {
          format: '{value:.0f}'
        },
        lineWidth: 0
      }], opts.tooltip = {
        crosshairs: true,
        formatter: function formatter() {
          var a = new Date(this.x * 1000);
          var hour = a.getHours();
          var minute = a.getMinutes();
          var time = hour + ':' + minute;
          return '<b>time:' + time + '</b><br>volume:' + this.y;
        }
      }, opts.series = this.site_levels.series;
      return opts;
    },
    chart_options_1: function chart_options_1(index) {
      if (index !== null) {
        var opts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__intraday_service__["a" /* default */].getChartConfig_1()));
        opts.chart = {
          type: "spline",
          height: 340,
          borderWidth: 0,
          marginBottom: 48,
          marginLeft: 5,
          plotBackgroundColor: '#EEEEEE'

        }, opts.xAxis = {
          tickmarkPlacement: 'on',
          startOnTick: true,

          minPadding: 0.01,
          minorTicks: true,

          gridLineWidth: 0.6,
          gridLineColor: '#B9B9B9',

          minorTickInterval: 'auto',
          minorTickWidth: 1,
          minorTickLength: 4,
          minorTickPosition: 'inside',
          minorTickColor: '#B9B9B9',
          minorGridLineColor: '#B9B9B9',
          minorGridLineWidth: 0.4,
          crosshair: false,
          min: this.site_levels.ticks[0],
          tickInterval: this.site_levels.ticks[1] - this.site_levels.ticks[0],
          tickPositions: this.site_levels.ticks,
          labels: {
            formatter: function formatter() {
              var a = new Date(this.value * 1000);
              var hour = a.getHours();
              var time = hour + ':00';
              return time;
            },
            rotation: -90
          }
        }, opts.yAxis = [{
          title: {
            text: ''
          },
          min: 0,
          max: this.site_levels.chart_control[index][0].data[0]['y'] + 200,
          tickInterval: 200,
          opposite: true,
          gridLineWidth: 0,
          lineWidth: 0
        }], opts.tooltip = {
          formatter: function formatter() {
            var a = new Date(this.x * 1000);
            var hour = a.getHours();
            var minute = a.getMinutes();
            var time = hour + ':' + minute;
            return '<b>time:' + time + '</b><br>volume:' + this.y;
          }
        }, opts.series = this.site_levels.chart_control[index];
        return opts;
      }
    }
  },

  computed: {}
});

/***/ }),
/* 600 */,
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnr_service__ = __webpack_require__(62);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Hazard',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      model: {
        name: ''
      },
      newHazard: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Hazard Name',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'id',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newHazardModal: function newHazardModal() {
      this.model = {
        name: ''
      };
      this.savebtn = false;
      this.newHazard = true;
    },
    trashHazard: function trashHazard() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/hazard/' + row.id + '/');
      } else {
        this.restoreHazard(row.id);
      }
    },
    okToSave: function okToSave() {
      if (this.model.name === undefined || this.model.name.trim().length == 0) {
        this.$swal('Alert!', 'Hazard Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveHazard: function saveHazard() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].save(this.model).then(function (data) {
        _this.$swal(data.status, data.message, data.status).then(function (result) {
          if (data.status == 'success') {
            _this.newHazard = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].getAll().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.hazards.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreHazard: function restoreHazard(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Hazard ?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].restore(id).then(function (data) {
            console.log(data);
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnr_service__ = __webpack_require__(62);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Control',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      trash: false,
      dpdt: 'Active',
      model: {
        name: ''
      },
      newControl: false,
      items: items,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'name',
        label: 'Control Name',
        sortable: true
      }],
      currentPage: 1,
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: 'id',
      sortDesc: false,
      filter: null,
      loadingData: true,
      savebtn: true
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newControlModal: function newControlModal() {
      this.model = {
        name: ''
      };
      this.savebtn = false;
      this.newControl = true;
    },
    trashControl: function trashControl() {
      this.trash = !this.trash;
      this.dpdt = this.trash ? "Trash" : "Active";
      this.getAll();
      this.loadingData = true;
    },
    rowClicked: function rowClicked(row) {
      if (!this.trash) {
        this.$router.push('/control/' + row.id + '/');
      } else {
        this.restoreControl(row.id);
      }
    },
    okToSave: function okToSave() {
      if (this.model.name === undefined || this.model.name.trim().length == 0) {
        this.$swal('Alert!', 'Control Name can not be empty', 'warning');
        return false;
      }

      return true;
    },
    saveControl: function saveControl() {
      var _this = this;

      if (!this.okToSave()) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].saveC(this.model).then(function (data) {
        _this.$swal(data.status, data.message, data.status).then(function (result) {
          if (data.status == 'success') {
            _this.newControl = false;
            _this.getAll();
          }
        });
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    getAll: function getAll() {
      var _this2 = this;

      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].getAllC().then(function (data) {
        if (data.status == 'success') {
          _this2.items = data.controls.filter(function (o) {
            return o.status_id == (_this2.trash ? 2 : 1);
          });
        } else {
          _this2.$swal(data.status, data.message, data.status);
          _this2.loadingData = false;
          return;
        }
        _this2.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this2.loadingData = false;
      });
    },
    restoreControl: function restoreControl(id) {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to restore this Control ?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].restoreC(id).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.filter = '';
              _this3.trash = false;
              _this3.getAll();
              _this3.loadingData = true;
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnr_service__ = __webpack_require__(62);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'HazardD',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				name: ''
			},
			updateData: null,
			originalData: null,

			loadingData: true
		};
	},

	methods: {
		editH: function editH() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].getBy(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.hazard;
					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.companyId;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Hazard Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var model = {
				name: this.model.name
			};

			__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].update(this.companyId, model).then(function (data) {
				_this2.$swal(data.status, data.message, data.status).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteH: function deleteH() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Hazard: " + this.model.name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].delete(_this3.companyId).then(function (data) {
						_this3.$swal(data.status, data.message, data.status);
						if (data.status == 'success') {
							_this3.$router.replace('/hazards');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnr_service__ = __webpack_require__(62);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ControlD',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				name: ''
			},
			updateData: null,
			originalData: null,

			loadingData: true
		};
	},

	methods: {
		editC: function editC() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].getByC(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.control;
					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.companyId;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.name === undefined || this.model.name.trim().length == 0) {
				this.$swal('Alert!', 'Control Name can not be empty', 'warning');
				return false;
			}
			return true;
		},
		updateC: function updateC() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}

			var model = {
				name: this.model.name
			};

			__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].updateC(this.companyId, model).then(function (data) {
				_this2.$swal(data.status, data.message, data.status).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteC: function deleteC(item) {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Control: " + this.model.name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].deleteC(_this3.companyId).then(function (data) {
						_this3.$swal(data.status, data.message, data.status);
						if (data.status == 'success') {
							_this3.$router.replace('/controls');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnr_service__ = __webpack_require__(62);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TDG',
    created: function created() {
        this.getAll();
    },
    data: function data() {
        return {
            trash: false,
            dpdt: 'Active',
            model: {
                common_name: '',
                product_description: '',
                packing_group: '',
                class_tdg: null,
                shipping_name: '',
                un: null,
                fluid_types_id: []
            },
            newTdg: false,
            items: items,
            fields: [{
                key: 'id',
                label: 'ID',
                sortable: true
            }, {
                key: 'common_name',
                label: 'Common Name',
                sortable: true
            }, {
                key: 'product_description',
                label: 'Product Description',
                sortable: false
            }, {
                key: 'packing_group',
                label: 'Packing Group',
                sortable: false
            }, {
                key: 'class_tdg',
                label: 'Class',
                sortable: false
            }, {
                key: 'shipping_name',
                label: 'Shipping Name',
                sortable: false
            }, {
                key: 'un',
                label: 'Un',
                sortable: false
            }],
            currentPage: 1,
            perPage: 25,
            totalRows: items.length,
            pageOptions: [25, 50, 100],
            sortBy: 'id',
            sortDesc: false,
            filter: null,
            loadingData: true,
            savebtn: true,
            fluidtypeselect: [],
            indeterminateFT: false,
            ftAllSelected: false
        };
    },

    computed: {
        sortOptions: function sortOptions() {
            return this.fields.filter(function (f) {
                return f.sortable;
            }).map(function (f) {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },
    methods: {
        onFiltered: function onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        newTdgModal: function newTdgModal() {
            this.model = {
                common_name: '',
                product_description: '',
                packing_group: '',
                class_tdg: null,
                shipping_name: '',
                un: null,
                fluid_types_id: []
            };
            this.savebtn = false;
            this.newTdg = true;
        },
        trashTdg: function trashTdg() {
            this.trash = !this.trash;
            this.dpdt = this.trash ? "Trash" : "Active";
            this.getAll();
            this.loadingData = true;
        },
        rowClicked: function rowClicked(row) {
            if (!this.trash) {
                this.$router.push('/tdg/' + row.id + '/');
            } else {
                this.restoreTdg(row.id);
            }
        },
        okToSave: function okToSave() {
            if (this.model.common_name === undefined || this.model.common_name.trim().length == 0) {
                this.$swal('Alert!', 'Common Name can not be empty', 'warning');
                return false;
            }
            if (this.model.product_description === undefined || this.model.product_description.trim().length == 0) {
                this.$swal('Alert!', 'Product Description can not be empty', 'warning');
                return false;
            }
            if (this.model.packing_group === undefined || this.model.packing_group.trim().length == 0) {
                this.$swal('Alert!', 'Packing Group can not be empty', 'warning');
                return false;
            }
            if (this.model.class_tdg === null || this.model.class_tdg.trim().length == 0) {
                this.$swal('Alert!', 'Class can not be empty', 'warning');
                return false;
            }
            if (this.model.shipping_name === undefined || this.model.shipping_name.trim().length == 0) {
                this.$swal('Alert!', 'Shipping Name can not be empty', 'warning');
                return false;
            }
            if (this.model.un === null || this.model.un.trim().length == 0) {
                this.$swal('Alert!', 'Un can not be empty', 'warning');
                return false;
            }
            return true;
        },
        saveTdg: function saveTdg() {
            var _this = this;

            if (!this.okToSave()) {
                return;
            }
            console.log(this.model);
            __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].save_tdg(this.model).then(function (data) {
                _this.$swal(data.status, data.message, data.status).then(function (result) {
                    if (data.status == 'success') {
                        _this.newTdg = false;
                        _this.getAll();
                    }
                });
            }).catch(function (error) {
                _this.$swal('Error', 'Server not response. ' + error, 'error');
            });
            this.savebtn = false;
        },
        getAll: function getAll() {
            var _this2 = this;

            this.loadingData = true;
            __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].getAll_tdg().then(function (data) {
                if (data.status == 'success') {
                    _this2.items = data.tdgs.filter(function (o) {
                        return o.status_id == (_this2.trash ? 2 : 1);
                    });
                    _this2.fluidtypeselect = data.fluid_types;
                } else {
                    _this2.$swal(data.status, data.message, data.status);
                    _this2.fluidtypeselect = [];
                    _this2.loadingData = false;
                    return;
                }
                _this2.loadingData = false;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
                _this2.loadingData = false;
            });
        },
        restoreTdg: function restoreTdg(id) {
            var _this3 = this;

            this.$swal({
                title: 'Please, confirm',
                text: "Are you sure to restore this Tdg ?",
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].restore_tdg(id).then(function (data) {
                        _this3.$swal(data.status, data.message, data.status);
                        if (data.status == 'success') {
                            _this3.filter = '';
                            _this3.trash = false;
                            _this3.getAll();
                            _this3.loadingData = true;
                        }
                    }).catch(function (error) {
                        _this3.$swal('Error', 'Server not response. ' + error, 'error');
                    });
                }
            });
        },
        FTToggleAll: function FTToggleAll(checked) {
            this.model.fluid_types_id = checked ? this.fluidtypeselect.map(function (item) {
                return item.id;
            }) : [];
        },
        fluidtypesChange: function fluidtypesChange() {
            if (this.model.fluid_types_id.length === 0) {
                this.indeterminateFT = false;
                this.ftAllSelected = false;
            } else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
                this.indeterminateFT = false;
                this.ftAllSelected = true;
            } else {
                this.indeterminateFT = true;
                this.ftAllSelected = false;
            }
        }
    }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnr_service__ = __webpack_require__(62);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'TdgD',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				common_name: '',
				product_description: '',
				packing_group: '',
				class_tdg: null,
				shipping_name: '',
				un: null,
				fluid_types_id: []
			},
			updateData: null,
			originalData: null,

			loadingData: true,
			fluidtypeselect: [],
			indeterminateFT: false,
			ftAllSelected: false
		};
	},

	methods: {
		editTdg: function editTdg() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].getBy_tdg(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.tdg;
					_this.fluidtypeselect = data.fluid_types;
					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.companyId;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.common_name === undefined || this.model.common_name.trim().length == 0) {
				this.$swal('Alert!', 'Common Name can not be empty', 'warning');
				return false;
			}
			if (this.model.product_description === undefined || this.model.product_description.trim().length == 0) {
				this.$swal('Alert!', 'Product Description can not be empty', 'warning');
				return false;
			}
			if (this.model.packing_group === undefined || this.model.packing_group.trim().length == 0) {
				this.$swal('Alert!', 'Packing Group can not be empty', 'warning');
				return false;
			}
			if (this.model.class_tdg === null || this.model.class_tdg.trim().length == 0) {
				this.$swal('Alert!', 'Class can not be empty', 'warning');
				return false;
			}
			if (this.model.shipping_name === undefined || this.model.shipping_name.trim().length == 0) {
				this.$swal('Alert!', 'Shipping Name can not be empty', 'warning');
				return false;
			}
			if (this.model.un === null || this.model.un.trim().length == 0) {
				this.$swal('Alert!', 'Un can not be empty', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			console.log(this.model);
			__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].update_tdg(this.companyId, this.model).then(function (data) {
				_this2.$swal(data.status, data.message, data.status).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTdg: function deleteTdg() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Tdg: " + this.model.common_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__cnr_service__["a" /* default */].delete_tdg(_this3.companyId).then(function (data) {
						_this3.$swal(data.status, data.message, data.status);
						if (data.status == 'success') {
							_this3.$router.replace('/tdgs');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		FTToggleAll: function FTToggleAll(checked) {
			this.model.fluid_types_id = checked ? this.fluidtypeselect.map(function (item) {
				return item.id;
			}) : [];
		},
		fluidtypesChange: function fluidtypesChange() {
			if (this.model.fluid_types_id.length === 0) {
				this.indeterminateFT = false;
				this.ftAllSelected = false;
			} else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
				this.indeterminateFT = false;
				this.ftAllSelected = true;
			} else {
				this.indeterminateFT = true;
				this.ftAllSelected = false;
			}
		}
	}
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__receipt_service__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PetroTranz',
  created: function created() {
    this.getAll();
  },
  data: function data() {
    return {
      row: 0,
      loadingData: true,
      configTable: false,

      items: items,
      totalRows: items.length,
      fields: [{
        key: 'id',
        label: 'ID',
        sortable: true
      }, {
        key: 'haul_id',
        label: 'Haul ID',
        sortable: true
      }, {
        key: 'success',
        label: 'Success'
      }, {
        key: 'send_date',
        label: 'Send Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format("MMM DD, YYYY HH:MM:SS");
        }
      }, {
        key: 'message',
        label: 'Message'
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      role: '',
      myToggle: false,

      filename: 'petrotranz' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "id": "id",
        "haul_id": "haul_id",
        "success": "success",
        "send_date": "send_date",
        "message": "message"
      },
      items_csv: [],
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD')
      }
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this = this;

      this.items = [];

      console.log(this.filter_by);
      __WEBPACK_IMPORTED_MODULE_2__receipt_service__["a" /* default */].get_petrotranz_hauls(this.filter_by).then(function (data) {
        if (data.status == 'success') {
          _this.items = data.hauls;
          _this.items_csv = _this.items;
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
        _this.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    rowClicked: function rowClicked(row, index, e) {
      console.log('click');
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
      }
      this.filter_by.initial_date = a;
      this.getAll();
      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
      }
      this.filter_by.end_date = a;
      this.getAll();
      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD')
      };
      this.getAll();
      this.loadingData = true;
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Customer',
    created: function created() {
        this.getAll();
    },
    data: function data() {
        return {
            trash: false,
            dpdt: 'Active',
            model: {
                customer_name: '',
                address_1: '',
                address_2: '',
                address_3: '',
                postal_zip: '',
                prov_state: '',
                currency_id: null,
                gst: 'false',
                invoice_DoM: null,
                placeholder_1: '',
                placeholder_2: '',
                infile: [{
                    'name': '',
                    'file_64': ''
                }]
            },
            newIC: false,
            items: items,
            fields: [{
                key: 'id',
                label: 'ID',
                sortable: true
            }, {
                key: 'customer_name',
                label: 'Customer Name',
                sortable: true
            }, {
                key: 'address_1',
                label: 'Address 1',
                sortable: false
            }, {
                key: 'address_2',
                label: 'Address 2',
                sortable: false
            }, {
                key: 'address_3',
                label: 'Address 3',
                sortable: false
            }, {
                key: 'postal_zip',
                label: 'Postal Zip',
                sortable: false
            }, {
                key: 'prov_state',
                label: 'Prov State',
                sortable: false
            }, {
                key: 'currency_name',
                label: 'Currency',
                sortable: false
            }, {
                key: 'invoice_DoM',
                label: 'Day of Month',
                sortable: false
            }, {
                key: 'placeholder_1',
                label: 'Placeholder 1',
                sortable: false
            }, {
                key: 'placeholder_2',
                label: 'Placeholder 2',
                sortable: false
            }],
            currentPage: 1,
            perPage: 25,
            totalRows: items.length,
            pageOptions: [25, 50, 100],
            sortBy: 'id',
            sortDesc: false,
            filter: null,
            loadingData: true,
            savebtn: true,
            currency: [],
            DoM: [{ 'id': 1, 'name': '1' }, { 'id': 2, 'name': '2' }, { 'id': 3, 'name': '3' }, { 'id': 4, 'name': '4' }, { 'id': 5, 'name': '5' }, { 'id': 6, 'name': '6' }, { 'id': 7, 'name': '7' }, { 'id': 8, 'name': '8' }, { 'id': 9, 'name': '9' }, { 'id': 10, 'name': '10' }, { 'id': 11, 'name': '11' }, { 'id': 12, 'name': '12' }, { 'id': 13, 'name': '13' }, { 'id': 14, 'name': '14' }, { 'id': 15, 'name': '15' }, { 'id': 16, 'name': '16' }, { 'id': 17, 'name': '17' }, { 'id': 18, 'name': '18' }, { 'id': 19, 'name': '19' }, { 'id': 20, 'name': '20' }, { 'id': 21, 'name': '21' }, { 'id': 22, 'name': '22' }, { 'id': 23, 'name': '23' }, { 'id': 24, 'name': '24' }, { 'id': 25, 'name': '25' }, { 'id': 26, 'name': '26' }, { 'id': 27, 'name': '27' }, { 'id': 28, 'name': '28' }, { 'id': 29, 'name': '29' }, { 'id': 30, 'name': '30' }, { 'id': 31, 'name': '31' }],
            file: '',
            infile: {
                'name': '',
                'file_64': ''
            },
            otherfile: {
                'name': '',
                'file_64': ''
            }
        };
    },

    computed: {
        sortOptions: function sortOptions() {
            return this.fields.filter(function (f) {
                return f.sortable;
            }).map(function (f) {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },
    methods: {
        onFiltered: function onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        newICModal: function newICModal() {
            this.model = {
                customer_name: '',
                address_1: '',
                address_2: '',
                address_3: '',
                postal_zip: '',
                prov_state: '',
                currency_id: null,
                gst: false,
                invoice_DoM: null,
                placeholder_1: '',
                placeholder_2: '',
                infile: [{
                    'name': '',
                    'file_64': ''
                }]
            };
            this.infile = {
                'name': '',
                'file_64': ''
            };
            this.savebtn = false;
            this.newIC = true;
            this.$refs.file.value = null;
        },
        trashIC: function trashIC() {
            this.trash = !this.trash;
            this.dpdt = this.trash ? "Trash" : "Active";
            this.getAll();
            this.loadingData = true;
        },
        rowClicked: function rowClicked(row) {
            if (!this.trash) {
                this.$router.push('/invoice_customer/' + row.id + '/');
            } else {
                this.restoreIC(row.id);
            }
        },
        okToSave: function okToSave() {
            if (this.model.customer_name === undefined || this.model.customer_name.trim().length == 0) {
                this.$swal('Alert!', 'Customer Name can not be empty', 'warning');
                return false;
            }
            if (this.model.currency_id === undefined || this.model.currency_id == null) {
                this.$swal('Alert!', 'Address can not be empty', 'warning');
                return false;
            }
            return true;
        },
        saveIC: function saveIC() {
            var _this = this;

            if (!this.okToSave()) {
                return;
            }
            console.log(this.model);
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].save_IC(this.model).then(function (data) {
                _this.$swal(data.status, data.message, data.status).then(function (result) {
                    if (data.status == 'success') {
                        _this.newIC = false;
                        _this.getAll();
                    }
                });
            }).catch(function (error) {
                _this.$swal('Error', 'Server not response. ' + error, 'error');
            });
            this.savebtn = false;
        },
        getAll: function getAll() {
            var _this2 = this;

            this.loadingData = true;
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getAll_c().then(function (data) {
                if (data.status == 'success') {
                    _this2.items = data.invoice_customer.filter(function (o) {
                        return o.status_id == (_this2.trash ? 2 : 1);
                    });
                    _this2.currency = data.currency;
                } else {
                    _this2.$swal(data.status, data.message, data.status);
                    _this2.currency = [];
                    _this2.loadingData = false;
                    return;
                }
                _this2.loadingData = false;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
                _this2.loadingData = false;
            });
        },
        restoreIC: function restoreIC(id) {
            var _this3 = this;

            this.$swal({
                title: 'Please, confirm',
                text: "Are you sure to restore this Customer ?",
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].restore_icustomer(id).then(function (data) {
                        _this3.$swal(data.status, data.message, data.status);
                        if (data.status == 'success') {
                            _this3.filter = '';
                            _this3.trash = false;
                            _this3.getAll();
                            _this3.loadingData = true;
                        }
                    }).catch(function (error) {
                        _this3.$swal('Error', 'Server not response. ' + error, 'error');
                    });
                }
            });
        },
        handleFileUpload: function handleFileUpload(index) {

            if (this.$refs.file.files.length > 0) {

                this.file = this.$refs.file.files[0];
                this.infile.name = this.file.name;

                var url = window.URL.createObjectURL(this.file);
                this.url = url;
                setTimeout(function () {
                    return window.URL.revokeObjectURL(url);
                }, 100);
                var reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = function () {
                    localStorage.setItem('file_64', reader.result);
                    return;
                };
                this.infile.file_64 = localStorage.getItem('file_64');

                this.model.infile[index].name = this.infile.name;
                this.model.infile[index].file_64 = this.infile.file_64;
                console.log('-model-->', this.model.infile);
            }
        },
        removefile: function removefile(otherfile) {
            this.model.infile.splice(otherfile, 1);
        },
        anotherfile: function anotherfile() {

            if (this.model.infile.length === 0) {
                this.model.infile.push(this.otherfile);
                this.infile = {
                    'name': '',
                    'file_64': ''
                };
            } else {
                if (this.infile.name !== '') {
                    this.model.infile.push(this.otherfile);
                    this.infile = {
                        'name': '',
                        'file_64': ''
                    };
                } else {
                    this.$swal('warning', 'File no selected', 'warning');
                }
            }
        }
    }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'InvoiceCostumer',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				customer_name: '',
				address_1: '',
				address_2: '',
				address_3: '',
				postal_zip: '',
				prov_state: '',
				currency_id: null,
				gst: false,
				invoice_DoM: null,
				placeholder_1: '',
				placeholder_2: '',
				invoice_DoM_name: '',
				infile: []

			},
			updateData: null,
			originalData: null,
			loadingData: true,
			currency: [],
			DoM: [{ 'id': 1, 'name': '1' }, { 'id': 2, 'name': '2' }, { 'id': 3, 'name': '3' }, { 'id': 4, 'name': '4' }, { 'id': 5, 'name': '5' }, { 'id': 6, 'name': '6' }, { 'id': 7, 'name': '7' }, { 'id': 8, 'name': '8' }, { 'id': 9, 'name': '9' }, { 'id': 10, 'name': '10' }, { 'id': 11, 'name': '11' }, { 'id': 12, 'name': '12' }, { 'id': 13, 'name': '13' }, { 'id': 14, 'name': '14' }, { 'id': 15, 'name': '15' }, { 'id': 16, 'name': '16' }, { 'id': 17, 'name': '17' }, { 'id': 18, 'name': '18' }, { 'id': 19, 'name': '19' }, { 'id': 20, 'name': '20' }, { 'id': 21, 'name': '21' }, { 'id': 22, 'name': '22' }, { 'id': 23, 'name': '23' }, { 'id': 24, 'name': '24' }, { 'id': 25, 'name': '25' }, { 'id': 26, 'name': '26' }, { 'id': 27, 'name': '27' }, { 'id': 28, 'name': '28' }, { 'id': 29, 'name': '29' }, { 'id': 30, 'name': '30' }, { 'id': 31, 'name': '31' }],
			file: '',
			infile: {
				'name': '',
				'file_64': ''
			},
			otherfile: {
				'name': '',
				'file_64': ''
			}
		};
	},

	methods: {
		editTdg: function editTdg() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getBy_icustomer(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.invoice_customer;
					_this.currency = data.currency;
					console.log(_this.originalData);

					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.companyId;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.customer_name === undefined || this.model.customer_name.trim().length == 0) {
				this.$swal('Alert!', 'Customer Name can not be empty', 'warning');
				return false;
			}
			if (this.model.currency_id === undefined || this.model.currency_id == null) {
				this.$swal('Alert!', 'Address can not be empty', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			console.log(this.model);
			__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].update_icustomer(this.companyId, this.model).then(function (data) {
				_this2.$swal(data.status, data.message, data.status).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTdg: function deleteTdg() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Invoice Customer: " + this.model.customer_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].delete_icustomer(_this3.companyId).then(function (data) {
						_this3.$swal(data.status, data.message, data.status);
						if (data.status == 'success') {
							_this3.$router.replace('/invoice_customers');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		handleFileUpload: function handleFileUpload(index) {
			if (this.$refs.file.files.length > 0) {

				this.file = this.$refs.file.files[0];
				this.infile.name = this.file.name;

				var url = window.URL.createObjectURL(this.file);
				this.url = url;
				setTimeout(function () {
					return window.URL.revokeObjectURL(url);
				}, 100);
				var reader = new FileReader();
				reader.readAsDataURL(this.file);
				reader.onload = function () {
					localStorage.setItem('file_64', reader.result);
					return;
				};
				this.infile.file_64 = localStorage.getItem('file_64');

				this.model.infile[index].name = this.infile.name;
				this.model.infile[index].file_64 = this.infile.file_64;
				console.log('-model-->', this.model.infile);
			}
		},
		removefile: function removefile(otherfile) {
			this.model.infile.splice(otherfile, 1);
		},
		anotherfile: function anotherfile() {

			if (this.model.infile.length === 0) {
				this.model.infile.push(this.otherfile);
				this.infile = {
					'name': '',
					'file_64': ''
				};
			} else {
				var file_in = this.model.infile;
				var file_in_index = file_in.map(function (o) {
					return o.name;
				}).indexOf('');
				if (file_in_index > -1) {
					this.$swal('warning', 'File no selected', 'warning');
				} else {
					this.otherfile = {
						'name': '',
						'file_64': ''
					};
					this.model.infile.push(this.otherfile);
					this.infile = {
						'name': '',
						'file_64': ''
					};
				}
			}
		}
	}
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Contract',
    created: function created() {
        this.getAll();
    },
    data: function data() {
        return {
            trash: false,
            dpdt: 'Active',
            model: {
                contract_name: '',
                type_contract_id: null,
                start_date: '',
                of_months: '',
                volume: '',
                diff: '',
                index_contract_id: null,
                app: '',
                trader: '',
                priority: '',
                placeholder_1: '',
                placeholder_2: '',
                invoice_customer_id: null,
                pdfs: [{
                    'name': '',
                    'file_64': ''
                }],
                nomination_m3: '',
                nomination_bbl: '',
                post_appomt_nom: '',
                price_description: ''
            },
            newIC: false,
            items: items,
            fields: [{
                key: 'id',
                label: 'ID',
                sortable: true
            }, {
                key: 'contract_name',
                label: 'Contract Name',
                sortable: true
            }, {
                key: 'type_contract_name',
                label: 'Type Contract',
                sortable: false
            }, {
                key: 'start_date',
                label: 'Start Date',
                sortable: false
            }, {
                key: 'of_months',
                label: 'Of month',
                sortable: false
            }, {
                key: 'volume',
                label: 'Volume',
                sortable: false
            }, {
                key: 'diff',
                label: 'Diff',
                sortable: false
            }, {
                key: 'index_contract_name',
                label: 'Index Contract',
                sortable: false
            }, {
                key: 'app',
                label: 'App',
                sortable: false
            }, {
                key: 'trader',
                label: 'Trader',
                sortable: false
            }, {
                key: 'priority',
                label: 'Priority',
                sortable: false
            }, {
                key: 'placeholder_1',
                label: 'Placeholder 1',
                sortable: false
            }, {
                key: 'placeholder_2',
                label: 'Placeholder 2',
                sortable: false
            }, {
                key: 'invoice_customer_name',
                label: 'Customer',
                sortable: false
            }, {
                key: 'nomination_m3',
                label: 'Nomination(m3)',
                sortable: false
            }, {
                key: 'nomination_bbl',
                label: 'Nomination(bbl)',
                sortable: false
            }, {
                key: 'post_appomt_nom',
                label: 'Post Appomt. Nomination',
                sortable: false
            }, {
                key: 'price_description',
                label: 'Price Description',
                sortable: false
            }],
            currentPage: 1,
            perPage: 25,
            totalRows: items.length,
            pageOptions: [25, 50, 100],
            sortBy: 'id',
            sortDesc: false,
            filter: null,
            loadingData: true,
            savebtn: true,
            type_contract: [],
            index_contract: [],
            invoice_customer: [],
            url: '',
            file: '',
            infile: {
                'name': '',
                'file_64': ''
            },
            otherfile: {
                'name': '',
                'file_64': ''
            }
        };
    },

    computed: {
        sortOptions: function sortOptions() {
            return this.fields.filter(function (f) {
                return f.sortable;
            }).map(function (f) {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },
    methods: {
        onFiltered: function onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        newICModal: function newICModal() {
            this.model = {
                contract_name: '',
                type_contract_id: null,
                start_date: '',
                of_months: '',
                volume: '',
                diff: '',
                index_contract_id: null,
                app: '',
                trader: '',
                priority: '',
                placeholder_1: '',
                placeholder_2: '',
                invoice_customer_id: null,
                pdfs: [{
                    'name': '',
                    'file_64': ''
                }],
                nomination_m3: '',
                nomination_bbl: '',
                post_appomt_nom: '',
                price_description: ''
            };
            this.infile = {
                'name': '',
                'file_64': ''
            };
            this.savebtn = false;
            this.newIC = true;
            this.$refs.file.value = null;
        },
        trashIC: function trashIC() {
            this.trash = !this.trash;
            this.dpdt = this.trash ? "Trash" : "Active";
            this.getAll();
            this.loadingData = true;
        },
        rowClicked: function rowClicked(row) {
            if (!this.trash) {
                this.$router.push('/invoice_contract/' + row.id + '/');
            } else {
                this.restoreIC(row.id);
            }
        },
        okToSave: function okToSave() {
            if (this.model.contract_name === undefined || this.model.contract_name.trim().length == 0) {
                this.$swal('Alert!', 'Contract Name can not be empty', 'warning');
                return false;
            }
            if (this.model.start_date === undefined || this.model.start_date.trim().length == 0) {
                this.$swal('Alert!', 'Start Date can not be empty', 'warning');
                return false;
            }
            if (this.model.of_months === undefined || this.model.of_months.trim().length == 0) {
                this.$swal('Alert!', 'Of Months can not be empty', 'warning');
                return false;
            }
            if (this.model.volume === undefined || this.model.volume.trim().length == 0) {
                this.$swal('Alert!', 'Volume can not be empty', 'warning');
                return false;
            }
            if (this.model.diff === undefined || this.model.diff.trim().length == 0) {
                this.$swal('Alert!', 'Diff can not be empty', 'warning');
                return false;
            }
            if (this.model.trader === undefined || this.model.trader.trim().length == 0) {
                this.$swal('Alert!', 'Trader can not be empty', 'warning');
                return false;
            }
            if (this.model.priority === undefined || this.model.priority.trim().length == 0) {
                this.$swal('Alert!', 'Priority can not be empty', 'warning');
                return false;
            }
            if (this.model.type_contract_id === undefined || this.model.type_contract_id == null) {
                this.$swal('Alert!', 'Select Type Contract', 'warning');
                return false;
            }
            if (this.model.index_contract_id === undefined || this.model.index_contract_id == null) {
                this.$swal('Alert!', 'Select Index Contract', 'warning');
                return false;
            }
            if (this.model.invoice_customer_id === undefined || this.model.invoice_customer_id == null) {
                this.$swal('Alert!', 'Select Customer', 'warning');
                return false;
            }

            return true;
        },
        saveIC: function saveIC() {
            var _this = this;

            if (!this.okToSave()) {
                return;
            }
            console.log(this.model);
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].save_IC1(this.model).then(function (data) {
                _this.$swal(data.status, data.message, data.status).then(function (result) {
                    if (data.status == 'success') {
                        _this.newIC = false;
                        _this.getAll();
                    }
                });
            }).catch(function (error) {
                _this.$swal('Error', 'Server not response. ' + error, 'error');
            });
            this.savebtn = false;
        },
        getAll: function getAll() {
            var _this2 = this;

            this.loadingData = true;
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getAll_cc().then(function (data) {
                if (data.status == 'success') {
                    _this2.items = data.invoice_contract.filter(function (o) {
                        return o.status_id == (_this2.trash ? 2 : 1);
                    });
                    _this2.type_contract = data.type_contract;
                    _this2.index_contract = data.index_contract;
                    _this2.invoice_customer = data.invoice_customer;
                    console.log(_this2.items);
                } else {
                    _this2.$swal(data.status, data.message, data.status);
                    _this2.type_contract = [];
                    _this2.index_contract = [];
                    _this2.invoice_customer = [];
                    _this2.loadingData = false;
                    return;
                }
                _this2.loadingData = false;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
                _this2.loadingData = false;
            });
        },
        restoreIC: function restoreIC(id) {
            var _this3 = this;

            this.$swal({
                title: 'Please, confirm',
                text: "Are you sure to restore this Contract ?",
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].restore_icontract(id).then(function (data) {
                        _this3.$swal(data.status, data.message, data.status);
                        if (data.status == 'success') {
                            _this3.filter = '';
                            _this3.trash = false;
                            _this3.getAll();
                            _this3.loadingData = true;
                        }
                    }).catch(function (error) {
                        _this3.$swal('Error', 'Server not response. ' + error, 'error');
                    });
                }
            });
        },
        inputBlur: function inputBlur(variableName) {
            var variableValue = this.model[variableName];
            if (variableValue.length == 0) {
                if (variableName !== "exchange_rate") {
                    this.model[variableName] = "0.00";
                } else {
                    this.model[variableName] = "0.0000";
                }
            } else {
                var tempValue = variableValue.split(".");
                if (tempValue.length == 1) {
                    if (variableName !== "exchange_rate") {
                        this.model[variableName] = String(variableValue) + ".00";
                    } else {
                        this.model[variableName] = String(variableValue) + ".0000";
                    }
                } else if (tempValue.length == 2) {
                    if (variableName !== "exchange_rate") {
                        this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
                    } else {
                        this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "0000").slice(0, 4);
                    }
                }
            }
        },
        myOnlyNumber: function myOnlyNumber(evt, variableName) {
            var dotPosition = this.model[variableName].indexOf(".");
            var hasDot = dotPosition > -1;
            var length = this.model[variableName].length;
            if (variableName !== "exchange_rate") {
                this.isNumber(evt, hasDot, dotPosition, length, 2);
            } else {
                this.isNumber(evt, hasDot, dotPosition, length, 4);
            }
        },

        isNumber: function isNumber(evt, hasDot, dotPosition, length, n_digit) {

            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
                var selectionStart = evt.target.selectionStart;
                var selectionEnd = evt.target.selectionEnd;
                if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - n_digit > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            } else {
                evt.preventDefault();
            }
        },
        handleFileUpload: function handleFileUpload(index) {

            if (this.$refs.file.files.length > 0) {

                this.file = this.$refs.file.files[0];
                this.infile.name = this.file.name;

                var url = window.URL.createObjectURL(this.file);
                this.url = url;
                setTimeout(function () {
                    return window.URL.revokeObjectURL(url);
                }, 100);
                var reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = function () {
                    localStorage.setItem('file_64', reader.result);
                    return;
                };
                this.infile.file_64 = localStorage.getItem('file_64');

                this.model.pdfs[index].name = this.infile.name;
                this.model.pdfs[index].file_64 = this.infile.file_64;
                console.log('-model-->', this.model.pdfs);
            }
        },
        removefile: function removefile(otherfile) {
            this.model.pdfs.splice(otherfile, 1);
        },
        anotherfile: function anotherfile() {

            if (this.model.pdfs.length === 0) {
                this.model.pdfs.push(this.otherfile);
                this.infile = {
                    'name': '',
                    'file_64': ''
                };
            } else {
                if (this.infile.name !== '') {
                    this.model.pdfs.push(this.otherfile);
                    this.infile = {
                        'name': '',
                        'file_64': ''
                    };
                } else {
                    this.$swal('warning', 'File no selected', 'warning');
                }
            }
        }
    }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'InvoiceContract',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				contract_name: '',
				type_contract_id: null,
				type_contract_name: '',
				start_date: '',
				of_months: '',
				volume: '',
				diff: '',
				index_contract_id: null,
				index_contract_name: '',
				app: '',
				trader: '',
				priority: '',
				placeholder_1: '',
				placeholder_2: '',
				invoice_customer_id: null,
				invoice_customer_name: '',
				pdfs: [],
				nomination_m3: '',
				nomination_bbl: '',
				post_appomt_nom: '',
				price_description: ''
			},
			updateData: null,
			originalData: null,
			loadingData: true,
			type_contract: [],
			index_contract: [],
			invoice_customer: [],
			url: '',
			file: '',
			infile: {
				'name': '',
				'file_64': ''
			},
			otherfile: {
				'name': '',
				'file_64': ''
			}

		};
	},

	methods: {
		editTdg: function editTdg() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getBy_icontract(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.invoice_contract;
					_this.type_contract = data.type_contract;
					_this.index_contract = data.index_contract;
					_this.invoice_customer = data.invoice_customer;
					console.log('--->', _this.originalData);

					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.companyId;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.contract_name === undefined || this.model.contract_name.trim().length == 0) {
				this.$swal('Alert!', 'Contract Name can not be empty', 'warning');
				return false;
			}
			if (this.model.start_date === undefined || this.model.start_date.trim().length == 0) {
				this.$swal('Alert!', 'Start Date can not be empty', 'warning');
				return false;
			}
			if (this.model.of_months === undefined || this.model.of_months == '') {
				this.$swal('Alert!', 'Of Months can not be empty', 'warning');
				return false;
			}
			if (this.model.volume === undefined || this.model.volume == '') {
				this.$swal('Alert!', 'Volume can not be empty', 'warning');
				return false;
			}
			if (this.model.diff === undefined || this.model.diff == '') {
				this.$swal('Alert!', 'Diff can not be empty', 'warning');
				return false;
			}
			if (this.model.trader === undefined || this.model.trader.trim().length == 0) {
				this.$swal('Alert!', 'Trader can not be empty', 'warning');
				return false;
			}
			if (this.model.priority === undefined || this.model.priority == '') {
				this.$swal('Alert!', 'Priority can not be empty', 'warning');
				return false;
			}
			if (this.model.type_contract_id === undefined || this.model.type_contract_id == null) {
				this.$swal('Alert!', 'Select Type Contract', 'warning');
				return false;
			}
			if (this.model.index_contract_id === undefined || this.model.index_contract_id == null) {
				this.$swal('Alert!', 'Select Index Contract', 'warning');
				return false;
			}
			if (this.model.invoice_customer_id === undefined || this.model.invoice_customer_id == null) {
				this.$swal('Alert!', 'Select Customer', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			console.log('upd', this.model);
			__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].update_icontract(this.companyId, this.model).then(function (data) {
				_this2.$swal(data.status, data.message, data.status).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTdg: function deleteTdg() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Customer: " + this.model.contract_name + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].delete_icontract(_this3.companyId).then(function (data) {
						_this3.$swal(data.status, data.message, data.status);
						if (data.status == 'success') {
							_this3.$router.replace('/invoice_contracts');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		},
		inputBlur: function inputBlur(variableName) {
			var variableValue = this.model[variableName];
			if (variableValue.length == 0) {
				if (variableName !== "exchange_rate") {
					this.model[variableName] = "0.00";
				} else {
					this.model[variableName] = "0.0000";
				}
			} else {
				var tempValue = variableValue.split(".");
				if (tempValue.length == 1) {
					if (variableName !== "exchange_rate") {
						this.model[variableName] = String(variableValue) + ".00";
					} else {
						this.model[variableName] = String(variableValue) + ".0000";
					}
				} else if (tempValue.length == 2) {
					if (variableName !== "exchange_rate") {
						this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
					} else {
						this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "0000").slice(0, 4);
					}
				}
			}
		},
		myOnlyNumber: function myOnlyNumber(evt, variableName) {
			var dotPosition = this.model[variableName].indexOf(".");
			var hasDot = dotPosition > -1;
			var length = this.model[variableName].length;
			if (variableName !== "exchange_rate") {
				this.isNumber(evt, hasDot, dotPosition, length, 2);
			} else {
				this.isNumber(evt, hasDot, dotPosition, length, 4);
			}
		},

		isNumber: function isNumber(evt, hasDot, dotPosition, length, n_digit) {

			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
				var selectionStart = evt.target.selectionStart;
				var selectionEnd = evt.target.selectionEnd;
				if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - n_digit > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
					evt.preventDefault();
				} else {
					return true;
				}
			} else {
				evt.preventDefault();
			}
		},
		handleFileUpload: function handleFileUpload(index) {
			if (this.$refs.file.files.length > 0) {

				this.file = this.$refs.file.files[0];
				this.infile.name = this.file.name;

				var url = window.URL.createObjectURL(this.file);
				this.url = url;
				setTimeout(function () {
					return window.URL.revokeObjectURL(url);
				}, 100);
				var reader = new FileReader();
				reader.readAsDataURL(this.file);
				reader.onload = function () {
					localStorage.setItem('file_64', reader.result);
					return;
				};
				this.infile.file_64 = localStorage.getItem('file_64');

				this.model.pdfs[index].name = this.infile.name;
				this.model.pdfs[index].file_64 = this.infile.file_64;
				console.log('-model-->', this.model.pdfs);
			}
		},
		removefile: function removefile(otherfile) {
			this.model.pdfs.splice(otherfile, 1);
		},
		anotherfile: function anotherfile() {

			if (this.model.pdfs.length === 0) {
				this.model.pdfs.push(this.otherfile);
				this.infile = {
					'name': '',
					'file_64': ''
				};
			} else {
				var file_in = this.model.pdfs;
				var file_in_index = file_in.map(function (o) {
					return o.name;
				}).indexOf('');
				if (file_in_index > -1) {
					this.$swal('warning', 'File no selected', 'warning');
				} else {
					this.otherfile = {
						'name': '',
						'file_64': ''
					};
					this.model.pdfs.push(this.otherfile);
					this.infile = {
						'name': '',
						'file_64': ''
					};
				}
			}
		}
	}
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Adjustment',
    created: function created() {
        this.getAll();
    },
    data: function data() {
        return {
            trash: false,
            dpdt: 'Active',
            model: {
                volume: '',
                location_contract_id: null,
                invoice_customer_id: null,
                placeholder_1: '',
                placeholder_2: '',
                month: 1,
                year: 2021,
                month_year: ''
            },
            newIC: false,
            items: items,
            fields: [{
                key: 'id',
                label: 'ID',
                sortable: true
            }, {
                key: 'month_year',
                label: 'Month Year',
                sortable: true
            }, {
                key: 'invoice_customer_name',
                label: 'Customer',
                sortable: false
            }, {
                key: 'volume',
                label: 'Volume',
                sortable: false
            }, {
                key: 'location_contract_name',
                label: 'Load Location',
                sortable: false
            }, {
                key: 'placeholder_1',
                label: 'Placeholder 1',
                sortable: false
            }, {
                key: 'placeholder_2',
                label: 'Placeholder 2',
                sortable: false
            }],
            currentPage: 1,
            perPage: 25,
            totalRows: items.length,
            pageOptions: [25, 50, 100],
            sortBy: 'id',
            sortDesc: false,
            filter: null,
            loadingData: true,
            savebtn: true,
            location_contract: [],
            invoice_customer: [],
            years: [{ 'id': 2023, 'name': '2023' }, { 'id': 2022, 'name': '2022' }, { 'id': 2021, 'name': '2021' }, { 'id': 2019, 'name': '2020' }, { 'id': 2018, 'name': '2019' }],
            months: [{ 'id': 1, 'name': 'January' }, { 'id': 2, 'name': 'Frebuary' }, { 'id': 3, 'name': 'March' }, { 'id': 4, 'name': 'April' }, { 'id': 5, 'name': 'May' }, { 'id': 6, 'name': 'Jun' }, { 'id': 7, 'name': 'July' }, { 'id': 8, 'name': 'August' }, { 'id': 9, 'name': 'September' }, { 'id': 10, 'name': 'October' }, { 'id': 11, 'name': 'November' }, { 'id': 12, 'name': 'December' }]
        };
    },

    computed: {
        sortOptions: function sortOptions() {
            return this.fields.filter(function (f) {
                return f.sortable;
            }).map(function (f) {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },
    methods: {
        onFiltered: function onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        newICModal: function newICModal() {
            this.model = {
                month_year: null,
                volume: '',
                location_contract_id: null,
                invoice_customer_id: null,
                placeholder_1: '',
                placeholder_2: '',
                month: 1,
                year: 2021
            };
            this.savebtn = false;
            this.newIC = true;
        },
        trashIC: function trashIC() {
            this.trash = !this.trash;
            this.dpdt = this.trash ? "Trash" : "Active";
            this.getAll();
            this.loadingData = true;
        },
        rowClicked: function rowClicked(row) {
            if (!this.trash) {
                this.$router.push('/invoice_adjust/' + row.id + '/');
            } else {
                this.restoreIC(row.id);
            }
        },
        okToSave: function okToSave() {
            if (this.model.volume === undefined || this.model.volume.trim().length == 0) {
                this.$swal('Alert!', 'Volume can not be empty', 'warning');
                return false;
            }
            if (this.model.location_contract_id === undefined || this.model.location_contract_id === null) {
                this.$swal('Alert!', 'Select Load Location', 'warning');
                return false;
            }
            if (this.model.invoice_customer_id === undefined || this.model.invoice_customer_id === null) {
                this.$swal('Alert!', 'Select Load Location', 'warning');
                return false;
            }
            return true;
        },
        saveIC: function saveIC() {
            var _this = this;

            if (!this.okToSave()) {
                return;
            }
            console.log(this.model);
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].save_IC2(this.model).then(function (data) {
                _this.$swal(data.status, data.message, data.status).then(function (result) {
                    if (data.status == 'success') {
                        _this.newIC = false;
                        _this.getAll();
                    }
                });
            }).catch(function (error) {
                _this.$swal('Error', 'Server not response. ' + error, 'error');
            });
            this.savebtn = false;
        },
        getAll: function getAll() {
            var _this2 = this;

            this.loadingData = true;
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getAll_ca().then(function (data) {
                if (data.status == 'success') {
                    _this2.items = data.invoice_adjust.filter(function (o) {
                        return o.status_id == (_this2.trash ? 2 : 1);
                    });
                    _this2.location_contract = data.location_contract;
                    _this2.invoice_customer = data.invoice_customer;
                } else {
                    _this2.$swal(data.status, data.message, data.status);
                    _this2.location_contract = [];
                    _this2.invoice_customer = [];
                    _this2.loadingData = false;
                    return;
                }
                _this2.loadingData = false;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
                _this2.loadingData = false;
            });
        },
        restoreIC: function restoreIC(id) {
            var _this3 = this;

            this.$swal({
                title: 'Please, confirm',
                text: "Are you sure to restore this Adjustment ?",
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].restore_iadjust(id).then(function (data) {
                        _this3.$swal(data.status, data.message, data.status);
                        if (data.status == 'success') {
                            _this3.filter = '';
                            _this3.trash = false;
                            _this3.getAll();
                            _this3.loadingData = true;
                        }
                    }).catch(function (error) {
                        _this3.$swal('Error', 'Server not response. ' + error, 'error');
                    });
                }
            });
        }
    }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'InvoicePrice',
	created: function created() {
		this.getCompanyData();
	},
	props: {
		id: {
			type: String,
			default: 0
		}
	},
	data: function data() {
		return {
			subTitle: '',
			edit: false,
			found: false,
			notFoundMessage: 'Not found',
			model: {
				volume: '',
				location_contract_id: null,
				invoice_customer_id: null,
				placeholder_1: '',
				placeholder_2: '',
				month: 1,
				year: 2021,
				month_year: '',
				invoice_customer_name: '',
				location_contract_name: ''

			},
			updateData: null,
			originalData: null,

			loadingData: true,
			fluidtypeselect: [],
			indeterminateFT: false,
			ftAllSelected: false,
			location_contract: [],
			invoice_customer: [],
			years: [{ 'id': 2023, 'name': '2023' }, { 'id': 2022, 'name': '2022' }, { 'id': 2021, 'name': '2021' }, { 'id': 2019, 'name': '2020' }, { 'id': 2018, 'name': '2019' }],
			months: [{ 'id': 1, 'name': 'January' }, { 'id': 2, 'name': 'Frebuary' }, { 'id': 3, 'name': 'March' }, { 'id': 4, 'name': 'April' }, { 'id': 5, 'name': 'May' }, { 'id': 6, 'name': 'Jun' }, { 'id': 7, 'name': 'July' }, { 'id': 8, 'name': 'August' }, { 'id': 9, 'name': 'September' }, { 'id': 10, 'name': 'October' }, { 'id': 11, 'name': 'November' }, { 'id': 12, 'name': 'December' }]
		};
	},

	methods: {
		editTdg: function editTdg() {
			if (this.edit) {
				this.edit = false;
				this.restoreOriginalData();
			} else {
				this.edit = true;
			}
		},
		restoreOriginalData: function restoreOriginalData() {
			var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
			this.model = model;
		},
		getCompanyData: function getCompanyData() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getBy_iadjust(this.id).then(function (data) {
				if (data.status == 'success') {
					_this.originalData = data.invoice_adjust;
					_this.location_contract = data.location_contract;
					_this.invoice_customer = data.invoice_customer;
					console.log(_this.originalData);

					_this.companyId = _this.id;
					_this.loadingData = false;
					_this.found = true;
					_this.restoreOriginalData();
					_this.subTitle = _this.companyId;
				} else {
					_this.$swal(data.status, data.message, data.status);
					_this.loadingData = false;
					return;
				}
			}).catch(function (error) {
				_this.$swal('Error', 'Server not response. ' + error, 'error');
				_this.loadingData = false;
			});
		},
		okToUpdate: function okToUpdate() {
			if (this.model.volume === undefined || this.model.volume == '') {
				this.$swal('Alert!', 'Volume can not be empty', 'warning');
				return false;
			}
			if (this.model.location_contract_id === undefined || this.model.location_contract_id === null) {
				this.$swal('Alert!', 'Select Load Location', 'warning');
				return false;
			}
			if (this.model.invoice_customer_id === undefined || this.model.invoice_customer_id === null) {
				this.$swal('Alert!', 'Select Load Location', 'warning');
				return false;
			}
			return true;
		},
		update: function update() {
			var _this2 = this;

			if (!this.okToUpdate()) {
				return;
			}
			console.log(this.model);
			__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].update_iadjust(this.companyId, this.model).then(function (data) {
				_this2.$swal(data.status, data.message, data.status).then(function (result) {
					_this2.getCompanyData();
				});
			}).catch(function (error) {
				_this2.$swal('Error', 'Server not response. ' + error, 'error');
			});
			this.edit = false;
		},
		deleteTdg: function deleteTdg() {
			var _this3 = this;

			this.$swal({
				title: 'Please, confirm',
				text: "Are you sure to delete this Price: " + this.model.month_year + " ?",
				type: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes',
				reverseButtons: true
			}).then(function (result) {
				if (result.value) {
					__WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].delete_iadjust(_this3.companyId).then(function (data) {
						_this3.$swal(data.status, data.message, data.status);
						if (data.status == 'success') {
							_this3.$router.replace('/invoice_adjusts');
						}
					}).catch(function (error) {
						_this3.$swal('Error', 'Server not response. ' + error, 'error');
					});
				}
			});
		}
	}
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Price',
    created: function created() {
        this.getAll();
    },
    data: function data() {
        return {
            trash: false,
            dpdt: 'Active',
            model: {
                exchange_rate: '',
                wti: '',
                wcs: '',
                llk: '',
                llb: '',
                c5: '',
                aeco: '',
                placeholder_1: '',
                placeholder_2: '',
                month: 1,
                year: 2021,
                invoice_type_id: null
            },
            newIC: false,
            items: items,
            fields: [{
                key: 'id',
                label: 'ID',
                sortable: true
            }, {
                key: 'month_year',
                label: 'Month Year',
                sortable: true
            }, {
                key: 'exchange_rate',
                label: 'Exchange Rate',
                sortable: false
            }, {
                key: 'wti',
                label: 'WTI',
                sortable: false
            }, {
                key: 'wcs',
                label: 'WCS',
                sortable: false
            }, {
                key: 'llk',
                label: 'LLK',
                sortable: false
            }, {
                key: 'llb',
                label: 'LLB',
                sortable: false
            }, {
                key: 'c5',
                label: 'C5',
                sortable: false
            }, {
                key: 'aeco',
                label: 'AECO',
                sortable: false
            }, {
                key: 'placeholder_1',
                label: 'Placeholder 1',
                sortable: false
            }, {
                key: 'placeholder_2',
                label: 'Placeholder 2',
                sortable: false
            }, {
                key: 'invoice_type_name',
                label: 'Type',
                sortable: false
            }],
            currentPage: 1,
            perPage: 25,
            totalRows: items.length,
            pageOptions: [25, 50, 100],
            sortBy: 'id',
            sortDesc: false,
            filter: null,
            loadingData: true,
            savebtn: true,
            location_contract: [],
            years: [{ 'id': 2023, 'name': '2023' }, { 'id': 2022, 'name': '2022' }, { 'id': 2021, 'name': '2021' }, { 'id': 2019, 'name': '2020' }, { 'id': 2018, 'name': '2019' }],
            months: [{ 'id': 1, 'name': 'January' }, { 'id': 2, 'name': 'Frebuary' }, { 'id': 3, 'name': 'March' }, { 'id': 4, 'name': 'April' }, { 'id': 5, 'name': 'May' }, { 'id': 6, 'name': 'Jun' }, { 'id': 7, 'name': 'July' }, { 'id': 8, 'name': 'August' }, { 'id': 9, 'name': 'September' }, { 'id': 10, 'name': 'October' }, { 'id': 11, 'name': 'November' }, { 'id': 12, 'name': 'December' }],
            invoice_types: []
        };
    },

    computed: {
        sortOptions: function sortOptions() {
            return this.fields.filter(function (f) {
                return f.sortable;
            }).map(function (f) {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },
    methods: {
        onFiltered: function onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        newICModal: function newICModal() {
            this.model = {
                exchange_rate: '',
                wti: '',
                wcs: '',
                llk: '',
                llb: '',
                c5: '',
                aeco: '',
                placeholder_1: '',
                placeholder_2: '',
                month: 1,
                year: 2021,
                invoice_type_id: null
            };
            this.savebtn = false;
            this.newIC = true;
        },
        trashIC: function trashIC() {
            this.trash = !this.trash;
            this.dpdt = this.trash ? "Trash" : "Active";
            this.getAll();
            this.loadingData = true;
        },
        rowClicked: function rowClicked(row) {
            if (!this.trash) {
                this.$router.push('/invoice_price/' + row.id + '/');
            } else {
                this.restoreIC(row.id);
            }
        },
        okToSave: function okToSave() {
            if (this.model.placeholder_1 === undefined || this.model.placeholder_1.trim().length == 0) {
                this.$swal('Alert!', 'Placeholder 1 can not be empty', 'warning');
                return false;
            }
            if (this.model.placeholder_2 === undefined || this.model.placeholder_2.trim().length == 0) {
                this.$swal('Alert!', 'Placeholder 2 can not be empty', 'warning');
                return false;
            }
            if (this.model.aeco === undefined || this.model.aeco.trim().length == 0) {
                this.$swal('Alert!', 'AECO can not be empty', 'warning');
                return false;
            }
            if (this.model.c5 === undefined || this.model.c5.trim().length == 0) {
                this.$swal('Alert!', 'C5 can not be empty', 'warning');
                return false;
            }
            if (this.model.llb === undefined || this.model.llb.trim().length == 0) {
                this.$swal('Alert!', 'LLB can not be empty', 'warning');
                return false;
            }
            if (this.model.llk === undefined || this.model.llk.trim().length == 0) {
                this.$swal('Alert!', 'LLK can not be empty', 'warning');
                return false;
            }
            if (this.model.wcs === undefined || this.model.wcs.trim().length == 0) {
                this.$swal('Alert!', 'WCS can not be empty', 'warning');
                return false;
            }
            if (this.model.wti === undefined || this.model.wti.trim().length == 0) {
                this.$swal('Alert!', 'WTI can not be empty', 'warning');
                return false;
            }
            if (this.model.exchange_rate === undefined || this.model.exchange_rate.trim().length == 0) {
                this.$swal('Alert!', 'Exchange Rate can not be empty', 'warning');
                return false;
            }
            if (this.model.invoice_type_id === undefined || this.model.invoice_type_id === null) {
                this.$swal('Alert!', 'Select Type', 'warning');
                return false;
            }
            return true;
        },
        saveIC: function saveIC() {
            var _this = this;

            if (!this.okToSave()) {
                return;
            }
            console.log(this.model);
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].save_IC3(this.model).then(function (data) {
                _this.$swal(data.status, data.message, data.status).then(function (result) {
                    if (data.status == 'success') {
                        _this.newIC = false;
                        _this.getAll();
                    }
                });
            }).catch(function (error) {
                _this.$swal('Error', 'Server not response. ' + error, 'error');
            });
            this.savebtn = false;
        },
        getAll: function getAll() {
            var _this2 = this;

            this.loadingData = true;
            __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getAll_cp().then(function (data) {
                if (data.status == 'success') {
                    _this2.items = data.invoice_price.filter(function (o) {
                        return o.status_id == (_this2.trash ? 2 : 1);
                    });
                    _this2.invoice_types = data.invoice_types;
                    console.log(_this2.items);
                } else {
                    _this2.$swal(data.status, data.message, data.status);
                    _this2.loadingData = false;
                    return;
                }
                _this2.loadingData = false;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
                _this2.loadingData = false;
            });
        },
        restoreIC: function restoreIC(id) {
            var _this3 = this;

            this.$swal({
                title: 'Please, confirm',
                text: "Are you sure to restore this Price ?",
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                reverseButtons: true
            }).then(function (result) {
                if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].restore_iprice(id).then(function (data) {
                        _this3.$swal(data.status, data.message, data.status);
                        if (data.status == 'success') {
                            _this3.filter = '';
                            _this3.trash = false;
                            _this3.getAll();
                            _this3.loadingData = true;
                        }
                    }).catch(function (error) {
                        _this3.$swal('Error', 'Server not response. ' + error, 'error');
                    });
                }
            });
        },
        inputBlur: function inputBlur(variableName) {
            var variableValue = this.model[variableName];
            if (variableValue.length == 0) {

                this.model[variableName] = "0.00000";
            } else {
                if (variableValue.length == 1 && variableValue.indexOf("-") != -1) {

                    this.model[variableName] = "0.00000";
                    return;
                }
                var tempValue = variableValue.split(".");
                if (tempValue.length == 1) {

                    this.model[variableName] = String(variableValue) + ".00000";
                } else if (tempValue.length == 2) {

                    this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00000").slice(0, 5);
                }
            }
        },
        myOnlyNumber: function myOnlyNumber(evt, variableName) {
            var dotPosition = this.model[variableName].indexOf(".");
            var hasDot = dotPosition > -1;
            var length = this.model[variableName].length;
            this.isNumber(evt, hasDot, dotPosition, length, 5);
        },

        isNumber: function isNumber(evt, hasDot, dotPosition, length, n_digit) {

            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode <= 31 || charCode === 189 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
                var selectionStart = evt.target.selectionStart;
                var selectionEnd = evt.target.selectionEnd;
                if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - n_digit > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
                    evt.preventDefault();
                } else {
                    if (charCode == 189) {
                        if (length != 0) {
                            evt.preventDefault();
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }
            } else {
                evt.preventDefault();
            }
        }
    }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_service__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvoicePrice',
  created: function created() {
    this.getCompanyData();
  },
  props: {
    id: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      subTitle: '',
      edit: false,
      found: false,
      notFoundMessage: 'Not found',
      model: {
        exchange_rate: '',
        wti: '',
        wcs: '',
        llk: '',
        llb: '',
        c5: '',
        aeco: '',
        placeholder_1: '',
        placeholder_2: '',
        month: 1,
        year: 2021,
        month_year: '',
        invoice_type_id: null
      },
      updateData: null,
      originalData: null,
      loadingData: true,
      years: [{ 'id': 2023, 'name': '2023' }, { 'id': 2022, 'name': '2022' }, { 'id': 2021, 'name': '2021' }, { 'id': 2019, 'name': '2020' }, { 'id': 2018, 'name': '2019' }],
      months: [{ 'id': 1, 'name': 'January' }, { 'id': 2, 'name': 'Frebuary' }, { 'id': 3, 'name': 'March' }, { 'id': 4, 'name': 'April' }, { 'id': 5, 'name': 'May' }, { 'id': 6, 'name': 'Jun' }, { 'id': 7, 'name': 'July' }, { 'id': 8, 'name': 'August' }, { 'id': 9, 'name': 'September' }, { 'id': 10, 'name': 'October' }, { 'id': 11, 'name': 'November' }, { 'id': 12, 'name': 'December' }],
      invoice_types: []
    };
  },

  methods: {
    editTdg: function editTdg() {
      if (this.edit) {
        this.edit = false;
        this.restoreOriginalData();
      } else {
        this.edit = true;
      }
    },
    restoreOriginalData: function restoreOriginalData() {
      var model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.originalData);
      this.model = model;
    },
    getCompanyData: function getCompanyData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].getBy_iprice(this.id).then(function (data) {
        if (data.status == 'success') {
          _this.originalData = data.invoice_price;
          _this.invoice_types = data.invoice_types;
          console.log(_this.originalData);

          _this.companyId = _this.id;
          _this.loadingData = false;
          _this.found = true;
          _this.restoreOriginalData();
          _this.subTitle = _this.companyId;
        } else {
          _this.$swal(data.status, data.message, data.status);
          _this.loadingData = false;
          return;
        }
      }).catch(function (error) {
        _this.$swal('Error', 'Server not response. ' + error, 'error');
        _this.loadingData = false;
      });
    },
    okToUpdate: function okToUpdate() {
      if (this.model.placeholder_1 === undefined || this.model.placeholder_1.trim().length == 0) {
        this.$swal('Alert!', 'Placeholder 1 can not be empty', 'warning');
        return false;
      }
      if (this.model.placeholder_2 === undefined || this.model.placeholder_2.trim().length == 0) {
        this.$swal('Alert!', 'Placeholder 2 can not be empty', 'warning');
        return false;
      }
      if (this.model.aeco === undefined || this.model.aeco.trim().length == 0) {
        this.$swal('Alert!', 'AECO can not be empty', 'warning');
        return false;
      }
      if (this.model.c5 === undefined || this.model.c5.trim().length == 0) {
        this.$swal('Alert!', 'C5 can not be empty', 'warning');
        return false;
      }
      if (this.model.llb === undefined || this.model.llb.trim().length == 0) {
        this.$swal('Alert!', 'LLB can not be empty', 'warning');
        return false;
      }
      if (this.model.llk === undefined || this.model.llk.trim().length == 0) {
        this.$swal('Alert!', 'LLK can not be empty', 'warning');
        return false;
      }
      if (this.model.wcs === undefined || this.model.wcs.trim().length == 0) {
        this.$swal('Alert!', 'WCS can not be empty', 'warning');
        return false;
      }
      if (this.model.wti === undefined || this.model.wti.trim().length == 0) {
        this.$swal('Alert!', 'WTI can not be empty', 'warning');
        return false;
      }
      if (this.model.exchange_rate === undefined || this.model.exchange_rate.trim().length == 0) {
        this.$swal('Alert!', 'Exchange Rate can not be empty', 'warning');
        return false;
      }
      if (this.model.invoice_type_id === undefined || this.model.invoice_type_id === null) {
        this.$swal('Alert!', 'Select Type', 'warning');
        return false;
      }
      return true;
    },
    update: function update() {
      var _this2 = this;

      if (!this.okToUpdate()) {
        return;
      }
      console.log(this.model);
      __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].update_iprice(this.companyId, this.model).then(function (data) {
        _this2.$swal(data.status, data.message, data.status).then(function (result) {
          _this2.getCompanyData();
        });
      }).catch(function (error) {
        _this2.$swal('Error', 'Server not response. ' + error, 'error');
      });
      this.edit = false;
    },
    deleteTdg: function deleteTdg() {
      var _this3 = this;

      this.$swal({
        title: 'Please, confirm',
        text: "Are you sure to delete this Invoice Price: " + this.model.month_year + " ?",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__invoices_service__["a" /* default */].delete_iprice(_this3.companyId).then(function (data) {
            _this3.$swal(data.status, data.message, data.status);
            if (data.status == 'success') {
              _this3.$router.replace('/invoice_prices');
            }
          }).catch(function (error) {
            _this3.$swal('Error', 'Server not response. ' + error, 'error');
          });
        }
      });
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.model[variableName];
      if (variableValue.length == 0) {

        this.model[variableName] = "0.00000";
      } else {
        if (variableValue.length == 1 && variableValue.indexOf("-") != -1) {

          this.model[variableName] = "0.00000";
          return;
        }
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {

          this.model[variableName] = String(variableValue) + ".00000";
        } else if (tempValue.length == 2) {

          this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00000").slice(0, 5);
        }
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.model[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.model[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length, 5);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length, n_digit) {

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode === 189 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - n_digit > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          if (charCode == 189) {
            if (length != 0) {
              evt.preventDefault();
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      } else {
        evt.preventDefault();
      }
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__agreements_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_users_service__ = __webpack_require__(23);












__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__["a" /* default */]);

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HaulsPending',
  created: function created() {
    var _this = this;

    this.$root.$on('haul_Updated', function () {
      _this.getAll();
    });
    this.getAll();
  },
  props: {
    id: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    var _this2 = this,
        _newHaul,
        _ref;

    return _ref = {
      allSelected: false,
      tableValues: [],
      status: 'unchecked',
      haul_ids: [],
      haul_iidds: [],
      haul_iiddss: [],
      selected: '',
      row: 0,
      loadingData: true,
      companyName: '',
      companyId: null,
      configTable: false,

      items: items,
      itemsAll: items,
      totalRows: items.length,
      v_items: null,
      fieldsSelected: 8,
      maxFieldsSelected: 24,
      tempFields: [],
      fields: [{
        key: 'select_haul',
        label: 'Select',
        thClass: 'select_column', tdClass: 'select_column'
      }, {
        key: 'ticket',
        label: 'Ticket #',
        sortable: true
      }, {
        key: 'energy_company',
        label: 'Energy Company',
        sortable: true
      }, {
        key: 'trucking_company',
        label: 'Trucking Company',
        sortable: true
      }, {
        key: 'unload_location',
        label: 'Unload',
        sortable: false
      }, {
        key: 'load_location',
        label: 'Load',
        sortable: false
      }, {
        key: 'volume_actual',
        label: 'Deliveries',
        sortable: true,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(parseFloat(value).toFixed(2) * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'bsw',
        label: 'BS&W (%)',
        sortable: false,
        formatter: function formatter(value) {
          return parseFloat(value).toFixed(2);
        }
      }, {
        key: 'oil_actual',
        label: 'Oil',
        sortable: false,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(parseFloat(value).toFixed(2) * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          }return value;
        }
      }, {
        key: 'water_actual',
        label: 'Water',
        sortable: false,
        formatter: function formatter(value) {
          if (_this2.bbll == true) {
            value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
          } else {
            value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
          };return value;
        }
      }, {
        key: 'haul_start_date',
        label: 'Start Date',
        sortable: true,
        formatter: function formatter(value) {
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(value).format("MMM DD, YYYY");
        }
      }],
      currentPage: 1,
      perPage: 25,

      pageOptions: [25, 50, 100],
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      },
      modalEdit: {
        title: ''
      },
      selectedItems: ['energy_company', 'trucking_company', 'unload_location', 'ticket', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'haul_start_date'],
      role: '',
      savebtn: true,
      energy_company_id: null,
      unit: '',
      fromHaul: 0,
      bbll: false,
      myToggle: false,
      filter_by: { "initial_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('week').format('YYYY-MM-DD'), "end_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf('week').format('YYYY-MM-DD'), "truck_id": "", "trucking_company_id": "", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column": ['ticket', 'energy_company', 'trucking_company', 'unload_location', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual', 'haul_start_date']
      },
      energy_companies_filter: '',

      load_locations_filter: '',
      unload_locations_filter: '',
      drivers_filter: '            ',
      trucks_filter: '',
      trucking_companies_filter: '',
      invoices_filter: [],

      filters_save: {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_id: 0,
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',

        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: ''
      },

      filename: 'hauls_discrenpacy_' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYYMMDDHHMM') + '.csv',
      json_fields: {
        "haul_id": "haul_id",
        "energy_company": "energy_company",
        "trucking_company": "trucking_company",
        "ticket": "ticket",
        "unload_location": "unload_location",
        "load_location": "load_location",
        "volume_actual": "volume_actual",
        "bsw": "bsw",
        "oil_actual": "oil_actual",
        "energy_company_unload": "energy_company_unload",
        "unload_location_unload": "unload_location_unload",
        "volume_actual_unload": "volume_actual_unload",
        "bsw_unload": "bsw_unload",
        "oil_unload": "oil_unload"
      },
      items_csv: [],
      modalInvoice: false,
      invoiceOptions: [],
      invoiceHauls: [],
      newModal: false,
      model: {
        id: null,
        energy_company_id: null,
        trucking_company_id: null,
        invoice_id: null
      },
      company_name: [],
      energy_companies: [],
      sendbtn: true,
      newHaul: (_newHaul = {
        water_actual: "",
        water_percentage_estimate: "",
        oil_actual: "",
        volume_estimate: "",
        truck_company_select: [],
        driver_select: [],
        energy_company_select: [],
        unload_location_select: [],
        fluid_type_select: [],
        load_location_select: [],
        loads_locations: [],
        truck_select: [],
        truck_unit_select: [],

        companyName: '',
        load_location: '',
        loadingData: true,
        unload_location: '',
        haul_start_date: '',

        truck_company_id: '',
        load_location_id: '',
        user_id: '',
        full_name: '',
        truck_id: '',
        truck_unit_id: '',
        trucking_company_id: '',
        energy_companies_id: '',
        unload_location_id: '',
        fluid_type_id: '',
        water_percentage_actual: ''
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'water_percentage_estimate', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'volume_actual', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'volume_estimate', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_end_datetime', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_start_datetime', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_end_time', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'haul_start_time', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'chain_up', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'comments_start', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'comments_end', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'wait_times_csv', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'wait_times', [{
        "type_id": "3",
        "time": "00:00",
        "comments": ""
      }, {
        "type_id": "4",
        "time": "00:00",
        "comments": ""
      }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 'ticket', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 't_ticket', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_newHaul, 't_boss', ''), _newHaul),
      newEC: false,
      insert_data: { 'trucking_companies': [] },
      haul_updated: false
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'allSelected', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'Approved', 'Show Approved'), _ref;
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  },
  methods: {
    selectAllHauls: function selectAllHauls() {
      if (!this.allSelected) {
        this.toggleAllSelected();
      }
    },
    unselectAllHauls: function unselectAllHauls() {
      if (this.haul_ids.length > 0) {
        this.haul_ids = [];

        var tmp1 = this.tableValues.map(function (item) {
          return item.haul_id;
        });
        var tmp = this.haul_ids;
        var tmp2 = this.array_diff(tmp, tmp1);
        this.haul_ids = tmp2;
      }
    },
    toggleAllSelected: function toggleAllSelected() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        this.haul_ids = [];
        this.haul_ids = this.items.map(function (item) {
          return item.haul_id;
        });
      } else {
        this.haul_ids = [];
      }
    },
    array_diff: function array_diff(tmp, tmp1) {
      return tmp.filter(function (elemento) {
        return tmp1.indexOf(elemento) == -1;
      });
    },
    checkedField: function checkedField(row) {
      if (this.haul_ids.includes(row.item.haul_id)) {
        var index = this.haul_ids.indexOf(row.item.haul_id);
        if (index > -1) {
          this.haul_ids.splice(index, 1);
        }
      } else {
        this.haul_ids.push(row.item.haul_id);
      }
    },
    activate_custom_backdrop: function activate_custom_backdrop() {
      this.$root.$el.classList.add("custom_backdrop_behavior");
    },
    deactivate_custom_backdrop: function deactivate_custom_backdrop() {
      this.$root.$el.classList.remove("custom_backdrop_behavior");
    },
    openSelectColumns: function openSelectColumns() {
      this.tempFields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fields));
      this.configTable = true;
    },
    saveSelectedColumns: function saveSelectedColumns() {
      var _this3 = this;

      this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.tempFields));
      this.configTable = false;
      this.filter_by.column = this.fields.map(function (item) {
        return item.key;
      });
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].saveSelectedColumns(this.fields).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this3.getAll();
          }
        });
      });
    },
    shouldBeDisabled: function shouldBeDisabled(option) {
      return this.fieldsSelected >= this.maxFieldsSelected && this.tempFields.map(function (o) {
        return o.key;
      }).indexOf(option) == -1;
    },
    actionField: function actionField(option, label, position) {
      var _this4 = this;

      var fieldsLength = this.tempFields.length;
      var fieldIsActive = false;
      for (var i = 0; i <= fieldsLength; i++) {
        fieldIsActive = true;
        try {
          if (this.tempFields[i].key === option || this.tempFields[i] === option) {
            this.tempFields.splice(i, 1);
            fieldIsActive = false;
            break;
          }
        } catch (err) {

          if (option == 'haul_start_date' || option == 'haul_end_date') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                return __WEBPACK_IMPORTED_MODULE_7_moment___default()(value).format("MMM DD, YYYY");
              }
            };
          } else if (option == 'oil_actual' || option == 'volume_actual' || option == 'water_actual' || option == 'volume_estimate') {
            option = {
              key: option,
              label: label,
              sortable: true,
              formatter: function formatter(value) {
                if (_this4.bbll == true) {
                  value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
                } else {
                  value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
                };return value;
              }
            };
          } else {
            option = {
              key: option,
              label: label,
              sortable: true
            };
          }
          this.tempFields.splice(position, 0, option);
        }
      }
      this.fieldsSelected = this.tempFields.length;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll: function getAll() {
      var _this5 = this;

      this.items = [];

      __WEBPACK_IMPORTED_MODULE_5__agreements_service__["a" /* default */].getPendingDetail(this.id).then(function (data) {
        if (data.status == 'success') {
          _this5.items = data.hauls_pending;
          _this5.items_csv = _this5.items;
          _this5.itemsAll = _this5.items;
          _this5.role = data.role;
          _this5.company_name = data.trucking_companies;
          _this5.haul_ids = [];
          _this5.allSelected = false;
          _this5.getAll1();
        } else {
          _this5.$swal(data.status, data.message, data.status);
          _this5.loadingData = false;
          return;
        }
        _this5.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this5.loadingData = false;
      });
    },
    getAll1: function getAll1() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getAll1().then(function (data) {
        if (data.status == 'success') {

          _this6.energy_companies_filter = data.energy_companies_filter;

          _this6.load_locations_filter = data.load_locations_filter;
          _this6.unload_locations_filter = data.unload_locations_filter;

          _this6.trucking_companies_filter = data.trucking_companies_filter;

          _this6.bbll = data.bbl;

          if (_this6.role == 'operations_manager') {
            _this6.fields = [{
              key: 'haul_id',
              label: 'ID',
              sortable: false
            }, {
              key: 'unload_location',
              label: 'Unload',
              sortable: false
            }, {
              key: 'ticket',
              label: 'Ticket #',
              sortable: false
            }, {
              key: 'load_location',
              label: 'Load',
              sortable: false
            }, {
              key: 'volume_actual',
              label: 'Deliveries',
              sortable: true
            }, {
              key: 'bsw',
              label: 'BS&W (%)',
              sortable: false
            }, {
              key: 'oil_actual',
              label: 'Oil',
              sortable: false
            }, {
              key: 'drivers_filter',
              label: '            '
            }, { key: 'unload_location_unload', label: 'Unload', sortable: false
            }, { key: 'volume_actual_unload', label: 'Total Volume at Unload', sortable: true
            }, { key: 'bsw_unload', label: 'BS&W at Unload', sortable: false
            }, { key: 'oil_unload', label: 'Oil at Unload', sortable: false
            }, { key: 'action', label: 'Action' }];
          }
        } else {

          _this6.$swal(data.status, data.message, data.status);
          _this6.loadingData = false;
          return;
        }
        _this6.loadingData = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
        _this6.loadingData = false;
      });
    },
    reformat: function reformat(value) {
      if (value.indexOf('%') != -1) {
        return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
      } else if (value.indexOf('km') != -1) {
        return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km";
      } else {
        return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    ecFilter: function ecFilter(ec_filter, id) {
      this.filter_by['energy_companies_id'] = id;

      if (id == 0) {
        this.filter_by['energy_companies_id'] = '';
      }
      this.filters_save.energy_company_name = ec_filter;
      this.filters_save.energy_companies_id = id;
      this.getAll();

      this.loadingData = true;
    },
    dFilter: function dFilter(d_filter, id) {
      this.filter_by['users_id'] = id;
      if (id == 0) {
        this.filter_by['users_id'] = '';
      }
      this.filters_save.driver_name = d_filter;
      this.filters_save.users_id = id;
      this.getAll();

      this.loadingData = true;
    },
    tcFilter: function tcFilter(tc_filter, id) {
      this.filter_by['trucking_company_id'] = id;
      if (id == 0) {
        this.filter_by['trucking_company_id'] = '';
      }
      this.filters_save.trucking_company_name = tc_filter;
      this.filters_save.trucking_company_id = id;
      this.getAll();

      this.loadingData = true;
    },
    lFilter: function lFilter(l_filter, id) {
      this.filter_by['load_location_id'] = id;
      if (id == 0) {
        this.filter_by['load_location_id'] = '';
      }
      this.filters_save.load_name = l_filter;
      this.filters_save.load_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    uFilter: function uFilter(u_filter, id) {
      this.filter_by['unload_location_id'] = id;
      if (id == 0) {
        this.filter_by['unload_location_id'] = '';
      }
      this.filters_save.unload_name = u_filter;
      this.filters_save.unload_location_id = id;
      this.getAll();

      this.loadingData = true;
    },
    iFilter: function iFilter(a) {
      if (this.filter_by['end_date'] == '' || !this.filter_by['end_date']) {
        this.filter_by['end_date'] = '';
        this.filters_save.end_date = '';
      }
      this.filter_by.initial_date = a;
      this.filters_save.initial_date = this.filter_by.initial_date;
      this.getAll();

      this.loadingData = true;
    },
    eFilter: function eFilter(a) {
      if (this.filter_by['initial_date'] == '' || !this.filter_by['initial_date']) {
        this.filter_by['initial_date'] = '';
        this.filters_save.initial_date = '';
      }
      this.filter_by.end_date = a;
      this.filters_save.end_date = this.filter_by.end_date;
      this.getAll();

      this.loadingData = true;
    },
    tFilter: function tFilter(t_filter, id) {
      this.filter_by['truck_id'] = id;
      if (id == 0) {
        this.filter_by['truck_id'] = '';
      }
      this.filters_save.truck_name = t_filter;
      this.filters_save.truck_id = id;
      this.getAll();

      this.loadingData = true;
    },
    inFilter: function inFilter(t_filter, id) {
      this.filter_by['invoice_id'] = id;
      if (id == 0) {
        this.filter_by['invoice_id'] = '';
      }
      this.filters_save.invoice_name = t_filter;
      this.filters_save.invoice_id = id;
      this.getAll();

      this.loadingData = true;
    },
    ivFilter: function ivFilter(t_filter, id) {
      this.filter_by['invoic_id'] = id;
      if (id == 0) {
        this.filter_by['invoic_id'] = '';
      }
      this.filters_save.invoic_name = t_filter;
      this.filters_save.invoic_id = id;
      this.getAll();

      this.loadingData = true;
    },
    clearFilters: function clearFilters() {
      this.filter_by = { "initial_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('week').format('YYYY-MM-DD'),
        "end_date": __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf('week').format('YYYY-MM-DD'),
        "truck_id": "",
        "trucking_company_id": "",
        "users_id": "",
        "unload_location_id": "",
        "energy_companies_id": "",
        "load_location_id": "",
        "column": ['ticket', 'energy_company', 'trucking_company', 'unload_location', 'load_location', 'volume_actual', 'bsw', 'oil_actual', 'water_actual']
      };
      this.filters_save = {
        energy_companies_id: 0,
        energy_company_name: 'All Energy Companies',
        users_id: 0,
        driver_name: 'All Drivers',
        trucking_company_id: 0,
        truck_id: 0,
        truck_name: 'All Trucks',
        trucking_company_name: 'All Trucking Companies',
        load_location_id: 0,
        load_name: 'All Loads',
        unload_location_id: 0,
        unload_name: 'All Unloads',
        initial_date: '',
        end_date: '',
        flag_name: 'All Flags',
        invoice_id: 0,
        invoice_name: 'Hauls Without Invoice',
        invoic_id: 0,
        invoic_name: 'All Invoices'
      };

      this.Approved = 'Show Approved';
      this.getAll();

      this.loadingData = true;
    },
    rowClicked: function rowClicked(row, index, e) {
      e.preventDefault();
      var to_popup = { 'id': row.haul_id, 'haul_invoice': true, 'edit': '' };
      this.$root.$emit('openPopup', to_popup);
    },
    bbl: function bbl() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_8__users_users_service__["a" /* default */].bbl().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this7.loadingData = true;
            _this7.getAll();
          }
        });
      });
    },
    form: function form(value) {
      if (value !== '--') {
        if (this.bbll == true) {
          value = Number(value * 6.289814).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' bbl';
        } else {
          value = Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m³';
        };return value;
      } else {
        return value;
      }
    },
    form1: function form1(value) {
      if (value !== '--') {
        return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';
      } else {
        return value;
      }
    },
    openModal: function openModal() {
      var _this8 = this;

      this.invoiceOptions = [];
      var invoices_to_save = this.invoices_filter;
      invoices_to_save.map(function (item) {
        var item_data = {};
        item_data['value'] = item.id;
        item_data['text'] = item.invoice_ref;
        _this8.invoiceOptions.push(item_data);
      });
      this.modalInvoice = true;
    },
    addHaulsInvoice: function addHaulsInvoice() {
      var _this9 = this;

      if (!this.okToSave()) {
        return;
      }
      this.invoiceHauls = [];
      this.haul_ids.map(function (item) {
        var item_data = {};
        item_data['invoice_id'] = _this9.selected;
        item_data['haul_id'] = item;
        _this9.invoiceHauls.push(item_data);
      });
      __WEBPACK_IMPORTED_MODULE_5__agreements_service__["a" /* default */].addHaulsInvoice(this.invoiceHauls).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this9.haul_ids = [];
          _this9.selected = '';
          _this9.modalInvoice = false;
          _this9.getAll();
          _this9.loadingData = true;
        } else {
          _this9.selected = '';
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this9.modalInvoice = false;
        }
      });
    },
    okToSave: function okToSave() {
      if (this.selected === undefined || this.selected === '') {
        this.$swal('Alert!', 'Invoice not selected', 'warning');
        return false;
      }
      return true;
    },
    send_notification_click: function send_notification_click() {
      this.sendbtn = false;
      this.model.energy_company_id = null;
      this.model.invoice_id = null;
      this.newModal = true;
      if (this.role === 'super_admin') {
        this.model.trucking_company_id = null;
      }
    },
    send_click: function send_click() {
      var _this10 = this;

      if (!this.okToSend()) {
        return;
      }
      var column = this.fields.map(function (item) {
        return item.key;
      });
      var send_invoice = {
        "energy_company_id": this.model.energy_company_id,
        "trucking_company_id": this.model.trucking_company_id,
        "invoice_id": this.model.invoice_id,
        "column": column
      };
      __WEBPACK_IMPORTED_MODULE_5__agreements_service__["a" /* default */].send_invoice(send_invoice).then(function (data) {
        if (data.status == 'success') {
          _this10.$swal(data.status, data.message, data.status);
        } else {
          _this10.$swal(data.status, data.message, data.status);
          return;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.sendbtn = true;
      this.newModal = false;
    },
    selects_trucking_company_1: function selects_trucking_company_1() {
      var trucking_companies = this.company_name;
      this.energy_companies = [];
      this.model.energy_company_id = null;
      if (trucking_companies.length > 0) {
        var trucking_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.model.trucking_company_id);
        if (trucking_company_index > -1) {
          this.energy_companies = trucking_companies[trucking_company_index].energy_companies;
        }
      }
    },
    hideNewModal: function hideNewModal() {
      this.$refs.newModal.hide();
    },
    okToSend: function okToSend() {
      if (this.model.trucking_company_id === undefined || this.model.trucking_company_id === null) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.model.energy_company_id === undefined || this.model.energy_company_id === null) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.model.invoice_id === undefined || this.model.invoice_id == null) {
        this.$swal('Alert!', 'Invoice Ref not selected', 'warning');
        return false;
      }
      return true;
    },
    showNewHaulModal: function showNewHaulModal() {
      this.savebtn = false;
      this.newHaul.truck_company_select = [];
      this.newHaul.driver_select = [];
      this.newHaul.energy_company_select = [];
      this.newHaul.unload_location_select = [];
      this.newHaul.fluid_type_select = [];
      this.newHaul.load_location_select = [];
      this.newHaul.truck_select = [];

      this.newHaul.truck_company_id = '';
      this.newHaul.load_location_id = '';
      this.newHaul.user_id = '';
      this.newHaul.full_name = '';
      this.newHaul.truck_id = '';
      this.newHaul.energy_companies_id = '';
      this.newHaul.unload_location_id = '';
      this.newHaul.fluid_type_id = '';

      this.newHaul.comments_start = '';
      this.newHaul.comments_end = '';

      this.water_percentage_actual = '';
      this.water_percentage_estimate = '';
      this.volume_actual = '';
      this.volume_estimate = '';
      var tempDate = new Date();
      var tempDateTime = String(tempDate.getFullYear()) + "-" + ("0" + String(tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempDate.getDate())).slice(-2);
      var tempTime = ("0" + String(tempDate.getHours())).slice(-2) + ":" + ("0" + String(tempDate.getMinutes())).slice(-2);

      this.newHaul.haul_end_datetime = '';
      this.newHaul.haul_start_datetime = '';
      this.newHaul.haul_end_time = tempTime;
      this.newHaul.haul_start_time = tempTime;
      this.newHaul.chain_up = false;
      this.newHaul.t_ticket = '';
      this.newHaul.t_boss = '';
      if (this.role == 'super_admin') {
        if (this.insert_data.trucking_companies.length > 0) {
          var trucking_companies = this.insert_data.trucking_companies;
          this.newHaul.truck_company_select = trucking_companies.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
        } else {
          this.get_trucking_companies();
        }
      } else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        if (this.insert_data.trucking_companies.length > 0) {
          this.selects_trucking_company();
        } else {
          this.get_trucking_companies();
          this.selects_trucking_company();
        }
      }
      this.newEC = true;
    },
    addWaitTime: function addWaitTime() {
      this.newHaul.wait_times.push({
        "type_id": "5",
        "time": "00:00",
        "comments": ""
      });
    },
    hmsToSecondsOnly: function hmsToSecondsOnly(str) {
      var p = str.split(':'),
          s = 0,
          m = 1;

      while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
      }
      s *= 60;
      return s;
    },
    waitTimeLabel: function waitTimeLabel(wait_time) {
      var wait_times_label = [{
        type_id: "3",
        label: "Wait Time To Load"
      }, {
        type_id: "4",
        label: "Wait Time To Unload"
      }];
      var myIndex = wait_times_label.map(function (o) {
        return o.type_id;
      }).indexOf(wait_time.type_id);
      if (myIndex > -1) {
        return wait_times_label[myIndex].label;
      }
      return "Other Wait Time";
    },
    hideNewHaulModal: function hideNewHaulModal() {
      this.$refs.newHaulModal.hide();
    },
    okToSave_h: function okToSave_h() {
      if (this.newHaul.energy_companies_id === undefined || this.newHaul.energy_companies_id.length == 0) {
        this.$swal('Alert!', 'Energy Company not selected', 'warning');
        return false;
      } else if (this.newHaul.fluid_type_id === undefined || this.newHaul.fluid_type_id.length == 0) {
        this.$swal('Alert!', 'Fluid Type not selected', 'warning');
        return false;
      } else if (this.newHaul.load_location_id === undefined || this.newHaul.load_location_id.length == 0) {
        this.$swal('Alert!', 'Load Location not selected', 'warning');
        return false;
      } else if (this.newHaul.truck_company_id === undefined || this.newHaul.truck_company_id.length == 0) {
        this.$swal('Alert!', 'Trucking Company not selected', 'warning');
        return false;
      } else if (this.newHaul.unload_location_id === undefined || this.newHaul.unload_location_id.length == 0) {
        this.$swal('Alert!', 'Unload Location not selected', 'warning');
        return false;
      } else if (this.newHaul.user_id === undefined || this.newHaul.user_id.length == 0) {
        this.$swal('Alert!', 'Driver not selected', 'warning');
        return false;
      } else if (this.newHaul.truck_id === undefined || this.newHaul.truck_id.length == 0) {
        this.$swal('Alert!', 'Truck not selected', 'warning');
        return false;
      } else if (this.newHaul.volume_actual === undefined || this.newHaul.volume_actual.length == 0) {
        this.$swal('Alert!', 'Volume Actual can not be empty', 'warning');
        return false;
      } else if (this.newHaul.volume_actual < 5) {
        this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning');
        return false;
      } else if (this.newHaul.ticket === undefined || this.newHaul.ticket.length == 0) {
        this.$swal('Alert!', 'Ticket can not be empty', 'warning');
        return false;
      }

      try {
        var startDateValidation = new Date(this.newHaul.haul_start_datetime).getFullYear();
        if (startDateValidation <= 2000 || startDateValidation >= 2100) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'Start Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      try {
        var endDateValidation = new Date(this.newHaul.haul_end_datetime).getFullYear();
        if (endDateValidation <= 2000 || endDateValidation >= 2100) {
          throw '';
        }
      } catch (error) {
        this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning');
        return false;
      }

      return true;
    },
    saveHaul: function saveHaul() {
      var _this11 = this;

      this.inputBlur('water_percentage_actual');
      this.inputBlur('water_percentage_estimate');
      this.inputBlur('volume_actual');
      this.inputBlur('volume_estimate');
      if (!this.okToSave_h()) {
        return;
      }
      this.savebtn = true;
      var tempStartDateTime = new Date((this.newHaul.haul_start_datetime + " " + this.newHaul.haul_start_time).replace(/-/g, "/"));
      var tempEndDateTime = new Date((this.newHaul.haul_end_datetime + " " + this.newHaul.haul_end_time).replace(/-/g, "/"));

      var haul_start_datetime = String(tempStartDateTime.getFullYear()) + "-" + ("0" + String(tempStartDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempStartDateTime.getDate())).slice(-2) + " " + tempStartDateTime.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });
      var haul_end_datetime = String(tempEndDateTime.getFullYear()) + "-" + ("0" + String(tempEndDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempEndDateTime.getDate())).slice(-2) + " " + tempEndDateTime.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      });

      var saveData = {
        "energy_companies_id": String(this.newHaul.energy_companies_id),
        "users_id": String(this.newHaul.user_id),
        "fluid_type_id": String(this.newHaul.fluid_type_id),
        "load_location_id": String(this.newHaul.load_location_id),
        "unload_location_id": String(this.newHaul.unload_location_id),
        "truck_id": String(this.newHaul.truck_id),
        "trucks_unit_id": String(this.newHaul.truck_unit_id),
        "haul_start_datetime": haul_start_datetime,
        "haul_end_datetime": haul_end_datetime,
        "volume_estimate": String(this.newHaul.volume_estimate),
        "volume_actual": String(this.newHaul.volume_actual),
        "water_percentage_estimate": String(this.newHaul.water_percentage_estimate),
        "water_percentage_actual": String(this.newHaul.water_percentage_actual),
        "terminal_ticket": String(this.newHaul.t_ticket),
        "truck_ticket": String(this.newHaul.ticket),
        "terminal_boss_ticket_id": String(this.newHaul.t_boss),
        "chain_up_required": this.newHaul.chain_up,
        "total_distance": "0",
        "comments_start": String(this.newHaul.comments_start),
        "comments_end": String(this.newHaul.comments_end),
        "waypoints": "",
        "trip_pictures": "",
        "wait_times": this.newHaul.wait_times.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            time: _this11.hmsToSecondsOnly(item.time)
          });
        })
      };
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].save(saveData).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data[0], data[1], data[0]).then(function (result) {
          if (data[0] == 'success') {
            _this11.newEC = false;
            _this11.getAll();
          }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal('Error', 'Server not response. ' + error, 'error');
      });
      this.savebtn = false;
    },
    inputBlur: function inputBlur(variableName) {
      var variableValue = this.newHaul[variableName];
      if (variableValue.length == 0) {
        this.newHaul[variableName] = "0.00";
      } else {
        var tempValue = variableValue.split(".");
        if (tempValue.length == 1) {
          this.newHaul[variableName] = String(variableValue) + ".00";
        } else if (tempValue.length == 2) {
          this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2);
        }
      }
    },
    get_trucking_companies: function get_trucking_companies() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].get_trucking_hauls().then(function (data) {
        if (data.status == 'success') {
          _this12.insert_data = data.insert_data;
          var trucking_companies = _this12.insert_data.trucking_companies;
          if (_this12.role == 'super_admin') {

            _this12.newHaul.truck_company_select = trucking_companies.map(function (item) {
              return {
                'value': item.id,
                'text': item.name
              };
            });
          } else if (_this12.role == 'trucking_company_admin' || _this12.role == 'trucking_operational_manager') {
            if (trucking_companies.length > 0) {
              _this12.newHaul.truck_company_id = trucking_companies[0].id;

              var drivers = trucking_companies[0]['drivers'];

              _this12.newHaul.driver_select = drivers.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.name
                };
              });
              var trucks = trucking_companies[0]['trucks'];
              _this12.newHaul.truck_select = trucks.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.truck_name
                };
              });
              var truck_units = trucking_companies[0]['truck_units'];
              _this12.newHaul.truck_unit_select = truck_units.map(function (item) {
                return {
                  'value': item.id,
                  'text': item.truck_unit
                };
              });
              if (_this12.newHaul.truck_unit_select.length == 1) {
                _this12.newHaul.truck_unit = _this12.newHaul.truck_select[0].text;
                _this12.newHaul.truck_unit_id = _this12.newHaul.truck_select[0].value;
              }

              if (_this12.newHaul.driver_select.length == 1) {
                _this12.newHaul.full_name = _this12.newHaul.driver_select[0].text;
                _this12.newHaul.user_id = _this12.newHaul.driver_select[0].value;
              }
              if (_this12.newHaul.truck_select.length == 1) {
                _this12.newHaul.truck = _this12.newHaul.truck_select[0].text;
                _this12.newHaul.truck_id = _this12.newHaul.truck_select[0].value;
              }
            }
          }
        } else {
          _this12.$swal(data.status, data.message, data.status);
        }
      }).catch(function (error) {
        _this12.$swal('Error', 'Server not response. ' + error, 'error');
      });
    },
    selects_trucking_company: function selects_trucking_company() {

      if (this.role == 'super_admin') {
        this.newHaul.user_id = '';
        this.newHaul.full_name = '';
        this.newHaul.truck_id = '';
        this.newHaul.truck = '';
        this.newHaul.truck_unit_id = '';
        this.newHaul.truck_unit = '';
        var trucking_companies = this.insert_data.trucking_companies;

        var current_truck_company_index = trucking_companies.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.truck_company_id);
        if (current_truck_company_index > -1) {
          var drivers = trucking_companies[current_truck_company_index]['drivers'];
          this.newHaul.driver_select = drivers.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
          var trucks = trucking_companies[current_truck_company_index]['trucks'];
          this.newHaul.truck_select = trucks.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_name
            };
          });
          var truck_units = trucking_companies[current_truck_company_index]['truck_units'];
          this.newHaul.truck_unit_select = truck_units.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_unit
            };
          });
          if (this.newHaul.truck_unit_select.length == 1) {
            this.newHaul.truck_unit = this.newHaul.truck_select[0].text;
            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value;
          }

          if (this.newHaul.driver_select.length == 1) {
            this.newHaul.full_name = this.newHaul.driver_select[0].text;
            this.newHaul.user_id = this.newHaul.driver_select[0].value;
          }
          if (this.newHaul.truck_select.length == 1) {
            this.newHaul.truck = this.newHaul.truck_select[0].text;
            this.newHaul.truck_id = this.newHaul.truck_select[0].value;
          }
        }
      } else if (this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {

        this.newHaul.user_id = '';
        this.newHaul.full_name = '';
        this.newHaul.truck_id = '';
        this.newHaul.truck = '';
        this.newHaul.truck_unit_id = '';
        this.newHaul.truck_unit = '';
        if (this.insert_data.trucking_companies.length > 0) {
          var _trucking_companies = this.insert_data.trucking_companies;
          this.newHaul.truck_company_id = _trucking_companies[0].id;
          var _drivers = _trucking_companies[0]['drivers'];
          this.newHaul.driver_select = _drivers.map(function (item) {
            return {
              'value': item.id,
              'text': item.name
            };
          });
          var _trucks = _trucking_companies[0]['trucks'];
          this.newHaul.truck_select = _trucks.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_name
            };
          });
          var _truck_units = _trucking_companies[0]['truck_units'];
          this.newHaul.truck_unit_select = _truck_units.map(function (item) {
            return {
              'value': item.id,
              'text': item.truck_unit
            };
          });
          if (this.newHaul.truck_unit_select.length == 1) {
            this.newHaul.truck_unit = this.newHaul.truck_select[0].text;
            this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value;
          }

          if (this.newHaul.driver_select.length == 1) {
            this.newHaul.full_name = this.newHaul.driver_select[0].text;
            this.newHaul.user_id = this.newHaul.driver_select[0].value;
          }
          if (this.newHaul.truck_select.length == 1) {
            this.newHaul.truck = this.newHaul.truck_select[0].text;
            this.newHaul.truck_id = this.newHaul.truck_select[0].value;
          }
        }
      }
    },
    selects_energy_company: function selects_energy_company() {
      this.newHaul.load_location_select = [];
      this.newHaul.load_location = '';
      this.newHaul.load_location_id = '';
      var trucking_companies = this.insert_data.trucking_companies;

      var current_truck_company_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.truck_company_id);
      if (current_truck_company_index > -1) {
        var drivers = trucking_companies[current_truck_company_index]['drivers'];
        var drivers_index = drivers.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.user_id);
        if (drivers_index > -1) {
          var energycompanies = drivers[drivers_index]['energy_companies'];
          var energy_company_index = energycompanies.map(function (o) {
            return o.id;
          }).indexOf(this.newHaul.energy_companies_id);
          this.getLoadLocation(energycompanies[energy_company_index].id, drivers[drivers_index].id);
        }
      }
    },
    getLoadLocation: function getLoadLocation(energy_company_id, driver_id) {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getLoadLocation(energy_company_id, driver_id).then(function (data) {
        if (data['status'] == 'success') {
          _this13.loads_locations = data['load_locations'];
          _this13.newHaul.load_location_select = _this13.loads_locations.map(function (item) {
            return {
              'value': item.id,
              'text': item.legal_location
            };
          });
          if (_this13.newHaul.load_location_select.length == 1) {
            _this13.newHaul.load_location = _this13.newHaul.load_location_select[0].text;
            _this13.newHaul.load_location_id = _this13.newHaul.load_location_select[0].value;
          }
        } else {
          _this13.$swal(data[0], data[1], data[0]);
        }
        _this13.loadingData = false;
      }).catch(function (error) {
        _this13.$swal('Error', 'Server not response. ' + error, 'error');
        _this13.loadingData = false;
      });
    },
    selects_driver: function selects_driver() {
      this.newHaul.energy_companies_id = '';
      this.newHaul.energy_company = '';
      this.newHaul.unload_location_select = [];
      this.newHaul.unload_location = '';
      this.newHaul.unload_location_id = '';

      var trucking_companies = this.insert_data.trucking_companies;
      var current_truck_company_index = trucking_companies.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.truck_company_id);
      if (current_truck_company_index > -1) {
        var drivers = trucking_companies[current_truck_company_index]['drivers'];
        var drivers_index = drivers.map(function (o) {
          return o.id;
        }).indexOf(this.newHaul.user_id);
        var energycompanies = drivers[drivers_index]['energy_companies'];
        this.newHaul.energy_company_select = energycompanies.map(function (item) {
          return {
            'value': item.id,
            'text': item.company_name
          };
        });
        this.getUnloadLocation(drivers[drivers_index].id);
      }
    },
    getUnloadLocation: function getUnloadLocation(driver_id) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].getUnloadLocation(driver_id).then(function (data) {
        if (data['status'] == 'success') {
          var loads_locations = data['unload_locations'];
          _this14.newHaul.unload_location_select = loads_locations.map(function (item) {
            return {
              'value': item.id,
              'text': item.legal_location
            };
          });
        } else {
          _this14.$swal(data[0], data[1], data[0]);
        }
        _this14.loadingData = false;
      }).catch(function (error) {
        _this14.$swal('Error', 'Server not response. ' + error, 'error');
        _this14.loadingData = false;
      });
    },
    selects_load_location: function selects_load_location() {

      this.newHaul.fluid_type_select = [];
      this.newHaul.fluid_type = '';
      this.newHaul.fluid_type_id = '';
      var loads_locations = this.loads_locations;
      var loads_locations_index = loads_locations.map(function (o) {
        return o.id;
      }).indexOf(this.newHaul.load_location_id);
      if (loads_locations_index > -1) {
        var fluid_types = loads_locations[loads_locations_index]['fluids'];
        this.newHaul.fluid_type_select = fluid_types.map(function (item) {
          return {
            'value': item.id,
            'text': item.name
          };
        });
      }
    },
    myOnlyNumber: function myOnlyNumber(evt, variableName) {
      var dotPosition = this.newHaul[variableName].indexOf(".");
      var hasDot = dotPosition > -1;
      var length = this.newHaul[variableName].length;
      this.isNumber(evt, hasDot, dotPosition, length);
    },

    isNumber: function isNumber(evt, hasDot, dotPosition, length) {

      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode <= 31 || charCode == 37 || charCode == 39 || charCode >= 96 && charCode <= 105 || charCode >= 48 && charCode <= 57 || charCode === 46 || charCode === 19 || !hasDot && charCode == 190 || !hasDot && charCode == 110) {
        var selectionStart = evt.target.selectionStart;
        var selectionEnd = evt.target.selectionEnd;
        if (hasDot && selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart && length - 2 > dotPosition && charCode > 31 && charCode != 37 && charCode != 39) {
          evt.preventDefault();
        } else {
          return true;
        }
      } else {
        evt.preventDefault();
      }
    },
    approvedFilter: function approvedFilter(apr_filter) {
      if (this.role == 'super_admin' || this.role == 'trucking_company_admin' || this.role == 'trucking_operational_manager') {
        var itemsO = this.itemsAll;
        this.Approved = apr_filter;
        if (apr_filter === 'Approved') {
          var result = itemsO.filter(function (item) {
            return item.trucking_company_approved == true;
          });
          this.items = result;
        } else if (apr_filter === 'Unapproved') {
          var _result = itemsO.filter(function (item) {
            return item.trucking_company_unapproved == true;
          });
          this.items = _result;
        } else {
          this.items = this.itemsAll;
          this.haul_ids = [];
          this.Approved = 'Show Approved';
        }
      }
    },
    h_approved_click: function h_approved_click() {
      var _this15 = this;

      var model = {
        command: 'approved',
        approved: this.haul_ids
      };
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].HaulsApproved(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this15.getAll();
          _this15.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    h_deapproved_click: function h_deapproved_click() {
      var _this16 = this;

      var model = {
        command: 'unapproved',
        unapproved: this.haul_ids
      };
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_6__hauls_haul_service__["a" /* default */].HaulsApproved(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this16.getAll();
          _this16.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    h_unasigned_click: function h_unasigned_click() {
      var _this17 = this;

      var model = {
        command: 'unasigned',
        unasigned: this.haul_ids
      };
      this.haul_ids = [];
      __WEBPACK_IMPORTED_MODULE_5__agreements_service__["a" /* default */].HaulsUnasigned(model).then(function (data) {
        if (data.status == 'success') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
          _this17.getAll();
          _this17.loadingData = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].swal(data.status, data.message, data.status);
        }
      });
    },
    keyMonitor1: function keyMonitor1(evt) {
      if (evt.key.match(/[a-zA-Z0-9]/i) === null) {
        evt.preventDefault();
        return;
      } else {
        evt = evt ? evt : window.event;
        var key = evt.key;
        if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
          return;
        } else if (key == "Backspace") {
          var filter_txt = this.newHaul.t_ticket;
          var nn = filter_txt.length - 1;
          if (nn > 0) {
            this.newHaul.t_ticket = filter_txt.substring(0, nn);
            return;
          } else {
            this.newHaul.t_ticket = '';
            return;
          }
        } else if (key == "Delete") {
          return;
        } else {

          var _filter_txt = this.newHaul.t_ticket;
          var _nn = _filter_txt.length;
          if (_nn < 10) {
            _filter_txt = _filter_txt + key;
            this.newHaul.t_ticket = _filter_txt;
          } else {
            evt.preventDefault();
          }
          return;
        }
      }
    },
    keyMonitor: function keyMonitor(evt) {
      if (evt.key.match(/[a-zA-Z0-9]/i) === null) {
        evt.preventDefault();
        return;
      } else {
        evt = evt ? evt : window.event;
        var key = evt.key;
        if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown") {
          return;
        } else if (key == "Backspace") {
          var filter_txt = this.newHaul.ticket;
          var nn = filter_txt.length - 1;
          if (nn > 0) {
            this.newHaul.ticket = filter_txt.substring(0, nn);
            return;
          } else {
            this.newHaul.ticket = '';
            return;
          }
        } else if (key == "Delete") {
          return;
        } else {

          var _filter_txt2 = this.newHaul.ticket;
          var _nn2 = _filter_txt2.length;
          if (_nn2 < 10) {
            _filter_txt2 = _filter_txt2 + key;
            this.newHaul.ticket = _filter_txt2;
          } else {
            evt.preventDefault();
          }
          return;
        }
      }
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isolera_service__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'VolumeEstimate',
    data: function data() {
        return {
            model: {
                csv: ''
            },
            role: '',
            file: '',
            url: '',
            load_csv: 'Loading Excel file.....',
            uploadPercentage: 0,
            progress: false
        };
    },

    methods: {
        base64ToBlob: function base64ToBlob(base64) {
            var binaryString = window.atob(base64);
            var len = binaryString.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; ++i) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return new Blob([bytes], { type: 'application/csv' });
        },
        handleFileUpload: function handleFileUpload() {
            this.file = this.$refs.file.files[0];
            this.model.csv = this.file['name'];
            var url = window.URL.createObjectURL(this.file);
            this.url = url;
            setTimeout(function () {
                return window.URL.revokeObjectURL(url);
            }, 100);
        },
        okToSave: function okToSave() {

            if (this.model.csv === '') {
                this.$swal('Alert!', 'Please, Enter Excel file', 'warning');
                return false;
            }
            return true;
        },
        sendCSV: function sendCSV() {
            if (!this.okToSave()) {
                return;
            }
            this.savebtn = true;
            var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model);
            var blob = new Blob([json], {
                type: 'application/json'
            });
            var formData = new FormData();
            formData.append("document", blob);
            formData.append('file', this.file);
            this.uploadPercentage = 0;
            this.progress = true;
            this.load_csv = 'Sending Excel file.....';
            this.send_csv(formData);
        },
        send_csv: function send_csv(formData) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* apiDomain */] + '/send_csv/', formData, { headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': localStorage.getItem('access_token')
                },
                onUploadProgress: function onUploadProgress(progressEvent) {
                    _this.uploadPercentage = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
                }
            }).then(function (response) {
                var data = response.data;
                if (data.status == 'success') {
                    _this.load_csv = 'Volume Estimate Updated';
                    _this.$swal(data.status, data.message, data.status);
                    _this.progress = false;
                } else {
                    _this.load_csv = 'Loading Excel file.....', _this.uploadPercentage = 0, _this.progress = false;
                    _this.$swal(data.status, data.message, data.status);
                }
            }).catch(function (error) {
                _this.load_csv = 'Loading Excel file.....', _this.uploadPercentage = 0, _this.progress = false;
                _this.$swal('Error', 'Server not response. ' + error, 'error');
            });
        }
    }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downloadjs__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_downloadjs__);






/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		'type': {
			type: String,
			default: "xls"
		},

		'data': {
			type: Array,
			required: true
		},

		'fields': {
			type: Object,
			required: true
		},

		'title': {
			default: null
		},

		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.fields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			__WEBPACK_IMPORTED_MODULE_2_downloadjs___default()(blob, filename, mime);
		},

		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';

			if (this.title != null) {
				if (Array.isArray(this.title)) {
					for (var i = 0; i < this.title.length; i++) {
						xlsData += '<th colspan="' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data[0]).length + '">' + this.title[i] + '<th></tr><tr>';
					}
				} else {
					xlsData += '<th colspan="' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data[0]).length + '">' + this.title + '<th></tr><tr>';
				}
			}

			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';

			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			return xlsTemp.replace('${table}', xlsData);
		},

		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';

			if (this.title != null) {
				if (Array.isArray(this.title)) {
					for (var i = 0; i < this.title.length; i++) {
						csvData += this.title[i] + '\r\n';
					}
				} else {
					csvData += this.title + '\r\n';
				}
			}

			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';

			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + '';
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			return csvData;
		},

		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var iii = item;
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		callItemCallback: function callItemCallback(field, itemValue) {
			if ((typeof field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(field)) === 'object' && typeof field.callback === 'function') {
				return field.callback(itemValue);
			}

			return itemValue;
		},
		getNestedData: function getNestedData(key, item) {
			var field = (typeof key === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(key)) === 'object' ? key.field : key;

			var valueFromNestedKey = null;
			var keyNestedSplit = field.split(".");

			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}

			valueFromNestedKey = this.callItemCallback(key, valueFromNestedKey);

			return valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		}
	} });

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_json_excel__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clipboard2__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_clipboard2__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_highcharts_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__(1300));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_9_vue_json_excel__["a" /* default */]);

window.moment = __WEBPACK_IMPORTED_MODULE_8_moment___default.a;
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
      document.body.classList.toggle('aside-menu-hidden', true);

      next();
    });
  }
});
__WEBPACK_IMPORTED_MODULE_2_highcharts___default.a.setOptions({
  lang: {
    thousandsSep: ','
  }
});

/***/ }),
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88c70f36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(761)
  __webpack_require__(762)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88c70f36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_Login__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_tables_Tables__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_energy_companies_energy_companies__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_trucking_companies_trucking_companies__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_trucking_companies_trucking_company__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_reports_reports__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_hauls_hauls__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_hauls_tests__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_hauls_haul__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_trucks_trucks__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_trucks_truck__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_agreements_agreements__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_agreements_agreements_pending__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_agreements_agreement__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_locations_m_locations__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_locations_m_location__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_users_users__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_users_user__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_users_userDocument__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_m_targets_m_targets__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_m_targets_m_target__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_m_truck_types_m_truck_types__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_m_truck_types_m_truck_type__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_m_fluid_types_m_fluid_types__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_m_fluid_types_m_fluid_type__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_notification_notifications__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_location_types_m_location_types__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_location_types_m_location_type__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_operating_areas_m_operating_areas__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_operating_areas_m_operating_area__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_energy_companies_m_energy_company__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_roles_m_roles__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_roles_m_role__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_keys_keys__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_services_m_services__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_services_m_service__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_folders_folders__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_folders_folder__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_terminal_agreements_terminal_agreements__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_terminal_agreements_terminal_agreements_pending__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_terminal_agreements_terminal_agreement__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_terminal_agreements_indexes__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_terminal_agreements_index_detail__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_terminal_agreements_wti__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_terminal_agreements_wti_detail__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_hauls_export__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_profile_profile__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__auth_ForgotPassword__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_logs_logs__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_logs_log__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_pages_Page404__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_pages_Page500__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__auth_auth__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_terminal_companies_terminal_companies__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_terminal_companies_terminal_company__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_terminals_terminals__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_terminals_terminal__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_dashboard_Dash__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_powerbi_pwbi_listing__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_powerbi_pwbi_detail__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_powerbi_other_report__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_hauls_duplicated_hauls__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_hauls_discrepancy_report__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_receipt_receipt__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_hauls_request_hauls__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_hauls_request_h__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_invoices_invoices__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_invoices_invoice__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_invoices_haul_invoices__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_request_hauls_notifications__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_request_hauls_notification__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_invoices_notifications__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_invoices_notification__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_trucks_unit_trucks_units__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_trucks_unit_trucks_unit__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_receipt_altex__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_intraday_intraday_report__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_cnr_hazards__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_cnr_controls__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_cnr_hazard__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_cnr_control__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_cnr_tdgs__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_cnr_tdg__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_receipt_petrotranz_report__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_invoices_invoice_customers__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_invoices_invoice_customer__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_invoices_invoice_contracts__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_invoices_invoice_contract__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_invoices_invoice_adjusts__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_invoices_invoice_adjust__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_invoices_invoice_prices__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_invoices_invoice_price__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_agreements_agreement_pending_d__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_isolera_update_volume_estimate__ = __webpack_require__(1287);


















































































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  root: '/',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  relative: true,
  base: __dirname,
  routes: [{
    path: '/forgot_password',
    name: 'Forgot Password',
    component: __WEBPACK_IMPORTED_MODULE_51__auth_ForgotPassword__["a" /* default */]
  }, {
    path: '/tests',
    name: 'Hauls',
    component: __WEBPACK_IMPORTED_MODULE_11__views_hauls_tests__["a" /* default */]
  }, {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'targets',
      name: 'Targets',
      component: __WEBPACK_IMPORTED_MODULE_23__views_m_targets_m_targets__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'intraday',
      name: 'Intraday Report',
      component: __WEBPACK_IMPORTED_MODULE_80__views_intraday_intraday_report__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/target/:id',
      name: 'Target',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_24__views_m_targets_m_target__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'tables',
      name: 'Tables',
      component: __WEBPACK_IMPORTED_MODULE_5__views_tables_Tables__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'users',
      name: 'Users',
      component: __WEBPACK_IMPORTED_MODULE_20__views_users_users__["a" /* default */]
    }, {
      path: 'user/:id',
      name: 'User',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_21__views_users_user__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'user/:id/documents/:idDocument',
      name: 'userDocument',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_22__views_users_userDocument__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'trucks',
      name: 'Trucks',
      component: __WEBPACK_IMPORTED_MODULE_13__views_trucks_trucks__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'truck/:id',
      name: 'Truck',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_14__views_trucks_truck__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'agreements',
      name: 'Agreements',
      component: __WEBPACK_IMPORTED_MODULE_15__views_agreements_agreements__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/agreement/:id',
      name: 'Agreement',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_17__views_agreements_agreement__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'terminal_agreements',
      name: 'Terminal Agreements',
      component: __WEBPACK_IMPORTED_MODULE_42__views_terminal_agreements_terminal_agreements__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/terminal_agreement/:id',
      name: 'Terminal Agreement',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_44__views_terminal_agreements_terminal_agreement__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'energy_companies',
      name: 'Energy Company',
      component: __WEBPACK_IMPORTED_MODULE_6__views_energy_companies_energy_companies__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/energy_company/:id',
      name: 'Energy Companies',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_34__views_energy_companies_m_energy_company__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'trucking_companies',
      name: 'Trucking Companies',
      component: __WEBPACK_IMPORTED_MODULE_7__views_trucking_companies_trucking_companies__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'reports',
      name: 'Reports',
      component: __WEBPACK_IMPORTED_MODULE_9__views_reports_reports__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'hauls',
      name: 'Hauls',
      component: __WEBPACK_IMPORTED_MODULE_10__views_hauls_hauls__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/haul/:id',
      name: 'Haul',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_12__views_hauls_haul__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'locations',
      name: 'Locations',
      component: __WEBPACK_IMPORTED_MODULE_18__views_locations_m_locations__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/location/:id',
      name: 'Location',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_19__views_locations_m_location__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'operating_areas',
      name: 'Operating Areas',
      component: __WEBPACK_IMPORTED_MODULE_32__views_operating_areas_m_operating_areas__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/operating_area/:id',
      name: 'Operating Area',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_33__views_operating_areas_m_operating_area__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/trucking_company/:id',
      name: 'Trucking Company',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_8__views_trucking_companies_trucking_company__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'fluid_types',
      name: 'Fluid Types',
      component: __WEBPACK_IMPORTED_MODULE_27__views_m_fluid_types_m_fluid_types__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'notification',
      name: 'Notifications',
      component: __WEBPACK_IMPORTED_MODULE_29__views_notification_notifications__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/fluid_type/:id',
      name: 'Fluid Type',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_28__views_m_fluid_types_m_fluid_type__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'truck_types',
      name: 'Truck Types',
      component: __WEBPACK_IMPORTED_MODULE_25__views_m_truck_types_m_truck_types__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/truck_type/:id',
      name: 'Truck Type',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_26__views_m_truck_types_m_truck_type__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'location_types',
      name: 'Locations Types',
      component: __WEBPACK_IMPORTED_MODULE_30__views_location_types_m_location_types__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/location_type/:id',
      name: 'Locations Type',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_31__views_location_types_m_location_type__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'roles',
      name: 'Roles',
      component: __WEBPACK_IMPORTED_MODULE_35__views_roles_m_roles__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/role/:id',
      name: 'Role',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_36__views_roles_m_role__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'services',
      name: 'Services',
      component: __WEBPACK_IMPORTED_MODULE_38__views_services_m_services__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'keys',
      name: 'EC-Keys',
      component: __WEBPACK_IMPORTED_MODULE_37__views_keys_keys__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/service/:id',
      name: 'Service',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_39__views_services_m_service__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'folders',
      name: 'Folders',
      component: __WEBPACK_IMPORTED_MODULE_40__views_folders_folders__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/folder/:id',
      name: 'Folder',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_41__views_folders_folder__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/profile/:id',
      name: 'Profile',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_50__views_profile_profile__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'logs',
      name: 'Logs',
      component: __WEBPACK_IMPORTED_MODULE_52__views_logs_logs__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/log/:id',
      name: 'Log',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_53__views_logs_log__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'terminal_companies',
      name: 'Terminal Companies',
      component: __WEBPACK_IMPORTED_MODULE_57__views_terminal_companies_terminal_companies__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/terminal_company/:id',
      name: 'Terminal Company',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_58__views_terminal_companies_terminal_company__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'terminal_agreements_pending',
      name: 'Pending Terminal Agreements',
      component: __WEBPACK_IMPORTED_MODULE_43__views_terminal_agreements_terminal_agreements_pending__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'indexes',
      name: 'Indexes',
      component: __WEBPACK_IMPORTED_MODULE_45__views_terminal_agreements_indexes__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/index/:id',
      name: 'Index',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_46__views_terminal_agreements_index_detail__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'wti',
      name: 'WTIs',
      component: __WEBPACK_IMPORTED_MODULE_47__views_terminal_agreements_wti__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/wti/:id',
      name: 'WTI',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_48__views_terminal_agreements_wti_detail__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'other',
      name: 'Export',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_49__views_hauls_export__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'terminals',
      name: 'Terminals',
      component: __WEBPACK_IMPORTED_MODULE_59__views_terminals_terminals__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/terminal/:id',
      name: 'Terminal',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_60__views_terminals_terminal__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'agreements_pending',
      name: 'Pending Agreements',
      component: __WEBPACK_IMPORTED_MODULE_16__views_agreements_agreements_pending__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'dash',
      name: 'Dash Trucking Company Admin',
      component: __WEBPACK_IMPORTED_MODULE_61__views_dashboard_Dash__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'powerbi',
      name: 'Power BIs',
      component: __WEBPACK_IMPORTED_MODULE_62__views_powerbi_pwbi_listing__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/powerbi/:id',
      name: 'Power BI',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_63__views_powerbi_pwbi_detail__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'monthly_report',
      name: 'Monthly Report',
      component: __WEBPACK_IMPORTED_MODULE_64__views_powerbi_other_report__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'duplicated_hauls',
      name: 'Duplicated Hauls',
      component: __WEBPACK_IMPORTED_MODULE_65__views_hauls_duplicated_hauls__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'discrepancy_report',
      name: 'Discrepancy Report',
      component: __WEBPACK_IMPORTED_MODULE_66__views_hauls_discrepancy_report__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'receipts_wo_hauls',
      name: 'Receipts without Hauls',
      component: __WEBPACK_IMPORTED_MODULE_67__views_receipt_receipt__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'request_hauls',
      name: 'Request Hauls',
      component: __WEBPACK_IMPORTED_MODULE_68__views_hauls_request_hauls__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'request_hauls_trucking',
      name: 'Request Hauls',
      component: __WEBPACK_IMPORTED_MODULE_69__views_hauls_request_h__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoices',
      name: 'Invoices',
      component: __WEBPACK_IMPORTED_MODULE_70__views_invoices_invoices__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/invoice/:id',
      name: 'Invoice',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_71__views_invoices_invoice__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoices_hauls',
      name: 'Invoices Hauls',
      component: __WEBPACK_IMPORTED_MODULE_72__views_invoices_haul_invoices__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'request_haul_notifications',
      name: 'Request Haul Notifications',
      component: __WEBPACK_IMPORTED_MODULE_73__views_request_hauls_notifications__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/request_haul_notification/:id',
      name: 'Request Haul Notification',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_74__views_request_hauls_notification__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoice_haul_notifications',
      name: 'Invoice Haul Notifications',
      component: __WEBPACK_IMPORTED_MODULE_75__views_invoices_notifications__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/invoice_haul_notification/:id',
      name: 'Invoice Haul Notification',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_76__views_invoices_notification__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'trucks_units',
      name: 'TrucksUnits',
      component: __WEBPACK_IMPORTED_MODULE_77__views_trucks_unit_trucks_units__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'trucks_unit/:id',
      name: 'TrucksUnit',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_78__views_trucks_unit_trucks_unit__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'altex_check',
      name: 'Altex Ticket Check',
      component: __WEBPACK_IMPORTED_MODULE_79__views_receipt_altex__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'hazards',
      name: 'Hazards',
      component: __WEBPACK_IMPORTED_MODULE_81__views_cnr_hazards__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'controls',
      name: 'Controls',
      component: __WEBPACK_IMPORTED_MODULE_82__views_cnr_controls__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/hazard/:id',
      name: 'Hazard',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_83__views_cnr_hazard__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/control/:id',
      name: 'Control',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_84__views_cnr_control__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'tdgs',
      name: 'TDGs',
      component: __WEBPACK_IMPORTED_MODULE_85__views_cnr_tdgs__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/tdg/:id',
      name: 'TDG',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_86__views_cnr_tdg__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'petrotranz_report',
      name: 'PetroTranz Report',
      component: __WEBPACK_IMPORTED_MODULE_87__views_receipt_petrotranz_report__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoice_customers',
      name: 'Invoice Customer',
      component: __WEBPACK_IMPORTED_MODULE_88__views_invoices_invoice_customers__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoice_contracts',
      name: 'Invoice Contract',
      component: __WEBPACK_IMPORTED_MODULE_90__views_invoices_invoice_contracts__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoice_adjusts',
      name: 'Invoice Adjust',
      component: __WEBPACK_IMPORTED_MODULE_92__views_invoices_invoice_adjusts__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'invoice_prices',
      name: 'Invoice Prices',
      component: __WEBPACK_IMPORTED_MODULE_94__views_invoices_invoice_prices__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/invoice_price/:id',
      name: 'Invoice Price',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_95__views_invoices_invoice_price__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/invoice_adjust/:id',
      name: 'Invoice Adjust',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_93__views_invoices_invoice_adjust__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/invoice_customer/:id',
      name: 'Invoice Customer',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_89__views_invoices_invoice_customer__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/invoice_contract/:id',
      name: 'Invoice Contract',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_91__views_invoices_invoice_contract__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: '/agreement_pending_detail/:id',
      name: 'Detail Pending Agreement',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_96__views_agreements_agreement_pending_d__["a" /* default */],
      beforeEnter: requiredAuth
    }, {
      path: 'update_volume_estimate',
      name: 'Update Volume Estimate',
      component: __WEBPACK_IMPORTED_MODULE_97__views_isolera_update_volume_estimate__["a" /* default */],
      beforeEnter: requiredAuth
    }]
  }, {
    path: '/auth',
    redirect: 'login',
    name: 'Auth',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '/login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_4__auth_Login__["a" /* default */],
      beforeEnter: readyIsLogued
    }, {
      path: '/logout',
      name: 'Logout',
      beforeEnter: function beforeEnter(to, from, next) {
        __WEBPACK_IMPORTED_MODULE_56__auth_auth__["a" /* default */].logout();
        next('/login');
      }
    }]
  }, {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_54__views_pages_Page404__["a" /* default */]
    }, {
      path: '500',
      name: 'Page500',
      component: __WEBPACK_IMPORTED_MODULE_55__views_pages_Page500__["a" /* default */]
    }]
  }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_54__views_pages_Page404__["a" /* default */] }]
}));

function requiredAuth(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_56__auth_auth__["a" /* default */].isLoguedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

function readyIsLogued(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_56__auth_auth__["a" /* default */].isLoguedIn()) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 765 */,
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb34c962_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb34c962_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _ref;

/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Intraday Report',
    url: '/intraday',
    icon: 'fa fa-dashboard'
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Discrepancy Report',
      url: '/discrepancy_report',
      icon: 'fa fa-rocket'
    }, {
      name: 'Tickets Missing Hauls',
      url: '/receipts_wo_hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Altex Ticket Check',
      url: '/altex_check',
      icon: 'fa fa-rocket'
    }, {
      name: 'Petrotranz Report',
      url: '/petrotranz_report',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Request Hauls',
    url: '/request_hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Invoices',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'Trucking Company Invoices',
      url: '/invoices',
      icon: 'fa fa-rocket'
    }, {
      name: 'Haul Invoices',
      url: '/invoices_hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Customer',
      url: '/invoice_customers',
      icon: 'fa fa-rocket'
    }, {
      name: 'Contract',
      url: '/invoice_contracts',
      icon: 'fa fa-rocket'
    }, {
      name: 'Adjust',
      url: '/invoice_adjusts',
      icon: 'fa fa-rocket'
    }, {
      name: 'Price',
      url: '/invoice_prices',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Nominations',
    url: '/targets',
    icon: 'fa fa-bullseye'
  }, {
    name: 'Energy Companies',
    url: '/energy_companies',
    icon: 'fa fa-building'
  }, {
    name: 'Trucking',
    url: '/#',
    icon: 'fa fa-truck',
    children: [{
      name: 'Companies',
      url: '/trucking_companies',
      icon: 'fa fa-building'
    }, {
      name: 'Trailers',
      url: '/trucks',
      icon: 'fa fa-truck'
    }, {
      name: 'Truck Units',
      url: '/trucks_units',
      icon: 'fa fa-truck'
    }, {
      name: 'Agreements',
      url: '/agreements',
      icon: 'icon-docs'
    }, {
      name: 'Hauls Without Agreements',
      url: '/agreements_pending',
      icon: 'icon-docs'
    }]
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-industry'
    }]
  }, {
    name: 'Terminal',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Terminals',
      url: '/terminals',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Companies',
      url: '/terminal_companies',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Agreements',
      url: '/terminal_agreements',
      icon: 'fa fa-list'
    }, {
      name: 'Pending Terminal Agreements',
      url: '/terminal_agreements_pending',
      icon: 'fa fa-list'
    }, {
      name: 'Indexes',
      url: '/indexes',
      icon: 'fa fa-list'
    }, {
      name: 'WTI',
      url: '/wti',
      icon: 'fa fa-list'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Isolera',
      url: '/update_volume_estimate',
      icon: 'fa fa-pencil'
    }, {
      name: 'Hazards',
      url: '/hazards',
      icon: 'fa fa-tint'
    }, {
      name: 'Controls',
      url: '/controls',
      icon: 'fa fa-tint'
    }, {
      name: 'TDG',
      url: '/tdgs',
      icon: 'fa fa-tint'
    }, {
      name: 'Reports',
      url: '/powerbi',
      icon: 'fa fa-tint'
    }, {
      name: 'Notification',
      url: '/notification',
      icon: 'fa fa-tint'
    }, {
      name: 'Request Haul Notifications',
      url: '/request_haul_notifications',
      icon: 'fa fa-tint'
    }, {
      name: 'Invoice Notifications',
      url: '/invoice_haul_notifications',
      icon: 'fa fa-tint'
    }, {
      name: 'Folders',
      url: '/folders',
      icon: 'fa fa-folder'
    }, {
      name: 'Fluid Types',
      url: '/fluid_types',
      icon: 'fa fa-tint'
    }, {
      name: 'Truck Types',
      url: '/truck_types',
      icon: 'fa fa-truck'
    }, {
      name: 'Location Types',
      url: '/location_types',
      icon: 'fa fa-location-arrow'
    }, {
      name: 'Roles',
      url: '/roles',
      icon: 'fa fa-user-circle'
    }, {
      name: 'Services',
      url: '/services',
      icon: 'fa fa-handshake-o'
    }, {
      name: 'API-Keys',
      url: '/keys',
      icon: 'fa fa-handshake-o'
    }, {
      name: 'Fail Logs',
      url: '/logs',
      icon: 'fa fa-pencil'
    }, {
      name: 'Other',
      url: '/#',
      icon: 'fa fa-pencil',
      children: [{
        name: 'Export to PVR',
        url: '/other',
        icon: 'fa fa-folder'
      }]
    }]
  }],
  items_super_analyst: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }]
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Request Hauls',
    url: '/request_hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Nominations',
    url: '/targets',
    icon: 'fa fa-bullseye'
  }, {
    name: 'Agreements',
    url: '/agreements',
    icon: 'icon-docs'
  }, {
    name: 'Hauls Without Agreements',
    url: '/agreements_pending',
    icon: 'icon-docs'
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'icon-location-pin'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Agreements',
      url: '/terminal_agreements',
      icon: 'fa fa-list'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Notification',
      url: '/notification',
      icon: 'fa fa-tint'
    }, {
      name: 'Folders',
      url: '/folders',
      icon: 'fa fa-tint'
    }, {
      name: 'Other',
      url: '/#',
      icon: 'fa fa-pencil',
      children: [{
        name: 'Export to PRV',
        url: '/other',
        icon: 'fa fa-folder'
      }]
    }]
  }],
  items_super_analyst_ser: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Intraday Report',
    url: '/intraday',
    icon: 'fa fa-dashboard'
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }]
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Request Hauls',
    url: '/request_hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Nominations',
    url: '/targets',
    icon: 'fa fa-bullseye'
  }, {
    name: 'Agreements',
    url: '/agreements',
    icon: 'icon-docs'
  }, {
    name: 'Hauls Without Agreements',
    url: '/agreements_pending',
    icon: 'icon-docs'
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'icon-location-pin'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Agreements',
      url: '/terminal_agreements',
      icon: 'fa fa-list'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Notification',
      url: '/notification',
      icon: 'fa fa-tint'
    }, {
      name: 'Folders',
      url: '/folders',
      icon: 'fa fa-tint'
    }, {
      name: 'Other',
      url: '/#',
      icon: 'fa fa-pencil',
      children: [{
        name: 'Export to PRV',
        url: '/other',
        icon: 'fa fa-folder'
      }]
    }]
  }],
  items_analyst: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }]
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Request Hauls',
    url: '/request_hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Nominations',
    url: '/targets',
    icon: 'fa fa-bullseye'
  }, {
    name: 'Agreements',
    url: '/agreements',
    icon: 'icon-docs'
  }, {
    name: 'Hauls Without Agreements',
    url: '/agreements_pending',
    icon: 'icon-docs'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'icon-location-pin'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Agreements',
      url: '/terminal_agreements',
      icon: 'fa fa-list'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Notification',
      url: '/notification',
      icon: 'fa fa-tint'
    }, {
      name: 'Other',
      url: '/#',
      icon: 'fa fa-pencil',
      children: [{
        name: 'Export to PRV',
        url: '/other',
        icon: 'fa fa-folder'
      }]
    }]
  }],
  items_analyst_ser: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Intraday Report',
    url: '/intraday',
    icon: 'fa fa-dashboard'
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }]
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Request Hauls',
    url: '/request_hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Nominations',
    url: '/targets',
    icon: 'fa fa-bullseye'
  }, {
    name: 'Agreements',
    url: '/agreements',
    icon: 'icon-docs'
  }, {
    name: 'Hauls Without Agreements',
    url: '/agreements_pending',
    icon: 'icon-docs'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'icon-location-pin'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Agreements',
      url: '/terminal_agreements',
      icon: 'fa fa-list'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Notification',
      url: '/notification',
      icon: 'fa fa-tint'
    }, {
      name: 'Other',
      url: '/#',
      icon: 'fa fa-pencil',
      children: [{
        name: 'Export to PRV',
        url: '/other',
        icon: 'fa fa-folder'
      }]
    }]
  }],
  items_drivers: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket'
  }],
  items_trucking_company_admin: [{
    name: 'Dashboard',
    url: '/dash',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Monthly Report',
    url: '/monthly_report',
    icon: 'fa fa-bar-chart'
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Requested Hauls',
    url: '/request_hauls_trucking',
    icon: 'fa fa-rocket',
    badge: {
      text: ''
    }
  }, {
    name: 'Invoices',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'Trucking Company Invoices',
      url: '/invoices',
      icon: 'fa fa-rocket'
    }, {
      name: 'Haul invoices',
      url: '/invoices_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-industry'
    }]
  }, (_ref = {
    name: 'Trucking',
    url: '/#'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'name', 'Trucks'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'icon', 'fa fa-truck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'children', [{
    name: 'Trailers',
    url: '/trucks',
    icon: 'fa fa-truck'
  }, {
    name: 'Truck Units',
    url: '/trucks_units',
    icon: 'fa fa-truck'
  }]), _ref), {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Folders',
      url: '/folders',
      icon: 'fa fa-tint'
    }]
  }],
  items_trucking_company_admin_light: [{
    name: 'Hauls',
    url: '/hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Requested Hauls',
    url: '/request_hauls_trucking',
    icon: 'fa fa-rocket',
    badge: {
      text: ''
    }
  }],
  items_operations_manager_admin: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Discrepancy Report',
      url: '/discrepancy_report',
      icon: 'fa fa-rocket'
    }, {
      name: 'Tickets Missing Hauls',
      url: '/receipts_wo_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'All Hauls',
    url: '/hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Trucking',
    url: '/trucking_companies',
    icon: 'fa fa-truck'
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-industry'
    }]
  }],
  items_trucking_operational_manager: [{
    name: 'Dashboard',
    url: '/dash',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Monthly Report',
    url: '/monthly_report',
    icon: 'fa fa-bar-chart'
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Requested Hauls',
    url: '/request_hauls_trucking',
    icon: 'fa fa-rocket',
    badge: {
      text: ''
    }
  }, {
    name: 'Invoices',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'Trucking Company Invoices',
      url: '/invoices',
      icon: 'fa fa-rocket'
    }, {
      name: 'Haul invoices',
      url: '/invoices_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-industry'
    }]
  }, {
    name: 'Trucking',
    url: '/#',

    icon: 'fa fa-truck',
    children: [{
      name: 'Trailers',
      url: '/trucks',
      icon: 'fa fa-truck'
    }, {
      name: 'Truck Units',
      url: '/trucks_units',
      icon: 'fa fa-truck'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Folders',
      url: '/folders',
      icon: 'fa fa-tint'
    }]
  }],
  items_marketing_accountant: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-dashboard',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Reports',
    url: '/#',
    icon: 'fa fa-bar-chart',
    children: [{
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-bar-chart'
    }, {
      name: 'Monthly Report',
      url: '/monthly_report',
      icon: 'fa fa-bar-chart'
    }]
  }, {
    name: 'Hauls',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'All Hauls',
      url: '/hauls',
      icon: 'fa fa-rocket'
    }, {
      name: 'Duplicate Hauls',
      url: '/duplicated_hauls',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Request Hauls',
    url: '/request_hauls',
    icon: 'fa fa-rocket'
  }, {
    name: 'Nominations',
    url: '/targets',
    icon: 'fa fa-bullseye'
  }, {
    name: 'Invoices',
    url: '/#',
    icon: 'fa fa-rocket',
    children: [{
      name: 'Invoice Customer',
      url: '/invoice_customers',
      icon: 'fa fa-rocket'
    }, {
      name: 'Invoice Contract',
      url: '/invoice_contracts',
      icon: 'fa fa-rocket'
    }, {
      name: 'Invoice Adjust',
      url: '/invoice_adjusts',
      icon: 'fa fa-rocket'
    }, {
      name: 'Invoice Price',
      url: '/invoice_prices',
      icon: 'fa fa-rocket'
    }]
  }, {
    name: 'Agreements',
    url: '/agreements',
    icon: 'icon-docs'
  }, {
    name: 'Hauls Without Agreements',
    url: '/agreements_pending',
    icon: 'icon-docs'
  }, {
    name: 'Locations',
    url: '/#',
    icon: 'icon-location-pin',
    children: [{
      name: 'Load and Unload Locations',
      url: '/locations',
      icon: 'icon-location-pin'
    }, {
      name: 'Operating Areas',
      url: '/operating_areas',
      icon: 'fa fa-map-marker'
    }, {
      name: 'Terminal Agreements',
      url: '/terminal_agreements',
      icon: 'fa fa-list'
    }]
  }, {
    divider: true
  }, {
    name: 'Setting',
    url: '/#',
    icon: 'fa fa-cogs',
    children: [{
      name: 'Notification',
      url: '/notification',
      icon: 'fa fa-tint'
    }, {
      name: 'Other',
      url: '/#',
      icon: 'fa fa-pencil',
      children: [{
        name: 'Export to PRV',
        url: '/other',
        icon: 'fa fa-folder'
      }]
    }]
  }]
});

/***/ }),
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* unused harmony reexport Breadcrumb */
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f8b682_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(943);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f8b682_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HaulPopup_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109a8d2d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HaulPopup_vue__ = __webpack_require__(942);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-109a8d2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HaulPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109a8d2d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HaulPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(928);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(931);
function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(934);
function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(936);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(941);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"pageinfo",staticStyle:{"padding":"10px 0 0 15px"},attrs:{"id":"pageinfo"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('span',{staticClass:"haul-title"},[_vm._v(_vm._s(this.subTitle))]),_c('br'),_vm._v(" "),(_vm.haulId)?_c('router-link',{attrs:{"to":{ path: '/haul/' + _vm.data_in.id }}},[_vm._v(_vm._s(this.haulLink)+" "),_c('svg',{staticClass:"icon outbound",attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","x":"0px","y":"0px","viewBox":"0 0 100 100","width":"15","height":"15"}},[_c('path',{attrs:{"fill":"currentColor","d":"M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"}}),_vm._v(" "),_c('polygon',{attrs:{"fill":"currentColor","points":"45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"}})])]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticStyle:{"margin-rght":"18px"}},[(!_vm.edit)?_c('b-btn',{staticClass:"pull-right ml-1",attrs:{"variant":"info"},on:{"click":_vm.closePopupHaul}},[_c('i',{staticClass:"fa fa-close"})]):_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:((_vm.edit || _vm.edit_analyst)),expression:"(edit || edit_analyst)"}],staticClass:"pull-right ml-1",attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.editHaul}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:((_vm.edit || _vm.edit_analyst)),expression:"(edit || edit_analyst)"}],staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateHaul}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),(!_vm.edit && !_vm.edit_analyst)?_c('b-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='analyst' || this.role =='marketing_accountant' || _vm.role =='trucking_operational_manager'),expression:"role =='super_admin' || role =='trucking_company_admin' || role =='analyst' || this.role =='marketing_accountant' || role =='trucking_operational_manager'"}],staticClass:"pull-right ml-1",attrs:{"variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editHaul}},[_vm._v("Edit")]),_vm._v(" "),((_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager') && !_vm.data_in.haul_invoice)?_c('b-dropdown-item',{on:{"click":_vm.openModal}},[_vm._v("Assign/Unassign Folder")]):_vm._e(),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-dropdown-item',{on:{"click":_vm.deleteHaul}},[_vm._v("Delete")]):_vm._e()],2):_vm._e()],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',{attrs:{"id":"haul-information"}},[_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view1),expression:"view1"}],attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Trucking Company","label-for":"truck_company"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/trucking_company/'+_vm.truck_company_id+'/')}}},[_vm._v(_vm._s(_vm.truck_company))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"truck_company_id","options":_vm.truck_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.truck_company_id),callback:function ($$v) {_vm.truck_company_id=$$v},expression:"truck_company_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Driver","label-for":"full_name"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/user/'+_vm.user_id+'/')}}},[_vm._v(_vm._s(_vm.full_name))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"user_id","options":_vm.driver_select},on:{"input":function($event){_vm.selects_driver()}},model:{value:(_vm.user_id),callback:function ($$v) {_vm.user_id=$$v},expression:"user_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label":"Energy Company","label-for":"energy_company"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/energy_company/'+_vm.energy_companies_id+'/')}}},[_vm._v(_vm._s(this.energy_company))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"energy_companies_id","options":_vm.energy_company_select},on:{"input":function($event){_vm.selects_energy_company()}},model:{value:(_vm.energy_companies_id),callback:function ($$v) {_vm.energy_companies_id=$$v},expression:"energy_companies_id"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Trailer 1","label-for":"truck"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && _vm.view),expression:"!edit && view"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/truck/'+_vm.truck_id+'/')}}},[_vm._v(_vm._s(_vm.truck))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit && _vm.view),expression:"edit && view"}],attrs:{"size":"sm","id":"truck_id","options":_vm.truck_select},model:{value:(_vm.truck_id),callback:function ($$v) {_vm.truck_id=$$v},expression:"truck_id"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.view),expression:"!view"}],attrs:{"size":"sm","id":"truck_id","plaintext":"","type":"text"},model:{value:(_vm.truck_id),callback:function ($$v) {_vm.truck_id=$$v},expression:"truck_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Fluid Type","label-for":"fluid_type"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/fluid_type/'+_vm.fluid_type_id+'/')}}},[_vm._v(_vm._s(_vm.fluid_type))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"fluid_type_id","options":_vm.fluid_type_select},model:{value:(_vm.fluid_type_id),callback:function ($$v) {_vm.fluid_type_id=$$v},expression:"fluid_type_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Average Speed","label-for":"avg_speed"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"avg_speed","type":"text"},model:{value:(_vm.avg_speed),callback:function ($$v) {_vm.avg_speed=$$v},expression:"avg_speed"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Truck Type","label-for":"truck_type"}},[_c('b-form-input',{attrs:{"id":"truck_type","plaintext":"","type":"text"},model:{value:(_vm.truck_type),callback:function ($$v) {_vm.truck_type=$$v},expression:"truck_type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Truck Ticket #","label-for":"ticket1"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"ticket1","plaintext":"","type":"text"},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"ticket1","type":"text"},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Load Location","label-for":"load_location"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && !_vm.edit_analyst),expression:"!edit && !edit_analyst"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/location/'+_vm.load_location_id+'/')}}},[_vm._v(_vm._s(_vm.load_location))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","disabled":_vm.load_location_select.length==0,"id":"load_location_id","options":_vm.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.load_location_id),callback:function ($$v) {_vm.load_location_id=$$v},expression:"load_location_id"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit_analyst),expression:"edit_analyst"}],attrs:{"disabled":_vm.load_location_select.length==0,"id":"load_location_id","options":_vm.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.load_location_id),callback:function ($$v) {_vm.load_location_id=$$v},expression:"load_location_id"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Unload Location","label-for":"unload_location"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && !_vm.edit_analyst),expression:"!edit && !edit_analyst"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/location/'+_vm.unload_location_id+'/')}}},[_vm._v(_vm._s(_vm.unload_location))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"unload_location_id","options":_vm.unload_location_select},model:{value:(_vm.unload_location_id),callback:function ($$v) {_vm.unload_location_id=$$v},expression:"unload_location_id"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit_analyst),expression:"edit_analyst"}],attrs:{"id":"unload_location_id","options":_vm.unload_location_select},model:{value:(_vm.unload_location_id),callback:function ($$v) {_vm.unload_location_id=$$v},expression:"unload_location_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Terminal Ticket #","label-for":"ticket"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"ticket","plaintext":"","type":"text"},model:{value:(_vm.terminal_ticket),callback:function ($$v) {_vm.terminal_ticket=$$v},expression:"terminal_ticket"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"ticket","type":"text"},model:{value:(_vm.terminal_ticket),callback:function ($$v) {_vm.terminal_ticket=$$v},expression:"terminal_ticket"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Total Distance Km","label-for":"total_distance"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"total_distance","plaintext":"","type":"text"},model:{value:(_vm.total_distance),callback:function ($$v) {_vm.total_distance=$$v},expression:"total_distance"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"total_distance","type":"text"},model:{value:(_vm.total_distance),callback:function ($$v) {_vm.total_distance=$$v},expression:"total_distance"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Gross Revenue","label-for":"gross_revenue"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"gross_revenue","type":"text"},model:{value:(_vm.gross_revenue),callback:function ($$v) {_vm.gross_revenue=$$v},expression:"gross_revenue"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Net Revenue","label-for":"netback"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"netback","type":"text"},model:{value:(_vm.netback),callback:function ($$v) {_vm.netback=$$v},expression:"netback"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Re-Routed","label-for":"rerouted"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"rerouted","type":"text"},model:{value:(_vm.rerouted),callback:function ($$v) {_vm.rerouted=$$v},expression:"rerouted"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Terminal Boss","label-for":"terminal_boss"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"terminal_boss","type":"text"},model:{value:(_vm.terminal_boss),callback:function ($$v) {_vm.terminal_boss=$$v},expression:"terminal_boss"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"terminal_boss","type":"text"},model:{value:(_vm.terminal_boss),callback:function ($$v) {_vm.terminal_boss=$$v},expression:"terminal_boss"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Truck Unit","label-for":"truck_unit"}},[(_vm.trucks_unit_id!==null)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/trucks_unit/'+_vm.trucks_unit_id+'/')}}},[_vm._v(_vm._s(_vm.truck_unit))]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('b-form-select',{attrs:{"size":"sm","id":"truck_unit","value-field":"id","text-field":"truck_unit","options":_vm.truck_unit_select},model:{value:(_vm.trucks_unit_id),callback:function ($$v) {_vm.trucks_unit_id=$$v},expression:"trucks_unit_id"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"ID","label-for":"Id"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"Id","type":"text"},model:{value:(_vm.data_in.id),callback:function ($$v) {_vm.$set(_vm.data_in, "id", $$v)},expression:"data_in.id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Created at","label-for":"created_date"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"created_date","type":"text"},model:{value:(_vm.created_date),callback:function ($$v) {_vm.created_date=$$v},expression:"created_date"}}),_vm._v(" "),_c('b-form-input',{attrs:{"plaintext":"","id":"created_time","type":"text"},model:{value:(_vm.created_time),callback:function ($$v) {_vm.created_time=$$v},expression:"created_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Updated at","label-for":"updated_date"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"updated_date","type":"text"},model:{value:(_vm.updated_date),callback:function ($$v) {_vm.updated_date=$$v},expression:"updated_date"}}),_vm._v(" "),_c('b-form-input',{attrs:{"plaintext":"","id":"updated_time","type":"text"},model:{value:(_vm.updated_time),callback:function ($$v) {_vm.updated_time=$$v},expression:"updated_time"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Trailer 2","label-for":"truck2"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.truck2_id!==null && !_vm.edit && _vm.view),expression:"truck2_id!==null && !edit && view"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/truck/'+_vm.truck2_id+'/')}}},[_vm._v(_vm._s(_vm.truck2))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit && _vm.view),expression:"edit && view"}],attrs:{"id":"truck2","options":_vm.truck_select},model:{value:(_vm.truck2_id),callback:function ($$v) {_vm.truck2_id=$$v},expression:"truck2_id"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.truck2_id!==null && !_vm.view),expression:"truck2_id!==null && !view"}],attrs:{"id":"truck2","plaintext":"","type":"text"},model:{value:(_vm.truck2_id),callback:function ($$v) {_vm.truck2_id=$$v},expression:"truck2_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"id":"L2","label":"Residue Last Contained","label-for":"residue_last_contained"}},[(!_vm.edit)?_c('b-form-checkbox',{attrs:{"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.residue_last_contained),callback:function ($$v) {_vm.residue_last_contained=$$v},expression:"residue_last_contained"}}):_c('b-form-checkbox',{attrs:{"name":"Checkboxes2","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.residue_last_contained),callback:function ($$v) {_vm.residue_last_contained=$$v},expression:"residue_last_contained"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"TDG","label-for":"tdg"}},[(_vm.tdg_id!==null)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/tdg/'+_vm.tdg_id+'/')}}},[_vm._v(_vm._s(_vm.tdg))]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('b-form-select',{attrs:{"size":"sm","id":"tdg","value-field":"id","text-field":"name","options":_vm.tdg_select},model:{value:(_vm.tdg_id),callback:function ($$v) {_vm.tdg_id=$$v},expression:"tdg_id"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Flags")])])],1),_vm._v(" "),_vm._l((_vm.messages),function(message){return _c('div',{staticStyle:{"color":"#3F3F46","height":"30px","margin":"auto","padding":"10px 0 0 15px","font-size":"11px"}},[_vm._v("\n\t\t\t\t"+_vm._s(message)+"\n\t\t\t")])}),_vm._v(" "),(_vm.multiload_data.length)?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Loads")])])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.multiload_data),function(load,index){return _c('div',{key:index,style:('color:#3F3F46; margin: auto; padding: 10px 0 0px 15px; font-size: 11px; border-bottom: dashed 1px; background-color: ' + (index % 2 == 0 ? '#f8fbf8' : '#f5f5f5'))},[_c('b-row',{staticClass:"mb-2",staticStyle:{"padding":"10px 0 0px 0px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Load Location","label-for":"load_index"}},[_c('b-form-input',{attrs:{"size":"sm","plaintext":"","value":load.load_location,"type":"text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Fluid type","label-for":"fluid_index"}},[_c('b-form-input',{attrs:{"size":"sm","plaintext":"","value":load.fluid_type,"type":"text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Volume estimate","label-for":"volume_index"}},[_c('b-form-input',{attrs:{"size":"sm","plaintext":"","value":load.volume_estimate,"type":"text"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2",staticStyle:{"padding":"10px 0 0px 0px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Start","label-for":"start_index"}},[_c('b-form-input',{attrs:{"size":"sm","plaintext":"","value":load.load_start_datetime,"type":"text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Truck ticket","label-for":"ticket_index"}},[_c('b-form-input',{attrs:{"size":"sm","plaintext":"","value":load.truck_ticket,"type":"text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Comment","label-for":"comment_index"}},[_c('b-form-input',{attrs:{"size":"sm","plaintext":"","value":load.comment,"type":"text"}})],1)],1)],1)],1)}),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Volumes")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Volume Estimate","label-for":"volume_estimate"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"volume_estimate","type":"text"},model:{value:(_vm.volume_estimate),callback:function ($$v) {_vm.volume_estimate=$$v},expression:"volume_estimate"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"volume_estimate","type":"text"},nativeOn:{"keydown":function($event){_vm.volumeEstimateNumber($event)},"blur":function($event){_vm.inputBlur('volume_estimate')}},model:{value:(_vm.volume_estimate),callback:function ($$v) {_vm.volume_estimate=$$v},expression:"volume_estimate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Volume Total Actual","label-for":"volume_actual"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && !_vm.edit_analyst),expression:"!edit && !edit_analyst"}],attrs:{"plaintext":"","id":"volume_actual","type":"text"},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"volume_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.volumeActualNumber($event)},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit_analyst),expression:"edit_analyst"}],attrs:{"id":"volume_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.volumeActualNumber($event)},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Oil Actual","label-for":"oil_actual"}},[(!_vm.edit_analyst)?_c('b-form-input',{attrs:{"id":"oil_actual","plaintext":"","type":"text"},model:{value:(_vm.oil_actual),callback:function ($$v) {_vm.oil_actual=$$v},expression:"oil_actual"}}):_c('b-form-input',{attrs:{"id":"oil_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.oilActualNumber($event)},"blur":function($event){_vm.inputBlur('oil_actual')}},model:{value:(_vm.oil_actual),callback:function ($$v) {_vm.oil_actual=$$v},expression:"oil_actual"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Water Actual","label-for":"water_actual"}},[_c('b-form-input',{attrs:{"id":"water_actual","plaintext":"","type":"text"},model:{value:(_vm.water_actual),callback:function ($$v) {_vm.water_actual=$$v},expression:"water_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Water Cut Actual %","label-for":"water_percentage_actual"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"water_percentage_actual","type":"text"},model:{value:(_vm.water_percentage_actual),callback:function ($$v) {_vm.water_percentage_actual=$$v},expression:"water_percentage_actual"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"water_percentage_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.waterActualNumber($event)},"blur":function($event){_vm.inputBlur('water_percentage_actual')}},model:{value:(_vm.water_percentage_actual),callback:function ($$v) {_vm.water_percentage_actual=$$v},expression:"water_percentage_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"BS%W Actual","label-for":"bsw"}},[(!_vm.edit_analyst)?_c('b-form-input',{attrs:{"plaintext":"","id":"bsw","type":"text"},model:{value:(_vm.bsw),callback:function ($$v) {_vm.bsw=$$v},expression:"bsw"}}):_c('b-form-input',{attrs:{"id":"bsw","type":"text"},nativeOn:{"keydown":function($event){_vm.bswNumber($event)},"blur":function($event){_vm.inputBlur('bsw')}},model:{value:(_vm.bsw),callback:function ($$v) {_vm.bsw=$$v},expression:"bsw"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Times")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Start Date/Time","label-for":"haul_start_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_start_date","plaintext":"","type":"text"},model:{value:(_vm.haul_start_date),callback:function ($$v) {_vm.haul_start_date=$$v},expression:"haul_start_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"haul_start_datetime","type":"date"},model:{value:(_vm.haul_start_datetime),callback:function ($$v) {_vm.haul_start_datetime=$$v},expression:"haul_start_datetime"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_start_time","plaintext":"","type":"text"},model:{value:(_vm.haul_start_time),callback:function ($$v) {_vm.haul_start_time=$$v},expression:"haul_start_time"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"size":"sm","id":"haul_start_time","type":"text"},model:{value:(_vm.haul_start_time),callback:function ($$v) {_vm.haul_start_time=$$v},expression:"haul_start_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"End Date/Time","label-for":"haul_start_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_end_date","plaintext":"","type":"text"},model:{value:(_vm.haul_end_date),callback:function ($$v) {_vm.haul_end_date=$$v},expression:"haul_end_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"haul_end_datetime","type":"date"},model:{value:(_vm.haul_end_datetime),callback:function ($$v) {_vm.haul_end_datetime=$$v},expression:"haul_end_datetime"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_end_time","plaintext":"","type":"text"},model:{value:(_vm.haul_end_time),callback:function ($$v) {_vm.haul_end_time=$$v},expression:"haul_end_time"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"size":"sm","id":"haul_end_time","type":"text"},model:{value:(_vm.haul_end_time),callback:function ($$v) {_vm.haul_end_time=$$v},expression:"haul_end_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Drive Time","label-for":"driving_time"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"driving_time","type":"text"},model:{value:(_vm.driving_time),callback:function ($$v) {_vm.driving_time=$$v},expression:"driving_time"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Stand by Time","label-for":"stb"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"stb","type":"text"},model:{value:(_vm.stb),callback:function ($$v) {_vm.stb=$$v},expression:"stb"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Chain Up Time","label-for":"Chain_Up_Time"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"Chain_Up_Time","type":"text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Total Personal Time","label-for":"personal_time"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"personal_time","type":"text"},model:{value:(_vm.personal_time),callback:function ($$v) {_vm.personal_time=$$v},expression:"personal_time"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_vm._l((_vm.wait_times),function(wait_time,index){return _c('b-col',{key:wait_time.id,attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":wait_time.type_wait_times,"label-for":wait_time.type_wait_times}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"size":"sm","placeholder":"hh:mm","type":"text"},model:{value:(wait_time.total),callback:function ($$v) {_vm.$set(wait_time, "total", $$v)},expression:"wait_time.total"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"plaintext":"","type":"text"},model:{value:(wait_time.total),callback:function ($$v) {_vm.$set(wait_time, "total", $$v)},expression:"wait_time.total"}})],1)],1)}),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.personal_time_add),expression:"personal_time_add"}],attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":_vm.personal_time_option}},[_vm._v("Add Personal Time")])],1)],2),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_vm._l((_vm.wait_times),function(wait_time,index){return (wait_time.comments != '' && !_vm.edit)?_c('b-col',{key:wait_time.id,attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Comments Wait Time","label-for":"Comments_Wait_Time"}},[_c('b-form-textarea',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","type":"text","rows":2,"max-rows":2},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.wait_times),function(wait_time,index){return (_vm.edit)?_c('b-col',{key:wait_time.id,attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":'Comments ' + wait_time.type_wait_times,"label-for":"Comments_Wait_Time"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","placeholder":"Comments Wait Time","type":"text"},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}})],1)],1):_vm._e()}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Comments Start","label-for":"comments_start"}},[_c('b-form-textarea',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"comments_start","type":"text","rows":2,"max-rows":2},model:{value:(_vm.comments_start),callback:function ($$v) {_vm.comments_start=$$v},expression:"comments_start"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"comments_start","type":"text"},model:{value:(_vm.comments_start),callback:function ($$v) {_vm.comments_start=$$v},expression:"comments_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Comments End","label-for":"comments_end"}},[_c('b-form-textarea',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"comments_end","type":"text","rows":2,"max-rows":2},model:{value:(_vm.comments_end),callback:function ($$v) {_vm.comments_end=$$v},expression:"comments_end"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"comments_end","type":"text"},model:{value:(_vm.comments_end),callback:function ($$v) {_vm.comments_end=$$v},expression:"comments_end"}})],1)],1)],2),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Haul Cost")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Regular Cost","label-for":"regular_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"regular_cost","type":"text"},model:{value:(_vm.cost_regular),callback:function ($$v) {_vm.cost_regular=$$v},expression:"cost_regular"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Stb Cost","label-for":"stb_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"stb_cost","type":"text"},model:{value:(_vm.cost_stb),callback:function ($$v) {_vm.cost_stb=$$v},expression:"cost_stb"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Worktime Cost","label-for":"w_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"w_cost","type":"text"},model:{value:(_vm.cost_worktime),callback:function ($$v) {_vm.cost_worktime=$$v},expression:"cost_worktime"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Unit Cost","label-for":"unit_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"unit_cost","type":"text"},model:{value:(_vm.unit_cost),callback:function ($$v) {_vm.unit_cost=$$v},expression:"unit_cost"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Drive Rate","label-for":"rate"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"rate","type":"text"},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"onmouseover":"this.style.cursor='pointer'","sm":"6","md":"4","lg":"4","xl":"4"},on:{"click":function($event){_vm.est_detail()}}},[_c('b-form-group',{attrs:{"label":"Total Cost","label-for":"total_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"total_cost","type":"text"},model:{value:(_vm.total_cost),callback:function ($$v) {_vm.total_cost=$$v},expression:"total_cost"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Stand by Rate","label-for":"stb_rate"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"stb_rate","type":"text"},model:{value:(_vm.stb_rate),callback:function ($$v) {_vm.stb_rate=$$v},expression:"stb_rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Chain Up Rate","label-for":"chain_up_rate"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"chain_up_rate","type":"text"},model:{value:(_vm.chain_up_rate),callback:function ($$v) {_vm.chain_up_rate=$$v},expression:"chain_up_rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Chain Up Rate Applied","label-for":"id_5"}},[_c('b-form-checkbox',{attrs:{"id":"id_5","plain":"","disabled":""},model:{value:(_vm.chain_up_applied),callback:function ($$v) {_vm.chain_up_applied=$$v},expression:"chain_up_applied"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Agreement","label-for":"agreement"}},[(_vm.agreement_id != 'No Assigned' && !_vm.edit)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/agreement/'+_vm.agreement_id+'/')}}},[_vm._v(_vm._s(this.agreement_id))]):_c('b-form-input',{attrs:{"plaintext":"","id":"agreement","type":"text"},model:{value:(_vm.agreement_id),callback:function ($$v) {_vm.agreement_id=$$v},expression:"agreement_id"}})],1)],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.data_in.haul_invoice),expression:"data_in.haul_invoice"}],staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":_vm.invoiced_cost_click}},[_vm._v("Adjust Haul Cost")]),_vm._v(" "),(_vm.edit_invoiced_cost)?_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":_vm.invoiced_cost_update}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(_vm.edit_invoiced_cost)?_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":_vm.invoiced_cost_cancel}},[_vm._v("Cancel")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.data_in.haul_invoice),expression:"data_in.haul_invoice"}],staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Invoiced Cost","label-for":"ic"}},[(!_vm.edit_invoiced_cost)?_c('span',[_vm._v(_vm._s('$'+this.invoiced_cost))]):_c('b-form-input',{attrs:{"id":"ic","type":"text"},nativeOn:{"keydown":function($event){_vm.invoicedcostNumber($event)},"blur":function($event){_vm.inputBlur('invoiced_cost_text')}},model:{value:(_vm.invoiced_cost_text),callback:function ($$v) {_vm.invoiced_cost_text=$$v},expression:"invoiced_cost_text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8","md":"6","lg":"6","xl":"6"}},[_c('b-form-group',{attrs:{"label":"Justification","label-for":"desc"}},[(!_vm.edit_invoiced_cost)?_c('b-form-textarea',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"desc","type":"text","rows":"3","max-rows":"8"},model:{value:(_vm.justification),callback:function ($$v) {_vm.justification=$$v},expression:"justification"}}):_c('b-form-textarea',{attrs:{"id":"desc","type":"text","rows":"3","max-rows":"8"},model:{value:(_vm.justification_text),callback:function ($$v) {_vm.justification_text=$$v},expression:"justification_text"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Terminal Cost")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Terminal Treatment Fee","label-for":"terminal_treatment_fee"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_treatment_fee","type":"text"},model:{value:(_vm.terminal_treatment_fee),callback:function ($$v) {_vm.terminal_treatment_fee=$$v},expression:"terminal_treatment_fee"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Terminal Other Fees","label-for":"terminal_other_fees"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_other_fees","type":"text"},model:{value:(_vm.terminal_other_fees),callback:function ($$v) {_vm.terminal_other_fees=$$v},expression:"terminal_other_fees"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Terminal H2S Fees","label-for":"terminal_h2s_fees"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_h2s_fees","type":"text"},model:{value:(_vm.terminal_h2s_fees),callback:function ($$v) {_vm.terminal_h2s_fees=$$v},expression:"terminal_h2s_fees"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Terminal Density Fees","label-for":"terminal_density_fee"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_density_fee","type":"text"},model:{value:(_vm.terminal_density_fee),callback:function ($$v) {_vm.terminal_density_fee=$$v},expression:"terminal_density_fee"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Total Terminal Cost","label-for":"total_terminal_treatment_fees"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"total_terminal_treatment_fees","type":"text"},model:{value:(_vm.total_terminal_treatment_fees),callback:function ($$v) {_vm.total_terminal_treatment_fees=$$v},expression:"total_terminal_treatment_fees"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Route Map")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"mapStyle":_vm.mapStyle,"mapTypeId":_vm.mapTypeId}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('b-link',{attrs:{"href":_vm.infoLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.infoContent))])],1),_vm._v(" "),_c('gmap-polyline',{attrs:{"path":_vm.path,"options":_vm.options},on:{"update:path":function($event){_vm.path=$event}}}),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"label":m.label,"title":m.title,"icon":m.icon,"clickable":true,"draggable":m.draggable},on:{"click":function($event){_vm.toggleInfoWindow(m, index)}}})})],2)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Pictures")])])],1),_vm._v(" "),(_vm.files !='')?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},_vm._l((_vm.files),function(file){return _c('div',{key:file.file,staticStyle:{"padding-bottom":"20px"}},[_c('p',{staticStyle:{"padding":"10px 0 0 15px"}},[_vm._v(_vm._s(file.comment))]),_vm._v(" "),_c('img',{staticClass:"img-fluid rounded d-block m-l-none",attrs:{"src":file.file}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-btn',{staticClass:"float-right",staticStyle:{"margin-right":"30px"},attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.saveImage(file.file)}}},[_vm._v("Download")]),_vm._v(" "),_c('br')],1)})):_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('p',{staticStyle:{"padding":"10px 0 0 15px"}},[_vm._v("No pictures available for this Haul")])])]),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("Hazard Assessment")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"5px 0 0 5px"}},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',[_vm._v("Load Location: "+_vm._s(_vm.load_location))])])],1),_vm._v(" "),(!_vm.edit)?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hz_load.hazards.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"Hazards:","label-for":"hzID","verticall":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"hazard_name","options":_vm.hz_load.hazards,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No Hazards have been added")])])],1):_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hazards.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Hazards:","label-for":"hzID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.hazards,"name":"Checkboxes2","plain":""},on:{"input":_vm.HZChange},model:{value:(_vm.hazard_id),callback:function ($$v) {_vm.hazard_id=$$v},expression:"hazard_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateHZ,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.HZToggleAll},model:{value:(_vm.hzAllSelected),callback:function ($$v) {_vm.hzAllSelected=$$v},expression:"hzAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.hzAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No Hazards have been added")])])],1),_vm._v(" "),(!_vm.edit)?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hz_load.controls.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"Controls:","label-for":"ctlID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"control_name","options":_vm.hz_load.controls,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No controls have been added")])])],1):_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.controls.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Controls:","label-for":"ctlID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.controls,"name":"Checkboxes2","plain":""},on:{"input":_vm.CTLChange},model:{value:(_vm.control_id),callback:function ($$v) {_vm.control_id=$$v},expression:"control_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateCTL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.CTLToggleAll},model:{value:(_vm.ctlAllSelected),callback:function ($$v) {_vm.ctlAllSelected=$$v},expression:"ctlAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.ctlAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No controls have been added")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"5px 0 0 5px"}},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',[_vm._v("Unload Location: "+_vm._s(_vm.unload_location))])])],1),_vm._v(" "),(!_vm.edit)?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hz_unload.hazards.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"Hazards:","label-for":"hzID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"hazard_name","options":_vm.hz_unload.hazards,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No Hazards have been added")])])],1):_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hazards.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Hazards:","label-for":"hzID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.hazards,"name":"Checkboxes2","plain":""},on:{"input":_vm.HZ1Change},model:{value:(_vm.hazard1_id),callback:function ($$v) {_vm.hazard1_id=$$v},expression:"hazard1_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateHZ1,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.HZ1ToggleAll},model:{value:(_vm.hz1AllSelected),callback:function ($$v) {_vm.hz1AllSelected=$$v},expression:"hz1AllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.hz1AllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No Hazards have been added")])])],1),_vm._v(" "),(!_vm.edit)?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hz_unload.controls.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"Controls:","label-for":"ctlID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"control_name","options":_vm.hz_unload.controls,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No controls have been added")])])],1):_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.controls.length>0)?_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Controls:","label-for":"ctlID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.controls,"name":"Checkboxes2","plain":""},on:{"input":_vm.CTL1Change},model:{value:(_vm.control1_id),callback:function ($$v) {_vm.control1_id=$$v},expression:"control1_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateCTL1,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.CTL1ToggleAll},model:{value:(_vm.ctl1AllSelected),callback:function ($$v) {_vm.ctl1AllSelected=$$v},expression:"ctl1AllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.ctl1AllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('p',[_vm._v("No controls have been added")])])],1),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{staticStyle:{"background-color":"#ebe5d0","padding-top":"5px","padding-bottom":"5px"},attrs:{"sm":"12","md":"12","lg":"12","xl":"12"}},[_c('span',{staticClass:"col-form-label"},[_vm._v("CNR")])])],1):_vm._e(),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Request Number","label-for":"request_number"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"request_number","type":"text"},model:{value:(_vm.cnr_details[0].request_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "request_number", $$v)},expression:"cnr_details[0].request_number"}}):_c('b-form-input',{attrs:{"id":"request_number","type":"text"},model:{value:(_vm.cnr_details[0].request_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "request_number", $$v)},expression:"cnr_details[0].request_number"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Tank Number","label-for":"tank_number"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"tank_number","type":"text"},model:{value:(_vm.cnr_details[0].tank_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tank_number", $$v)},expression:"cnr_details[0].tank_number"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"id":"tank_number","type":"text"},model:{value:(_vm.cnr_details[0].tank_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tank_number", $$v)},expression:"cnr_details[0].tank_number"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Start Gauge","label-for":"start_gauge"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"start_gauge","type":"text"},model:{value:(_vm.cnr_details[0].start_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_gauge", $$v)},expression:"cnr_details[0].start_gauge"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('###'),expression:"'###'"}],attrs:{"id":"start_gauge","type":"text"},model:{value:(_vm.cnr_details[0].start_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_gauge", $$v)},expression:"cnr_details[0].start_gauge"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Finish Gauge","label-for":"finish_gauge"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"finish_gauge","type":"text"},model:{value:(_vm.cnr_details[0].finish_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "finish_gauge", $$v)},expression:"cnr_details[0].finish_gauge"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('###'),expression:"'###'"}],attrs:{"id":"finish_gauge","type":"text"},model:{value:(_vm.cnr_details[0].finish_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "finish_gauge", $$v)},expression:"cnr_details[0].finish_gauge"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Start Time Load","label-for":"start_time_load"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"start_time_load","type":"text"},model:{value:(_vm.cnr_details[0].start_time_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_time_load", $$v)},expression:"cnr_details[0].start_time_load"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"start_time_load","type":"date"},model:{value:(_vm.cnr_details[0].start_time_load_date),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_time_load_date", $$v)},expression:"cnr_details[0].start_time_load_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"start_time_load","type":"text"},model:{value:(_vm.cnr_details[0].start_time_load_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_time_load_time", $$v)},expression:"cnr_details[0].start_time_load_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"End Time Load","label-for":"end_time_load"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"end_time_load","type":"text"},model:{value:(_vm.cnr_details[0].end_time_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "end_time_load", $$v)},expression:"cnr_details[0].end_time_load"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"end_time_load","type":"date"},model:{value:(_vm.cnr_details[0].end_time_load_date),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "end_time_load_date", $$v)},expression:"cnr_details[0].end_time_load_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"end_time_load","type":"text"},model:{value:(_vm.cnr_details[0].end_time_load_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "end_time_load_time", $$v)},expression:"cnr_details[0].end_time_load_time"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Temperature Load","label-for":"temperature_load"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"temperature_load","type":"text"},model:{value:(_vm.cnr_details[0].temperature_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_load", $$v)},expression:"cnr_details[0].temperature_load"}}):_c('b-form-input',{attrs:{"id":"temperature_load","type":"text"},nativeOn:{"keydown":function($event){_vm.temperatureLoad($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].temperature_load')}},model:{value:(_vm.cnr_details[0].temperature_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_load", $$v)},expression:"cnr_details[0].temperature_load"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Temperature Unload","label-for":"temperature_unload"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"temperature_unload","type":"text"},model:{value:(_vm.cnr_details[0].temperature_unload),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_unload", $$v)},expression:"cnr_details[0].temperature_unload"}}):_c('b-form-input',{attrs:{"id":"temperature_unload","type":"text"},nativeOn:{"keydown":function($event){_vm.temperatureULoad($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].temperature_unload')}},model:{value:(_vm.cnr_details[0].temperature_unload),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_unload", $$v)},expression:"cnr_details[0].temperature_unload"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Gross Weight","label-for":"gross_weight"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"gross_weight","type":"text"},model:{value:(_vm.cnr_details[0].gross_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "gross_weight", $$v)},expression:"cnr_details[0].gross_weight"}}):_c('b-form-input',{attrs:{"id":"gross_weight","type":"text"},nativeOn:{"keydown":function($event){_vm.grossWeight($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].gross_weight')}},model:{value:(_vm.cnr_details[0].gross_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "gross_weight", $$v)},expression:"cnr_details[0].gross_weight"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',{staticStyle:{"padding":"10px 0 0 15px"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Tare Weight","label-for":"tare_weight"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"tare_weight","type":"text"},model:{value:(_vm.cnr_details[0].tare_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tare_weight", $$v)},expression:"cnr_details[0].tare_weight"}}):_c('b-form-input',{attrs:{"id":"tare_weight","type":"text"},nativeOn:{"keydown":function($event){_vm.tareWeight($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].tare_weight')}},model:{value:(_vm.cnr_details[0].tare_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tare_weight", $$v)},expression:"cnr_details[0].tare_weight"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Scale In Time","label-for":"scale_in_time"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"scale_in_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_in_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_in_time", $$v)},expression:"cnr_details[0].scale_in_time"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"id":"scale_in_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_in_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_in_time", $$v)},expression:"cnr_details[0].scale_in_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"4","xl":"4"}},[_c('b-form-group',{attrs:{"label":"Scale Out Time","label-for":"scale_out_time"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"scale_out_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_out_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_out_time", $$v)},expression:"cnr_details[0].scale_out_time"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"id":"scale_out_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_out_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_out_time", $$v)},expression:"cnr_details[0].scale_out_time"}})],1)],1)],1):_vm._e()],2),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add Personal Time","centered":"","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.personal_time_modal),callback:function ($$v) {_vm.personal_time_modal=$$v},expression:"personal_time_modal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Personal Time","label-for":"personal_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"personal_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('total')}},model:{value:(_vm.personal_time_items.total),callback:function ($$v) {_vm.$set(_vm.personal_time_items, "total", $$v)},expression:"personal_time_items.total"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Comments","label-for":"comments_pt"}},[_c('b-form-input',{attrs:{"id":"comments_ps","type":"text"},model:{value:(_vm.personal_time_items.comments),callback:function ($$v) {_vm.$set(_vm.personal_time_items, "comments", $$v)},expression:"personal_time_items.comments"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.hidepersonaltime()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.personal_time_save()}}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"","centered":"","ok-only":""},model:{value:(_vm.calculate),callback:function ($$v) {_vm.calculate=$$v},expression:"calculate"}},[_c('b-row',[_c('p',{staticStyle:{"margin-left":"5px","margin-bottom":"0","line-height":"15px"}},[_vm._v("Formula: "+_vm._s(_vm.formula))]),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Drive Rate:","label-for":"id_1"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_1","type":"text"},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}})],1),_vm._v(" "),(_vm.type_rate=='Volume Actual')?_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Volume Actual:","label-for":"id_2"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_2","type":"text"},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}})],1):_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Drive Time:","label-for":"id_2"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_2","type":"text"},model:{value:(_vm.driving_time),callback:function ($$v) {_vm.driving_time=$$v},expression:"driving_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Stand by Rate:","label-for":"id_3"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_3","type":"text"},model:{value:(_vm.stb_rate),callback:function ($$v) {_vm.stb_rate=$$v},expression:"stb_rate"}})],1),_vm._v(" "),(_vm.type_stb_rate=='Standby Time')?_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Standby Time:","label-for":"id_22"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_22","type":"text"},model:{value:(_vm.stb),callback:function ($$v) {_vm.stb=$$v},expression:"stb"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Chain Up Rate:","label-for":"id_4"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_4","type":"text"},model:{value:(_vm.chain_up_rate),callback:function ($$v) {_vm.chain_up_rate=$$v},expression:"chain_up_rate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Chain Up Rate Applied","label-for":"id_5"}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"id":"checkbox","plain":"","disabled":""},model:{value:(_vm.chain_up_applied),callback:function ($$v) {_vm.chain_up_applied=$$v},expression:"chain_up_applied"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Worktime Rate:","label-for":"id_6"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_6","type":"text"},model:{value:(_vm.worktime_rate),callback:function ($$v) {_vm.worktime_rate=$$v},expression:"worktime_rate"}})],1),_vm._v(" "),(_vm.type_worktime_rate=='Work Time')?_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"WorkTime:","label-for":"id_222"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_222","type":"text"},model:{value:(_vm.work_time),callback:function ($$v) {_vm.work_time=$$v},expression:"work_time"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Total Terminal Cost:","label-for":"id_7"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_7","type":"text"},model:{value:(_vm.total_terminal_treatment_fees),callback:function ($$v) {_vm.total_terminal_treatment_fees=$$v},expression:"total_terminal_treatment_fees"}})],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add to Folders","ok-variant":"primary","centered":"","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.modalFolders),callback:function ($$v) {_vm.modalFolders=$$v},expression:"modalFolders"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label-cols":2,"id":"L4","label-for":"folderID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.folderOptions,"name":"Checkboxes","plain":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.modalFolders=false}}},[_vm._v("\n\t\t\t\t\tCancel\n\t\t\t\t")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addHaulsFolder()}}},[_vm._v("\n\t\t\t\t\tSave\n\t\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[(_vm.haul_id)?_c('HaulPopup',{key:_vm.componentKey,ref:"haul_detail",attrs:{"data_in":_vm.data_in}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(248);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(945);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787b2b42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(947);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787b2b42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_vm._v(_vm._s(_vm.year)+" © Drift Technological Solutions Ltd.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06658494_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(951);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06658494_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cb6377e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(950);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cb6377e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.current_user)+" ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}]},[_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Current Login")])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"text-success"},[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "+_vm._s(_vm.role))])],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.getProfile}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Profile")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),(_vm.current_role == 'super_admin')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'analyst')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'marketing_accountant')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'super_analyst')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'trucking_company_admin')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dash"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'trucking_operational_manager')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dash"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'trucking_company_admin_light')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/hauls"}}):_vm._e(),_vm._v(" "),(_vm.current_role == 'operations_manager')?_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"d-md-down-none"},[_c('b-nav-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],staticClass:"px-3"},[_c('router-link',{attrs:{"to":"/dashboard"}},[_vm._v("Dashboard")])],1),_vm._v(" "),_c('b-nav-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.current_role !== 'trucking_company_admin' && _vm.current_role !== 'trucking_company_admin_light' && _vm.current_role !== 'trucking_operational_manager'),expression:"current_role !== 'trucking_company_admin' && current_role !== 'trucking_company_admin_light' && current_role !== 'trucking_operational_manager'"}],staticClass:"px-3"},[_c('router-link',{attrs:{"to":"/reports"}},[_vm._v("Reports")])],1),_vm._v(" "),_c('b-nav-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.view1),expression:"view1"}],staticClass:"px-3"},[_c('router-link',{attrs:{"to":"/hauls"}},[_vm._v("Hauls")])],1),_vm._v(" "),_c('b-nav-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.current_role === 'super_admin' || _vm.current_role === 'super_analyst' || _vm.current_role === 'analyst' || _vm.current_role === 'marketing_accountant'),expression:"current_role === 'super_admin' || current_role === 'super_analyst' || current_role === 'analyst' || current_role === 'marketing_accountant'"}],staticClass:"px-3"},[_c('router-link',{attrs:{"to":"/targets"}},[_vm._v("Nominations")])],1),_vm._v(" "),_c('b-nav-item',{directives:[{name:"show",rawName:"v-show",value:(!_vm.view1),expression:"!view1"}],staticClass:"px-3"},[_c('router-link',{attrs:{"to":"/users"}},[_vm._v("Users")])],1)],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto header-username"},[_c('HeaderDropdownAccnt')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d2d796c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(974);
function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d2d796c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419727a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(955);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419727a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bed3424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(957);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bed3424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0777a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(959);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0777a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c6b7ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(961);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c6b7ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(963);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536afe98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(965);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536afe98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcf9e66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(967);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcf9e66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"pill":"","variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(969);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(971);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 972 */,
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[(item.name=='Requested Hauls')?_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":_vm.badge,"variant":item.variant}}):_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44793f58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1041);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44793f58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartTarget_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartTarget_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 267,
	"./af.js": 267,
	"./ar": 268,
	"./ar-dz": 269,
	"./ar-dz.js": 269,
	"./ar-kw": 270,
	"./ar-kw.js": 270,
	"./ar-ly": 271,
	"./ar-ly.js": 271,
	"./ar-ma": 272,
	"./ar-ma.js": 272,
	"./ar-sa": 273,
	"./ar-sa.js": 273,
	"./ar-tn": 274,
	"./ar-tn.js": 274,
	"./ar.js": 268,
	"./az": 275,
	"./az.js": 275,
	"./be": 276,
	"./be.js": 276,
	"./bg": 277,
	"./bg.js": 277,
	"./bn": 278,
	"./bn.js": 278,
	"./bo": 279,
	"./bo.js": 279,
	"./br": 280,
	"./br.js": 280,
	"./bs": 281,
	"./bs.js": 281,
	"./ca": 282,
	"./ca.js": 282,
	"./cs": 283,
	"./cs.js": 283,
	"./cv": 284,
	"./cv.js": 284,
	"./cy": 285,
	"./cy.js": 285,
	"./da": 286,
	"./da.js": 286,
	"./de": 287,
	"./de-at": 288,
	"./de-at.js": 288,
	"./de-ch": 289,
	"./de-ch.js": 289,
	"./de.js": 287,
	"./dv": 290,
	"./dv.js": 290,
	"./el": 291,
	"./el.js": 291,
	"./en-au": 292,
	"./en-au.js": 292,
	"./en-ca": 293,
	"./en-ca.js": 293,
	"./en-gb": 294,
	"./en-gb.js": 294,
	"./en-ie": 295,
	"./en-ie.js": 295,
	"./en-nz": 296,
	"./en-nz.js": 296,
	"./eo": 297,
	"./eo.js": 297,
	"./es": 298,
	"./es-do": 299,
	"./es-do.js": 299,
	"./es.js": 298,
	"./et": 300,
	"./et.js": 300,
	"./eu": 301,
	"./eu.js": 301,
	"./fa": 302,
	"./fa.js": 302,
	"./fi": 303,
	"./fi.js": 303,
	"./fo": 304,
	"./fo.js": 304,
	"./fr": 305,
	"./fr-ca": 306,
	"./fr-ca.js": 306,
	"./fr-ch": 307,
	"./fr-ch.js": 307,
	"./fr.js": 305,
	"./fy": 308,
	"./fy.js": 308,
	"./gd": 309,
	"./gd.js": 309,
	"./gl": 310,
	"./gl.js": 310,
	"./gom-latn": 311,
	"./gom-latn.js": 311,
	"./he": 312,
	"./he.js": 312,
	"./hi": 313,
	"./hi.js": 313,
	"./hr": 314,
	"./hr.js": 314,
	"./hu": 315,
	"./hu.js": 315,
	"./hy-am": 316,
	"./hy-am.js": 316,
	"./id": 317,
	"./id.js": 317,
	"./is": 318,
	"./is.js": 318,
	"./it": 319,
	"./it.js": 319,
	"./ja": 320,
	"./ja.js": 320,
	"./jv": 321,
	"./jv.js": 321,
	"./ka": 322,
	"./ka.js": 322,
	"./kk": 323,
	"./kk.js": 323,
	"./km": 324,
	"./km.js": 324,
	"./kn": 325,
	"./kn.js": 325,
	"./ko": 326,
	"./ko.js": 326,
	"./ky": 327,
	"./ky.js": 327,
	"./lb": 328,
	"./lb.js": 328,
	"./lo": 329,
	"./lo.js": 329,
	"./lt": 330,
	"./lt.js": 330,
	"./lv": 331,
	"./lv.js": 331,
	"./me": 332,
	"./me.js": 332,
	"./mi": 333,
	"./mi.js": 333,
	"./mk": 334,
	"./mk.js": 334,
	"./ml": 335,
	"./ml.js": 335,
	"./mr": 336,
	"./mr.js": 336,
	"./ms": 337,
	"./ms-my": 338,
	"./ms-my.js": 338,
	"./ms.js": 337,
	"./my": 339,
	"./my.js": 339,
	"./nb": 340,
	"./nb.js": 340,
	"./ne": 341,
	"./ne.js": 341,
	"./nl": 342,
	"./nl-be": 343,
	"./nl-be.js": 343,
	"./nl.js": 342,
	"./nn": 344,
	"./nn.js": 344,
	"./pa-in": 345,
	"./pa-in.js": 345,
	"./pl": 346,
	"./pl.js": 346,
	"./pt": 347,
	"./pt-br": 348,
	"./pt-br.js": 348,
	"./pt.js": 347,
	"./ro": 349,
	"./ro.js": 349,
	"./ru": 350,
	"./ru.js": 350,
	"./sd": 351,
	"./sd.js": 351,
	"./se": 352,
	"./se.js": 352,
	"./si": 353,
	"./si.js": 353,
	"./sk": 354,
	"./sk.js": 354,
	"./sl": 355,
	"./sl.js": 355,
	"./sq": 356,
	"./sq.js": 356,
	"./sr": 357,
	"./sr-cyrl": 358,
	"./sr-cyrl.js": 358,
	"./sr.js": 357,
	"./ss": 359,
	"./ss.js": 359,
	"./sv": 360,
	"./sv.js": 360,
	"./sw": 361,
	"./sw.js": 361,
	"./ta": 362,
	"./ta.js": 362,
	"./te": 363,
	"./te.js": 363,
	"./tet": 364,
	"./tet.js": 364,
	"./th": 365,
	"./th.js": 365,
	"./tl-ph": 366,
	"./tl-ph.js": 366,
	"./tlh": 367,
	"./tlh.js": 367,
	"./tr": 368,
	"./tr.js": 368,
	"./tzl": 369,
	"./tzl.js": 369,
	"./tzm": 370,
	"./tzm-latn": 371,
	"./tzm-latn.js": 371,
	"./tzm.js": 370,
	"./uk": 372,
	"./uk.js": 372,
	"./ur": 373,
	"./ur.js": 373,
	"./uz": 374,
	"./uz-latn": 375,
	"./uz-latn.js": 375,
	"./uz.js": 374,
	"./vi": 376,
	"./vi.js": 376,
	"./x-pseudo": 377,
	"./x-pseudo.js": 377,
	"./yo": 378,
	"./yo.js": 378,
	"./zh-cn": 379,
	"./zh-cn.js": 379,
	"./zh-hk": 380,
	"./zh-hk.js": 380,
	"./zh-tw": 381,
	"./zh-tw.js": 381
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1009;

/***/ }),
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.1.0","/home/ubuntu/drift_client"]],"_from":"vue-chartjs@3.1.0","_id":"vue-chartjs@3.1.0","_inBundle":false,"_integrity":"sha512-cp70zluNJdN57J907hSzjp4jayF6O0ayBJ/alZprHx+BvbVe+nL+QF3TOPSSao3UoenCopYJybmDi/RWYb7afw==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.1.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.1.0","saveSpec":null,"fetchSpec":"3.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.1.0.tgz","_spec":"3.1.0","_where":"/home/ubuntu/drift_client","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.1.0"}

/***/ }),
/* 1039 */,
/* 1040 */,
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"mb-4"},[_c('b-col',{attrs:{"md":"12","lg":"8","xl":"4"}},[(!_vm.chart_activated)?_c('h2',{staticClass:"pr-3 my-1 mb-3 mb-lg-0 pageinfo text-center text-lg-left"},[_vm._v("Dashboard")]):_c('h2',{staticClass:"pr-3 my-1 mb-3 mb-lg-0 pageinfo text-center text-lg-left"},[_vm._v("Dashboard - Trucking Company")])])],1),_vm._v(" "),(!_vm.chart_activated)?_c('b-row',{staticClass:"mb-4"},[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.ec_filter,"title":"Energy Company"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])}))],1),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.tc_filter,"title":"Trucking Company"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_vm._v("All Trucking Companies")]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","lg":"2","title":"Initial Date"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"input":function($event){_vm.iFilter()}},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","lg":"2","title":"End date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"input":function($event){_vm.eFilter()}},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),(_vm.role=='super_admin' || _vm.role=='super_analyst' || _vm.role=='operations_manager')?_c('b-col',{attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.oa_filter,"title":"Operating Area"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.oaFilter('All Operating Areas', 0)}}},[_vm._v("All Operating Areas")]),_vm._v(" "),_vm._l((_vm.operating_areas_filter),function(operating_area_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.oaFilter(operating_area_filter.name, operating_area_filter.id)}}},[_vm._v(_vm._s(operating_area_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-btn',{staticClass:"pull-right pull-sm-left my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1),_vm._v(" "),_c('b-col',[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),(_vm.role =='super_admin')?_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate Chart'),expression:"'Activate/Deactivate Chart'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.activate_chart_click()}}},[_c('i',{staticClass:"fa fa-bar-chart"})]):_vm._e()],1)],1):_c('b-row',{staticClass:"mb-4"},[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.tc_filter1,"title":"Trucking Company"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter1('All Trucking Companies', 0)}}},[_vm._v("All Trucking Companies")]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter1),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter1(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.ec_filter1,"title":"Energy Company"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter1('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter1),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter1(energy_company_filter.name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","lg":"2","title":"Initial Date"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"input":function($event){_vm.iFilter1()}},model:{value:(_vm.filter_by1.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by1, "initial_date", $$v)},expression:"filter_by1.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","lg":"2","title":"End date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"input":function($event){_vm.eFilter1()}},model:{value:(_vm.filter_by1.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by1, "end_date", $$v)},expression:"filter_by1.end_date"}})],1),_vm._v(" "),(_vm.role=='super_admin' || _vm.role=='super_analyst' || _vm.role=='operations_manager')?_c('b-col',{attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.oa_filter1,"title":"Operating Area"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.oaFilter1('All Operating Areas', 0)}}},[_vm._v("All Operating Areas")]),_vm._v(" "),_vm._l((_vm.operating_areas_filter1),function(operating_area_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.oaFilter1(operating_area_filter.name, operating_area_filter.id)}}},[_vm._v(_vm._s(operating_area_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-btn',{staticClass:"pull-right pull-sm-left my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.clearFilters1()}}},[_vm._v("Clear")])],1),_vm._v(" "),_c('b-col',[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),(_vm.role =='super_admin')?_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate Chart'),expression:"'Activate/Deactivate Chart'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.activate_chart_click()}}},[_c('i',{staticClass:"fa fa-bar-chart"})]):_vm._e(),_vm._v(" "),(_vm.role =='super_admin' && _vm.chart_activated && (_vm.load_locations_id.length > 0 || _vm.unload_locations_id.length > 0))?_c('b-btn',{staticClass:"pull-right my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.generate_chart_click()}}},[_vm._v("Generate Chart")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-targets cart-100",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticStyle:{"line-height":"20px","margin-bottom":"5px"}},[_vm._v("Alerts")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"}},[_vm._v(_vm._s(_vm.alerts.initial_date)+"-"+_vm._s(_vm.alerts.end_date))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('Volume > 60 m³')}}},[_vm._v("Volume Spikes : "+_vm._s(_vm.alerts.spike)+" Loads")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('BS&W - 100%')}}},[_vm._v("BS&W=100% : "+_vm._s(_vm.alerts.b100)+" Loads")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('BS&W < 0.5%')}}},[_vm._v("BS&W<0.5% : "+_vm._s(_vm.alerts.b50)+" Loads")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('BS&W - Additional Fees Apply')}}},[_vm._v("Additional Fees: "+_vm._s(_vm.alerts.fee)+" Loads")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('Haul without Nom')}}},[_vm._v("Hauls w/o Nominations: "+_vm._s(_vm.alerts.nom)+" Loads")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_vm._l((_vm.targets_chart),function(target_chart){return (!_vm.chart_activated)?_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-targets cart-100",attrs:{"no-body":""}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"col-auto"},[_c('h4',{staticStyle:{"line-height":"20px","margin-bottom":"5px","margin-top":"5px","font-weight":"bold"}},[_vm._v(_vm._s(target_chart.target_data.legal_location))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"}},[_vm._v(_vm._s(target_chart.target_data.target_initial_date)+"-"+_vm._s(target_chart.target_data.target_end_date))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"}},[_vm._v(_vm._s(target_chart.target_data.fluid_name))])]),_vm._v(" "),_c('b-col',[_c('h4',{staticStyle:{"line-height":"20px","margin-bottom":"5px","margin-top":"5px","text-align":"right"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.est_detail(target_chart.target_data.estimate_selling_price)}}},[_vm._v(_vm._s(target_chart.target_data.estimate_selling_price.price))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('highcharts',{attrs:{"options":target_chart.target_chart}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('highcharts',{staticClass:"chart",attrs:{"options":target_chart.target_chart1}})],1)],1)],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.location_other.length !=0 && !_vm.chart_activated)?_c('b-col',{attrs:{"sm":"6","lg":"4"}},[_c('b-card',{staticClass:"bg-targets cart-100",attrs:{"no-body":""}},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"md":"12"}},[_c('h4',{staticStyle:{"line-height":"20px","margin-bottom":"5px","margin-top":"5px"}},[_vm._v(_vm._s(_vm.location_other[0].location_data.legal_location))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"}},[_vm._v(_vm._s(_vm.location_other[0].location_data.location_initial_date)+"-"+_vm._s(_vm.location_other[0].location_data.location_end_date))])]),_vm._v(" "),_c('highcharts',{staticClass:"chart",attrs:{"options":_vm.location_other[0].target_chart}})],1)],1)],1)],1):_vm._e()],2),_vm._v(" "),(_vm.role =='super_admin' &&  _vm.chart_activated && (_vm.unloadlocationselect.length > 0 || _vm.loadlocationselect.length > 0))?_c('b-row',[_c('b-col',{attrs:{"sm":"4","lg":"4"}},[_c('b-row',[_c('b-col',[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-size":"lg","label-class":"font-weight-bold pt-0","id":"L5","label":"Load Locations","label-for":"loadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.load_locations_id),callback:function ($$v) {_vm.load_locations_id=$$v},expression:"load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t            "+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t          ")])],1):_c('span',[_vm._v("No Load locations")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.unloadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-size":"lg","label-class":"font-weight-bold pt-0","id":"L6","label":"Unload Locations","label-for":"unloadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.unloadLocationsChange},model:{value:(_vm.unload_locations_id),callback:function ($$v) {_vm.unload_locations_id=$$v},expression:"unload_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ULToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t        "+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t        ")])],1):_c('span',[_vm._v("No Unload locations")])],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8","lg":"8"}},[_c('b-card',{staticClass:"chart-wrapper",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('highcharts',{staticClass:"chart",attrs:{"options":_vm.chart}})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.role =='super_admin' &&  _vm.chart_activated && _vm.users_select.length >0 && (_vm.load_locations_id.length > 0 || _vm.unload_locations_id.length > 0))?_c('b-row',[_c('b-col',{attrs:{"sm":"4","lg":"4"}},[_c('b-row',[_c('b-col',[(_vm.users_select.length > 0)?_c('b-form-group',{attrs:{"label-size":"lg","label-class":"font-weight-bold pt-0","id":"L7","label":"Drivers","label-for":"userID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.users_select,"name":"Checkboxes2","plain":""},on:{"input":_vm.user_Change},model:{value:(_vm.users_id),callback:function ($$v) {_vm.users_id=$$v},expression:"users_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminate_user,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.user_ToggleAll},model:{value:(_vm.user_AllSelected),callback:function ($$v) {_vm.user_AllSelected=$$v},expression:"user_AllSelected"}},[_vm._v("\n\t\t\t\t\t          "+_vm._s(_vm.user_AllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t      ")])],1):_c('p',[_vm._v("No Users")])],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8","lg":"8"}},[_c('b-card',{staticClass:"chart-wrapper",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('highcharts',{staticClass:"chart",attrs:{"options":_vm.chart_users}})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.chart_activated)?_c('draggable',{attrs:{"list":_vm.list,"disabled":!_vm.enabled,"ghost-class":"ghost"},on:{"start":function($event){_vm.dragging = true},"end":_vm.change}},_vm._l((_vm.list),function(element){return _c('b-row',{key:element.chart},[_c('b-col',{attrs:{"sm":"1","lg":"1"}},[_c('b-card',{staticClass:"drag chart",attrs:{"no-body":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"11","lg":"11"}},[_c('b-card',{attrs:{"no-body":""}},[_c('highcharts',{attrs:{"c":"","options":_vm.$eval('this.'+element.chart)}})],1)],1)],1)})):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.calculate),callback:function ($$v) {_vm.calculate=$$v},expression:"calculate"}},[_c('p',[_vm._v(_vm._s(_vm.show_formula))]),_vm._v(" "),_c('b-row',[_c('b-table',{attrs:{"borderless":"","show-empty":"","empty-text":"No Variables added","fields":[{key: 'chk', label: 'Added'}, {key: 'variable_name', label: 'Variable'}, {key: 'variable_value', label: 'Value'}],"items":_vm.estimate_selling_price,"stacked":"sm","small":""},scopedSlots:_vm._u([{key:"chk",fn:function(row){return [_c('b-form-checkbox',{attrs:{"id":"checkbox","size":"sm"},on:{"change":function($event){_vm.checkedField(row.item.variable_name, row.index, row.item.chk)}},model:{value:(row.item.chk),callback:function ($$v) {_vm.$set(row.item, "chk", $$v)},expression:"row.item.chk"}})]}},{key:"variable_value",fn:function(row){return [(row.item.chk)?_c('b-form',[(row.item.variable_name=='BBL to m3:')?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"id_51","options":_vm.bbl_array},model:{value:(row.item.variable_value),callback:function ($$v) {_vm.$set(row.item, "variable_value", $$v)},expression:"row.item.variable_value"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select bbl --")])])],2):_c('b-form-input',{attrs:{"plaintext":"","id":"id_1","type":"text"},model:{value:(row.item.variable_value),callback:function ($$v) {_vm.$set(row.item, "variable_value", $$v)},expression:"row.item.variable_value"}})],1):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.calculate=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.save_formula()}}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12aeb92c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1043);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12aeb92c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"4"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Sign In to your account")]),_vm._v(" "),(_vm.dataRequired)?_c('p',{staticClass:"text-danger"},[_vm._v("Data required")]):_vm._e(),_vm._v(" "),(_vm.waiting)?_c('p',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.waitingMessage))]):_vm._e(),_vm._v(" "),(_vm.loginFailed)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.loginFailedMessage))]):_vm._e(),_vm._v(" "),(_vm.notResponse)?_c('p',{staticClass:"text-danger"},[_vm._v("Server not respond, please try later.")]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-user"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user),expression:"user"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Username or Email"},domProps:{"value":(_vm.user)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.loginUser($event)},"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value}}})]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-4"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-lock"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.loginUser($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('b-button',{staticClass:"px-4",attrs:{"variant":"primary"},on:{"click":_vm.loginUser}},[_vm._v("Login")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('b-button',{staticClass:"px-0",attrs:{"variant":"link"},on:{"click":function($event){_vm.$router.push('/forgot_password/')}}},[_vm._v("Forgot password?")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"ForgotPassword",attrs:{"title":"Forgot Password","ok-only":"","ok-title":"Close","ok-variant":"secundary"},on:{"hide":_vm.resetNewModal},model:{value:(_vm.ForgotPassword),callback:function ($$v) {_vm.ForgotPassword=$$v},expression:"ForgotPassword"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-at"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user),expression:"user"}],staticClass:"form-control",attrs:{"type":"email","required":"","placeholder":"Enter your Email"},domProps:{"value":(_vm.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value}}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.Cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.getUser}},[_vm._v("Reset Password")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c3b754_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__ = __webpack_require__(1047);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c3b754_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cb775ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__(1046);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cb775ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":_vm.caption}},[_c('b-table',{attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage},scopedSlots:_vm._u([{key:"status",fn:function(data){return [_c('b-badge',{attrs:{"variant":_vm.getBadge(data.item.status)}},[_vm._v(_vm._s(data.item.status))])]}}])}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.items),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('c-table',{attrs:{"caption":"<i class='fa fa-align-justify'></i> Simple Table"}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('c-table',{attrs:{"striped":"","caption":"<i class='fa fa-align-justify'></i> Striped Table"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('c-table',{attrs:{"small":"","caption":"<i class='fa fa-align-justify'></i> Condensed Table"}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('c-table',{attrs:{"fixed":"","bordered":"","caption":"<i class='fa fa-align-justify'></i> Bordered Table"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('c-table',{attrs:{"hover":"","striped":"","bordered":"","small":"","fixed":"","caption":"<i class='fa fa-align-justify'></i> Combined All Table"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_energy_companies_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29c3e98e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_energy_companies_vue__ = __webpack_require__(1049);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_energy_companies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29c3e98e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_energy_companies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Energy Companies")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Energy Companies - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","energycompamies":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashEC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashEC()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newECModal}},[_vm._v("Add Energy Company")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Energy Company","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Energy Company Name","label-for":"EnergyCompanyName","horizontal":""}},[_c('b-form-input',{attrs:{"id":"EnergyCompanyName","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"CNR","label-for":"ULID0","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"id":"checkbox","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.model.cnr_inputs),callback:function ($$v) {_vm.$set(_vm.model, "cnr_inputs", $$v)},expression:"model.cnr_inputs"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Isolera","label-for":"isolera","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"name":"Checkboxes2","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.model.isolera),callback:function ($$v) {_vm.$set(_vm.model, "isolera", $$v)},expression:"model.isolera"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Address","label-for":"address","horizontal":""}},[_c('b-form-textarea',{attrs:{"id":"address","type":"text","rows":"3","max-rows":"8","autocomplete":"off"},model:{value:(_vm.model.address),callback:function ($$v) {_vm.$set(_vm.model, "address", $$v)},expression:"model.address"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"24 Phone Number","label-for":"phone_number_24","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number_24","placeholder":"##########","type":"tel","autocomplete":"off"},model:{value:(_vm.model.phone_number_24),callback:function ($$v) {_vm.$set(_vm.model, "phone_number_24", $$v)},expression:"model.phone_number_24"}})],1),_vm._v(" "),(_vm.truckingcompaniesselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Trucking Companies","label-for":"truckingCompaniesID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.truckingcompaniesselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.TCChange},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateTC,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.TCToggleAll},model:{value:(_vm.tcAllSelected),callback:function ($$v) {_vm.tcAllSelected=$$v},expression:"tcAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.tcAllSelected ? 'Un-select All' : 'Select All')+"\n              ")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newEC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveEC}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucking_companies_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3e2746e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucking_companies_vue__ = __webpack_require__(1075);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucking_companies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3e2746e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucking_companies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Trucking Companies")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Trucking Companies - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),(_vm.role==='super_admin')?_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTC()}}},[_vm._v("Trash")])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newTCModal}},[_vm._v("Add Trucking Company")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fieldsTh,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Trucking Company","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newTC),callback:function ($$v) {_vm.newTC=$$v},expression:"newTC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Company Name","label-for":"CompanyNameID","horizontal":""}},[_c('b-form-input',{attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.model.trucking_company_name),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_name", $$v)},expression:"model.trucking_company_name"}})],1),_vm._v(" "),(_vm.role === 'super_admin' && _vm.energycompaniesselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Energy Companies","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"company_name","options":_vm.energycompaniesselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.ECChange},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateEC,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ECToggleAll},model:{value:(_vm.ecAllSelected),callback:function ($$v) {_vm.ecAllSelected=$$v},expression:"ecAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.ecAllSelected ? 'Un-select All' : 'Select All')+"\n              ")])],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Truck Printing","label-for":"ULID0","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox"},model:{value:(_vm.model.in_truck_printing),callback:function ($$v) {_vm.$set(_vm.model, "in_truck_printing", $$v)},expression:"model.in_truck_printing"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Multi Loads","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox"},model:{value:(_vm.model.multiloads),callback:function ($$v) {_vm.$set(_vm.model, "multiloads", $$v)},expression:"model.multiloads"}})],1),_vm._v(" "),(_vm.operatingareasselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Operating Areas","label-for":"OaID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.operatingareasselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.OAChange},model:{value:(_vm.model.operating_areas_id),callback:function ($$v) {_vm.$set(_vm.model, "operating_areas_id", $$v)},expression:"model.operating_areas_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.OAToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.loadlocationsselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Load Locations","label-for":"LoadLocationID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationsselect,"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}})],1):_vm._e(),_vm._v(" "),(_vm.unloadlocationsselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Unload Locations","label-for":"UnLoadLocationID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.unloadlocationsselect,"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.model.unload_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "unload_locations_id", $$v)},expression:"model.unload_locations_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Address","label-for":"address","horizontal":""}},[_c('b-form-textarea',{attrs:{"id":"address","type":"text","rows":"3","max-rows":"8"},model:{value:(_vm.model.address),callback:function ($$v) {_vm.$set(_vm.model, "address", $$v)},expression:"model.address"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","label":"Dispatch Title","label-for":"dispatch_title","horizontal":""}},[_c('b-form-input',{attrs:{"id":"dispatch_title","type":"text"},model:{value:(_vm.model.dispatch_title),callback:function ($$v) {_vm.$set(_vm.model, "dispatch_title", $$v)},expression:"model.dispatch_title"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"Phone Number #1","label-for":"phone_number1","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number1","placeholder":"##########","type":"tel","autocomplete":"off"},model:{value:(_vm.model.phone_number1),callback:function ($$v) {_vm.$set(_vm.model, "phone_number1", $$v)},expression:"model.phone_number1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Phone Number #2","label-for":"phone_number2","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number2","placeholder":"##########","type":"tel","autocomplete":"off"},model:{value:(_vm.model.phone_number2),callback:function ($$v) {_vm.$set(_vm.model, "phone_number2", $$v)},expression:"model.phone_number2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L16","label":"Alternate Name","label-for":"alternate_name","horizontal":""}},[_c('b-form-input',{attrs:{"id":"alternate_name","type":"text"},model:{value:(_vm.model.alternate_name),callback:function ($$v) {_vm.$set(_vm.model, "alternate_name", $$v)},expression:"model.alternate_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":3,"id":"L15","label":"Company Logo","label-for":"file01","horizontal":""}},[_c('input',{ref:"file",attrs:{"type":"file","id":"files","accept":"image/*"},on:{"change":function($event){_vm.handleFileUpload()}}})])],1)],1),_vm._v(" "),(_vm.progress)?_c('b-row',[(_vm.load_logo==='Saving Logo file.....')?_c('b-col',{attrs:{"md":"10"}},[_c('h5',{staticClass:"mt-3"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_vm._v(" "+_vm._s(_vm.load_logo))]),_vm._v(" "),_c('b-progress',{staticClass:"mb-3",attrs:{"value":_vm.uploadPercentage,"max":100,"show-progress":"","animated":""}})],1):_c('b-col',{attrs:{"md":"10"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.load_logo))]),_vm._v(" "),_c('b-progress',{staticClass:"mb-3",attrs:{"value":_vm.uploadPercentage,"max":100,"show-progress":"","animated":""}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.url!='')?_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","allowfullscreen":"","frameborder":"0","src":_vm.url}}):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Hazards:","label-for":"hzID","horizontal":""}},[(_vm.hazards.length>0)?_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.hazards,"name":"Checkboxes2","plain":""},on:{"input":_vm.HZChange},model:{value:(_vm.model.hazard_id),callback:function ($$v) {_vm.$set(_vm.model, "hazard_id", $$v)},expression:"model.hazard_id"}}):_c('p',[_vm._v("No Hazards have been added")]),_vm._v(" "),(_vm.hazards.length>0)?_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateHZ,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.HZToggleAll},model:{value:(_vm.hzAllSelected),callback:function ($$v) {_vm.hzAllSelected=$$v},expression:"hzAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.hzAllSelected ? 'Un-select All' : 'Select All')+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Controls:","label-for":"ctlID","horizontal":""}},[(_vm.controls.length>0)?_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.controls,"name":"Checkboxes2","plain":""},on:{"input":_vm.CTLChange},model:{value:(_vm.model.control_id),callback:function ($$v) {_vm.$set(_vm.model, "control_id", $$v)},expression:"model.control_id"}}):_c('p',[_vm._v("No controls have been added")]),_vm._v(" "),(_vm.controls.length>0)?_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateCTL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.CTLToggleAll},model:{value:(_vm.ctlAllSelected),callback:function ($$v) {_vm.ctlAllSelected=$$v},expression:"ctlAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.ctlAllSelected ? 'Un-select All' : 'Select All')+"\n              ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveTC}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Config Table","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"value":"id","disabled":true},on:{"change":function($event){_vm.actionField('id')}}},[_vm._v("Company ID")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"name","disabled":true},on:{"change":function($event){_vm.actionField('name')}}},[_vm._v("Company Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"drivers"},on:{"change":function($event){_vm.actionField('drivers')}}},[_vm._v("Drivers")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"trucks"},on:{"change":function($event){_vm.actionField('trucks')}}},[_vm._v("Trucks")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"operating_areas"},on:{"change":function($event){_vm.actionField('operating_areas')}}},[_vm._v("Assign. Operating Areas")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucking_company_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbd09ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucking_company_vue__ = __webpack_require__(1080);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucking_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbd09ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucking_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Trucking Company - "+_vm._s(this.subTitle))])]),_vm._v(" "),(_vm.role==='super_admin' || _vm.role==='operations_manager')?_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTC}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTC}},[_vm._v("Delete")])],2)],1):_vm._e()],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Company Name","label-for":"CompanyNameID","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"CompanyNameID","type":"text"},model:{value:(_vm.model.trucking_company_name),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_name", $$v)},expression:"model.trucking_company_name"}}):_vm._e(),_vm._v(" "),(_vm.edit && _vm.role==='super_admin')?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.model.trucking_company_name),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_name", $$v)},expression:"model.trucking_company_name"}}):_vm._e(),_vm._v(" "),(_vm.edit && _vm.role==='operations_manager')?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"CompanyNameID","type":"text"},model:{value:(_vm.model.trucking_company_name),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_name", $$v)},expression:"model.trucking_company_name"}}):_vm._e()],1),_vm._v(" "),(_vm.role==='super_admin' && _vm.model.energy_companies.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Energy Companies","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"company_name","options":_vm.model.energy_companies,"name":"Checkboxes2","checked":true,"plain":"","disabled":""}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L177","label":"Truck Printing","label-for":"ULID0","horizontal":""}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"id":"checkbox","plain":"","disabled":""},model:{value:(_vm.model.in_truck_printing),callback:function ($$v) {_vm.$set(_vm.model, "in_truck_printing", $$v)},expression:"model.in_truck_printing"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox"},model:{value:(_vm.model.in_truck_printing),callback:function ($$v) {_vm.$set(_vm.model, "in_truck_printing", $$v)},expression:"model.in_truck_printing"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Multi Loads","label-for":"ULID","horizontal":""}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"id":"checkbox","plain":"","disabled":""},model:{value:(_vm.model.multiloads),callback:function ($$v) {_vm.$set(_vm.model, "multiloads", $$v)},expression:"model.multiloads"}}):_vm._e(),_vm._v(" "),(_vm.edit && _vm.role==='super_admin')?_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox"},model:{value:(_vm.model.multiloads),callback:function ($$v) {_vm.$set(_vm.model, "multiloads", $$v)},expression:"model.multiloads"}}):_vm._e(),_vm._v(" "),(_vm.edit && _vm.role==='operations_manager')?_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"id":"checkbox","plain":"","disabled":""},model:{value:(_vm.model.multiloads),callback:function ($$v) {_vm.$set(_vm.model, "multiloads", $$v)},expression:"model.multiloads"}}):_vm._e()],1),_vm._v(" "),(_vm.model.operating_areas.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Operating Areas","label-for":"OaID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.operating_areas,"name":"Checkboxes2","checked":true,"plain":"","disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.model.load_locations.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Load Locations","label-for":"LLID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.model.load_locations,"name":"Checkboxes2","checked":true,"plain":"","disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.model.unload_locations.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Unload Locations","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.model.unload_locations,"name":"Checkboxes2","checked":true,"plain":"","disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.role==='super_admin' && _vm.energycompaniesselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Energy Company","label-for":"energyID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"company_name","options":_vm.energycompaniesselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.ECChange},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateEC,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ECToggleAll},model:{value:(_vm.ecAllSelected),callback:function ($$v) {_vm.ecAllSelected=$$v},expression:"ecAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ecAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.operatingareasselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Operating Areas","label-for":"Oa1ID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.operatingareasselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.OAChange},model:{value:(_vm.model.operating_areas_id),callback:function ($$v) {_vm.$set(_vm.model, "operating_areas_id", $$v)},expression:"model.operating_areas_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.OAToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.loadlocationsselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"Load Locations","label-for":"LL1ID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationsselect,"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}})],1):_vm._e(),_vm._v(" "),(_vm.unloadlocationsselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Unload Locations","label-for":"LL1ID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationsselect,"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.model.unload_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "unload_locations_id", $$v)},expression:"model.unload_locations_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Address","label-for":"address","horizontal":""}},[(!_vm.edit)?_c('b-form-textarea',{staticClass:"plaintext-input",attrs:{"id":"address","plaintext":"","type":"text","rows":"3","max-rows":"8"},model:{value:(_vm.model.address),callback:function ($$v) {_vm.$set(_vm.model, "address", $$v)},expression:"model.address"}}):_c('b-form-input',{attrs:{"id":"address","type":"text"},model:{value:(_vm.model.address),callback:function ($$v) {_vm.$set(_vm.model, "address", $$v)},expression:"model.address"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","label":"Dispatch Title","label-for":"dispatch_title","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"dispatch_title","plaintext":"","type":"text"},model:{value:(_vm.model.dispatch_title),callback:function ($$v) {_vm.$set(_vm.model, "dispatch_title", $$v)},expression:"model.dispatch_title"}}):_c('b-form-input',{attrs:{"id":"dispatch_title","type":"text"},model:{value:(_vm.model.dispatch_title),callback:function ($$v) {_vm.$set(_vm.model, "dispatch_title", $$v)},expression:"model.dispatch_title"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"Phone Number #1","label-for":"phone_number1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"phone_number1","plaintext":"","type":"tel"},model:{value:(_vm.model.phone_number1),callback:function ($$v) {_vm.$set(_vm.model, "phone_number1", $$v)},expression:"model.phone_number1"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number1","type":"tel","placeholder":"##########"},model:{value:(_vm.model.phone_number1),callback:function ($$v) {_vm.$set(_vm.model, "phone_number1", $$v)},expression:"model.phone_number1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Phone Number #2","label-for":"phone_number2","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"phone_number2","plaintext":"","type":"tel"},model:{value:(_vm.model.phone_number2),callback:function ($$v) {_vm.$set(_vm.model, "phone_number2", $$v)},expression:"model.phone_number2"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number2","type":"tel","placeholder":"##########"},model:{value:(_vm.model.phone_number2),callback:function ($$v) {_vm.$set(_vm.model, "phone_number2", $$v)},expression:"model.phone_number2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L16","label":"Alternate Name","label-for":"alternate_name","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"alternate_name","plaintext":"","type":"text"},model:{value:(_vm.model.alternate_name),callback:function ($$v) {_vm.$set(_vm.model, "alternate_name", $$v)},expression:"model.alternate_name"}}):_c('b-form-input',{attrs:{"id":"alternate_name","type":"text"},model:{value:(_vm.model.alternate_name),callback:function ($$v) {_vm.$set(_vm.model, "alternate_name", $$v)},expression:"model.alternate_name"}})],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Company Logo","label-for":"company_logo","horizontal":""}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"company_logo","plaintext":"","type":"text"},model:{value:(_vm.model.company_logo),callback:function ($$v) {_vm.$set(_vm.model, "company_logo", $$v)},expression:"model.company_logo"}})],1):_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Company Logo","label-for":"company_logo","horizontal":""}},[(_vm.model.company_logo!='')?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"company_logo","plaintext":"","type":"text"},model:{value:(_vm.model.company_logo),callback:function ($$v) {_vm.$set(_vm.model, "company_logo", $$v)},expression:"model.company_logo"}}):_vm._e(),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","id":"files","accept":"image/*"},on:{"change":function($event){_vm.handleFileUpload()}}})],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Hazards:","label-for":"hzID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"hazard_name","options":_vm.model.hazard,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Hazards:","label-for":"hzID","horizontal":""}},[(_vm.hazards.length > 0)?_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.hazards,"name":"Checkboxes2","plain":""},on:{"input":_vm.HZChange},model:{value:(_vm.model.hazard_id),callback:function ($$v) {_vm.$set(_vm.model, "hazard_id", $$v)},expression:"model.hazard_id"}}):_c('p',[_vm._v("No Hazards have been added")]),_vm._v(" "),(_vm.hazards.length > 0)?_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateHZ,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.HZToggleAll},model:{value:(_vm.hzAllSelected),callback:function ($$v) {_vm.hzAllSelected=$$v},expression:"hzAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.hzAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")]):_vm._e()],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Controls:","label-for":"ctlID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"control_name","options":_vm.model.control,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Controls:","label-for":"ctlID","horizontal":""}},[(_vm.controls.length > 0)?_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.controls,"name":"Checkboxes2","plain":""},on:{"input":_vm.CTLChange},model:{value:(_vm.model.control_id),callback:function ($$v) {_vm.$set(_vm.model, "control_id", $$v)},expression:"model.control_id"}}):_c('p',[_vm._v("No Controls have been added")]),_vm._v(" "),(_vm.controls.length > 0)?_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateCTL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.CTLToggleAll},model:{value:(_vm.ctlAllSelected),callback:function ($$v) {_vm.ctlAllSelected=$$v},expression:"ctlAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ctlAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTC}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTC}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c215368e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__ = __webpack_require__(1085);
function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c215368e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll(filter_by) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_report/', filter_by, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveSelectedColumns: function saveSelectedColumns(selectColumns) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_report/select_columns/', selectColumns, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	saveFilters: function saveFilters(filters) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_report/filters_reports/', filters, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getFilters: function getFilters() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/haul_report/reports_start/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.filters_start];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 395,
	"./af.js": 395,
	"./ar": 396,
	"./ar-dz": 397,
	"./ar-dz.js": 397,
	"./ar-kw": 398,
	"./ar-kw.js": 398,
	"./ar-ly": 399,
	"./ar-ly.js": 399,
	"./ar-ma": 400,
	"./ar-ma.js": 400,
	"./ar-sa": 401,
	"./ar-sa.js": 401,
	"./ar-tn": 402,
	"./ar-tn.js": 402,
	"./ar.js": 396,
	"./az": 403,
	"./az.js": 403,
	"./be": 404,
	"./be.js": 404,
	"./bg": 405,
	"./bg.js": 405,
	"./bm": 406,
	"./bm.js": 406,
	"./bn": 407,
	"./bn.js": 407,
	"./bo": 408,
	"./bo.js": 408,
	"./br": 409,
	"./br.js": 409,
	"./bs": 410,
	"./bs.js": 410,
	"./ca": 411,
	"./ca.js": 411,
	"./cs": 412,
	"./cs.js": 412,
	"./cv": 413,
	"./cv.js": 413,
	"./cy": 414,
	"./cy.js": 414,
	"./da": 415,
	"./da.js": 415,
	"./de": 416,
	"./de-at": 417,
	"./de-at.js": 417,
	"./de-ch": 418,
	"./de-ch.js": 418,
	"./de.js": 416,
	"./dv": 419,
	"./dv.js": 419,
	"./el": 420,
	"./el.js": 420,
	"./en-au": 421,
	"./en-au.js": 421,
	"./en-ca": 422,
	"./en-ca.js": 422,
	"./en-gb": 423,
	"./en-gb.js": 423,
	"./en-ie": 424,
	"./en-ie.js": 424,
	"./en-il": 425,
	"./en-il.js": 425,
	"./en-nz": 426,
	"./en-nz.js": 426,
	"./eo": 427,
	"./eo.js": 427,
	"./es": 428,
	"./es-do": 429,
	"./es-do.js": 429,
	"./es-us": 430,
	"./es-us.js": 430,
	"./es.js": 428,
	"./et": 431,
	"./et.js": 431,
	"./eu": 432,
	"./eu.js": 432,
	"./fa": 433,
	"./fa.js": 433,
	"./fi": 434,
	"./fi.js": 434,
	"./fo": 435,
	"./fo.js": 435,
	"./fr": 436,
	"./fr-ca": 437,
	"./fr-ca.js": 437,
	"./fr-ch": 438,
	"./fr-ch.js": 438,
	"./fr.js": 436,
	"./fy": 439,
	"./fy.js": 439,
	"./gd": 440,
	"./gd.js": 440,
	"./gl": 441,
	"./gl.js": 441,
	"./gom-latn": 442,
	"./gom-latn.js": 442,
	"./gu": 443,
	"./gu.js": 443,
	"./he": 444,
	"./he.js": 444,
	"./hi": 445,
	"./hi.js": 445,
	"./hr": 446,
	"./hr.js": 446,
	"./hu": 447,
	"./hu.js": 447,
	"./hy-am": 448,
	"./hy-am.js": 448,
	"./id": 449,
	"./id.js": 449,
	"./is": 450,
	"./is.js": 450,
	"./it": 451,
	"./it.js": 451,
	"./ja": 452,
	"./ja.js": 452,
	"./jv": 453,
	"./jv.js": 453,
	"./ka": 454,
	"./ka.js": 454,
	"./kk": 455,
	"./kk.js": 455,
	"./km": 456,
	"./km.js": 456,
	"./kn": 457,
	"./kn.js": 457,
	"./ko": 458,
	"./ko.js": 458,
	"./ky": 459,
	"./ky.js": 459,
	"./lb": 460,
	"./lb.js": 460,
	"./lo": 461,
	"./lo.js": 461,
	"./lt": 462,
	"./lt.js": 462,
	"./lv": 463,
	"./lv.js": 463,
	"./me": 464,
	"./me.js": 464,
	"./mi": 465,
	"./mi.js": 465,
	"./mk": 466,
	"./mk.js": 466,
	"./ml": 467,
	"./ml.js": 467,
	"./mn": 468,
	"./mn.js": 468,
	"./mr": 469,
	"./mr.js": 469,
	"./ms": 470,
	"./ms-my": 471,
	"./ms-my.js": 471,
	"./ms.js": 470,
	"./mt": 472,
	"./mt.js": 472,
	"./my": 473,
	"./my.js": 473,
	"./nb": 474,
	"./nb.js": 474,
	"./ne": 475,
	"./ne.js": 475,
	"./nl": 476,
	"./nl-be": 477,
	"./nl-be.js": 477,
	"./nl.js": 476,
	"./nn": 478,
	"./nn.js": 478,
	"./pa-in": 479,
	"./pa-in.js": 479,
	"./pl": 480,
	"./pl.js": 480,
	"./pt": 481,
	"./pt-br": 482,
	"./pt-br.js": 482,
	"./pt.js": 481,
	"./ro": 483,
	"./ro.js": 483,
	"./ru": 484,
	"./ru.js": 484,
	"./sd": 485,
	"./sd.js": 485,
	"./se": 486,
	"./se.js": 486,
	"./si": 487,
	"./si.js": 487,
	"./sk": 488,
	"./sk.js": 488,
	"./sl": 489,
	"./sl.js": 489,
	"./sq": 490,
	"./sq.js": 490,
	"./sr": 491,
	"./sr-cyrl": 492,
	"./sr-cyrl.js": 492,
	"./sr.js": 491,
	"./ss": 493,
	"./ss.js": 493,
	"./sv": 494,
	"./sv.js": 494,
	"./sw": 495,
	"./sw.js": 495,
	"./ta": 496,
	"./ta.js": 496,
	"./te": 497,
	"./te.js": 497,
	"./tet": 498,
	"./tet.js": 498,
	"./tg": 499,
	"./tg.js": 499,
	"./th": 500,
	"./th.js": 500,
	"./tl-ph": 501,
	"./tl-ph.js": 501,
	"./tlh": 502,
	"./tlh.js": 502,
	"./tr": 503,
	"./tr.js": 503,
	"./tzl": 504,
	"./tzl.js": 504,
	"./tzm": 505,
	"./tzm-latn": 506,
	"./tzm-latn.js": 506,
	"./tzm.js": 505,
	"./ug-cn": 507,
	"./ug-cn.js": 507,
	"./uk": 508,
	"./uk.js": 508,
	"./ur": 509,
	"./ur.js": 509,
	"./uz": 510,
	"./uz-latn": 511,
	"./uz-latn.js": 511,
	"./uz.js": 510,
	"./vi": 512,
	"./vi.js": 512,
	"./x-pseudo": 513,
	"./x-pseudo.js": 513,
	"./yo": 514,
	"./yo.js": 514,
	"./zh-cn": 515,
	"./zh-cn.js": 515,
	"./zh-hk": 516,
	"./zh-hk.js": 516,
	"./zh-tw": 517,
	"./zh-tw.js": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1084;

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Reports")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-btn',{staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openSelectColumns()}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-btn',{staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),_c('download-excel',{attrs:{"data":_vm.items,"fields":_vm.json_fields,"type":"csv","name":_vm.filename}},[_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"}},[_c('i',{staticClass:"fa fa-file-excel-o"})])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.rol==='super_admin'),expression:"rol==='super_admin'"}],staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.ec_filter},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"title":"Trucking Companies","sm":"6","md":"3"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.tc_filter},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_vm._v("All Trucking Companies")]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"title":"Trucks","sm":"6","md":"3"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.t_filter},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tFilter('All Trucks', 0)}}},[_vm._v("All Trucks")]),_vm._v(" "),_vm._l((_vm.trucks_filter),function(truck_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tFilter(truck_filter.truck_name, truck_filter.id)}}},[_vm._v(_vm._s(truck_filter.truck_name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"title":"Truck Type","sm":"6","md":"3"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.tt_filter},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ttFilter('All Truck Types', 0)}}},[_vm._v("All Truck Types")]),_vm._v(" "),_vm._l((_vm.truck_types_filter),function(truck_type_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ttFilter(truck_type_filter.name, truck_type_filter.id)}}},[_vm._v(_vm._s(truck_type_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"6","md":"3"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.u_filter,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"6","md":"3","lg":"4","title":"Initial date"}},[_c('b-form-input',{attrs:{"id":"haul_initial_datetime","type":"date"},on:{"input":function($event){_vm.iFilter()}},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"sm":"6","md":"3","title":"End date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"input":function($event){_vm.eFilter()}},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mb-4",staticStyle:{"max-width":"90px","padding-top":"3px","padding-bottom":"3px"},attrs:{"md":"1","lg":"1"}},[_c('b-button',{staticStyle:{"height":"100%"},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.v_filter == 'All' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('two_ways_est_hrs'),"value":"two_ways_est_hrs"},on:{"change":function($event){_vm.actionField('two_ways_est_hrs', 'Est Two Way(hrs)', 0)}}},[_vm._v("Est Two Way(hrs)")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_load_size'),"value":"avg_load_size"},on:{"change":function($event){_vm.actionField('avg_load_size', 'Avg Load Size', 0)}}},[_vm._v("Avg Load Size")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_m3_day'),"value":"avg_m3_day"},on:{"change":function($event){_vm.actionField('avg_m3_day', 'Avg Day', 1)}}},[_vm._v("Avg Day")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('charge_type'),"value":"charge_type"},on:{"change":function($event){_vm.actionField('charge_type', 'Charge Type', 2)}}},[_vm._v("Charge Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('company_name'),"value":"company_name"},on:{"change":function($event){_vm.actionField('company_name','Company Name',3)}}},[_vm._v("Company Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_type'),"value":"cost_type"},on:{"change":function($event){_vm.actionField('cost_type', 'Cost Type',4)}}},[_vm._v("Cost Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_hauled_km'),"value":"fluid_hauled_km"},on:{"change":function($event){_vm.actionField('fluid_hauled_km','Fluid Hauled(km)',6)}}},[_vm._v("Fluid Hauled(km)")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('loads'),"value":"loads"},on:{"change":function($event){_vm.actionField('loads', 'Loads',7)}}},[_vm._v("Loads")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('rate'),"value":"rate"},on:{"change":function($event){_vm.actionField('rate', 'Rate', 8)}}},[_vm._v("Rate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('short_long_target'),"value":"short_long_target"},on:{"change":function($event){_vm.actionField('short_long_target', 'Short Long Target', 9)}}},[_vm._v("Short Long Target")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('target_end_date'),"value":"target_end_date"},on:{"change":function($event){_vm.actionField('target_end_date', 'Target End Date',9)}}},[_vm._v("Target End Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('target_start_date'),"value":"target_start_date"},on:{"change":function($event){_vm.actionField('target_start_date','Target Start Date', 10)}}},[_vm._v("Target Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck_type'),"value":"truck_type"},on:{"change":function($event){_vm.actionField('truck_type', 'Truck Type', 9)}}},[_vm._v("Truck Type")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('speed'),"value":"speed"},on:{"change":function($event){_vm.actionField('speed', 'Speed', 10)}}},[_vm._v("Speed")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('target_volume'),"value":"target_volume"},on:{"change":function($event){_vm.actionField('target_volume', 'Target Volume', 11)}}},[_vm._v("Target Volume")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('est_bbl_haul_cost'),"value":"est_bbl_haul_cost"},on:{"change":function($event){_vm.actionField('est_bbl_haul_cost', 'Est Haul Cost', 10)}}},[_vm._v("Est Haul Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('term_fee_m'),"value":"term_fee_m"},on:{"change":function($event){_vm.actionField('term_fee_m','Term Fee', 12)}}},[_vm._v("Term Fee")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_cost'),"value":"total_cost"},on:{"change":function($event){_vm.actionField('total_cost','Total Cost',13)}}},[_vm._v("Total Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_regular'),"value":"total_regular"},on:{"change":function($event){_vm.actionField('total_regular','Total Regular', 14)}}},[_vm._v("Total Regular")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_stb'),"value":"total_stb"},on:{"change":function($event){_vm.actionField('total_stb','Total STB', 16)}}},[_vm._v("Total STB")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_longitude'),"value":"unload_longitude"},on:{"change":function($event){_vm.actionField('unload_longitude','Unload Longitude', 14)}}},[_vm._v("Unload Longitude")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_actual'),"value":"volume_actual"},on:{"change":function($event){_vm.actionField('volume_actual','Volume Actual', 16)}}},[_vm._v("Volume Actual")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_latitude'),"value":"unload_latitude"},on:{"change":function($event){_vm.actionField('unload_latitude', 'Unload Latitude', 9)}}},[_vm._v("Unload Latitude")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_locations'),"value":"unload_locations"},on:{"change":function($event){_vm.actionField('unload_locations', 'Unload Locations', 9)}}},[_vm._v("Unload Locations")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_locations'),"value":"total_stb_time"},on:{"change":function($event){_vm.actionField('total_stb_time', 'Total STB Time', 9)}}},[_vm._v("Total STB Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_driving_time'),"value":"total_driving_time"},on:{"change":function($event){_vm.actionField('total_driving_time', 'Total Driving Time', 9)}}},[_vm._v("Total Driving Time")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n        Save\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hauls_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c0ba51c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hauls_vue__ = __webpack_require__(1089);
function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c0ba51c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hauls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c0ba51c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hauls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"ml-4 pt-2"},[_vm._v("Multi Load Haul")]),_vm._v(" "),_vm._l((_vm.loads),function(load,index){return _c('div',{key:index,staticClass:"details-container ml-4 pl-4"},[_c('div',{staticClass:"item location py-2"},[_c('h6',[_vm._v("Load Location")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(load.load_location))])]),_vm._v(" "),_c('div',{staticClass:"item ticket py-2"},[_c('h6',[_vm._v("Truck Ticket")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(load.truck_ticket))])]),_vm._v(" "),_c('div',{staticClass:"item date py-2"},[_c('h6',[_vm._v("Start Date/Time")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(load.load_start_datetime))])]),_vm._v(" "),_c('div',{staticClass:"item volume py-2"},[_c('h6',[_vm._v("Est. Vol")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(load.volume_estimate))])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("All Hauls")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("All Hauls - Trash")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Select Datapoints'),expression:"'Select Datapoints'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openSelectColumns()}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activated),expression:"activated"},{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Export to csv'),expression:"'Export to csv'",modifiers:{"hover":true,"top":true}}],ref:"e_csv",staticClass:"pull-right ml5",attrs:{"id":"e_csv","disabled":_vm.iscsv,"variant":"info"},on:{"click":function($event){_vm.csv_export()}}},[_c('i',{staticClass:"fa fa-file-excel-o"})]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Create Folder'),expression:"'Create Folder'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openCreateFolder()}}},[_c('i',{staticClass:"fa fa-folder"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[(_vm.progress)?_c('h5',{staticClass:"pull-right ml5"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_vm._v(" "+_vm._s(_vm.load_csv))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"order":"3","order-md":"2","sm":"6","md":"2","lg":"2","title":"Actived / Deleted"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"id":"ddown1","text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashHaul()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashHaul()}}},[_vm._v("Trash")])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"order":"5","order-md":"4","sm":"6","md":"2","lg":"2","title":"Folder"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"id":"ddown1","text":_vm.filters_save.folder}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.Folders('All Folders', 0)}}},[_vm._v("All Folders")]),_vm._v(" "),_vm._l((_vm.folders),function(folder){return _c('b-dropdown-item',{on:{"click":function($event){_vm.Folders(folder.name, folder.id)}}},[_vm._v(_vm._s(folder.name))])}),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.Folders('Unassigned Hauls', 0)}}},[_vm._v("Unassigned Hauls")])],2)],1),_vm._v(" "),_c('b-col',{staticClass:"ml-auto my-1",attrs:{"order":"2","order-md":"5","cols":"4","sm":"6","md":"2","lg":"2"}},[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.showNewHaulModal()}}},[_vm._v("Add Haul")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f2",attrs:{"title":"Drivers","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.driver_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.dFilter('All Drivers', 0)}}},[_vm._v("All Drivers")]),_vm._v(" "),_vm._l((_vm.drivers_filter),function(driver_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.dFilter(driver_filter.username, driver_filter.id)}}},[_vm._v(_vm._s(driver_filter.username))])})],2)],1),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='super_analyst' || _vm.role =='analyst' || this.role =='marketing_accountant' || _vm.role =='operations_manager')?_c('b-col',{staticClass:"my-1 f4",attrs:{"title":"Trucking Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f5",attrs:{"title":"Trucks","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.truck_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tFilter('All Trucks', 0)}}},[_vm._v("All Trucks")]),_vm._v(" "),_vm._l((_vm.trucks_filter),function(truck_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tFilter(truck_filter.truck_name, truck_filter.id)}}},[_vm._v(_vm._s(truck_filter.truck_name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f6",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.load_name,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Loads', 0)}}},[_vm._v("All Loads")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.unload_name,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='super_analyst' || _vm.role =='analyst' || this.role =='marketing_accountant' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Fluid Types","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.fluid_type_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ftFilter('All Fluid Types', 0)}}},[_vm._v("All Fluid Types")]),_vm._v(" "),_vm._l((_vm.fluid_types_filter),function(fluid_type_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ftFilter(fluid_type_filter.name, fluid_type_filter.id)}}},[_vm._v(_vm._s(fluid_type_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f8",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"right":"","text":_vm.filters_save.flag_name,"title":"Flag"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('All Flags',0)}}},[_vm._v("All Flags")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Volume > 60 m³',1)}}},[_vm._v("Volume > 60 m³")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('BS&W - 100%',2)}}},[_vm._v("BS&W - 100%")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('BS&W < 0.5%',3)}}},[_vm._v("BS&W < 0.5%")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('BS&W - Additional Fees Apply',4)}}},[_vm._v("BS&W - Additional Fees Apply")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Haul without Nom',5)}}},[_vm._v("Haul without Nom")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Haul from mobil',17)}}},[_vm._v("Haul from mobil")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('With Contracts',6)}}},[_vm._v("With Contracts")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Without Contracts',7)}}},[_vm._v("Without Contracts")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Rerouted: Yes',8)}}},[_vm._v("Rerouted: Yes")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Rerouted: No',9)}}},[_vm._v("Rerouted: No")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Haul Duplicated',10)}}},[_vm._v("Haul Duplicated")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Drive Time:Neg',12)}}},[_vm._v("Drive Time:Neg")]),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Unknow Load Location',0)}}},[_vm._v("Unknow Load Location")]):_vm._e(),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Price Anomaly',14)}}},[_vm._v("Price Anomaly")]):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Duplicated Hauls',15)}}},[_vm._v("Duplicated Hauls")]),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-dropdown-item',{on:{"click":function($event){_vm.vFilter('Drive Time Anomaly',16)}}},[_vm._v("Drive Time Anomaly")]):_vm._e(),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-dropdown-item',{on:{"click":function($event){_vm.approvedFilter('Approved')}}},[_vm._v("Approved")]):_vm._e(),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-dropdown-item',{on:{"click":function($event){_vm.approvedFilter('Unapproved')}}},[_vm._v("Unapproved")]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ml-auto",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"2"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1),_vm._v(" "),_c('b-row',[(_vm.haul_ids.length > 0)?_c('b-col',{staticClass:"my-1"},[_c('div',{staticClass:"card bulk-action-controls m-0"},[_c('div',{staticClass:"card-body p-1 d-flex align-middle"},[_c('p',{staticClass:"col-sm-3 ml-2 px-0 my-auto align-middle"},[_vm._v(" "+_vm._s(_vm.haul_ids.length)+" haul(s) selected of "+_vm._s(_vm.totalRows))]),_vm._v(" "),(!_vm.allSelected)?_c('b-button',{staticClass:"col-sm-2 ml-0 btn-select",on:{"click":_vm.selectAllHauls}},[_vm._v(" Select All ")]):_vm._e(),_vm._v(" "),_c('b-dropdown',{staticClass:"mx-2 my-auto align-middle",attrs:{"id":"ddown1","text":"Bulk Actions","title":"Bulk Actions"}},[(!this.trash)?_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteHaul()}}},[_vm._v("Delete")]):_c('b-dropdown-item',{on:{"click":function($event){_vm.restoreHauls()}}},[_vm._v("Restore")]),_vm._v(" "),(_vm.filters_save.folder == 'All Folders' || _vm.filters_save.folder == 'Unassigned Hauls')?_c('b-dropdown-item',{on:{"click":function($event){_vm.openModal()}}},[_vm._v("Add to folder")]):_c('b-dropdown-item',{on:{"click":function($event){_vm.removeHaul()}}},[_vm._v("Remove from folder")]),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager' || _vm.role =='super_admin')?_c('b-dropdown-item',{on:{"click":function($event){_vm.h_approved_click()}}},[_vm._v("Approve Haul")]):_vm._e(),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager' || _vm.role =='super_admin')?_c('b-dropdown-item',{on:{"click":function($event){_vm.h_deapproved_click()}}},[_vm._v("Unapprove Haul")]):_vm._e(),_vm._v(" "),((_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager') && (_vm.filters_save.flag_name == 'Unknow Load Location' || _vm.filters_save.flag_name == 'Price Anomaly' || _vm.filters_save.flag_name == 'Duplicated Hauls' || _vm.filters_save.flag_name == 'Drive Time Anomaly'))?_c('b-dropdown-item',{on:{"click":function($event){_vm.ignore_click(_vm.filters_save.flag_name)}}},[_vm._v("Ignore")]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"align-middle ml-auto close-controls",on:{"click":_vm.unselectAllHauls}},[_vm._v(" × ")])],1)])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive p-0 m-0"},[(!_vm.loadingData && _vm.filters_save.flag_name == 'All Flags' && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked,"refreshed":_vm.haulUpdated},scopedSlots:_vm._u([{key:"HEAD_select_haul",fn:function(data){return [_c('b-form-checkbox',{attrs:{"id":"checkbox"},on:{"change":_vm.toggleAllSelected},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.allSelected),callback:function ($$v) {_vm.allSelected=$$v},expression:"allSelected"}})]}},{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+" \n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}]),model:{value:(_vm.tableValues),callback:function ($$v) {_vm.tableValues=$$v},expression:"tableValues"}}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'Volume > 60 m³' && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+" \n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'BS&W - 100%' && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'BS&W < 0.5%' && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'BS&W - Additional Fees Apply' && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && (_vm.filters_save.flag_name == 'Haul without Nom' || _vm.filters_save.flag_name == 'Haul from mobil') && _vm.FromDash!='Waittimes' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.FromDash=='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.v_items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'With Contracts' && _vm.FromDash!='Waittimes' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'Without Contracts' && _vm.FromDash!='Waittimes' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'Rerouted: Yes' && _vm.FromDash!='Waittimes' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'Rerouted: No' && _vm.FromDash!='Waittimes' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'Haul Duplicated' && _vm.FromDash!='Waittimes' )?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),(!_vm.loadingData && _vm.filters_save.flag_name == 'Drive Time:Neg' && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),((_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager') && !_vm.loadingData && (_vm.filters_save.flag_name == 'Unknow Load Location' || _vm.filters_save.flag_name =='Price Anomaly' || _vm.filters_save.flag_name == 'Duplicated Hauls' || _vm.filters_save.flag_name =='Drive Time Anomaly') && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),((_vm.role !=='trucking_company_admin' || _vm.role !=='trucking_operational_manager') && !_vm.loadingData && (_vm.filters_save.flag_name == 'Duplicated Hauls' || _vm.filters_save.flag_name =='Drive Time Anomaly') && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e(),_vm._v(" "),((_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager') && !_vm.loadingData && (_vm.filters_save.flag_name == 'Approved' || _vm.filters_save.flag_name =='Unapproved') && _vm.FromDash!='Waittimes')?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"refreshed":_vm.haulUpdated,"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"load_location",fn:function(row){return [(row.item.multiloads)?_c('span',{staticClass:"show-details-cell",on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_vm._v("\n                Multi-Loads\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(row.item.load_location)+"\n              ")])]}},{key:"row-details",fn:function(row){return [_c('row-details',{attrs:{"loads":row.item.loads}})]}}])}):_vm._e()],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modalInfo","title":_vm.modalInfo.title,"ok-only":""},on:{"hide":_vm.resetModal}},[_c('pre',[_vm._v(_vm._s(_vm.modalInfo.content))])]),_vm._v(" "),_c('b-modal',{ref:"mEdit",attrs:{"id":"modalEdit","title":_vm.modalEdit.title,"ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},on:{"hide":_vm.resetEditModal}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-fire"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.companyName),expression:"companyName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Company name"},domProps:{"value":(_vm.companyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.companyName=$event.target.value}}})])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-button',{staticClass:"px-4 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.updateEC}},[_vm._v("Update")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newHaulModal",staticClass:"newHaulModal",attrs:{"title":"New Haul","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin' || _vm.role ==='operations_manager' || _vm.role ==='super_analyst' || _vm.role ==='analyst' || this.role =='marketing_accountant')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Truking Company","label-for":"truck_company"}},[_c('b-form-select',{attrs:{"id":"truck_company_id","options":_vm.newHaul.truck_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.newHaul.truck_company_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_company_id", $$v)},expression:"newHaul.truck_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trailer","label-for":"truck"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.truck_select.length==0,"id":"truck_id","options":_vm.newHaul.truck_select},model:{value:(_vm.newHaul.truck_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_id", $$v)},expression:"newHaul.truck_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Truck Unit","label-for":"truck_unit"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.truck_unit_select.length==0,"id":"truck_unit","options":_vm.newHaul.truck_unit_select},model:{value:(_vm.newHaul.truck_unit_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_unit_id", $$v)},expression:"newHaul.truck_unit_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Driver","label-for":"full_name"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.driver_select.length==0,"id":"user_id","options":_vm.newHaul.driver_select},on:{"input":function($event){_vm.selects_driver()}},model:{value:(_vm.newHaul.user_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "user_id", $$v)},expression:"newHaul.user_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.energy_company_select.length==0,"id":"energy_companies_id","options":_vm.newHaul.energy_company_select},on:{"input":function($event){_vm.selects_energy_company()}},model:{value:(_vm.newHaul.energy_companies_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "energy_companies_id", $$v)},expression:"newHaul.energy_companies_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Load","label-for":"load_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.load_location_select.length==0,"id":"load_location_id","options":_vm.newHaul.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.newHaul.load_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "load_location_id", $$v)},expression:"newHaul.load_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Fluid","label-for":"fluid_type"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.fluid_type_select.length==0,"id":"fluid_type_id","options":_vm.newHaul.fluid_type_select},model:{value:(_vm.newHaul.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "fluid_type_id", $$v)},expression:"newHaul.fluid_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload","label-for":"unload_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.unload_location_select.length==0,"id":"unload_location_id","options":_vm.newHaul.unload_location_select},on:{"input":function($event){_vm.selects_unload_location()}},model:{value:(_vm.newHaul.unload_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "unload_location_id", $$v)},expression:"newHaul.unload_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Water Cut Actual %","label-for":"water_percentage_actual"}},[_c('b-form-input',{attrs:{"id":"water_percentage_actual","placeholder":"0.00","type":"text"},nativeOn:{"blur":function($event){_vm.inputBlur('water_percentage_actual')},"keydown":function($event){_vm.myOnlyNumber($event, 'water_percentage_actual')}},model:{value:(_vm.newHaul.water_percentage_actual),callback:function ($$v) {_vm.$set(_vm.newHaul, "water_percentage_actual", $$v)},expression:"newHaul.water_percentage_actual"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume Actual","label-for":"volume_actual"}},[_c('b-form-input',{attrs:{"id":"volume_actual","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume_actual')},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.newHaul.volume_actual),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume_actual", $$v)},expression:"newHaul.volume_actual"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume Estimate","label-for":"volume_estimate"}},[_c('b-form-input',{attrs:{"id":"volume_estimate","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume_estimate')},"blur":function($event){_vm.inputBlur('volume_estimate')}},model:{value:(_vm.newHaul.volume_estimate),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume_estimate", $$v)},expression:"newHaul.volume_estimate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"# Ticket","label-for":"ticket"}},[_c('b-form-input',{attrs:{"id":"ticket","type":"text","autocomplete":"off","placeholder":"max 10 characters"},nativeOn:{"keydown":function($event){_vm.keyMonitor($event)}},model:{value:(_vm.newHaul.ticket),callback:function ($$v) {_vm.$set(_vm.newHaul, "ticket", $$v)},expression:"newHaul.ticket"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Ticket","label-for":"t_ticket"}},[_c('b-form-input',{attrs:{"id":"t_ticket","type":"text","autocomplete":"off","placeholder":"max 10 characters"},nativeOn:{"keydown":function($event){_vm.keyMonitor1($event)}},model:{value:(_vm.newHaul.t_ticket),callback:function ($$v) {_vm.$set(_vm.newHaul, "t_ticket", $$v)},expression:"newHaul.t_ticket"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Boss Number","label-for":"t_boss"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"t_boss","type":"text","autocomplete":"off","placeholder":"max 10 digits"},model:{value:(_vm.newHaul.t_boss),callback:function ($$v) {_vm.$set(_vm.newHaul, "t_boss", $$v)},expression:"newHaul.t_boss"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Chain Up","label-for":"chain_up"}},[_c('b-form-select',{attrs:{"id":"chain_up"},model:{value:(_vm.newHaul.chain_up),callback:function ($$v) {_vm.$set(_vm.newHaul, "chain_up", $$v)},expression:"newHaul.chain_up"}},[_c('option',{domProps:{"value":false}},[_vm._v("NO")]),_c('option',{domProps:{"value":true}},[_vm._v("YES")])])],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Start Date","label-for":"haul_start_date"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},model:{value:(_vm.newHaul.haul_start_datetime),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_start_datetime", $$v)},expression:"newHaul.haul_start_datetime"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Start Time","label-for":"haul_start_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_start_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('haul_start_time')}},model:{value:(_vm.newHaul.haul_start_time),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_start_time", $$v)},expression:"newHaul.haul_start_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Date","label-for":"haul_start_date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},model:{value:(_vm.newHaul.haul_end_datetime),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_end_datetime", $$v)},expression:"newHaul.haul_end_datetime"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Time","label-for":"haul_end_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_end_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('haul_end_time')}},model:{value:(_vm.newHaul.haul_end_time),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_end_time", $$v)},expression:"newHaul.haul_end_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Comments Start","label-for":"comments_start"}},[_c('b-form-input',{attrs:{"id":"comments_start","type":"text"},model:{value:(_vm.newHaul.comments_start),callback:function ($$v) {_vm.$set(_vm.newHaul, "comments_start", $$v)},expression:"newHaul.comments_start"}})],1),_vm._v(" "),_vm._l((_vm.newHaul.wait_times),function(wait_time,index){return _c('b-form-group',{key:wait_time.type_id,attrs:{"label-cols":4,"horizontal":"","label":_vm.waitTimeLabel(wait_time),"label-for":_vm.waitTimeLabel(wait_time)}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"placeholder":"hh:mm","type":"text"},model:{value:(wait_time.time),callback:function ($$v) {_vm.$set(wait_time, "time", $$v)},expression:"wait_time.time"}}),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":"Comments","type":"text"},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}}),_vm._v(" "),(wait_time.type_id == 5)?_c('b-btn',{staticClass:"wait-time-remove-button",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.removeTimeBlur(index)}}},[_vm._v("X")]):_vm._e()],1)}),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.addWaitTime}},[_vm._v("Add another Wait Time")])],2)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Hazard Assessment","label-for":"hz"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"5px 0 0 5px"}},[_c('b-col',{attrs:{"cols":"12"}},[(_vm.newHaul.load_location_id!='')?_c('span',[_vm._v("Load Location: "+_vm._s(_vm.newHaul.load_location_name))]):_c('p',[_vm._v("No load location selected")])])],1),_vm._v(" "),(_vm.newHaul.load_location_id!='')?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hazards.length>0)?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Hazards:","label-for":"hzID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.hazards,"name":"Checkboxes2","plain":""},on:{"input":_vm.HZChange},model:{value:(_vm.hazard_id),callback:function ($$v) {_vm.hazard_id=$$v},expression:"hazard_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateHZ,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.HZToggleAll},model:{value:(_vm.hzAllSelected),callback:function ($$v) {_vm.hzAllSelected=$$v},expression:"hzAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.hzAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("No Hazards have been added")])])],1):_vm._e(),_vm._v(" "),(_vm.newHaul.load_location_id!='')?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.controls.length>0)?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Controls:","label-for":"ctlID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.controls,"name":"Checkboxes2","plain":""},on:{"input":_vm.CTLChange},model:{value:(_vm.control_id),callback:function ($$v) {_vm.control_id=$$v},expression:"control_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateCTL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.CTLToggleAll},model:{value:(_vm.ctlAllSelected),callback:function ($$v) {_vm.ctlAllSelected=$$v},expression:"ctlAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.ctlAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("No controls have been added")])])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"5px 0 0 5px"}},[_c('b-col',{attrs:{"cols":"12"}},[(_vm.newHaul.unload_location_id!='')?_c('span',[_vm._v("Unload Location: "+_vm._s(_vm.newHaul.unload_location_name))]):_c('p',[_vm._v("No unload location selected")])])],1),_vm._v(" "),(_vm.newHaul.unload_location_id!='')?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.hazards.length>0)?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Hazards:","label-for":"hzID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.hazards,"name":"Checkboxes2","plain":""},on:{"input":_vm.HZ1Change},model:{value:(_vm.hazard1_id),callback:function ($$v) {_vm.hazard1_id=$$v},expression:"hazard1_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateHZ1,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.HZ1ToggleAll},model:{value:(_vm.hz1AllSelected),callback:function ($$v) {_vm.hz1AllSelected=$$v},expression:"hz1AllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.hz1AllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("No Hazards have been added")])])],1):_vm._e(),_vm._v(" "),(_vm.newHaul.unload_location_id!='')?_c('b-row',{staticStyle:{"padding":"15px 0 0 15px"}},[(_vm.controls.length>0)?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"Controls:","label-for":"ctlID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.controls,"name":"Checkboxes2","plain":""},on:{"input":_vm.CTL1Change},model:{value:(_vm.control1_id),callback:function ($$v) {_vm.control1_id=$$v},expression:"control1_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateCTL1,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.CTL1ToggleAll},model:{value:(_vm.ctl1AllSelected),callback:function ($$v) {_vm.ctl1AllSelected=$$v},expression:"ctl1AllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.ctl1AllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1)],1):_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("No controls have been added")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewHaulModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveHaul}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('ticket'),"value":"ticket"},on:{"change":function($event){_vm.actionField('ticket', 'Ticket #',1)}}},[_vm._v("Ticket #")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_id'),"value":"haul_id"},on:{"change":function($event){_vm.actionField('haul_id', 'Haul ID', 2)}}},[_vm._v("Haul ID")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('full_name'),"value":"full_name"},on:{"change":function($event){_vm.actionField('full_name', 'Driver', 5)}}},[_vm._v("Driver")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='operations_manager' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('energy_company'),"value":"energy_company"},on:{"change":function($event){_vm.actionField('energy_company', 'Energy Company', 3)}}},[_vm._v("Energy Company")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('load_location'),"value":"load_location"},on:{"change":function($event){_vm.actionField('load_location', 'Load', 6)}}},[_vm._v("Load")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_location'),"value":"unload_location"},on:{"change":function($event){_vm.actionField('unload_location', 'Unload', 7)}}},[_vm._v("Unload")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trailer'),"value":"trailer"},on:{"change":function($event){_vm.actionField('trailer','Trailer',8)}}},[_vm._v("Trailer")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_actual'),"value":"volume_actual"},on:{"change":function($event){_vm.actionField('volume_actual','Deliveries',9)}}},[_vm._v("Deliveries")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('oil_actual'),"value":"oil_actual"},on:{"change":function($event){_vm.actionField('oil_actual','Oil',10)}}},[_vm._v("Oil")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_actual'),"value":"water_actual"},on:{"change":function($event){_vm.actionField('water_actual', 'Water',11)}}},[_vm._v("Water")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('bsw'),"value":"bsw"},on:{"change":function($event){_vm.actionField('bsw', 'BS&W', 12)}}},[_vm._v("BS&W")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_date'),"value":"haul_start_date"},on:{"change":function($event){_vm.actionField('haul_start_date', 'Start Date', 13)}}},[_vm._v("Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_date'),"value":"haul_end_date"},on:{"change":function($event){_vm.actionField('haul_end_date', 'End Date', 14)}}},[_vm._v("End Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_type'),"value":"fluid_type"},on:{"change":function($event){_vm.actionField('fluid_type','Fluid Type', 15)}}},[_vm._v("Fluid Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trucking_company'),"value":"trucking_company"},on:{"change":function($event){_vm.actionField('trucking_company','Trucking Company', 4)}}},[_vm._v("Trucking Company")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_percentage_actual'),"value":"water_percentage_actual"},on:{"change":function($event){_vm.actionField('water_percentage_actual','Water Cut Actual', 16)}}},[_vm._v("Water Cut Actual")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_time'),"value":"haul_start_time"},on:{"change":function($event){_vm.actionField('haul_start_time','Start Time', 17)}}},[_vm._v("Start Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_time'),"value":"haul_end_time"},on:{"change":function($event){_vm.actionField('haul_end_time','End Time', 18)}}},[_vm._v("End Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_speed'),"value":"avg_speed"},on:{"change":function($event){_vm.actionField('avg_speed','Speed Avg', 19)}}},[_vm._v("Speed Avg")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_regular'),"value":"cost_regular"},on:{"change":function($event){_vm.actionField('cost_regular','Regular Cost', 20)}}},[_vm._v("Regular Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_stb'),"value":"cost_stb"},on:{"change":function($event){_vm.actionField('cost_stb','STB Cost', 21)}}},[_vm._v("STB Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_worktime'),"value":"cost_worktime"},on:{"change":function($event){_vm.actionField('cost_worktime','Worktime Cost', 22)}}},[_vm._v("Worktime Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_cost'),"value":"total_cost"},on:{"change":function($event){_vm.actionField('total_cost','Total Cost', 23)}}},[_vm._v("Total Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('flags'),"value":"flags"},on:{"change":function($event){_vm.actionField('flags','Flags', 24)}}},[_vm._v("Flags")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('approved/unapproved'),"value":"approved/unapproved"},on:{"change":function($event){_vm.actionField('approved/unapproved','Approved/Unapproved Haul', 25)}}},[_vm._v("Approved/Unapproved Haul")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck_unit'),"value":"truck_unit"},on:{"change":function($event){_vm.actionField('truck_unit','Truck Unit',26)}}},[_vm._v("Truck Unit")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('terminal_boss'),"value":"terminal_boss"},on:{"change":function($event){_vm.actionField('terminal_boss', 'Terminal Boss Ticket',27)}}},[_vm._v("Terminal Boss Ticket")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_estimate'),"value":"volume_estimate"},on:{"change":function($event){_vm.actionField('volume_estimate','Volume Estimate',28)}}},[_vm._v("Volume Estimate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('rate'),"value":"rate"},on:{"change":function($event){_vm.actionField('rate','Rate', 29)}}},[_vm._v("Rate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('stb'),"value":"stb"},on:{"change":function($event){_vm.actionField('stb', 'STB Time', 30)}}},[_vm._v("STB Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('justification'),"value":"justification"},on:{"change":function($event){_vm.actionField('justification','Justification', 31)}}},[_vm._v("Justification")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_subtotal_cost'),"value":"fluid_subtotal_cost"},on:{"change":function($event){_vm.actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 32)}}},[_vm._v("Fluid Subtotal Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst'),"value":"fluid_gst"},on:{"change":function($event){_vm.actionField('fluid_gst','Fluid GST', 33)}}},[_vm._v("Fluid GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst_subtotal'),"value":"fluid_gst_subtotal"},on:{"change":function($event){_vm.actionField('fluid_gst_subtotal','Fluid Total', 34)}}},[_vm._v("Fluid Total")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_cost_subtotal'),"value":"wait_time_cost_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 34)}}},[_vm._v("Wait Time Cost Subtotal")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst'),"value":"wait_time_gst"},on:{"change":function($event){_vm.actionField('wait_time_gst','Wait Time GST', 35)}}},[_vm._v("Wait Time GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst_subtotal'),"value":"wait_time_gst_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 36)}}},[_vm._v("Wait Time GST Subtotal")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n          Save\n        ")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add to Folders","ok-variant":"primary","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.modalFolders),callback:function ($$v) {_vm.modalFolders=$$v},expression:"modalFolders"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label-cols":2,"id":"L4","label-for":"folderID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.folderOptions,"name":"Checkboxes","plain":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.modalFolders=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addHaulsFolder()}}},[_vm._v("\n          Save\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tests_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c9e57d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tests_vue__ = __webpack_require__(1091);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c9e57d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.items}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_haul_vue__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b989a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_haul_vue__ = __webpack_require__(1093);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_haul_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b989a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_haul_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo",attrs:{"id":"pageinfo"}},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Haul "+_vm._s(this.subTitle))]),_vm._v(" "),(_vm.folder_haul.length > 0)?_c('h4',[_vm._v("Folders:")]):_vm._e(),_vm._v(" "),_vm._l((_vm.folder_haul),function(folder){return _c('ul',[_c('li',[_c('h5',[_vm._v(_vm._s(folder.name)+" ")])])])})],2),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[(_vm.isPopup === true)?_c('b-btn',{staticClass:"pull-right ml-1",attrs:{"variant":"info"},on:{"click":_vm.closePopupHaul}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Close")]):_vm._e(),_vm._v(" "),_c('b-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='analyst'|| this.role =='marketing_accountant' || _vm.role =='trucking_operational__manager'),expression:"role =='super_admin' || role =='trucking_company_admin' || role =='analyst'|| this.role =='marketing_accountant' || role =='trucking_operational__manager'"}],staticClass:"pull-right ml-1",attrs:{"disabled":_vm.edit || _vm.edit_analyst,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editHaul}},[_vm._v("Edit")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational__manager')?_c('b-dropdown-item',{on:{"click":_vm.deleteHaul}},[_vm._v("Delete")]):_vm._e()],2),_vm._v(" "),_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Assign/Unassign Folder'),expression:"'Assign/Unassign Folder'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openModal()}}},[_c('i',{staticClass:"fa fa-folder"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"haul-information",attrs:{"id":"haul-information"}},[_c('b-tabs',{attrs:{"pills":"","card":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Haul","active":""}},[_c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"mapStyle":_vm.mapStyle,"mapTypeId":_vm.mapTypeId}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('b-link',{attrs:{"href":_vm.infoLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.infoContent))])],1),_vm._v(" "),_c('gmap-polyline',{attrs:{"path":_vm.path,"options":_vm.options},on:{"update:path":function($event){_vm.path=$event}}}),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"label":m.label,"title":m.title,"icon":m.icon,"clickable":true,"draggable":m.draggable},on:{"click":function($event){_vm.toggleInfoWindow(m, index)}}})})],2),_vm._v(" "),_c('b-card',[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t")])])],1):_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_vm._l((_vm.messages),function(message){return _c('div',{staticStyle:{"background-color":"#CC0000","color":"white","height":"40px","margin":"auto","padding":"10px"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(message)+"\n\t\t\t\t\t\t\t\t")])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view1),expression:"view1"}],attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Trucking Company","label-for":"truck_company"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/trucking_company/'+_vm.truck_company_id+'/')}}},[_vm._v(_vm._s(_vm.truck_company))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"truck_company_id","options":_vm.truck_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.truck_company_id),callback:function ($$v) {_vm.truck_company_id=$$v},expression:"truck_company_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Driver","label-for":"full_name"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/user/'+_vm.user_id+'/')}}},[_vm._v(_vm._s(_vm.full_name))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"user_id","options":_vm.driver_select},on:{"input":function($event){_vm.selects_driver()}},model:{value:(_vm.user_id),callback:function ($$v) {_vm.user_id=$$v},expression:"user_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label":"Energy Company","label-for":"energy_company"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/energy_company/'+_vm.energy_companies_id+'/')}}},[_vm._v(_vm._s(this.energy_company))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"energy_companies_id","options":_vm.energy_company_select},on:{"input":function($event){_vm.selects_energy_company()}},model:{value:(_vm.energy_companies_id),callback:function ($$v) {_vm.energy_companies_id=$$v},expression:"energy_companies_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Trailer 1","label-for":"truck"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && _vm.view),expression:"!edit && view"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/truck/'+_vm.truck_id+'/')}}},[_vm._v(_vm._s(_vm.truck))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit && _vm.view),expression:"edit && view"}],attrs:{"id":"truck_id","options":_vm.truck_select},model:{value:(_vm.truck_id),callback:function ($$v) {_vm.truck_id=$$v},expression:"truck_id"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.view),expression:"!view"}],attrs:{"id":"truck_id","plaintext":"","type":"text"},model:{value:(_vm.truck_id),callback:function ($$v) {_vm.truck_id=$$v},expression:"truck_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Truck Type","label-for":"truck_type"}},[_c('b-form-input',{attrs:{"id":"truck_type","plaintext":"","type":"text"},model:{value:(_vm.truck_type),callback:function ($$v) {_vm.truck_type=$$v},expression:"truck_type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Truck Ticket #","label-for":"ticket1"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"ticket1","plaintext":"","type":"text"},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"ticket1","type":"text"},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Load Location","label-for":"load_location"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && !_vm.edit_analyst),expression:"!edit && !edit_analyst"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/location/'+_vm.load_location_id+'/')}}},[_vm._v(_vm._s(_vm.load_location))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"disabled":_vm.load_location_select.length==0,"id":"load_location_id","options":_vm.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.load_location_id),callback:function ($$v) {_vm.load_location_id=$$v},expression:"load_location_id"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit_analyst),expression:"edit_analyst"}],attrs:{"disabled":_vm.load_location_select.length==0,"id":"load_location_id","options":_vm.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.load_location_id),callback:function ($$v) {_vm.load_location_id=$$v},expression:"load_location_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Fluid Type","label-for":"fluid_type"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/fluid_type/'+_vm.fluid_type_id+'/')}}},[_vm._v(_vm._s(_vm.fluid_type))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"fluid_type_id","options":_vm.fluid_type_select},model:{value:(_vm.fluid_type_id),callback:function ($$v) {_vm.fluid_type_id=$$v},expression:"fluid_type_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Unload Location","label-for":"unload_location"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && !_vm.edit_analyst),expression:"!edit && !edit_analyst"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/location/'+_vm.unload_location_id+'/')}}},[_vm._v(_vm._s(_vm.unload_location))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"unload_location_id","options":_vm.unload_location_select},model:{value:(_vm.unload_location_id),callback:function ($$v) {_vm.unload_location_id=$$v},expression:"unload_location_id"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit_analyst),expression:"edit_analyst"}],attrs:{"id":"unload_location_id","options":_vm.unload_location_select},model:{value:(_vm.unload_location_id),callback:function ($$v) {_vm.unload_location_id=$$v},expression:"unload_location_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Terminal Ticket #","label-for":"ticket"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"ticket","plaintext":"","type":"text"},model:{value:(_vm.terminal_ticket),callback:function ($$v) {_vm.terminal_ticket=$$v},expression:"terminal_ticket"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"ticket","type":"text"},model:{value:(_vm.terminal_ticket),callback:function ($$v) {_vm.terminal_ticket=$$v},expression:"terminal_ticket"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Total Distance Km","label-for":"total_distance"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"total_distance","plaintext":"","type":"text"},model:{value:(_vm.total_distance),callback:function ($$v) {_vm.total_distance=$$v},expression:"total_distance"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"total_distance","type":"text"},model:{value:(_vm.total_distance),callback:function ($$v) {_vm.total_distance=$$v},expression:"total_distance"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Average Speed","label-for":"avg_speed"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"avg_speed","type":"text"},model:{value:(_vm.avg_speed),callback:function ($$v) {_vm.avg_speed=$$v},expression:"avg_speed"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Volume Estimate","label-for":"volume_estimate"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"volume_estimate","type":"text"},model:{value:(_vm.volume_estimate),callback:function ($$v) {_vm.volume_estimate=$$v},expression:"volume_estimate"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"volume_estimate","type":"text"},nativeOn:{"keydown":function($event){_vm.volumeEstimateNumber($event)},"blur":function($event){_vm.inputBlur('volume_estimate')}},model:{value:(_vm.volume_estimate),callback:function ($$v) {_vm.volume_estimate=$$v},expression:"volume_estimate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Volume Total Actual","label-for":"volume_actual"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit && !_vm.edit_analyst),expression:"!edit && !edit_analyst"}],attrs:{"plaintext":"","id":"volume_actual","type":"text"},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"volume_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.volumeActualNumber($event)},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit_analyst),expression:"edit_analyst"}],attrs:{"id":"volume_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.volumeActualNumber($event)},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Oil Actual","label-for":"oil_actual"}},[(!_vm.edit_analyst)?_c('b-form-input',{attrs:{"id":"oil_actual","plaintext":"","type":"text"},model:{value:(_vm.oil_actual),callback:function ($$v) {_vm.oil_actual=$$v},expression:"oil_actual"}}):_c('b-form-input',{attrs:{"id":"oil_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.oilActualNumber($event)},"blur":function($event){_vm.inputBlur('oil_actual')}},model:{value:(_vm.oil_actual),callback:function ($$v) {_vm.oil_actual=$$v},expression:"oil_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Water Actual","label-for":"water_actual"}},[_c('b-form-input',{attrs:{"id":"water_actual","plaintext":"","type":"text"},model:{value:(_vm.water_actual),callback:function ($$v) {_vm.water_actual=$$v},expression:"water_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Water Cut Actual %","label-for":"water_percentage_actual"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"water_percentage_actual","type":"text"},model:{value:(_vm.water_percentage_actual),callback:function ($$v) {_vm.water_percentage_actual=$$v},expression:"water_percentage_actual"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"water_percentage_actual","type":"text"},nativeOn:{"keydown":function($event){_vm.waterActualNumber($event)},"blur":function($event){_vm.inputBlur('water_percentage_actual')}},model:{value:(_vm.water_percentage_actual),callback:function ($$v) {_vm.water_percentage_actual=$$v},expression:"water_percentage_actual"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"BS%W Actual","label-for":"bsw"}},[(!_vm.edit_analyst)?_c('b-form-input',{attrs:{"plaintext":"","id":"bsw","type":"text"},model:{value:(_vm.bsw),callback:function ($$v) {_vm.bsw=$$v},expression:"bsw"}}):_c('b-form-input',{attrs:{"id":"bsw","type":"text"},nativeOn:{"keydown":function($event){_vm.bswNumber($event)},"blur":function($event){_vm.inputBlur('bsw')}},model:{value:(_vm.bsw),callback:function ($$v) {_vm.bsw=$$v},expression:"bsw"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Start Date/Time","label-for":"haul_start_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_start_date","plaintext":"","type":"text"},model:{value:(_vm.haul_start_date),callback:function ($$v) {_vm.haul_start_date=$$v},expression:"haul_start_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"haul_start_datetime","type":"date"},model:{value:(_vm.haul_start_datetime),callback:function ($$v) {_vm.haul_start_datetime=$$v},expression:"haul_start_datetime"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_start_time","plaintext":"","type":"text"},model:{value:(_vm.haul_start_time),callback:function ($$v) {_vm.haul_start_time=$$v},expression:"haul_start_time"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_start_time","type":"text"},model:{value:(_vm.haul_start_time),callback:function ($$v) {_vm.haul_start_time=$$v},expression:"haul_start_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"End Date/Time","label-for":"haul_start_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_end_date","plaintext":"","type":"text"},model:{value:(_vm.haul_end_date),callback:function ($$v) {_vm.haul_end_date=$$v},expression:"haul_end_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"haul_end_datetime","type":"date"},model:{value:(_vm.haul_end_datetime),callback:function ($$v) {_vm.haul_end_datetime=$$v},expression:"haul_end_datetime"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"id":"haul_end_time","plaintext":"","type":"text"},model:{value:(_vm.haul_end_time),callback:function ($$v) {_vm.haul_end_time=$$v},expression:"haul_end_time"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_end_time","type":"text"},model:{value:(_vm.haul_end_time),callback:function ($$v) {_vm.haul_end_time=$$v},expression:"haul_end_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Drive Time","label-for":"driving_time"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"driving_time","type":"text"},model:{value:(_vm.driving_time),callback:function ($$v) {_vm.driving_time=$$v},expression:"driving_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Stand by Time","label-for":"stb"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"stb","type":"text"},model:{value:(_vm.stb),callback:function ($$v) {_vm.stb=$$v},expression:"stb"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Chain Up Time","label-for":"Chain_Up_Time"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"Chain_Up_Time","type":"text"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Total Personal Time","label-for":"personal_time"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"personal_time","type":"text"},model:{value:(_vm.personal_time),callback:function ($$v) {_vm.personal_time=$$v},expression:"personal_time"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"onmouseover":"this.style.cursor='pointer'","sm":"6","md":"4","lg":"3","xl":"2"},on:{"click":function($event){_vm.est_detail()}}},[_c('b-form-group',{attrs:{"label":"Total Cost","label-for":"total_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"total_cost","type":"text"},model:{value:(_vm.total_cost),callback:function ($$v) {_vm.total_cost=$$v},expression:"total_cost"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Unit Cost","label-for":"unit_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"unit_cost","type":"text"},model:{value:(_vm.unit_cost),callback:function ($$v) {_vm.unit_cost=$$v},expression:"unit_cost"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Drive Rate","label-for":"rate"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"rate","type":"text"},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Stand by Rate","label-for":"stb_rate"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"stb_rate","type":"text"},model:{value:(_vm.stb_rate),callback:function ($$v) {_vm.stb_rate=$$v},expression:"stb_rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Chain Up Rate","label-for":"chain_up_rate"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"chain_up_rate","type":"text"},model:{value:(_vm.chain_up_rate),callback:function ($$v) {_vm.chain_up_rate=$$v},expression:"chain_up_rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Agreement","label-for":"agreement"}},[(_vm.agreement_id != 'No Assigned' && !_vm.edit)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/agreement/'+_vm.agreement_id+'/')}}},[_vm._v(_vm._s(this.agreement_id))]):_c('b-form-input',{attrs:{"plaintext":"","id":"agreement","type":"text"},model:{value:(_vm.agreement_id),callback:function ($$v) {_vm.agreement_id=$$v},expression:"agreement_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Regular Cost","label-for":"regular_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"regular_cost","type":"text"},model:{value:(_vm.cost_regular),callback:function ($$v) {_vm.cost_regular=$$v},expression:"cost_regular"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Stb Cost","label-for":"stb_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"stb_cost","type":"text"},model:{value:(_vm.cost_stb),callback:function ($$v) {_vm.cost_stb=$$v},expression:"cost_stb"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Worktime Cost","label-for":"w_cost"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"w_cost","type":"text"},model:{value:(_vm.cost_worktime),callback:function ($$v) {_vm.cost_worktime=$$v},expression:"cost_worktime"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_vm._l((_vm.wait_times),function(wait_time,index){return _c('b-col',{key:wait_time.id,attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":wait_time.type_wait_times,"label-for":wait_time.type_wait_times}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"placeholder":"hh:mm","type":"text"},model:{value:(wait_time.total),callback:function ($$v) {_vm.$set(wait_time, "total", $$v)},expression:"wait_time.total"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"plaintext":"","type":"text"},model:{value:(wait_time.total),callback:function ($$v) {_vm.$set(wait_time, "total", $$v)},expression:"wait_time.total"}})],1)],1)}),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.personal_time_add),expression:"personal_time_add"}],attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":_vm.personal_time_option}},[_vm._v("Add Personal Time")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Chain Up Rate Applied","label-for":"id_5"}},[_c('b-form-checkbox',{attrs:{"id":"id_5","plain":"","disabled":""},model:{value:(_vm.chain_up_applied),callback:function ($$v) {_vm.chain_up_applied=$$v},expression:"chain_up_applied"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Terminal Boss","label-for":"terminal_boss"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"terminal_boss","type":"text"},model:{value:(_vm.terminal_boss),callback:function ($$v) {_vm.terminal_boss=$$v},expression:"terminal_boss"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","id":"terminal_boss","type":"text"},model:{value:(_vm.terminal_boss),callback:function ($$v) {_vm.terminal_boss=$$v},expression:"terminal_boss"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Truck Unit","label-for":"truck_unit"}},[(_vm.trucks_unit_id!==null)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/trucks_unit/'+_vm.trucks_unit_id+'/')}}},[_vm._v(_vm._s(_vm.truck_unit))]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('b-form-select',{attrs:{"size":"sm","id":"truck_unit","value-field":"id","text-field":"truck_unit","options":_vm.truck_unit_select},model:{value:(_vm.trucks_unit_id),callback:function ($$v) {_vm.trucks_unit_id=$$v},expression:"trucks_unit_id"}}):_vm._e()],1)],1)],2),_vm._v(" "),_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Comments Start","label-for":"comments_start"}},[_c('b-form-textarea',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"comments_start","type":"text","rows":2,"max-rows":2},model:{value:(_vm.comments_start),callback:function ($$v) {_vm.comments_start=$$v},expression:"comments_start"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"comments_start","type":"text"},model:{value:(_vm.comments_start),callback:function ($$v) {_vm.comments_start=$$v},expression:"comments_start"}})],1)],1),_vm._v(" "),_vm._l((_vm.wait_times),function(wait_time,index){return (wait_time.comments != '' && !_vm.edit)?_c('b-col',{key:wait_time.id,attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Comments Wait Time","label-for":"Comments_Wait_Time"}},[_c('b-form-textarea',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","type":"text","rows":2,"max-rows":2},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.wait_times),function(wait_time,index){return (_vm.edit)?_c('b-col',{key:wait_time.id,attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":wait_time.type_wait_times,"label-for":"Comments_Wait_Time"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"placeholder":"Comments Wait Time","type":"text"},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}})],1)],1):_vm._e()}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Comments End","label-for":"comments_end"}},[_c('b-form-textarea',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"comments_end","type":"text","rows":2,"max-rows":2},model:{value:(_vm.comments_end),callback:function ($$v) {_vm.comments_end=$$v},expression:"comments_end"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"comments_end","type":"text"},model:{value:(_vm.comments_end),callback:function ($$v) {_vm.comments_end=$$v},expression:"comments_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"ID","label-for":"Id"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"Id","type":"text"},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}})],1)],1)],2),_vm._v(" "),_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Terminal Treatment Fee","label-for":"terminal_treatment_fee"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_treatment_fee","type":"text"},model:{value:(_vm.terminal_treatment_fee),callback:function ($$v) {_vm.terminal_treatment_fee=$$v},expression:"terminal_treatment_fee"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Terminal Other Fees","label-for":"terminal_other_fees"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_other_fees","type":"text"},model:{value:(_vm.terminal_other_fees),callback:function ($$v) {_vm.terminal_other_fees=$$v},expression:"terminal_other_fees"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Terminal H2S Fees","label-for":"terminal_h2s_fees"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_h2s_fees","type":"text"},model:{value:(_vm.terminal_h2s_fees),callback:function ($$v) {_vm.terminal_h2s_fees=$$v},expression:"terminal_h2s_fees"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Terminal Density Fees","label-for":"terminal_density_fee"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"terminal_density_fee","type":"text"},model:{value:(_vm.terminal_density_fee),callback:function ($$v) {_vm.terminal_density_fee=$$v},expression:"terminal_density_fee"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Total Terminal Cost","label-for":"total_terminal_treatment_fees"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"total_terminal_treatment_fees","type":"text"},model:{value:(_vm.total_terminal_treatment_fees),callback:function ($$v) {_vm.total_terminal_treatment_fees=$$v},expression:"total_terminal_treatment_fees"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Gross Revenue","label-for":"gross_revenue"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"gross_revenue","type":"text"},model:{value:(_vm.gross_revenue),callback:function ($$v) {_vm.gross_revenue=$$v},expression:"gross_revenue"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Net Revenue","label-for":"netback"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"netback","type":"text"},model:{value:(_vm.netback),callback:function ($$v) {_vm.netback=$$v},expression:"netback"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Created at","label-for":"created_date"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"created_date","type":"text"},model:{value:(_vm.created_date),callback:function ($$v) {_vm.created_date=$$v},expression:"created_date"}}),_vm._v(" "),_c('b-form-input',{attrs:{"plaintext":"","id":"created_time","type":"text"},model:{value:(_vm.created_time),callback:function ($$v) {_vm.created_time=$$v},expression:"created_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Updated at","label-for":"updated_date"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"updated_date","type":"text"},model:{value:(_vm.updated_date),callback:function ($$v) {_vm.updated_date=$$v},expression:"updated_date"}}),_vm._v(" "),_c('b-form-input',{attrs:{"plaintext":"","id":"updated_time","type":"text"},model:{value:(_vm.updated_time),callback:function ($$v) {_vm.updated_time=$$v},expression:"updated_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Re-Routed","label-for":"rerouted"}},[_c('b-form-input',{attrs:{"plaintext":"","id":"rerouted","type":"text"},model:{value:(_vm.rerouted),callback:function ($$v) {_vm.rerouted=$$v},expression:"rerouted"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Trailer 2","label-for":"truck2"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.truck2_id!==null && !_vm.edit && _vm.view),expression:"truck2_id!==null && !edit && view"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/truck/'+_vm.truck2_id+'/')}}},[_vm._v(_vm._s(_vm.truck2))]),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit && _vm.view),expression:"edit && view"}],attrs:{"id":"truck2","options":_vm.truck_select},model:{value:(_vm.truck2_id),callback:function ($$v) {_vm.truck2_id=$$v},expression:"truck2_id"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.truck2_id!==null && !_vm.view),expression:"truck2_id!==null && !view"}],attrs:{"id":"truck2","plaintext":"","type":"text"},model:{value:(_vm.truck2_id),callback:function ($$v) {_vm.truck2_id=$$v},expression:"truck2_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"id":"L2","label":"Residue Last Contained","label-for":"residue_last_contained"}},[(!_vm.edit)?_c('b-form-checkbox',{attrs:{"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.residue_last_contained),callback:function ($$v) {_vm.residue_last_contained=$$v},expression:"residue_last_contained"}}):_c('b-form-checkbox',{attrs:{"name":"Checkboxes2","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.residue_last_contained),callback:function ($$v) {_vm.residue_last_contained=$$v},expression:"residue_last_contained"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"TDG","label-for":"tdg"}},[(_vm.tdg_id!==null)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.$router.push('/tdg/'+_vm.tdg_id+'/')}}},[_vm._v(_vm._s(_vm.tdg))]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('b-form-select',{attrs:{"size":"sm","id":"tdg","value-field":"id","text-field":"name","options":_vm.tdg_select},model:{value:(_vm.tdg_id),callback:function ($$v) {_vm.tdg_id=$$v},expression:"tdg_id"}}):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Request Number","label-for":"request_number"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"request_number","type":"text"},model:{value:(_vm.cnr_details[0].request_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "request_number", $$v)},expression:"cnr_details[0].request_number"}}):_c('b-form-input',{attrs:{"id":"request_number","type":"text"},model:{value:(_vm.cnr_details[0].request_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "request_number", $$v)},expression:"cnr_details[0].request_number"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Tank Number","label-for":"tank_number"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"tank_number","type":"text"},model:{value:(_vm.cnr_details[0].tank_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tank_number", $$v)},expression:"cnr_details[0].tank_number"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"id":"tank_number","type":"text"},model:{value:(_vm.cnr_details[0].tank_number),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tank_number", $$v)},expression:"cnr_details[0].tank_number"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Start Gauge","label-for":"start_gauge"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"start_gauge","type":"text"},model:{value:(_vm.cnr_details[0].start_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_gauge", $$v)},expression:"cnr_details[0].start_gauge"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('###'),expression:"'###'"}],attrs:{"id":"start_gauge","type":"text"},model:{value:(_vm.cnr_details[0].start_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_gauge", $$v)},expression:"cnr_details[0].start_gauge"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Finish Gauge","label-for":"finish_gauge"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"finish_gauge","type":"text"},model:{value:(_vm.cnr_details[0].finish_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "finish_gauge", $$v)},expression:"cnr_details[0].finish_gauge"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('###'),expression:"'###'"}],attrs:{"id":"finish_gauge","type":"text"},model:{value:(_vm.cnr_details[0].finish_gauge),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "finish_gauge", $$v)},expression:"cnr_details[0].finish_gauge"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Start Time Load","label-for":"start_time_load"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"start_time_load","type":"text"},model:{value:(_vm.cnr_details[0].start_time_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_time_load", $$v)},expression:"cnr_details[0].start_time_load"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"start_time_load","type":"date"},model:{value:(_vm.cnr_details[0].start_time_load_date),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_time_load_date", $$v)},expression:"cnr_details[0].start_time_load_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"start_time_load","type":"text"},model:{value:(_vm.cnr_details[0].start_time_load_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "start_time_load_time", $$v)},expression:"cnr_details[0].start_time_load_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"End Time Load","label-for":"end_time_load"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"end_time_load","type":"text"},model:{value:(_vm.cnr_details[0].end_time_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "end_time_load", $$v)},expression:"cnr_details[0].end_time_load"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"end_time_load","type":"date"},model:{value:(_vm.cnr_details[0].end_time_load_date),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "end_time_load_date", $$v)},expression:"cnr_details[0].end_time_load_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"end_time_load","type":"text"},model:{value:(_vm.cnr_details[0].end_time_load_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "end_time_load_time", $$v)},expression:"cnr_details[0].end_time_load_time"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.cnr && _vm.cnr_details.length>0)?_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Temperature Load","label-for":"temperature_load"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"temperature_load","type":"text"},model:{value:(_vm.cnr_details[0].temperature_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_load", $$v)},expression:"cnr_details[0].temperature_load"}}):_c('b-form-input',{attrs:{"id":"temperature_load","type":"text"},nativeOn:{"keydown":function($event){_vm.temperatureLoad($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].temperature_load')}},model:{value:(_vm.cnr_details[0].temperature_load),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_load", $$v)},expression:"cnr_details[0].temperature_load"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Temperature Unload","label-for":"temperature_unload"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"temperature_unload","type":"text"},model:{value:(_vm.cnr_details[0].temperature_unload),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_unload", $$v)},expression:"cnr_details[0].temperature_unload"}}):_c('b-form-input',{attrs:{"id":"temperature_unload","type":"text"},nativeOn:{"keydown":function($event){_vm.temperatureULoad($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].temperature_unload')}},model:{value:(_vm.cnr_details[0].temperature_unload),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "temperature_unload", $$v)},expression:"cnr_details[0].temperature_unload"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Gross Weight","label-for":"gross_weight"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"gross_weight","type":"text"},model:{value:(_vm.cnr_details[0].gross_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "gross_weight", $$v)},expression:"cnr_details[0].gross_weight"}}):_c('b-form-input',{attrs:{"id":"gross_weight","type":"text"},nativeOn:{"keydown":function($event){_vm.grossWeight($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].gross_weight')}},model:{value:(_vm.cnr_details[0].gross_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "gross_weight", $$v)},expression:"cnr_details[0].gross_weight"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Tare Weight","label-for":"tare_weight"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"tare_weight","type":"text"},model:{value:(_vm.cnr_details[0].tare_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tare_weight", $$v)},expression:"cnr_details[0].tare_weight"}}):_c('b-form-input',{attrs:{"id":"tare_weight","type":"text"},nativeOn:{"keydown":function($event){_vm.tareWeight($event)},"blur":function($event){_vm.inputBlur1('this.cnr_details[0].tare_weight')}},model:{value:(_vm.cnr_details[0].tare_weight),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "tare_weight", $$v)},expression:"cnr_details[0].tare_weight"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Scale In Time","label-for":"scale_in_time"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"scale_in_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_in_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_in_time", $$v)},expression:"cnr_details[0].scale_in_time"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"id":"scale_in_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_in_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_in_time", $$v)},expression:"cnr_details[0].scale_in_time"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","md":"4","lg":"3","xl":"2"}},[_c('b-form-group',{attrs:{"label":"Scale Out Time","label-for":"scale_out_time"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"scale_out_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_out_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_out_time", $$v)},expression:"cnr_details[0].scale_out_time"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"id":"scale_out_time","type":"text"},model:{value:(_vm.cnr_details[0].scale_out_time),callback:function ($$v) {_vm.$set(_vm.cnr_details[0], "scale_out_time", $$v)},expression:"cnr_details[0].scale_out_time"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[(_vm.edit || _vm.edit_analyst)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit || _vm.edit_analyst),expression:"edit || edit_analyst"}],attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateHaul}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit || _vm.edit_analyst),expression:"edit || edit_analyst"}],attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.editHaul}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()])],2)],1)],1)],1),_vm._v(" "),(_vm.files !='')?_c('b-tab',{attrs:{"title":"Hauls Pictures"}},_vm._l((_vm.files),function(file){return _c('div',[_c('p',[_vm._v(_vm._s(file.comment))]),_vm._v(" "),_c('img',{staticClass:"img-fluid rounded d-block m-l-none",attrs:{"src":file.file}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveImage(file.file)}}},[_vm._v("Download")]),_vm._v(" "),_c('br')],1)})):_vm._e()],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add to Folders","ok-variant":"primary","centered":"","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.modalFolders),callback:function ($$v) {_vm.modalFolders=$$v},expression:"modalFolders"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label-cols":2,"id":"L4","label-for":"folderID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.folderOptions,"name":"Checkboxes","plain":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.modalFolders=false}}},[_vm._v("\n\t\t\t\t\tCancel\n\t\t\t\t")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addHaulsFolder()}}},[_vm._v("\n\t\t\t\t\tSave\n\t\t\t\t")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add Personal Time","centered":"","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.personal_time_modal),callback:function ($$v) {_vm.personal_time_modal=$$v},expression:"personal_time_modal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Personal Time","label-for":"personal_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"personal_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('total')}},model:{value:(_vm.personal_time_items.total),callback:function ($$v) {_vm.$set(_vm.personal_time_items, "total", $$v)},expression:"personal_time_items.total"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Comments","label-for":"comments_pt"}},[_c('b-form-input',{attrs:{"id":"comments_ps","type":"text"},model:{value:(_vm.personal_time_items.comments),callback:function ($$v) {_vm.$set(_vm.personal_time_items, "comments", $$v)},expression:"personal_time_items.comments"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.hidepersonaltime()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.personal_time_save()}}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"","centered":"","ok-only":""},model:{value:(_vm.calculate),callback:function ($$v) {_vm.calculate=$$v},expression:"calculate"}},[_c('b-row',[_c('p',{staticStyle:{"margin-left":"5px","margin-bottom":"0","line-height":"15px"}},[_vm._v("Formula: "+_vm._s(_vm.formula))]),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Drive Rate:","label-for":"id_1"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_1","type":"text"},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}})],1),_vm._v(" "),(_vm.type_rate=='Volume Actual')?_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Volume Actual:","label-for":"id_2"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_2","type":"text"},model:{value:(_vm.volume_actual),callback:function ($$v) {_vm.volume_actual=$$v},expression:"volume_actual"}})],1):_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Drive Time:","label-for":"id_2"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_2","type":"text"},model:{value:(_vm.driving_time),callback:function ($$v) {_vm.driving_time=$$v},expression:"driving_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Stand by Rate:","label-for":"id_3"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_3","type":"text"},model:{value:(_vm.stb_rate),callback:function ($$v) {_vm.stb_rate=$$v},expression:"stb_rate"}})],1),_vm._v(" "),(_vm.type_stb_rate=='Standby Time')?_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Standby Time:","label-for":"id_22"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_22","type":"text"},model:{value:(_vm.stb),callback:function ($$v) {_vm.stb=$$v},expression:"stb"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Chain Up Rate:","label-for":"id_4"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_4","type":"text"},model:{value:(_vm.chain_up_rate),callback:function ($$v) {_vm.chain_up_rate=$$v},expression:"chain_up_rate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Chain Up Rate Applied","label-for":"id_5"}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"id":"checkbox","plain":"","disabled":""},model:{value:(_vm.chain_up_applied),callback:function ($$v) {_vm.chain_up_applied=$$v},expression:"chain_up_applied"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Worktime Rate:","label-for":"id_6"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_6","type":"text"},model:{value:(_vm.worktime_rate),callback:function ($$v) {_vm.worktime_rate=$$v},expression:"worktime_rate"}})],1),_vm._v(" "),(_vm.type_worktime_rate=='Work Time')?_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"WorkTime:","label-for":"id_222"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_222","type":"text"},model:{value:(_vm.work_time),callback:function ($$v) {_vm.work_time=$$v},expression:"work_time"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label":"Total Terminal Cost:","label-for":"id_7"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id_7","type":"text"},model:{value:(_vm.total_terminal_treatment_fees),callback:function ($$v) {_vm.total_terminal_treatment_fees=$$v},expression:"total_terminal_treatment_fees"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucks_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f61c29a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucks_vue__ = __webpack_require__(1095);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f61c29a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Trucks")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Trucks - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),(_vm.role==='super_admin' || _vm.role==='trucking_company_admin' || _vm.role==='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTrucks()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTrucks()}}},[_vm._v("Trash")])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"disabled":!_vm.insert_data,"variant":"primary"},on:{"click":_vm.newTruckModal}},[_vm._v("Add Truck")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t\t")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fieldsTh,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modalInfo","title":_vm.modalInfo.title,"ok-only":""},on:{"hide":_vm.resetModal}},[_c('pre',[_vm._v(_vm._s(_vm.modalInfo.content))])])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Truck","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newTruck),callback:function ($$v) {_vm.newTruck=$$v},expression:"newTruck"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Truck Name:","label-for":"trucknameID","horizontal":""}},[_c('b-form-input',{attrs:{"id":"trucknameID","type":"text"},model:{value:(_vm.model.truck_name),callback:function ($$v) {_vm.$set(_vm.model, "truck_name", $$v)},expression:"model.truck_name"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"id":"L4","label":"Trucking Company:","label-for":"truckingCompanyID","horizontal":""}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"trucking_company","id":"truckingCompanyID","options":_vm.truckingcompaniesselect},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Truck Type:","label-for":"truckTypeID","horizontal":""}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"type","id":"truckTypeID","options":_vm.trucktypesselect},model:{value:(_vm.model.truck_type_id),callback:function ($$v) {_vm.$set(_vm.model, "truck_type_id", $$v)},expression:"model.truck_type_id"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTruck=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveNewTruck}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Config Table","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"value":"id","disabled":true}},[_vm._v("Truck ID")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"truck_name","disabled":true}},[_vm._v("Truck Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"plate_truck","disabled":true}},[_vm._v("Plate Truck")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"type"},on:{"change":function($event){_vm.actionField('type')}}},[_vm._v("Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"trucking_company"},on:{"change":function($event){_vm.actionField('trucking_company')}}},[_vm._v("Trucking Company")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"create_at"},on:{"change":function($event){_vm.actionField('create_at')}}},[_vm._v("Created")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_truck_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_188a4eff_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_truck_vue__ = __webpack_require__(1097);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_truck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_188a4eff_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_truck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Truck - "+_vm._s(this.subTitle))])]),_vm._v(" "),(_vm.role ==='super_admin' || _vm.role ==='trucking_company_admin' || _vm.role === 'trucking_operational_manager')?_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTruck}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTruck}},[_vm._v("Delete")])],2)],1):_vm._e()],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Truck Name","label-for":"trucknameID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"trucknameID","type":"text"},model:{value:(_vm.model.truck_name),callback:function ($$v) {_vm.$set(_vm.model, "truck_name", $$v)},expression:"model.truck_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"trucknameID","type":"text"},model:{value:(_vm.model.truck_name),callback:function ($$v) {_vm.$set(_vm.model, "truck_name", $$v)},expression:"model.truck_name"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label":"Trucking Company","label-for":"truckingCompanyID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"truckingCompanyID","type":"text"},model:{value:(_vm.model.trucking_company),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company", $$v)},expression:"model.trucking_company"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"value-field":"id","text-field":"trucking_company","id":"truckingCompanyID","options":_vm.truckingcompaniesselect},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Truck Type","label-for":"truckTypeID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"truckTypeID","type":"text"},model:{value:(_vm.model.truck_type),callback:function ($$v) {_vm.$set(_vm.model, "truck_type", $$v)},expression:"model.truck_type"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"value-field":"id","text-field":"type","id":"truckTypeID","options":_vm.trucktypesselect},model:{value:(_vm.model.truck_type_id),callback:function ($$v) {_vm.$set(_vm.model, "truck_type_id", $$v)},expression:"model.truck_type_id"}})],1),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTruck}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTruck}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreements_vue__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efd13a1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreements_vue__ = __webpack_require__(1101);
function injectStyle (ssrContext) {
  __webpack_require__(1099)
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4efd13a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efd13a1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Fluid Transportation Agreement")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Fluid Transportation Agreement - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashAgreement()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashAgreement()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"disabled":_vm.loadingData,"variant":"primary"},on:{"click":function($event){_vm.showNewModal()}}},[_vm._v("New Agreement")])],1),_vm._v(" "),(_vm.role =='super_admin')?_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"2","title":"Energy Companies"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filter_agree.energy_company},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"2","title":"Trucking Companies"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filter_agree.trucking_company},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filter_agree.load_locations,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Load Locations', 0)}}},[_vm._v("All Load Locations")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filter_agree.unload_locations,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unload Locations', 0)}}},[_vm._v("All Unload Locations")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filter_agree.truck_types,"title":"TruckTypes"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ttFilter('All Truck Types', 0)}}},[_vm._v("All Truck Types")]),_vm._v(" "),_vm._l((_vm.truck_types_filter),function(truck_type_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ttFilter(truck_type_filter.name, truck_type_filter.id)}}},[_vm._v(_vm._s(truck_type_filter.name))])})],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"items":_vm.items,"fields":_vm.fieldsTh,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"details",fn:function(row){return [_c('center',[_c('b-button',{attrs:{"size":"sm","variant":"info"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}],staticClass:"fa fa-angle-double-up"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}],staticClass:"fa fa-angle-double-right"})])],1)]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',_vm._l((row.item),function(value,key){return _c('li',{key:key},[_vm._v(_vm._s(key)+": "+_vm._s(value))])}))])]}},{key:"load_locations_l",fn:function(row){return _vm._l((row.item.load_locations_l),function(load_location,index){return _c('p',{key:index},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(load_location)+"\n\t\t\t\t\t\t\t\t")])})}},{key:"unload_locations_l",fn:function(row){return _vm._l((row.item.unload_locations_l),function(unload_location,index){return _c('p',{key:index},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(unload_location)+"\n\t\t\t\t\t\t\t\t")])})}},{key:"fluidtypes",fn:function(row){return _vm._l((row.item.fluidtypes),function(fluidtype,index){return _c('p',{key:index},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(fluidtype)+"\n\t\t\t\t\t\t\t\t")])})}},{key:"truck_types_l",fn:function(row){return _vm._l((row.item.truck_types_l),function(truck_type,index){return _c('p',{key:index},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(truck_type)+"\n\t\t\t\t\t\t\t\t")])})}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-1 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modalInfo","title":_vm.modalInfo.title,"ok-only":""},on:{"hide":_vm.resetModal}},[_c('pre',[_vm._v(_vm._s(_vm.modalInfo.content))])])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newAgreements",attrs:{"title":"New Agreement","id":"newModal","size":"lg"},model:{value:(_vm.newAgreements),callback:function ($$v) {_vm.newAgreements=$$v},expression:"newAgreements"}},[_c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""},model:{value:(_vm.modalTabIndex),callback:function ($$v) {_vm.modalTabIndex=$$v},expression:"modalTabIndex"}},[_c('b-tab',{attrs:{"title":"Basic Info","active":""}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L1","label":"Location Based Contract","label-for":"radio-group-1","vertical":""}},[_c('b-form-radio-group',{attrs:{"id":"radio-group-1","options":_vm.options,"plain":""},model:{value:(_vm.model.located_based),callback:function ($$v) {_vm.$set(_vm.model, "located_based", $$v)},expression:"model.located_based"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L11","label":"Fluid Type Based Contract","label-for":"radio-group-4","vertical":""}},[_c('b-form-radio-group',{attrs:{"id":"radio-group-4","options":_vm.options,"plain":""},model:{value:(_vm.model.fluid_based),callback:function ($$v) {_vm.$set(_vm.model, "fluid_based", $$v)},expression:"model.fluid_based"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Initial Date","label-for":"initial_date"}},[_c('b-form-input',{attrs:{"id":"initial_date","type":"date"},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"End Date","label-for":"end_date"}},[_c('b-form-input',{attrs:{"id":"end_date","type":"date"},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin')?_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Energy Company","label-for":"energyCompanies"}},[_c('b-form-select',{attrs:{"id":"energyCompanies","options":_vm.energyCompanies},on:{"input":function($event){_vm.select_energy_companies()}},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Trucking Company","label-for":"truckingCompanies"}},[_c('b-form-select',{attrs:{"id":"truckingCompanies","options":_vm.truckingCompanies},on:{"input":function($event){_vm.select_trucking_companies()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Regular Charge","label-for":"regular_charge"}},[_c('b-form-select',{attrs:{"id":"regular_charge","options":_vm.chargeTypes},model:{value:(_vm.model.regular_charge_id),callback:function ($$v) {_vm.$set(_vm.model, "regular_charge_id", $$v)},expression:"model.regular_charge_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select regular charge --")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Regular Rate","label-for":"regular_rate"}},[_c('b-form-input',{attrs:{"id":"regular_rate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'regular_rate')}},model:{value:(_vm.model.regular_rate),callback:function ($$v) {_vm.$set(_vm.model, "regular_rate", $$v)},expression:"model.regular_rate"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Standby Time Charge","label-for":"stb_charge"}},[_c('b-form-select',{attrs:{"id":"stb_charge","options":_vm.chargeTypes},model:{value:(_vm.model.stb_charge_id),callback:function ($$v) {_vm.$set(_vm.model, "stb_charge_id", $$v)},expression:"model.stb_charge_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select standby time charge --")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Standby Time Rate","label-for":"stb_rate"}},[_c('b-form-input',{attrs:{"id":"stb_rate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'stb_rate')}},model:{value:(_vm.model.stb_rate),callback:function ($$v) {_vm.$set(_vm.model, "stb_rate", $$v)},expression:"model.stb_rate"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Worktime Charge","label-for":"worktime_charge"}},[_c('b-form-select',{attrs:{"id":"worktime_charge","options":_vm.chargeTypes},model:{value:(_vm.model.worktime_charge_id),callback:function ($$v) {_vm.$set(_vm.model, "worktime_charge_id", $$v)},expression:"model.worktime_charge_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select worktime charge --")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Worktime Rate","label-for":"worktime_rate"}},[_c('b-form-input',{attrs:{"id":"worktime_rate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'worktime_rate')}},model:{value:(_vm.model.worktime_rate),callback:function ($$v) {_vm.$set(_vm.model, "worktime_rate", $$v)},expression:"model.worktime_rate"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L2","label":"Wait Time Discount?","label-for":"radio-group-2","vertical":""}},[_c('b-form-radio-group',{attrs:{"id":"radio-group-2","options":_vm.options,"plain":""},model:{value:(_vm.model.wait_time_discount),callback:function ($$v) {_vm.$set(_vm.model, "wait_time_discount", $$v)},expression:"model.wait_time_discount"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":3,"id":"L3","label":"Would you like to round to the nearest 15min? ","label-for":"radio-group-3","vertical":""}},[_c('b-form-radio-group',{attrs:{"id":"radio-group-3","options":_vm.options,"plain":""},model:{value:(_vm.model.rounding),callback:function ($$v) {_vm.$set(_vm.model, "rounding", $$v)},expression:"model.rounding"}})],1)],1),_vm._v(" "),(_vm.model.regular_charge_id != null && _vm.model.regular_rate != null)?_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Chain Up Rate","label-for":"chain_up_rate"}},[_c('b-form-input',{attrs:{"id":"chain_up_rate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'chain_up_rate')}},model:{value:(_vm.model.chain_up_rate),callback:function ($$v) {_vm.$set(_vm.model, "chain_up_rate", $$v)},expression:"model.chain_up_rate"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Truck Types"}},[(_vm.truckTypes.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"","label-for":"loadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.truckTypes,"name":"Checkboxes2","plain":""},on:{"input":_vm.trucktypesChange},model:{value:(_vm.model.truck_type_id),callback:function ($$v) {_vm.$set(_vm.model, "truck_type_id", $$v)},expression:"model.truck_type_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateTT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ttToggleAll},model:{value:(_vm.ttAllSelected),callback:function ($$v) {_vm.ttAllSelected=$$v},expression:"ttAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ttAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.trucking_company_id != null ? 'There are no registered Truck Types for the selected Trucking Company' : 'No Trucking Company selected'))])],1),_vm._v(" "),(_vm.model.located_based =='true')?_c('b-tab',{attrs:{"title":"Load Locations"}},[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"","label-for":"loadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.energy_company_id != null ? 'There are no registered Load locations for the selected Energy Company' : 'No Energy Company selected'))])],1):_vm._e(),_vm._v(" "),(_vm.model.located_based =='true')?_c('b-tab',{attrs:{"title":"Unload Locations"}},[(_vm.unloadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L7","label":"","label-for":"unloadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.unloadLocationsChange},model:{value:(_vm.model.unload_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "unload_locations_id", $$v)},expression:"model.unload_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ULToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.energy_company_id != null ? 'There are no registered Unoad locations for the selected Energy Company' : 'No Energy Company selected'))])],1):_vm._e(),_vm._v(" "),(_vm.model.fluid_based =='true')?_c('b-tab',{attrs:{"title":"Fluid Types"}},[(_vm.fluidtypeselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L8","label":"","label-for":"fluid_type","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.fluidtypeselect,"name":"Checkboxes2","plain":""},on:{"input":function($event){_vm.fluidtypesChange()}},model:{value:(_vm.model.fluid_types_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_types_id", $$v)},expression:"model.fluid_types_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateFT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.FTToggleAll},model:{value:(_vm.ftAllSelected),callback:function ($$v) {_vm.ftAllSelected=$$v},expression:"ftAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ftAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v("No fluid type registered")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newAgreements=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveAgreements}},[_vm._v("Save")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreements_pending_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2d4c0ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreements_pending_vue__ = __webpack_require__(1103);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreements_pending_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2d4c0ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreements_pending_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Hauls Without Agreements")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"services":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"action",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.create_a(row.item, row.index)}}},[_vm._v("\n                                    Create Agreement\n                                ")])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',_vm._l((row.item),function(value,key){return _c('li',{key:key},[_vm._v(_vm._s(key)+": "+_vm._s(value))])}))])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c9dc3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__ = __webpack_require__(1106);
function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00c9dc3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c9dc3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Fluid Transportation Agreement - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editAgreement}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteAgreement}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',{staticClass:"p-0"},[_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Basic Info"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L1","label":"Location Based Contract","label-for":"radio-group-1","vertical":""}},[(_vm.edit)?_c('b-form-radio-group',{attrs:{"id":"radio-group-1","options":_vm.options,"plain":""},model:{value:(_vm.model.located_based),callback:function ($$v) {_vm.$set(_vm.model, "located_based", $$v)},expression:"model.located_based"}}):_c('b-form-radio-group',{attrs:{"id":"radio-group-1","options":_vm.options,"plain":"","disabled":""},model:{value:(_vm.model.located_based),callback:function ($$v) {_vm.$set(_vm.model, "located_based", $$v)},expression:"model.located_based"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L11","label":"Fluid Type Based Contract","label-for":"radio-group-4","vertical":""}},[(_vm.edit)?_c('b-form-radio-group',{attrs:{"id":"radio-group-4","options":_vm.options,"plain":""},model:{value:(_vm.model.fluid_based),callback:function ($$v) {_vm.$set(_vm.model, "fluid_based", $$v)},expression:"model.fluid_based"}}):_c('b-form-radio-group',{attrs:{"id":"radio-group-4","options":_vm.options,"plain":"","disabled":""},model:{value:(_vm.model.fluid_based),callback:function ($$v) {_vm.$set(_vm.model, "fluid_based", $$v)},expression:"model.fluid_based"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Initial Date","label-for":"initial_date"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"id":"initial_date","type":"text","readonly":""},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}}):_c('b-form-input',{attrs:{"id":"initial_date","type":"date","readonly":!_vm.edit},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"End Date","label-for":"end_date"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"id":"end_date","type":"text","readonly":""},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}}):_c('b-form-input',{attrs:{"id":"end_date","type":"date","readonly":!_vm.edit},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin')?_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Energy Company","label-for":"energyCompanies"}},[((_vm.role =='super_admin' && _vm.edit))?_c('b-form-select',{attrs:{"value-field":"id","text-field":"company_name","id":"energyCompanies","options":_vm.energyCompanies,"disabled":!_vm.edit},on:{"input":_vm.select_energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.energy_company),callback:function ($$v) {_vm.$set(_vm.model, "energy_company", $$v)},expression:"model.energy_company"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Trucking Company","label-for":"truckingCompanies"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"truckingCompanies","options":_vm.truckingCompanies,"disabled":!_vm.edit},on:{"input":_vm.select_trucking_companies},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.trucking_company),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company", $$v)},expression:"model.trucking_company"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Regular Charge","label-for":"regular_charge"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"regular_charge","options":_vm.chargeTypes,"disabled":!_vm.edit},model:{value:(_vm.model.regular_charge_id),callback:function ($$v) {_vm.$set(_vm.model, "regular_charge_id", $$v)},expression:"model.regular_charge_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select regular charge --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.regular_charge),callback:function ($$v) {_vm.$set(_vm.model, "regular_charge", $$v)},expression:"model.regular_charge"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Regular Rate","label-for":"regular_rate"}},[(_vm.edit)?_c('b-form-input',{attrs:{"id":"regular_rate","type":"text","readonly":!_vm.edit},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'regular_rate')}},model:{value:(_vm.model.regular_rate),callback:function ($$v) {_vm.$set(_vm.model, "regular_rate", $$v)},expression:"model.regular_rate"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.regular_rate1),callback:function ($$v) {_vm.$set(_vm.model, "regular_rate1", $$v)},expression:"model.regular_rate1"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Standby Time Charge","label-for":"stb_charge"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"stb_charge","options":_vm.chargeTypes,"disabled":!_vm.edit},model:{value:(_vm.model.stb_charge_id),callback:function ($$v) {_vm.$set(_vm.model, "stb_charge_id", $$v)},expression:"model.stb_charge_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select standby time charge --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.stb_charge),callback:function ($$v) {_vm.$set(_vm.model, "stb_charge", $$v)},expression:"model.stb_charge"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Standby Time Rate","label-for":"stb_rate"}},[(_vm.edit)?_c('b-form-input',{attrs:{"id":"stb_rate","type":"text","readonly":!_vm.edit},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'stb_rate')}},model:{value:(_vm.model.stb_rate),callback:function ($$v) {_vm.$set(_vm.model, "stb_rate", $$v)},expression:"model.stb_rate"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.stb_rate1),callback:function ($$v) {_vm.$set(_vm.model, "stb_rate1", $$v)},expression:"model.stb_rate1"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Worktime Charge","label-for":"worktime_charge"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"worktime_charge","options":_vm.chargeTypes,"disabled":!_vm.edit},model:{value:(_vm.model.worktime_charge_id),callback:function ($$v) {_vm.$set(_vm.model, "worktime_charge_id", $$v)},expression:"model.worktime_charge_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select worktime charge --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.worktime_charge),callback:function ($$v) {_vm.$set(_vm.model, "worktime_charge", $$v)},expression:"model.worktime_charge"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Worktime Rate","label-for":"worktime_rate"}},[(_vm.edit)?_c('b-form-input',{attrs:{"id":"worktime_rate","type":"text","readonly":!_vm.edit},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'worktime_rate')}},model:{value:(_vm.model.worktime_rate),callback:function ($$v) {_vm.$set(_vm.model, "worktime_rate", $$v)},expression:"model.worktime_rate"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.worktime_rate1),callback:function ($$v) {_vm.$set(_vm.model, "worktime_rate1", $$v)},expression:"model.worktime_rate1"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L2","label":"Wait Time Discount?","label-for":"radio-group-2","vertical":""}},[(_vm.edit)?_c('b-form-radio-group',{attrs:{"id":"radio-group-2","options":_vm.options,"plain":""},model:{value:(_vm.model.wait_time_discount),callback:function ($$v) {_vm.$set(_vm.model, "wait_time_discount", $$v)},expression:"model.wait_time_discount"}}):_c('b-form-radio-group',{attrs:{"id":"radio-group-2","options":_vm.options,"plain":"","disabled":""},model:{value:(_vm.model.wait_time_discount),callback:function ($$v) {_vm.$set(_vm.model, "wait_time_discount", $$v)},expression:"model.wait_time_discount"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":3,"id":"L3","label":"Would you like to round to the nearest 15min? ","label-for":"radio-group-3","vertical":""}},[(_vm.edit)?_c('b-form-radio-group',{attrs:{"id":"radio-group-3","options":_vm.options,"plain":""},model:{value:(_vm.model.rounding),callback:function ($$v) {_vm.$set(_vm.model, "rounding", $$v)},expression:"model.rounding"}}):_c('b-form-radio-group',{attrs:{"id":"radio-group-3","options":_vm.options,"plain":"","disabled":""},model:{value:(_vm.model.rounding),callback:function ($$v) {_vm.$set(_vm.model, "rounding", $$v)},expression:"model.rounding"}})],1)],1),_vm._v(" "),(_vm.model.regular_charge_id != '' && _vm.model.regular_rate != '0.00')?_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Chain Up Rate","label-for":"chain_up_rate"}},[(_vm.edit)?_c('b-form-input',{attrs:{"id":"chain_up_rate","type":"text","readonly":!_vm.edit},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'chain_up_rate')}},model:{value:(_vm.model.chain_up_rate),callback:function ($$v) {_vm.$set(_vm.model, "chain_up_rate", $$v)},expression:"model.chain_up_rate"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.chain_up_rate1),callback:function ($$v) {_vm.$set(_vm.model, "chain_up_rate1", $$v)},expression:"model.chain_up_rate1"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Truck Types"}},[(_vm.edit)?_c('div',[(_vm.truckTypes.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L4","label":"","label-for":"truck_types","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.truckTypes,"name":"Checkboxes2","plain":""},on:{"input":_vm.trucktypesChange},model:{value:(_vm.model.truck_type_id),callback:function ($$v) {_vm.$set(_vm.model, "truck_type_id", $$v)},expression:"model.truck_type_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateTT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ttToggleAll},model:{value:(_vm.ttAllSelected),callback:function ($$v) {_vm.ttAllSelected=$$v},expression:"ttAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ttAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.trucking_company_id != null ? 'There are no registered Truck Types for the selected Trucking Company' : 'No Trucking Company selected'))])],1):_c('div',[(_vm.model.truck_types.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"","label-for":"truck_types","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.truck_types,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('p',[_vm._v("No Truck Types have been added")])],1)]),_vm._v(" "),(_vm.model.located_based =='true')?_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Load Location"}},[(_vm.edit)?_c('div',[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"","label-for":"load_locations","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.llToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.energy_company_id != null ? 'There are no registered Load Locations for the selected Energy Company' : 'No Energy Company selected'))])],1):_c('div',[(_vm.model.load_locations.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L7","label":"","label-for":"load_locations","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.model.load_locations,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('p',[_vm._v("No Load Locations have been added")])],1)]):_vm._e(),_vm._v(" "),(_vm.model.located_based =='true')?_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Unload Location"}},[(_vm.edit)?_c('div',[(_vm.unloadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L8","label":"","label-for":"unload_locations","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.unloadLocationsChange},model:{value:(_vm.model.unload_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "unload_locations_id", $$v)},expression:"model.unload_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ulToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v("There are no registered Unload Locations")])],1):_c('div',[(_vm.model.unload_locations.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L9","label":"","label-for":"unload_locations","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.model.unload_locations,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('p',[_vm._v("No Unload Locations have been added")])],1)]):_vm._e(),_vm._v(" "),(_vm.model.fluid_based =='true')?_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Fluid Types"}},[(_vm.edit)?_c('div',[(_vm.fluidtypeselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L10","label":"","label-for":"fluid_types","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.fluidtypeselect,"name":"Checkboxes2","plain":""},on:{"input":function($event){_vm.fluidtypesChange()}},model:{value:(_vm.model.fluid_types_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_types_id", $$v)},expression:"model.fluid_types_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateFT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ftToggleAll},model:{value:(_vm.ftAllSelected),callback:function ($$v) {_vm.ftAllSelected=$$v},expression:"ftAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ftAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v("No Fluid Types registered")])],1):_c('div',[(_vm.model.fluid_types.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L11","label":"","label-for":"fluid_types","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.fluid_types,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('p',[_vm._v("No Fluid Types have been added")])],1)]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateAgreement}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.editAgreement}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_locations_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310514fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_locations_vue__ = __webpack_require__(1108);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_locations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310514fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_locations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Locations")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Locations - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{attrs:{"id":"ddown1","text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashLocation()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashLocation()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","md":"6","xs":"12"}},[(_vm.role==='super_admin' || _vm.role==='operations_manager')?_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Add Location")]):_vm._e()],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t\t")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"items":_vm.items,"fields":_vm.fields},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newLocationModal",attrs:{"title":"New Location","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newLocations),callback:function ($$v) {_vm.newLocations=$$v},expression:"newLocations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Is this location owned, operated, and solely used by your energy company?","label-for":"CompanyTypeID","horizontal":""}},[(_vm.role ==='super_admin' || _vm.role ==='operations_manager')?_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"43px"},attrs:{"id":"checkbox"},on:{"change":function($event){_vm.clear()}},model:{value:(_vm.model.company_type),callback:function ($$v) {_vm.$set(_vm.model, "company_type", $$v)},expression:"model.company_type"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"43px"},attrs:{"id":"checkbox","disabled":""},model:{value:(_vm.model.company_type),callback:function ($$v) {_vm.$set(_vm.model, "company_type", $$v)},expression:"model.company_type"}})],1),_vm._v(" "),(_vm.role ==='super_admin' && _vm.model.company_type && _vm.energycompanyselect.length > 0 )?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Energy Company","label-for":"EnergyCompanyID","horizontal":""}},[_c('b-form-select',{attrs:{"id":"EnergyCompanyID","options":_vm.energycompanyselect},on:{"input":function($event){_vm.select_energy_company()}},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Location Type","label-for":"LocationTypeID","horizontal":""}},[(_vm.role ==='super_admin' || _vm.role ==='operations_manager')?_c('b-form-select',{attrs:{"id":"LocationTypeID","options":_vm.locationselect},on:{"input":function($event){_vm.select_location_type()}},model:{value:(_vm.model.location_types_id),callback:function ($$v) {_vm.$set(_vm.model, "location_types_id", $$v)},expression:"model.location_types_id"}}):_c('b-form-select',{attrs:{"id":"LocationTypeID","options":_vm.locationselect,"disabled":""},model:{value:(_vm.model.location_types_id),callback:function ($$v) {_vm.$set(_vm.model, "location_types_id", $$v)},expression:"model.location_types_id"}})],1),_vm._v(" "),(_vm.fluidtypeselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Fluid Type","label-for":"FluidTypeID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.fluidtypeselect,"name":"Checkboxes","plain":""},on:{"input":_vm.fluidTypeChange},model:{value:(_vm.model.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type_id", $$v)},expression:"model.fluid_type_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminate,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.fluidToggleAll},model:{value:(_vm.fluidAllSelected),callback:function ($$v) {_vm.fluidAllSelected=$$v},expression:"fluidAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.fluidAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Location Name","label-for":"locationname","horizontal":""}},[_c('b-form-input',{attrs:{"id":"locationname","type":"text"},model:{value:(_vm.model.legal_location),callback:function ($$v) {_vm.$set(_vm.model, "legal_location", $$v)},expression:"model.legal_location"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Location Isolera Name","label-for":"isolera_location_name","horizontal":""}},[_c('b-form-input',{attrs:{"id":"isolera_location_name","type":"text"},model:{value:(_vm.model.isolera_location_name),callback:function ($$v) {_vm.$set(_vm.model, "isolera_location_name", $$v)},expression:"model.isolera_location_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"LSD","label-for":"lsd","horizontal":""}},[_c('b-form-input',{attrs:{"id":"lsd","type":"text"},model:{value:(_vm.model.lsd),callback:function ($$v) {_vm.$set(_vm.model, "lsd", $$v)},expression:"model.lsd"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Latitude","label-for":"latitude","horizontal":""}},[_c('b-form-input',{attrs:{"id":"latitude","type":"number"},nativeOn:{"blur":function($event){_vm.coordsBlur('latitude')}},model:{value:(_vm.model.latitude),callback:function ($$v) {_vm.$set(_vm.model, "latitude", $$v)},expression:"model.latitude"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Longitude","label-for":"longitude","horizontal":""}},[_c('b-form-input',{attrs:{"id":"longitude","type":"number"},nativeOn:{"blur":function($event){_vm.coordsBlur('longitude')}},model:{value:(_vm.model.longitude),callback:function ($$v) {_vm.$set(_vm.model, "longitude", $$v)},expression:"model.longitude"}})],1),_vm._v(" "),(_vm.location_type_name == 'Load')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Battery Code","label-for":"battery_code","horizontal":""}},[_c('b-form-input',{attrs:{"id":"battery_code","type":"text"},model:{value:(_vm.model.battery_code),callback:function ($$v) {_vm.$set(_vm.model, "battery_code", $$v)},expression:"model.battery_code"}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Unload')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Terminal","label-for":"terminal_id","horizontal":""}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"terminal_id","type":"text","options":_vm.terminalselect},model:{value:(_vm.model.terminal_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_id", $$v)},expression:"model.terminal_id"}},[_c('template',{slot:"first"},[_c('option',{domProps:{"value":null}},[_vm._v("-- select terminal --")])])],2)],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Unload')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Terminal Code","label-for":"terminal_code","horizontal":""}},[_c('b-form-input',{attrs:{"id":"terminal_code","type":"text"},model:{value:(_vm.model.terminal_code),callback:function ($$v) {_vm.$set(_vm.model, "terminal_code", $$v)},expression:"model.terminal_code"}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Load')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Invoice Code","label-for":"invoice_code","horizontal":""}},[_c('b-form-input',{attrs:{"id":"invoice_code","type":"text"},model:{value:(_vm.model.invoice_code),callback:function ($$v) {_vm.$set(_vm.model, "invoice_code", $$v)},expression:"model.invoice_code"}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Load')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"Uwi","label-for":"uwi","horizontal":""}},[_c('b-btn',{staticClass:"pull-left",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.adduwi()}}},[_vm._v("Add Uwi")])],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Load' && _vm.model.uwi.length>0)?_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":""}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No UWI have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: 'UWI Name'}, {key: 'cost_code', label: 'Cost Code'}, {key: 'percentage', label: 'Percentage'}],"items":_vm.model.uwi,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removeuwi(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"name",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"name"},model:{value:(_vm.model.uwi[item.index].name),callback:function ($$v) {_vm.$set(_vm.model.uwi[item.index], "name", $$v)},expression:"model.uwi[item.index].name"}})]}},{key:"cost_code",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"cost_code","type":"text"},model:{value:(_vm.model.uwi[item.index].cost_code),callback:function ($$v) {_vm.$set(_vm.model.uwi[item.index], "cost_code", $$v)},expression:"model.uwi[item.index].cost_code"}})]}},{key:"percentage",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'percentage')}},model:{value:(_vm.model.uwi[item.index].percentage),callback:function ($$v) {_vm.$set(_vm.model.uwi[item.index], "percentage", $$v)},expression:"model.uwi[item.index].percentage"}})]}}])})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Load')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Contact Name","label-for":"contact_name","horizontal":""}},[_c('b-form-input',{attrs:{"id":"contact_name","type":"text"},model:{value:(_vm.model.contact_name),callback:function ($$v) {_vm.$set(_vm.model, "contact_name", $$v)},expression:"model.contact_name"}})],1):_vm._e(),_vm._v(" "),(_vm.operationareaselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Operating Areas","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.operationareaselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.operationAreaChange},model:{value:(_vm.model.operation_area_id),callback:function ($$v) {_vm.$set(_vm.model, "operation_area_id", $$v)},expression:"model.operation_area_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.OAToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.agreements.length > 0 && _vm.model.company_type)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Agreements","label-for":"agrrementsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.agreements,"name":"Checkboxes2","plain":""},on:{"input":_vm.agreeChange},model:{value:(_vm.model.agreement_id),callback:function ($$v) {_vm.$set(_vm.model, "agreement_id", $$v)},expression:"model.agreement_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateAgree,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.agreeToggleAll},model:{value:(_vm.agreeAllSelected),callback:function ($$v) {_vm.agreeAllSelected=$$v},expression:"agreeAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.agreeAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewLocationModal}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.savebtn)?_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveLocations(_vm.model)}}},[_vm._v("Save")]):_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","disabled":"","variant":"primary"}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Config Table","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"value":"id","disabled":true},on:{"change":function($event){_vm.actionField('legal_location')}}},[_vm._v("Legal Location")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"name","disabled":true},on:{"change":function($event){_vm.actionField('longitude')}}},[_vm._v("Longitude")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"status","disabled":true},on:{"change":function($event){_vm.actionField('latitude')}}},[_vm._v("Latitude")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"status","disabled":true},on:{"change":function($event){_vm.actionField('location_type')}}},[_vm._v("Location Type")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_location_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f2dd066_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_location_vue__ = __webpack_require__(1110);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f2dd066_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_location_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Location - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.role =='super_admin' || (_vm.view1 && _vm.location_type_name != 'Unload') || (_vm.role =='operations_manager' && _vm.model.energy_company_owned)),expression:"role =='super_admin' || (view1 && location_type_name != 'Unload') || (role =='operations_manager' && model.energy_company_owned)"}],staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editLocation}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteLocations}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"location-information"},[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',{attrs:{"pills":"","card":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-row',[_c('b-col',{attrs:{"md":"9"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Id","label-for":"id"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id","type":"text"},model:{value:(_vm.model.id),callback:function ($$v) {_vm.$set(_vm.model, "id", $$v)},expression:"model.id"}})],1),_vm._v(" "),(_vm.role ==='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Is this location owned, operated, and solely used by your energy company?","label-for":"CompanyTypeID","horizontal":""}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"23px"},attrs:{"id":"checkbox","disabled":""},model:{value:(_vm.model.energy_company_owned),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_owned", $$v)},expression:"model.energy_company_owned"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"23px"},attrs:{"id":"checkbox"},model:{value:(_vm.model.energy_company_owned),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_owned", $$v)},expression:"model.energy_company_owned"}})],1):_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Is this location owned, operated, and solely used by your energy company?","label-for":"CompanyTypeID","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"23px"},attrs:{"id":"checkbox","disabled":""},model:{value:(_vm.model.energy_company_owned),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_owned", $$v)},expression:"model.energy_company_owned"}})],1),_vm._v(" "),(_vm.model.energy_company_owned)?_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.role =='super_admin'),expression:"role =='super_admin'"}],attrs:{"label-cols":4,"id":"L4","label":"Energy Company","label-for":"EnergyCompanyID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"EnergyCompanyID","type":"text"},model:{value:(_vm.model.energy_company),callback:function ($$v) {_vm.$set(_vm.model, "energy_company", $$v)},expression:"model.energy_company"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"EnergyCompanyID","options":_vm.energycompanyselect},on:{"input":function($event){_vm.select_energy_company()}},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Location Type","label-for":"LocationTypeID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"LocationTypeID","type":"text"},model:{value:(_vm.model.location_type),callback:function ($$v) {_vm.$set(_vm.model, "location_type", $$v)},expression:"model.location_type"}}),_vm._v(" "),(_vm.role ==='super_admin' || _vm.role ==='operations_manager')?_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"LocationTypeID","options":_vm.locationselect,"placeholder":"Select Location Type"},on:{"input":function($event){_vm.select_location_type()}},model:{value:(_vm.model.location_types_id),callback:function ($$v) {_vm.$set(_vm.model, "location_types_id", $$v)},expression:"model.location_types_id"}}):_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"LocationTypeID","options":_vm.locationselect,"placeholder":"Select Location Type","disabled":""},model:{value:(_vm.model.location_types_id),callback:function ($$v) {_vm.$set(_vm.model, "location_types_id", $$v)},expression:"model.location_types_id"}})],1),_vm._v(" "),(_vm.fluidtypeselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Fluid Type","label-for":"FluidTypeID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.fluidtypeselect,"name":"Checkboxes","plain":""},on:{"input":_vm.fluidTypeChange},model:{value:(_vm.model.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type_id", $$v)},expression:"model.fluid_type_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminate,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.fluidToggleAll},model:{value:(_vm.fluidAllSelected),callback:function ($$v) {_vm.fluidAllSelected=$$v},expression:"fluidAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.fluidAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.model.fluid_types.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Fluid Type","label-for":"FluidTypeID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.fluid_types,"name":"Checkboxes","plain":"","checked":_vm.allChecked(),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Load')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Battery Code","label-for":"BatteryCodeID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"BatteryCodeID","type":"text"},model:{value:(_vm.model.battery_code),callback:function ($$v) {_vm.$set(_vm.model, "battery_code", $$v)},expression:"model.battery_code"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"BatteryCodeID"},model:{value:(_vm.model.battery_code),callback:function ($$v) {_vm.$set(_vm.model, "battery_code", $$v)},expression:"model.battery_code"}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Unload')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Terminal","label-for":"TerminalID","horizontal":""}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"TerminalID","options":_vm.terminalselect},model:{value:(_vm.model.terminal_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_id", $$v)},expression:"model.terminal_id"}},[_c('template',{slot:"first"},[_c('option',{domProps:{"value":null}},[_vm._v("-- select terminal --")])])],2):_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"TerminalID","type":"text","plaintext":""},model:{value:(_vm.model.terminal),callback:function ($$v) {_vm.$set(_vm.model, "terminal", $$v)},expression:"model.terminal"}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Unload')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Terminal Code","label-for":"TerminalCodeID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"TerminalCodeID","type":"text"},model:{value:(_vm.model.terminal_code),callback:function ($$v) {_vm.$set(_vm.model, "terminal_code", $$v)},expression:"model.terminal_code"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"TerminalCodeID"},model:{value:(_vm.model.terminal_code),callback:function ($$v) {_vm.$set(_vm.model, "terminal_code", $$v)},expression:"model.terminal_code"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Location Name","label-for":"locationname","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"locationname","type":"text"},model:{value:(_vm.model.legal_location),callback:function ($$v) {_vm.$set(_vm.model, "legal_location", $$v)},expression:"model.legal_location"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"locationname","type":"text"},model:{value:(_vm.model.legal_location),callback:function ($$v) {_vm.$set(_vm.model, "legal_location", $$v)},expression:"model.legal_location"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Location Isolera Name","label-for":"isolera_location_name","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"isolera_location_name","type":"text"},model:{value:(_vm.model.isolera_location_name),callback:function ($$v) {_vm.$set(_vm.model, "isolera_location_name", $$v)},expression:"model.isolera_location_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"isolera_location_name","type":"text"},model:{value:(_vm.model.isolera_location_name),callback:function ($$v) {_vm.$set(_vm.model, "isolera_location_name", $$v)},expression:"model.isolera_location_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Longitude","label-for":"longitude","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"longitude","type":"text"},model:{value:(_vm.model.longitude),callback:function ($$v) {_vm.$set(_vm.model, "longitude", $$v)},expression:"model.longitude"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"longitude","type":"number"},nativeOn:{"blur":function($event){_vm.coordsBlur('longitude')}},model:{value:(_vm.model.longitude),callback:function ($$v) {_vm.$set(_vm.model, "longitude", $$v)},expression:"model.longitude"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Latitude","label-for":"latitude","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"latitude","type":"text"},model:{value:(_vm.model.latitude),callback:function ($$v) {_vm.$set(_vm.model, "latitude", $$v)},expression:"model.latitude"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"latitude","type":"number"},nativeOn:{"blur":function($event){_vm.coordsBlur('latitude')}},model:{value:(_vm.model.latitude),callback:function ($$v) {_vm.$set(_vm.model, "latitude", $$v)},expression:"model.latitude"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"LSD","label-for":"lsd","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"lsd","type":"text"},model:{value:(_vm.model.lsd),callback:function ($$v) {_vm.$set(_vm.model, "lsd", $$v)},expression:"model.lsd"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"lsd","type":"text"},model:{value:(_vm.model.lsd),callback:function ($$v) {_vm.$set(_vm.model, "lsd", $$v)},expression:"model.lsd"}})],1),_vm._v(" "),(_vm.location_type_name =='Load')?_c('b-form-group',{attrs:{"label":"Invoice Code","label-for":"invoice_code","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"invoice_code","type":"text"},model:{value:(_vm.model.invoice_code),callback:function ($$v) {_vm.$set(_vm.model, "invoice_code", $$v)},expression:"model.invoice_code"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"invoice_code","type":"text"},model:{value:(_vm.model.invoice_code),callback:function ($$v) {_vm.$set(_vm.model, "invoice_code", $$v)},expression:"model.invoice_code"}})],1):_vm._e(),_vm._v(" "),(_vm.location_type_name == 'Load')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"Uwi","label-for":"uwi","horizontal":""}},[(_vm.location_type_name == 'Load')?_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":""}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No UWI have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: 'UWI Name'}, {key: 'cost_code', label: 'Cost Code'}, {key: 'percentage', label: 'Percentage'}],"items":_vm.model.uwi,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return _vm.edit?[_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removeuwi(item.index)}}},[_c('i',{staticClass:"icon-close"})])]:undefined}},{key:"name",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"name"},model:{value:(_vm.model.uwi[item.index].name),callback:function ($$v) {_vm.$set(_vm.model.uwi[item.index], "name", $$v)},expression:"model.uwi[item.index].name"}}):_c('span',[_vm._v(_vm._s(_vm.model.uwi[item.index].name))])]}},{key:"cost_code",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"cost_code","type":"text"},model:{value:(_vm.model.uwi[item.index].cost_code),callback:function ($$v) {_vm.$set(_vm.model.uwi[item.index], "cost_code", $$v)},expression:"model.uwi[item.index].cost_code"}}):_c('span',[_vm._v(_vm._s(_vm.model.uwi[item.index].cost_code))])]}},{key:"percentage",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'percentage')}},model:{value:(_vm.model.uwi[item.index].percentage),callback:function ($$v) {_vm.$set(_vm.model.uwi[item.index], "percentage", $$v)},expression:"model.uwi[item.index].percentage"}}):_c('span',[_vm._v(_vm._s(_vm.model.uwi[item.index].percentage))])]}}])}),_vm._v(" "),(_vm.edit)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.adduwi()}}},[_vm._v("Add Uwi")])],1)],1):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.location_type_name =='Load')?_c('b-form-group',{attrs:{"label":"Contact Name","label-for":"contact_name","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"contact_name","type":"text"},model:{value:(_vm.model.contact_name),callback:function ($$v) {_vm.$set(_vm.model, "contact_name", $$v)},expression:"model.contact_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"invoice_code","type":"text"},model:{value:(_vm.model.contact_name),callback:function ($$v) {_vm.$set(_vm.model, "contact_name", $$v)},expression:"model.contact_name"}})],1):_vm._e(),_vm._v(" "),(_vm.operationareaselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Operating Areas","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.operationareaselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.operationAreaChange},model:{value:(_vm.model.operation_area_id),callback:function ($$v) {_vm.$set(_vm.model, "operation_area_id", $$v)},expression:"model.operation_area_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.OAToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.model.operating_areas.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Operating Areas","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.operating_areas,"name":"Checkboxes2","plain":"","checked":_vm.allCheckedOA(),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.agreements.length > 0 && _vm.edit && _vm.model.energy_company_owned)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Agreements","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.agreements,"name":"Checkboxes2","plain":""},on:{"input":_vm.agreeChange},model:{value:(_vm.model.agreement_id),callback:function ($$v) {_vm.$set(_vm.model, "agreement_id", $$v)},expression:"model.agreement_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateAgree,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.agreeToggleAll},model:{value:(_vm.agreeAllSelected),callback:function ($$v) {_vm.agreeAllSelected=$$v},expression:"agreeAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.agreeAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.model.agreements.length > 0 && !_vm.edit && _vm.model.energy_company_owned)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"Agreements","label-for":"agreeID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.agreements,"name":"Checkboxes2","plain":"","checked":_vm.allCheckedAgree(),"disabled":""}})],1):_vm._e(),_vm._v(" "),_c('div',[(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Petrotranz Location","label-for":"ptty"}},[(_vm.model.petrotranz!=null)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ptty","type":"text"},model:{value:(_vm.model.petrotranz.name),callback:function ($$v) {_vm.$set(_vm.model.petrotranz, "name", $$v)},expression:"model.petrotranz.name"}}):_vm._e()],1):_c('b-form-group',{attrs:{"label-cols":3,"horizontal":"","label":"Petrotranz Location","label-for":"ptty1"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"autocomplete":"off","id":"ptty1","placeholder":"Search Filtered starting by ... (minimum 3 char)","type":"text"},nativeOn:{"keydown":function($event){_vm.keyMonitor($event)}},model:{value:(_vm.filtered),callback:function ($$v) {_vm.filtered=$$v},expression:"filtered"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.suggest),expression:"suggest"}],attrs:{"select-size":_vm.size,"disabled":_vm.petrotranz.length==0,"value-field":"id","text-field":"name","id":"ptty1","options":_vm.petrotranz},on:{"input":function($event){_vm.select_petrotranz()}},model:{value:(_vm.model1.petrotranz_company_id),callback:function ($$v) {_vm.$set(_vm.model1, "petrotranz_company_id", $$v)},expression:"model1.petrotranz_company_id"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"})])],1)],1),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.updateLocation(_vm.model)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editLocation}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49230e14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_vue__ = __webpack_require__(1113);
function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49230e14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Users")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Users - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"lg":"3","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashUser()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashUser()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),(_vm.role ==='super_admin' || _vm.role ==='analyst' || _vm.role =='marketing_accountant')?_c('b-col',{staticClass:"my-1",attrs:{"lg":"3","title":"Trucking Companies"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewUserModal}},[_vm._v("Add User")])],1)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t\t")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fieldsTh,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newUser",attrs:{"title":"New User","size":"lg","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newUser),callback:function ($$v) {_vm.newUser=$$v},expression:"newUser"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(this.role === 'super_analyst')?_c('p',[_vm._v("You can only create user as Analyst, they will have the same privileges as you except that they can not create, delete nor update other users of type Analyst.")]):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":"First Name","label-for":"FirstName","label-cols":3,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keydown":function($event){_vm.isLetter($event)}},model:{value:(_vm.first_name),callback:function ($$v) {_vm.first_name=$$v},expression:"first_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name","label-for":"LastName","label-cols":3,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keydown":function($event){_vm.isLetter($event)}},model:{value:(_vm.last_name),callback:function ($$v) {_vm.last_name=$$v},expression:"last_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"Email","label-cols":3,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),(_vm.role === 'super_admin' || _vm.role === 'operations_manager' || _vm.role === 'trucking_company_admin' || _vm.role === 'trucking_company_admin_light' || _vm.role === 'trucking_operational_manager')?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"User Role","label-for":"RoleID","horizontal":""}},[_c('b-form-select',{attrs:{"text-field":"name","value-field":"id","id":"RoleID","options":_vm.userrolesselect},on:{"input":function($event){_vm.select_user_role()}},model:{value:(_vm.user_role_id),callback:function ($$v) {_vm.user_role_id=$$v},expression:"user_role_id"}})],1):_vm._e(),_vm._v(" "),(_vm.showPhone)?_c('b-form-group',{attrs:{"label":"Phone Number","label-for":"Phone Number","label-cols":3,"horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],staticClass:"form-control",model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras)?_c('b-form-group',{attrs:{"label":"Terminal Boss ID","label-for":"terminal_boss_user_id","label-cols":3,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.terminal_boss_user_id),callback:function ($$v) {_vm.terminal_boss_user_id=$$v},expression:"terminal_boss_user_id"}})],1):_vm._e(),_vm._v(" "),(_vm.showTC)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Trucking Company","label-for":"tcID","horizontal":""}},[_c('b-form-select',{attrs:{"text-field":"name","value-field":"id","id":"tcID","options":_vm.truckingcompanyselect},on:{"input":function($event){_vm.select_trucking_company()}},model:{value:(_vm.trucking_company_id),callback:function ($$v) {_vm.trucking_company_id=$$v},expression:"trucking_company_id"}})],1):_vm._e(),_vm._v(" "),(_vm.energycompanyselect.length > 0 && _vm.showEC)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Energy Companies","label-for":"ECID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.energycompanyselect,"name":"radioSubComponent","plain":""},on:{"input":function($event){_vm.select_energy_company()}},model:{value:(_vm.energy_company_id),callback:function ($$v) {_vm.energy_company_id=$$v},expression:"energy_company_id"}})],1):_vm._e(),_vm._v(" "),(_vm.operatingareasselect.length > 0 && _vm.showExtras)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Operating Areas","label-for":"OAID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.operatingareasselect,"name":"Checkboxes","plain":""},on:{"input":_vm.operatingAreaChange},model:{value:(_vm.operating_areas_id),callback:function ($$v) {_vm.operating_areas_id=$$v},expression:"operating_areas_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.oaToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.loadlocationsselect.length > 0 && _vm.showExtras)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Assigned Load Locations","label-for":"LLID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.loadlocationsselect,"name":"Checkboxes","plain":"","disabled":""},model:{value:(_vm.load_locations_id),callback:function ($$v) {_vm.load_locations_id=$$v},expression:"load_locations_id"}})],1):_vm._e(),_vm._v(" "),(_vm.unloadlocationsselect.length > 0 && _vm.showExtras)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Assigned Unload Locations","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.unloadlocationsselect,"name":"Checkboxes","plain":"","disabled":""},model:{value:(_vm.unload_locations_id),callback:function ($$v) {_vm.unload_locations_id=$$v},expression:"unload_locations_id"}})],1):_vm._e(),_vm._v(" "),(_vm.role !== 'operations_manager' && (_vm.current_user_role_name === 'analyst'|| this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant'))?_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"All Operating Areas Access?","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox"},model:{value:(_vm.operating_areas_access),callback:function ($$v) {_vm.operating_areas_access=$$v},expression:"operating_areas_access"}})],1):_vm._e(),_vm._v(" "),(_vm.role !== 'operations_manager' && (_vm.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') && !_vm.operating_areas_access)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Operating Areas","label-for":"OAID","horizontal":""}},[(_vm.operatingareasselect.length > 0)?_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.operatingareasselect,"name":"Checkboxes","plain":""},on:{"input":_vm.operatingAreaChange},model:{value:(_vm.operating_areas_id),callback:function ($$v) {_vm.operating_areas_id=$$v},expression:"operating_areas_id"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.favorites_load.length > 0 && _vm.showExtras)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Favorite Load Locations","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.favorites_load,"name":"Checkboxes","plain":""},on:{"input":_vm.llChange},model:{value:(_vm.favorites_load_id),callback:function ($$v) {_vm.favorites_load_id=$$v},expression:"favorites_load_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.llToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.favorites_unload.length > 0 && _vm.showExtras)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Favorite Unload Locations","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.favorites_unload,"name":"Checkboxes","plain":""},on:{"input":_vm.ulChange},model:{value:(_vm.favorites_unload_id),callback:function ($$v) {_vm.favorites_unload_id=$$v},expression:"favorites_unload_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ulToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newUser=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveUser}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Config Table","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"value":"id","disabled":true},on:{"change":function($event){_vm.actionField('id')}}},[_vm._v("User ID")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"first_name"},on:{"change":function($event){_vm.actionField('first_name')}}},[_vm._v("First Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"last_name"},on:{"change":function($event){_vm.actionField('last_name')}}},[_vm._v("Last Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"username","disabled":true},on:{"change":function($event){_vm.actionField('username')}}},[_vm._v("Username")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"email"},on:{"change":function($event){_vm.actionField('email')}}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"role"},on:{"change":function($event){_vm.actionField('role')}}},[_vm._v("Role")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"status"},on:{"change":function($event){_vm.actionField('status')}}},[_vm._v("Status")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0282ea27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_vue__ = __webpack_require__(1116);
function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0282ea27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("User - "+_vm._s(this.subTitle))])]),_vm._v(" "),(_vm.role !== 'operations_manager')?_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right ml-1",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editUser}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteUser}},[_vm._v("Delete")])],2),_vm._v(" "),(_vm.role !='analyst')?_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"},on:{"click":function($event){_vm.resend()}}},[_c('i',{staticClass:"fa fa-send"})]):_vm._e()],1):_c('b-col',{attrs:{"lg":"6"}},[(_vm.current_user_role_name === 'analyst' || _vm.current_user_role_name === 'super_analyst' || _vm.current_user_role_name === 'marketing_accountant')?_c('b-container',[_c('b-dropdown',{staticClass:"pull-right ml-1",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editUser}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteUser}},[_vm._v("Delete")])],2)],1):_vm._e(),_vm._v(" "),(_vm.role !='analyst' || _vm.role != 'marketing_accountant')?_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"},on:{"click":function($event){_vm.resend()}}},[_c('i',{staticClass:"fa fa-send"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[((_vm.user_role_id == 2 && _vm.loggued_user_rol == 1) || (_vm.user_role_id == 2 && _vm.loggued_user_rol == 4) || (_vm.user_role_id == 2 && _vm.loggued_user_rol == 6) || (_vm.user_role_id == 2 && _vm.loggued_user_rol == 8))?_c('b-tabs',{attrs:{"pills":"","card":""}},[_c('b-tab',{attrs:{"title":"User Details","active":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Id","label-for":"id"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id","type":"text"},model:{value:(_vm.user_id),callback:function ($$v) {_vm.user_id=$$v},expression:"user_id"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"ghg":"","label-cols":4,"id":"L4","label":"User Role:","label-for":"RoleID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.user_role),callback:function ($$v) {_vm.user_role=$$v},expression:"user_role"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit & _vm.userrolesselect.length>0),expression:"edit & userrolesselect.length>0"}],attrs:{"text-field":"name","value-field":"id","id":"RoleID","options":_vm.userrolesselect},on:{"input":function($event){_vm.select_user_role()}},model:{value:(_vm.user_role_id),callback:function ($$v) {_vm.user_role_id=$$v},expression:"user_role_id"}})],1),_vm._v(" "),(_vm.showTC)?_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"id":"L4","label":"Trucking Company:","label-for":"tcID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"tcID","type":"text"},model:{value:(_vm.trucking_company_name),callback:function ($$v) {_vm.trucking_company_name=$$v},expression:"trucking_company_name"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit & _vm.truckingcompanyselect.length>0),expression:"edit & truckingcompanyselect.length>0"}],attrs:{"text-field":"name","value-field":"id","id":"tcID","options":_vm.truckingcompanyselect},on:{"input":function($event){_vm.select_trucking_company()}},model:{value:(_vm.trucking_company_id),callback:function ($$v) {_vm.trucking_company_id=$$v},expression:"trucking_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Username:","label-for":"Username","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keypress":function($event){_vm.isLowerCaseUsername($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"First Name:","label-for":"FirstName","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.first_name),callback:function ($$v) {_vm.first_name=$$v},expression:"first_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keydown":function($event){_vm.isLetter($event)}},model:{value:(_vm.first_name),callback:function ($$v) {_vm.first_name=$$v},expression:"first_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name:","label-for":"LastName","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.last_name),callback:function ($$v) {_vm.last_name=$$v},expression:"last_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keydown":function($event){_vm.isLetter($event)}},model:{value:(_vm.last_name),callback:function ($$v) {_vm.last_name=$$v},expression:"last_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email:","label-for":"Email","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),(_vm.showExtras)?_c('b-form-group',{attrs:{"label":"Phone:","label-for":"phone","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],staticClass:"form-control",model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras)?_c('b-form-group',{attrs:{"label":"Terminal Boss ID:","label-for":"TerminalBoss","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.terminal_boss_user_id),callback:function ($$v) {_vm.terminal_boss_user_id=$$v},expression:"terminal_boss_user_id"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"autocomplete":"off","type":"text"},model:{value:(_vm.terminal_boss_user_id),callback:function ($$v) {_vm.terminal_boss_user_id=$$v},expression:"terminal_boss_user_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"label":"New Password:","label-for":"nPassword","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"id":"nPassword","autocomplete":"new-password","type":"password"},model:{value:(_vm.new_password),callback:function ($$v) {_vm.new_password=$$v},expression:"new_password"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"label":"Confirm new Password:","label-for":"cnPassword","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"id":"cnPassword","autocomplete":"new-password","type":"password"},model:{value:(_vm.confirm_new_password),callback:function ($$v) {_vm.confirm_new_password=$$v},expression:"confirm_new_password"}})],1),_vm._v(" "),(_vm.energycompanyselect.length > 0 && _vm.showEC && _vm.edit)?_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"id":"L4","label":"Energy Companies:","label-for":"ECID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.energycompanyselect,"name":"radioSubComponent","plain":""},model:{value:(_vm.energy_company_id),callback:function ($$v) {_vm.energy_company_id=$$v},expression:"energy_company_id"}})],1):_vm._e(),_vm._v(" "),(_vm.operatingareasselect.length > 0 && _vm.showExtras && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Operating Areas:","label-for":"OAID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.operatingareasselect,"name":"Checkboxes7","plain":""},on:{"input":_vm.operatingAreaChange},model:{value:(_vm.operating_areas_id),callback:function ($$v) {_vm.operating_areas_id=$$v},expression:"operating_areas_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.oaToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.loadlocationsselect.length > 0 && _vm.showExtras && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Load Locations:","label-for":"LLID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"plain":"","disabled":"","text-field":"name","value-field":"id","options":_vm.loadlocationsselect,"name":"Checkboxes6"},model:{value:(_vm.load_locations_id),callback:function ($$v) {_vm.load_locations_id=$$v},expression:"load_locations_id"}})],1):_vm._e(),_vm._v(" "),(_vm.unloadlocationsselect.length > 0 && _vm.showExtras && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Unload Locations:","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"plain":"","disabled":"","id":"ULID","text-field":"name","value-field":"id","options":_vm.unloadlocationsselect,"name":"Checkboxes5"},model:{value:(_vm.unload_locations_id),callback:function ($$v) {_vm.unload_locations_id=$$v},expression:"unload_locations_id"}})],1):_vm._e(),_vm._v(" "),(_vm.favorites_load_select.length > 0 && _vm.showExtras && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L20","label":"Favorite Load Locations:","label-for":"fav2","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"plain":"","id":"fav2","text-field":"name","value-field":"id","options":_vm.favorites_load_select,"name":"Checkboxes6"},on:{"input":_vm.llChange},model:{value:(_vm.favorites_load_id),callback:function ($$v) {_vm.favorites_load_id=$$v},expression:"favorites_load_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.llToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.favorites_unload_select.length > 0 && _vm.showExtras && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L21","label":"Favorite Unload Locations:","label-for":"fav3","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"plain":"","id":"fav3","text-field":"name","value-field":"id","options":_vm.favorites_unload_select,"name":"Checkboxes5"},on:{"input":_vm.ulChange},model:{value:(_vm.favorites_unload_id),callback:function ($$v) {_vm.favorites_unload_id=$$v},expression:"favorites_unload_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ulToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.showEC && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Energy Companies:","label-for":"ECID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":[_vm.energy_company_name],"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.energy_company_name),callback:function ($$v) {_vm.energy_company_name=$$v},expression:"energy_company_name"}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"Operating Areas:","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.operating_areas,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('operating_areas'),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Load Locations:","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.load_locations,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('load_locations'),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Unload Locations:","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.unload_locations,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('unload_locations'),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Favorite Load Locations","label-for":"fav0","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.favorites_load,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('favorites_load'),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","label":"Favorite Unload Locations","label-for":"fav1","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.favorites_unload,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('favorites_unload'),"disabled":""}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Updated at","label-for":"updated_at","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"updated_at","type":"text"},model:{value:(_vm.updated_at),callback:function ($$v) {_vm.updated_at=$$v},expression:"updated_at"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateUser}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editUser}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Documents"}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"12","lg":"12"}},[_c('b-button',{staticClass:"pull-right",attrs:{"disabled":_vm.loadingData,"variant":"primary"},on:{"click":function($event){ _vm.newDocuments = true}}},[_vm._v("Add New Document")])],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"12","md":"12"}},[(_vm.emptyFiles)?_c('p',{staticClass:"text-danger"},[_c('center',[_vm._v(" Not File found for this user")])],1):_c('b-table',{staticClass:"animated fadeIn",staticStyle:{"width":"100% !important"},attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.itemsFiles,"fields":_vm.fieldsFile},on:{"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"visor",fn:function(row){return [_c('img',{staticStyle:{"width":"40px","height":"40px"},attrs:{"src":row.item.file,"alt":""}})]}},{key:"actions",fn:function(row){return [_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){$event.stopPropagation();_vm.deleteDocument(row.item)}}},[_c('i',{staticClass:"fa fa-trash"})])]}}])})],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-container',[_c('b-form-group',{attrs:{"label":"First Name","label-for":"FirstName","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.first_name),callback:function ($$v) {_vm.first_name=$$v},expression:"first_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keydown":function($event){_vm.isLetter($event)}},model:{value:(_vm.first_name),callback:function ($$v) {_vm.first_name=$$v},expression:"first_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name","label-for":"LastName","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.last_name),callback:function ($$v) {_vm.last_name=$$v},expression:"last_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keydown":function($event){_vm.isLetter($event)}},model:{value:(_vm.last_name),callback:function ($$v) {_vm.last_name=$$v},expression:"last_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Username","label-for":"Username","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"text"},nativeOn:{"keypress":function($event){_vm.isLowerCaseUsername($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"Email","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),(_vm.showExtras)?_c('b-form-group',{attrs:{"label":"phone","label-for":"phone","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"},{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],staticClass:"form-control",model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.role =='super_admin' || _vm.role =='operations_manager'),expression:"role =='super_admin' || role =='operations_manager'"}],attrs:{"label-cols":4,"id":"L4","label":"User Role","label-for":"RoleID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"RoleID","type":"text"},model:{value:(_vm.user_role),callback:function ($$v) {_vm.user_role=$$v},expression:"user_role"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"text-field":"name","value-field":"id","id":"RoleID","options":_vm.userrolesselect},on:{"input":function($event){_vm.select_user_role()}},model:{value:(_vm.user_role_id),callback:function ($$v) {_vm.user_role_id=$$v},expression:"user_role_id"}})],1),_vm._v(" "),(_vm.showTC)?_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.role =='super_admin' || _vm.role =='operations_manager'),expression:"role =='super_admin' || role =='operations_manager'"}],attrs:{"label-cols":4,"id":"L42","label":"Trucking Company","label-for":"tcID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"tcID","type":"text"},model:{value:(_vm.trucking_company_name),callback:function ($$v) {_vm.trucking_company_name=$$v},expression:"trucking_company_name"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"text-field":"name","value-field":"id","id":"tcID","options":_vm.truckingcompanyselect},on:{"input":function($event){_vm.select_trucking_company()}},model:{value:(_vm.trucking_company_id),callback:function ($$v) {_vm.trucking_company_id=$$v},expression:"trucking_company_id"}})],1):_vm._e(),_vm._v(" "),(_vm.energycompanyselect.length > 0 && _vm.showEC && _vm.edit)?_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"id":"L43","label":"Energy Companies","label-for":"ECID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.energycompanyselect,"name":"radioSubComponent","plain":""},on:{"input":function($event){_vm.select_energy_company()}},model:{value:(_vm.energy_company_id),callback:function ($$v) {_vm.energy_company_id=$$v},expression:"energy_company_id"}})],1):_vm._e(),_vm._v(" "),(_vm.operatingareasselect.length > 0 && _vm.showExtras && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Operating Areas","label-for":"OAID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.operatingareasselect,"name":"Checkboxes","plain":""},on:{"input":_vm.operatingAreaChange},model:{value:(_vm.operating_areas_id),callback:function ($$v) {_vm.operating_areas_id=$$v},expression:"operating_areas_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateOA,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.oaToggleAll},model:{value:(_vm.oaAllSelected),callback:function ($$v) {_vm.oaAllSelected=$$v},expression:"oaAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.oaAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.showEC && !_vm.edit)?_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"id":"L8","label":"Energy Companies","label-for":"ECID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":[_vm.energy_company_name],"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.energy_company_name),callback:function ($$v) {_vm.energy_company_name=$$v},expression:"energy_company_name"}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Operating Areas","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.operating_areas,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('operating_areas'),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Load Locations","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.load_locations,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('load_locations'),"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.showExtras && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Unload Locations","label-for":"operationAreasID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.unload_locations,"name":"Checkboxes2","plain":"","checked":_vm.allChecked('unload_locations'),"disabled":""}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"label":"New Password","label-for":"nPassword","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"id":"nPassword","autocomplete":"new-password","type":"password"},model:{value:(_vm.new_password),callback:function ($$v) {_vm.new_password=$$v},expression:"new_password"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"label":"Confirm new Password","label-for":"cnPassword","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"id":"cnPassword","autocomplete":"new-password","type":"password"},model:{value:(_vm.confirm_new_password),callback:function ($$v) {_vm.confirm_new_password=$$v},expression:"confirm_new_password"}})],1)],1),_vm._v(" "),(_vm.current_user_role_name === 'analyst' || _vm.current_user_role_name === 'super_analyst' || _vm.current_user_role_name === 'marketing_accountant')?_c('b-container',[(!_vm.edit)?_c('b-row',[(!_vm.operating_areas_access)?_c('b-col',[(_vm.operating_areas.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Operating Areas","label-for":"OAID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","value-field":"id","options":_vm.operating_areas,"name":"Checkboxes","plain":"","disabled":""},model:{value:(_vm.operating_areas_id),callback:function ($$v) {_vm.operating_areas_id=$$v},expression:"operating_areas_id"}})],1):_vm._e()],1):_c('b-col',[_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"All Operating Areas Access","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox","disabled":""},model:{value:(_vm.operating_areas_access),callback:function ($$v) {_vm.operating_areas_access=$$v},expression:"operating_areas_access"}})],1)],1)],1):_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"All Operating Areas Access?","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox"},model:{value:(_vm.operating_areas_access),callback:function ($$v) {_vm.operating_areas_access=$$v},expression:"operating_areas_access"}})],1),_vm._v(" "),(_vm.operatingareasselect.length > 0 && !_vm.operating_areas_access)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Any Operating Areas?","label-for":"OAID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"text-field":"name","value-field":"id","options":_vm.operatingareasselect,"name":"Checkboxes","plain":""},on:{"input":_vm.operatingAreaChange1},model:{value:(_vm.operating_areas_id),callback:function ($$v) {_vm.operating_areas_id=$$v},expression:"operating_areas_id"}})],1):_vm._e()],1)],1),_vm._v(" "),(!_vm.edit)?_c('b-row',[(_vm.energy_company_name==='Serafina Energy')?_c('b-col',[_c('b-form-group',{attrs:{"label-cols":4,"id":"L18","label":"Manage Intraday","label-for":"checkbox1","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox1","disabled":""},model:{value:(_vm.manage_intraday),callback:function ($$v) {_vm.manage_intraday=$$v},expression:"manage_intraday"}})],1)],1):_vm._e()],1):_c('b-row',[(_vm.energy_company_name==='Serafina Energy')?_c('b-col',[_c('b-form-group',{attrs:{"label-cols":4,"id":"L18","label":"Manage Intraday","label-for":"checkbox1","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"checkbox1"},model:{value:(_vm.manage_intraday),callback:function ($$v) {_vm.manage_intraday=$$v},expression:"manage_intraday"}})],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateUser}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editUser}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v("Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"newDocuments",attrs:{"title":"New Document","size":"lg","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},on:{"hide":_vm.resetModal},model:{value:(_vm.newDocuments),callback:function ($$v) {_vm.newDocuments=$$v},expression:"newDocuments"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Tittle","label-for":"filetitle"}},[_c('b-form-input',{attrs:{"id":"","type":"text"},model:{value:(_vm.filetitle),callback:function ($$v) {_vm.filetitle=$$v},expression:"filetitle"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Select File","label-for":"filename"}},[_c('b-form-file',{staticClass:"mt-3",attrs:{"accept":"image/png, image/jpeg, image/jpg, application/pdf","placeholder":"Select File","plain":""},model:{value:(_vm.documents),callback:function ($$v) {_vm.documents=$$v},expression:"documents"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newDocuments = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.saveDocuments}},[_vm._v("Upload")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userDocument_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b9d412a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userDocument_vue__ = __webpack_require__(1118);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b9d412a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("User - "+_vm._s(this.user)+" | Document: "+_vm._s(this.fileTitle))])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                 \t")])])],1):_c('div',[(_vm.found)?_c('b-row',[(_vm.isImage)?_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('img',{attrs:{"src":this.file,"alt":this.fileName}})]):_vm._e(),_vm._v(" "),(_vm.isApplication)?_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('embed',{attrs:{"src":this.file,"width":"100%","height":"800px"}})]):_vm._e()],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t                 \t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_targets_vue__ = __webpack_require__(533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f7637c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_targets_vue__ = __webpack_require__(1120);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_targets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f7637c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_targets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Nominations")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Nominations - Trash")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"},on:{"click":function($event){_vm.configTable = true}}},[_c('i',{staticClass:"fa fa-cog"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","targets":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{attrs:{"id":"ddown1","text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTarget()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTarget()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.newTargetModal()}}},[_vm._v("Add Nomination")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                       ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"actions",fn:function(row){return [_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.newTargetModal(row)}}},[_vm._v("\n\t\t\t\t\t\t\t\tClone\n\t\t\t\t\t\t\t")])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Nomination","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newTargets),callback:function ($$v) {_vm.newTargets=$$v},expression:"newTargets"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"target0"}},[_c('b-form-select',{attrs:{"id":"target0","options":_vm.energycompanies},on:{"input":_vm.select_energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1),_vm._v(" "),(_vm.fluids.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Fluid Types","label-for":"Grouptarget2","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.fluids,"name":"Checkboxes2","plain":""},on:{"input":_vm.FTChange},model:{value:(_vm.model.fluid_type_ids),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type_ids", $$v)},expression:"model.fluid_type_ids"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateFT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.FTToggleAll},model:{value:(_vm.ftAllSelected),callback:function ($$v) {_vm.ftAllSelected=$$v},expression:"ftAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.ftAllSelected ? 'Un-select All' : 'Select All')+"\n              ")])],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload Location","label-for":"Grouptarget1"}},[_c('b-form-select',{attrs:{"disabled":_vm.locations.length == 0,"id":"Grouptarget1","options":_vm.locations},model:{value:(_vm.model.location_id),callback:function ($$v) {_vm.$set(_vm.model, "location_id", $$v)},expression:"model.location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Initial Date","label-for":"initial_date"}},[_c('b-form-input',{attrs:{"id":"initial_date","type":"date"},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Date","label-for":"end_date"}},[_c('b-form-input',{attrs:{"id":"end_date","type":"date"},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume","label-for":"target5"}},[_c('b-form-input',{attrs:{"placeholder":"0.00","id":"target5"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume')},"blur":function($event){_vm.inputBlur('volume')}},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTargets=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveTargets()}}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Config Table","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"value":"energy_company_name","disabled":true},on:{"change":function($event){_vm.actionField('energy_company_name')}}},[_vm._v("Energy Company Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"location_name","disabled":true},on:{"change":function($event){_vm.actionField('location_name')}}},[_vm._v("Location Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"fluid_type_name","disabled":true},on:{"change":function($event){_vm.actionField('fluid_type_name')}}},[_vm._v("Fluid Type Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"initial_date","disabled":true},on:{"change":function($event){_vm.actionField('initial_date')}}},[_vm._v("Initial Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"end_date","disabled":true},on:{"change":function($event){_vm.actionField('end_date')}}},[_vm._v("End Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"volume","disabled":true},on:{"change":function($event){_vm.actionField('volume')}}},[_vm._v("Volume")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_target_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f799c40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_target_vue__ = __webpack_require__(1122);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_target_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f799c40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_target_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Nomination - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.edittarget}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTargets}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t")])])],1):_c('b-card',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Id","label-for":"id"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id","type":"text"},model:{value:(_vm.model.id),callback:function ($$v) {_vm.$set(_vm.model, "id", $$v)},expression:"model.id"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"target0"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"target0","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"target0","options":_vm.energycompanies},on:{"input":_vm.select_energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1),_vm._v(" "),(_vm.model.fluid_types.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Fluid Types","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.fluid_types,"name":"Checkboxes22","checked":true,"plain":"","disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.fluids.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Fluid Types","label-for":"Grouptarget2","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.fluids,"name":"Checkboxes2","plain":""},on:{"input":_vm.FTChange},model:{value:(_vm.model.fluid_type_ids),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type_ids", $$v)},expression:"model.fluid_type_ids"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateFT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.FTToggleAll},model:{value:(_vm.ftAllSelected),callback:function ($$v) {_vm.ftAllSelected=$$v},expression:"ftAllSelected"}},[_vm._v("\n                "+_vm._s(_vm.ftAllSelected ? 'Un-select All' : 'Select All')+"\n              ")])],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload Location","label-for":"Grouptarget1"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"Grouptarget1","type":"text"},model:{value:(_vm.model.location_name),callback:function ($$v) {_vm.$set(_vm.model, "location_name", $$v)},expression:"model.location_name"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"disabled":_vm.locations.length == 0,"id":"Grouptarget1","options":_vm.locations},model:{value:(_vm.model.location_id),callback:function ($$v) {_vm.$set(_vm.model, "location_id", $$v)},expression:"model.location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Initial Date","label-for":"initial_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"initial_date","type":"text"},model:{value:(_vm.initial_date),callback:function ($$v) {_vm.initial_date=$$v},expression:"initial_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"initial_date","type":"date"},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Date","label-for":"end_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"end_date","type":"text"},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"id":"end_date","type":"date"},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume","label-for":"target5"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"target5","type":"text"},model:{value:(_vm.model.formatVolume),callback:function ($$v) {_vm.$set(_vm.model, "formatVolume", $$v)},expression:"model.formatVolume"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"placeholder":"0.00","id":"target5"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume')},"blur":function($event){_vm.inputBlur('volume')}},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}})],1),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTarget}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.edittarget}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_truck_types_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_512cdc33_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_truck_types_vue__ = __webpack_require__(1124);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_truck_types_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_512cdc33_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_truck_types_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Truck Types")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newTruckTypeModal}},[_vm._v("Add Truck Type")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n              ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Truck Types","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newTruckTypes),callback:function ($$v) {_vm.newTruckTypes=$$v},expression:"newTruckTypes"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Truck Type","label-for":"TruckTypeName","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.TruckTypesName),callback:function ($$v) {_vm.TruckTypesName=$$v},expression:"TruckTypesName"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTruckTypes=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveTruckTypes}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_truck_type_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c38a8ff_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_truck_type_vue__ = __webpack_require__(1126);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_truck_type_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c38a8ff_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_truck_type_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Truck type - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTT}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTT}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Truck Type","label-for":"ttID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ttID","type":"text"},model:{value:(_vm.truckTypeName),callback:function ($$v) {_vm.truckTypeName=$$v},expression:"truckTypeName"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.truckTypeName),callback:function ($$v) {_vm.truckTypeName=$$v},expression:"truckTypeName"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTT}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTT}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_fluid_types_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f32fea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_fluid_types_vue__ = __webpack_require__(1128);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_fluid_types_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f32fea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_fluid_types_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Fluid Types")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newFluidTypeModal}},[_vm._v("Add Fluid Type")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n              ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Fluid Types","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newFluidTypes),callback:function ($$v) {_vm.newFluidTypes=$$v},expression:"newFluidTypes"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Fluid Type Name","label-for":"FluidTypeName","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.FluidTypesName),callback:function ($$v) {_vm.FluidTypesName=$$v},expression:"FluidTypesName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Isolera Fluid Type Name","label-for":"isolera_fluid_type_name","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.isolera_fluid_type_name),callback:function ($$v) {_vm.isolera_fluid_type_name=$$v},expression:"isolera_fluid_type_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Fluid Type Color","label-for":"FluidTypeColor","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"color"},model:{value:(_vm.FluidTypesColor),callback:function ($$v) {_vm.FluidTypesColor=$$v},expression:"FluidTypesColor"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newFluidTypes=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveFluidTypes}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_fluid_type_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1dcda2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_fluid_type_vue__ = __webpack_require__(1130);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_fluid_type_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1dcda2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_fluid_type_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Fluid type - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editFT}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteFT}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Fluid Type Name","label-for":"ftID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ftID","type":"text"},model:{value:(_vm.fluidTypeName),callback:function ($$v) {_vm.fluidTypeName=$$v},expression:"fluidTypeName"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.fluidTypeName),callback:function ($$v) {_vm.fluidTypeName=$$v},expression:"fluidTypeName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Isolera Fluid Type Name","label-for":"ftID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ftID","type":"text"},model:{value:(_vm.isolera_fluid_type_name),callback:function ($$v) {_vm.isolera_fluid_type_name=$$v},expression:"isolera_fluid_type_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.isolera_fluid_type_name),callback:function ($$v) {_vm.isolera_fluid_type_name=$$v},expression:"isolera_fluid_type_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Fluid Type Color","label-for":"color","horizontal":""}},[_c('b-form-input',{attrs:{"id":"color","disabled":!_vm.edit,"type":"color"},model:{value:(_vm.fluidTypeColor),callback:function ($$v) {_vm.fluidTypeColor=$$v},expression:"fluidTypeColor"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateFT}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editFT}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e83aef6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(1134);
function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e83aef6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e83aef6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/config/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				if (response.data.status === 'success') {
					data = response.data;
					resolve(data);
				} else {
					data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	putConfig: function putConfig(notifications) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/user/config/', { 'notifications': notifications }, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			}).then(function (response) {
				var data = '';
				console.log(response.data);
				data = response.data;
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Notifications")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',[_c('b-form-checkbox',{staticClass:"pull-right",attrs:{"id":"checkbox","checked":_vm.notifications},on:{"change":function($event){_vm.checkedField()}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v("  Notifications")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_vm._v(" "),_c('br'),_vm._v("Loading data...\n              ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","fixed":false,"items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"select",fn:function(row){return [_c('b-form-checkbox',{attrs:{"id":"checkbox","checked":row.item.active,"disabled":_vm.check},on:{"change":function($event){_vm.checkedField(row)}},nativeOn:{"click":function($event){$event.stopPropagation();}}})]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Fluid Types","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newFluidTypes),callback:function ($$v) {_vm.newFluidTypes=$$v},expression:"newFluidTypes"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Fluid Type Name","label-for":"FluidTypeName","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.FluidTypesName),callback:function ($$v) {_vm.FluidTypesName=$$v},expression:"FluidTypesName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Isolera Fluid Type Name","label-for":"isolera_fluid_type_name","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.isolera_fluid_type_name),callback:function ($$v) {_vm.isolera_fluid_type_name=$$v},expression:"isolera_fluid_type_name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Fluid Type Color","label-for":"FluidTypeColor","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"color"},model:{value:(_vm.FluidTypesColor),callback:function ($$v) {_vm.FluidTypesColor=$$v},expression:"FluidTypesColor"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_location_types_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617564fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_location_types_vue__ = __webpack_require__(1136);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_location_types_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617564fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_location_types_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Location Types")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","roles":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"6","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Add Location Type")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newLocationModal",attrs:{"title":"New Location Type","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newLocations),callback:function ($$v) {_vm.newLocations=$$v},expression:"newLocations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"L1","label":"Location Type Name","label-for":"locationtypename","horizontal":""}},[_c('b-form-input',{attrs:{"id":"locationtypename","type":"text","placeholder":"Location Type Name"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewLocationModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveLocations}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_location_type_vue__ = __webpack_require__(542);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa67973e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_location_type_vue__ = __webpack_require__(1138);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_location_type_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa67973e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_location_type_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Location Type - "+_vm._s(_vm.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editservice}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteLocationType}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"card location-information"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                 \t")])])],1):_c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Location Type Name","label-for":"locationtypename","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"locationtypename","type":"text","readonly":!_vm.edit},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"locationtypename","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateservice}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editservice}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_operating_areas_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002ab926_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_operating_areas_vue__ = __webpack_require__(1140);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_operating_areas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002ab926_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_operating_areas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Operating Areas")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Operating Areas - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view1),expression:"view1"}],staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashOA()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashOA()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","md":"6","xs":"12"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.view1),expression:"view1"}],staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.operatingAreaModal}},[_vm._v("Add Operating Area")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t\t")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Operating Area","size":"lg","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newOperatingArea),callback:function ($$v) {_vm.newOperatingArea=$$v},expression:"newOperatingArea"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Operating Area Name","label-for":"OperatingANameID","horizontal":""}},[_c('b-form-input',{attrs:{"id":"OperatingANameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),(_vm.role =='super_admin' && _vm.energycompanyselect.length > 0 )?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Energy Company","label-for":"EnergyCompanyID","horizontal":""}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"company_name","id":"EnergyCompanyID","options":_vm.energycompanyselect},on:{"input":_vm.select_energy_company},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Company Cosigner","label-for":"company_cosigner","horizontal":""}},[_c('b-form-input',{attrs:{"id":"company_cosigner","type":"text","autocomplete":"off"},model:{value:(_vm.model.company_cosigner),callback:function ($$v) {_vm.$set(_vm.model, "company_cosigner", $$v)},expression:"model.company_cosigner"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"Phone Number","label-for":"phone_number","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number","placeholder":"##########","type":"tel","autocomplete":"off"},model:{value:(_vm.model.phone_number),callback:function ($$v) {_vm.$set(_vm.model, "phone_number", $$v)},expression:"model.phone_number"}})],1),_vm._v(" "),(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Load Locations","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.unloadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Unload Locations","label-for":"unloadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.unloadLocationsChange},model:{value:(_vm.model.unload_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "unload_locations_id", $$v)},expression:"model.unload_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ULToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newOperatingArea=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveOperatingAreas(_vm.model)}}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Config Table","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"value":"id","disabled":true},on:{"change":function($event){_vm.actionField('name')}}},[_vm._v("Operating Area Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"name","disabled":true},on:{"change":function($event){_vm.actionField('trucking_company_name')}}},[_vm._v("Truck Company Name")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_operating_area_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33091a3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_operating_area_vue__ = __webpack_require__(1142);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_operating_area_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33091a3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_operating_area_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Operating Area - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='operations_manager')?_c('b-dropdown-item',{on:{"click":_vm.editOA}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteOperatingArea}},[_vm._v("Delete")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":!_vm.assign},on:{"click":function($event){_vm.editAssign()}}},[_vm._v("Assign All Drivers")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Id","label-for":"id"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"id","type":"text"},model:{value:(_vm.model.id),callback:function ($$v) {_vm.$set(_vm.model, "id", $$v)},expression:"model.id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Operating Area Name","label-for":"OperatingANameID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"OperatingANameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"OperatingANameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label":"Energy Company","label-for":"EnergyCompanyID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"EnergyCompanyID","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"value-field":"id","text-field":"company_name","id":"EnergyCompanyID","options":_vm.energycompanyselect,"placeholder":"Select Location Type"},on:{"input":_vm.select_energy_company},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Company Cosigner","label-for":"company_cosigner","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"company_cosigner","plaintext":"","type":"text"},model:{value:(_vm.model.company_cosigner),callback:function ($$v) {_vm.$set(_vm.model, "company_cosigner", $$v)},expression:"model.company_cosigner"}}):_c('b-form-input',{attrs:{"id":"company_cosigner","type":"text","autocomplete":"off"},model:{value:(_vm.model.company_cosigner),callback:function ($$v) {_vm.$set(_vm.model, "company_cosigner", $$v)},expression:"model.company_cosigner"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"Phone Number","label-for":"phone_number","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"phone_number","plaintext":"","type":"tel"},model:{value:(_vm.model.phone_number),callback:function ($$v) {_vm.$set(_vm.model, "phone_number", $$v)},expression:"model.phone_number"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number","placeholder":"##########","type":"tel","autocomplete":"off"},model:{value:(_vm.model.phone_number),callback:function ($$v) {_vm.$set(_vm.model, "phone_number", $$v)},expression:"model.phone_number"}})],1),_vm._v(" "),(_vm.model.load_locations.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Load Locations","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.model.load_locations,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.model.unload_locations.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Unload Locations","label-for":"unloadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.model.unload_locations,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.loadlocationselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Load Locations","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.unloadlocationselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Unload Locations","label-for":"unloadLocationsID1","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.unloadLocationsChange},model:{value:(_vm.model.unload_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "unload_locations_id", $$v)},expression:"model.unload_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ULToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.updateOperatingArea(_vm.model)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editOA}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)])],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Trucking Companies","ok-variant":"primary"},model:{value:(_vm.addUsers),callback:function ($$v) {_vm.addUsers=$$v},expression:"addUsers"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[(_vm.truckingcompanyselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"TC4","label":"","label-for":"TcID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.truckingcompanyselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.truckingcompanyChange},model:{value:(_vm.model.trucking_companies_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_companies_id", $$v)},expression:"model.trucking_companies_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"5px"},attrs:{"indeterminate":_vm.indeterminatetc,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.TCToggleAll},model:{value:(_vm.AllSelectedtc),callback:function ($$v) {_vm.AllSelectedtc=$$v},expression:"AllSelectedtc"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.AllSelectedtc ? 'Un-select All' : 'Select All')+"\n\t\t\t\t")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.editAssign() }}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.assigndrivers}},[_vm._v("\n          Assign\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_energy_company_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12dbf0e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_energy_company_vue__ = __webpack_require__(1144);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_energy_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12dbf0e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_energy_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Energy Company - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editEC}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteEC}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Company Name","label-for":"CompanyNameID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],attrs:{"plaintext":"","id":"CompanyNameID","type":"text"},model:{value:(_vm.model.company_name),callback:function ($$v) {_vm.$set(_vm.model, "company_name", $$v)},expression:"model.company_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"CNR","label-for":"cnr","horizontal":""}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.model.cnr_inputs),callback:function ($$v) {_vm.$set(_vm.model, "cnr_inputs", $$v)},expression:"model.cnr_inputs"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",attrs:{"name":"Checkboxes2","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.model.cnr_inputs),callback:function ($$v) {_vm.$set(_vm.model, "cnr_inputs", $$v)},expression:"model.cnr_inputs"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Isolera","label-for":"isolera","horizontal":""}},[_c('b-form-checkbox',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"custom-checkboxes",attrs:{"name":"Checkboxes2","plain":"","disabled":""},model:{value:(_vm.model.isolera),callback:function ($$v) {_vm.$set(_vm.model, "isolera", $$v)},expression:"model.isolera"}}),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"custom-checkboxes",attrs:{"name":"Checkboxes2","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.model.isolera),callback:function ($$v) {_vm.$set(_vm.model, "isolera", $$v)},expression:"model.isolera"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Address","label-for":"address","horizontal":""}},[(!_vm.edit)?_c('b-form-textarea',{attrs:{"plaintext":"","id":"address","type":"text","rows":"3","max-rows":"8","autocomplete":"off"},model:{value:(_vm.model.address),callback:function ($$v) {_vm.$set(_vm.model, "address", $$v)},expression:"model.address"}}):_c('b-form-textarea',{attrs:{"id":"address","type":"text","rows":"3","max-rows":"8","autocomplete":"off"},model:{value:(_vm.model.address),callback:function ($$v) {_vm.$set(_vm.model, "address", $$v)},expression:"model.address"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"24 Phone Number","label-for":"phone_number_24","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{attrs:{"plaintext":"","id":"phone_number_24","type":"tel"},model:{value:(_vm.model.phone_number_24),callback:function ($$v) {_vm.$set(_vm.model, "phone_number_24", $$v)},expression:"model.phone_number_24"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"phone_number_24","placeholder":"##########","type":"tel","autocomplete":"off"},model:{value:(_vm.model.phone_number_24),callback:function ($$v) {_vm.$set(_vm.model, "phone_number_24", $$v)},expression:"model.phone_number_24"}})],1),_vm._v(" "),(_vm.model.trucking_companies.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Trucking Companies","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.trucking_companies,"name":"Checkboxes2","checked":_vm.allCheckedTC(),"plain":"","disabled":""}})],1):_vm._e(),_vm._v(" "),(_vm.truckingcompaniesselect.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Trucking Company","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.truckingcompaniesselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.TCChange},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateTC,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.TCToggleAll},model:{value:(_vm.tcAllSelected),callback:function ($$v) {_vm.tcAllSelected=$$v},expression:"tcAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.tcAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Petrotranz Company","label-for":"ptty"}},[(_vm.model.petrotranz!=null)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ptty","type":"text"},model:{value:(_vm.model.petrotranz.name),callback:function ($$v) {_vm.$set(_vm.model.petrotranz, "name", $$v)},expression:"model.petrotranz.name"}}):_vm._e()],1):_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Petrotranz Company","label-for":"ptty1"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"autocomplete":"off","id":"ptty1","placeholder":"Search Filtered by ...(minimum 3 letters)","type":"text"},nativeOn:{"keydown":function($event){_vm.keyMonitor($event)}},model:{value:(_vm.filtered),callback:function ($$v) {_vm.filtered=$$v},expression:"filtered"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.suggest),expression:"suggest"}],attrs:{"select-size":_vm.size,"disabled":_vm.petrotranz.length==0,"value-field":"id","text-field":"name","id":"ptty1","options":_vm.petrotranz},on:{"input":function($event){_vm.select_petrotranz()}},model:{value:(_vm.model1.petrotranz_company_id),callback:function ($$v) {_vm.$set(_vm.model1, "petrotranz_company_id", $$v)},expression:"model1.petrotranz_company_id"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"})])],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Petrotranz Codes","label-for":"L6","horizontal":""}},[(_vm.model.petrotranz!=null)?_c('div',[(_vm.model.petrotranz.codes.length!==0)?_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.petrotranz.codes,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}}):_vm._e()],1):_vm._e()]):_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Petrotranz Codes","label-for":"L6","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.codes,"name":"Checkboxes2","plain":""},on:{"input":_vm.codesChange},model:{value:(_vm.model1.petrotranz_company_id.codes),callback:function ($$v) {_vm.$set(_vm.model1.petrotranz_company_id, "codes", $$v)},expression:"model1.petrotranz_company_id.codes"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminatePT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.PTToggleAll},model:{value:(_vm.ptAllSelected),callback:function ($$v) {_vm.ptAllSelected=$$v},expression:"ptAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.ptAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateEC}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editEC}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_roles_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8e8ded_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_roles_vue__ = __webpack_require__(1146);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8e8ded_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Roles")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","roles":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"6","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Add Role")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newLocationModal",attrs:{"title":"New Role","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newLocations),callback:function ($$v) {_vm.newLocations=$$v},expression:"newLocations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"L1","label":"Role Name","label-for":"rolename","horizontal":""}},[_c('b-form-input',{attrs:{"id":"rolename","type":"text","placeholder":"Enter Role Name"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewLocationModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveLocations}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_role_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428a3851_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_role_vue__ = __webpack_require__(1148);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_role_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428a3851_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_role_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Role - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editservice}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteservice}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t")])])],1):_c('div',[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Role Name","label-for":"rolename","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"rolename","type":"text","readonly":!_vm.edit},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"rolename","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateservice}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editservice}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keys_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3120fa10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keys_vue__ = __webpack_require__(1151);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keys_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3120fa10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keys_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/apikeys/', { headers: {
					'Content-Type': 'application/json', 'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/apikey/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	deleteKey: function deleteKey(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/apikey/delete/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	renewKey: function renewKey(id) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/apikey/renew/' + id + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("API - Keys")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","roles":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"6","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Assign Key")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"actions",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.renewKey(row)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tRenew\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.deleteKey(row)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDelete\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newLocationModal",attrs:{"title":"New Role","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newLocations),callback:function ($$v) {_vm.newLocations=$$v},expression:"newLocations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Company Type","label-for":"api0"}},[_c('b-form-select',{attrs:{"id":"api0","value-field":"id","text-field":"name","options":_vm.company_type},on:{"input":function($event){_vm.select_company_type()}},model:{value:(_vm.model.company_type_id),callback:function ($$v) {_vm.$set(_vm.model, "company_type_id", $$v)},expression:"model.company_type_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[(_vm.model.company_type_id === 0)?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Companies","label-for":"api1"}},[_c('b-form-select',{attrs:{"id":"api1","value-field":"id","text-field":"name","options":_vm.company_name},on:{"input":function($event){_vm.select_company()}},model:{value:(_vm.model.company_id),callback:function ($$v) {_vm.$set(_vm.model, "company_id", $$v)},expression:"model.company_id"}})],1):_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Companies","label-for":"api1"}},[_c('b-form-select',{attrs:{"id":"api1","value-field":"id","text-field":"name","options":_vm.company_name},on:{"input":function($event){_vm.select_company()}},model:{value:(_vm.model.company_id),callback:function ($$v) {_vm.$set(_vm.model, "company_id", $$v)},expression:"model.company_id"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewLocationModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.assignKey}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_services_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3630362e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_services_vue__ = __webpack_require__(1153);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3630362e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Services")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","services":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"6","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Add Service")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newLocationModal",attrs:{"title":"New Service","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newLocations),callback:function ($$v) {_vm.newLocations=$$v},expression:"newLocations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"L1","label":"Service Name","label-for":"servicename","horizontal":""}},[_c('b-form-input',{attrs:{"id":"servicename","type":"text","placeholder":"Enter Service Name"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),(_vm.roles1.length > 0)?_c('b-form-group',{attrs:{"label-cols":2,"id":"L4","label":"Roles","label-for":"rolesID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.roles1,"name":"Checkboxes","plain":""},on:{"input":_vm.rolesChange},model:{value:(_vm.model.roles_id),callback:function ($$v) {_vm.$set(_vm.model, "roles_id", $$v)},expression:"model.roles_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminate,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.rolesToggleAll},model:{value:(_vm.rolesAllSelected),callback:function ($$v) {_vm.rolesAllSelected=$$v},expression:"rolesAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.rolesAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewServiceModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveServices}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_service_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adf1c034_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_service_vue__ = __webpack_require__(1155);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adf1c034_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_service_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Service - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),(_vm.tabIndex==0)?_c('b-dropdown-item',{on:{"click":_vm.editservice}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),(_vm.tabIndex==0)?_c('b-dropdown-item',{on:{"click":_vm.deleteservice}},[_vm._v("Delete")]):_vm._e()],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                 \t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Service Name","label-for":"servicename","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"servicename","type":"text","readonly":!_vm.edit},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"servicename","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),(_vm.roles.length > 0 && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Roles:","label-for":"rolesID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.roles,"name":"Checkboxes","plain":"","disabled":""},model:{value:(_vm.model.roles_selected),callback:function ($$v) {_vm.$set(_vm.model, "roles_selected", $$v)},expression:"model.roles_selected"}})],1):_vm._e(),_vm._v(" "),(_vm.roles1.length > 0 && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Roles:","label-for":"rolesID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.roles1,"name":"Checkboxes","plain":""},on:{"input":_vm.rolesChange},model:{value:(_vm.model.roles_newselected),callback:function ($$v) {_vm.$set(_vm.model, "roles_newselected", $$v)},expression:"model.roles_newselected"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminate,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.rolesToggleAll},model:{value:(_vm.rolesAllSelected),callback:function ($$v) {_vm.rolesAllSelected=$$v},expression:"rolesAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.rolesAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateservice}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editservice}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t\t")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_folders_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9099ded4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_folders_vue__ = __webpack_require__(1157);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_folders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9099ded4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_folders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Folders")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Folders - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","services":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"3","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],staticClass:"my-1",attrs:{"lg":"3","title":"Actived / Deleted"}},[_c('b-dropdown',{attrs:{"id":"ddown1","text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashFolder()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashFolder()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Add Folder")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newLocationModal",attrs:{"title":"New Folder","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newLocations),callback:function ($$v) {_vm.newLocations=$$v},expression:"newLocations"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"id":"L1","label":"Folder Name","label-for":"foldername","horizontal":""}},[_c('b-form-input',{attrs:{"id":"foldername","type":"text","placeholder":"Enter Service Name"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),(_vm.energy_companies.length > 1)?_c('b-form-group',{attrs:{"label":"Energy Company","label-for":"energy_company_id","horizontal":""}},[_c('b-form-select',{attrs:{"id":"energy_company_id","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewServiceModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveFolder}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_folder_vue__ = __webpack_require__(554);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d8d604_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_folder_vue__ = __webpack_require__(1159);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_folder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d8d604_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_folder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Service - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),(_vm.tabIndex==0)?_c('b-dropdown-item',{on:{"click":_vm.editservice}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),(_vm.tabIndex==0)?_c('b-dropdown-item',{on:{"click":_vm.deleteservice}},[_vm._v("Delete")]):_vm._e()],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                 \t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Service Name","label-for":"servicename","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"servicename","type":"text","readonly":!_vm.edit},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"servicename","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Energy Company","label-for":"servicename","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"servicename","type":"text","readonly":!_vm.edit},model:{value:(_vm.model.energy_company),callback:function ($$v) {_vm.$set(_vm.model, "energy_company", $$v)},expression:"model.energy_company"}})],1),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateservice}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editservice}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t\t")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_agreements_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e33a4b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_agreements_vue__ = __webpack_require__(1162);
function injectStyle (ssrContext) {
  __webpack_require__(1161)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e33a4b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_agreements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e33a4b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_agreements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Terminal Agreements")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Terminal Agreements - Trash")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.list),expression:"list"}]},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"services":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashAgreement()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashAgreement()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"disabled":_vm.loadingData,"variant":"primary"},on:{"click":_vm.showNewLocationModal}},[_vm._v("Add Terminal Agreement")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t\t\t")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',_vm._l((row.item),function(value,key){return _c('li',{key:key},[_vm._v(_vm._s(key)+": "+_vm._s(value))])}))])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add Unload Location","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newUnloadLocation),callback:function ($$v) {_vm.newUnloadLocation=$$v},expression:"newUnloadLocation"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload Location","label-for":"Grouptarget1"}},[_c('b-form-select',{attrs:{"disabled":_vm.locations.length == 0,"id":"Grouptarget1","options":_vm.locations},model:{value:(_vm.u_location_id),callback:function ($$v) {_vm.u_location_id=$$v},expression:"u_location_id"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newUnloadLocation=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addunloadlocation()}}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add Load Location","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newLoadLocation),callback:function ($$v) {_vm.newLoadLocation=$$v},expression:"newLoadLocation"}},[_c('b-row',[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Load Locations","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.hideloadlocation()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addloadlocation()}}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newModal",attrs:{"title":"New Terminal Agreement","id":"newModal","size":"lg"},model:{value:(_vm.newModal),callback:function ($$v) {_vm.newModal=$$v},expression:"newModal"}},[_c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""},model:{value:(_vm.modalTabIndex),callback:function ($$v) {_vm.modalTabIndex=$$v},expression:"modalTabIndex"}},[_c('b-tab',{attrs:{"title":"Basic Info","active":""}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"vertical":"","label":"Initial Date","label-for":"initial_date"}},[_c('b-form-input',{attrs:{"id":"initial_date","type":"date"},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"vertical":"","label":"End Date","label-for":"end_date"}},[_c('b-form-input',{attrs:{"id":"end_date","type":"date"},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin')?_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Energy Company","label-for":"energyCompanies"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"energyCompanies","options":_vm.energycompanies},on:{"input":_vm.select_energy_company},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[(_vm.fluidtypes.length > 0)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L5","label":"Fluid Types","label-for":"fluidtypesID","vertical":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"other","text-field":"name","options":_vm.fluidtypes,"name":"Checkboxes2","plain":""},on:{"input":_vm.select_fluid_type},model:{value:(_vm.fluid_type),callback:function ($$v) {_vm.fluid_type=$$v},expression:"fluid_type"}})],1):_vm._e()],1)],1),_vm._v(" "),(_vm.model.other_terms.length > 0)?_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Stream Type","label-for":"streamtype"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"streamtype","options":_vm.fluid_type.stream_type},model:{value:(_vm.model.other_terms[0].stream_type_id),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "stream_type_id", $$v)},expression:"model.other_terms[0].stream_type_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select stream type --")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Blending Dry Fee","label-for":"blending_dry_fee"}},[_c('b-form-input',{attrs:{"id":"blending_dry_fee","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.other_terms[0].blending_dry_fee),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "blending_dry_fee", $$v)},expression:"model.other_terms[0].blending_dry_fee"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Terminal Company","label-for":"terminalCompanies"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"terminalCompanies","options":_vm.terminalcompanies},model:{value:(_vm.model.terminal_company_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_company_id", $$v)},expression:"model.terminal_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select terminal company --")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Terminal","label-for":"terminal"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"terminal","options":_vm.terminals},on:{"input":_vm.select_terminal},model:{value:(_vm.model.terminal_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_id", $$v)},expression:"model.terminal_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select terminal --")])])],2)],1)],1),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Terminal Rate","label-for":"rate"}},[_c('b-form-input',{attrs:{"id":"rate","type":"text","placeholder":"The regular terminal fee that will apply to all hauls"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.rate),callback:function ($$v) {_vm.$set(_vm.model, "rate", $$v)},expression:"model.rate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Treatment Fees"}},[_c('p',[_vm._v("\n      \t\t\t\t\t\tTreatment fees that will apply only to those hauls which H2S condition apply as shows below \n    \t\t\t\t\t\t")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No Treatement fees added","fields":[{key: 'delete', label: ' '}, {key: 'treatment_fee_type_id', label: 'Type'}, {key: 'treatment_fee', label: 'Treatment fee'}, {key: 'condition_id', label: 'Condition'}, {key: 'percentage', label: 'Percentage'}],"items":_vm.model.treatfees,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removetreatmentfee(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"treatment_fee_type_id",fn:function(item){return [_c('b-form-select',{attrs:{"size":"sm","id":"type","options":_vm.treatment_fee_type},model:{value:(_vm.model.treatfees[item.index].treatment_fee_type_id),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "treatment_fee_type_id", $$v)},expression:"model.treatfees[item.index].treatment_fee_type_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select type --")])])],2)]}},{key:"treatment_fee",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"treatmentfee","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'treatmentfee')}},model:{value:(_vm.model.treatfees[item.index].treatment_fee),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "treatment_fee", $$v)},expression:"model.treatfees[item.index].treatment_fee"}})]}},{key:"condition_id",fn:function(item){return [_c('b-form-select',{attrs:{"size":"sm","id":"condition","options":_vm.condition},model:{value:(_vm.model.treatfees[item.index].condition_id),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "condition_id", $$v)},expression:"model.treatfees[item.index].condition_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select condition --")])])],2)]}},{key:"percentage",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'percentage')}},model:{value:(_vm.model.treatfees[item.index].percentage),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "percentage", $$v)},expression:"model.treatfees[item.index].percentage"}})]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.addtreatmentfee()}}},[_vm._v("Add New Treatment Fee")])],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Other Fees"}},[_c('p',[_vm._v("\n      \t\t\t\t\t\t\tAny other fees added here will be automatically apply to all hauls that unload in this location that contains water as a fluid type\n    \t\t\t\t\t\t")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No other fees have been added","fields":[{key: 'delete', label: ' '}, {key: 'terminal_rate', label: 'Terminal Rate'}, {key: 'rate', label: 'Rate'}],"items":_vm.model.otherfees,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removeotherfee(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"terminal_rate",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"otherfee","type":"text"},model:{value:(_vm.model.otherfees[item.index].terminal_rate),callback:function ($$v) {_vm.$set(_vm.model.otherfees[item.index], "terminal_rate", $$v)},expression:"model.otherfees[item.index].terminal_rate"}})]}},{key:"rate",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"otherrate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.otherfees[item.index].rate),callback:function ($$v) {_vm.$set(_vm.model.otherfees[item.index], "rate", $$v)},expression:"model.otherfees[item.index].rate"}})]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.otherfee()}}},[_vm._v("Add Other Fee")])],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Unload Locations"}},[_c('p',[_vm._v("\n\t\t\t\t\t\t\tAny other fees added here will be automatically apply to all hauls that unload in this location that  contains water as a fluid type\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No Unload Locations have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: 'Unload Location'}, {key: 'shipping_cost', label: 'Shipping Cost'}, {key: 'monthly_commitment', label: 'Monthly Commitment'}, {key: 'contact_person', label: 'Contact Person'}, {key: 'contact_email', label: 'Contact Email'}, {key: 'show_details', label: ' '}],"items":_vm.model.unload_locations,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"show_details",fn:function(row){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Add Terminal Cost","size":"sm"},on:{"click":function($event){_vm.addterminalcost(row)}}},[_c('i',{staticClass:"icon-plus"}),_vm._v(" Cost")])]}},{key:"row-details",fn:function(row){return [_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"cols":"7"}},[_c('b',[_vm._v("Terminal Cost")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b',[_vm._v("Percentage")])])],1),_vm._v(" "),_vm._l((_vm.model.unload_locations[row.index].terminal_costs),function(terminal_cost,index1){return _c('b-row',{key:index1,staticClass:"mb-2"},[_c('b-col',{attrs:{"cols":"7"}},[_c('b-form-input',{attrs:{"size":"sm","id":"terminal_cost_name","type":"text"},model:{value:(_vm.model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[row.index].terminal_costs[index1], "terminal_cost_name", $$v)},expression:"model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{attrs:{"size":"sm","id":"terminal_cost_percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'percentage')}},model:{value:(_vm.model.unload_locations[row.index].terminal_costs[index1].percentage),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[row.index].terminal_costs[index1], "percentage", $$v)},expression:"model.unload_locations[row.index].terminal_costs[index1].percentage"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Delete Terminal Cost","size":"sm"},on:{"click":function($event){_vm.removeterminalcost(row, index1)}}},[_c('i',{staticClass:"icon-close"})])],1)],1)})]}},{key:"name",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"location","readonly":""},model:{value:(_vm.model.unload_locations[0].name),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[0], "name", $$v)},expression:"model.unload_locations[0].name"}})]}},{key:"shipping_cost",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"shipping_cost","type":"text"},model:{value:(_vm.model.unload_locations[item.index].shipping_cost),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "shipping_cost", $$v)},expression:"model.unload_locations[item.index].shipping_cost"}})]}},{key:"monthly_commitment",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"monthly_commitment","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'monthly_commitment')}},model:{value:(_vm.model.unload_locations[item.index].monthly_commitment),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "monthly_commitment", $$v)},expression:"model.unload_locations[item.index].monthly_commitment"}})]}},{key:"contact_person",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"contact_person","type":"text"},model:{value:(_vm.model.unload_locations[item.index].contact_person),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "contact_person", $$v)},expression:"model.unload_locations[item.index].contact_person"}})]}},{key:"contact_email",fn:function(item){return [_c('b-form-input',{attrs:{"size":"sm","id":"contact_email","type":"text"},model:{value:(_vm.model.unload_locations[item.index].contact_email),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "contact_email", $$v)},expression:"model.unload_locations[item.index].contact_email"}})]}}])})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Load Locations"}},[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"","label-for":"loadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.energy_company_id != null ? 'There are no registered Load locations for the selected Energy Company' : 'No Energy Company selected'))])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newModal=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveTerminalAgreement}},[_vm._v("Save")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_agreements_pending_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c55ef43_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_agreements_pending_vue__ = __webpack_require__(1164);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_agreements_pending_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c55ef43_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_agreements_pending_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Pending Terminal Agreements")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.list),expression:"list"}]},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"services":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashAgreement()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashAgreement()}}},[_vm._v("Trash")])],1)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t                 ")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"action",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.create_a(row.item, row.index)}}},[_vm._v("\n                                    Create Agreement\n                                ")])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('ul',_vm._l((row.item),function(value,key){return _c('li',{key:key},[_vm._v(_vm._s(key)+": "+_vm._s(value))])}))])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.list),expression:"!list"}]},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.fluidtypes.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Fluid Types","label-for":"fluidtypesID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"other","text-field":"name","options":_vm.fluidtypes,"name":"Checkboxes2","plain":""},on:{"input":_vm.select_fluid_type},model:{value:(_vm.fluid_type),callback:function ($$v) {_vm.fluid_type=$$v},expression:"fluid_type"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Initial Date","label-for":"initial_date"}},[_c('b-form-input',{attrs:{"id":"initial_date","type":"date"},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Date","label-for":"end_date"}},[_c('b-form-input',{attrs:{"id":"end_date","type":"date"},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energyCompanies"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"energyCompanies","options":_vm.energycompanies},on:{"input":_vm.select_energy_company},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Company","label-for":"terminalCompanies"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"terminalCompanies","options":_vm.terminalcompanies},model:{value:(_vm.model.terminal_company_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_company_id", $$v)},expression:"model.terminal_company_id"}})],1)],1)],1),_vm._v(" "),(_vm.model.other_terms.length > 0)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Stream Type","label-for":"streamtype"}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"streamtype","options":_vm.fluid_type.stream_type},model:{value:(_vm.model.other_terms[0].stream_type_id),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "stream_type_id", $$v)},expression:"model.other_terms[0].stream_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":6,"horizontal":"","label":"Blending Dry Fee","label-for":"blending_dry_fee"}},[_c('b-form-input',{attrs:{"id":"blending_dry_fee","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.other_terms[0].blending_dry_fee),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "blending_dry_fee", $$v)},expression:"model.other_terms[0].blending_dry_fee"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"70rem"},attrs:{"title":"Terminal Rate"}},[_c('b-card-text',{attrs:{"text-tag":"p"}},[_vm._v("\n      \t\t\t\t\tThe regular terminal fee that will apply to all hauls \n    \t\t\t\t\t")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-cols":6,"horizontal":"","label":"Terminal Rate","label-for":"rate"}},[_c('b-form-input',{attrs:{"id":"rate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.rate),callback:function ($$v) {_vm.$set(_vm.model, "rate", $$v)},expression:"model.rate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"70rem"},attrs:{"title":"Treatment Fees"}},[_c('b-card-text',{attrs:{"text-tag":"p"}},[_vm._v("\n      \t\t\t\t\tTreatment fee that will apply only to those hauls which H2S contition apply as shows below \n    \t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.model.treatfees),function(treatfee,index){return _c('div',[_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label-cols":2,"vertical":"","label-size":"sm","label":"Type","label-for":"type"}},[_c('b-form-select',{attrs:{"size":"sm","id":"type","options":_vm.treatment_fee_type},model:{value:(_vm.model.treatfees[index].treatment_fee_type_id),callback:function ($$v) {_vm.$set(_vm.model.treatfees[index], "treatment_fee_type_id", $$v)},expression:"model.treatfees[index].treatment_fee_type_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label-cols":2,"vertical":"","label-size":"sm","label":"Treatment Fee","label-for":"treatmentfee"}},[_c('b-form-input',{attrs:{"size":"sm","id":"treatmentfee","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.treatfees[index].treatment_fee),callback:function ($$v) {_vm.$set(_vm.model.treatfees[index], "treatment_fee", $$v)},expression:"model.treatfees[index].treatment_fee"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label-cols":2,"vertical":"","label":"Condition","label-for":"condition"}},[_c('b-form-select',{attrs:{"size":"sm","id":"condition","options":_vm.condition},model:{value:(_vm.model.treatfees[index].condition_id),callback:function ($$v) {_vm.$set(_vm.model.treatfees[index], "condition_id", $$v)},expression:"model.treatfees[index].condition_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label-cols":2,"vertical":"","label-size":"sm","label":"Percentage","label-for":"percentage"}},[_c('b-form-input',{attrs:{"size":"sm","id":"percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.treatfees[index].percentage),callback:function ($$v) {_vm.$set(_vm.model.treatfees[index], "percentage", $$v)},expression:"model.treatfees[index].percentage"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"*"}},[_c('b-btn',{on:{"click":function($event){_vm.removetreatmentfee(index)}}},[_vm._v("X")])],1)],1),_vm._v(" "),_c('hr')],1)}),_vm._v(" "),_c('b-row',[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addtreatmentfee()}}},[_vm._v("Add New Treatment Fee")])],1)],2),_vm._v(" "),_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"70rem"},attrs:{"title":"Other Fees"}},[_c('b-card-text',{attrs:{"text-tag":"p"}},[_vm._v("\n      \t\t\t\t\tAny other fees added here will be automatically \n\t\t\t\t\t\t\t\tapply to all hauls that unload in this location that  contains water as a fluid type\n    \t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.model.otherfees),function(otherfee,index){return _c('div',[_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Terminal Rate","label-for":"otherfee"}},[_c('b-form-input',{attrs:{"size":"sm","id":"otherfee","type":"text"},model:{value:(_vm.model.otherfees[index].terminal_rate),callback:function ($$v) {_vm.$set(_vm.model.otherfees[index], "terminal_rate", $$v)},expression:"model.otherfees[index].terminal_rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Rate","label-for":"otherrate"}},[_c('b-form-input',{attrs:{"size":"sm","id":"otherrate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.otherfees[index].rate),callback:function ($$v) {_vm.$set(_vm.model.otherfees[index], "rate", $$v)},expression:"model.otherfees[index].rate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-btn',{on:{"click":function($event){_vm.removeotherfee(index)}}},[_vm._v("X")])],1)],1),_vm._v(" "),_c('hr')],1)}),_vm._v(" "),_c('b-row',[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.otherfee()}}},[_vm._v("Add Other")])],1)],2),_vm._v(" "),_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"70rem"},attrs:{"title":"Unload Locations"}},[_c('b-card-text',{attrs:{"text-tag":"p"}},[_vm._v("\n      \t\t\t\t\tAny other fees added here will be automatically \n\t\t\t\t\t\t\t\tapply to all hauls that unload in this location that  contains water as a fluid type\n    \t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.model.unload_locations),function(unload_location,index){return _c('div',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"7"}},[_c('b-form-group',{attrs:{"label-cols":7,"horizontal":"","label-size":"sm","label":"Location:","label-for":"location"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","size":"md","id":"location","type":"text"},model:{value:(_vm.model.unload_locations[index].name),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index], "name", $$v)},expression:"model.unload_locations[index].name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-btn',{on:{"click":function($event){_vm.removelocation(index)}}},[_vm._v("X")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Shipping Cost","label-for":"shipping_cost"}},[_c('b-form-input',{attrs:{"size":"sm","id":"shipping_cost","type":"text"},model:{value:(_vm.model.unload_locations[index].shipping_cost),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index], "shipping_cost", $$v)},expression:"model.unload_locations[index].shipping_cost"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Monthly Commitment","label-for":"monthly_commitment"}},[_c('b-form-input',{attrs:{"size":"sm","id":"monthly_commitment","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.unload_locations[index].monthly_commitment),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index], "monthly_commitment", $$v)},expression:"model.unload_locations[index].monthly_commitment"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Contact Person","label-for":"contact_person"}},[_c('b-form-input',{attrs:{"size":"sm","id":"contact_person","type":"text"},model:{value:(_vm.model.unload_locations[index].contact_person),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index], "contact_person", $$v)},expression:"model.unload_locations[index].contact_person"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Contact Email","label-for":"contact_email"}},[_c('b-form-input',{attrs:{"size":"sm","id":"contact_email","type":"text"},model:{value:(_vm.model.unload_locations[index].contact_email),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index], "contact_email", $$v)},expression:"model.unload_locations[index].contact_email"}})],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.model.unload_locations[index].terminal_costs),function(terminal_cost,index1){return _c('div',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-row',{staticStyle:{"background-color":"#f5f5f5"}},[_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Terminal Cost","label-for":"terminal_cost_name"}},[_c('b-form-input',{attrs:{"size":"sm","id":"terminal_cost_name","type":"text"},model:{value:(_vm.model.unload_locations[index].terminal_costs[index1].terminal_cost_name),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index].terminal_costs[index1], "terminal_cost_name", $$v)},expression:"model.unload_locations[index].terminal_costs[index1].terminal_cost_name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label-cols":5,"horizontal":"","label-size":"sm","label":"Percentage","label-for":"terminal_cost_percentage"}},[_c('b-form-input',{attrs:{"size":"sm","id":"terminal_cost_percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.unload_locations[index].terminal_costs[index1].percentage),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[index].terminal_costs[index1], "percentage", $$v)},expression:"model.unload_locations[index].terminal_costs[index1].percentage"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-btn',{on:{"click":function($event){_vm.removeterminalcost(index, index1)}}},[_vm._v("X")])],1)],1)],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addterminalcost(index)}}},[_vm._v("Add Terminal Cost")])],1)],1),_vm._v(" "),_c('hr')],2)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.showunloadlocation()}}},[_vm._v("Add Unload Location")])],1)],2),_vm._v(" "),(_vm.model.energy_company_id != null)?_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"70rem"},attrs:{"title":"Load Locations"}},[_c('div'),_vm._v(" "),(_vm.load_locations.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"legal_location","options":_vm.load_locations,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.showloadlocation()}}},[_vm._v("Add Load Location")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewServiceModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveTerminalAgreement}},[_vm._v("Save")])],1)],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add Unload Location","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newUnloadLocation),callback:function ($$v) {_vm.newUnloadLocation=$$v},expression:"newUnloadLocation"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload Location","label-for":"Grouptarget1"}},[_c('b-form-select',{attrs:{"disabled":_vm.locations.length == 0,"id":"Grouptarget1","options":_vm.locations},model:{value:(_vm.u_location_id),callback:function ($$v) {_vm.u_location_id=$$v},expression:"u_location_id"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newUnloadLocation=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addunloadlocation()}}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add Load Location","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newLoadLocation),callback:function ($$v) {_vm.newLoadLocation=$$v},expression:"newLoadLocation"}},[_c('b-row',[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Load Locations","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.model.load_locations_id),callback:function ($$v) {_vm.$set(_vm.model, "load_locations_id", $$v)},expression:"model.load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.hideloadlocation()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addloadlocation()}}},[_vm._v("Add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_agreement_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b99fcbc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_agreement_vue__ = __webpack_require__(1167);
function injectStyle (ssrContext) {
  __webpack_require__(1166)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b99fcbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_agreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b99fcbc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_agreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Terminal Agreement - "+_vm._s(this.model.id))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.edit_terminal_agreement}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.delete_terminal_agreement}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',{staticClass:"p-0"},[_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Basic Info"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"vertical":"","label":"Initial Date","label-for":"initial_date"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}}):_c('b-form-input',{attrs:{"id":"initial_date","type":"date","readonly":!_vm.edit},model:{value:(_vm.model.initial_date),callback:function ($$v) {_vm.$set(_vm.model, "initial_date", $$v)},expression:"model.initial_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":4,"vertical":"","label":"End Date","label-for":"end_date"}},[(!_vm.edit)?_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}}):_c('b-form-input',{attrs:{"id":"end_date","type":"date","readonly":!_vm.edit},model:{value:(_vm.model.end_date),callback:function ($$v) {_vm.$set(_vm.model, "end_date", $$v)},expression:"model.end_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Energy Company","label-for":"energyCompanies"}},[((_vm.role =='super_admin' && _vm.edit))?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"energyCompanies","options":_vm.energycompanies,"disabled":!_vm.edit},on:{"input":_vm.select_energy_company},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.energy_company),callback:function ($$v) {_vm.$set(_vm.model, "energy_company", $$v)},expression:"model.energy_company"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[(_vm.fluidtypes.length > 0)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L5","label":"Fluid Type","label-for":"fluidtypesID","vertical":""}},[(_vm.edit)?_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"other","text-field":"name","options":_vm.fluidtypes,"name":"Checkboxes2","plain":"","disabled":!_vm.edit},on:{"input":_vm.select_fluid_type},model:{value:(_vm.fluid_type),callback:function ($$v) {_vm.fluid_type=$$v},expression:"fluid_type"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.fluid_type),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type", $$v)},expression:"model.fluid_type"}})],1):_vm._e()],1)],1),_vm._v(" "),(_vm.model.other_terms.length > 0)?_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Stream Type","label-for":"streamtype"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"streamtype","options":_vm.fluid_type.stream_type,"disabled":!_vm.edit},model:{value:(_vm.model.other_terms[0].stream_type_id),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "stream_type_id", $$v)},expression:"model.other_terms[0].stream_type_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select stream type --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.other_terms[0].stream_type_name),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "stream_type_name", $$v)},expression:"model.other_terms[0].stream_type_name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Blending Dry Fee","label-for":"blending_dry_fee"}},[(_vm.edit)?_c('b-form-input',{attrs:{"id":"blending_dry_fee","type":"text","readonly":!_vm.edit},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.other_terms[0].blending_dry_fee),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "blending_dry_fee", $$v)},expression:"model.other_terms[0].blending_dry_fee"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.other_terms[0].blending_dry_fee1),callback:function ($$v) {_vm.$set(_vm.model.other_terms[0], "blending_dry_fee1", $$v)},expression:"model.other_terms[0].blending_dry_fee1"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Terminal Company","label-for":"terminalCompanies"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"terminalCompanies","options":_vm.terminalcompanies,"disabled":!_vm.edit},model:{value:(_vm.model.terminal_company_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_company_id", $$v)},expression:"model.terminal_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select terminal company --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.terminal_company),callback:function ($$v) {_vm.$set(_vm.model, "terminal_company", $$v)},expression:"model.terminal_company"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Terminal","label-for":"terminal"}},[(_vm.edit)?_c('b-form-select',{attrs:{"value-field":"id","text-field":"name","id":"terminal","options":_vm.terminals,"disabled":!_vm.edit},on:{"input":_vm.select_terminal},model:{value:(_vm.model.terminal_id),callback:function ($$v) {_vm.$set(_vm.model, "terminal_id", $$v)},expression:"model.terminal_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select terminal --")])])],2):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.terminal),callback:function ($$v) {_vm.$set(_vm.model, "terminal", $$v)},expression:"model.terminal"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label-cols":3,"vertical":"","label":"Terminal Rate","label-for":"rate"}},[(_vm.edit)?_c('b-form-input',{attrs:{"id":"rate","type":"text","placeholder":"The regular terminal fee that will apply to all hauls","readonly":!_vm.edit},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.rate),callback:function ($$v) {_vm.$set(_vm.model, "rate", $$v)},expression:"model.rate"}}):_c('b-form-input',{attrs:{"type":"text","readonly":""},model:{value:(_vm.model.rate1),callback:function ($$v) {_vm.$set(_vm.model, "rate1", $$v)},expression:"model.rate1"}})],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Treatment Fees"}},[_c('p',[_vm._v("\n\t\t\t\t\tTreatment fees that will apply only to those hauls which H2S condition apply as shows below \n\t\t\t\t\t")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No Treatement fees added","fields":[{key: 'delete', label: ' '}, {key: 'treatment_fee_type_id', label: 'Type'}, {key: 'treatment_fee', label: 'Treatment fee'}, {key: 'condition_id', label: 'Condition'}, {key: 'percentage', label: 'Percentage'}],"items":_vm.model.treatfees,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return _vm.edit?[_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removetreatmentfee(item.index)}}},[_c('i',{staticClass:"icon-close"})])]:undefined}},{key:"treatment_fee_type_id",fn:function(item){return [(_vm.edit)?_c('b-form-select',{attrs:{"size":"sm","id":"type","options":_vm.treatment_fee_type},model:{value:(_vm.model.treatfees[item.index].treatment_fee_type_id),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "treatment_fee_type_id", $$v)},expression:"model.treatfees[item.index].treatment_fee_type_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select type --")])])],2):_c('span',[_vm._v(_vm._s(_vm.model.treatfees[item.index].treatment_fee_type_name))])]}},{key:"treatment_fee",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"treatmentfee","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'treatmentfee')}},model:{value:(_vm.model.treatfees[item.index].treatment_fee),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "treatment_fee", $$v)},expression:"model.treatfees[item.index].treatment_fee"}}):_c('span',[_vm._v(_vm._s(_vm.model.treatfees[item.index].treatment_fee1))])]}},{key:"condition_id",fn:function(item){return [(_vm.edit)?_c('b-form-select',{attrs:{"size":"sm","id":"condition","options":_vm.condition},model:{value:(_vm.model.treatfees[item.index].condition_id),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "condition_id", $$v)},expression:"model.treatfees[item.index].condition_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select condition --")])])],2):_c('span',[_vm._v(_vm._s(_vm.model.treatfees[item.index].condition_name))])]}},{key:"percentage",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'percentage')}},model:{value:(_vm.model.treatfees[item.index].percentage),callback:function ($$v) {_vm.$set(_vm.model.treatfees[item.index], "percentage", $$v)},expression:"model.treatfees[item.index].percentage"}}):_c('span',[_vm._v(_vm._s(_vm.model.treatfees[item.index].percentage1))])]}}])}),_vm._v(" "),(_vm.edit)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.addtreatmentfee()}}},[_vm._v("Add New Treatment Fee")])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Other Fees"}},[_c('p',[_vm._v("\n\t\t\t\t\t\tAny other fees added here will be automatically apply to all hauls that unload in this location that contains water as a fluid type\n\t\t\t\t\t")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No other fees have been added","fields":[{key: 'delete', label: ' '}, {key: 'terminal_rate', label: 'Terminal Rate'}, {key: 'rate', label: 'Rate'}],"items":_vm.model.otherfees,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return _vm.edit?[_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removeotherfee(item.index)}}},[_c('i',{staticClass:"icon-close"})])]:undefined}},{key:"terminal_rate",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"otherfee","type":"text"},model:{value:(_vm.model.otherfees[item.index].terminal_rate),callback:function ($$v) {_vm.$set(_vm.model.otherfees[item.index], "terminal_rate", $$v)},expression:"model.otherfees[item.index].terminal_rate"}}):_c('span',[_vm._v(_vm._s(_vm.model.otherfees[item.index].terminal_rate))])]}},{key:"rate",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"otherrate","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.otherfees[item.index].rate),callback:function ($$v) {_vm.$set(_vm.model.otherfees[item.index], "rate", $$v)},expression:"model.otherfees[item.index].rate"}}):_c('span',[_vm._v(_vm._s(_vm.model.otherfees[item.index].rate1))])]}}])}),_vm._v(" "),(_vm.edit)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.otherfee()}}},[_vm._v("Add Other Fee")])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Unload Locations"}},[_c('p',[_vm._v("\n\t\t\t\t\tAny other fees added here will be automatically apply to all hauls that unload in this location that  contains water as a fluid type\n\t\t\t\t\t")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No Unload Locations have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: 'Unload Location'}, {key: 'shipping_cost', label: 'Shipping Cost'}, {key: 'monthly_commitment', label: 'Monthly Commitment'}, {key: 'contact_person', label: 'Contact Person'}, {key: 'contact_email', label: 'Contact Email'}, {key: 'show_details', label: ' '}],"items":_vm.model.unload_locations,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"show_details",fn:function(row){return [_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.model.unload_locations[row.index].terminal_costs.length>0 && !row.detailsShowing ? row.toggleDetails() : '')),(_vm.edit)?_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Add Terminal Cost","size":"sm"},on:{"click":function($event){_vm.addterminalcost(row)}}},[_c('i',{staticClass:"icon-plus"}),_vm._v(" Cost")]):_vm._e()]}},{key:"row-details",fn:function(row){return [_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"cols":"7"}},[_c('b',[_vm._v("Terminal Cost")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b',[_vm._v("Percentage")])])],1),_vm._v(" "),_vm._l((_vm.model.unload_locations[row.index].terminal_costs),function(terminal_cost,index1){return _c('b-row',{key:index1,staticClass:"mb-2  ml-2"},[_c('b-col',{staticClass:"p-1",attrs:{"cols":"7"}},[(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"terminal_cost_name","type":"text"},model:{value:(_vm.model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[row.index].terminal_costs[index1], "terminal_cost_name", $$v)},expression:"model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name"}}):_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name))])],1),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"3"}},[(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"terminal_cost_percentage","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'percentage')}},model:{value:(_vm.model.unload_locations[row.index].terminal_costs[index1].percentage),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[row.index].terminal_costs[index1], "percentage", $$v)},expression:"model.unload_locations[row.index].terminal_costs[index1].percentage"}}):_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[row.index].terminal_costs[index1].percentage1))])],1),_vm._v(" "),(_vm.edit)?_c('b-col',{staticClass:"p-0 pt-1",attrs:{"cols":"2"}},[_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Delete Terminal Cost","size":"sm"},on:{"click":function($event){_vm.removeterminalcost(row, index1)}}},[_c('i',{staticClass:"icon-close"})])],1):_vm._e()],1)})]}},{key:"name",fn:function(item){return [_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[0].name))])]}},{key:"shipping_cost",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"shipping_cost","type":"text"},model:{value:(_vm.model.unload_locations[item.index].shipping_cost),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "shipping_cost", $$v)},expression:"model.unload_locations[item.index].shipping_cost"}}):_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[item.index].shipping_cost))])]}},{key:"monthly_commitment",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"monthly_commitment","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'monthly_commitment')}},model:{value:(_vm.model.unload_locations[item.index].monthly_commitment),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "monthly_commitment", $$v)},expression:"model.unload_locations[item.index].monthly_commitment"}}):_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[item.index].monthly_commitment1))])]}},{key:"contact_person",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"contact_person","type":"text"},model:{value:(_vm.model.unload_locations[item.index].contact_person),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "contact_person", $$v)},expression:"model.unload_locations[item.index].contact_person"}}):_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[item.index].contact_person))])]}},{key:"contact_email",fn:function(item){return [(_vm.edit)?_c('b-form-input',{attrs:{"size":"sm","id":"contact_email","type":"text"},model:{value:(_vm.model.unload_locations[item.index].contact_email),callback:function ($$v) {_vm.$set(_vm.model.unload_locations[item.index], "contact_email", $$v)},expression:"model.unload_locations[item.index].contact_email"}}):_c('span',[_vm._v(_vm._s(_vm.model.unload_locations[item.index].contact_email))])]}}])})],1),_vm._v(" "),_c('b-card',{staticClass:"p-0 m-0 mb-3",attrs:{"title":"Load Locations"}},[(_vm.edit)?_c('div',[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L6","label":"","label-for":"loadLocationsID1","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.load_locations_id),callback:function ($$v) {_vm.load_locations_id=$$v},expression:"load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t\t\t\t")])],1):_c('p',[_vm._v(_vm._s(_vm.model.energy_company_id != null ? 'There are no registered Load locations for the selected Energy Company' : 'No Energy Company selected'))])],1):_c('div',[(_vm.model.load_locations.length > 0)?_c('b-form-group',{attrs:{"label-cols":1,"id":"L5","label":"","label-for":"loadLocationsID","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"text-field":"name","options":_vm.model.load_locations,"name":"Checkboxes2","plain":"","checked":true,"disabled":""}})],1):_c('p',[_vm._v("No Load Locations have been added")])],1)]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.update_terminal_agreement}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" \n\t\t\t\t\t\t\t"),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.edit_terminal_agreement}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()])],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_indexes_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c499110_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_indexes_vue__ = __webpack_require__(1169);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_indexes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c499110_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_indexes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Indexes")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Indexes - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"index":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIndex()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIndex()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newIndexModal}},[_vm._v("Add Index")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Index","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newIndex),callback:function ($$v) {_vm.newIndex=$$v},expression:"newIndex"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Settle Date","label-for":"settle_date"}},[_c('b-form-input',{attrs:{"id":"settle_date","type":"date"},model:{value:(_vm.model.settle_date),callback:function ($$v) {_vm.$set(_vm.model, "settle_date", $$v)},expression:"model.settle_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Fluid Type","label-for":"fluid_type"}},[_c('b-form-select',{attrs:{"disabled":_vm.fluid_types.length == 0,"value-field":"id","text-field":"name","id":"fluid_type","options":_vm.fluid_types},model:{value:(_vm.model.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type_id", $$v)},expression:"model.fluid_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Index","label-for":"index"}},[_c('b-form-input',{attrs:{"id":"index","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.index),callback:function ($$v) {_vm.$set(_vm.model, "index", $$v)},expression:"model.index"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"WADF","label-for":"wadf"}},[_c('b-form-input',{attrs:{"id":"wadf","type":"number"},nativeOn:{"blur":function($event){_vm.coordsBlur('wadf')}},model:{value:(_vm.model.wadf),callback:function ($$v) {_vm.$set(_vm.model, "wadf", $$v)},expression:"model.wadf"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newIndex=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveIndex}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_detail_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85fbd346_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_detail_vue__ = __webpack_require__(1171);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85fbd346_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Index - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editIndex}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteIndex}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Settle Date","label-for":"settle_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"settle_date","type":"text"},model:{value:(_vm.show.settle_date),callback:function ($$v) {_vm.$set(_vm.show, "settle_date", $$v)},expression:"show.settle_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"settle_date","type":"date"},model:{value:(_vm.model.settle_date),callback:function ($$v) {_vm.$set(_vm.model, "settle_date", $$v)},expression:"model.settle_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Fluid Type","label-for":"fluid_type"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"id":"fluid_type","plaintext":"","type":"text"},model:{value:(_vm.show.fluid_type),callback:function ($$v) {_vm.$set(_vm.show, "fluid_type", $$v)},expression:"show.fluid_type"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"disabled":_vm.fluid_types.length == 0,"value-field":"id","text-field":"name","id":"fluid_type","options":_vm.fluid_types},model:{value:(_vm.model.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_type_id", $$v)},expression:"model.fluid_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Index","label-for":"index"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"index","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.index),callback:function ($$v) {_vm.$set(_vm.model, "index", $$v)},expression:"model.index"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"index","type":"text"},model:{value:(_vm.show.index),callback:function ($$v) {_vm.$set(_vm.show, "index", $$v)},expression:"show.index"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"WADF","label-for":"wadf"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"wadf","type":"number"},nativeOn:{"blur":function($event){_vm.coordsBlur('wadf')}},model:{value:(_vm.model.wadf),callback:function ($$v) {_vm.$set(_vm.model, "wadf", $$v)},expression:"model.wadf"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"wadf","type":"text"},model:{value:(_vm.show.wadf),callback:function ($$v) {_vm.$set(_vm.show, "wadf", $$v)},expression:"show.wadf"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateIndex}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editIndex}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wti_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424789d1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wti_vue__ = __webpack_require__(1173);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424789d1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("WTI")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("WTI - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"wti":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashWti()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashWti()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newWtiModal}},[_vm._v("Add WTI")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New WTI","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newWti),callback:function ($$v) {_vm.newWti=$$v},expression:"newWti"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Settle Date","label-for":"settle_date"}},[_c('b-form-input',{attrs:{"id":"settle_date","type":"date"},model:{value:(_vm.model.settle_date),callback:function ($$v) {_vm.$set(_vm.model, "settle_date", $$v)},expression:"model.settle_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Future","label-for":"future"}},[_c('b-form-input',{attrs:{"id":"future","type":"date"},model:{value:(_vm.model.future),callback:function ($$v) {_vm.$set(_vm.model, "future", $$v)},expression:"model.future"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"WTI","label-for":"wti"}},[_c('b-form-input',{attrs:{"id":"wti","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.wti),callback:function ($$v) {_vm.$set(_vm.model, "wti", $$v)},expression:"model.wti"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Forex","label-for":"forex"}},[_c('b-form-input',{attrs:{"id":"forex","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.forex),callback:function ($$v) {_vm.$set(_vm.model, "forex", $$v)},expression:"model.forex"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newWti=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveWti}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wti_detail_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c44da74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wti_detail_vue__ = __webpack_require__(1175);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wti_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c44da74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wti_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("WTI - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editWti}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteWti}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Settle Date","label-for":"settle_date"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"settle_date","type":"text"},model:{value:(_vm.show.settle_date),callback:function ($$v) {_vm.$set(_vm.show, "settle_date", $$v)},expression:"show.settle_date"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"settle_date","type":"date"},model:{value:(_vm.model.settle_date),callback:function ($$v) {_vm.$set(_vm.model, "settle_date", $$v)},expression:"model.settle_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Future","label-for":"future"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"future","type":"text"},model:{value:(_vm.show.future),callback:function ($$v) {_vm.$set(_vm.show, "future", $$v)},expression:"show.future"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"future","type":"date"},model:{value:(_vm.model.future),callback:function ($$v) {_vm.$set(_vm.model, "future", $$v)},expression:"model.future"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"WTI","label-for":"wti"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"wti","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.wti),callback:function ($$v) {_vm.$set(_vm.model, "wti", $$v)},expression:"model.wti"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"wti","type":"text"},model:{value:(_vm.show.wti),callback:function ($$v) {_vm.$set(_vm.show, "wti", $$v)},expression:"show.wti"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Forex","label-for":"forex"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"forex","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'rate')}},model:{value:(_vm.model.forex),callback:function ($$v) {_vm.$set(_vm.model, "forex", $$v)},expression:"model.forex"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"forex","type":"text"},model:{value:(_vm.show.forex),callback:function ($$v) {_vm.$set(_vm.show, "forex", $$v)},expression:"show.forex"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateWti}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editWti}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_export_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1736f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_export_vue__ = __webpack_require__(1178);
function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_export_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1736f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_export_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Hauls - Export to PVR")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('download-excel',{attrs:{"data":_vm.items,"fields":_vm.json_fields,"type":"csv","name":_vm.filename}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Export to PVR'),expression:"'Export to PVR'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right",attrs:{"variant":"info"}},[_c('i',{staticClass:"fa fa-file-excel-o"})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.send_ftp),expression:"send_ftp"},{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Send to FTP'),expression:"'Send to FTP'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.SendFTP()}}},[_c('i',{staticClass:"fa fa-paper-plane-o"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"2","lg":"4"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f4",attrs:{"title":"Trucking Companies","sm":"6","md":"2","lg":"4"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"2","lg":"4"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f10",attrs:{"title":"End date","sm":"6","md":"2","lg":"4"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11",staticStyle:{"max-width":"90px","padding-top":"3px","padding-bottom":"3px"},attrs:{"md":"1"}},[_c('b-button',{staticStyle:{"height":"100%"},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_vm._e(),_vm._v(" "),(!_vm.loadingData)?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.filters_save.sortby,"sort-desc":_vm.filters_save.sortdesc},on:{"update:sortBy":function($event){_vm.$set(_vm.filters_save, "sortby", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filters_save, "sortdesc", $event)},"sort-changed":_vm.sortingChanged,"filtered":_vm.onFiltered}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31427bda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__(1181);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31427bda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getBy: function getBy(userId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/profile/' + userId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.profile];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	reset_password: function reset_password(dataUser) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/profile/reset_password/', dataUser, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = [response.data.status, response.data.message];
					resolve(data);
				} else {
					var data = [response.data.status, response.data.message];
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Profile")])])],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"User Role:","label-for":"RoleID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"RoleID","type":"text"},model:{value:(_vm.model.role),callback:function ($$v) {_vm.$set(_vm.model, "role", $$v)},expression:"model.role"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Username:","label-for":"Username","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.model.username),callback:function ($$v) {_vm.$set(_vm.model, "username", $$v)},expression:"model.username"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"First Name:","label-for":"FirstName","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.model.first_name),callback:function ($$v) {_vm.$set(_vm.model, "first_name", $$v)},expression:"model.first_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name:","label-for":"LastName","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.model.last_name),callback:function ($$v) {_vm.$set(_vm.model, "last_name", $$v)},expression:"model.last_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email:","label-for":"Email","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","type":"text"},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nopassword),expression:"!nopassword"}],attrs:{"label":"New Password","label-for":"nPassword","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"id":"nPassword","autocomplete":"new-password","type":"password"},model:{value:(_vm.new_password),callback:function ($$v) {_vm.new_password=$$v},expression:"new_password"}})],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nopassword),expression:"!nopassword"}],attrs:{"label":"Confirm new Password","label-for":"cnPassword","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"id":"cnPassword","autocomplete":"new-password","type":"password"},model:{value:(_vm.confirm_new_password),callback:function ($$v) {_vm.confirm_new_password=$$v},expression:"confirm_new_password"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.nopassword),expression:"nopassword"}],attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.resetpass}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Reset Password")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nopassword),expression:"!nopassword"}],attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updatepass}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update Password")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.nopassword),expression:"!nopassword"}],attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.cancelpass}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acbb0f64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(1183);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acbb0f64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"4"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v("Forgot Password")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-at"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user),expression:"user"}],staticClass:"form-control",attrs:{"type":"email","required":"","placeholder":"Enter your Email or Phone Number"},domProps:{"value":(_vm.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value}}})])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.$router.push('/')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.getUser}},[_vm._v("Reset Password")])],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logs_vue__ = __webpack_require__(565);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd12962_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logs_vue__ = __webpack_require__(1186);
function injectStyle (ssrContext) {
  __webpack_require__(1185)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd12962_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Logs")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('download-excel',{attrs:{"data":_vm.items,"fields":_vm.json_fields,"type":"csv","name":_vm.filename}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Export to csv'),expression:"'Export to csv'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right",attrs:{"variant":"info"}},[_c('i',{staticClass:"fa fa-file-excel-o"})])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}})],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_vm._e(),_vm._v(" "),(!_vm.loadingData)?_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"select_log",fn:function(row){return [_c('b-form-checkbox',{attrs:{"id":"checkbox"},on:{"change":function($event){_vm.checkedField(row)}},nativeOn:{"click":function($event){$event.stopPropagation();}}})]}}])}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_log_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5443fd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_log_vue__ = __webpack_require__(1189);
function injectStyle (ssrContext) {
  __webpack_require__(1188)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_log_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5443fd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_log_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Fail Log - "+_vm._s(_vm.model.id))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.changeLogStatus}},[_vm._v("Change Log Status to "+_vm._s(_vm.model.is_resolved ? 'Not Solved' : 'Solved'))]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":this.model.is_resolved},on:{"click":_vm.repostJsonData}},[_vm._v("Repost Json Data")])],2)],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t")])])],1):_c('div',[_c('b-card',[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Error Message","label-for":"logerror","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"logerror","type":"text","readonly":true},model:{value:(_vm.model.error),callback:function ($$v) {_vm.$set(_vm.model, "error", $$v)},expression:"model.error"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Resolution Status","label-for":"logstatus","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"logstatus","value":_vm.model.is_resolved ? 'Solved' : 'Not Solved',"type":"text","readonly":true}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Requested Service","label-for":"logservice","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"logservice","type":"text","readonly":true},model:{value:(_vm.model.service),callback:function ($$v) {_vm.$set(_vm.model, "service", $$v)},expression:"model.service"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Client Platform","label-for":"logclient","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"logclient","type":"text","readonly":true},model:{value:(_vm.model.client),callback:function ($$v) {_vm.$set(_vm.model, "client", $$v)},expression:"model.client"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Generated At","label-for":"logdate","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"logdate","type":"text","readonly":true},model:{value:(_vm.model.generated_at),callback:function ($$v) {_vm.$set(_vm.model, "generated_at", $$v)},expression:"model.generated_at"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Requested by User","label-for":"loguser","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"loguser","type":"text","readonly":true},model:{value:(_vm.model.user),callback:function ($$v) {_vm.$set(_vm.model, "user", $$v)},expression:"model.user"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Traceback","label-for":"logtraceback","label-cols":2,"horizontal":""}},[_c('pre',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"id":"logtraceback"}},[_vm._v(_vm._s(_vm.model.traceback))])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Last Repost At","label-for":"logrepostdate","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"logrepostdate","type":"text","readonly":true},model:{value:(_vm.model.last_repost_at),callback:function ($$v) {_vm.$set(_vm.model, "last_repost_at", $$v)},expression:"model.last_repost_at"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"Last Repost Response","label-for":"logrepostmessage","label-cols":4,"horizontal":""}},[_c('b-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.last_repost_response),expression:"model.last_repost_response"}],attrs:{"id":"logrepostmessage","variant":"primary"}},[_vm._v(_vm._s(_vm.model.last_repost_response ? _vm.model.last_repost_response.message : ''))]),_vm._v(" "),(_vm.model.last_repost_response)?_c('b-popover',{attrs:{"target":"logrepostmessage","triggers":"hover focus"}},[_c('template',{slot:"title"},[_c('strong',[_vm._v("Last Repost Response")])]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.model.last_repost_response.status)+": ")]),_vm._v(" "),_c('span',{class:_vm.model.last_repost_response.status === 'success' ? 'text-success' : 'text-danger'},[_c('strong',[_vm._v(_vm._s(_vm.model.last_repost_response.message))])]),_vm._v(" "),(_vm.model.last_repost_response.traceback)?_c('div',[_c('pre',[_vm._v(_vm._s(_vm.model.last_repost_response.traceback))])]):_vm._e()],2):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Posted Json Data","label-for":"logdata","label-cols":2,"horizontal":""}},[_c('div',{staticClass:"textarea",attrs:{"id":"logdata"},domProps:{"innerHTML":_vm._s(this.json)}})])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(1191);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ddc22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('b-input-group',[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a83bae8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(1193);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a83bae8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Houston, we have a problem!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for is temporarily unavailable.")])]),_vm._v(" "),_c('b-input-group',[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_companies_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50910438_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_companies_vue__ = __webpack_require__(1195);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_companies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50910438_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_companies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Terminal Companies")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Terminal Companies - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminalcompamies":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashEC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashEC()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newECModal}},[_vm._v("Add Terminal Company")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Terminal Company","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Terminal Company Name","label-for":"TerminalCompanyName","horizontal":""}},[_c('b-form-input',{attrs:{"id":"TerminalCompanyName","type":"text"},model:{value:(_vm.model.terminal_company_name),callback:function ($$v) {_vm.$set(_vm.model, "terminal_company_name", $$v)},expression:"model.terminal_company_name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newEC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveEC}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_company_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c5437b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_company_vue__ = __webpack_require__(1197);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c5437b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Terminal Company - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editEC}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteEC}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Company Name","label-for":"CompanyNameID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"CompanyNameID","type":"text"},model:{value:(_vm.model.company_name),callback:function ($$v) {_vm.$set(_vm.model, "company_name", $$v)},expression:"model.company_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"CompanyNameID","type":"text"},model:{value:(_vm.model.terminal_company_name),callback:function ($$v) {_vm.$set(_vm.model, "terminal_company_name", $$v)},expression:"model.terminal_company_name"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateEC}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editEC}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminals_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5dbb3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminals_vue__ = __webpack_require__(1199);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5dbb3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Terminal")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Terminal - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTerminal()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTerminal()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newTerminalModal}},[_vm._v("Add Terminal")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Terminal","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newTerminal),callback:function ($$v) {_vm.newTerminal=$$v},expression:"newTerminal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Terminal Name","label-for":"TerminalName","horizontal":""}},[_c('b-form-input',{attrs:{"id":"TerminalName","type":"text"},model:{value:(_vm.model.terminal_name),callback:function ($$v) {_vm.$set(_vm.model, "terminal_name", $$v)},expression:"model.terminal_name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTerminal=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveTerminal}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e60c1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_vue__ = __webpack_require__(1201);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terminal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e60c1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terminal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Terminal - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTerminal}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTerminal}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Terminal Name","label-for":"TerminalNameID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"TerminalNameID","type":"text"},model:{value:(_vm.model.terminal_name),callback:function ($$v) {_vm.$set(_vm.model, "terminal_name", $$v)},expression:"model.terminal_name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"TerminalNameID","type":"text"},model:{value:(_vm.model.terminal_name),callback:function ($$v) {_vm.$set(_vm.model, "terminal_name", $$v)},expression:"model.terminal_name"}})],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Petrotranz Business","label-for":"ptty"}},[(_vm.model.petrotranz!=null)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ptty","type":"text"},model:{value:(_vm.model.petrotranz.name),callback:function ($$v) {_vm.$set(_vm.model.petrotranz, "name", $$v)},expression:"model.petrotranz.name"}}):_vm._e()],1):_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Petrotranz Business","label-for":"ptty1"}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"autocomplete":"off","id":"ptty1","placeholder":"Search Filtered starting by ... (minimum 3 char)","type":"text"},on:{"input":_vm.veo},nativeOn:{"keydown":function($event){_vm.keyMonitor($event)}},model:{value:(_vm.model.filter),callback:function ($$v) {_vm.$set(_vm.model, "filter", $$v)},expression:"model.filter"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.suggest),expression:"suggest"}],attrs:{"select-size":_vm.size,"disabled":_vm.petrotranz.length==0,"value-field":"id","text-field":"name","id":"ptty1","options":_vm.petrotranz},on:{"input":function($event){_vm.select_petrotranz()}},model:{value:(_vm.model1.petrotranz_company_id),callback:function ($$v) {_vm.$set(_vm.model1, "petrotranz_company_id", $$v)},expression:"model1.petrotranz_company_id"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"})])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTerminal}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTerminal}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dash_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae869d78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dash_vue__ = __webpack_require__(1203);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae869d78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"mb-4"},[_c('b-col',{attrs:{"md":"12","lg":"3","xl":"2"}},[_c('h2',{staticClass:"pr-3 my-1 mb-3 mb-lg-0 pageinfo text-center text-lg-left"},[_vm._v("Dashboard")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.ec_filter,"title":"Energy Company"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","lg":"2","title":"Initial Date"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"input":function($event){_vm.iFilter()}},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"3","lg":"2","title":"End date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"input":function($event){_vm.eFilter()}},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b my-1",attrs:{"variant":"info","text":_vm.oa_filter,"title":"Operating Area"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.oaFilter('All Operating Areas', 0)}}},[_vm._v("All Operating Areas")]),_vm._v(" "),_vm._l((_vm.operating_areas_filter),function(operating_area_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.oaFilter(operating_area_filter.name, operating_area_filter.id)}}},[_vm._v(_vm._s(operating_area_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-btn',{staticClass:"pull-right pull-sm-left my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1),_vm._v(" "),_c('b-col',[((_vm.load_locations_id.length > 0 || _vm.unload_locations_id.length > 0))?_c('b-btn',{staticClass:"pull-right my-1",attrs:{"variant":"info"},on:{"click":function($event){_vm.generate_chart_click()}}},[_vm._v("Generate Chart")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"6"}},[_c('b-card',{staticClass:"bg-targets cart-100",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticStyle:{"line-height":"20px","margin-bottom":"5px"}},[_vm._v("Alerts")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('Unknow Load Location',13)}}},[_vm._v("Unknow Load Location : "+_vm._s(_vm.alerts.unknow_load_location)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('Price Anomaly',14)}}},[_vm._v("Price Anomaly        : "+_vm._s(_vm.alerts.price_anomaly))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('Duplicated Truck Ticket',15)}}},[_vm._v("Duplicated Truck Ticket : "+_vm._s(_vm.alerts.duplicated_truck_ticket))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0","line-height":"17px"},attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.alert_filter('Drive Time Anomaly',16)}}},[_vm._v("Drive Time Anomaly      : "+_vm._s(_vm.alerts.drive_time_anomaly))]),_vm._v(" "),_c('br')])],1)],1)],1),_vm._v(" "),((_vm.unloadlocationselect.length > 0 || _vm.loadlocationselect.length > 0))?_c('b-row',[_c('b-col',{attrs:{"sm":"4","lg":"4"}},[_c('b-row',[_c('b-col',[(_vm.loadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-size":"lg","label-class":"font-weight-bold pt-0","id":"L5","label":"Load Locations","label-for":"loadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.loadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.loadLocationsChange},model:{value:(_vm.load_locations_id),callback:function ($$v) {_vm.load_locations_id=$$v},expression:"load_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateLL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.LLToggleAll},model:{value:(_vm.llAllSelected),callback:function ($$v) {_vm.llAllSelected=$$v},expression:"llAllSelected"}},[_vm._v("\n\t\t\t\t\t            "+_vm._s(_vm.llAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t          ")])],1):_c('span',[_vm._v("No Load locations")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.unloadlocationselect.length > 0)?_c('b-form-group',{attrs:{"label-size":"lg","label-class":"font-weight-bold pt-0","id":"L5","label":"Unload Locations","label-for":"unloadLocationsID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"legal_location","options":_vm.unloadlocationselect,"name":"Checkboxes2","plain":""},on:{"input":_vm.unloadLocationsChange},model:{value:(_vm.unload_locations_id),callback:function ($$v) {_vm.unload_locations_id=$$v},expression:"unload_locations_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateUL,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.ULToggleAll},model:{value:(_vm.ulAllSelected),callback:function ($$v) {_vm.ulAllSelected=$$v},expression:"ulAllSelected"}},[_vm._v("\n\t\t\t\t\t        "+_vm._s(_vm.ulAllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t        ")])],1):_c('span',[_vm._v("No Unload locations")])],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8","lg":"8"}},[_c('b-card',{staticClass:"chart-wrapper",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('highcharts',{staticClass:"chart",attrs:{"options":_vm.chart}})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.users_select.length >0 && (_vm.load_locations_id.length > 0 || _vm.unload_locations_id.length > 0))?_c('b-row',[_c('b-col',{attrs:{"sm":"4","lg":"4"}},[_c('b-row',[_c('b-col',[(_vm.users_select.length > 0)?_c('b-form-group',{attrs:{"label-size":"lg","label-class":"font-weight-bold pt-0","id":"L6","label":"Drivers","label-for":"userID","vertical":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.users_select,"name":"Checkboxes2","plain":""},on:{"input":_vm.user_Change},model:{value:(_vm.users_id),callback:function ($$v) {_vm.users_id=$$v},expression:"users_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminate_user,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.user_ToggleAll},model:{value:(_vm.user_AllSelected),callback:function ($$v) {_vm.user_AllSelected=$$v},expression:"user_AllSelected"}},[_vm._v("\n\t\t\t\t\t          "+_vm._s(_vm.user_AllSelected ? 'Un-select All' : 'Select All')+"\n\t\t\t\t      ")])],1):_c('p',[_vm._v("No Users")])],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8","lg":"8"}},[_c('b-card',{staticClass:"chart-wrapper",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('highcharts',{staticClass:"chart",attrs:{"options":_vm.chart_users}})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newHaulModal",attrs:{"title":"Notification","size":"lg","hide-footer":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{attrs:{"hover":"","show-empty":"","stacked":"md","items":_vm.notification,"fields":_vm.fields},scopedSlots:_vm._u([{key:"action",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.adjust(row.item, row.index)}}},[_vm._v("\n            Accept\n            ")])]}},{key:"action1",fn:function(row){return [_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.ignore(row.item, row.index)}}},[_vm._v("\n            Ignore\n            ")])]}}])})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pwbi_listing_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2985800e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pwbi_listing_vue__ = __webpack_require__(1205);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pwbi_listing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2985800e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pwbi_listing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Report")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Report - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTerminal()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTerminal()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newTerminalModal}},[_vm._v("Add Report")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Power Bi","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newTerminal),callback:function ($$v) {_vm.newTerminal=$$v},expression:"newTerminal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Company Type","label-for":"pwbi0"}},[_c('b-form-select',{attrs:{"id":"pwbi0","value-field":"id","text-field":"name","options":_vm.company_type},on:{"input":function($event){_vm.select_company_type()}},model:{value:(_vm.model.company_type_id),callback:function ($$v) {_vm.$set(_vm.model, "company_type_id", $$v)},expression:"model.company_type_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[(_vm.model.company_type_id === 0)?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Companies","label-for":"pwbi1"}},[_c('b-form-select',{attrs:{"id":"pwbi1","value-field":"id","text-field":"name","options":_vm.company_name},on:{"input":function($event){_vm.select_company()}},model:{value:(_vm.model.company_id),callback:function ($$v) {_vm.$set(_vm.model, "company_id", $$v)},expression:"model.company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1):_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Companies","label-for":"pwbi1"}},[_c('b-form-select',{attrs:{"id":"pwbi1","value-field":"id","text-field":"name","options":_vm.company_name},on:{"input":function($event){_vm.select_company()}},model:{value:(_vm.model.company_id),callback:function ($$v) {_vm.$set(_vm.model, "company_id", $$v)},expression:"model.company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L0","label":"Report Name","label-for":"pwb3","horizontal":""}},[_c('b-form-input',{attrs:{"id":"pwb3","type":"text","placeholder":"Report Name"},model:{value:(_vm.model.report_name),callback:function ($$v) {_vm.$set(_vm.model, "report_name", $$v)},expression:"model.report_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Activate Power Bi","label-for":"ULID","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"ULID"},model:{value:(_vm.model.activate_pb),callback:function ($$v) {_vm.$set(_vm.model, "activate_pb", $$v)},expression:"model.activate_pb"}})],1),_vm._v(" "),(!_vm.model.activate_pb)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Pdf File","label-for":"pwb2","horizontal":""}},[_c('input',{ref:"file",attrs:{"type":"file","id":"files","accept":"application/pdf"},on:{"change":function($event){_vm.handleFileUpload()}}})]):_vm._e(),_vm._v(" "),(_vm.model.activate_pb)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Url","label-for":"pwb3","horizontal":""}},[_c('b-form-input',{attrs:{"id":"pwb3","type":"url","placeholder":"Url"},model:{value:(_vm.model.url),callback:function ($$v) {_vm.$set(_vm.model, "url", $$v)},expression:"model.url"}})],1):_vm._e()],1)],1),_vm._v(" "),(_vm.progress)?_c('b-row',[(_vm.load_pdf==='Saving PDF file.....')?_c('b-col',{attrs:{"md":"10"}},[_c('h5',{staticClass:"mt-3"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_vm._v(" "+_vm._s(_vm.load_pdf))]),_vm._v(" "),_c('b-progress',{staticClass:"mb-3",attrs:{"value":_vm.uploadPercentage,"max":100,"show-progress":"","animated":""}})],1):_c('b-col',{attrs:{"md":"10"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.load_pdf))]),_vm._v(" "),_c('b-progress',{staticClass:"mb-3",attrs:{"value":_vm.uploadPercentage,"max":100,"show-progress":"","animated":""}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.url!='')?_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","allowfullscreen":"","frameborder":"0","src":_vm.url}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTerminal=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveReport}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Report - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTerminal}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTerminal}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Company Type","label-for":"pw0","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"pw0","type":"text"},model:{value:(_vm.model.company_type),callback:function ($$v) {_vm.$set(_vm.model, "company_type", $$v)},expression:"model.company_type"}}):_c('b-form-select',{attrs:{"id":"pw0","value-field":"id","text-field":"name","options":_vm.company_type},on:{"input":function($event){_vm.select_company_type()}},model:{value:(_vm.model.company_type_id),callback:function ($$v) {_vm.$set(_vm.model, "company_type_id", $$v)},expression:"model.company_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Company Name","label-for":"pw1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"pw1","type":"text"},model:{value:(_vm.model.company_name),callback:function ($$v) {_vm.$set(_vm.model, "company_name", $$v)},expression:"model.company_name"}}):_c('b-form-select',{attrs:{"id":"pw1","value-field":"id","text-field":"name","options":_vm.company_name},on:{"input":function($event){_vm.select_company()}},model:{value:(_vm.model.company_id),callback:function ($$v) {_vm.$set(_vm.model, "company_id", $$v)},expression:"model.company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Report Name","label-for":"pw2","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"pw2","type":"text"},model:{value:(_vm.model.report_name),callback:function ($$v) {_vm.$set(_vm.model, "report_name", $$v)},expression:"model.report_name"}}):_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"pw2","type":"text"},model:{value:(_vm.model.report_name),callback:function ($$v) {_vm.$set(_vm.model, "report_name", $$v)},expression:"model.report_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Activate Power Bi","label-for":"ULID","horizontal":""}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"ULID","disabled":""},model:{value:(_vm.model.activate_pb),callback:function ($$v) {_vm.$set(_vm.model, "activate_pb", $$v)},expression:"model.activate_pb"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"ULID"},on:{"change":_vm.toggle},model:{value:(_vm.model.activate_pb),callback:function ($$v) {_vm.$set(_vm.model, "activate_pb", $$v)},expression:"model.activate_pb"}})],1),_vm._v(" "),(!_vm.model.activate_pb && _vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Pdf File","label-for":"pwb2","horizontal":""}},[(_vm.model.pdf!=='')?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"pw2","type":"text"},model:{value:(_vm.model.pdf),callback:function ($$v) {_vm.$set(_vm.model, "pdf", $$v)},expression:"model.pdf"}}):_vm._e(),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","id":"files","accept":"application/pdf"},on:{"change":function($event){_vm.handleFileUpload()}}})],1):_vm._e(),_vm._v(" "),(!_vm.model.activate_pb && !_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Pdf File","label-for":"pwb2","horizontal":""}},[_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"pw2","type":"text"},model:{value:(_vm.model.pdf),callback:function ($$v) {_vm.$set(_vm.model, "pdf", $$v)},expression:"model.pdf"}})],1):_vm._e(),_vm._v(" "),(_vm.model.activate_pb)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Url","label-for":"pw3","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"pw3","type":"text"},model:{value:(_vm.model.url),callback:function ($$v) {_vm.$set(_vm.model, "url", $$v)},expression:"model.url"}}):_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"pw3","type":"text"},model:{value:(_vm.model.url),callback:function ($$v) {_vm.$set(_vm.model, "url", $$v)},expression:"model.url"}})],1):_vm._e(),_vm._v(" "),(_vm.model.url!='')?_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","allowfullscreen":"","frameborder":"0","src":_vm.model.url}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTerminal}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTerminal}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_other_report_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252b487a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_other_report_vue__ = __webpack_require__(1208);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_other_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252b487a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_other_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Monthly Report")])])],1),_vm._v(" "),_c('div',[_c('b-card',[_c('b-row',[(_vm.role==='super_admin')?_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L1","label":"Company Type","label-for":"pw0","horizontal":""}},[_c('b-form-select',{attrs:{"id":"pw0","value-field":"id","text-field":"name","options":_vm.company_type},on:{"input":function($event){_vm.select_company_type()}},model:{value:(_vm.model.company_type_id),callback:function ($$v) {_vm.$set(_vm.model, "company_type_id", $$v)},expression:"model.company_type_id"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.role==='super_admin')?_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label-cols":3,"id":"L2","label":"Company Name","label-for":"pw1","horizontal":""}},[_c('b-form-select',{attrs:{"id":"pw1","value-field":"id","text-field":"name","options":_vm.company_name},on:{"input":function($event){_vm.select_company()}},model:{value:(_vm.model.company_id),callback:function ($$v) {_vm.$set(_vm.model, "company_id", $$v)},expression:"model.company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select company --")])])],2)],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[(_vm.model.report.length>0)?_c('b-form-group',{attrs:{"label-cols":3,"id":"L4","label":"Select Report","label-for":"pw2","horizontal":""}},[_c('b-form-select',{attrs:{"id":"pw2","value-field":"id","text-field":"report_name","options":_vm.model.report},on:{"input":function($event){_vm.select_report()}},model:{value:(_vm.report_id),callback:function ($$v) {_vm.report_id=$$v},expression:"report_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select report --")])])],2)],1):_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.view),expression:"view"}],attrs:{"label-cols":3,"id":"L5","label":"","label-for":"pw2","horizontal":""}},[_c('p',[_vm._v(_vm._s(_vm.no_report))])])],1)],1),_vm._v(" "),(_vm.progress)?_c('b-row',[(_vm.load_pdf==='Loading PDF file.....')?_c('b-col',{attrs:{"md":"12"}},[_c('h5',{staticClass:"text-center mt-3"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_vm._v(" "+_vm._s(_vm.load_pdf))])]):_c('b-col',{attrs:{"md":"12"}},[_c('h5',{staticClass:"text-center mt-3"},[_vm._v(_vm._s(_vm.load_pdf))])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',[(_vm.url!=='')?_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","allowfullscreen":"","frameborder":"0","src":_vm.url}}):_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v("No Reports\n\t\t\t\t\t            ")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_duplicated_hauls_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961a3310_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_duplicated_hauls_vue__ = __webpack_require__(1211);
function injectStyle (ssrContext) {
  __webpack_require__(1210)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-961a3310"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_duplicated_hauls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_961a3310_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_duplicated_hauls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Duplicate Hauls")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Select Datapoints'),expression:"'Select Datapoints'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openSelectColumns()}}},[_c('i',{staticClass:"fa fa-cog"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f2",attrs:{"title":"Drivers","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.driver_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.dFilter('All Drivers', 0)}}},[_vm._v("All Drivers")]),_vm._v(" "),_vm._l((_vm.drivers_filter),function(driver_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.dFilter(driver_filter.username, driver_filter.id)}}},[_vm._v(_vm._s(driver_filter.username))])})],2)],1),_vm._v(" "),(_vm.role !=='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1 f4",attrs:{"title":"Trucking Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f5",attrs:{"title":"Trucks","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.truck_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tFilter('All Trucks', 0)}}},[_vm._v("All Trucks")]),_vm._v(" "),_vm._l((_vm.trucks_filter),function(truck_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tFilter(truck_filter.truck_name, truck_filter.id)}}},[_vm._v(_vm._s(truck_filter.truck_name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f6",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.load_name,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Loads', 0)}}},[_vm._v("All Loads")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.unload_name,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_id'),"value":"haul_id"},on:{"change":function($event){_vm.actionField('haul_id', 'ID', 1)}}},[_vm._v("Id")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('full_name'),"value":"full_name"},on:{"change":function($event){_vm.actionField('full_name', 'Driver', 4)}}},[_vm._v("Driver")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='operations_manager' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('energy_company'),"value":"energy_company"},on:{"change":function($event){_vm.actionField('energy_company', 'Energy Company', 2)}}},[_vm._v("Energy Company")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('load_location'),"value":"load_location"},on:{"change":function($event){_vm.actionField('load_location', 'Load', 5)}}},[_vm._v("Load")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_location'),"value":"unload_location"},on:{"change":function($event){_vm.actionField('unload_location', 'Unload', 6)}}},[_vm._v("Unload")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck'),"value":"truck"},on:{"change":function($event){_vm.actionField('truck','Truck',7)}}},[_vm._v("Truck")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_actual'),"value":"volume_actual"},on:{"change":function($event){_vm.actionField('volume_actual','Deliveries',9)}}},[_vm._v("Deliveries")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('oil_actual'),"value":"oil_actual"},on:{"change":function($event){_vm.actionField('oil_actual','Oil',10)}}},[_vm._v("Oil")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_actual'),"value":"water_actual"},on:{"change":function($event){_vm.actionField('water_actual', 'Water',11)}}},[_vm._v("Water")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('bsw'),"value":"bsw"},on:{"change":function($event){_vm.actionField('bsw', 'BS&W', 12)}}},[_vm._v("BS&W")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_date'),"value":"haul_start_date"},on:{"change":function($event){_vm.actionField('haul_start_date', 'Start Date', 13)}}},[_vm._v("Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_date'),"value":"haul_end_date"},on:{"change":function($event){_vm.actionField('haul_end_date', 'End Date', 14)}}},[_vm._v("End Date")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_type'),"value":"fluid_type"},on:{"change":function($event){_vm.actionField('fluid_type','Fluid Type', 15)}}},[_vm._v("Fluid Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trucking_company'),"value":"trucking_company"},on:{"change":function($event){_vm.actionField('trucking_company','Trucking Company', 3)}}},[_vm._v("Trucking Company")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_percentage_actual'),"value":"water_percentage_actual"},on:{"change":function($event){_vm.actionField('water_percentage_actual','Water Cut Actual', 16)}}},[_vm._v("Water Cut Actual")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_time'),"value":"haul_start_time"},on:{"change":function($event){_vm.actionField('haul_start_time','Start Time', 17)}}},[_vm._v("Start Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_time'),"value":"haul_end_time"},on:{"change":function($event){_vm.actionField('haul_end_time','End Time', 18)}}},[_vm._v("End Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_speed'),"value":"avg_speed"},on:{"change":function($event){_vm.actionField('avg_speed','Speed Avg', 19)}}},[_vm._v("Speed Avg")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_regular'),"value":"cost_regular"},on:{"change":function($event){_vm.actionField('cost_regular','Regular Cost', 20)}}},[_vm._v("Regular Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_stb'),"value":"cost_stb"},on:{"change":function($event){_vm.actionField('cost_stb','STB Cost', 21)}}},[_vm._v("STB Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_cost'),"value":"total_cost"},on:{"change":function($event){_vm.actionField('total_cost','Total Cost', 22)}}},[_vm._v("Total Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('flags'),"value":"flags"},on:{"change":function($event){_vm.actionField('flags','Flags', 23)}}},[_vm._v("Flags")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n          Save\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_discrepancy_report_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b7e8c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_discrepancy_report_vue__ = __webpack_require__(1214);
function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13b7e8c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_discrepancy_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b7e8c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_discrepancy_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Discrepancy Report")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),_c('download-excel',{ref:"excel",attrs:{"data":_vm.items_csv,"fields":_vm.json_fields,"type":"csv","name":_vm.filename}},[_c('span',[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Export to csv'),expression:"'Export to csv'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"}},[_c('i',{staticClass:"fa fa-file-excel-o"})])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),(_vm.role !=='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1 f4",attrs:{"title":"Trucking Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f6",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.load_name,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Loads', 0)}}},[_vm._v("All Loads")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.unload_name,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"bsw_unload",fn:function(row){return [(row.item.bsw_unload!=row.item.bsw && row.item.bsw_unload!='--')?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.form1(row.item.bsw_unload)))]):_c('span',[_vm._v(_vm._s(_vm.form1(row.item.bsw_unload)))])]}},{key:"oil_unload",fn:function(row){return [(row.item.oil_unload!=row.item.oil_actual && row.item.oil_unload!='--')?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.form(row.item.oil_unload)))]):_c('span',[_vm._v(_vm._s(_vm.form(row.item.oil_unload)))])]}},{key:"volume_actual_unload",fn:function(row){return [(row.item.volume_actual_unload!=row.item.volume_actual && row.item.volume_actual_unload!='--')?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.form(row.item.volume_actual_unload)))]):_c('span',[_vm._v(_vm._s(_vm.form(row.item.volume_actual_unload)))])]}},{key:"bsw",fn:function(row){return [(row.item.bsw_unload!=row.item.bsw  && row.item.bsw_unload!='--')?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.form1(row.item.bsw)))]):_c('span',[_vm._v(_vm._s(_vm.form1(row.item.bsw)))])]}},{key:"oil_actual",fn:function(row){return [(row.item.oil_unload!=row.item.oil_actual  && row.item.oil_unload!='--')?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.form(row.item.oil_actual)))]):_c('span',[_vm._v(_vm._s(_vm.form(row.item.oil_actual)))])]}},{key:"volume_actual",fn:function(row){return [(row.item.volume_actual_unload!=row.item.volume_actual  && row.item.volume_actual_unload!='--')?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.form(row.item.volume_actual)))]):_c('span',[_vm._v(_vm._s(_vm.form(row.item.volume_actual)))])]}},{key:"action",fn:function(row){return [(row.item.volume_actual_unload!='--' && row.item.oil_unload!='--')?_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.adjust(row.item, row.index)}}},[_vm._v("\n              Adjust\n            ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_id'),"value":"haul_id"},on:{"change":function($event){_vm.actionField('haul_id', 'ID', 1)}}},[_vm._v("Id")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('full_name'),"value":"full_name"},on:{"change":function($event){_vm.actionField('full_name', 'Driver', 4)}}},[_vm._v("Driver")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='operations_manager' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('energy_company'),"value":"energy_company"},on:{"change":function($event){_vm.actionField('energy_company', 'Energy Company', 2)}}},[_vm._v("Energy Company")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('load_location'),"value":"load_location"},on:{"change":function($event){_vm.actionField('load_location', 'Load', 5)}}},[_vm._v("Load")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_location'),"value":"unload_location"},on:{"change":function($event){_vm.actionField('unload_location', 'Unload', 6)}}},[_vm._v("Unload")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck'),"value":"truck"},on:{"change":function($event){_vm.actionField('truck','Truck',7)}}},[_vm._v("Truck")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_actual'),"value":"volume_actual"},on:{"change":function($event){_vm.actionField('volume_actual','Deliveries',9)}}},[_vm._v("Deliveries")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('oil_actual'),"value":"oil_actual"},on:{"change":function($event){_vm.actionField('oil_actual','Oil',10)}}},[_vm._v("Oil")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_actual'),"value":"water_actual"},on:{"change":function($event){_vm.actionField('water_actual', 'Water',11)}}},[_vm._v("Water")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('bsw'),"value":"bsw"},on:{"change":function($event){_vm.actionField('bsw', 'BS&W', 12)}}},[_vm._v("BS&W")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_date'),"value":"haul_start_date"},on:{"change":function($event){_vm.actionField('haul_start_date', 'Start Date', 13)}}},[_vm._v("Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_date'),"value":"haul_end_date"},on:{"change":function($event){_vm.actionField('haul_end_date', 'End Date', 14)}}},[_vm._v("End Date")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_type'),"value":"fluid_type"},on:{"change":function($event){_vm.actionField('fluid_type','Fluid Type', 15)}}},[_vm._v("Fluid Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trucking_company'),"value":"trucking_company"},on:{"change":function($event){_vm.actionField('trucking_company','Trucking Company', 3)}}},[_vm._v("Trucking Company")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_percentage_actual'),"value":"water_percentage_actual"},on:{"change":function($event){_vm.actionField('water_percentage_actual','Water Cut Actual', 16)}}},[_vm._v("Water Cut Actual")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_time'),"value":"haul_start_time"},on:{"change":function($event){_vm.actionField('haul_start_time','Start Time', 17)}}},[_vm._v("Start Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_time'),"value":"haul_end_time"},on:{"change":function($event){_vm.actionField('haul_end_time','End Time', 18)}}},[_vm._v("End Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_speed'),"value":"avg_speed"},on:{"change":function($event){_vm.actionField('avg_speed','Speed Avg', 19)}}},[_vm._v("Speed Avg")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_regular'),"value":"cost_regular"},on:{"change":function($event){_vm.actionField('cost_regular','Regular Cost', 20)}}},[_vm._v("Regular Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_stb'),"value":"cost_stb"},on:{"change":function($event){_vm.actionField('cost_stb','STB Cost', 21)}}},[_vm._v("STB Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_cost'),"value":"total_cost"},on:{"change":function($event){_vm.actionField('total_cost','Total Cost', 22)}}},[_vm._v("Total Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('flags'),"value":"flags"},on:{"change":function($event){_vm.actionField('flags','Flags', 23)}}},[_vm._v("Flags")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n          Save\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receipt_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d271744c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receipt_vue__ = __webpack_require__(1217);
function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d271744c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d271744c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receipt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Tickets Missing Hauls")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),_c('download-excel',{ref:"excel",attrs:{"data":_vm.items_csv,"fields":_vm.json_fields,"type":"csv","name":_vm.filename}},[_c('span',[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Export to csv'),expression:"'Export to csv'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"}},[_c('i',{staticClass:"fa fa-file-excel-o"})])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"bsw_unload",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm.form1(row.item.bsw_unload)))])]}},{key:"oil_unload",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm.form(row.item.oil_unload)))])]}},{key:"volume_actual_unload",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm.form(row.item.volume_actual_unload)))])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_request_hauls_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547913b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_request_hauls_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-547913b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_request_hauls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547913b8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_request_hauls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Request Hauls")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}})],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"ml-auto my-1",attrs:{"order":"2","order-md":"5","cols":"4","sm":"6","md":"2","lg":"2"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.showNewHaulModal()}}},[_vm._v("Request Haul")])],1)],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f4",attrs:{"title":"Trucking Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f6",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.load_name,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Loads', 0)}}},[_vm._v("All Loads")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.unload_name,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"title":"Fluid Types","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.fluid_type_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ftFilter('All Fluid Types', 0)}}},[_vm._v("All Fluid Types")]),_vm._v(" "),_vm._l((_vm.fluid_types_filter),function(fluid_type_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ftFilter(fluid_type_filter.name, fluid_type_filter.id)}}},[_vm._v(_vm._s(fluid_type_filter.name))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered}})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newHaulModal",staticClass:"newHaulModal",attrs:{"title":"New Request Haul","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.energy_company_select.length==0,"value-field":"id","text-field":"energy_company_name","id":"energy_companies_id","options":_vm.newHaul.energy_company_select},on:{"input":function($event){_vm.selects_energy_company()}},model:{value:(_vm.newHaul.energy_companies_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "energy_companies_id", $$v)},expression:"newHaul.energy_companies_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"trucking_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.trucking_company_select.length==0,"value-field":"id","text-field":"trucking_company_name","id":"trucking_company_id","options":_vm.newHaul.trucking_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.newHaul.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "trucking_company_id", $$v)},expression:"newHaul.trucking_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Operating Area","label-for":"operating_area"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.operating_area_select.length==0,"value-field":"id","text-field":"operating_area_name","id":"operating_area","options":_vm.newHaul.operating_area_select},on:{"input":function($event){_vm.selects_operating_area()}},model:{value:(_vm.newHaul.operating_area_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "operating_area_id", $$v)},expression:"newHaul.operating_area_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Load","label-for":"load_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.load_location_select.length==0,"id":"load_location_id","value-field":"id","text-field":"legal_location","options":_vm.newHaul.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.newHaul.load_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "load_location_id", $$v)},expression:"newHaul.load_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload","label-for":"unload_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.unload_location_select.length==0,"id":"unload_location_id","value-field":"id","text-field":"legal_location","options":_vm.newHaul.unload_location_select},model:{value:(_vm.newHaul.unload_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "unload_location_id", $$v)},expression:"newHaul.unload_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Fluid","label-for":"fluid_type"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.fluid_type_select.length==0,"id":"fluid_type_id","value-field":"id","text-field":"name","options":_vm.newHaul.fluid_type_select},model:{value:(_vm.newHaul.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "fluid_type_id", $$v)},expression:"newHaul.fluid_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume","label-for":"volume"}},[_c('b-form-input',{attrs:{"id":"volume","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume')},"blur":function($event){_vm.inputBlur('volume')}},model:{value:(_vm.newHaul.volume),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume", $$v)},expression:"newHaul.volume"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Dispatch Date","label-for":"dispatch_date"}},[_c('b-form-input',{attrs:{"id":"dispatch_date","type":"date"},model:{value:(_vm.newHaul.dispatch_date),callback:function ($$v) {_vm.$set(_vm.newHaul, "dispatch_date", $$v)},expression:"newHaul.dispatch_date"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewHaulModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.save_click()}}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_request_h_vue__ = __webpack_require__(585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf58378_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_request_h_vue__ = __webpack_require__(1223);
function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cf58378"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_request_h_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf58378_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_request_h_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Requested Hauls")])])],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f6",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.load_name,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Loads', 0)}}},[_vm._v("All Loads")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.unload_name,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),(_vm.role =='super_admin' ||  _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Fluid Types","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.fluid_type_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ftFilter('All Fluid Types', 0)}}},[_vm._v("All Fluid Types")]),_vm._v(" "),_vm._l((_vm.fluid_types_filter),function(fluid_type_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ftFilter(fluid_type_filter.name, fluid_type_filter.id)}}},[_vm._v(_vm._s(fluid_type_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"action",fn:function(row){return [(row.item.status_id==4)?_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.adjust(row.item, row.index)}}},[_vm._v("\n                        Accept\n                        ")]):_c('b-button',{staticClass:"mr-1",attrs:{"size":"sm"},on:{"click":function($event){_vm.adjust(row.item, row.index)}}},[_vm._v("\n                        Reject\n                        ")])]}}])}),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443061c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__ = __webpack_require__(1226);
function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-443061c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443061c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Trucking Company Invoices")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Trucking Company Invoices - Trash")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[(_vm.role !='analyst')?_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"},on:{"click":function($event){_vm.send_notification_click()}}},[_c('i',{staticClass:"fa fa-send"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"ml-auto my-1",attrs:{"order":"2","order-md":"5","cols":"4","sm":"6","md":"2","lg":"2"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.showNewInvoiceModal()}}},[_vm._v("Add Invoice")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked,"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"newInvoiceModal",staticClass:"newHaulModal",attrs:{"title":"New Invoice","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"trucking_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.trucking_company_select.length==0,"value-field":"id","text-field":"trucking_company_name","id":"trucking_company","options":_vm.newHaul.trucking_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.newHaul.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "trucking_company_id", $$v)},expression:"newHaul.trucking_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.energy_company_select.length==0,"value-field":"id","text-field":"energy_company_name","id":"energy_company","options":_vm.newHaul.energy_company_select},model:{value:(_vm.newHaul.energy_company_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "energy_company_id", $$v)},expression:"newHaul.energy_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Invoice Ref","label-for":"invoice_ref"}},[_c('b-form-input',{attrs:{"id":"invoice_ref","type":"text"},model:{value:(_vm.newHaul.volume),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume", $$v)},expression:"newHaul.volume"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Cost Code/PO","label-for":"cost_code"}},[_c('b-form-input',{attrs:{"id":"cost_code","type":"text"},model:{value:(_vm.newHaul.cost_code),callback:function ($$v) {_vm.$set(_vm.newHaul, "cost_code", $$v)},expression:"newHaul.cost_code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Date","label-for":"date"}},[_c('b-form-input',{attrs:{"id":"date","type":"date"},model:{value:(_vm.newHaul.date),callback:function ($$v) {_vm.$set(_vm.newHaul, "date", $$v)},expression:"newHaul.date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Surcharge %","label-for":"surcharge"}},[_c('b-form-input',{attrs:{"id":"surcharge","type":"text","placeholder":"0.00"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'surcharge')},"blur":function($event){_vm.inputBlur('surcharge')}},model:{value:(_vm.newHaul.surcharge),callback:function ($$v) {_vm.$set(_vm.newHaul, "surcharge", $$v)},expression:"newHaul.surcharge"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewInvoiceModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.save_click()}}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newModal",staticClass:"newHaulModal",attrs:{"title":"Invoice Notification","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newModal),callback:function ($$v) {_vm.newModal=$$v},expression:"newModal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"trucking_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.company_name.length==0,"value-field":"id","text-field":"trucking_company_name","id":"trucking_company","options":_vm.company_name},on:{"input":function($event){_vm.selects_trucking_company_1()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.energy_companies.length==0,"value-field":"id","text-field":"energy_company_name","id":"energy_company","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Invoice Ref","label-for":"inv0"}},[_c('b-form-select',{attrs:{"disabled":_vm.invoices_filter.length==0,"value-field":"id","text-field":"invoice_ref","id":"inv0","options":_vm.invoices_filter},model:{value:(_vm.model.invoice_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_id", $$v)},expression:"model.invoice_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select invoice ref --")])])],2)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.sendbtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.send_click()}}},[_vm._v("Send")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_vue__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_472072af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_vue__ = __webpack_require__(1228);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_472072af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Invoice - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTerminal}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTerminal}},[_vm._v("Delete")])],2),_vm._v(" "),(_vm.role !='analyst' && !_vm.edit)?_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"},on:{"click":function($event){_vm.send_click()}}},[_c('i',{staticClass:"fa fa-send"})]):_vm._e(),_vm._v(" "),_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Select Datapoints'),expression:"'Select Datapoints'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openSelectColumns()}}},[_c('i',{staticClass:"fa fa-bullseye"})])],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"tc"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"tc","type":"text"},model:{value:(_vm.model.trucking_company_name),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_name", $$v)},expression:"model.trucking_company_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.trucking_companies.length==0,"value-field":"id","text-field":"trucking_company_name","id":"tc","options":_vm.trucking_companies},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"tc"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"tc","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.energy_companies.length==0,"value-field":"id","text-field":"energy_company_name","id":"tc","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Invoice Ref","label-for":"invoice_ref"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"invoice_ref","type":"text"},model:{value:(_vm.model.invoice_ref),callback:function ($$v) {_vm.$set(_vm.model, "invoice_ref", $$v)},expression:"model.invoice_ref"}}):_c('b-form-input',{attrs:{"id":"invoice_ref","type":"text"},model:{value:(_vm.model.invoice_ref),callback:function ($$v) {_vm.$set(_vm.model, "invoice_ref", $$v)},expression:"model.invoice_ref"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Cost Code/PO","label-for":"cost_code"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"cost_code","type":"text"},model:{value:(_vm.model.cost_code),callback:function ($$v) {_vm.$set(_vm.model, "cost_code", $$v)},expression:"model.cost_code"}}):_c('b-form-input',{attrs:{"id":"cost_code","type":"text"},model:{value:(_vm.model.cost_code),callback:function ($$v) {_vm.$set(_vm.model, "cost_code", $$v)},expression:"model.cost_code"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Date","label-for":"date"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"date","type":"text","readonly":""},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}}):_c('b-form-input',{attrs:{"id":"date","type":"date","readonly":!_vm.edit},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Surcharge Value","label-for":"surcharge"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"surcharge","plaintext":"","type":"text"},model:{value:(_vm.model.surcharge),callback:function ($$v) {_vm.$set(_vm.model, "surcharge", $$v)},expression:"model.surcharge"}}):_c('b-form-input',{attrs:{"id":"surcharge","type":"text","placeholder":"0.00"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'surcharge')},"blur":function($event){_vm.inputBlur('surcharge')}},model:{value:(_vm.model.surcharge),callback:function ($$v) {_vm.$set(_vm.model, "surcharge", $$v)},expression:"model.surcharge"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"vertical":"","label":"","label-for":"summary"}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No Summary","fields":_vm.fields1,"items":_vm.model.summary,"stacked":"sm","outlined":"","small":"","bordered":"","hover":""},on:{"row-clicked":_vm.rowClicked}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"1","md":"1"}},[_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Sub-Total")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4","md":"4"}}),_vm._v(" "),_c('b-col',{staticClass:"p-1 text-center",attrs:{"cols":"1","md":"1"}},[_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.model.rate_avg))])])]),_vm._v(" "),_c('b-col',{staticClass:"p-1 text-center",attrs:{"cols":"1","md":"1"}},[_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.model.volume_avg))])])]),_vm._v(" "),_c('b-col',{staticClass:"p-1 text-left",attrs:{"cols":"1","md":"1"}},[_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.model.s_total_avg))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h3')])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h5',[_vm._v("Hauls")]),_vm._v(" "),_c('b-form-group',{attrs:{"vertical":"","label":"","label-for":"hauls"}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No Hauls","fields":_vm.fields,"items":_vm.model.hauls,"stacked":"sm","outlined":"","small":"","bordered":"","hover":""},on:{"row-clicked":_vm.rowClicked}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTerminal}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTerminal}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)])],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('ticket'),"value":"ticket"},on:{"change":function($event){_vm.actionField('ticket', 'Ticket #',1)}}},[_vm._v("Ticket #")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_date'),"value":"haul_start_date"},on:{"change":function($event){_vm.actionField('haul_start_date', 'Start Date', 2)}}},[_vm._v("Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('load_location'),"value":"load_location"},on:{"change":function($event){_vm.actionField('load_location', 'Load', 3)}}},[_vm._v("Load")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_location'),"value":"unload_location"},on:{"change":function($event){_vm.actionField('unload_location', 'Unload', 4)}}},[_vm._v("Unload")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('terminal_boss'),"value":"terminal_boss"},on:{"change":function($event){_vm.actionField('terminal_boss', 'Terminal Boss Ticket',5)}}},[_vm._v("Terminal Boss Ticket")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume'),"value":"volume"},on:{"change":function($event){_vm.actionField('volume','Volume',6)}}},[_vm._v("Volume")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('bsw'),"value":"bsw"},on:{"change":function($event){_vm.actionField('bsw', 'BS&W', 7)}}},[_vm._v("BS&W")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_type'),"value":"fluid_type"},on:{"change":function($event){_vm.actionField('fluid_type','Fluid Type', 8)}}},[_vm._v("Fluid Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck_unit'),"value":"truck_unit"},on:{"change":function($event){_vm.actionField('truck_unit','Truck Unit',9)}}},[_vm._v("Truck Unit")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trailer'),"value":"trailer"},on:{"change":function($event){_vm.actionField('trailer','Trailer',10)}}},[_vm._v("Trailer")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('rate'),"value":"rate"},on:{"change":function($event){_vm.actionField('rate','Rate', 11)}}},[_vm._v("Rate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('stb'),"value":"stb"},on:{"change":function($event){_vm.actionField('stb', 'STB Time', 12)}}},[_vm._v("STB Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_stb'),"value":"cost_stb"},on:{"change":function($event){_vm.actionField('cost_stb','STB Cost', 13)}}},[_vm._v("STB Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('justification'),"value":"justification"},on:{"change":function($event){_vm.actionField('justification','Justification', 14)}}},[_vm._v("Justification")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_subtotal_cost'),"value":"fluid_subtotal_cost"},on:{"change":function($event){_vm.actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 15)}}},[_vm._v("Fluid Subtotal Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst'),"value":"fluid_gst"},on:{"change":function($event){_vm.actionField('fluid_gst','Fluid GST', 16)}}},[_vm._v("Fluid GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst_subtotal'),"value":"fluid_gst_subtotal"},on:{"change":function($event){_vm.actionField('fluid_gst_subtotal','Fluid Total', 17)}}},[_vm._v("Fluid Total")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_cost_subtotal'),"value":"wait_time_cost_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 18)}}},[_vm._v("Wait Time Cost Subtotal")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst'),"value":"wait_time_gst"},on:{"change":function($event){_vm.actionField('wait_time_gst','Wait Time GST', 19)}}},[_vm._v("Wait Time GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst_subtotal'),"value":"wait_time_gst_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 20)}}},[_vm._v("Wait Time GST Subtotal")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n          Save\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_haul_invoices_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b0dd12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_haul_invoices_vue__ = __webpack_require__(1231);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11b0dd12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_haul_invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b0dd12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_haul_invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Haul Invoices")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Select Datapoints'),expression:"'Select Datapoints'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openSelectColumns()}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})]),_vm._v(" "),(_vm.role !='analyst' || _vm.role !='marketing_accountant')?_c('b-btn',{staticClass:"pull-right",attrs:{"variant":"info"},on:{"click":function($event){_vm.send_notification_click()}}},[_c('i',{staticClass:"fa fa-send"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"ml-auto my-1",attrs:{"order":"2","order-md":"5","cols":"4","sm":"6","md":"2","lg":"2"}},[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.showNewHaulModal()}}},[_vm._v("Add Haul")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role === 'trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Invoices","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.invoice_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.inFilter('Hauls Without Invoice', 0)}}},[_vm._v("Hauls Without Invoice")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.inFilter('Hauls With Invoice', 1)}}},[_vm._v("Hauls With Invoice")])],1)],1):_vm._e(),_vm._v(" "),(_vm.filter_by.invoice_id == 1 && _vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role === 'trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Invoices","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.invoic_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ivFilter('All Invoices', 0)}}},[_vm._v("All Invoices")]),_vm._v(" "),_vm._l((_vm.invoices_filter),function(invoice_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ivFilter(invoice_filter.invoice_ref, invoice_filter.id)}}},[_vm._v(_vm._s(invoice_filter.invoice_ref))])})],2)],1):_vm._e(),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role === 'trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"title":"Energy Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.energy_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter('All Energy Companies', 0)}}},[_vm._v("All Energy Companies")]),_vm._v(" "),_vm._l((_vm.energy_companies_filter),function(energy_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.ecFilter(energy_company_filter.company_name, energy_company_filter.id)}}},[_vm._v(_vm._s(energy_company_filter.company_name))])})],2)],1):_vm._e(),_vm._v(" "),(_vm.role !=='trucking_company_admin' || _vm.role !== 'trucking_operational_manager')?_c('b-col',{staticClass:"my-1 f4",attrs:{"title":"Trucking Companies","sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.trucking_company_name},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter('All Trucking Companies', 0)}}},[_c('h6',[_vm._v("All Trucking Companies")])]),_vm._v(" "),_vm._l((_vm.trucking_companies_filter),function(trucking_company_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.tcFilter(trucking_company_filter.name, trucking_company_filter.id)}}},[_vm._v(_vm._s(trucking_company_filter.name))])})],2)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f6",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.load_name,"title":"Load Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter('All Loads', 0)}}},[_vm._v("All Loads")]),_vm._v(" "),_vm._l((_vm.load_locations_filter),function(load_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.lFilter(load_location_filter.legal_location, load_location_filter.id)}}},[_vm._v(_vm._s(load_location_filter.legal_location))])})],2)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 f7",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"text":_vm.filters_save.unload_name,"title":"Unload Locations"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter('All Unloads', 0)}}},[_vm._v("All Unloads")]),_vm._v(" "),_vm._l((_vm.unload_locations_filter),function(unload_location_filter){return _c('b-dropdown-item',{on:{"click":function($event){_vm.uFilter(unload_location_filter.legal_location, unload_location_filter.id)}}},[_vm._v(_vm._s(unload_location_filter.legal_location))])})],2)],1),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-col',{staticClass:"my-1 f8",attrs:{"sm":"6","md":"3","lg":"2"}},[_c('b-dropdown',{staticClass:"custom_dropdown custom_dropdown_b",attrs:{"right":"","text":_vm.Approved,"title":"Approved"},on:{"show":_vm.activate_custom_backdrop,"hidden":_vm.deactivate_custom_backdrop}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.approvedFilter('All')}}},[_vm._v("All")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.approvedFilter('Approved')}}},[_vm._v("Approved")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.approvedFilter('Unapproved')}}},[_vm._v("Unapproved")])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1),_vm._v(" "),_c('b-row',[(_vm.haul_ids.length > 0 && _vm.filters_save.invoice_name == 'Hauls Without Invoice')?_c('b-col',{staticClass:"my-1"},[_c('div',{staticClass:"card bulk-action-controls m-0"},[_c('div',{staticClass:"card-body p-1 d-flex align-middle"},[_c('p',{staticClass:"col-sm-3 ml-2 px-0 my-auto align-middle"},[_vm._v(" "+_vm._s(_vm.haul_ids.length)+" haul(s) selected of "+_vm._s(_vm.totalRows))]),_vm._v(" "),_c('b-dropdown',{staticClass:"mx-2 my-auto align-middle",attrs:{"id":"ddown1","text":"Bulk Actions","title":"Bulk Actions"}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.openModal()}}},[_vm._v("Add to Invoice")]),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager' || _vm.role =='super_admin')?_c('b-dropdown-item',{on:{"click":function($event){_vm.h_approved_click()}}},[_vm._v("Approve Haul")]):_vm._e(),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager' || _vm.role =='super_admin')?_c('b-dropdown-item',{on:{"click":function($event){_vm.h_deapproved_click()}}},[_vm._v("Unapprove Haul")]):_vm._e(),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager' || _vm.role =='super_admin')?_c('b-dropdown-item',{on:{"click":function($event){_vm.h_unasigned_click()}}},[_vm._v("Unassign Haul from All Invoices")]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"align-middle ml-auto close-controls"})],1)])]):_vm._e()],1),_vm._v(" "),_c('b-row',[(_vm.haul_ids.length > 0 && _vm.filters_save.invoice_name == 'Hauls With Invoice')?_c('b-col',{staticClass:"my-1"},[_c('div',{staticClass:"card bulk-action-controls m-0"},[_c('div',{staticClass:"card-body p-1 d-flex align-middle"},[_c('p',{staticClass:"col-sm-3 ml-2 px-0 my-auto align-middle"},[_vm._v(" "+_vm._s(_vm.haul_ids.length)+" haul(s) selected of "+_vm._s(_vm.totalRows))]),_vm._v(" "),_c('b-dropdown',{staticClass:"mx-2 my-auto align-middle",attrs:{"id":"ddown2","text":"Bulk Actions","title":"Bulk Actions"}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.openModal()}}},[_vm._v("Re-assign to Invoice")]),_vm._v(" "),(_vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager' || _vm.role =='super_admin')?_c('b-dropdown-item',{on:{"click":function($event){_vm.h_unasigned_click()}}},[_vm._v("Unassign Haul from All Invoices")]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"align-middle ml-auto close-controls"})],1)])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{ref:"table",staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"action",fn:function(row){return undefined}},{key:"HEAD_select_haul",fn:function(data){return [_c('b-form-checkbox',{attrs:{"id":"checkbox"},on:{"change":_vm.toggleAllSelected},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.allSelected),callback:function ($$v) {_vm.allSelected=$$v},expression:"allSelected"}})]}},{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}},{key:"invoiced_cost",fn:function(item){return [(item.item.invoiced_cost!=item.item.total_cost )?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(item.item.invoiced_cost))]):_c('span',[_vm._v(_vm._s(item.item.invoiced_cost))])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add to Invoice","ok-variant":"primary","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.modalInvoice),callback:function ($$v) {_vm.modalInvoice=$$v},expression:"modalInvoice"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label-cols":2,"id":"L4","label-for":"folderID","horizontal":""}},[_c('b-form-radio-group',{staticClass:"custom-checkboxes",attrs:{"options":_vm.invoiceOptions,"name":"Checkboxes","plain":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.modalInvoice=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.addHaulsInvoice()}}},[_vm._v("\n          Save\n        ")])],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('ticket'),"value":"ticket"},on:{"change":function($event){_vm.actionField('ticket', 'Ticket #',1)}}},[_vm._v("Ticket #")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_id'),"value":"haul_id"},on:{"change":function($event){_vm.actionField('haul_id', 'Haul ID', 2)}}},[_vm._v("Haul Id")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('full_name'),"value":"full_name"},on:{"change":function($event){_vm.actionField('full_name', 'Driver', 5)}}},[_vm._v("Driver")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='operations_manager' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('energy_company'),"value":"energy_company"},on:{"change":function($event){_vm.actionField('energy_company', 'Energy Company', 3)}}},[_vm._v("Energy Company")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('load_location'),"value":"load_location"},on:{"change":function($event){_vm.actionField('load_location', 'Load', 6)}}},[_vm._v("Load")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_location'),"value":"unload_location"},on:{"change":function($event){_vm.actionField('unload_location', 'Unload', 7)}}},[_vm._v("Unload")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck'),"value":"truck"},on:{"change":function($event){_vm.actionField('truck','Trailer',8)}}},[_vm._v("Trailer")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_actual'),"value":"volume_actual"},on:{"change":function($event){_vm.actionField('volume_actual','Deliveries',9)}}},[_vm._v("Deliveries")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('oil_actual'),"value":"oil_actual"},on:{"change":function($event){_vm.actionField('oil_actual','Oil',10)}}},[_vm._v("Oil")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_actual'),"value":"water_actual"},on:{"change":function($event){_vm.actionField('water_actual', 'Water',11)}}},[_vm._v("Water")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('bsw'),"value":"bsw"},on:{"change":function($event){_vm.actionField('bsw', 'BS&W', 12)}}},[_vm._v("BS&W")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_date'),"value":"haul_start_date"},on:{"change":function($event){_vm.actionField('haul_start_date', 'Start Date', 13)}}},[_vm._v("Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_date'),"value":"haul_end_date"},on:{"change":function($event){_vm.actionField('haul_end_date', 'End Date', 14)}}},[_vm._v("End Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_type'),"value":"fluid_type"},on:{"change":function($event){_vm.actionField('fluid_type','Fluid Type', 15)}}},[_vm._v("Fluid Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trucking_company'),"value":"trucking_company"},on:{"change":function($event){_vm.actionField('trucking_company','Trucking Company', 4)}}},[_vm._v("Trucking Company")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_percentage_actual'),"value":"water_percentage_actual"},on:{"change":function($event){_vm.actionField('water_percentage_actual','Water Cut Actual', 16)}}},[_vm._v("Water Cut Actual")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_time'),"value":"haul_start_time"},on:{"change":function($event){_vm.actionField('haul_start_time','Start Time', 17)}}},[_vm._v("Start Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_time'),"value":"haul_end_time"},on:{"change":function($event){_vm.actionField('haul_end_time','End Time', 18)}}},[_vm._v("End Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_speed'),"value":"avg_speed"},on:{"change":function($event){_vm.actionField('avg_speed','Speed Avg', 19)}}},[_vm._v("Speed Avg")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_regular'),"value":"cost_regular"},on:{"change":function($event){_vm.actionField('cost_regular','Regular Cost', 20)}}},[_vm._v("Regular Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_stb'),"value":"cost_stb"},on:{"change":function($event){_vm.actionField('cost_stb','STB Cost', 21)}}},[_vm._v("STB Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_worktime'),"value":"cost_worktime"},on:{"change":function($event){_vm.actionField('cost_worktime','Worktime Cost', 22)}}},[_vm._v("Worktime Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_cost'),"value":"total_cost"},on:{"change":function($event){_vm.actionField('total_cost','Total Cost', 23)}}},[_vm._v("Total Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('invoiced_cost'),"value":"invoiced_cost"},on:{"change":function($event){_vm.actionField('invoiced_cost','Invoice Cost', 24)}}},[_vm._v("Invoice Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('justification'),"value":"justification"},on:{"change":function($event){_vm.actionField('justification','Justification', 25)}}},[_vm._v("Justification")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('flags'),"value":"flags"},on:{"change":function($event){_vm.actionField('flags','Flags', 26)}}},[_vm._v("Flags")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('invoice_id'),"value":"invoice_id"},on:{"change":function($event){_vm.actionField('invoice_id','Invoice ID', 27)}}},[_vm._v("Invoice ID")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('invoice_ref'),"value":"invoice_ref"},on:{"change":function($event){_vm.actionField('invoice_ref','Invoice Ref', 28)}}},[_vm._v("Invoice Ref")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('approved/unapproved'),"value":"approved/unapproved"},on:{"change":function($event){_vm.actionField('approved/unapproved','Approved/Unapproved Haul', 29)}}},[_vm._v("Approved/Unapproved Haul")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck_unit'),"value":"truck_unit"},on:{"change":function($event){_vm.actionField('truck_unit','Truck Unit',30)}}},[_vm._v("Truck Unit")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('terminal_boss'),"value":"terminal_boss"},on:{"change":function($event){_vm.actionField('terminal_boss', 'Terminal Boss Ticket',31)}}},[_vm._v("Terminal Boss Ticket")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_estimate'),"value":"volume_estimate"},on:{"change":function($event){_vm.actionField('volume_estimate','Volume Estimate',32)}}},[_vm._v("Volume Estimate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('rate'),"value":"rate"},on:{"change":function($event){_vm.actionField('rate','Rate', 33)}}},[_vm._v("Rate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('stb'),"value":"stb"},on:{"change":function($event){_vm.actionField('stb', 'STB Time', 34)}}},[_vm._v("STB Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_subtotal_cost'),"value":"fluid_subtotal_cost"},on:{"change":function($event){_vm.actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 35)}}},[_vm._v("Fluid Subtotal Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst'),"value":"fluid_gst"},on:{"change":function($event){_vm.actionField('fluid_gst','Fluid GST', 36)}}},[_vm._v("Fluid GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst_subtotal'),"value":"fluid_gst_subtotal"},on:{"change":function($event){_vm.actionField('fluid_gst_subtotal','Fluid Total', 37)}}},[_vm._v("Fluid Total")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_cost_subtotal'),"value":"wait_time_cost_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 38)}}},[_vm._v("Wait Time Cost Subtotal")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst'),"value":"wait_time_gst"},on:{"change":function($event){_vm.actionField('wait_time_gst','Wait Time GST', 39)}}},[_vm._v("Wait Time GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst_subtotal'),"value":"wait_time_gst_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 40)}}},[_vm._v("Wait Time GST Subtotal")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n          Save\n        ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newModal",staticClass:"newHaulModal",attrs:{"title":"Invoice Notification","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newModal),callback:function ($$v) {_vm.newModal=$$v},expression:"newModal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"trucking_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.company_name.length==0,"value-field":"id","text-field":"trucking_company_name","id":"trucking_company","options":_vm.company_name},on:{"input":function($event){_vm.selects_trucking_company_1()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.energy_companies.length==0,"value-field":"id","text-field":"energy_company_name","id":"energy_company","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Invoice Ref","label-for":"inv0"}},[_c('b-form-select',{attrs:{"disabled":_vm.invoices_filter.length==0,"value-field":"id","text-field":"invoice_ref","id":"inv0","options":_vm.invoices_filter},model:{value:(_vm.model.invoice_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_id", $$v)},expression:"model.invoice_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select invoice ref --")])])],2)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.sendbtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.send_click()}}},[_vm._v("Send")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newHaulModal",staticClass:"newHaulModal",attrs:{"title":"New Haul","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role ==='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Truking Company","label-for":"truck_company"}},[_c('b-form-select',{attrs:{"id":"truck_company_id","options":_vm.newHaul.truck_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.newHaul.truck_company_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_company_id", $$v)},expression:"newHaul.truck_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trailer","label-for":"truck"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.truck_select.length==0,"id":"truck_id","options":_vm.newHaul.truck_select},model:{value:(_vm.newHaul.truck_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_id", $$v)},expression:"newHaul.truck_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Truck Unit","label-for":"truck_unit"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.truck_unit_select.length==0,"id":"truck_unit","options":_vm.newHaul.truck_unit_select},model:{value:(_vm.newHaul.truck_unit_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_unit_id", $$v)},expression:"newHaul.truck_unit_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Driver","label-for":"full_name"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.driver_select.length==0,"id":"user_id","options":_vm.newHaul.driver_select},on:{"input":function($event){_vm.selects_driver()}},model:{value:(_vm.newHaul.user_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "user_id", $$v)},expression:"newHaul.user_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.energy_company_select.length==0,"id":"energy_companies_id","options":_vm.newHaul.energy_company_select},on:{"input":function($event){_vm.selects_energy_company()}},model:{value:(_vm.newHaul.energy_companies_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "energy_companies_id", $$v)},expression:"newHaul.energy_companies_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Load","label-for":"load_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.load_location_select.length==0,"id":"load_location_id","options":_vm.newHaul.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.newHaul.load_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "load_location_id", $$v)},expression:"newHaul.load_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Fluid","label-for":"fluid_type"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.fluid_type_select.length==0,"id":"fluid_type_id","options":_vm.newHaul.fluid_type_select},model:{value:(_vm.newHaul.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "fluid_type_id", $$v)},expression:"newHaul.fluid_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload","label-for":"unload_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.unload_location_select.length==0,"id":"unload_location_id","options":_vm.newHaul.unload_location_select},model:{value:(_vm.newHaul.unload_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "unload_location_id", $$v)},expression:"newHaul.unload_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Water Cut Actual %","label-for":"water_percentage_actual"}},[_c('b-form-input',{attrs:{"id":"water_percentage_actual","placeholder":"0.00","type":"text"},nativeOn:{"blur":function($event){_vm.inputBlur('water_percentage_actual')},"keydown":function($event){_vm.myOnlyNumber($event, 'water_percentage_actual')}},model:{value:(_vm.newHaul.water_percentage_actual),callback:function ($$v) {_vm.$set(_vm.newHaul, "water_percentage_actual", $$v)},expression:"newHaul.water_percentage_actual"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume Actual","label-for":"volume_actual"}},[_c('b-form-input',{attrs:{"id":"volume_actual","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume_actual')},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.newHaul.volume_actual),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume_actual", $$v)},expression:"newHaul.volume_actual"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume Estimate","label-for":"volume_estimate"}},[_c('b-form-input',{attrs:{"id":"volume_estimate","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume_estimate')},"blur":function($event){_vm.inputBlur('volume_estimate')}},model:{value:(_vm.newHaul.volume_estimate),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume_estimate", $$v)},expression:"newHaul.volume_estimate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"# Ticket","label-for":"ticket"}},[_c('b-form-input',{attrs:{"id":"ticket","type":"text","autocomplete":"off","placeholder":"max 10 characters"},nativeOn:{"keydown":function($event){_vm.keyMonitor($event)}},model:{value:(_vm.newHaul.ticket),callback:function ($$v) {_vm.$set(_vm.newHaul, "ticket", $$v)},expression:"newHaul.ticket"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Ticket","label-for":"t_ticket"}},[_c('b-form-input',{attrs:{"id":"t_ticket","type":"text","autocomplete":"off","placeholder":"max 10 characters"},nativeOn:{"keydown":function($event){_vm.keyMonitor1($event)}},model:{value:(_vm.newHaul.t_ticket),callback:function ($$v) {_vm.$set(_vm.newHaul, "t_ticket", $$v)},expression:"newHaul.t_ticket"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Boss Number","label-for":"t_boss"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"t_boss","type":"text","autocomplete":"off","placeholder":"max 10 digits"},model:{value:(_vm.newHaul.t_boss),callback:function ($$v) {_vm.$set(_vm.newHaul, "t_boss", $$v)},expression:"newHaul.t_boss"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Chain Up","label-for":"chain_up"}},[_c('b-form-select',{attrs:{"id":"chain_up"},model:{value:(_vm.newHaul.chain_up),callback:function ($$v) {_vm.$set(_vm.newHaul, "chain_up", $$v)},expression:"newHaul.chain_up"}},[_c('option',{domProps:{"value":false}},[_vm._v("NO")]),_c('option',{domProps:{"value":true}},[_vm._v("YES")])])],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Start Date","label-for":"haul_start_date"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},model:{value:(_vm.newHaul.haul_start_datetime),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_start_datetime", $$v)},expression:"newHaul.haul_start_datetime"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Start Time","label-for":"haul_start_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_start_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('haul_start_time')}},model:{value:(_vm.newHaul.haul_start_time),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_start_time", $$v)},expression:"newHaul.haul_start_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Date","label-for":"haul_start_date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},model:{value:(_vm.newHaul.haul_end_datetime),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_end_datetime", $$v)},expression:"newHaul.haul_end_datetime"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Time","label-for":"haul_end_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_end_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('haul_end_time')}},model:{value:(_vm.newHaul.haul_end_time),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_end_time", $$v)},expression:"newHaul.haul_end_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Comments Start","label-for":"comments_start"}},[_c('b-form-input',{attrs:{"id":"comments_start","type":"text"},model:{value:(_vm.newHaul.comments_start),callback:function ($$v) {_vm.$set(_vm.newHaul, "comments_start", $$v)},expression:"newHaul.comments_start"}})],1),_vm._v(" "),_vm._l((_vm.newHaul.wait_times),function(wait_time,index){return _c('b-form-group',{key:wait_time.type_id,attrs:{"label-cols":4,"horizontal":"","label":_vm.waitTimeLabel(wait_time),"label-for":_vm.waitTimeLabel(wait_time)}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"placeholder":"hh:mm","type":"text"},model:{value:(wait_time.time),callback:function ($$v) {_vm.$set(wait_time, "time", $$v)},expression:"wait_time.time"}}),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":"Comments","type":"text"},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}}),_vm._v(" "),(wait_time.type_id == 5)?_c('b-btn',{staticClass:"wait-time-remove-button",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.removeTimeBlur(index)}}},[_vm._v("X")]):_vm._e()],1)}),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.addWaitTime}},[_vm._v("Add another Wait Time")])],2)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewHaulModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveHaul}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3866489c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(1233);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3866489c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Request Notifications")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Request Notifications - Trash")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}})],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"order":"2","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trash_click()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trash_click()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"ml-auto my-1",attrs:{"order":"3","order-md":"5","cols":"4","sm":"6","md":"2","lg":"2"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.showNewModal()}}},[_vm._v("Add Request Notification")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"activate",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"disabled":"","id":"checkbox","value":item.activate},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(item.item.activate),callback:function ($$v) {_vm.$set(item.item, "activate", $$v)},expression:"item.item.activate"}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"newModal",staticClass:"newHaulModal",attrs:{"title":"New Request Notification","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newModal),callback:function ($$v) {_vm.newModal=$$v},expression:"newModal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Companies","label-for":"notif1"}},[_c('b-form-select',{attrs:{"id":"notif1","value-field":"id","text-field":"name","options":_vm.company_name},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"notif2","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"N1","label":"Activate","label-for":"notif3","horizontal":""}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"notif3"},model:{value:(_vm.model.activate),callback:function ($$v) {_vm.$set(_vm.model, "activate", $$v)},expression:"model.activate"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.save_click()}}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05650dda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_vue__ = __webpack_require__(1235);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05650dda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v(_vm._s(_vm.$options.name)+" - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.edit_e}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.delete_d}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Energy Company Name","label-for":"notif1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"notif1","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}}):_c('b-form-select',{attrs:{"id":"notif1","value-field":"id","text-field":"name","options":_vm.company_name},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"notif2","label-cols":4,"horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"form-control",attrs:{"disabled":"","type":"email"},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}}):_c('b-form-input',{staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Activated","label-for":"ULID","horizontal":""}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"ULID","disabled":""},model:{value:(_vm.model.activate),callback:function ($$v) {_vm.$set(_vm.model, "activate", $$v)},expression:"model.activate"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"13px"},attrs:{"id":"ULID"},model:{value:(_vm.model.activate),callback:function ($$v) {_vm.$set(_vm.model, "activate", $$v)},expression:"model.activate"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.update}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.edit_e}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f91e536a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(1237);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f91e536a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Invoice Notifications")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Invoice Notifications - Trash")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}})],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"order":"2","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trash_click()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trash_click()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"ml-auto my-1",attrs:{"order":"3","order-md":"5","cols":"4","sm":"6","md":"2","lg":"2"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.showNewModal()}}},[_vm._v("Add Invoice Notification")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"activate",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"disabled":"","id":"checkbox","value":item.activate},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(item.item.activate),callback:function ($$v) {_vm.$set(item.item, "activate", $$v)},expression:"item.item.activate"}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"newModal",staticClass:"newHaulModal",attrs:{"title":"New Invoice Notification","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newModal),callback:function ($$v) {_vm.newModal=$$v},expression:"newModal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"trucking_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.company_name.length==0,"value-field":"id","text-field":"trucking_company_name","id":"trucking_company","options":_vm.company_name},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.energy_companies.length==0,"value-field":"id","text-field":"energy_company_name","id":"energy_company","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"notif2","label-cols":4,"horizontal":""}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.save_click()}}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc60232_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_vue__ = __webpack_require__(1239);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc60232_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v(_vm._s(_vm.$options.name)+" - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.edit_e}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.delete_d}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Trucking Company Name","label-for":"notif1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"notif1","type":"text"},model:{value:(_vm.model.trucking_company_name),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_name", $$v)},expression:"model.trucking_company_name"}}):_c('b-form-select',{attrs:{"id":"notif1","value-field":"id","text-field":"trucking_company_name","options":_vm.company_name},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Energy Company Name","label-for":"notif2","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"notif2","type":"text"},model:{value:(_vm.model.energy_company_name),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_name", $$v)},expression:"model.energy_company_name"}}):_c('b-form-select',{attrs:{"id":"notif2","value-field":"id","text-field":"energy_company_name","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"notif2","label-cols":4,"horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"form-control",attrs:{"disabled":"","type":"email"},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}}):_c('b-form-input',{staticClass:"form-control",attrs:{"type":"email"},nativeOn:{"keypress":function($event){_vm.isLowerCaseEmail($event)}},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.update}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.edit_e}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucks_units_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b2b25a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucks_units_vue__ = __webpack_require__(1241);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucks_units_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b2b25a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucks_units_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v("Truck Units")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v("Truck Units - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"my-1",attrs:{"lg":"4","md":"6","xs":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{staticClass:"brad-0",attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),(_vm.role==='super_admin' || _vm.role==='trucking_company_admin' || _vm.role==='trucking_operational_manager')?_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTrucks()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTrucks()}}},[_vm._v("Trash")])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"lg":"5","md":"6","xs":"12"}},[_c('b-button',{staticClass:"active mb-3 pull-right",attrs:{"disabled":!_vm.insert_data,"variant":"primary"},on:{"click":_vm.newTruckModal}},[_vm._v("Add Truck unit")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t\t\t\t")])])],1):_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-left",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modalInfo","title":_vm.modalInfo.title,"ok-only":""},on:{"hide":_vm.resetModal}},[_c('pre',[_vm._v(_vm._s(_vm.modalInfo.content))])])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Truck unit","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newTruck),callback:function ($$v) {_vm.newTruck=$$v},expression:"newTruck"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Truck Unit:","label-for":"trucknameID","horizontal":""}},[_c('b-form-input',{attrs:{"id":"trucknameID","type":"text"},model:{value:(_vm.model.truck_unit),callback:function ($$v) {_vm.$set(_vm.model, "truck_unit", $$v)},expression:"model.truck_unit"}})],1),_vm._v(" "),(_vm.role==='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Trucking Company:","label-for":"truckingCompanyID","horizontal":""}},[_c('b-form-select',{attrs:{"value-field":"id","text-field":"trucking_company","id":"truckingCompanyID","options":_vm.truckingcompaniesselect},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTruck=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveNewTruck}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucks_unit_vue__ = __webpack_require__(597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660d3f06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucks_unit_vue__ = __webpack_require__(1243);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trucks_unit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660d3f06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trucks_unit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Truck Unit - "+_vm._s(this.subTitle))])]),_vm._v(" "),(_vm.role ==='super_admin' || _vm.role ==='trucking_company_admin' || _vm.role === 'trucking_operational_manager')?_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editTruck}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteTruck}},[_vm._v("Delete")])],2)],1):_vm._e()],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Truck Unit","label-for":"trucknameID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"trucknameID","type":"text"},model:{value:(_vm.model.truck_unit),callback:function ($$v) {_vm.$set(_vm.model, "truck_unit", $$v)},expression:"model.truck_unit"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"trucknameID","type":"text"},model:{value:(_vm.model.truck_unit),callback:function ($$v) {_vm.$set(_vm.model, "truck_unit", $$v)},expression:"model.truck_unit"}})],1),_vm._v(" "),(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label":"Trucking Company","label-for":"truckingCompanyID","label-cols":4,"horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"truckingCompanyID","type":"text"},model:{value:(_vm.model.trucking_company),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company", $$v)},expression:"model.trucking_company"}}),_vm._v(" "),_c('b-form-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"value-field":"id","text-field":"trucking_company","id":"truckingCompanyID","options":_vm.truckingcompaniesselect},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}})],1):_vm._e(),_vm._v(" "),(_vm.edit)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateTruck}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editTruck}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1):_vm._e()],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_altex_vue__ = __webpack_require__(598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ce688c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_altex_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8ce688c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_altex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ce688c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_altex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Altex Tickets Check")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('download-excel',{ref:"excel",attrs:{"data":_vm.items_csv,"fields":_vm.json_fields,"type":"csv","name":_vm.filename}},[_c('span',[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Export to csv'),expression:"'Export to csv'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"}},[_c('i',{staticClass:"fa fa-file-excel-o"})])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intraday_report_vue__ = __webpack_require__(599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9631532e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intraday_report_vue__ = __webpack_require__(1252);
function injectStyle (ssrContext) {
  __webpack_require__(1248)
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9631532e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intraday_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9631532e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intraday_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  getLocationsIndicatorsData: function getLocationsIndicatorsData() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + "/locations_indicator/", {
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("access_token")
        }
      }).then(function (response) {
        var data = "";
        if (response.data.status === "success") {
          data = response.data;
          resolve(data);
        } else {
          data = response.data;
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  send_volumeChange: function send_volumeChange(filter_by) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + "/location_volume_change/", filter_by, {
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("access_token")
        }
      }).then(function (response) {
        var data = "";
        if (response.data.status === "success") {
          data = response.data;
          resolve(data);
        } else {
          data = response.data;
          resolve(data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getChartConfig: function getChartConfig() {
    return {
      chart: {
        type: "scatter",
        inverted: true,
        marginLeft: 0,
        height: 55
      },
      title: {
        text: null
      },
      legend: {
        enabled: false
      },
      yAxis: {
        gridLineWidth: 0
      },
      xAxis: {
        categories: []
      },
      plotOptions: {
        series: {
          stickyTracking: true,
          pointPadding: 0.25,
          borderWidth: 0,
          color: "#000",
          marker: {
            symbol: "target",
            height: 10,
            width: 10,
            lineWidth: 4
          }
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      tooltip: {
        outside: true,
        useHTML: true
      }
    };
  },
  getChartConfig_1: function getChartConfig_1() {
    return {

      title: {
        text: null
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        borderWidth: 0
      },
      plotOptions: {
        spline: {
          lineWidth: 2,
          marker: {
            enabled: false
          }
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      tooltip: {
        outside: true
      }
    };
  }
});

/***/ }),
/* 1251 */,
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading\n            data...\n          ")])])],1):_c('div',[(_vm.no_detail)?_c('Container',{staticClass:"location-widget p-1 mb-4",attrs:{"group-name":"col","get-child-payload":_vm.getCardPayload('column.id'),"should-accept-drop":_vm.shouldAcceptDropDesktop,"should-animate-drop":_vm.shouldAnimateDropDesktop,"drag-class":"card-ghost","drop-class":"card-ghost-drop"},on:{"drop":function (e) { return _vm.onCardDrop('col', e); },"drag-start":function (e) { return _vm.log('drag start', e); },"drag-end":function (e) { return _vm.log('drag end', e); }}},[_c('div',{staticClass:"card location-widget mb-4 animated fadeIn"},[_c('div',{attrs:{"card-header":"","location-widget-header":""}},[_c('highcharts',{staticClass:"chart-container",attrs:{"options":_vm.chart_options()}})],1)]),_vm._v(" "),_vm._l((_vm.locacations_data.locations),function(location,index){return _c('div',{key:index + '_draggable'},[_c('div',{staticClass:"card location-widget mb-4 animated fadeIn"},[_c('div',{staticClass:"card-header location-widget-header"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',{staticClass:"location-widget-title",attrs:{"onmouseover":"this.style.cursor='pointer'"},on:{"click":function($event){_vm.detail(index)}}},[_vm._v(_vm._s(location.name)+" - "+_vm._s(_vm.date_format((location.lastUpdated)))+"\n                  ")]),_vm._v(" "),(location.state!=null)?_c('b-badge',{staticClass:"location-state",attrs:{"variant":_vm.getStateVariant(location.state)}},[_vm._v(_vm._s(location.state))]):_c('b-badge',{staticClass:"location-state",attrs:{"variant":_vm.getStateVariant(location.state)}},[_vm._v(_vm._s("No State"))])],1)]),_vm._v(" "),_c('div',{staticClass:"card-body card-border m-0 p-2"},[_c('div',{staticClass:"location-widget-chart"},[_c('highcharts',{ref:'location_chart_' + index,refInFor:true,staticClass:"chart-container",attrs:{"options":_vm.chartOptions(index)}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between flex-wrap location-widget-legend mt-4"},[_c('div',[_c('b-badge',{staticClass:"legend-badget",staticStyle:{"background-color":"#364A8A"}},[_vm._v(" ")]),_vm._v("\n                    L: "+_vm._s(location.low)+"m"),_c('sup',[_vm._v("3")]),_vm._v(" / H:\n                    "+_vm._s(location.high)+"m"),_c('sup',[_vm._v("3")])],1),_vm._v(" "),_c('div',[_c('b-badge',{staticClass:"legend-badget",staticStyle:{"background-color":"#6FA64B"}},[_vm._v(" ")]),_vm._v("\n                    EOD: "+_vm._s(location.eod)+"m"),_c('sup',[_vm._v("3")]),_vm._v(" / 6AM: "+_vm._s(location.sixAM)+"m"),_c('sup',[_vm._v("3")])],1),_vm._v(" "),_c('div',[_c('b-badge',{staticClass:"legend-badget",staticStyle:{"background-color":"#FFD966"}},[_vm._v(" ")]),_vm._v("\n                    Current: "+_vm._s(location.current)+" m"),_c('sup',[_vm._v("3")])],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between flex-wrap location-widget-legend mt-4"},[_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Prod:")]),_c('br'),_vm._v("\n                    "+_vm._s(location.pro)+"m"),_c('sup',[_vm._v("3")])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Rem:")]),_c('br'),_vm._v("\n                    "+_vm._s(location.rem)+"m"),_c('sup',[_vm._v("3")])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Hauls:")]),_c('br'),_vm._v("\n                    "+_vm._s(location.haulsDelivered)+"m"),_c('sup',[_vm._v("3")]),_vm._v(" /\n                    "+_vm._s(location.haulsRequested)+"m"),_c('sup',[_vm._v("3")])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("HT:")]),_c('br'),_vm._v("\n                    "+_vm._s(location.ht)+"hr\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between flex-wrap location-widget-legend mt-5"},[(_vm.view)?_c('b-button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.minus(index)}}},[_vm._v("Cut (-)")]):_vm._e(),_vm._v(" "),(_vm.view)?_c('b-button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.add(index)}}},[_vm._v("Add (+)")]):_vm._e(),_vm._v(" "),(_vm.view)?_c('b-button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.confirm(index)}}},[_vm._v("Confirm")]):_vm._e()],1),_vm._v(" "),(location.preview)?_c('div',{staticClass:"d-flex justify-content-center flex-wrap location-widget-legend mt-5"},[_vm._v("\n                    "+_vm._s(location.inc)+_vm._s(_vm.sign)+_vm._s(location.inc_1)+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}})],1)],1)})],2):_vm._e(),_vm._v(" "),(!_vm.no_detail)?_c('Container',{staticClass:"location-widget p-1 mb-4",attrs:{"group-name":"col1","get-child-payload":_vm.getCardPayload('column.id'),"should-accept-drop":_vm.shouldAcceptDropDesktop,"should-animate-drop":_vm.shouldAnimateDropDesktop,"drag-class":"card-ghost","drop-class":"card-ghost-drop"},on:{"drop":function (e) { return _vm.onCardDrop('col1', e); }}},[_c('div',{staticClass:"card location-widget mb-4 animated fadeIn"},[_c('div',{staticClass:"card-header location-widget-header"},[_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',{staticClass:"location-widget-title"},[_vm._v(_vm._s(_vm.loc.name)+" \n                                ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Inventory : ")]),_c('span',[_vm._v(_vm._s(_vm.loc.current)+"m"),_c('sup',[_vm._v("3")]),_vm._v(" / "+_vm._s(_vm.loc.percentage)+"%")])]),_vm._v(" "),_c('highcharts',{staticClass:"chart-container",attrs:{"options":_vm.chartOptions1(_vm.loc.percentage)}}),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Low : ")]),_c('span',[_vm._v(_vm._s(_vm.loc.low)+"m"),_c('sup',[_vm._v("3")]),_vm._v(" / ")]),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("High: ")]),_c('span',[_vm._v(_vm._s(_vm.loc.high)+"m"),_c('sup',[_vm._v("3")])])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Production : ")]),_c('span',[_vm._v(_vm._s(_vm.loc.pro)+"m"),_c('sup',[_vm._v("3")])])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Hours to HT: ")]),_c('span',[_vm._v(_vm._s(_vm.loc.ht)+"hr")])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Requested : ")]),_c('span',[_vm._v(_vm._s(_vm.loc.haulsRequested)+"m"),_c('sup',[_vm._v("3")])])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Hauled : ")]),_c('span',[_vm._v(" "+_vm._s(_vm.loc.current)+" m"),_c('sup',[_vm._v("3")])])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Remaining : ")]),_c('span',[_vm._v(_vm._s(_vm.loc.rem)+"m"),_c('sup',[_vm._v("3")])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"7"}},[_c('highcharts',{staticClass:"chart-container",attrs:{"options":_vm.chart_options_1(_vm.index_1)}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('b-table',{attrs:{"show-empty":"","empty-text":"No Add/Cut","outlined":true,"borderless":true,"fields":[{key: 'item', label: ' '}, {key: 'add', label: 'Add'}, {key: 'cut', label: 'Cut'}, {key: 'total', label: 'Total'}, {key: 'pending', label: 'Pending'}],"items":_vm.volume_change,"stacked":"sm","small":""},scopedSlots:_vm._u([{key:"add",fn:function(row){return [_c('span',[_vm._v("   "+_vm._s(_vm.volume_change[row.index].add))])]}},{key:"cut",fn:function(row){return [_c('span',[_vm._v("   "+_vm._s(_vm.volume_change[row.index].cut))])]}},{key:"total",fn:function(row){return [_c('span',[_vm._v("   "+_vm._s(_vm.volume_change[row.index].total))])]}},{key:"pending",fn:function(row){return [_c('span',[_vm._v("   "+_vm._s(_vm.volume_change[row.index].pending))])]}}])})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-table',{attrs:{"show-empty":"","empty-text":"No Volume Change","outlined":false,"borderless":true,"border":false,"fields":[{key: 'createdTime', label: '  '}, {key: 'truckCo', label: '  '}, {key: 'terminal', label: '  '}, {key: 'amount', label: '  '}, {key: 'confirmation', label: '  '}],"items":_vm.loc.volumeChanges,"stacked":"sm","hover":"","no-border-collapse":false,"small":""},scopedSlots:_vm._u([{key:"createdTime",fn:function(item){return [_c('span',[_vm._v(_vm._s(_vm.date_format1(_vm.loc.volumeChanges[item.index].createdTime)))])]}},{key:"truckCo",fn:function(item){return [_c('span',[_vm._v(_vm._s(_vm.map_tc(_vm.loc.volumeChanges[item.index].truckCo, _vm.maps_truckco)))])]}},{key:"terminal",fn:function(item){return [_c('span',[_vm._v(_vm._s(_vm.map_terminal(_vm.loc.volumeChanges[item.index].terminal)))])]}},{key:"amount",fn:function(item){return [_c('span',[_vm._v("35m"),_c('sup',[_vm._v("3")])])]}},{key:"confirmation",fn:function(item){return [(_vm.loc.volumeChanges[item.index].confirmation==null)?_c('b-badge',{staticStyle:{"background-color":"#F8F32b"}},[_vm._v("Pending\n                                                      ")]):_vm._e(),_vm._v(" "),(_vm.loc.volumeChanges[item.index].confirmation=='n')?_c('b-badge',{staticStyle:{"background-color":"#f3c293"}},[_vm._v("Rejected\n                                                      ")]):_vm._e(),_vm._v(" "),(_vm.loc.volumeChanges[item.index].confirmation=='y')?_c('b-badge',{staticStyle:{"background-color":"#b7F49a"}},[_vm._v("Accepted\n                                                      ")]):_vm._e()]}}])})],1)],1)],1)]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.back_click()}}},[_vm._v("Back")])],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"no-fade":"","centered":"","button-size":"sm","size":"sm","hide-header":"","hide-backdrop":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":""},model:{value:(_vm.newTC),callback:function ($$v) {_vm.newTC=$$v},expression:"newTC"}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-cols":1,"vertical":"","label":"Trucking Company","label-for":"terminalCompanies"}},[_c('b-form-select',{attrs:{"id":"terminalCompanies","options":_vm.trucking_companies},model:{value:(_vm.to_send_data.trucking_company),callback:function ($$v) {_vm.$set(_vm.to_send_data, "trucking_company", $$v)},expression:"to_send_data.trucking_company"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-cols":1,"vertical":"","label":"Terminal","label-for":"terminal"}},[_c('b-form-select',{attrs:{"id":"terminal","options":_vm.terminals},model:{value:(_vm.to_send_data.terminal),callback:function ($$v) {_vm.$set(_vm.to_send_data, "terminal", $$v)},expression:"to_send_data.terminal"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select terminal --")])])],2)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.cancel()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.confirm_to()}}},[_vm._v("Confirm")])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hazards_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afd3b9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hazards_vue__ = __webpack_require__(1254);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hazards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afd3b9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hazards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashHazard()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashHazard()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newHazardModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n\n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Hazard","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newHazard),callback:function ($$v) {_vm.newHazard=$$v},expression:"newHazard"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Hazard Name","label-for":"HazardName","horizontal":""}},[_c('b-form-input',{attrs:{"id":"HazardName","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newHazard=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveHazard}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_controls_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8b069c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_controls_vue__ = __webpack_require__(1256);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_controls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8b069c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_controls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashControl()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashControl()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newControlModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n                    \n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Control","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newControl),callback:function ($$v) {_vm.newControl=$$v},expression:"newControl"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Control Name","label-for":"ControlName","horizontal":""}},[_c('b-form-input',{attrs:{"id":"ControlName","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newControl=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveControl}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hazard_vue__ = __webpack_require__(603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e142a6f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hazard_vue__ = __webpack_require__(1258);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hazard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e142a6f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hazard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Hazard - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.editH()}}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteH()}}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Hazard Name","label-for":"HazardNameID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"HazardNameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"HazardNameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.update()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.editH()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_control_vue__ = __webpack_require__(604);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3477963a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_control_vue__ = __webpack_require__(1260);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_control_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3477963a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_control_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Control - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.editC}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteC}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Control Name","label-for":"ControlNameID","horizontal":""}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.edit),expression:"!edit"}],staticClass:"plaintext-input",attrs:{"plaintext":"","id":"ControlNameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],staticClass:"plaintext-input",attrs:{"id":"ControlNameID","type":"text"},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.updateC}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":_vm.editC}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tdgs_vue__ = __webpack_require__(605);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2642cf4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tdgs_vue__ = __webpack_require__(1262);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tdgs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2642cf4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tdgs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTdg()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashTdg()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newTdgModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n\n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Tdg","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newTdg),callback:function ($$v) {_vm.newTdg=$$v},expression:"newTdg"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Common Name","label-for":"Tdg1","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg1","type":"text"},model:{value:(_vm.model.common_name),callback:function ($$v) {_vm.$set(_vm.model, "common_name", $$v)},expression:"model.common_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Product Description","label-for":"Tdg2","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg2","type":"text"},model:{value:(_vm.model.product_description),callback:function ($$v) {_vm.$set(_vm.model, "product_description", $$v)},expression:"model.product_description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Packing Group","label-for":"Tdg3","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg3","type":"text"},model:{value:(_vm.model.packing_group),callback:function ($$v) {_vm.$set(_vm.model, "packing_group", $$v)},expression:"model.packing_group"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Class","label-for":"Tdg4","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"Tdg4","type":"text","placeholder":"only numbers"},model:{value:(_vm.model.class_tdg),callback:function ($$v) {_vm.$set(_vm.model, "class_tdg", $$v)},expression:"model.class_tdg"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Shipping Name","label-for":"Tdg5","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg5","type":"text"},model:{value:(_vm.model.shipping_name),callback:function ($$v) {_vm.$set(_vm.model, "shipping_name", $$v)},expression:"model.shipping_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Un","label-for":"Tdg6","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"Tdg6","type":"text","placeholder":"only numbers"},model:{value:(_vm.model.un),callback:function ($$v) {_vm.$set(_vm.model, "un", $$v)},expression:"model.un"}})],1),_vm._v(" "),(_vm.fluidtypeselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Fluid Types","label-for":"Tdg7","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.fluidtypeselect,"name":"Checkboxes2","plain":""},on:{"input":function($event){_vm.fluidtypesChange()}},model:{value:(_vm.model.fluid_types_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_types_id", $$v)},expression:"model.fluid_types_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateFT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.FTToggleAll},model:{value:(_vm.ftAllSelected),callback:function ($$v) {_vm.ftAllSelected=$$v},expression:"ftAllSelected"}},[_vm._v("\n                    "+_vm._s(_vm.ftAllSelected ? 'Un-select All' : 'Select All')+"\n                ")])],1):_c('p',[_vm._v("No fluid type registered")])],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newTdg=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveTdg}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tdg_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3d388e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tdg_vue__ = __webpack_require__(1264);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tdg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3d388e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tdg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Tdg - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.editTdg()}}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteTdg()}}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Common Name","label-for":"Tdg1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"plaintext":"","id":"Tdg1","type":"text"},model:{value:(_vm.model.common_name),callback:function ($$v) {_vm.$set(_vm.model, "common_name", $$v)},expression:"model.common_name"}}):_c('b-form-input',{attrs:{"id":"Tdg1","type":"text"},model:{value:(_vm.model.common_name),callback:function ($$v) {_vm.$set(_vm.model, "common_name", $$v)},expression:"model.common_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Product Description","label-for":"Tdg2","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg2","plaintext":"","type":"text"},model:{value:(_vm.model.product_description),callback:function ($$v) {_vm.$set(_vm.model, "product_description", $$v)},expression:"model.product_description"}}):_c('b-form-input',{attrs:{"id":"Tdg2","type":"text"},model:{value:(_vm.model.product_description),callback:function ($$v) {_vm.$set(_vm.model, "product_description", $$v)},expression:"model.product_description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Packing Group","label-for":"Tdg3","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","plaintext":"","type":"text"},model:{value:(_vm.model.packing_group),callback:function ($$v) {_vm.$set(_vm.model, "packing_group", $$v)},expression:"model.packing_group"}}):_c('b-form-input',{attrs:{"id":"Tdg3","type":"text"},model:{value:(_vm.model.packing_group),callback:function ($$v) {_vm.$set(_vm.model, "packing_group", $$v)},expression:"model.packing_group"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Class","label-for":"Tdg4","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg4","plaintext":"","type":"text"},model:{value:(_vm.model.class_tdg),callback:function ($$v) {_vm.$set(_vm.model, "class_tdg", $$v)},expression:"model.class_tdg"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"Tdg4","type":"text","placeholder":"only numbers"},model:{value:(_vm.model.class_tdg),callback:function ($$v) {_vm.$set(_vm.model, "class_tdg", $$v)},expression:"model.class_tdg"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Shipping Name","label-for":"Tdg5","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg5","plaintext":"","type":"text"},model:{value:(_vm.model.shipping_name),callback:function ($$v) {_vm.$set(_vm.model, "shipping_name", $$v)},expression:"model.shipping_name"}}):_c('b-form-input',{attrs:{"id":"Tdg5","type":"text"},model:{value:(_vm.model.shipping_name),callback:function ($$v) {_vm.$set(_vm.model, "shipping_name", $$v)},expression:"model.shipping_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Un","label-for":"Tdg6","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","plaintext":"","type":"text"},model:{value:(_vm.model.un),callback:function ($$v) {_vm.$set(_vm.model, "un", $$v)},expression:"model.un"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"Tdg6","type":"text","placeholder":"only numbers"},model:{value:(_vm.model.un),callback:function ($$v) {_vm.$set(_vm.model, "un", $$v)},expression:"model.un"}})],1),_vm._v(" "),(_vm.edit)?_c('div',[(_vm.fluidtypeselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Fluid Types","label-for":"Tdg7","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"value-field":"id","text-field":"name","options":_vm.fluidtypeselect,"name":"Checkboxes2","plain":""},on:{"input":function($event){_vm.fluidtypesChange()}},model:{value:(_vm.model.fluid_types_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_types_id", $$v)},expression:"model.fluid_types_id"}}),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"margin-top":"15px"},attrs:{"indeterminate":_vm.indeterminateFT,"aria-describedby":"","aria-controls":"","plain":""},on:{"change":_vm.FTToggleAll},model:{value:(_vm.ftAllSelected),callback:function ($$v) {_vm.ftAllSelected=$$v},expression:"ftAllSelected"}},[_vm._v("\n                                            "+_vm._s(_vm.ftAllSelected ? 'Un-select All' : 'Select All')+"\n                                        ")])],1):_c('p',[_vm._v("No fluid type registered")])],1):_c('div',[(_vm.fluidtypeselect.length > 0)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Fluid Types","label-for":"Tdg7","horizontal":""}},[_c('b-form-checkbox-group',{staticClass:"custom-checkboxes",attrs:{"disabled":"","value-field":"id","text-field":"name","options":_vm.fluidtypeselect,"name":"Checkboxes2","plain":""},model:{value:(_vm.model.fluid_types_id),callback:function ($$v) {_vm.$set(_vm.model, "fluid_types_id", $$v)},expression:"model.fluid_types_id"}})],1):_c('p',[_vm._v("No fluid type registered")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.update()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.editTdg()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_petrotranz_report_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8751be6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_petrotranz_report_vue__ = __webpack_require__(1267);
function injectStyle (ssrContext) {
  __webpack_require__(1266)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8751be6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_petrotranz_report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8751be6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_petrotranz_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Petrotranz Report")])])],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 f9",attrs:{"title":"Initial Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},on:{"change":_vm.iFilter},model:{value:(_vm.filter_by.initial_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "initial_date", $$v)},expression:"filter_by.initial_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f10",attrs:{"title":"End Date","sm":"6","md":"4","lg":"3"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},on:{"change":_vm.eFilter},model:{value:(_vm.filter_by.end_date),callback:function ($$v) {_vm.$set(_vm.filter_by, "end_date", $$v)},expression:"filter_by.end_date"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 lg-3 f11 ",staticStyle:{"padding-top":"3px","padding-bottom":"3px"},attrs:{"sm":"6","md":"4","lg":"3"}},[_c('b-button',{staticStyle:{"height":"100%"},attrs:{"block":""},on:{"click":function($event){_vm.clearFilters()}}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_customers_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56488c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_customers_vue__ = __webpack_require__(1269);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56488c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newICModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n\n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Customer","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newIC),callback:function ($$v) {_vm.newIC=$$v},expression:"newIC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Customer Name","label-for":"Tdg1","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg1","type":"text"},model:{value:(_vm.model.customer_name),callback:function ($$v) {_vm.$set(_vm.model, "customer_name", $$v)},expression:"model.customer_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Address 1","label-for":"Tdg2","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg2","type":"text","placeholder":"Optional"},model:{value:(_vm.model.address_1),callback:function ($$v) {_vm.$set(_vm.model, "address_1", $$v)},expression:"model.address_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Address 2","label-for":"Tdg3","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg3","type":"text","placeholder":"Optional"},model:{value:(_vm.model.address_2),callback:function ($$v) {_vm.$set(_vm.model, "address_2", $$v)},expression:"model.address_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Address 3","label-for":"Tdg4","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg4","type":"text","placeholder":"Optional"},model:{value:(_vm.model.address_3),callback:function ($$v) {_vm.$set(_vm.model, "address_3", $$v)},expression:"model.address_3"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Postal Zip","label-for":"Tdg5","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg5","type":"text","placeholder":"Optional"},model:{value:(_vm.model.postal_zip),callback:function ($$v) {_vm.$set(_vm.model, "postal_zip", $$v)},expression:"model.postal_zip"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Prov State","label-for":"Tdg6","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg6","type":"text","placeholder":"Optional"},model:{value:(_vm.model.prov_state),callback:function ($$v) {_vm.$set(_vm.model, "prov_state", $$v)},expression:"model.prov_state"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","horizontal":"","label":"Currency","label-for":"Tdg7"}},[_c('b-form-select',{attrs:{"disabled":_vm.currency.length==0,"value-field":"id","text-field":"name","id":"Tdg7","options":_vm.currency},model:{value:(_vm.model.currency_id),callback:function ($$v) {_vm.$set(_vm.model, "currency_id", $$v)},expression:"model.currency_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select currency --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","horizontal":"","label":"GST","label-for":"Tdg8"}},[_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"43px"},attrs:{"id":"Tdg8","value":"true","unchecked-value":"false"},model:{value:(_vm.model.gst),callback:function ($$v) {_vm.$set(_vm.model, "gst", $$v)},expression:"model.gst"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Day of Month ","label-for":"Tdg9","horizontal":""}},[_c('b-form-select',{attrs:{"disabled":_vm.DoM.length==0,"value-field":"id","text-field":"name","id":"Tdg9","options":_vm.DoM},model:{value:(_vm.model.invoice_DoM),callback:function ($$v) {_vm.$set(_vm.model, "invoice_DoM", $$v)},expression:"model.invoice_DoM"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select day of month(optional) --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Placeholder 1","label-for":"Tdg10","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg10","type":"text","placeholder":"Optional"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Placeholder 2","label-for":"Tdg11","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg11","type":"text","placeholder":"Optional"},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Attach File","label-for":"file","horizontal":""}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No file have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: ' '}],"items":_vm.model.infile,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removefile(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"name",fn:function(item){return [_c('input',{ref:"file",staticClass:"form-control-file",attrs:{"type":"file","id":"files","accept":"application/pdf, image/png, image/jpg, .xlsx, .xls, .doc, docx"},on:{"change":function($event){_vm.handleFileUpload(item.index)}}})]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.anotherfile()}}},[_vm._v("Add another file")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newIC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveIC}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_customer_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a1fb6d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_customer_vue__ = __webpack_require__(1271);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a1fb6d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Customer - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.editTdg()}}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteTdg()}}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Customer Name","label-for":"Tdg1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg1","type":"text","plaintext":""},model:{value:(_vm.model.customer_name),callback:function ($$v) {_vm.$set(_vm.model, "customer_name", $$v)},expression:"model.customer_name"}}):_c('b-form-input',{attrs:{"id":"Tdg1","type":"text"},model:{value:(_vm.model.customer_name),callback:function ($$v) {_vm.$set(_vm.model, "customer_name", $$v)},expression:"model.customer_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Address 1","label-for":"Tdg2","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg2","type":"text","plaintext":""},model:{value:(_vm.model.address_1),callback:function ($$v) {_vm.$set(_vm.model, "address_1", $$v)},expression:"model.address_1"}}):_c('b-form-input',{attrs:{"id":"Tdg2","type":"text"},model:{value:(_vm.model.address_1),callback:function ($$v) {_vm.$set(_vm.model, "address_1", $$v)},expression:"model.address_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Address 2","label-for":"Tdg3","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","type":"text","plaintext":""},model:{value:(_vm.model.address_2),callback:function ($$v) {_vm.$set(_vm.model, "address_2", $$v)},expression:"model.address_2"}}):_c('b-form-input',{attrs:{"id":"Tdg3","type":"text"},model:{value:(_vm.model.address_2),callback:function ($$v) {_vm.$set(_vm.model, "address_2", $$v)},expression:"model.address_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Address 3","label-for":"Tdg4","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg4","type":"text","plaintext":""},model:{value:(_vm.model.address_3),callback:function ($$v) {_vm.$set(_vm.model, "address_3", $$v)},expression:"model.address_3"}}):_c('b-form-input',{attrs:{"id":"Tdg4","type":"text"},model:{value:(_vm.model.address_3),callback:function ($$v) {_vm.$set(_vm.model, "address_3", $$v)},expression:"model.address_3"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Postal Zip","label-for":"Tdg5","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg5","type":"text","plaintext":""},model:{value:(_vm.model.postal_zip),callback:function ($$v) {_vm.$set(_vm.model, "postal_zip", $$v)},expression:"model.postal_zip"}}):_c('b-form-input',{attrs:{"id":"Tdg5","type":"text"},model:{value:(_vm.model.postal_zip),callback:function ($$v) {_vm.$set(_vm.model, "postal_zip", $$v)},expression:"model.postal_zip"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Prov State","label-for":"Tdg6","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","type":"text","plaintext":""},model:{value:(_vm.model.prov_state),callback:function ($$v) {_vm.$set(_vm.model, "prov_state", $$v)},expression:"model.prov_state"}}):_c('b-form-input',{attrs:{"id":"Tdg6","type":"text"},model:{value:(_vm.model.prov_state),callback:function ($$v) {_vm.$set(_vm.model, "prov_state", $$v)},expression:"model.prov_state"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","horizontal":"","label":"Currency","label-for":"Tdg7"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","type":"text","plaintext":""},model:{value:(_vm.model.currency_name),callback:function ($$v) {_vm.$set(_vm.model, "currency_name", $$v)},expression:"model.currency_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.currency.length==0,"value-field":"id","text-field":"name","id":"Tdg7","options":_vm.currency},model:{value:(_vm.model.currency_id),callback:function ($$v) {_vm.$set(_vm.model, "currency_id", $$v)},expression:"model.currency_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select currency --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","horizontal":"","label":"GST","label-for":"Tdg8"}},[(!_vm.edit)?_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"43px"},attrs:{"id":"Tdg8","plain":"","disabled":""},model:{value:(_vm.model.gst),callback:function ($$v) {_vm.$set(_vm.model, "gst", $$v)},expression:"model.gst"}}):_c('b-form-checkbox',{staticClass:"custom-checkboxes",staticStyle:{"margin-top":"43px"},attrs:{"id":"Tdg8","plain":"","value":"true","unchecked-value":"false"},model:{value:(_vm.model.gst),callback:function ($$v) {_vm.$set(_vm.model, "gst", $$v)},expression:"model.gst"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Day of Month ","label-for":"Tdg9","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","type":"text","plaintext":""},model:{value:(_vm.model.invoice_DoM_name),callback:function ($$v) {_vm.$set(_vm.model, "invoice_DoM_name", $$v)},expression:"model.invoice_DoM_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.DoM.length==0,"value-field":"id","text-field":"name","id":"Tdg9","options":_vm.DoM},model:{value:(_vm.model.invoice_DoM),callback:function ($$v) {_vm.$set(_vm.model, "invoice_DoM", $$v)},expression:"model.invoice_DoM"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select day of month(optional) --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Placeholder 1","label-for":"Tdg10","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg10","type":"text","plaintext":""},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}}):_c('b-form-input',{attrs:{"id":"Tdg10","type":"text"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Placeholder 2","label-for":"Tdg11","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg11","type":"text","plaintext":""},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}}):_c('b-form-input',{attrs:{"id":"Tdg10","type":"text"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Infile","label-for":"file","horizontal":""}},_vm._l((_vm.model.infile),function(file_in,index){return _c('div',[_c('p',[_vm._v(_vm._s(file_in.name))])])})):_c('b-form-group',{attrs:{"label-cols":4,"id":"L15","label":"Attach File","label-for":"file","horizontal":""}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No file have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: ' '}],"items":_vm.model.infile,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removefile(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"name",fn:function(item){return [(item.item.name=='')?_c('span',{staticClass:"show-details-cell"},[_c('input',{ref:"file",staticClass:"form-control-file",attrs:{"type":"file","id":"files","accept":"application/pdf, image/png, image/jpg, .xlsx, .xls, .doc, docx"},on:{"change":function($event){_vm.handleFileUpload(item.index)}}})]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.item.name)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.anotherfile()}}},[_vm._v("Add another file")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.update()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.editTdg()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_contracts_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12875cce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_contracts_vue__ = __webpack_require__(1273);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_contracts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12875cce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_contracts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newICModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n\n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Contract","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newIC),callback:function ($$v) {_vm.newIC=$$v},expression:"newIC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Contract Name","label-for":"Tdg1","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg1","type":"text"},model:{value:(_vm.model.contract_name),callback:function ($$v) {_vm.$set(_vm.model, "contract_name", $$v)},expression:"model.contract_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","horizontal":"","label":"Type Contract","label-for":"Tdg2"}},[_c('b-form-select',{attrs:{"disabled":_vm.type_contract.length==0,"value-field":"id","text-field":"name","id":"Tdg2","options":_vm.type_contract},model:{value:(_vm.model.type_contract_id),callback:function ($$v) {_vm.$set(_vm.model, "type_contract_id", $$v)},expression:"model.type_contract_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select type contract --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Start Date","label-for":"Tdg3","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg3","type":"date"},model:{value:(_vm.model.start_date),callback:function ($$v) {_vm.$set(_vm.model, "start_date", $$v)},expression:"model.start_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Of Months","label-for":"Tdg4","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],attrs:{"id":"Tdg4","type":"text","placeholder":"Only numbers(max 2 digits)","autocomplete":"off"},model:{value:(_vm.model.of_months),callback:function ($$v) {_vm.$set(_vm.model, "of_months", $$v)},expression:"model.of_months"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Volume","label-for":"Tdg5","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('#########'),expression:"'#########'"}],attrs:{"id":"Tdg5","type":"text","placeholder":"Only numbers(max 9 digits)","autocomplete":"off"},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Diff","label-for":"Tdg6","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg6","type":"text","placeholder":"0.00","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'diff')},"blur":function($event){_vm.inputBlur('diff')}},model:{value:(_vm.model.diff),callback:function ($$v) {_vm.$set(_vm.model, "diff", $$v)},expression:"model.diff"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","horizontal":"","label":"Index Contract","label-for":"Tdg7"}},[_c('b-form-select',{attrs:{"disabled":_vm.index_contract.length==0,"value-field":"id","text-field":"name","id":"Tdg7","options":_vm.index_contract},model:{value:(_vm.model.index_contract_id),callback:function ($$v) {_vm.$set(_vm.model, "index_contract_id", $$v)},expression:"model.index_contract_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select index contract --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"App","label-for":"Tdg8","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg8","type":"text","placeholder":"0.00","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'app')},"blur":function($event){_vm.inputBlur('app')}},model:{value:(_vm.model.app),callback:function ($$v) {_vm.$set(_vm.model, "app", $$v)},expression:"model.app"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"trader","label-for":"Tdg9","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg9","type":"text"},model:{value:(_vm.model.trader),callback:function ($$v) {_vm.$set(_vm.model, "trader", $$v)},expression:"model.trader"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Priority","label-for":"Tdg10","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],attrs:{"id":"Tdg10","type":"text","placeholder":"Only numbers(max 2 digits)","autocomplete":"off"},model:{value:(_vm.model.priority),callback:function ($$v) {_vm.$set(_vm.model, "priority", $$v)},expression:"model.priority"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Placeholder 1","label-for":"Tdg11","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg11","type":"text","placeholder":"Optional"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","label":"Placeholder 2","label-for":"Tdg12","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg12","type":"text","placeholder":"Optional"},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"Invoice Customer","label-for":"Tdg13","horizontal":""}},[_c('b-form-select',{attrs:{"disabled":_vm.invoice_customer.length==0,"value-field":"id","text-field":"name","id":"Tdg13","options":_vm.invoice_customer},model:{value:(_vm.model.invoice_customer_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_customer_id", $$v)},expression:"model.invoice_customer_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select customer --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L15","label":"Nomination(m3)","label-for":"Tdg15","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg15","type":"text","placeholder":"0.00","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'nomination_m3')},"blur":function($event){_vm.inputBlur('nomination_m3')}},model:{value:(_vm.model.nomination_m3),callback:function ($$v) {_vm.$set(_vm.model, "nomination_m3", $$v)},expression:"model.nomination_m3"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L16","label":"Nomination(bbl)","label-for":"Tdg16","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg16","type":"text","placeholder":"0.00","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'nomination_bbl')},"blur":function($event){_vm.inputBlur('nomination_bbl')}},model:{value:(_vm.model.nomination_bbl),callback:function ($$v) {_vm.$set(_vm.model, "nomination_bbl", $$v)},expression:"model.nomination_bbl"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Post Appomt. Nomination","label-for":"Tdg17","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg17","type":"text","placeholder":"0.00","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'post_appomt_nom')},"blur":function($event){_vm.inputBlur('post_appomt_nom')}},model:{value:(_vm.model.post_appomt_nom),callback:function ($$v) {_vm.$set(_vm.model, "post_appomt_nom", $$v)},expression:"model.post_appomt_nom"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L18","label":"Price Description","label-for":"Tdg18","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg18","type":"text","autocomplete":"off"},model:{value:(_vm.model.price_description),callback:function ($$v) {_vm.$set(_vm.model, "price_description", $$v)},expression:"model.price_description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Attach Pdfs","label-for":"file","horizontal":""}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No pdf file have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: ' '}],"items":_vm.model.pdfs,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removefile(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"name",fn:function(item){return [_c('input',{ref:"file",staticClass:"form-control-file",attrs:{"type":"file","id":"files","accept":"application/pdf"},on:{"change":function($event){_vm.handleFileUpload(item.index)}}})]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.anotherfile()}}},[_vm._v("Add another Pdf")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newIC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveIC}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_contract_vue__ = __webpack_require__(611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd120848_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_contract_vue__ = __webpack_require__(1275);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_contract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd120848_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Contract - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.editTdg()}}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteTdg()}}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Contract Name","label-for":"Tdg1","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg1","type":"text","plaintext":""},model:{value:(_vm.model.contract_name),callback:function ($$v) {_vm.$set(_vm.model, "contract_name", $$v)},expression:"model.contract_name"}}):_c('b-form-input',{attrs:{"id":"Tdg1","type":"text"},model:{value:(_vm.model.contract_name),callback:function ($$v) {_vm.$set(_vm.model, "contract_name", $$v)},expression:"model.contract_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","horizontal":"","label":"Type Contract","label-for":"Tdg2"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg2","type":"text","plaintext":""},model:{value:(_vm.model.type_contract_name),callback:function ($$v) {_vm.$set(_vm.model, "type_contract_name", $$v)},expression:"model.type_contract_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.type_contract.length==0,"value-field":"id","text-field":"name","id":"Tdg2","options":_vm.type_contract},model:{value:(_vm.model.type_contract_id),callback:function ($$v) {_vm.$set(_vm.model, "type_contract_id", $$v)},expression:"model.type_contract_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select type contract --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Start Date","label-for":"Tdg3","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","type":"text","plaintext":""},model:{value:(_vm.model.start_date),callback:function ($$v) {_vm.$set(_vm.model, "start_date", $$v)},expression:"model.start_date"}}):_c('b-form-input',{attrs:{"id":"Tdg3","type":"date"},model:{value:(_vm.model.start_date),callback:function ($$v) {_vm.$set(_vm.model, "start_date", $$v)},expression:"model.start_date"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"Of Months","label-for":"Tdg4","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg4","type":"text","plaintext":""},model:{value:(_vm.model.of_months),callback:function ($$v) {_vm.$set(_vm.model, "of_months", $$v)},expression:"model.of_months"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],attrs:{"id":"Tdg4","type":"text","autocomplete":"off"},model:{value:(_vm.model.of_months),callback:function ($$v) {_vm.$set(_vm.model, "of_months", $$v)},expression:"model.of_months"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Volume","label-for":"Tdg5","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg5","type":"text","plaintext":""},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('#########'),expression:"'#########'"}],attrs:{"id":"Tdg5","type":"text","autocomplete":"off"},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Diff","label-for":"Tdg6","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","type":"text","plaintext":""},model:{value:(_vm.model.diff),callback:function ($$v) {_vm.$set(_vm.model, "diff", $$v)},expression:"model.diff"}}):_c('b-form-input',{attrs:{"id":"Tdg6","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'diff')},"blur":function($event){_vm.inputBlur('diff')}},model:{value:(_vm.model.diff),callback:function ($$v) {_vm.$set(_vm.model, "diff", $$v)},expression:"model.diff"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","horizontal":"","label":"Index Contract","label-for":"Tdg7"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg7","type":"text","plaintext":""},model:{value:(_vm.model.index_contract_name),callback:function ($$v) {_vm.$set(_vm.model, "index_contract_name", $$v)},expression:"model.index_contract_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.index_contract.length==0,"value-field":"id","text-field":"name","id":"Tdg7","options":_vm.index_contract},model:{value:(_vm.model.index_contract_id),callback:function ($$v) {_vm.$set(_vm.model, "index_contract_id", $$v)},expression:"model.index_contract_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select index contract --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"App","label-for":"Tdg8","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg8","type":"text","plaintext":""},model:{value:(_vm.model.app),callback:function ($$v) {_vm.$set(_vm.model, "app", $$v)},expression:"model.app"}}):_c('b-form-input',{attrs:{"id":"Tdg8","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'app')},"blur":function($event){_vm.inputBlur('app')}},model:{value:(_vm.model.app),callback:function ($$v) {_vm.$set(_vm.model, "app", $$v)},expression:"model.app"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"trader","label-for":"Tdg9","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg9","type":"text","plaintext":""},model:{value:(_vm.model.trader),callback:function ($$v) {_vm.$set(_vm.model, "trader", $$v)},expression:"model.trader"}}):_c('b-form-input',{attrs:{"id":"Tdg9","type":"text"},model:{value:(_vm.model.trader),callback:function ($$v) {_vm.$set(_vm.model, "trader", $$v)},expression:"model.trader"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Priority","label-for":"Tdg10","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg10","type":"text","plaintext":""},model:{value:(_vm.model.priority),callback:function ($$v) {_vm.$set(_vm.model, "priority", $$v)},expression:"model.priority"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],attrs:{"id":"Tdg10","type":"text","autocomplete":"off"},model:{value:(_vm.model.priority),callback:function ($$v) {_vm.$set(_vm.model, "priority", $$v)},expression:"model.priority"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Placeholder 1","label-for":"Tdg11","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg11","type":"text","plaintext":""},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}}):_c('b-form-input',{attrs:{"id":"Tdg11","type":"text"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","label":"Placeholder 2","label-for":"Tdg12","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg12","type":"text","plaintext":""},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}}):_c('b-form-input',{attrs:{"id":"Tdg12","type":"text"},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L13","label":"Customer","label-for":"Tdg13","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg13","type":"text","plaintext":""},model:{value:(_vm.model.invoice_customer_name),callback:function ($$v) {_vm.$set(_vm.model, "invoice_customer_name", $$v)},expression:"model.invoice_customer_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.invoice_customer.length==0,"value-field":"id","text-field":"name","id":"Tdg13","options":_vm.invoice_customer},model:{value:(_vm.model.invoice_customer_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_customer_id", $$v)},expression:"model.invoice_customer_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select invoice customer --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L15","label":"Nomination(m3)","label-for":"Tdg15","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg15","type":"text","plaintext":""},model:{value:(_vm.model.nomination_m3),callback:function ($$v) {_vm.$set(_vm.model, "nomination_m3", $$v)},expression:"model.nomination_m3"}}):_c('b-form-input',{attrs:{"id":"Tdg15","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'nomination_m3')},"blur":function($event){_vm.inputBlur('nomination_m3')}},model:{value:(_vm.model.nomination_m3),callback:function ($$v) {_vm.$set(_vm.model, "nomination_m3", $$v)},expression:"model.nomination_m3"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L16","label":"Nomination(bbl)","label-for":"Tdg16","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg16","type":"text","plaintext":""},model:{value:(_vm.model.nomination_bbl),callback:function ($$v) {_vm.$set(_vm.model, "nomination_bbl", $$v)},expression:"model.nomination_bbl"}}):_c('b-form-input',{attrs:{"id":"Tdg16","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'nomination_bbl')},"blur":function($event){_vm.inputBlur('nomination_bbl')}},model:{value:(_vm.model.nomination_bbl),callback:function ($$v) {_vm.$set(_vm.model, "nomination_bbl", $$v)},expression:"model.nomination_bbl"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L17","label":"Post Appomt. Nomination","label-for":"Tdg17","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg17","type":"text","plaintext":""},model:{value:(_vm.model.post_appomt_nom),callback:function ($$v) {_vm.$set(_vm.model, "post_appomt_nom", $$v)},expression:"model.post_appomt_nom"}}):_c('b-form-input',{attrs:{"id":"Tdg17","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'post_appomt_nom')},"blur":function($event){_vm.inputBlur('post_appomt_nom')}},model:{value:(_vm.model.post_appomt_nom),callback:function ($$v) {_vm.$set(_vm.model, "post_appomt_nom", $$v)},expression:"model.post_appomt_nom"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L18","label":"Price Description","label-for":"Tdg18","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg18","type":"text","plaintext":""},model:{value:(_vm.model.price_description),callback:function ($$v) {_vm.$set(_vm.model, "price_description", $$v)},expression:"model.price_description"}}):_c('b-form-input',{attrs:{"id":"Tdg18","type":"text"},model:{value:(_vm.model.price_description),callback:function ($$v) {_vm.$set(_vm.model, "price_description", $$v)},expression:"model.price_description"}})],1),_vm._v(" "),(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L14","label":"Attach Pdfs","label-for":"file","horizontal":""}},_vm._l((_vm.model.pdfs),function(pdf,index){return _c('div',[_c('p',[_vm._v(_vm._s(pdf.name))])])})):_c('b-form-group',{attrs:{"label-cols":4,"id":"L144","label":"Attach Pdfs","label-for":"file","horizontal":""}},[_c('b-table',{attrs:{"striped":"","show-empty":"","empty-text":"No pdf have been added","fields":[{key: 'delete', label: ' '}, {key: 'name', label: ' '}],"items":_vm.model.pdfs,"stacked":"sm","outlined":"","small":""},scopedSlots:_vm._u([{key:"delete",fn:function(item){return [_c('b-btn',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pull-right",attrs:{"title":"Delete","size":"sm"},on:{"click":function($event){_vm.removefile(item.index)}}},[_c('i',{staticClass:"icon-close"})])]}},{key:"name",fn:function(item){return [(item.item.name=='')?_c('span',{staticClass:"show-details-cell"},[_c('input',{ref:"file",staticClass:"form-control-file",attrs:{"type":"file","id":"files","accept":"application/pdf"},on:{"change":function($event){_vm.handleFileUpload(item.index)}}})]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.item.name)+"\n\t\t\t\t\t\t\t\t\t\t\t")])]}}])}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-btn',{staticClass:"pull-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.anotherfile()}}},[_vm._v("Add pdf")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.update()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.editTdg()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_adjusts_vue__ = __webpack_require__(612);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f765e4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_adjusts_vue__ = __webpack_require__(1277);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_adjusts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f765e4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_adjusts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newICModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n\n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Adjustment","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newIC),callback:function ($$v) {_vm.newIC=$$v},expression:"newIC"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","horizontal":"","label":"Month","label-for":"Tdg1"}},[_c('b-form-select',{attrs:{"disabled":_vm.months.length==0,"value-field":"id","text-field":"name","id":"Tdg1","options":_vm.months},model:{value:(_vm.model.month),callback:function ($$v) {_vm.$set(_vm.model, "month", $$v)},expression:"model.month"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","horizontal":"","label":"Year","label-for":"Tdg2"}},[_c('b-form-select',{attrs:{"disabled":_vm.years.length==0,"value-field":"id","text-field":"name","id":"Tdg2","options":_vm.years},model:{value:(_vm.model.year),callback:function ($$v) {_vm.$set(_vm.model, "year", $$v)},expression:"model.year"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Customer","label-for":"Tdg7","horizontal":""}},[_c('b-form-select',{attrs:{"disabled":_vm.invoice_customer.length==0,"value-field":"id","text-field":"name","id":"Tdg7","options":_vm.invoice_customer},model:{value:(_vm.model.invoice_customer_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_customer_id", $$v)},expression:"model.invoice_customer_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select customer --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Volume","label-for":"Tdg3","horizontal":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('########'),expression:"'########'"}],attrs:{"id":"Tdg3","type":"text","placeholder":"Only numbers(max 8 digits)","autocomplete":"off"},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","horizontal":"","label":"Load Location","label-for":"Tdg4"}},[_c('b-form-select',{attrs:{"disabled":_vm.location_contract.length==0,"value-field":"id","text-field":"name","id":"Tdg4","options":_vm.location_contract},model:{value:(_vm.model.location_contract_id),callback:function ($$v) {_vm.$set(_vm.model, "location_contract_id", $$v)},expression:"model.location_contract_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select load location --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Placeholder 1","label-for":"Tdg5","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg5","type":"text","placeholder":"Optional"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Placeholder 2","label-for":"Tdg6","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg6","type":"text","placeholder":"Optional"},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newIC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveIC}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_adjust_vue__ = __webpack_require__(613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419b00aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_adjust_vue__ = __webpack_require__(1279);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_adjust_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419b00aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_adjust_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Adjusment - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.editTdg()}}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteTdg()}}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","horizontal":"","label":"Month Year","label-for":"Tdg1"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg1","plaintext":"","type":"text"},model:{value:(_vm.model.month_year),callback:function ($$v) {_vm.$set(_vm.model, "month_year", $$v)},expression:"model.month_year"}}):_vm._e()],1):_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","horizontal":"","label":"Month Year","label-for":"Tdg1"}},[_c('b-form-select',{attrs:{"disabled":_vm.months.length==0,"value-field":"id","text-field":"name","id":"Tdg11","options":_vm.months},model:{value:(_vm.model.month),callback:function ($$v) {_vm.$set(_vm.model, "month", $$v)},expression:"model.month"}}),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":_vm.years.length==0,"value-field":"id","text-field":"name","id":"Tdg111","options":_vm.years},model:{value:(_vm.model.year),callback:function ($$v) {_vm.$set(_vm.model, "year", $$v)},expression:"model.year"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"Customer","label-for":"Tdg7","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","type":"text","plaintext":""},model:{value:(_vm.model.invoice_customer_name),callback:function ($$v) {_vm.$set(_vm.model, "invoice_customer_name", $$v)},expression:"model.invoice_customer_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.invoice_customer.length==0,"value-field":"id","text-field":"name","id":"Tdg7","options":_vm.invoice_customer},model:{value:(_vm.model.invoice_customer_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_customer_id", $$v)},expression:"model.invoice_customer_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select invoice customer --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Volume","label-for":"Tdg3","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","type":"text","plaintext":""},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}}):_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('########'),expression:"'########'"}],attrs:{"id":"Tdg33","type":"text","autocomplete":"off"},model:{value:(_vm.model.volume),callback:function ($$v) {_vm.$set(_vm.model, "volume", $$v)},expression:"model.volume"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","horizontal":"","label":"Load Location","label-for":"Tdg4"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","type":"text","plaintext":""},model:{value:(_vm.model.location_contract_name),callback:function ($$v) {_vm.$set(_vm.model, "location_contract_name", $$v)},expression:"model.location_contract_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.location_contract.length==0,"value-field":"id","text-field":"name","id":"Tdg4","options":_vm.location_contract},model:{value:(_vm.model.location_contract_id),callback:function ($$v) {_vm.$set(_vm.model, "location_contract_id", $$v)},expression:"model.location_contract_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select load location --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"Placeholder 1","label-for":"Tdg5","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg5","type":"text","plaintext":""},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}}):_c('b-form-input',{attrs:{"id":"Tdg55","type":"text"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"Placeholder 2","label-for":"Tdg6","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","type":"text","plaintext":""},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}}):_c('b-form-input',{attrs:{"id":"Tdg66","type":"text"},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.update()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.editTdg()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_prices_vue__ = __webpack_require__(614);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39fd3e81_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_prices_vue__ = __webpack_require__(1281);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_prices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39fd3e81_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_prices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trash),expression:"!trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.trash),expression:"trash"}]},[_vm._v(_vm._s(_vm.$options.name)+"s - Trash")])])],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-container',{attrs:{"fluid":"","terminal":""}},[_c('b-row',{staticClass:"justify-content-between"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"4"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"3"}},[_c('b-dropdown',{staticClass:"pull-left",attrs:{"text":_vm.dpdt}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Active")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.trashIC()}}},[_vm._v("Trash")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"5"}},[_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.newICModal}},[_vm._v("Add "+_vm._s(_vm.$options.name)+"\n\n                ")])],1)],1),_vm._v(" "),(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n                ")])])],1):_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"my-0 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"New Price","size":"lg","ok-only":"","ok-title":"Cancel","ok-variant":"secundary"},model:{value:(_vm.newIC),callback:function ($$v) {_vm.newIC=$$v},expression:"newIC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","horizontal":"","label":"Month","label-for":"Tdg1"}},[_c('b-form-select',{attrs:{"disabled":_vm.months.length==0,"value-field":"id","text-field":"name","id":"Tdg1","options":_vm.months},model:{value:(_vm.model.month),callback:function ($$v) {_vm.$set(_vm.model, "month", $$v)},expression:"model.month"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","horizontal":"","label":"Year","label-for":"Tdg2"}},[_c('b-form-select',{attrs:{"disabled":_vm.years.length==0,"value-field":"id","text-field":"name","id":"Tdg2","options":_vm.years},model:{value:(_vm.model.year),callback:function ($$v) {_vm.$set(_vm.model, "year", $$v)},expression:"model.year"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"Exchange Rate","label-for":"Tdg3","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg3","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'exchange_rate')},"blur":function($event){_vm.inputBlur('exchange_rate')}},model:{value:(_vm.model.exchange_rate),callback:function ($$v) {_vm.$set(_vm.model, "exchange_rate", $$v)},expression:"model.exchange_rate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"WTI","label-for":"Tdg4","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg4","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'wti')},"blur":function($event){_vm.inputBlur('wti')}},model:{value:(_vm.model.wti),callback:function ($$v) {_vm.$set(_vm.model, "wti", $$v)},expression:"model.wti"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"WCS","label-for":"Tdg5","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg5","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'wcs')},"blur":function($event){_vm.inputBlur('wcs')}},model:{value:(_vm.model.wcs),callback:function ($$v) {_vm.$set(_vm.model, "wcs", $$v)},expression:"model.wcs"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"LLK","label-for":"Tdg6","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg6","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'llk')},"blur":function($event){_vm.inputBlur('llk')}},model:{value:(_vm.model.llk),callback:function ($$v) {_vm.$set(_vm.model, "llk", $$v)},expression:"model.llk"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"LLB","label-for":"Tdg7","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg7","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'llb')},"blur":function($event){_vm.inputBlur('llb')}},model:{value:(_vm.model.llb),callback:function ($$v) {_vm.$set(_vm.model, "llb", $$v)},expression:"model.llb"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"C5","label-for":"Tdg8","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg8","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'c5')},"blur":function($event){_vm.inputBlur('c5')}},model:{value:(_vm.model.c5),callback:function ($$v) {_vm.$set(_vm.model, "c5", $$v)},expression:"model.c5"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"AECO","label-for":"Tdg9","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg9","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'aeco')},"blur":function($event){_vm.inputBlur('aeco')}},model:{value:(_vm.model.aeco),callback:function ($$v) {_vm.$set(_vm.model, "aeco", $$v)},expression:"model.aeco"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Placeholder 1","label-for":"Tdg10","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg10","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'placeholder_1')},"blur":function($event){_vm.inputBlur('placeholder_1')}},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L11","label":"Placeholder 2","label-for":"Tdg11","horizontal":""}},[_c('b-form-input',{attrs:{"id":"Tdg11","type":"text","placeholder":"0.00000","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'placeholder_2')},"blur":function($event){_vm.inputBlur('placeholder_2')}},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","horizontal":"","label":"Type","label-for":"Tdg12"}},[_c('b-form-select',{attrs:{"disabled":_vm.invoice_types.length==0,"value-field":"id","text-field":"name","id":"Tdg12","options":_vm.invoice_types},model:{value:(_vm.model.invoice_type_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_type_id", $$v)},expression:"model.invoice_type_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select type --")])])],2)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.newIC=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveIC}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_price_vue__ = __webpack_require__(615);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0122808c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_price_vue__ = __webpack_require__(1283);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_price_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0122808c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Price - "+_vm._s(this.subTitle))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-dropdown',{staticClass:"pull-right",attrs:{"disabled":_vm.edit,"right":"","variant":"info","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.editTdg()}}},[_vm._v("Edit")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.deleteTdg()}}},[_vm._v("Delete")])],2)],1)],1),_vm._v(" "),_c('div',[(_vm.loadingData)?_c('b-card',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v("Loading data...\n\t\t\t\t\t")])])],1):_c('div',[(_vm.found)?_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[(!_vm.edit)?_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","horizontal":"","label":"Month Year","label-for":"Tdg1"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg1","plaintext":"","type":"text"},model:{value:(_vm.model.month_year),callback:function ($$v) {_vm.$set(_vm.model, "month_year", $$v)},expression:"model.month_year"}}):_vm._e()],1):_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","horizontal":"","label":"Month Year","label-for":"Tdg1"}},[_c('b-form-select',{attrs:{"disabled":_vm.months.length==0,"value-field":"id","text-field":"name","id":"Tdg11","options":_vm.months},model:{value:(_vm.model.month),callback:function ($$v) {_vm.$set(_vm.model, "month", $$v)},expression:"model.month"}}),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":_vm.years.length==0,"value-field":"id","text-field":"name","id":"Tdg111","options":_vm.years},model:{value:(_vm.model.year),callback:function ($$v) {_vm.$set(_vm.model, "year", $$v)},expression:"model.year"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L2","label":"Exchange Rate","label-for":"Tdg2","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg2","plaintext":"","type":"text"},model:{value:(_vm.model.exchange_rate),callback:function ($$v) {_vm.$set(_vm.model, "exchange_rate", $$v)},expression:"model.exchange_rate"}}):_c('b-form-input',{attrs:{"id":"Tdg2","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'exchange_rate')},"blur":function($event){_vm.inputBlur('exchange_rate')}},model:{value:(_vm.model.exchange_rate),callback:function ($$v) {_vm.$set(_vm.model, "exchange_rate", $$v)},expression:"model.exchange_rate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L3","label":"WTI","label-for":"Tdg3","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg3","plaintext":"","type":"text"},model:{value:(_vm.model.wti),callback:function ($$v) {_vm.$set(_vm.model, "wti", $$v)},expression:"model.wti"}}):_c('b-form-input',{attrs:{"id":"Tdg3","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'wti')},"blur":function($event){_vm.inputBlur('wti')}},model:{value:(_vm.model.wti),callback:function ($$v) {_vm.$set(_vm.model, "wti", $$v)},expression:"model.wti"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L4","label":"WCS","label-for":"Tdg4","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg4","plaintext":"","type":"text"},model:{value:(_vm.model.wcs),callback:function ($$v) {_vm.$set(_vm.model, "wcs", $$v)},expression:"model.wcs"}}):_c('b-form-input',{attrs:{"id":"Tdg4","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'wcs')},"blur":function($event){_vm.inputBlur('wcs')}},model:{value:(_vm.model.wcs),callback:function ($$v) {_vm.$set(_vm.model, "wcs", $$v)},expression:"model.wcs"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L5","label":"LLK","label-for":"Tdg5","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg5","plaintext":"","type":"text"},model:{value:(_vm.model.llk),callback:function ($$v) {_vm.$set(_vm.model, "llk", $$v)},expression:"model.llk"}}):_c('b-form-input',{attrs:{"id":"Tdg5","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'llk')},"blur":function($event){_vm.inputBlur('llk')}},model:{value:(_vm.model.llk),callback:function ($$v) {_vm.$set(_vm.model, "llk", $$v)},expression:"model.llk"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L6","label":"LLB","label-for":"Tdg6","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg6","plaintext":"","type":"text"},model:{value:(_vm.model.llb),callback:function ($$v) {_vm.$set(_vm.model, "llb", $$v)},expression:"model.llb"}}):_c('b-form-input',{attrs:{"id":"Tdg6","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'llb')},"blur":function($event){_vm.inputBlur('llb')}},model:{value:(_vm.model.llb),callback:function ($$v) {_vm.$set(_vm.model, "llb", $$v)},expression:"model.llb"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L7","label":"C5","label-for":"Tdg7","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg7","plaintext":"","type":"text"},model:{value:(_vm.model.c5),callback:function ($$v) {_vm.$set(_vm.model, "c5", $$v)},expression:"model.c5"}}):_c('b-form-input',{attrs:{"id":"Tdg7","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'c5')},"blur":function($event){_vm.inputBlur('c5')}},model:{value:(_vm.model.c5),callback:function ($$v) {_vm.$set(_vm.model, "c5", $$v)},expression:"model.c5"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L8","label":"AECO","label-for":"Tdg8","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg8","plaintext":"","type":"text"},model:{value:(_vm.model.aeco),callback:function ($$v) {_vm.$set(_vm.model, "aeco", $$v)},expression:"model.aeco"}}):_c('b-form-input',{attrs:{"id":"Tdg8","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'aeco')},"blur":function($event){_vm.inputBlur('aeco')}},model:{value:(_vm.model.aeco),callback:function ($$v) {_vm.$set(_vm.model, "aeco", $$v)},expression:"model.aeco"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L9","label":"Placeholder 1","label-for":"Tdg9","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg9","plaintext":"","type":"text"},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}}):_c('b-form-input',{attrs:{"id":"Tdg9","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'placeholder_1')},"blur":function($event){_vm.inputBlur('placeholder_1')}},model:{value:(_vm.model.placeholder_1),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_1", $$v)},expression:"model.placeholder_1"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L10","label":"Placeholder 2","label-for":"Tdg10","horizontal":""}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg10","plaintext":"","type":"text","autocomplete":"off"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'placeholder_2')},"blur":function($event){_vm.inputBlur('placeholder_2')}},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}}):_c('b-form-input',{attrs:{"id":"Tdg10","type":"text"},model:{value:(_vm.model.placeholder_2),callback:function ($$v) {_vm.$set(_vm.model, "placeholder_2", $$v)},expression:"model.placeholder_2"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"id":"L12","horizontal":"","label":"Type","label-for":"Tdg12"}},[(!_vm.edit)?_c('b-form-input',{staticClass:"plaintext-input",attrs:{"id":"Tdg12","type":"text","plaintext":""},model:{value:(_vm.model.invoice_type_name),callback:function ($$v) {_vm.$set(_vm.model, "invoice_type_name", $$v)},expression:"model.invoice_type_name"}}):_c('b-form-select',{attrs:{"disabled":_vm.invoice_types.length==0,"value-field":"id","text-field":"name","id":"Tdg12","options":_vm.invoice_types},model:{value:(_vm.model.invoice_type_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_type_id", $$v)},expression:"model.invoice_type_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select type --")])])],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit),expression:"edit"}],attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.update()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Update")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.editTdg()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])],1)],1)],1)],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center text-danger"},[_c('i',{staticClass:"icon fa-lg icon-puzzle"}),_c('br'),_vm._v(_vm._s(_vm.notFoundMessage)+"\n\t\t\t\t\t\t")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_pending_d_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f64269b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_pending_d_vue__ = __webpack_require__(1286);
function injectStyle (ssrContext) {
  __webpack_require__(1285)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f64269b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_pending_d_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f64269b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_pending_d_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{attrs:{"id":"custom_backdrop"}}),_vm._v(" "),_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"cols":"4","lg":"6"}},[_c('h2',[_vm._v("Haul Pending")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8","lg":"6"}},[_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Select Datapoints'),expression:"'Select Datapoints'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.openSelectColumns()}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:('Activate/Deactivate bbl'),expression:"'Activate/Deactivate bbl'",modifiers:{"hover":true,"top":true}}],staticClass:"pull-right ml5",attrs:{"variant":"info"},on:{"click":function($event){_vm.bbl()}}},[_c('i',{staticClass:"fa fa-bullseye"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"filters pb-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"order":"1","order-md":"1","cols":"8","sm":"6","md":"4","lg":"2"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('b-form-input',{attrs:{"placeholder":"Search"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Clear")])],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-0"},[(_vm.loadingData)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_c('br'),_vm._v(" Loading data... ")])])],1):_c('div',{staticClass:"table-responsive p-0 m-0"},[_c('b-table',{ref:"table",staticClass:"animated fadeIn",attrs:{"striped":"","bordered":"","hover":"","show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter},on:{"filtered":_vm.onFiltered,"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"action",fn:function(row){return undefined}},{key:"HEAD_select_haul",fn:function(data){return [_c('b-form-checkbox',{attrs:{"id":"checkbox"},on:{"change":_vm.toggleAllSelected},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.allSelected),callback:function ($$v) {_vm.allSelected=$$v},expression:"allSelected"}})]}},{key:"select_haul",fn:function(item){return [_c('b-form-checkbox',{key:item.index,attrs:{"id":"checkbox","value":item.item.haul_id},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haul_ids),callback:function ($$v) {_vm.haul_ids=$$v},expression:"haul_ids"}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"table-controls"},[_c('b-row',[_c('b-col',{staticClass:"my-1 pull-right",attrs:{"lg":"2","md":"2","sm":"12"}},[_c('div',{staticClass:"input-group mb-3"},[_c('div',{staticClass:"input-group-prepend"}),_vm._v(" "),_c('b-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"lg":"10","md":"10","sm":"12"}},[_c('b-pagination',{staticClass:"mt-0 mb-3 pull-right",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Columns to Display","ok-variant":"primary"},model:{value:(_vm.configTable),callback:function ($$v) {_vm.configTable=$$v},expression:"configTable"}},[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('ticket'),"value":"ticket"},on:{"change":function($event){_vm.actionField('ticket', 'Ticket #',1)}}},[_vm._v("Ticket #")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_id'),"value":"haul_id"},on:{"change":function($event){_vm.actionField('haul_id', 'Haul ID', 2)}}},[_vm._v("Haul Id")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('full_name'),"value":"full_name"},on:{"change":function($event){_vm.actionField('full_name', 'Driver', 5)}}},[_vm._v("Driver")]),_vm._v(" "),(_vm.role =='super_admin' || _vm.role =='trucking_company_admin' || _vm.role =='operations_manager' || _vm.role =='trucking_operational_manager')?_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('energy_company'),"value":"energy_company"},on:{"change":function($event){_vm.actionField('energy_company', 'Energy Company', 3)}}},[_vm._v("Energy Company")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('load_location'),"value":"load_location"},on:{"change":function($event){_vm.actionField('load_location', 'Load', 6)}}},[_vm._v("Load")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('unload_location'),"value":"unload_location"},on:{"change":function($event){_vm.actionField('unload_location', 'Unload', 7)}}},[_vm._v("Unload")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck'),"value":"truck"},on:{"change":function($event){_vm.actionField('truck','Trailer',8)}}},[_vm._v("Trailer")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_actual'),"value":"volume_actual"},on:{"change":function($event){_vm.actionField('volume_actual','Deliveries',9)}}},[_vm._v("Deliveries")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('oil_actual'),"value":"oil_actual"},on:{"change":function($event){_vm.actionField('oil_actual','Oil',10)}}},[_vm._v("Oil")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_actual'),"value":"water_actual"},on:{"change":function($event){_vm.actionField('water_actual', 'Water',11)}}},[_vm._v("Water")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('bsw'),"value":"bsw"},on:{"change":function($event){_vm.actionField('bsw', 'BS&W', 12)}}},[_vm._v("BS&W")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_date'),"value":"haul_start_date"},on:{"change":function($event){_vm.actionField('haul_start_date', 'Start Date', 13)}}},[_vm._v("Start Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_date'),"value":"haul_end_date"},on:{"change":function($event){_vm.actionField('haul_end_date', 'End Date', 14)}}},[_vm._v("End Date")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_type'),"value":"fluid_type"},on:{"change":function($event){_vm.actionField('fluid_type','Fluid Type', 15)}}},[_vm._v("Fluid Type")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('trucking_company'),"value":"trucking_company"},on:{"change":function($event){_vm.actionField('trucking_company','Trucking Company', 4)}}},[_vm._v("Trucking Company")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('water_percentage_actual'),"value":"water_percentage_actual"},on:{"change":function($event){_vm.actionField('water_percentage_actual','Water Cut Actual', 16)}}},[_vm._v("Water Cut Actual")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_start_time'),"value":"haul_start_time"},on:{"change":function($event){_vm.actionField('haul_start_time','Start Time', 17)}}},[_vm._v("Start Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('haul_end_time'),"value":"haul_end_time"},on:{"change":function($event){_vm.actionField('haul_end_time','End Time', 18)}}},[_vm._v("End Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('avg_speed'),"value":"avg_speed"},on:{"change":function($event){_vm.actionField('avg_speed','Speed Avg', 19)}}},[_vm._v("Speed Avg")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCheckboxes","name":"Checkboxes","plain":true,"checked":_vm.selectedItems}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_regular'),"value":"cost_regular"},on:{"change":function($event){_vm.actionField('cost_regular','Regular Cost', 20)}}},[_vm._v("Regular Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_stb'),"value":"cost_stb"},on:{"change":function($event){_vm.actionField('cost_stb','STB Cost', 21)}}},[_vm._v("STB Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('cost_worktime'),"value":"cost_worktime"},on:{"change":function($event){_vm.actionField('cost_worktime','Worktime Cost', 22)}}},[_vm._v("Worktime Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('total_cost'),"value":"total_cost"},on:{"change":function($event){_vm.actionField('total_cost','Total Cost', 23)}}},[_vm._v("Total Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('invoiced_cost'),"value":"invoiced_cost"},on:{"change":function($event){_vm.actionField('invoiced_cost','Invoice Cost', 24)}}},[_vm._v("Invoice Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('justification'),"value":"justification"},on:{"change":function($event){_vm.actionField('justification','Justification', 25)}}},[_vm._v("Justification")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('flags'),"value":"flags"},on:{"change":function($event){_vm.actionField('flags','Flags', 26)}}},[_vm._v("Flags")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('truck_unit'),"value":"truck_unit"},on:{"change":function($event){_vm.actionField('truck_unit','Truck Unit',27)}}},[_vm._v("Truck Unit")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('terminal_boss'),"value":"terminal_boss"},on:{"change":function($event){_vm.actionField('terminal_boss', 'Terminal Boss Ticket',28)}}},[_vm._v("Terminal Boss Ticket")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('volume_estimate'),"value":"volume_estimate"},on:{"change":function($event){_vm.actionField('volume_estimate','Volume Estimate',29)}}},[_vm._v("Volume Estimate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('rate'),"value":"rate"},on:{"change":function($event){_vm.actionField('rate','Rate', 30)}}},[_vm._v("Rate")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('stb'),"value":"stb"},on:{"change":function($event){_vm.actionField('stb', 'STB Time', 31)}}},[_vm._v("STB Time")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_subtotal_cost'),"value":"fluid_subtotal_cost"},on:{"change":function($event){_vm.actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 32)}}},[_vm._v("Fluid Subtotal Cost")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst'),"value":"fluid_gst"},on:{"change":function($event){_vm.actionField('fluid_gst','Fluid GST', 33)}}},[_vm._v("Fluid GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('fluid_gst_subtotal'),"value":"fluid_gst_subtotal"},on:{"change":function($event){_vm.actionField('fluid_gst_subtotal','Fluid Total', 34)}}},[_vm._v("Fluid Total")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_cost_subtotal'),"value":"wait_time_cost_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 35)}}},[_vm._v("Wait Time Cost Subtotal")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst'),"value":"wait_time_gst"},on:{"change":function($event){_vm.actionField('wait_time_gst','Wait Time GST', 36)}}},[_vm._v("Wait Time GST")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"disabled":_vm.shouldBeDisabled('wait_time_gst_subtotal'),"value":"wait_time_gst_subtotal"},on:{"change":function($event){_vm.actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 37)}}},[_vm._v("Wait Time GST Subtotal")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.configTable=false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.saveSelectedColumns()}}},[_vm._v("\n          Save\n        ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newModal",staticClass:"newHaulModal",attrs:{"title":"Invoice Notification","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newModal),callback:function ($$v) {_vm.newModal=$$v},expression:"newModal"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role =='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trucking Company","label-for":"trucking_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.company_name.length==0,"value-field":"id","text-field":"trucking_company_name","id":"trucking_company","options":_vm.company_name},on:{"input":function($event){_vm.selects_trucking_company_1()}},model:{value:(_vm.model.trucking_company_id),callback:function ($$v) {_vm.$set(_vm.model, "trucking_company_id", $$v)},expression:"model.trucking_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select trucking company --")])])],2)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.energy_companies.length==0,"value-field":"id","text-field":"energy_company_name","id":"energy_company","options":_vm.energy_companies},model:{value:(_vm.model.energy_company_id),callback:function ($$v) {_vm.$set(_vm.model, "energy_company_id", $$v)},expression:"model.energy_company_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select energy company --")])])],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Invoice Ref","label-for":"inv0"}},[_c('b-form-select',{attrs:{"disabled":_vm.invoices_filter.length==0,"value-field":"id","text-field":"invoice_ref","id":"inv0","options":_vm.invoices_filter},model:{value:(_vm.model.invoice_id),callback:function ($$v) {_vm.$set(_vm.model, "invoice_id", $$v)},expression:"model.invoice_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- select invoice ref --")])])],2)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.sendbtn,"size":"md","variant":"primary"},on:{"click":function($event){_vm.send_click()}}},[_vm._v("Send")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newHaulModal",staticClass:"newHaulModal",attrs:{"title":"New Haul","hide-header-close":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.newEC),callback:function ($$v) {_vm.newEC=$$v},expression:"newEC"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.role ==='super_admin')?_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Truking Company","label-for":"truck_company"}},[_c('b-form-select',{attrs:{"id":"truck_company_id","options":_vm.newHaul.truck_company_select},on:{"input":function($event){_vm.selects_trucking_company()}},model:{value:(_vm.newHaul.truck_company_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_company_id", $$v)},expression:"newHaul.truck_company_id"}})],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Trailer","label-for":"truck"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.truck_select.length==0,"id":"truck_id","options":_vm.newHaul.truck_select},model:{value:(_vm.newHaul.truck_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_id", $$v)},expression:"newHaul.truck_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Truck Unit","label-for":"truck_unit"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.truck_unit_select.length==0,"id":"truck_unit","options":_vm.newHaul.truck_unit_select},model:{value:(_vm.newHaul.truck_unit_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "truck_unit_id", $$v)},expression:"newHaul.truck_unit_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Driver","label-for":"full_name"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.driver_select.length==0,"id":"user_id","options":_vm.newHaul.driver_select},on:{"input":function($event){_vm.selects_driver()}},model:{value:(_vm.newHaul.user_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "user_id", $$v)},expression:"newHaul.user_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Energy Company","label-for":"energy_company"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.energy_company_select.length==0,"id":"energy_companies_id","options":_vm.newHaul.energy_company_select},on:{"input":function($event){_vm.selects_energy_company()}},model:{value:(_vm.newHaul.energy_companies_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "energy_companies_id", $$v)},expression:"newHaul.energy_companies_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Load","label-for":"load_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.load_location_select.length==0,"id":"load_location_id","options":_vm.newHaul.load_location_select},on:{"input":function($event){_vm.selects_load_location()}},model:{value:(_vm.newHaul.load_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "load_location_id", $$v)},expression:"newHaul.load_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Fluid","label-for":"fluid_type"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.fluid_type_select.length==0,"id":"fluid_type_id","options":_vm.newHaul.fluid_type_select},model:{value:(_vm.newHaul.fluid_type_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "fluid_type_id", $$v)},expression:"newHaul.fluid_type_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Unload","label-for":"unload_location"}},[_c('b-form-select',{attrs:{"disabled":_vm.newHaul.unload_location_select.length==0,"id":"unload_location_id","options":_vm.newHaul.unload_location_select},model:{value:(_vm.newHaul.unload_location_id),callback:function ($$v) {_vm.$set(_vm.newHaul, "unload_location_id", $$v)},expression:"newHaul.unload_location_id"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Water Cut Actual %","label-for":"water_percentage_actual"}},[_c('b-form-input',{attrs:{"id":"water_percentage_actual","placeholder":"0.00","type":"text"},nativeOn:{"blur":function($event){_vm.inputBlur('water_percentage_actual')},"keydown":function($event){_vm.myOnlyNumber($event, 'water_percentage_actual')}},model:{value:(_vm.newHaul.water_percentage_actual),callback:function ($$v) {_vm.$set(_vm.newHaul, "water_percentage_actual", $$v)},expression:"newHaul.water_percentage_actual"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume Actual","label-for":"volume_actual"}},[_c('b-form-input',{attrs:{"id":"volume_actual","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume_actual')},"blur":function($event){_vm.inputBlur('volume_actual')}},model:{value:(_vm.newHaul.volume_actual),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume_actual", $$v)},expression:"newHaul.volume_actual"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Volume Estimate","label-for":"volume_estimate"}},[_c('b-form-input',{attrs:{"id":"volume_estimate","placeholder":"0.00","type":"text"},nativeOn:{"keydown":function($event){_vm.myOnlyNumber($event, 'volume_estimate')},"blur":function($event){_vm.inputBlur('volume_estimate')}},model:{value:(_vm.newHaul.volume_estimate),callback:function ($$v) {_vm.$set(_vm.newHaul, "volume_estimate", $$v)},expression:"newHaul.volume_estimate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"# Ticket","label-for":"ticket"}},[_c('b-form-input',{attrs:{"id":"ticket","type":"text","autocomplete":"off","placeholder":"max 10 characters"},nativeOn:{"keydown":function($event){_vm.keyMonitor($event)}},model:{value:(_vm.newHaul.ticket),callback:function ($$v) {_vm.$set(_vm.newHaul, "ticket", $$v)},expression:"newHaul.ticket"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Ticket","label-for":"t_ticket"}},[_c('b-form-input',{attrs:{"id":"t_ticket","type":"text","autocomplete":"off","placeholder":"max 10 characters"},nativeOn:{"keydown":function($event){_vm.keyMonitor1($event)}},model:{value:(_vm.newHaul.t_ticket),callback:function ($$v) {_vm.$set(_vm.newHaul, "t_ticket", $$v)},expression:"newHaul.t_ticket"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Terminal Boss Number","label-for":"t_boss"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"}],attrs:{"id":"t_boss","type":"text","autocomplete":"off","placeholder":"max 10 digits"},model:{value:(_vm.newHaul.t_boss),callback:function ($$v) {_vm.$set(_vm.newHaul, "t_boss", $$v)},expression:"newHaul.t_boss"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Chain Up","label-for":"chain_up"}},[_c('b-form-select',{attrs:{"id":"chain_up"},model:{value:(_vm.newHaul.chain_up),callback:function ($$v) {_vm.$set(_vm.newHaul, "chain_up", $$v)},expression:"newHaul.chain_up"}},[_c('option',{domProps:{"value":false}},[_vm._v("NO")]),_c('option',{domProps:{"value":true}},[_vm._v("YES")])])],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Start Date","label-for":"haul_start_date"}},[_c('b-form-input',{attrs:{"id":"haul_start_datetime","type":"date"},model:{value:(_vm.newHaul.haul_start_datetime),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_start_datetime", $$v)},expression:"newHaul.haul_start_datetime"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Start Time","label-for":"haul_start_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_start_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('haul_start_time')}},model:{value:(_vm.newHaul.haul_start_time),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_start_time", $$v)},expression:"newHaul.haul_start_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Date","label-for":"haul_start_date"}},[_c('b-form-input',{attrs:{"id":"haul_end_datetime","type":"date"},model:{value:(_vm.newHaul.haul_end_datetime),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_end_datetime", $$v)},expression:"newHaul.haul_end_datetime"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"End Time","label-for":"haul_end_time"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"id":"haul_end_time","placeholder":"hh:mm","type":"text"},nativeOn:{"blur":function($event){_vm.timeBlur('haul_end_time')}},model:{value:(_vm.newHaul.haul_end_time),callback:function ($$v) {_vm.$set(_vm.newHaul, "haul_end_time", $$v)},expression:"newHaul.haul_end_time"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-cols":4,"horizontal":"","label":"Comments Start","label-for":"comments_start"}},[_c('b-form-input',{attrs:{"id":"comments_start","type":"text"},model:{value:(_vm.newHaul.comments_start),callback:function ($$v) {_vm.$set(_vm.newHaul, "comments_start", $$v)},expression:"newHaul.comments_start"}})],1),_vm._v(" "),_vm._l((_vm.newHaul.wait_times),function(wait_time,index){return _c('b-form-group',{key:wait_time.type_id,attrs:{"label-cols":4,"horizontal":"","label":_vm.waitTimeLabel(wait_time),"label-for":_vm.waitTimeLabel(wait_time)}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"}],attrs:{"placeholder":"hh:mm","type":"text"},model:{value:(wait_time.time),callback:function ($$v) {_vm.$set(wait_time, "time", $$v)},expression:"wait_time.time"}}),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":"Comments","type":"text"},model:{value:(wait_time.comments),callback:function ($$v) {_vm.$set(wait_time, "comments", $$v)},expression:"wait_time.comments"}}),_vm._v(" "),(wait_time.type_id == 5)?_c('b-btn',{staticClass:"wait-time-remove-button",attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.removeTimeBlur(index)}}},[_vm._v("X")]):_vm._e()],1)}),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.addWaitTime}},[_vm._v("Add another Wait Time")])],2)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.hideNewHaulModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.savebtn,"size":"md","variant":"primary"},on:{"click":_vm.saveHaul}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_update_volume_estimate_vue__ = __webpack_require__(617);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c84f01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_update_volume_estimate_vue__ = __webpack_require__(1289);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_update_volume_estimate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c84f01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_update_volume_estimate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
	getAll: function getAll() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	save: function save(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/create/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	getBy: function getBy(TerminalId) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/' + TerminalId + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					resolve(response.data);
				} else {
					resolve(response.data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	delete: function _delete(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/delete/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	restore: function restore(idTerminal) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/restore/' + idTerminal + '/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	update: function update(idTerminal, formData) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/update/' + idTerminal + '/', formData, { headers: {
					'Content-Type': 'multipart/form-data',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				var data = [response.data.status, response.data.message];
				resolve(data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	find: function find(model) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/powerbi/monthly_report/', model, { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				resolve(response.data);
			}).catch(function (error) {
				reject(error);
			});
		});
	},
	get_company: function get_company() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* apiDomain */] + '/pwbi/', { headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				} }).then(function (response) {
				if (response.data.status === 'success') {
					var data = response.data;
					resolve(data);
				} else {
					var data = response.data;
					resolve(data);
				}
			}).catch(function (error) {
				reject(error);
			});
		});
	}
});

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row pageinfo"},[_c('b-col',{attrs:{"lg":"6"}},[_c('h2',[_vm._v("Update Volume Estimate")])])],1),_vm._v(" "),_c('div',[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label-cols":4,"id":"L1","label":"Excel File","label-for":"csv","horizontal":""}},[_c('input',{ref:"file",attrs:{"type":"file","id":"files","accept":".xls, .xlsx"},on:{"change":function($event){_vm.handleFileUpload()}}})])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-button',{staticClass:"float-left",attrs:{"size":"md","variant":"primary"},on:{"click":_vm.sendCSV}},[_vm._v("Update")])],1)],1),_vm._v(" "),(_vm.progress)?_c('b-row',[(_vm.load_csv==='Loading Excel file.....')?_c('b-col',{attrs:{"md":"12"}},[_c('h5',{staticClass:"text-center mt-3"},[_c('i',{staticClass:"fa fa-refresh fa-lg mt-4 fa-spin"}),_vm._v(" "+_vm._s(_vm.load_csv))])]):_c('b-col',{attrs:{"md":"12"}},[_c('h5',{staticClass:"text-center mt-3"},[_vm._v(_vm._s(_vm.load_csv))])])],1):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1290 */,
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a3b1f3c_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__(1297);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a3b1f3c_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[619]);


// WEBPACK FOOTER //
// static/js/app.56f78a75889e9b488f54.js